/**
 * Swiper 3.4.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * 
 * http://www.idangero.us/swiper/
 * 
 * Copyright 2016, Vladimir Kharlampidi
 * The iDangero.us
 * http://www.idangero.us/
 * 
 * Licensed under MIT
 * 
 * Released on: December 13, 2016
 */
(function () {
    'use strict';
    var $;
    /*===========================
    Swiper
    ===========================*/
    var Swiper = function (container, params) {
        if (!(this instanceof Swiper)) return new Swiper(container, params);

        var defaults = {
            direction: 'horizontal',
            touchEventsTarget: 'container',
            initialSlide: 0,
            speed: 300,
            // autoplay
            autoplay: false,
            autoplayDisableOnInteraction: true,
            autoplayStopOnLast: false,
            // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
            iOSEdgeSwipeDetection: false,
            iOSEdgeSwipeThreshold: 20,
            // Free mode
            freeMode: false,
            freeModeMomentum: true,
            freeModeMomentumRatio: 1,
            freeModeMomentumBounce: true,
            freeModeMomentumBounceRatio: 1,
            freeModeMomentumVelocityRatio: 1,
            freeModeSticky: false,
            freeModeMinimumVelocity: 0.02,
            // Autoheight
            autoHeight: false,
            // Set wrapper width
            setWrapperSize: false,
            // Virtual Translate
            virtualTranslate: false,
            // Effects
            effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
            coverflow: {
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows : true
            },
            flip: {
                slideShadows : true,
                limitRotation: true
            },
            cube: {
                slideShadows: true,
                shadow: true,
                shadowOffset: 20,
                shadowScale: 0.94
            },
            fade: {
                crossFade: false
            },
            // Parallax
            parallax: false,
            // Zoom
            zoom: false,
            zoomMax: 3,
            zoomMin: 1,
            zoomToggle: true,
            // Scrollbar
            scrollbar: null,
            scrollbarHide: true,
            scrollbarDraggable: false,
            scrollbarSnapOnRelease: false,
            // Keyboard Mousewheel
            keyboardControl: false,
            mousewheelControl: false,
            mousewheelReleaseOnEdges: false,
            mousewheelInvert: false,
            mousewheelForceToAxis: false,
            mousewheelSensitivity: 1,
            mousewheelEventsTarged: 'container',
            // Hash Navigation
            hashnav: false,
            hashnavWatchState: false,
            // History
            history: false,
            // Commong Nav State
            replaceState: false,
            // Breakpoints
            breakpoints: undefined,
            // Slides grid
            spaceBetween: 0,
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerColumnFill: 'column',
            slidesPerGroup: 1,
            centeredSlides: false,
            slidesOffsetBefore: 0, // in px
            slidesOffsetAfter: 0, // in px
            // Round length
            roundLengths: false,
            // Touches
            touchRatio: 1,
            touchAngle: 45,
            simulateTouch: true,
            shortSwipes: true,
            longSwipes: true,
            longSwipesRatio: 0.5,
            longSwipesMs: 300,
            followFinger: true,
            onlyExternal: false,
            threshold: 0,
            touchMoveStopPropagation: true,
            touchReleaseOnEdges: false,
            // Unique Navigation Elements
            uniqueNavElements: true,
            // Pagination
            pagination: null,
            paginationElement: 'span',
            paginationClickable: false,
            paginationHide: false,
            paginationBulletRender: null,
            paginationProgressRender: null,
            paginationFractionRender: null,
            paginationCustomRender: null,
            paginationType: 'bullets', // 'bullets' or 'progress' or 'fraction' or 'custom'
            // Resistance
            resistance: true,
            resistanceRatio: 0.85,
            // Next/prev buttons
            nextButton: null,
            prevButton: null,
            // Progress
            watchSlidesProgress: false,
            watchSlidesVisibility: false,
            // Cursor
            grabCursor: false,
            // Clicks
            preventClicks: true,
            preventClicksPropagation: true,
            slideToClickedSlide: false,
            // Lazy Loading
            lazyLoading: false,
            lazyLoadingInPrevNext: false,
            lazyLoadingInPrevNextAmount: 1,
            lazyLoadingOnTransitionStart: false,
            // Images
            preloadImages: true,
            updateOnImagesReady: true,
            // loop
            loop: false,
            loopAdditionalSlides: 0,
            loopedSlides: null,
            // Control
            control: undefined,
            controlInverse: false,
            controlBy: 'slide', //or 'container'
            normalizeSlideIndex: true,
            // Swiping/no swiping
            allowSwipeToPrev: true,
            allowSwipeToNext: true,
            swipeHandler: null, //'.swipe-handler',
            noSwiping: true,
            noSwipingClass: 'swiper-no-swiping',
            // Passive Listeners
            passiveListeners: true,
            // NS
            containerModifierClass: 'swiper-container-', // NEW
            slideClass: 'swiper-slide',
            slideActiveClass: 'swiper-slide-active',
            slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
            slideVisibleClass: 'swiper-slide-visible',
            slideDuplicateClass: 'swiper-slide-duplicate',
            slideNextClass: 'swiper-slide-next',
            slideDuplicateNextClass: 'swiper-slide-duplicate-next',
            slidePrevClass: 'swiper-slide-prev',
            slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
            wrapperClass: 'swiper-wrapper',
            bulletClass: 'swiper-pagination-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active',
            buttonDisabledClass: 'swiper-button-disabled',
            paginationCurrentClass: 'swiper-pagination-current',
            paginationTotalClass: 'swiper-pagination-total',
            paginationHiddenClass: 'swiper-pagination-hidden',
            paginationProgressbarClass: 'swiper-pagination-progressbar',
            paginationClickableClass: 'swiper-pagination-clickable', // NEW
            paginationModifierClass: 'swiper-pagination-', // NEW
            lazyLoadingClass: 'swiper-lazy',
            lazyStatusLoadingClass: 'swiper-lazy-loading',
            lazyStatusLoadedClass: 'swiper-lazy-loaded',
            lazyPreloaderClass: 'swiper-lazy-preloader',
            notificationClass: 'swiper-notification',
            preloaderClass: 'preloader',
            zoomContainerClass: 'swiper-zoom-container',
        
            // Observer
            observer: false,
            observeParents: false,
            // Accessibility
            a11y: false,
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            // Callbacks
            runCallbacksOnInit: true
            /*
            Callbacks:
            onInit: function (swiper)
            onDestroy: function (swiper)
            onClick: function (swiper, e)
            onTap: function (swiper, e)
            onDoubleTap: function (swiper, e)
            onSliderMove: function (swiper, e)
            onSlideChangeStart: function (swiper)
            onSlideChangeEnd: function (swiper)
            onTransitionStart: function (swiper)
            onTransitionEnd: function (swiper)
            onImagesReady: function (swiper)
            onProgress: function (swiper, progress)
            onTouchStart: function (swiper, e)
            onTouchMove: function (swiper, e)
            onTouchMoveOpposite: function (swiper, e)
            onTouchEnd: function (swiper, e)
            onReachBeginning: function (swiper)
            onReachEnd: function (swiper)
            onSetTransition: function (swiper, duration)
            onSetTranslate: function (swiper, translate)
            onAutoplayStart: function (swiper)
            onAutoplayStop: function (swiper),
            onLazyImageLoad: function (swiper, slide, image)
            onLazyImageReady: function (swiper, slide, image)
            */
        
        };
        var initialVirtualTranslate = params && params.virtualTranslate;
        
        params = params || {};
        var originalParams = {};
        for (var param in params) {
            if (typeof params[param] === 'object' && params[param] !== null && !(params[param].nodeType || params[param] === window || params[param] === document || (typeof Dom7 !== 'undefined' && params[param] instanceof Dom7) || (typeof jQuery !== 'undefined' && params[param] instanceof jQuery))) {
                originalParams[param] = {};
                for (var deepParam in params[param]) {
                    originalParams[param][deepParam] = params[param][deepParam];
                }
            }
            else {
                originalParams[param] = params[param];
            }
        }
        for (var def in defaults) {
            if (typeof params[def] === 'undefined') {
                params[def] = defaults[def];
            }
            else if (typeof params[def] === 'object') {
                for (var deepDef in defaults[def]) {
                    if (typeof params[def][deepDef] === 'undefined') {
                        params[def][deepDef] = defaults[def][deepDef];
                    }
                }
            }
        }
        
        // Swiper
        var s = this;
        
        // Params
        s.params = params;
        s.originalParams = originalParams;
        
        // Classname
        s.classNames = [];
        /*=========================
          Dom Library and plugins
          ===========================*/
        if (typeof $ !== 'undefined' && typeof Dom7 !== 'undefined'){
            $ = Dom7;
        }
        if (typeof $ === 'undefined') {
            if (typeof Dom7 === 'undefined') {
                $ = window.Dom7 || window.Zepto || window.jQuery;
            }
            else {
                $ = Dom7;
            }
            if (!$) return;
        }
        // Export it to Swiper instance
        s.$ = $;
        
        /*=========================
          Breakpoints
          ===========================*/
        s.currentBreakpoint = undefined;
        s.getActiveBreakpoint = function () {
            //Get breakpoint for window width
            if (!s.params.breakpoints) return false;
            var breakpoint = false;
            var points = [], point;
            for ( point in s.params.breakpoints ) {
                if (s.params.breakpoints.hasOwnProperty(point)) {
                    points.push(point);
                }
            }
            points.sort(function (a, b) {
                return parseInt(a, 10) > parseInt(b, 10);
            });
            for (var i = 0; i < points.length; i++) {
                point = points[i];
                if (point >= window.innerWidth && !breakpoint) {
                    breakpoint = point;
                }
            }
            return breakpoint || 'max';
        };
        s.setBreakpoint = function () {
            //Set breakpoint for window width and update parameters
            var breakpoint = s.getActiveBreakpoint();
            if (breakpoint && s.currentBreakpoint !== breakpoint) {
                var breakPointsParams = breakpoint in s.params.breakpoints ? s.params.breakpoints[breakpoint] : s.originalParams;
                var needsReLoop = s.params.loop && (breakPointsParams.slidesPerView !== s.params.slidesPerView);
                for ( var param in breakPointsParams ) {
                    s.params[param] = breakPointsParams[param];
                }
                s.currentBreakpoint = breakpoint;
                if(needsReLoop && s.destroyLoop) {
                    s.reLoop(true);
                }
            }
        };
        // Set breakpoint on load
        if (s.params.breakpoints) {
            s.setBreakpoint();
        }
        
        /*=========================
          Preparation - Define Container, Wrapper and Pagination
          ===========================*/
        s.container = $(container);
        if (s.container.length === 0) return;
        if (s.container.length > 1) {
            var swipers = [];
            s.container.each(function () {
                var container = this;
                swipers.push(new Swiper(this, params));
            });
            return swipers;
        }
        
        // Save instance in container HTML Element and in data
        s.container[0].swiper = s;
        s.container.data('swiper', s);
        
        s.classNames.push(s.params.containerModifierClass + s.params.direction);
        
        if (s.params.freeMode) {
            s.classNames.push(s.params.containerModifierClass + 'free-mode');
        }
        if (!s.support.flexbox) {
            s.classNames.push(s.params.containerModifierClass + 'no-flexbox');
            s.params.slidesPerColumn = 1;
        }
        if (s.params.autoHeight) {
            s.classNames.push(s.params.containerModifierClass + 'autoheight');
        }
        // Enable slides progress when required
        if (s.params.parallax || s.params.watchSlidesVisibility) {
            s.params.watchSlidesProgress = true;
        }
        // Max resistance when touchReleaseOnEdges
        if (s.params.touchReleaseOnEdges) {
            s.params.resistanceRatio = 0;
        }
        // Coverflow / 3D
        if (['cube', 'coverflow', 'flip'].indexOf(s.params.effect) >= 0) {
            if (s.support.transforms3d) {
                s.params.watchSlidesProgress = true;
                s.classNames.push(s.params.containerModifierClass + '3d');
            }
            else {
                s.params.effect = 'slide';
            }
        }
        if (s.params.effect !== 'slide') {
            s.classNames.push(s.params.containerModifierClass + s.params.effect);
        }
        if (s.params.effect === 'cube') {
            s.params.resistanceRatio = 0;
            s.params.slidesPerView = 1;
            s.params.slidesPerColumn = 1;
            s.params.slidesPerGroup = 1;
            s.params.centeredSlides = false;
            s.params.spaceBetween = 0;
            s.params.virtualTranslate = true;
            s.params.setWrapperSize = false;
        }
        if (s.params.effect === 'fade' || s.params.effect === 'flip') {
            s.params.slidesPerView = 1;
            s.params.slidesPerColumn = 1;
            s.params.slidesPerGroup = 1;
            s.params.watchSlidesProgress = true;
            s.params.spaceBetween = 0;
            s.params.setWrapperSize = false;
            if (typeof initialVirtualTranslate === 'undefined') {
                s.params.virtualTranslate = true;
            }
        }
        
        // Grab Cursor
        if (s.params.grabCursor && s.support.touch) {
            s.params.grabCursor = false;
        }
        
        // Wrapper
        s.wrapper = s.container.children('.' + s.params.wrapperClass);
        
        // Pagination
        if (s.params.pagination) {
            s.paginationContainer = $(s.params.pagination);
            if (s.params.uniqueNavElements && typeof s.params.pagination === 'string' && s.paginationContainer.length > 1 && s.container.find(s.params.pagination).length === 1) {
                s.paginationContainer = s.container.find(s.params.pagination);
            }
        
            if (s.params.paginationType === 'bullets' && s.params.paginationClickable) {
                s.paginationContainer.addClass(s.params.paginationModifierClass + 'clickable');
            }
            else {
                s.params.paginationClickable = false;
            }
            s.paginationContainer.addClass(s.params.paginationModifierClass + s.params.paginationType);
        }
        // Next/Prev Buttons
        if (s.params.nextButton || s.params.prevButton) {
            if (s.params.nextButton) {
                s.nextButton = $(s.params.nextButton);
                if (s.params.uniqueNavElements && typeof s.params.nextButton === 'string' && s.nextButton.length > 1 && s.container.find(s.params.nextButton).length === 1) {
                    s.nextButton = s.container.find(s.params.nextButton);
                }
            }
            if (s.params.prevButton) {
                s.prevButton = $(s.params.prevButton);
                if (s.params.uniqueNavElements && typeof s.params.prevButton === 'string' && s.prevButton.length > 1 && s.container.find(s.params.prevButton).length === 1) {
                    s.prevButton = s.container.find(s.params.prevButton);
                }
            }
        }
        
        // Is Horizontal
        s.isHorizontal = function () {
            return s.params.direction === 'horizontal';
        };
        // s.isH = isH;
        
        // RTL
        s.rtl = s.isHorizontal() && (s.container[0].dir.toLowerCase() === 'rtl' || s.container.css('direction') === 'rtl');
        if (s.rtl) {
            s.classNames.push(s.params.containerModifierClass + 'rtl');
        }
        
        // Wrong RTL support
        if (s.rtl) {
            s.wrongRTL = s.wrapper.css('display') === '-webkit-box';
        }
        
        // Columns
        if (s.params.slidesPerColumn > 1) {
            s.classNames.push(s.params.containerModifierClass + 'multirow');
        }
        
        // Check for Android
        if (s.device.android) {
            s.classNames.push(s.params.containerModifierClass + 'android');
        }
        
        // Add classes
        s.container.addClass(s.classNames.join(' '));
        
        // Translate
        s.translate = 0;
        
        // Progress
        s.progress = 0;
        
        // Velocity
        s.velocity = 0;
        
        /*=========================
          Locks, unlocks
          ===========================*/
        s.lockSwipeToNext = function () {
            s.params.allowSwipeToNext = false;
            if (s.params.allowSwipeToPrev === false && s.params.grabCursor) {
                s.unsetGrabCursor();
            }
        };
        s.lockSwipeToPrev = function () {
            s.params.allowSwipeToPrev = false;
            if (s.params.allowSwipeToNext === false && s.params.grabCursor) {
                s.unsetGrabCursor();
            }
        };
        s.lockSwipes = function () {
            s.params.allowSwipeToNext = s.params.allowSwipeToPrev = false;
            if (s.params.grabCursor) s.unsetGrabCursor();
        };
        s.unlockSwipeToNext = function () {
            s.params.allowSwipeToNext = true;
            if (s.params.allowSwipeToPrev === true && s.params.grabCursor) {
                s.setGrabCursor();
            }
        };
        s.unlockSwipeToPrev = function () {
            s.params.allowSwipeToPrev = true;
            if (s.params.allowSwipeToNext === true && s.params.grabCursor) {
                s.setGrabCursor();
            }
        };
        s.unlockSwipes = function () {
            s.params.allowSwipeToNext = s.params.allowSwipeToPrev = true;
            if (s.params.grabCursor) s.setGrabCursor();
        };
        
        /*=========================
          Round helper
          ===========================*/
        function round(a) {
            return Math.floor(a);
        }
        /*=========================
          Set grab cursor
          ===========================*/
        s.setGrabCursor = function(moving) {
            s.container[0].style.cursor = 'move';
            s.container[0].style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
            s.container[0].style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
            s.container[0].style.cursor = moving ? 'grabbing': 'grab';
        };
        s.unsetGrabCursor = function () {
            s.container[0].style.cursor = '';
        };
        if (s.params.grabCursor) {
            s.setGrabCursor();
        }
        /*=========================
          Update on Images Ready
          ===========================*/
        s.imagesToLoad = [];
        s.imagesLoaded = 0;
        
        s.loadImage = function (imgElement, src, srcset, sizes, checkForComplete, callback) {
            var image;
            function onReady () {
                if (callback) callback();
            }
            if (!imgElement.complete || !checkForComplete) {
                if (src) {
                    image = new window.Image();
                    image.onload = onReady;
                    image.onerror = onReady;
                    if (sizes) {
                        image.sizes = sizes;
                    }
                    if (srcset) {
                        image.srcset = srcset;
                    }
                    if (src) {
                        image.src = src;
                    }
                } else {
                    onReady();
                }
        
            } else {//image already loaded...
                onReady();
            }
        };
        s.preloadImages = function () {
            s.imagesToLoad = s.container.find('img');
            function _onReady() {
                if (typeof s === 'undefined' || s === null || !s) return;
                if (s.imagesLoaded !== undefined) s.imagesLoaded++;
                if (s.imagesLoaded === s.imagesToLoad.length) {
                    if (s.params.updateOnImagesReady) s.update();
                    s.emit('onImagesReady', s);
                }
            }
            for (var i = 0; i < s.imagesToLoad.length; i++) {
                s.loadImage(s.imagesToLoad[i], (s.imagesToLoad[i].currentSrc || s.imagesToLoad[i].getAttribute('src')), (s.imagesToLoad[i].srcset || s.imagesToLoad[i].getAttribute('srcset')), s.imagesToLoad[i].sizes || s.imagesToLoad[i].getAttribute('sizes'), true, _onReady);
            }
        };
        
        /*=========================
          Autoplay
          ===========================*/
        s.autoplayTimeoutId = undefined;
        s.autoplaying = false;
        s.autoplayPaused = false;
        function autoplay() {
            var autoplayDelay = s.params.autoplay;
            var activeSlide = s.slides.eq(s.activeIndex);
            if (activeSlide.attr('data-swiper-autoplay')) {
                autoplayDelay = activeSlide.attr('data-swiper-autoplay') || s.params.autoplay;
            }
            s.autoplayTimeoutId = setTimeout(function () {
                if (s.params.loop) {
                    s.fixLoop();
                    s._slideNext();
                    s.emit('onAutoplay', s);
                }
                else {
                    if (!s.isEnd) {
                        s._slideNext();
                        s.emit('onAutoplay', s);
                    }
                    else {
                        if (!params.autoplayStopOnLast) {
                            s._slideTo(0);
                            s.emit('onAutoplay', s);
                        }
                        else {
                            s.stopAutoplay();
                        }
                    }
                }
            }, autoplayDelay);
        }
        s.startAutoplay = function () {
            if (typeof s.autoplayTimeoutId !== 'undefined') return false;
            if (!s.params.autoplay) return false;
            if (s.autoplaying) return false;
            s.autoplaying = true;
            s.emit('onAutoplayStart', s);
            autoplay();
        };
        s.stopAutoplay = function (internal) {
            if (!s.autoplayTimeoutId) return;
            if (s.autoplayTimeoutId) clearTimeout(s.autoplayTimeoutId);
            s.autoplaying = false;
            s.autoplayTimeoutId = undefined;
            s.emit('onAutoplayStop', s);
        };
        s.pauseAutoplay = function (speed) {
            if (s.autoplayPaused) return;
            if (s.autoplayTimeoutId) clearTimeout(s.autoplayTimeoutId);
            s.autoplayPaused = true;
            if (speed === 0) {
                s.autoplayPaused = false;
                autoplay();
            }
            else {
                s.wrapper.transitionEnd(function () {
                    if (!s) return;
                    s.autoplayPaused = false;
                    if (!s.autoplaying) {
                        s.stopAutoplay();
                    }
                    else {
                        autoplay();
                    }
                });
            }
        };
        /*=========================
          Min/Max Translate
          ===========================*/
        s.minTranslate = function () {
            return (-s.snapGrid[0]);
        };
        s.maxTranslate = function () {
            return (-s.snapGrid[s.snapGrid.length - 1]);
        };
        /*=========================
          Slider/slides sizes
          ===========================*/
        s.updateAutoHeight = function () {
            var activeSlides = [];
            var newHeight = 0;
            var i;
        
            // Find slides currently in view
            if(s.params.slidesPerView !== 'auto' && s.params.slidesPerView > 1) {
                for (i = 0; i < Math.ceil(s.params.slidesPerView); i++) {
                    var index = s.activeIndex + i;
                    if(index > s.slides.length) break;
                    activeSlides.push(s.slides.eq(index)[0]);
                }
            } else {
                activeSlides.push(s.slides.eq(s.activeIndex)[0]);
            }
        
            // Find new height from heighest slide in view
            for (i = 0; i < activeSlides.length; i++) {
                if (typeof activeSlides[i] !== 'undefined') {
                    var height = activeSlides[i].offsetHeight;
                    newHeight = height > newHeight ? height : newHeight;
                }
            }
        
            // Update Height
            if (newHeight) s.wrapper.css('height', newHeight + 'px');
        };
        s.updateContainerSize = function () {
            var width, height;
            if (typeof s.params.width !== 'undefined') {
                width = s.params.width;
            }
            else {
                width = s.container[0].clientWidth;
            }
            if (typeof s.params.height !== 'undefined') {
                height = s.params.height;
            }
            else {
                height = s.container[0].clientHeight;
            }
            if (width === 0 && s.isHorizontal() || height === 0 && !s.isHorizontal()) {
                return;
            }
        
            //Subtract paddings
            width = width - parseInt(s.container.css('padding-left'), 10) - parseInt(s.container.css('padding-right'), 10);
            height = height - parseInt(s.container.css('padding-top'), 10) - parseInt(s.container.css('padding-bottom'), 10);
        
            // Store values
            s.width = width;
            s.height = height;
            s.size = s.isHorizontal() ? s.width : s.height;
        };
        
        s.updateSlidesSize = function () {
            s.slides = s.wrapper.children('.' + s.params.slideClass);
            s.snapGrid = [];
            s.slidesGrid = [];
            s.slidesSizesGrid = [];
        
            var spaceBetween = s.params.spaceBetween,
                slidePosition = -s.params.slidesOffsetBefore,
                i,
                prevSlideSize = 0,
                index = 0;
            if (typeof s.size === 'undefined') return;
            if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
                spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * s.size;
            }
        
            s.virtualSize = -spaceBetween;
            // reset margins
            if (s.rtl) s.slides.css({marginLeft: '', marginTop: ''});
            else s.slides.css({marginRight: '', marginBottom: ''});
        
            var slidesNumberEvenToRows;
            if (s.params.slidesPerColumn > 1) {
                if (Math.floor(s.slides.length / s.params.slidesPerColumn) === s.slides.length / s.params.slidesPerColumn) {
                    slidesNumberEvenToRows = s.slides.length;
                }
                else {
                    slidesNumberEvenToRows = Math.ceil(s.slides.length / s.params.slidesPerColumn) * s.params.slidesPerColumn;
                }
                if (s.params.slidesPerView !== 'auto' && s.params.slidesPerColumnFill === 'row') {
                    slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, s.params.slidesPerView * s.params.slidesPerColumn);
                }
            }
        
            // Calc slides
            var slideSize;
            var slidesPerColumn = s.params.slidesPerColumn;
            var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
            var numFullColumns = slidesPerRow - (s.params.slidesPerColumn * slidesPerRow - s.slides.length);
            for (i = 0; i < s.slides.length; i++) {
                slideSize = 0;
                var slide = s.slides.eq(i);
                if (s.params.slidesPerColumn > 1) {
                    // Set slides order
                    var newSlideOrderIndex;
                    var column, row;
                    if (s.params.slidesPerColumnFill === 'column') {
                        column = Math.floor(i / slidesPerColumn);
                        row = i - column * slidesPerColumn;
                        if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn-1)) {
                            if (++row >= slidesPerColumn) {
                                row = 0;
                                column++;
                            }
                        }
                        newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
                        slide
                            .css({
                                '-webkit-box-ordinal-group': newSlideOrderIndex,
                                '-moz-box-ordinal-group': newSlideOrderIndex,
                                '-ms-flex-order': newSlideOrderIndex,
                                '-webkit-order': newSlideOrderIndex,
                                'order': newSlideOrderIndex
                            });
                    }
                    else {
                        row = Math.floor(i / slidesPerRow);
                        column = i - row * slidesPerRow;
                    }
                    slide
                        .css(
                            'margin-' + (s.isHorizontal() ? 'top' : 'left'),
                            (row !== 0 && s.params.spaceBetween) && (s.params.spaceBetween + 'px')
                        )
                        .attr('data-swiper-column', column)
                        .attr('data-swiper-row', row);
        
                }
                if (slide.css('display') === 'none') continue;
                if (s.params.slidesPerView === 'auto') {
                    slideSize = s.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
                    if (s.params.roundLengths) slideSize = round(slideSize);
                }
                else {
                    slideSize = (s.size - (s.params.slidesPerView - 1) * spaceBetween) / s.params.slidesPerView;
                    if (s.params.roundLengths) slideSize = round(slideSize);
        
                    if (s.isHorizontal()) {
                        s.slides[i].style.width = slideSize + 'px';
                    }
                    else {
                        s.slides[i].style.height = slideSize + 'px';
                    }
                }
                s.slides[i].swiperSlideSize = slideSize;
                s.slidesSizesGrid.push(slideSize);
        
        
                if (s.params.centeredSlides) {
                    slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
                    if (i === 0) slidePosition = slidePosition - s.size / 2 - spaceBetween;
                    if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
                    if ((index) % s.params.slidesPerGroup === 0) s.snapGrid.push(slidePosition);
                    s.slidesGrid.push(slidePosition);
                }
                else {
                    if ((index) % s.params.slidesPerGroup === 0) s.snapGrid.push(slidePosition);
                    s.slidesGrid.push(slidePosition);
                    slidePosition = slidePosition + slideSize + spaceBetween;
                }
        
                s.virtualSize += slideSize + spaceBetween;
        
                prevSlideSize = slideSize;
        
                index ++;
            }
            s.virtualSize = Math.max(s.virtualSize, s.size) + s.params.slidesOffsetAfter;
            var newSlidesGrid;
        
            if (
                s.rtl && s.wrongRTL && (s.params.effect === 'slide' || s.params.effect === 'coverflow')) {
                s.wrapper.css({width: s.virtualSize + s.params.spaceBetween + 'px'});
            }
            if (!s.support.flexbox || s.params.setWrapperSize) {
                if (s.isHorizontal()) s.wrapper.css({width: s.virtualSize + s.params.spaceBetween + 'px'});
                else s.wrapper.css({height: s.virtualSize + s.params.spaceBetween + 'px'});
            }
        
            if (s.params.slidesPerColumn > 1) {
                s.virtualSize = (slideSize + s.params.spaceBetween) * slidesNumberEvenToRows;
                s.virtualSize = Math.ceil(s.virtualSize / s.params.slidesPerColumn) - s.params.spaceBetween;
                if (s.isHorizontal()) s.wrapper.css({width: s.virtualSize + s.params.spaceBetween + 'px'});
                else s.wrapper.css({height: s.virtualSize + s.params.spaceBetween + 'px'});
                if (s.params.centeredSlides) {
                    newSlidesGrid = [];
                    for (i = 0; i < s.snapGrid.length; i++) {
                        if (s.snapGrid[i] < s.virtualSize + s.snapGrid[0]) newSlidesGrid.push(s.snapGrid[i]);
                    }
                    s.snapGrid = newSlidesGrid;
                }
            }
        
            // Remove last grid elements depending on width
            if (!s.params.centeredSlides) {
                newSlidesGrid = [];
                for (i = 0; i < s.snapGrid.length; i++) {
                    if (s.snapGrid[i] <= s.virtualSize - s.size) {
                        newSlidesGrid.push(s.snapGrid[i]);
                    }
                }
                s.snapGrid = newSlidesGrid;
                if (Math.floor(s.virtualSize - s.size) - Math.floor(s.snapGrid[s.snapGrid.length - 1]) > 1) {
                    s.snapGrid.push(s.virtualSize - s.size);
                }
            }
            if (s.snapGrid.length === 0) s.snapGrid = [0];
        
            if (s.params.spaceBetween !== 0) {
                if (s.isHorizontal()) {
                    if (s.rtl) s.slides.css({marginLeft: spaceBetween + 'px'});
                    else s.slides.css({marginRight: spaceBetween + 'px'});
                }
                else s.slides.css({marginBottom: spaceBetween + 'px'});
            }
            if (s.params.watchSlidesProgress) {
                s.updateSlidesOffset();
            }
        };
        s.updateSlidesOffset = function () {
            for (var i = 0; i < s.slides.length; i++) {
                s.slides[i].swiperSlideOffset = s.isHorizontal() ? s.slides[i].offsetLeft : s.slides[i].offsetTop;
            }
        };
        
        /*=========================
          Dynamic Slides Per View
          ===========================*/
        s.currentSlidesPerView = function () {
            var spv = 1, i, j;
            if (s.params.centeredSlides) {
                var size = s.slides[s.activeIndex].swiperSlideSize;
                var breakLoop;
                for (i = s.activeIndex + 1; i < s.slides.length; i++) {
                    if (s.slides[i] && !breakLoop) {
                        size += s.slides[i].swiperSlideSize;
                        spv ++;
                        if (size > s.size) breakLoop = true;
                    }
                }
                for (j = s.activeIndex - 1; j >= 0; j--) {
                    if (s.slides[j] && !breakLoop) {
                        size += s.slides[j].swiperSlideSize;
                        spv ++;
                        if (size > s.size) breakLoop = true;
                    }
                }
            }
            else {
                for (i = s.activeIndex + 1; i < s.slides.length; i++) {
                    if (s.slidesGrid[i] - s.slidesGrid[s.activeIndex] < s.size) {
                        spv++;
                    }
                }
            }
            return spv;
        };
        /*=========================
          Slider/slides progress
          ===========================*/
        s.updateSlidesProgress = function (translate) {
            if (typeof translate === 'undefined') {
                translate = s.translate || 0;
            }
            if (s.slides.length === 0) return;
            if (typeof s.slides[0].swiperSlideOffset === 'undefined') s.updateSlidesOffset();
        
            var offsetCenter = -translate;
            if (s.rtl) offsetCenter = translate;
        
            // Visible Slides
            s.slides.removeClass(s.params.slideVisibleClass);
            for (var i = 0; i < s.slides.length; i++) {
                var slide = s.slides[i];
                var slideProgress = (offsetCenter + (s.params.centeredSlides ? s.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + s.params.spaceBetween);
                if (s.params.watchSlidesVisibility) {
                    var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
                    var slideAfter = slideBefore + s.slidesSizesGrid[i];
                    var isVisible =
                        (slideBefore >= 0 && slideBefore < s.size) ||
                        (slideAfter > 0 && slideAfter <= s.size) ||
                        (slideBefore <= 0 && slideAfter >= s.size);
                    if (isVisible) {
                        s.slides.eq(i).addClass(s.params.slideVisibleClass);
                    }
                }
                slide.progress = s.rtl ? -slideProgress : slideProgress;
            }
        };
        s.updateProgress = function (translate) {
            if (typeof translate === 'undefined') {
                translate = s.translate || 0;
            }
            var translatesDiff = s.maxTranslate() - s.minTranslate();
            var wasBeginning = s.isBeginning;
            var wasEnd = s.isEnd;
            if (translatesDiff === 0) {
                s.progress = 0;
                s.isBeginning = s.isEnd = true;
            }
            else {
                s.progress = (translate - s.minTranslate()) / (translatesDiff);
                s.isBeginning = s.progress <= 0;
                s.isEnd = s.progress >= 1;
            }
            if (s.isBeginning && !wasBeginning) s.emit('onReachBeginning', s);
            if (s.isEnd && !wasEnd) s.emit('onReachEnd', s);
        
            if (s.params.watchSlidesProgress) s.updateSlidesProgress(translate);
            s.emit('onProgress', s, s.progress);
        };
        s.updateActiveIndex = function () {
            var translate = s.rtl ? s.translate : -s.translate;
            var newActiveIndex, i, snapIndex;
            for (i = 0; i < s.slidesGrid.length; i ++) {
                if (typeof s.slidesGrid[i + 1] !== 'undefined') {
                    if (translate >= s.slidesGrid[i] && translate < s.slidesGrid[i + 1] - (s.slidesGrid[i + 1] - s.slidesGrid[i]) / 2) {
                        newActiveIndex = i;
                    }
                    else if (translate >= s.slidesGrid[i] && translate < s.slidesGrid[i + 1]) {
                        newActiveIndex = i + 1;
                    }
                }
                else {
                    if (translate >= s.slidesGrid[i]) {
                        newActiveIndex = i;
                    }
                }
            }
            // Normalize slideIndex
            if(s.params.normalizeSlideIndex){
                if (newActiveIndex < 0 || typeof newActiveIndex === 'undefined') newActiveIndex = 0;
            }
            // for (i = 0; i < s.slidesGrid.length; i++) {
                // if (- translate >= s.slidesGrid[i]) {
                    // newActiveIndex = i;
                // }
            // }
            snapIndex = Math.floor(newActiveIndex / s.params.slidesPerGroup);
            if (snapIndex >= s.snapGrid.length) snapIndex = s.snapGrid.length - 1;
        
            if (newActiveIndex === s.activeIndex) {
                return;
            }
            s.snapIndex = snapIndex;
            s.previousIndex = s.activeIndex;
            s.activeIndex = newActiveIndex;
            s.updateClasses();
            s.updateRealIndex();
        };
        s.updateRealIndex = function(){
            s.realIndex = parseInt(s.slides.eq(s.activeIndex).attr('data-swiper-slide-index') || s.activeIndex, 10);
        };
        
        /*=========================
          Classes
          ===========================*/
        s.updateClasses = function () {
            s.slides.removeClass(s.params.slideActiveClass + ' ' + s.params.slideNextClass + ' ' + s.params.slidePrevClass + ' ' + s.params.slideDuplicateActiveClass + ' ' + s.params.slideDuplicateNextClass + ' ' + s.params.slideDuplicatePrevClass);
            var activeSlide = s.slides.eq(s.activeIndex);
            // Active classes
            activeSlide.addClass(s.params.slideActiveClass);
            if (params.loop) {
                // Duplicate to all looped slides
                if (activeSlide.hasClass(s.params.slideDuplicateClass)) {
                    s.wrapper.children('.' + s.params.slideClass + ':not(.' + s.params.slideDuplicateClass + ')[data-swiper-slide-index="' + s.realIndex + '"]').addClass(s.params.slideDuplicateActiveClass);
                }
                else {
                    s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + s.realIndex + '"]').addClass(s.params.slideDuplicateActiveClass);
                }
            }
            // Next Slide
            var nextSlide = activeSlide.next('.' + s.params.slideClass).addClass(s.params.slideNextClass);
            if (s.params.loop && nextSlide.length === 0) {
                nextSlide = s.slides.eq(0);
                nextSlide.addClass(s.params.slideNextClass);
            }
            // Prev Slide
            var prevSlide = activeSlide.prev('.' + s.params.slideClass).addClass(s.params.slidePrevClass);
            if (s.params.loop && prevSlide.length === 0) {
                prevSlide = s.slides.eq(-1);
                prevSlide.addClass(s.params.slidePrevClass);
            }
            if (params.loop) {
                // Duplicate to all looped slides
                if (nextSlide.hasClass(s.params.slideDuplicateClass)) {
                    s.wrapper.children('.' + s.params.slideClass + ':not(.' + s.params.slideDuplicateClass + ')[data-swiper-slide-index="' + nextSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicateNextClass);
                }
                else {
                    s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + nextSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicateNextClass);
                }
                if (prevSlide.hasClass(s.params.slideDuplicateClass)) {
                    s.wrapper.children('.' + s.params.slideClass + ':not(.' + s.params.slideDuplicateClass + ')[data-swiper-slide-index="' + prevSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicatePrevClass);
                }
                else {
                    s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + prevSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicatePrevClass);
                }
            }
        
            // Pagination
            if (s.paginationContainer && s.paginationContainer.length > 0) {
                // Current/Total
                var current,
                    total = s.params.loop ? Math.ceil((s.slides.length - s.loopedSlides * 2) / s.params.slidesPerGroup) : s.snapGrid.length;
                if (s.params.loop) {
                    current = Math.ceil((s.activeIndex - s.loopedSlides)/s.params.slidesPerGroup);
                    if (current > s.slides.length - 1 - s.loopedSlides * 2) {
                        current = current - (s.slides.length - s.loopedSlides * 2);
                    }
                    if (current > total - 1) current = current - total;
                    if (current < 0 && s.params.paginationType !== 'bullets') current = total + current;
                }
                else {
                    if (typeof s.snapIndex !== 'undefined') {
                        current = s.snapIndex;
                    }
                    else {
                        current = s.activeIndex || 0;
                    }
                }
                // Types
                if (s.params.paginationType === 'bullets' && s.bullets && s.bullets.length > 0) {
                    s.bullets.removeClass(s.params.bulletActiveClass);
                    if (s.paginationContainer.length > 1) {
                        s.bullets.each(function () {
                            if ($(this).index() === current) $(this).addClass(s.params.bulletActiveClass);
                        });
                    }
                    else {
                        s.bullets.eq(current).addClass(s.params.bulletActiveClass);
                    }
                }
                if (s.params.paginationType === 'fraction') {
                    s.paginationContainer.find('.' + s.params.paginationCurrentClass).text(current + 1);
                    s.paginationContainer.find('.' + s.params.paginationTotalClass).text(total);
                }
                if (s.params.paginationType === 'progress') {
                    var scale = (current + 1) / total,
                        scaleX = scale,
                        scaleY = 1;
                    if (!s.isHorizontal()) {
                        scaleY = scale;
                        scaleX = 1;
                    }
                    s.paginationContainer.find('.' + s.params.paginationProgressbarClass).transform('translate3d(0,0,0) scaleX(' + scaleX + ') scaleY(' + scaleY + ')').transition(s.params.speed);
                }
                if (s.params.paginationType === 'custom' && s.params.paginationCustomRender) {
                    s.paginationContainer.html(s.params.paginationCustomRender(s, current + 1, total));
                    s.emit('onPaginationRendered', s, s.paginationContainer[0]);
                }
            }
        
            // Next/active buttons
            if (!s.params.loop) {
                if (s.params.prevButton && s.prevButton && s.prevButton.length > 0) {
                    if (s.isBeginning) {
                        s.prevButton.addClass(s.params.buttonDisabledClass);
                        if (s.params.a11y && s.a11y) s.a11y.disable(s.prevButton);
                    }
                    else {
                        s.prevButton.removeClass(s.params.buttonDisabledClass);
                        if (s.params.a11y && s.a11y) s.a11y.enable(s.prevButton);
                    }
                }
                if (s.params.nextButton && s.nextButton && s.nextButton.length > 0) {
                    if (s.isEnd) {
                        s.nextButton.addClass(s.params.buttonDisabledClass);
                        if (s.params.a11y && s.a11y) s.a11y.disable(s.nextButton);
                    }
                    else {
                        s.nextButton.removeClass(s.params.buttonDisabledClass);
                        if (s.params.a11y && s.a11y) s.a11y.enable(s.nextButton);
                    }
                }
            }
        };
        
        /*=========================
          Pagination
          ===========================*/
        s.updatePagination = function () {
            if (!s.params.pagination) return;
            if (s.paginationContainer && s.paginationContainer.length > 0) {
                var paginationHTML = '';
                if (s.params.paginationType === 'bullets') {
                    var numberOfBullets = s.params.loop ? Math.ceil((s.slides.length - s.loopedSlides * 2) / s.params.slidesPerGroup) : s.snapGrid.length;
                    for (var i = 0; i < numberOfBullets; i++) {
                        if (s.params.paginationBulletRender) {
                            paginationHTML += s.params.paginationBulletRender(s, i, s.params.bulletClass);
                        }
                        else {
                            paginationHTML += '<' + s.params.paginationElement+' class="' + s.params.bulletClass + '"></' + s.params.paginationElement + '>';
                        }
                    }
                    s.paginationContainer.html(paginationHTML);
                    s.bullets = s.paginationContainer.find('.' + s.params.bulletClass);
                    if (s.params.paginationClickable && s.params.a11y && s.a11y) {
                        s.a11y.initPagination();
                    }
                }
                if (s.params.paginationType === 'fraction') {
                    if (s.params.paginationFractionRender) {
                        paginationHTML = s.params.paginationFractionRender(s, s.params.paginationCurrentClass, s.params.paginationTotalClass);
                    }
                    else {
                        paginationHTML =
                            '<span class="' + s.params.paginationCurrentClass + '"></span>' +
                            ' / ' +
                            '<span class="' + s.params.paginationTotalClass+'"></span>';
                    }
                    s.paginationContainer.html(paginationHTML);
                }
                if (s.params.paginationType === 'progress') {
                    if (s.params.paginationProgressRender) {
                        paginationHTML = s.params.paginationProgressRender(s, s.params.paginationProgressbarClass);
                    }
                    else {
                        paginationHTML = '<span class="' + s.params.paginationProgressbarClass + '"></span>';
                    }
                    s.paginationContainer.html(paginationHTML);
                }
                if (s.params.paginationType !== 'custom') {
                    s.emit('onPaginationRendered', s, s.paginationContainer[0]);
                }
            }
        };
        /*=========================
          Common update method
          ===========================*/
        s.update = function (updateTranslate) {
            if (!s) return;
            s.updateContainerSize();
            s.updateSlidesSize();
            s.updateProgress();
            s.updatePagination();
            s.updateClasses();
            if (s.params.scrollbar && s.scrollbar) {
                s.scrollbar.set();
            }
            function forceSetTranslate() {
                var translate = s.rtl ? -s.translate : s.translate;
                newTranslate = Math.min(Math.max(s.translate, s.maxTranslate()), s.minTranslate());
                s.setWrapperTranslate(newTranslate);
                s.updateActiveIndex();
                s.updateClasses();
            }
            if (updateTranslate) {
                var translated, newTranslate;
                if (s.controller && s.controller.spline) {
                    s.controller.spline = undefined;
                }
                if (s.params.freeMode) {
                    forceSetTranslate();
                    if (s.params.autoHeight) {
                        s.updateAutoHeight();
                    }
                }
                else {
                    if ((s.params.slidesPerView === 'auto' || s.params.slidesPerView > 1) && s.isEnd && !s.params.centeredSlides) {
                        translated = s.slideTo(s.slides.length - 1, 0, false, true);
                    }
                    else {
                        translated = s.slideTo(s.activeIndex, 0, false, true);
                    }
                    if (!translated) {
                        forceSetTranslate();
                    }
                }
            }
            else if (s.params.autoHeight) {
                s.updateAutoHeight();
            }
        };
        
        /*=========================
          Resize Handler
          ===========================*/
        s.onResize = function (forceUpdatePagination) {
            //Breakpoints
            if (s.params.breakpoints) {
                s.setBreakpoint();
            }
        
            // Disable locks on resize
            var allowSwipeToPrev = s.params.allowSwipeToPrev;
            var allowSwipeToNext = s.params.allowSwipeToNext;
            s.params.allowSwipeToPrev = s.params.allowSwipeToNext = true;
        
            s.updateContainerSize();
            s.updateSlidesSize();
            if (s.params.slidesPerView === 'auto' || s.params.freeMode || forceUpdatePagination) s.updatePagination();
            if (s.params.scrollbar && s.scrollbar) {
                s.scrollbar.set();
            }
            if (s.controller && s.controller.spline) {
                s.controller.spline = undefined;
            }
            var slideChangedBySlideTo = false;
            if (s.params.freeMode) {
                var newTranslate = Math.min(Math.max(s.translate, s.maxTranslate()), s.minTranslate());
                s.setWrapperTranslate(newTranslate);
                s.updateActiveIndex();
                s.updateClasses();
        
                if (s.params.autoHeight) {
                    s.updateAutoHeight();
                }
            }
            else {
                s.updateClasses();
                if ((s.params.slidesPerView === 'auto' || s.params.slidesPerView > 1) && s.isEnd && !s.params.centeredSlides) {
                    slideChangedBySlideTo = s.slideTo(s.slides.length - 1, 0, false, true);
                }
                else {
                    slideChangedBySlideTo = s.slideTo(s.activeIndex, 0, false, true);
                }
            }
            if (s.params.lazyLoading && !slideChangedBySlideTo && s.lazy) {
                s.lazy.load();
            }
            // Return locks after resize
            s.params.allowSwipeToPrev = allowSwipeToPrev;
            s.params.allowSwipeToNext = allowSwipeToNext;
        };
        
        /*=========================
          Events
          ===========================*/
        
        //Define Touch Events
        s.touchEventsDesktop = {start: 'mousedown', move: 'mousemove', end: 'mouseup'};
        if (window.navigator.pointerEnabled) s.touchEventsDesktop = {start: 'pointerdown', move: 'pointermove', end: 'pointerup'};
        else if (window.navigator.msPointerEnabled) s.touchEventsDesktop = {start: 'MSPointerDown', move: 'MSPointerMove', end: 'MSPointerUp'};
        s.touchEvents = {
            start : s.support.touch || !s.params.simulateTouch  ? 'touchstart' : s.touchEventsDesktop.start,
            move : s.support.touch || !s.params.simulateTouch ? 'touchmove' : s.touchEventsDesktop.move,
            end : s.support.touch || !s.params.simulateTouch ? 'touchend' : s.touchEventsDesktop.end
        };
        
        
        // WP8 Touch Events Fix
        if (window.navigator.pointerEnabled || window.navigator.msPointerEnabled) {
            (s.params.touchEventsTarget === 'container' ? s.container : s.wrapper).addClass('swiper-wp8-' + s.params.direction);
        }
        
        // Attach/detach events
        s.initEvents = function (detach) {
            var actionDom = detach ? 'off' : 'on';
            var action = detach ? 'removeEventListener' : 'addEventListener';
            var touchEventsTarget = s.params.touchEventsTarget === 'container' ? s.container[0] : s.wrapper[0];
            var target = s.support.touch ? touchEventsTarget : document;
        
            var moveCapture = s.params.nested ? true : false;
        
            //Touch Events
            if (s.browser.ie) {
                touchEventsTarget[action](s.touchEvents.start, s.onTouchStart, false);
                target[action](s.touchEvents.move, s.onTouchMove, moveCapture);
                target[action](s.touchEvents.end, s.onTouchEnd, false);
            }
            else {
                if (s.support.touch) {
                    var passiveListener = s.touchEvents.start === 'touchstart' && s.support.passiveListener && s.params.passiveListeners ? {passive: true, capture: false} : false;
                    touchEventsTarget[action](s.touchEvents.start, s.onTouchStart, passiveListener);
                    touchEventsTarget[action](s.touchEvents.move, s.onTouchMove, moveCapture);
                    touchEventsTarget[action](s.touchEvents.end, s.onTouchEnd, passiveListener);
                }
                if ((params.simulateTouch && !s.device.ios && !s.device.android) || (params.simulateTouch && !s.support.touch && s.device.ios)) {
                    touchEventsTarget[action]('mousedown', s.onTouchStart, false);
                    document[action]('mousemove', s.onTouchMove, moveCapture);
                    document[action]('mouseup', s.onTouchEnd, false);
                }
            }
            window[action]('resize', s.onResize);
        
            // Next, Prev, Index
            if (s.params.nextButton && s.nextButton && s.nextButton.length > 0) {
                s.nextButton[actionDom]('click', s.onClickNext);
                if (s.params.a11y && s.a11y) s.nextButton[actionDom]('keydown', s.a11y.onEnterKey);
            }
            if (s.params.prevButton && s.prevButton && s.prevButton.length > 0) {
                s.prevButton[actionDom]('click', s.onClickPrev);
                if (s.params.a11y && s.a11y) s.prevButton[actionDom]('keydown', s.a11y.onEnterKey);
            }
            if (s.params.pagination && s.params.paginationClickable) {
                s.paginationContainer[actionDom]('click', '.' + s.params.bulletClass, s.onClickIndex);
                if (s.params.a11y && s.a11y) s.paginationContainer[actionDom]('keydown', '.' + s.params.bulletClass, s.a11y.onEnterKey);
            }
        
            // Prevent Links Clicks
            if (s.params.preventClicks || s.params.preventClicksPropagation) touchEventsTarget[action]('click', s.preventClicks, true);
        };
        s.attachEvents = function () {
            s.initEvents();
        };
        s.detachEvents = function () {
            s.initEvents(true);
        };
        
        /*=========================
          Handle Clicks
          ===========================*/
        // Prevent Clicks
        s.allowClick = true;
        s.preventClicks = function (e) {
            if (!s.allowClick) {
                if (s.params.preventClicks) e.preventDefault();
                if (s.params.preventClicksPropagation && s.animating) {
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                }
            }
        };
        // Clicks
        s.onClickNext = function (e) {
            e.preventDefault();
            if (s.isEnd && !s.params.loop) return;
            s.slideNext();
        };
        s.onClickPrev = function (e) {
            e.preventDefault();
            if (s.isBeginning && !s.params.loop) return;
            s.slidePrev();
        };
        s.onClickIndex = function (e) {
            e.preventDefault();
            var index = $(this).index() * s.params.slidesPerGroup;
            if (s.params.loop) index = index + s.loopedSlides;
            s.slideTo(index);
        };
        
        /*=========================
          Handle Touches
          ===========================*/
        function findElementInEvent(e, selector) {
            var el = $(e.target);
            if (!el.is(selector)) {
                if (typeof selector === 'string') {
                    el = el.parents(selector);
                }
                else if (selector.nodeType) {
                    var found;
                    el.parents().each(function (index, _el) {
                        if (_el === selector) found = selector;
                    });
                    if (!found) return undefined;
                    else return selector;
                }
            }
            if (el.length === 0) {
                return undefined;
            }
            return el[0];
        }
        s.updateClickedSlide = function (e) {
            var slide = findElementInEvent(e, '.' + s.params.slideClass);
            var slideFound = false;
            if (slide) {
                for (var i = 0; i < s.slides.length; i++) {
                    if (s.slides[i] === slide) slideFound = true;
                }
            }
        
            if (slide && slideFound) {
                s.clickedSlide = slide;
                s.clickedIndex = $(slide).index();
            }
            else {
                s.clickedSlide = undefined;
                s.clickedIndex = undefined;
                return;
            }
            if (s.params.slideToClickedSlide && s.clickedIndex !== undefined && s.clickedIndex !== s.activeIndex) {
                var slideToIndex = s.clickedIndex,
                    realIndex,
                    duplicatedSlides,
                    slidesPerView = s.params.slidesPerView === 'auto' ? s.currentSlidesPerView() : s.params.slidesPerView;
                if (s.params.loop) {
                    if (s.animating) return;
                    realIndex = parseInt($(s.clickedSlide).attr('data-swiper-slide-index'), 10);
                    if (s.params.centeredSlides) {
                        if ((slideToIndex < s.loopedSlides - slidesPerView/2) || (slideToIndex > s.slides.length - s.loopedSlides + slidesPerView/2)) {
                            s.fixLoop();
                            slideToIndex = s.wrapper.children('.' + s.params.slideClass + '[data-swiper-slide-index="' + realIndex + '"]:not(.' + s.params.slideDuplicateClass + ')').eq(0).index();
                            setTimeout(function () {
                                s.slideTo(slideToIndex);
                            }, 0);
                        }
                        else {
                            s.slideTo(slideToIndex);
                        }
                    }
                    else {
                        if (slideToIndex > s.slides.length - slidesPerView) {
                            s.fixLoop();
                            slideToIndex = s.wrapper.children('.' + s.params.slideClass + '[data-swiper-slide-index="' + realIndex + '"]:not(.' + s.params.slideDuplicateClass + ')').eq(0).index();
                            setTimeout(function () {
                                s.slideTo(slideToIndex);
                            }, 0);
                        }
                        else {
                            s.slideTo(slideToIndex);
                        }
                    }
                }
                else {
                    s.slideTo(slideToIndex);
                }
            }
        };
        
        var isTouched,
            isMoved,
            allowTouchCallbacks,
            touchStartTime,
            isScrolling,
            currentTranslate,
            startTranslate,
            allowThresholdMove,
            // Form elements to match
            formElements = 'input, select, textarea, button, video',
            // Last click time
            lastClickTime = Date.now(), clickTimeout,
            //Velocities
            velocities = [],
            allowMomentumBounce;
        
        // Animating Flag
        s.animating = false;
        
        // Touches information
        s.touches = {
            startX: 0,
            startY: 0,
            currentX: 0,
            currentY: 0,
            diff: 0
        };
        
        // Touch handlers
        var isTouchEvent, startMoving;
        s.onTouchStart = function (e) {
            if (e.originalEvent) e = e.originalEvent;
            isTouchEvent = e.type === 'touchstart';
            if (!isTouchEvent && 'which' in e && e.which === 3) return;
            if (s.params.noSwiping && findElementInEvent(e, '.' + s.params.noSwipingClass)) {
                s.allowClick = true;
                return;
            }
            if (s.params.swipeHandler) {
                if (!findElementInEvent(e, s.params.swipeHandler)) return;
            }
        
            var startX = s.touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
            var startY = s.touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
        
            // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore
            if(s.device.ios && s.params.iOSEdgeSwipeDetection && startX <= s.params.iOSEdgeSwipeThreshold) {
                return;
            }
        
            isTouched = true;
            isMoved = false;
            allowTouchCallbacks = true;
            isScrolling = undefined;
            startMoving = undefined;
            s.touches.startX = startX;
            s.touches.startY = startY;
            touchStartTime = Date.now();
            s.allowClick = true;
            s.updateContainerSize();
            s.swipeDirection = undefined;
            if (s.params.threshold > 0) allowThresholdMove = false;
            if (e.type !== 'touchstart') {
                var preventDefault = true;
                if ($(e.target).is(formElements)) preventDefault = false;
                if (document.activeElement && $(document.activeElement).is(formElements)) {
                    document.activeElement.blur();
                }
                if (preventDefault) {
                    e.preventDefault();
                }
            }
            s.emit('onTouchStart', s, e);
        };
        
        s.onTouchMove = function (e) {
            if (e.originalEvent) e = e.originalEvent;
            if (isTouchEvent && e.type === 'mousemove') return;
            if (e.preventedByNestedSwiper) {
                s.touches.startX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
                s.touches.startY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
                return;
            }
            if (s.params.onlyExternal) {
                // isMoved = true;
                s.allowClick = false;
                if (isTouched) {
                    s.touches.startX = s.touches.currentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
                    s.touches.startY = s.touches.currentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
                    touchStartTime = Date.now();
                }
                return;
            }
            if (isTouchEvent && s.params.touchReleaseOnEdges && !s.params.loop) {
                if (!s.isHorizontal()) {
                    // Vertical
                    if (
                        (s.touches.currentY < s.touches.startY && s.translate <= s.maxTranslate()) ||
                        (s.touches.currentY > s.touches.startY && s.translate >= s.minTranslate())
                        ) {
                        return;
                    }
                }
                else {
                    if (
                        (s.touches.currentX < s.touches.startX && s.translate <= s.maxTranslate()) ||
                        (s.touches.currentX > s.touches.startX && s.translate >= s.minTranslate())
                        ) {
                        return;
                    }
                }
            }
            if (isTouchEvent && document.activeElement) {
                if (e.target === document.activeElement && $(e.target).is(formElements)) {
                    isMoved = true;
                    s.allowClick = false;
                    return;
                }
            }
            if (allowTouchCallbacks) {
                s.emit('onTouchMove', s, e);
            }
            if (e.targetTouches && e.targetTouches.length > 1) return;
        
            s.touches.currentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
            s.touches.currentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
        
            if (typeof isScrolling === 'undefined') {
                var touchAngle;
                if (s.isHorizontal() && s.touches.currentY === s.touches.startY || !s.isHorizontal() && s.touches.currentX === s.touches.startX) {
                    isScrolling = false;
                }
                else {
                    touchAngle = Math.atan2(Math.abs(s.touches.currentY - s.touches.startY), Math.abs(s.touches.currentX - s.touches.startX)) * 180 / Math.PI;
                    isScrolling = s.isHorizontal() ? touchAngle > s.params.touchAngle : (90 - touchAngle > s.params.touchAngle);
                }
            }
            if (isScrolling) {
                s.emit('onTouchMoveOpposite', s, e);
            }
            if (typeof startMoving === 'undefined' && s.browser.ieTouch) {
                if (s.touches.currentX !== s.touches.startX || s.touches.currentY !== s.touches.startY) {
                    startMoving = true;
                }
            }
            if (!isTouched) return;
            if (isScrolling)  {
                isTouched = false;
                return;
            }
            if (!startMoving && s.browser.ieTouch) {
                return;
            }
            s.allowClick = false;
            s.emit('onSliderMove', s, e);
            e.preventDefault();
            if (s.params.touchMoveStopPropagation && !s.params.nested) {
                e.stopPropagation();
            }
        
            if (!isMoved) {
                if (params.loop) {
                    s.fixLoop();
                }
                startTranslate = s.getWrapperTranslate();
                s.setWrapperTransition(0);
                if (s.animating) {
                    s.wrapper.trigger('webkitTransitionEnd transitionend oTransitionEnd MSTransitionEnd msTransitionEnd');
                }
                if (s.params.autoplay && s.autoplaying) {
                    if (s.params.autoplayDisableOnInteraction) {
                        s.stopAutoplay();
                    }
                    else {
                        s.pauseAutoplay();
                    }
                }
                allowMomentumBounce = false;
                //Grab Cursor
                if (s.params.grabCursor && (s.params.allowSwipeToNext === true || s.params.allowSwipeToPrev === true)) {
                    s.setGrabCursor(true);
                }
            }
            isMoved = true;
        
            var diff = s.touches.diff = s.isHorizontal() ? s.touches.currentX - s.touches.startX : s.touches.currentY - s.touches.startY;
        
            diff = diff * s.params.touchRatio;
            if (s.rtl) diff = -diff;
        
            s.swipeDirection = diff > 0 ? 'prev' : 'next';
            currentTranslate = diff + startTranslate;
        
            var disableParentSwiper = true;
            if ((diff > 0 && currentTranslate > s.minTranslate())) {
                disableParentSwiper = false;
                if (s.params.resistance) currentTranslate = s.minTranslate() - 1 + Math.pow(-s.minTranslate() + startTranslate + diff, s.params.resistanceRatio);
            }
            else if (diff < 0 && currentTranslate < s.maxTranslate()) {
                disableParentSwiper = false;
                if (s.params.resistance) currentTranslate = s.maxTranslate() + 1 - Math.pow(s.maxTranslate() - startTranslate - diff, s.params.resistanceRatio);
            }
        
            if (disableParentSwiper) {
                e.preventedByNestedSwiper = true;
            }
        
            // Directions locks
            if (!s.params.allowSwipeToNext && s.swipeDirection === 'next' && currentTranslate < startTranslate) {
                currentTranslate = startTranslate;
            }
            if (!s.params.allowSwipeToPrev && s.swipeDirection === 'prev' && currentTranslate > startTranslate) {
                currentTranslate = startTranslate;
            }
        
        
            // Threshold
            if (s.params.threshold > 0) {
                if (Math.abs(diff) > s.params.threshold || allowThresholdMove) {
                    if (!allowThresholdMove) {
                        allowThresholdMove = true;
                        s.touches.startX = s.touches.currentX;
                        s.touches.startY = s.touches.currentY;
                        currentTranslate = startTranslate;
                        s.touches.diff = s.isHorizontal() ? s.touches.currentX - s.touches.startX : s.touches.currentY - s.touches.startY;
                        return;
                    }
                }
                else {
                    currentTranslate = startTranslate;
                    return;
                }
            }
        
            if (!s.params.followFinger) return;
        
            // Update active index in free mode
            if (s.params.freeMode || s.params.watchSlidesProgress) {
                s.updateActiveIndex();
            }
            if (s.params.freeMode) {
                //Velocity
                if (velocities.length === 0) {
                    velocities.push({
                        position: s.touches[s.isHorizontal() ? 'startX' : 'startY'],
                        time: touchStartTime
                    });
                }
                velocities.push({
                    position: s.touches[s.isHorizontal() ? 'currentX' : 'currentY'],
                    time: (new window.Date()).getTime()
                });
            }
            // Update progress
            s.updateProgress(currentTranslate);
            // Update translate
            s.setWrapperTranslate(currentTranslate);
        };
        s.onTouchEnd = function (e) {
            if (e.originalEvent) e = e.originalEvent;
            if (allowTouchCallbacks) {
                s.emit('onTouchEnd', s, e);
            }
            allowTouchCallbacks = false;
            if (!isTouched) return;
            //Return Grab Cursor
            if (s.params.grabCursor && isMoved && isTouched  && (s.params.allowSwipeToNext === true || s.params.allowSwipeToPrev === true)) {
                s.setGrabCursor(false);
            }
        
            // Time diff
            var touchEndTime = Date.now();
            var timeDiff = touchEndTime - touchStartTime;
        
            // Tap, doubleTap, Click
            if (s.allowClick) {
                s.updateClickedSlide(e);
                s.emit('onTap', s, e);
                if (timeDiff < 300 && (touchEndTime - lastClickTime) > 300) {
                    if (clickTimeout) clearTimeout(clickTimeout);
                    clickTimeout = setTimeout(function () {
                        if (!s) return;
                        if (s.params.paginationHide && s.paginationContainer.length > 0 && !$(e.target).hasClass(s.params.bulletClass)) {
                            s.paginationContainer.toggleClass(s.params.paginationHiddenClass);
                        }
                        s.emit('onClick', s, e);
                    }, 300);
        
                }
                if (timeDiff < 300 && (touchEndTime - lastClickTime) < 300) {
                    if (clickTimeout) clearTimeout(clickTimeout);
                    s.emit('onDoubleTap', s, e);
                }
            }
        
            lastClickTime = Date.now();
            setTimeout(function () {
                if (s) s.allowClick = true;
            }, 0);
        
            if (!isTouched || !isMoved || !s.swipeDirection || s.touches.diff === 0 || currentTranslate === startTranslate) {
                isTouched = isMoved = false;
                return;
            }
            isTouched = isMoved = false;
        
            var currentPos;
            if (s.params.followFinger) {
                currentPos = s.rtl ? s.translate : -s.translate;
            }
            else {
                currentPos = -currentTranslate;
            }
            if (s.params.freeMode) {
                if (currentPos < -s.minTranslate()) {
                    s.slideTo(s.activeIndex);
                    return;
                }
                else if (currentPos > -s.maxTranslate()) {
                    if (s.slides.length < s.snapGrid.length) {
                        s.slideTo(s.snapGrid.length - 1);
                    }
                    else {
                        s.slideTo(s.slides.length - 1);
                    }
                    return;
                }
        
                if (s.params.freeModeMomentum) {
                    if (velocities.length > 1) {
                        var lastMoveEvent = velocities.pop(), velocityEvent = velocities.pop();
        
                        var distance = lastMoveEvent.position - velocityEvent.position;
                        var time = lastMoveEvent.time - velocityEvent.time;
                        s.velocity = distance / time;
                        s.velocity = s.velocity / 2;
                        if (Math.abs(s.velocity) < s.params.freeModeMinimumVelocity) {
                            s.velocity = 0;
                        }
                        // this implies that the user stopped moving a finger then released.
                        // There would be no events with distance zero, so the last event is stale.
                        if (time > 150 || (new window.Date().getTime() - lastMoveEvent.time) > 300) {
                            s.velocity = 0;
                        }
                    } else {
                        s.velocity = 0;
                    }
                    s.velocity = s.velocity * s.params.freeModeMomentumVelocityRatio;
        
                    velocities.length = 0;
                    var momentumDuration = 1000 * s.params.freeModeMomentumRatio;
                    var momentumDistance = s.velocity * momentumDuration;
        
                    var newPosition = s.translate + momentumDistance;
                    if (s.rtl) newPosition = - newPosition;
                    var doBounce = false;
                    var afterBouncePosition;
                    var bounceAmount = Math.abs(s.velocity) * 20 * s.params.freeModeMomentumBounceRatio;
                    if (newPosition < s.maxTranslate()) {
                        if (s.params.freeModeMomentumBounce) {
                            if (newPosition + s.maxTranslate() < -bounceAmount) {
                                newPosition = s.maxTranslate() - bounceAmount;
                            }
                            afterBouncePosition = s.maxTranslate();
                            doBounce = true;
                            allowMomentumBounce = true;
                        }
                        else {
                            newPosition = s.maxTranslate();
                        }
                    }
                    else if (newPosition > s.minTranslate()) {
                        if (s.params.freeModeMomentumBounce) {
                            if (newPosition - s.minTranslate() > bounceAmount) {
                                newPosition = s.minTranslate() + bounceAmount;
                            }
                            afterBouncePosition = s.minTranslate();
                            doBounce = true;
                            allowMomentumBounce = true;
                        }
                        else {
                            newPosition = s.minTranslate();
                        }
                    }
                    else if (s.params.freeModeSticky) {
                        var j = 0,
                            nextSlide;
                        for (j = 0; j < s.snapGrid.length; j += 1) {
                            if (s.snapGrid[j] > -newPosition) {
                                nextSlide = j;
                                break;
                            }
        
                        }
                        if (Math.abs(s.snapGrid[nextSlide] - newPosition) < Math.abs(s.snapGrid[nextSlide - 1] - newPosition) || s.swipeDirection === 'next') {
                            newPosition = s.snapGrid[nextSlide];
                        } else {
                            newPosition = s.snapGrid[nextSlide - 1];
                        }
                        if (!s.rtl) newPosition = - newPosition;
                    }
                    //Fix duration
                    if (s.velocity !== 0) {
                        if (s.rtl) {
                            momentumDuration = Math.abs((-newPosition - s.translate) / s.velocity);
                        }
                        else {
                            momentumDuration = Math.abs((newPosition - s.translate) / s.velocity);
                        }
                    }
                    else if (s.params.freeModeSticky) {
                        s.slideReset();
                        return;
                    }
        
                    if (s.params.freeModeMomentumBounce && doBounce) {
                        s.updateProgress(afterBouncePosition);
                        s.setWrapperTransition(momentumDuration);
                        s.setWrapperTranslate(newPosition);
                        s.onTransitionStart();
                        s.animating = true;
                        s.wrapper.transitionEnd(function () {
                            if (!s || !allowMomentumBounce) return;
                            s.emit('onMomentumBounce', s);
        
                            s.setWrapperTransition(s.params.speed);
                            s.setWrapperTranslate(afterBouncePosition);
                            s.wrapper.transitionEnd(function () {
                                if (!s) return;
                                s.onTransitionEnd();
                            });
                        });
                    } else if (s.velocity) {
                        s.updateProgress(newPosition);
                        s.setWrapperTransition(momentumDuration);
                        s.setWrapperTranslate(newPosition);
                        s.onTransitionStart();
                        if (!s.animating) {
                            s.animating = true;
                            s.wrapper.transitionEnd(function () {
                                if (!s) return;
                                s.onTransitionEnd();
                            });
                        }
        
                    } else {
                        s.updateProgress(newPosition);
                    }
        
                    s.updateActiveIndex();
                }
                if (!s.params.freeModeMomentum || timeDiff >= s.params.longSwipesMs) {
                    s.updateProgress();
                    s.updateActiveIndex();
                }
                return;
            }
        
            // Find current slide
            var i, stopIndex = 0, groupSize = s.slidesSizesGrid[0];
            for (i = 0; i < s.slidesGrid.length; i += s.params.slidesPerGroup) {
                if (typeof s.slidesGrid[i + s.params.slidesPerGroup] !== 'undefined') {
                    if (currentPos >= s.slidesGrid[i] && currentPos < s.slidesGrid[i + s.params.slidesPerGroup]) {
                        stopIndex = i;
                        groupSize = s.slidesGrid[i + s.params.slidesPerGroup] - s.slidesGrid[i];
                    }
                }
                else {
                    if (currentPos >= s.slidesGrid[i]) {
                        stopIndex = i;
                        groupSize = s.slidesGrid[s.slidesGrid.length - 1] - s.slidesGrid[s.slidesGrid.length - 2];
                    }
                }
            }
        
            // Find current slide size
            var ratio = (currentPos - s.slidesGrid[stopIndex]) / groupSize;
        
            if (timeDiff > s.params.longSwipesMs) {
                // Long touches
                if (!s.params.longSwipes) {
                    s.slideTo(s.activeIndex);
                    return;
                }
                if (s.swipeDirection === 'next') {
                    if (ratio >= s.params.longSwipesRatio) s.slideTo(stopIndex + s.params.slidesPerGroup);
                    else s.slideTo(stopIndex);
        
                }
                if (s.swipeDirection === 'prev') {
                    if (ratio > (1 - s.params.longSwipesRatio)) s.slideTo(stopIndex + s.params.slidesPerGroup);
                    else s.slideTo(stopIndex);
                }
            }
            else {
                // Short swipes
                if (!s.params.shortSwipes) {
                    s.slideTo(s.activeIndex);
                    return;
                }
                if (s.swipeDirection === 'next') {
                    s.slideTo(stopIndex + s.params.slidesPerGroup);
        
                }
                if (s.swipeDirection === 'prev') {
                    s.slideTo(stopIndex);
                }
            }
        };
        /*=========================
          Transitions
          ===========================*/
        s._slideTo = function (slideIndex, speed) {
            return s.slideTo(slideIndex, speed, true, true);
        };
        s.slideTo = function (slideIndex, speed, runCallbacks, internal) {
            if (typeof runCallbacks === 'undefined') runCallbacks = true;
            if (typeof slideIndex === 'undefined') slideIndex = 0;
            if (slideIndex < 0) slideIndex = 0;
            s.snapIndex = Math.floor(slideIndex / s.params.slidesPerGroup);
            if (s.snapIndex >= s.snapGrid.length) s.snapIndex = s.snapGrid.length - 1;
        
            var translate = - s.snapGrid[s.snapIndex];
            // Stop autoplay
            if (s.params.autoplay && s.autoplaying) {
                if (internal || !s.params.autoplayDisableOnInteraction) {
                    s.pauseAutoplay(speed);
                }
                else {
                    s.stopAutoplay();
                }
            }
            // Update progress
            s.updateProgress(translate);
        
            // Normalize slideIndex
            if(s.params.normalizeSlideIndex){
                for (var i = 0; i < s.slidesGrid.length; i++) {
                    if (- Math.floor(translate * 100) >= Math.floor(s.slidesGrid[i] * 100)) {
                        slideIndex = i;
                    }
                }
            }
        
            // Directions locks
            if (!s.params.allowSwipeToNext && translate < s.translate && translate < s.minTranslate()) {
                return false;
            }
            if (!s.params.allowSwipeToPrev && translate > s.translate && translate > s.maxTranslate()) {
                if ((s.activeIndex || 0) !== slideIndex ) return false;
            }
        
            // Update Index
            if (typeof speed === 'undefined') speed = s.params.speed;
            s.previousIndex = s.activeIndex || 0;
            s.activeIndex = slideIndex;
            s.updateRealIndex();
            if ((s.rtl && -translate === s.translate) || (!s.rtl && translate === s.translate)) {
                // Update Height
                if (s.params.autoHeight) {
                    s.updateAutoHeight();
                }
                s.updateClasses();
                if (s.params.effect !== 'slide') {
                    s.setWrapperTranslate(translate);
                }
                return false;
            }
            s.updateClasses();
            s.onTransitionStart(runCallbacks);
        
            if (speed === 0 || s.browser.lteIE9) {
                s.setWrapperTranslate(translate);
                s.setWrapperTransition(0);
                s.onTransitionEnd(runCallbacks);
            }
            else {
                s.setWrapperTranslate(translate);
                s.setWrapperTransition(speed);
                if (!s.animating) {
                    s.animating = true;
                    s.wrapper.transitionEnd(function () {
                        if (!s) return;
                        s.onTransitionEnd(runCallbacks);
                    });
                }
        
            }
        
            return true;
        };
        
        s.onTransitionStart = function (runCallbacks) {
            if (typeof runCallbacks === 'undefined') runCallbacks = true;
            if (s.params.autoHeight) {
                s.updateAutoHeight();
            }
            if (s.lazy) s.lazy.onTransitionStart();
            if (runCallbacks) {
                s.emit('onTransitionStart', s);
                if (s.activeIndex !== s.previousIndex) {
                    s.emit('onSlideChangeStart', s);
                    if (s.activeIndex > s.previousIndex) {
                        s.emit('onSlideNextStart', s);
                    }
                    else {
                        s.emit('onSlidePrevStart', s);
                    }
                }
        
            }
        };
        s.onTransitionEnd = function (runCallbacks) {
            s.animating = false;
            s.setWrapperTransition(0);
            if (typeof runCallbacks === 'undefined') runCallbacks = true;
            if (s.lazy) s.lazy.onTransitionEnd();
            if (runCallbacks) {
                s.emit('onTransitionEnd', s);
                if (s.activeIndex !== s.previousIndex) {
                    s.emit('onSlideChangeEnd', s);
                    if (s.activeIndex > s.previousIndex) {
                        s.emit('onSlideNextEnd', s);
                    }
                    else {
                        s.emit('onSlidePrevEnd', s);
                    }
                }
            }
            if (s.params.history && s.history) {
                s.history.setHistory(s.params.history, s.activeIndex);
            }
            if (s.params.hashnav && s.hashnav) {
                s.hashnav.setHash();
            }
        
        };
        s.slideNext = function (runCallbacks, speed, internal) {
            if (s.params.loop) {
                if (s.animating) return false;
                s.fixLoop();
                var clientLeft = s.container[0].clientLeft;
                return s.slideTo(s.activeIndex + s.params.slidesPerGroup, speed, runCallbacks, internal);
            }
            else return s.slideTo(s.activeIndex + s.params.slidesPerGroup, speed, runCallbacks, internal);
        };
        s._slideNext = function (speed) {
            return s.slideNext(true, speed, true);
        };
        s.slidePrev = function (runCallbacks, speed, internal) {
            if (s.params.loop) {
                if (s.animating) return false;
                s.fixLoop();
                var clientLeft = s.container[0].clientLeft;
                return s.slideTo(s.activeIndex - 1, speed, runCallbacks, internal);
            }
            else return s.slideTo(s.activeIndex - 1, speed, runCallbacks, internal);
        };
        s._slidePrev = function (speed) {
            return s.slidePrev(true, speed, true);
        };
        s.slideReset = function (runCallbacks, speed, internal) {
            return s.slideTo(s.activeIndex, speed, runCallbacks);
        };
        
        s.disableTouchControl = function () {
            s.params.onlyExternal = true;
            return true;
        };
        s.enableTouchControl = function () {
            s.params.onlyExternal = false;
            return true;
        };
        
        /*=========================
          Translate/transition helpers
          ===========================*/
        s.setWrapperTransition = function (duration, byController) {
            s.wrapper.transition(duration);
            if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
                s.effects[s.params.effect].setTransition(duration);
            }
            if (s.params.parallax && s.parallax) {
                s.parallax.setTransition(duration);
            }
            if (s.params.scrollbar && s.scrollbar) {
                s.scrollbar.setTransition(duration);
            }
            if (s.params.control && s.controller) {
                s.controller.setTransition(duration, byController);
            }
            s.emit('onSetTransition', s, duration);
        };
        s.setWrapperTranslate = function (translate, updateActiveIndex, byController) {
            var x = 0, y = 0, z = 0;
            if (s.isHorizontal()) {
                x = s.rtl ? -translate : translate;
            }
            else {
                y = translate;
            }
        
            if (s.params.roundLengths) {
                x = round(x);
                y = round(y);
            }
        
            if (!s.params.virtualTranslate) {
                if (s.support.transforms3d) s.wrapper.transform('translate3d(' + x + 'px, ' + y + 'px, ' + z + 'px)');
                else s.wrapper.transform('translate(' + x + 'px, ' + y + 'px)');
            }
        
            s.translate = s.isHorizontal() ? x : y;
        
            // Check if we need to update progress
            var progress;
            var translatesDiff = s.maxTranslate() - s.minTranslate();
            if (translatesDiff === 0) {
                progress = 0;
            }
            else {
                progress = (translate - s.minTranslate()) / (translatesDiff);
            }
            if (progress !== s.progress) {
                s.updateProgress(translate);
            }
        
            if (updateActiveIndex) s.updateActiveIndex();
            if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
                s.effects[s.params.effect].setTranslate(s.translate);
            }
            if (s.params.parallax && s.parallax) {
                s.parallax.setTranslate(s.translate);
            }
            if (s.params.scrollbar && s.scrollbar) {
                s.scrollbar.setTranslate(s.translate);
            }
            if (s.params.control && s.controller) {
                s.controller.setTranslate(s.translate, byController);
            }
            s.emit('onSetTranslate', s, s.translate);
        };
        
        s.getTranslate = function (el, axis) {
            var matrix, curTransform, curStyle, transformMatrix;
        
            // automatic axis detection
            if (typeof axis === 'undefined') {
                axis = 'x';
            }
        
            if (s.params.virtualTranslate) {
                return s.rtl ? -s.translate : s.translate;
            }
        
            curStyle = window.getComputedStyle(el, null);
            if (window.WebKitCSSMatrix) {
                curTransform = curStyle.transform || curStyle.webkitTransform;
                if (curTransform.split(',').length > 6) {
                    curTransform = curTransform.split(', ').map(function(a){
                        return a.replace(',','.');
                    }).join(', ');
                }
                // Some old versions of Webkit choke when 'none' is passed; pass
                // empty string instead in this case
                transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
            }
            else {
                transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform  || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
                matrix = transformMatrix.toString().split(',');
            }
        
            if (axis === 'x') {
                //Latest Chrome and webkits Fix
                if (window.WebKitCSSMatrix)
                    curTransform = transformMatrix.m41;
                //Crazy IE10 Matrix
                else if (matrix.length === 16)
                    curTransform = parseFloat(matrix[12]);
                //Normal Browsers
                else
                    curTransform = parseFloat(matrix[4]);
            }
            if (axis === 'y') {
                //Latest Chrome and webkits Fix
                if (window.WebKitCSSMatrix)
                    curTransform = transformMatrix.m42;
                //Crazy IE10 Matrix
                else if (matrix.length === 16)
                    curTransform = parseFloat(matrix[13]);
                //Normal Browsers
                else
                    curTransform = parseFloat(matrix[5]);
            }
            if (s.rtl && curTransform) curTransform = -curTransform;
            return curTransform || 0;
        };
        s.getWrapperTranslate = function (axis) {
            if (typeof axis === 'undefined') {
                axis = s.isHorizontal() ? 'x' : 'y';
            }
            return s.getTranslate(s.wrapper[0], axis);
        };
        
        /*=========================
          Observer
          ===========================*/
        s.observers = [];
        function initObserver(target, options) {
            options = options || {};
            // create an observer instance
            var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
            var observer = new ObserverFunc(function (mutations) {
                mutations.forEach(function (mutation) {
                    s.onResize(true);
                    s.emit('onObserverUpdate', s, mutation);
                });
            });
        
            observer.observe(target, {
                attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
                childList: typeof options.childList === 'undefined' ? true : options.childList,
                characterData: typeof options.characterData === 'undefined' ? true : options.characterData
            });
        
            s.observers.push(observer);
        }
        s.initObservers = function () {
            if (s.params.observeParents) {
                var containerParents = s.container.parents();
                for (var i = 0; i < containerParents.length; i++) {
                    initObserver(containerParents[i]);
                }
            }
        
            // Observe container
            initObserver(s.container[0], {childList: false});
        
            // Observe wrapper
            initObserver(s.wrapper[0], {attributes: false});
        };
        s.disconnectObservers = function () {
            for (var i = 0; i < s.observers.length; i++) {
                s.observers[i].disconnect();
            }
            s.observers = [];
        };
        /*=========================
          Loop
          ===========================*/
        // Create looped slides
        s.createLoop = function () {
            // Remove duplicated slides
            s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass).remove();
        
            var slides = s.wrapper.children('.' + s.params.slideClass);
        
            if(s.params.slidesPerView === 'auto' && !s.params.loopedSlides) s.params.loopedSlides = slides.length;
        
            s.loopedSlides = parseInt(s.params.loopedSlides || s.params.slidesPerView, 10);
            s.loopedSlides = s.loopedSlides + s.params.loopAdditionalSlides;
            if (s.loopedSlides > slides.length) {
                s.loopedSlides = slides.length;
            }
        
            var prependSlides = [], appendSlides = [], i;
            slides.each(function (index, el) {
                var slide = $(this);
                if (index < s.loopedSlides) appendSlides.push(el);
                if (index < slides.length && index >= slides.length - s.loopedSlides) prependSlides.push(el);
                slide.attr('data-swiper-slide-index', index);
            });
            for (i = 0; i < appendSlides.length; i++) {
                s.wrapper.append($(appendSlides[i].cloneNode(true)).addClass(s.params.slideDuplicateClass));
            }
            for (i = prependSlides.length - 1; i >= 0; i--) {
                s.wrapper.prepend($(prependSlides[i].cloneNode(true)).addClass(s.params.slideDuplicateClass));
            }
        };
        s.destroyLoop = function () {
            s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass).remove();
            s.slides.removeAttr('data-swiper-slide-index');
        };
        s.reLoop = function (updatePosition) {
            var oldIndex = s.activeIndex - s.loopedSlides;
            s.destroyLoop();
            s.createLoop();
            s.updateSlidesSize();
            if (updatePosition) {
                s.slideTo(oldIndex + s.loopedSlides, 0, false);
            }
        
        };
        s.fixLoop = function () {
            var newIndex;
            //Fix For Negative Oversliding
            if (s.activeIndex < s.loopedSlides) {
                newIndex = s.slides.length - s.loopedSlides * 3 + s.activeIndex;
                newIndex = newIndex + s.loopedSlides;
                s.slideTo(newIndex, 0, false, true);
            }
            //Fix For Positive Oversliding
            else if ((s.params.slidesPerView === 'auto' && s.activeIndex >= s.loopedSlides * 2) || (s.activeIndex > s.slides.length - s.params.slidesPerView * 2)) {
                newIndex = -s.slides.length + s.activeIndex + s.loopedSlides;
                newIndex = newIndex + s.loopedSlides;
                s.slideTo(newIndex, 0, false, true);
            }
        };
        /*=========================
          Append/Prepend/Remove Slides
          ===========================*/
        s.appendSlide = function (slides) {
            if (s.params.loop) {
                s.destroyLoop();
            }
            if (typeof slides === 'object' && slides.length) {
                for (var i = 0; i < slides.length; i++) {
                    if (slides[i]) s.wrapper.append(slides[i]);
                }
            }
            else {
                s.wrapper.append(slides);
            }
            if (s.params.loop) {
                s.createLoop();
            }
            if (!(s.params.observer && s.support.observer)) {
                s.update(true);
            }
        };
        s.prependSlide = function (slides) {
            if (s.params.loop) {
                s.destroyLoop();
            }
            var newActiveIndex = s.activeIndex + 1;
            if (typeof slides === 'object' && slides.length) {
                for (var i = 0; i < slides.length; i++) {
                    if (slides[i]) s.wrapper.prepend(slides[i]);
                }
                newActiveIndex = s.activeIndex + slides.length;
            }
            else {
                s.wrapper.prepend(slides);
            }
            if (s.params.loop) {
                s.createLoop();
            }
            if (!(s.params.observer && s.support.observer)) {
                s.update(true);
            }
            s.slideTo(newActiveIndex, 0, false);
        };
        s.removeSlide = function (slidesIndexes) {
            if (s.params.loop) {
                s.destroyLoop();
                s.slides = s.wrapper.children('.' + s.params.slideClass);
            }
            var newActiveIndex = s.activeIndex,
                indexToRemove;
            if (typeof slidesIndexes === 'object' && slidesIndexes.length) {
                for (var i = 0; i < slidesIndexes.length; i++) {
                    indexToRemove = slidesIndexes[i];
                    if (s.slides[indexToRemove]) s.slides.eq(indexToRemove).remove();
                    if (indexToRemove < newActiveIndex) newActiveIndex--;
                }
                newActiveIndex = Math.max(newActiveIndex, 0);
            }
            else {
                indexToRemove = slidesIndexes;
                if (s.slides[indexToRemove]) s.slides.eq(indexToRemove).remove();
                if (indexToRemove < newActiveIndex) newActiveIndex--;
                newActiveIndex = Math.max(newActiveIndex, 0);
            }
        
            if (s.params.loop) {
                s.createLoop();
            }
        
            if (!(s.params.observer && s.support.observer)) {
                s.update(true);
            }
            if (s.params.loop) {
                s.slideTo(newActiveIndex + s.loopedSlides, 0, false);
            }
            else {
                s.slideTo(newActiveIndex, 0, false);
            }
        
        };
        s.removeAllSlides = function () {
            var slidesIndexes = [];
            for (var i = 0; i < s.slides.length; i++) {
                slidesIndexes.push(i);
            }
            s.removeSlide(slidesIndexes);
        };
        

        /*=========================
          Effects
          ===========================*/
        s.effects = {
            fade: {
                setTranslate: function () {
                    for (var i = 0; i < s.slides.length; i++) {
                        var slide = s.slides.eq(i);
                        var offset = slide[0].swiperSlideOffset;
                        var tx = -offset;
                        if (!s.params.virtualTranslate) tx = tx - s.translate;
                        var ty = 0;
                        if (!s.isHorizontal()) {
                            ty = tx;
                            tx = 0;
                        }
                        var slideOpacity = s.params.fade.crossFade ?
                                Math.max(1 - Math.abs(slide[0].progress), 0) :
                                1 + Math.min(Math.max(slide[0].progress, -1), 0);
                        slide
                            .css({
                                opacity: slideOpacity
                            })
                            .transform('translate3d(' + tx + 'px, ' + ty + 'px, 0px)');
        
                    }
        
                },
                setTransition: function (duration) {
                    s.slides.transition(duration);
                    if (s.params.virtualTranslate && duration !== 0) {
                        var eventTriggered = false;
                        s.slides.transitionEnd(function () {
                            if (eventTriggered) return;
                            if (!s) return;
                            eventTriggered = true;
                            s.animating = false;
                            var triggerEvents = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'];
                            for (var i = 0; i < triggerEvents.length; i++) {
                                s.wrapper.trigger(triggerEvents[i]);
                            }
                        });
                    }
                }
            },
            flip: {
                setTranslate: function () {
                    for (var i = 0; i < s.slides.length; i++) {
                        var slide = s.slides.eq(i);
                        var progress = slide[0].progress;
                        if (s.params.flip.limitRotation) {
                            progress = Math.max(Math.min(slide[0].progress, 1), -1);
                        }
                        var offset = slide[0].swiperSlideOffset;
                        var rotate = -180 * progress,
                            rotateY = rotate,
                            rotateX = 0,
                            tx = -offset,
                            ty = 0;
                        if (!s.isHorizontal()) {
                            ty = tx;
                            tx = 0;
                            rotateX = -rotateY;
                            rotateY = 0;
                        }
                        else if (s.rtl) {
                            rotateY = -rotateY;
                        }
        
                        slide[0].style.zIndex = -Math.abs(Math.round(progress)) + s.slides.length;
        
                        if (s.params.flip.slideShadows) {
                            //Set shadows
                            var shadowBefore = s.isHorizontal() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
                            var shadowAfter = s.isHorizontal() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');
                            if (shadowBefore.length === 0) {
                                shadowBefore = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'left' : 'top') + '"></div>');
                                slide.append(shadowBefore);
                            }
                            if (shadowAfter.length === 0) {
                                shadowAfter = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'right' : 'bottom') + '"></div>');
                                slide.append(shadowAfter);
                            }
                            if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
                            if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
                        }
        
                        slide
                            .transform('translate3d(' + tx + 'px, ' + ty + 'px, 0px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)');
                    }
                },
                setTransition: function (duration) {
                    s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
                    if (s.params.virtualTranslate && duration !== 0) {
                        var eventTriggered = false;
                        s.slides.eq(s.activeIndex).transitionEnd(function () {
                            if (eventTriggered) return;
                            if (!s) return;
                            if (!$(this).hasClass(s.params.slideActiveClass)) return;
                            eventTriggered = true;
                            s.animating = false;
                            var triggerEvents = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'];
                            for (var i = 0; i < triggerEvents.length; i++) {
                                s.wrapper.trigger(triggerEvents[i]);
                            }
                        });
                    }
                }
            },
            cube: {
                setTranslate: function () {
                    var wrapperRotate = 0, cubeShadow;
                    if (s.params.cube.shadow) {
                        if (s.isHorizontal()) {
                            cubeShadow = s.wrapper.find('.swiper-cube-shadow');
                            if (cubeShadow.length === 0) {
                                cubeShadow = $('<div class="swiper-cube-shadow"></div>');
                                s.wrapper.append(cubeShadow);
                            }
                            cubeShadow.css({height: s.width + 'px'});
                        }
                        else {
                            cubeShadow = s.container.find('.swiper-cube-shadow');
                            if (cubeShadow.length === 0) {
                                cubeShadow = $('<div class="swiper-cube-shadow"></div>');
                                s.container.append(cubeShadow);
                            }
                        }
                    }
                    for (var i = 0; i < s.slides.length; i++) {
                        var slide = s.slides.eq(i);
                        var slideAngle = i * 90;
                        var round = Math.floor(slideAngle / 360);
                        if (s.rtl) {
                            slideAngle = -slideAngle;
                            round = Math.floor(-slideAngle / 360);
                        }
                        var progress = Math.max(Math.min(slide[0].progress, 1), -1);
                        var tx = 0, ty = 0, tz = 0;
                        if (i % 4 === 0) {
                            tx = - round * 4 * s.size;
                            tz = 0;
                        }
                        else if ((i - 1) % 4 === 0) {
                            tx = 0;
                            tz = - round * 4 * s.size;
                        }
                        else if ((i - 2) % 4 === 0) {
                            tx = s.size + round * 4 * s.size;
                            tz = s.size;
                        }
                        else if ((i - 3) % 4 === 0) {
                            tx = - s.size;
                            tz = 3 * s.size + s.size * 4 * round;
                        }
                        if (s.rtl) {
                            tx = -tx;
                        }
        
                        if (!s.isHorizontal()) {
                            ty = tx;
                            tx = 0;
                        }
        
                        var transform = 'rotateX(' + (s.isHorizontal() ? 0 : -slideAngle) + 'deg) rotateY(' + (s.isHorizontal() ? slideAngle : 0) + 'deg) translate3d(' + tx + 'px, ' + ty + 'px, ' + tz + 'px)';
                        if (progress <= 1 && progress > -1) {
                            wrapperRotate = i * 90 + progress * 90;
                            if (s.rtl) wrapperRotate = -i * 90 - progress * 90;
                        }
                        slide.transform(transform);
                        if (s.params.cube.slideShadows) {
                            //Set shadows
                            var shadowBefore = s.isHorizontal() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
                            var shadowAfter = s.isHorizontal() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');
                            if (shadowBefore.length === 0) {
                                shadowBefore = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'left' : 'top') + '"></div>');
                                slide.append(shadowBefore);
                            }
                            if (shadowAfter.length === 0) {
                                shadowAfter = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'right' : 'bottom') + '"></div>');
                                slide.append(shadowAfter);
                            }
                            if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
                            if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
                        }
                    }
                    s.wrapper.css({
                        '-webkit-transform-origin': '50% 50% -' + (s.size / 2) + 'px',
                        '-moz-transform-origin': '50% 50% -' + (s.size / 2) + 'px',
                        '-ms-transform-origin': '50% 50% -' + (s.size / 2) + 'px',
                        'transform-origin': '50% 50% -' + (s.size / 2) + 'px'
                    });
        
                    if (s.params.cube.shadow) {
                        if (s.isHorizontal()) {
                            cubeShadow.transform('translate3d(0px, ' + (s.width / 2 + s.params.cube.shadowOffset) + 'px, ' + (-s.width / 2) + 'px) rotateX(90deg) rotateZ(0deg) scale(' + (s.params.cube.shadowScale) + ')');
                        }
                        else {
                            var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                            var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                            var scale1 = s.params.cube.shadowScale,
                                scale2 = s.params.cube.shadowScale / multiplier,
                                offset = s.params.cube.shadowOffset;
                            cubeShadow.transform('scale3d(' + scale1 + ', 1, ' + scale2 + ') translate3d(0px, ' + (s.height / 2 + offset) + 'px, ' + (-s.height / 2 / scale2) + 'px) rotateX(-90deg)');
                        }
                    }
                    var zFactor = (s.isSafari || s.isUiWebView) ? (-s.size / 2) : 0;
                    s.wrapper.transform('translate3d(0px,0,' + zFactor + 'px) rotateX(' + (s.isHorizontal() ? 0 : wrapperRotate) + 'deg) rotateY(' + (s.isHorizontal() ? -wrapperRotate : 0) + 'deg)');
                },
                setTransition: function (duration) {
                    s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
                    if (s.params.cube.shadow && !s.isHorizontal()) {
                        s.container.find('.swiper-cube-shadow').transition(duration);
                    }
                }
            },
            coverflow: {
                setTranslate: function () {
                    var transform = s.translate;
                    var center = s.isHorizontal() ? -transform + s.width / 2 : -transform + s.height / 2;
                    var rotate = s.isHorizontal() ? s.params.coverflow.rotate: -s.params.coverflow.rotate;
                    var translate = s.params.coverflow.depth;
                    //Each slide offset from center
                    for (var i = 0, length = s.slides.length; i < length; i++) {
                        var slide = s.slides.eq(i);
                        var slideSize = s.slidesSizesGrid[i];
                        var slideOffset = slide[0].swiperSlideOffset;
                        var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * s.params.coverflow.modifier;
        
                        var rotateY = s.isHorizontal() ? rotate * offsetMultiplier : 0;
                        var rotateX = s.isHorizontal() ? 0 : rotate * offsetMultiplier;
                        // var rotateZ = 0
                        var translateZ = -translate * Math.abs(offsetMultiplier);
        
                        var translateY = s.isHorizontal() ? 0 : s.params.coverflow.stretch * (offsetMultiplier);
                        var translateX = s.isHorizontal() ? s.params.coverflow.stretch * (offsetMultiplier) : 0;
        
                        //Fix for ultra small values
                        if (Math.abs(translateX) < 0.001) translateX = 0;
                        if (Math.abs(translateY) < 0.001) translateY = 0;
                        if (Math.abs(translateZ) < 0.001) translateZ = 0;
                        if (Math.abs(rotateY) < 0.001) rotateY = 0;
                        if (Math.abs(rotateX) < 0.001) rotateX = 0;
        
                        var slideTransform = 'translate3d(' + translateX + 'px,' + translateY + 'px,' + translateZ + 'px)  rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';
        
                        slide.transform(slideTransform);
                        slide[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
                        if (s.params.coverflow.slideShadows) {
                            //Set shadows
                            var shadowBefore = s.isHorizontal() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
                            var shadowAfter = s.isHorizontal() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');
                            if (shadowBefore.length === 0) {
                                shadowBefore = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'left' : 'top') + '"></div>');
                                slide.append(shadowBefore);
                            }
                            if (shadowAfter.length === 0) {
                                shadowAfter = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'right' : 'bottom') + '"></div>');
                                slide.append(shadowAfter);
                            }
                            if (shadowBefore.length) shadowBefore[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                            if (shadowAfter.length) shadowAfter[0].style.opacity = (-offsetMultiplier) > 0 ? -offsetMultiplier : 0;
                        }
                    }
        
                    //Set correct perspective for IE10
                    if (s.browser.ie) {
                        var ws = s.wrapper[0].style;
                        ws.perspectiveOrigin = center + 'px 50%';
                    }
                },
                setTransition: function (duration) {
                    s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
                }
            }
        };

        /*=========================
          Images Lazy Loading
          ===========================*/
        s.lazy = {
            initialImageLoaded: false,
            loadImageInSlide: function (index, loadInDuplicate) {
                if (typeof index === 'undefined') return;
                if (typeof loadInDuplicate === 'undefined') loadInDuplicate = true;
                if (s.slides.length === 0) return;
        
                var slide = s.slides.eq(index);
                var img = slide.find('.' + s.params.lazyLoadingClass + ':not(.' + s.params.lazyStatusLoadedClass + '):not(.' + s.params.lazyStatusLoadingClass + ')');
                if (slide.hasClass(s.params.lazyLoadingClass) && !slide.hasClass(s.params.lazyStatusLoadedClass) && !slide.hasClass(s.params.lazyStatusLoadingClass)) {
                    img = img.add(slide[0]);
                }
                if (img.length === 0) return;
        
                img.each(function () {
                    var _img = $(this);
                    _img.addClass(s.params.lazyStatusLoadingClass);
                    var background = _img.attr('data-background');
                    var src = _img.attr('data-src'),
                        srcset = _img.attr('data-srcset'),
                        sizes = _img.attr('data-sizes');
                    s.loadImage(_img[0], (src || background), srcset, sizes, false, function () {
                        if (background) {
                            _img.css('background-image', 'url("' + background + '")');
                            _img.removeAttr('data-background');
                        }
                        else {
                            if (srcset) {
                                _img.attr('srcset', srcset);
                                _img.removeAttr('data-srcset');
                            }
                            if (sizes) {
                                _img.attr('sizes', sizes);
                                _img.removeAttr('data-sizes');
                            }
                            if (src) {
                                _img.attr('src', src);
                                _img.removeAttr('data-src');
                            }
        
                        }
        
                        _img.addClass(s.params.lazyStatusLoadedClass).removeClass(s.params.lazyStatusLoadingClass);
                        slide.find('.' + s.params.lazyPreloaderClass + ', .' + s.params.preloaderClass).remove();
                        if (s.params.loop && loadInDuplicate) {
                            var slideOriginalIndex = slide.attr('data-swiper-slide-index');
                            if (slide.hasClass(s.params.slideDuplicateClass)) {
                                var originalSlide = s.wrapper.children('[data-swiper-slide-index="' + slideOriginalIndex + '"]:not(.' + s.params.slideDuplicateClass + ')');
                                s.lazy.loadImageInSlide(originalSlide.index(), false);
                            }
                            else {
                                var duplicatedSlide = s.wrapper.children('.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + slideOriginalIndex + '"]');
                                s.lazy.loadImageInSlide(duplicatedSlide.index(), false);
                            }
                        }
                        s.emit('onLazyImageReady', s, slide[0], _img[0]);
                    });
        
                    s.emit('onLazyImageLoad', s, slide[0], _img[0]);
                });
        
            },
            load: function () {
                var i;
                var slidesPerView = s.params.slidesPerView;
                if (slidesPerView === 'auto') {
                    slidesPerView = 0;
                }
                if (!s.lazy.initialImageLoaded) s.lazy.initialImageLoaded = true;
                if (s.params.watchSlidesVisibility) {
                    s.wrapper.children('.' + s.params.slideVisibleClass).each(function () {
                        s.lazy.loadImageInSlide($(this).index());
                    });
                }
                else {
                    if (slidesPerView > 1) {
                        for (i = s.activeIndex; i < s.activeIndex + slidesPerView ; i++) {
                            if (s.slides[i]) s.lazy.loadImageInSlide(i);
                        }
                    }
                    else {
                        s.lazy.loadImageInSlide(s.activeIndex);
                    }
                }
                if (s.params.lazyLoadingInPrevNext) {
                    if (slidesPerView > 1 || (s.params.lazyLoadingInPrevNextAmount && s.params.lazyLoadingInPrevNextAmount > 1)) {
                        var amount = s.params.lazyLoadingInPrevNextAmount;
                        var spv = slidesPerView;
                        var maxIndex = Math.min(s.activeIndex + spv + Math.max(amount, spv), s.slides.length);
                        var minIndex = Math.max(s.activeIndex - Math.max(spv, amount), 0);
                        // Next Slides
                        for (i = s.activeIndex + slidesPerView; i < maxIndex; i++) {
                            if (s.slides[i]) s.lazy.loadImageInSlide(i);
                        }
                        // Prev Slides
                        for (i = minIndex; i < s.activeIndex ; i++) {
                            if (s.slides[i]) s.lazy.loadImageInSlide(i);
                        }
                    }
                    else {
                        var nextSlide = s.wrapper.children('.' + s.params.slideNextClass);
                        if (nextSlide.length > 0) s.lazy.loadImageInSlide(nextSlide.index());
        
                        var prevSlide = s.wrapper.children('.' + s.params.slidePrevClass);
                        if (prevSlide.length > 0) s.lazy.loadImageInSlide(prevSlide.index());
                    }
                }
            },
            onTransitionStart: function () {
                if (s.params.lazyLoading) {
                    if (s.params.lazyLoadingOnTransitionStart || (!s.params.lazyLoadingOnTransitionStart && !s.lazy.initialImageLoaded)) {
                        s.lazy.load();
                    }
                }
            },
            onTransitionEnd: function () {
                if (s.params.lazyLoading && !s.params.lazyLoadingOnTransitionStart) {
                    s.lazy.load();
                }
            }
        };
        

        /*=========================
          Scrollbar
          ===========================*/
        s.scrollbar = {
            isTouched: false,
            setDragPosition: function (e) {
                var sb = s.scrollbar;
                var x = 0, y = 0;
                var translate;
                var pointerPosition = s.isHorizontal() ?
                    ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageX : e.pageX || e.clientX) :
                    ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageY : e.pageY || e.clientY) ;
                var position = (pointerPosition) - sb.track.offset()[s.isHorizontal() ? 'left' : 'top'] - sb.dragSize / 2;
                var positionMin = -s.minTranslate() * sb.moveDivider;
                var positionMax = -s.maxTranslate() * sb.moveDivider;
                if (position < positionMin) {
                    position = positionMin;
                }
                else if (position > positionMax) {
                    position = positionMax;
                }
                position = -position / sb.moveDivider;
                s.updateProgress(position);
                s.setWrapperTranslate(position, true);
            },
            dragStart: function (e) {
                var sb = s.scrollbar;
                sb.isTouched = true;
                e.preventDefault();
                e.stopPropagation();
        
                sb.setDragPosition(e);
                clearTimeout(sb.dragTimeout);
        
                sb.track.transition(0);
                if (s.params.scrollbarHide) {
                    sb.track.css('opacity', 1);
                }
                s.wrapper.transition(100);
                sb.drag.transition(100);
                s.emit('onScrollbarDragStart', s);
            },
            dragMove: function (e) {
                var sb = s.scrollbar;
                if (!sb.isTouched) return;
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
                sb.setDragPosition(e);
                s.wrapper.transition(0);
                sb.track.transition(0);
                sb.drag.transition(0);
                s.emit('onScrollbarDragMove', s);
            },
            dragEnd: function (e) {
                var sb = s.scrollbar;
                if (!sb.isTouched) return;
                sb.isTouched = false;
                if (s.params.scrollbarHide) {
                    clearTimeout(sb.dragTimeout);
                    sb.dragTimeout = setTimeout(function () {
                        sb.track.css('opacity', 0);
                        sb.track.transition(400);
                    }, 1000);
        
                }
                s.emit('onScrollbarDragEnd', s);
                if (s.params.scrollbarSnapOnRelease) {
                    s.slideReset();
                }
            },
            draggableEvents: (function () {
                if ((s.params.simulateTouch === false && !s.support.touch)) return s.touchEventsDesktop;
                else return s.touchEvents;
            })(),
            enableDraggable: function () {
                var sb = s.scrollbar;
                var target = s.support.touch ? sb.track : document;
                $(sb.track).on(sb.draggableEvents.start, sb.dragStart);
                $(target).on(sb.draggableEvents.move, sb.dragMove);
                $(target).on(sb.draggableEvents.end, sb.dragEnd);
            },
            disableDraggable: function () {
                var sb = s.scrollbar;
                var target = s.support.touch ? sb.track : document;
                $(sb.track).off(sb.draggableEvents.start, sb.dragStart);
                $(target).off(sb.draggableEvents.move, sb.dragMove);
                $(target).off(sb.draggableEvents.end, sb.dragEnd);
            },
            set: function () {
                if (!s.params.scrollbar) return;
                var sb = s.scrollbar;
                sb.track = $(s.params.scrollbar);
                if (s.params.uniqueNavElements && typeof s.params.scrollbar === 'string' && sb.track.length > 1 && s.container.find(s.params.scrollbar).length === 1) {
                    sb.track = s.container.find(s.params.scrollbar);
                }
                sb.drag = sb.track.find('.swiper-scrollbar-drag');
                if (sb.drag.length === 0) {
                    sb.drag = $('<div class="swiper-scrollbar-drag"></div>');
                    sb.track.append(sb.drag);
                }
                sb.drag[0].style.width = '';
                sb.drag[0].style.height = '';
                sb.trackSize = s.isHorizontal() ? sb.track[0].offsetWidth : sb.track[0].offsetHeight;
        
                sb.divider = s.size / s.virtualSize;
                sb.moveDivider = sb.divider * (sb.trackSize / s.size);
                sb.dragSize = sb.trackSize * sb.divider;
        
                if (s.isHorizontal()) {
                    sb.drag[0].style.width = sb.dragSize + 'px';
                }
                else {
                    sb.drag[0].style.height = sb.dragSize + 'px';
                }
        
                if (sb.divider >= 1) {
                    sb.track[0].style.display = 'none';
                }
                else {
                    sb.track[0].style.display = '';
                }
                if (s.params.scrollbarHide) {
                    sb.track[0].style.opacity = 0;
                }
            },
            setTranslate: function () {
                if (!s.params.scrollbar) return;
                var diff;
                var sb = s.scrollbar;
                var translate = s.translate || 0;
                var newPos;
        
                var newSize = sb.dragSize;
                newPos = (sb.trackSize - sb.dragSize) * s.progress;
                if (s.rtl && s.isHorizontal()) {
                    newPos = -newPos;
                    if (newPos > 0) {
                        newSize = sb.dragSize - newPos;
                        newPos = 0;
                    }
                    else if (-newPos + sb.dragSize > sb.trackSize) {
                        newSize = sb.trackSize + newPos;
                    }
                }
                else {
                    if (newPos < 0) {
                        newSize = sb.dragSize + newPos;
                        newPos = 0;
                    }
                    else if (newPos + sb.dragSize > sb.trackSize) {
                        newSize = sb.trackSize - newPos;
                    }
                }
                if (s.isHorizontal()) {
                    if (s.support.transforms3d) {
                        sb.drag.transform('translate3d(' + (newPos) + 'px, 0, 0)');
                    }
                    else {
                        sb.drag.transform('translateX(' + (newPos) + 'px)');
                    }
                    sb.drag[0].style.width = newSize + 'px';
                }
                else {
                    if (s.support.transforms3d) {
                        sb.drag.transform('translate3d(0px, ' + (newPos) + 'px, 0)');
                    }
                    else {
                        sb.drag.transform('translateY(' + (newPos) + 'px)');
                    }
                    sb.drag[0].style.height = newSize + 'px';
                }
                if (s.params.scrollbarHide) {
                    clearTimeout(sb.timeout);
                    sb.track[0].style.opacity = 1;
                    sb.timeout = setTimeout(function () {
                        sb.track[0].style.opacity = 0;
                        sb.track.transition(400);
                    }, 1000);
                }
            },
            setTransition: function (duration) {
                if (!s.params.scrollbar) return;
                s.scrollbar.drag.transition(duration);
            }
        };

        /*=========================
          Controller
          ===========================*/
        s.controller = {
            LinearSpline: function (x, y) {
                this.x = x;
                this.y = y;
                this.lastIndex = x.length - 1;
                // Given an x value (x2), return the expected y2 value:
                // (x1,y1) is the known point before given value,
                // (x3,y3) is the known point after given value.
                var i1, i3;
                var l = this.x.length;
        
                this.interpolate = function (x2) {
                    if (!x2) return 0;
        
                    // Get the indexes of x1 and x3 (the array indexes before and after given x2):
                    i3 = binarySearch(this.x, x2);
                    i1 = i3 - 1;
        
                    // We have our indexes i1 & i3, so we can calculate already:
                    // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
                    return ((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1]) + this.y[i1];
                };
        
                var binarySearch = (function() {
                    var maxIndex, minIndex, guess;
                    return function(array, val) {
                        minIndex = -1;
                        maxIndex = array.length;
                        while (maxIndex - minIndex > 1)
                            if (array[guess = maxIndex + minIndex >> 1] <= val) {
                                minIndex = guess;
                            } else {
                                maxIndex = guess;
                            }
                        return maxIndex;
                    };
                })();
            },
            //xxx: for now i will just save one spline function to to
            getInterpolateFunction: function(c){
                if(!s.controller.spline) s.controller.spline = s.params.loop ?
                    new s.controller.LinearSpline(s.slidesGrid, c.slidesGrid) :
                    new s.controller.LinearSpline(s.snapGrid, c.snapGrid);
            },
            setTranslate: function (translate, byController) {
               var controlled = s.params.control;
               var multiplier, controlledTranslate;
               function setControlledTranslate(c) {
                    // this will create an Interpolate function based on the snapGrids
                    // x is the Grid of the scrolled scroller and y will be the controlled scroller
                    // it makes sense to create this only once and recall it for the interpolation
                    // the function does a lot of value caching for performance
                    translate = c.rtl && c.params.direction === 'horizontal' ? -s.translate : s.translate;
                    if (s.params.controlBy === 'slide') {
                        s.controller.getInterpolateFunction(c);
                        // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                        // but it did not work out
                        controlledTranslate = -s.controller.spline.interpolate(-translate);
                    }
        
                    if(!controlledTranslate || s.params.controlBy === 'container'){
                        multiplier = (c.maxTranslate() - c.minTranslate()) / (s.maxTranslate() - s.minTranslate());
                        controlledTranslate = (translate - s.minTranslate()) * multiplier + c.minTranslate();
                    }
        
                    if (s.params.controlInverse) {
                        controlledTranslate = c.maxTranslate() - controlledTranslate;
                    }
                    c.updateProgress(controlledTranslate);
                    c.setWrapperTranslate(controlledTranslate, false, s);
                    c.updateActiveIndex();
               }
               if (s.isArray(controlled)) {
                   for (var i = 0; i < controlled.length; i++) {
                       if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
                           setControlledTranslate(controlled[i]);
                       }
                   }
               }
               else if (controlled instanceof Swiper && byController !== controlled) {
        
                   setControlledTranslate(controlled);
               }
            },
            setTransition: function (duration, byController) {
                var controlled = s.params.control;
                var i;
                function setControlledTransition(c) {
                    c.setWrapperTransition(duration, s);
                    if (duration !== 0) {
                        c.onTransitionStart();
                        c.wrapper.transitionEnd(function(){
                            if (!controlled) return;
                            if (c.params.loop && s.params.controlBy === 'slide') {
                                c.fixLoop();
                            }
                            c.onTransitionEnd();
        
                        });
                    }
                }
                if (s.isArray(controlled)) {
                    for (i = 0; i < controlled.length; i++) {
                        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
                            setControlledTransition(controlled[i]);
                        }
                    }
                }
                else if (controlled instanceof Swiper && byController !== controlled) {
                    setControlledTransition(controlled);
                }
            }
        };

        /*=========================
          Hash Navigation
          ===========================*/
        s.hashnav = {
            onHashCange: function (e, a) {
                var newHash = document.location.hash.replace('#', '');
                var activeSlideHash = s.slides.eq(s.activeIndex).attr('data-hash');
                if (newHash !== activeSlideHash) {
                    s.slideTo(s.wrapper.children('.' + s.params.slideClass + '[data-hash="' + (newHash) + '"]').index());
                }
            },
            attachEvents: function (detach) {
                var action = detach ? 'off' : 'on';
                $(window)[action]('hashchange', s.hashnav.onHashCange);
            },
            setHash: function () {
                if (!s.hashnav.initialized || !s.params.hashnav) return;
                if (s.params.replaceState && window.history && window.history.replaceState) {
                    window.history.replaceState(null, null, ('#' + s.slides.eq(s.activeIndex).attr('data-hash') || ''));
                } else {
                    var slide = s.slides.eq(s.activeIndex);
                    var hash = slide.attr('data-hash') || slide.attr('data-history');
                    document.location.hash = hash || '';
                }
            },
            init: function () {
                if (!s.params.hashnav || s.params.history) return;
                s.hashnav.initialized = true;
                var hash = document.location.hash.replace('#', '');
                if (hash) {
                    var speed = 0;
                    for (var i = 0, length = s.slides.length; i < length; i++) {
                        var slide = s.slides.eq(i);
                        var slideHash = slide.attr('data-hash') || slide.attr('data-history');
                        if (slideHash === hash && !slide.hasClass(s.params.slideDuplicateClass)) {
                            var index = slide.index();
                            s.slideTo(index, speed, s.params.runCallbacksOnInit, true);
                        }
                    }
                }
                if (s.params.hashnavWatchState) s.hashnav.attachEvents();
            },
            destroy: function () {
                if (s.params.hashnavWatchState) s.hashnav.attachEvents(true);
            }
        };

        /*=========================
          History Api with fallback to Hashnav
          ===========================*/
        s.history = {
            init: function () {
                if (!s.params.history) return;
                if (!window.history || !window.history.pushState) {
                    s.params.history = false;
                    s.params.hashnav = true;
                    return;
                }
                s.history.initialized = true;
                this.paths = this.getPathValues();
                if (!this.paths.key && !this.paths.value) return;
                this.scrollToSlide(0, this.paths.value, s.params.runCallbacksOnInit);
                if (!s.params.replaceState) {
                    window.addEventListener('popstate', this.setHistoryPopState);
                }
            },
            setHistoryPopState: function() {
                s.history.paths = s.history.getPathValues();
                s.history.scrollToSlide(s.params.speed, s.history.paths.value, false);
            },
            getPathValues: function() {
                var pathArray = window.location.pathname.slice(1).split('/');
                var total = pathArray.length;
                var key = pathArray[total - 2];
                var value = pathArray[total - 1];
                return { key: key, value: value };
            },
            setHistory: function (key, index) {
                if (!s.history.initialized || !s.params.history) return;
                var slide = s.slides.eq(index);
                var value = this.slugify(slide.attr('data-history'));
                if (!window.location.pathname.includes(key)) {
                    value = key + '/' + value;
                }
                if (s.params.replaceState) {
                    window.history.replaceState(null, null, value);
                } else {
                    window.history.pushState(null, null, value);
                }
            },
            slugify: function(text) {
                return text.toString().toLowerCase()
                    .replace(/\s+/g, '-')
                    .replace(/[^\w\-]+/g, '')
                    .replace(/\-\-+/g, '-')
                    .replace(/^-+/, '')
                    .replace(/-+$/, '');
            },
            scrollToSlide: function(speed, value, runCallbacks) {
                if (value) {
                    for (var i = 0, length = s.slides.length; i < length; i++) {
                        var slide = s.slides.eq(i);
                        var slideHistory = this.slugify(slide.attr('data-history'));
                        if (slideHistory === value && !slide.hasClass(s.params.slideDuplicateClass)) {
                            var index = slide.index();
                            s.slideTo(index, speed, runCallbacks);
                        }
                    }
                } else {
                    s.slideTo(0, speed, runCallbacks);
                }
            }
        };

        /*=========================
          Keyboard Control
          ===========================*/
        function handleKeyboard(e) {
            if (e.originalEvent) e = e.originalEvent; //jquery fix
            var kc = e.keyCode || e.charCode;
            // Directions locks
            if (!s.params.allowSwipeToNext && (s.isHorizontal() && kc === 39 || !s.isHorizontal() && kc === 40)) {
                return false;
            }
            if (!s.params.allowSwipeToPrev && (s.isHorizontal() && kc === 37 || !s.isHorizontal() && kc === 38)) {
                return false;
            }
            if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
                return;
            }
            if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) {
                return;
            }
            if (kc === 37 || kc === 39 || kc === 38 || kc === 40) {
                var inView = false;
                //Check that swiper should be inside of visible area of window
                if (s.container.parents('.' + s.params.slideClass).length > 0 && s.container.parents('.' + s.params.slideActiveClass).length === 0) {
                    return;
                }
                var windowScroll = {
                    left: window.pageXOffset,
                    top: window.pageYOffset
                };
                var windowWidth = window.innerWidth;
                var windowHeight = window.innerHeight;
                var swiperOffset = s.container.offset();
                if (s.rtl) swiperOffset.left = swiperOffset.left - s.container[0].scrollLeft;
                var swiperCoord = [
                    [swiperOffset.left, swiperOffset.top],
                    [swiperOffset.left + s.width, swiperOffset.top],
                    [swiperOffset.left, swiperOffset.top + s.height],
                    [swiperOffset.left + s.width, swiperOffset.top + s.height]
                ];
                for (var i = 0; i < swiperCoord.length; i++) {
                    var point = swiperCoord[i];
                    if (
                        point[0] >= windowScroll.left && point[0] <= windowScroll.left + windowWidth &&
                        point[1] >= windowScroll.top && point[1] <= windowScroll.top + windowHeight
                    ) {
                        inView = true;
                    }
        
                }
                if (!inView) return;
            }
            if (s.isHorizontal()) {
                if (kc === 37 || kc === 39) {
                    if (e.preventDefault) e.preventDefault();
                    else e.returnValue = false;
                }
                if ((kc === 39 && !s.rtl) || (kc === 37 && s.rtl)) s.slideNext();
                if ((kc === 37 && !s.rtl) || (kc === 39 && s.rtl)) s.slidePrev();
            }
            else {
                if (kc === 38 || kc === 40) {
                    if (e.preventDefault) e.preventDefault();
                    else e.returnValue = false;
                }
                if (kc === 40) s.slideNext();
                if (kc === 38) s.slidePrev();
            }
        }
        s.disableKeyboardControl = function () {
            s.params.keyboardControl = false;
            $(document).off('keydown', handleKeyboard);
        };
        s.enableKeyboardControl = function () {
            s.params.keyboardControl = true;
            $(document).on('keydown', handleKeyboard);
        };
        

        /*=========================
          Mousewheel Control
          ===========================*/
        s.mousewheel = {
            event: false,
            lastScrollTime: (new window.Date()).getTime()
        };
        if (s.params.mousewheelControl) {
            /**
             * The best combination if you prefer spinX + spinY normalization.  It favors
             * the older DOMMouseScroll for Firefox, as FF does not include wheelDelta with
             * 'wheel' event, making spin speed determination impossible.
             */
            s.mousewheel.event = (navigator.userAgent.indexOf('firefox') > -1) ?
                'DOMMouseScroll' :
                isEventSupported() ?
                    'wheel' : 'mousewheel';
        }
        
        function isEventSupported() {
            var eventName = 'onwheel';
            var isSupported = eventName in document;
        
            if (!isSupported) {
                var element = document.createElement('div');
                element.setAttribute(eventName, 'return;');
                isSupported = typeof element[eventName] === 'function';
            }
        
            if (!isSupported &&
                document.implementation &&
                document.implementation.hasFeature &&
                    // always returns true in newer browsers as per the standard.
                    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
                document.implementation.hasFeature('', '') !== true ) {
                // This is the only way to test support for the `wheel` event in IE9+.
                isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
            }
        
            return isSupported;
        }
        
        function handleMousewheel(e) {
            if (e.originalEvent) e = e.originalEvent; //jquery fix
            var delta = 0;
            var rtlFactor = s.rtl ? -1 : 1;
        
            var data = normalizeWheel( e );
        
            if (s.params.mousewheelForceToAxis) {
                if (s.isHorizontal()) {
                    if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = data.pixelX * rtlFactor;
                    else return;
                }
                else {
                    if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = data.pixelY;
                    else return;
                }
            }
            else {
                delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? - data.pixelX * rtlFactor : - data.pixelY;
            }
        
            if (delta === 0) return;
        
            if (s.params.mousewheelInvert) delta = -delta;
        
            if (!s.params.freeMode) {
                if ((new window.Date()).getTime() - s.mousewheel.lastScrollTime > 60) {
                    if (delta < 0) {
                        if ((!s.isEnd || s.params.loop) && !s.animating) {
                            s.slideNext();
                            s.emit('onScroll', s, e);
                        }
                        else if (s.params.mousewheelReleaseOnEdges) return true;
                    }
                    else {
                        if ((!s.isBeginning || s.params.loop) && !s.animating) {
                            s.slidePrev();
                            s.emit('onScroll', s, e);
                        }
                        else if (s.params.mousewheelReleaseOnEdges) return true;
                    }
                }
                s.mousewheel.lastScrollTime = (new window.Date()).getTime();
        
            }
            else {
                //Freemode or scrollContainer:
                var position = s.getWrapperTranslate() + delta * s.params.mousewheelSensitivity;
                var wasBeginning = s.isBeginning,
                    wasEnd = s.isEnd;
        
                if (position >= s.minTranslate()) position = s.minTranslate();
                if (position <= s.maxTranslate()) position = s.maxTranslate();
        
                s.setWrapperTransition(0);
                s.setWrapperTranslate(position);
                s.updateProgress();
                s.updateActiveIndex();
        
                if (!wasBeginning && s.isBeginning || !wasEnd && s.isEnd) {
                    s.updateClasses();
                }
        
                if (s.params.freeModeSticky) {
                    clearTimeout(s.mousewheel.timeout);
                    s.mousewheel.timeout = setTimeout(function () {
                        s.slideReset();
                    }, 300);
                }
                else {
                    if (s.params.lazyLoading && s.lazy) {
                        s.lazy.load();
                    }
                }
                // Emit event
                s.emit('onScroll', s, e);
        
                // Stop autoplay
                if (s.params.autoplay && s.params.autoplayDisableOnInteraction) s.stopAutoplay();
        
                // Return page scroll on edge positions
                if (position === 0 || position === s.maxTranslate()) return;
            }
        
            if (e.preventDefault) e.preventDefault();
            else e.returnValue = false;
            return false;
        }
        s.disableMousewheelControl = function () {
            if (!s.mousewheel.event) return false;
            var target = s.container;
            if (s.params.mousewheelEventsTarged !== 'container') {
                target = $(s.params.mousewheelEventsTarged);
            }
            target.off(s.mousewheel.event, handleMousewheel);
            return true;
        };
        
        s.enableMousewheelControl = function () {
            if (!s.mousewheel.event) return false;
            var target = s.container;
            if (s.params.mousewheelEventsTarged !== 'container') {
                target = $(s.params.mousewheelEventsTarged);
            }
            target.on(s.mousewheel.event, handleMousewheel);
            return true;
        };
        
        /**
         * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
         * complicated, thus this doc is long and (hopefully) detailed enough to answer
         * your questions.
         *
         * If you need to react to the mouse wheel in a predictable way, this code is
         * like your bestest friend. * hugs *
         *
         * As of today, there are 4 DOM event types you can listen to:
         *
         *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
         *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
         *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
         *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
         *
         * So what to do?  The is the best:
         *
         *   normalizeWheel.getEventType();
         *
         * In your event callback, use this code to get sane interpretation of the
         * deltas.  This code will return an object with properties:
         *
         *   spinX   -- normalized spin speed (use for zoom) - x plane
         *   spinY   -- " - y plane
         *   pixelX  -- normalized distance (to pixels) - x plane
         *   pixelY  -- " - y plane
         *
         * Wheel values are provided by the browser assuming you are using the wheel to
         * scroll a web page by a number of lines or pixels (or pages).  Values can vary
         * significantly on different platforms and browsers, forgetting that you can
         * scroll at different speeds.  Some devices (like trackpads) emit more events
         * at smaller increments with fine granularity, and some emit massive jumps with
         * linear speed or acceleration.
         *
         * This code does its best to normalize the deltas for you:
         *
         *   - spin is trying to normalize how far the wheel was spun (or trackpad
         *     dragged).  This is super useful for zoom support where you want to
         *     throw away the chunky scroll steps on the PC and make those equal to
         *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
         *     resolve a single slow step on a wheel to 1.
         *
         *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
         *     get the crazy differences between browsers, but at least it'll be in
         *     pixels!
         *
         *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
         *     should translate to positive value zooming IN, negative zooming OUT.
         *     This matches the newer 'wheel' event.
         *
         * Why are there spinX, spinY (or pixels)?
         *
         *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
         *     with a mouse.  It results in side-scrolling in the browser by default.
         *
         *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
         *
         *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
         *     probably is by browsers in conjunction with fancy 3D controllers .. but
         *     you know.
         *
         * Implementation info:
         *
         * Examples of 'wheel' event if you scroll slowly (down) by one step with an
         * average mouse:
         *
         *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
         *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
         *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
         *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
         *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
         *
         * On the trackpad:
         *
         *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
         *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
         *
         * On other/older browsers.. it's more complicated as there can be multiple and
         * also missing delta values.
         *
         * The 'wheel' event is more standard:
         *
         * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
         *
         * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
         * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
         * backward compatibility with older events.  Those other values help us
         * better normalize spin speed.  Example of what the browsers provide:
         *
         *                          | event.wheelDelta | event.detail
         *        ------------------+------------------+--------------
         *          Safari v5/OS X  |       -120       |       0
         *          Safari v5/Win7  |       -120       |       0
         *         Chrome v17/OS X  |       -120       |       0
         *         Chrome v17/Win7  |       -120       |       0
         *                IE9/Win7  |       -120       |   undefined
         *         Firefox v4/OS X  |     undefined    |       1
         *         Firefox v4/Win7  |     undefined    |       3
         *
         */
        function normalizeWheel( /*object*/ event ) /*object*/ {
            // Reasonable defaults
            var PIXEL_STEP = 10;
            var LINE_HEIGHT = 40;
            var PAGE_HEIGHT = 800;
        
            var sX = 0, sY = 0,       // spinX, spinY
                pX = 0, pY = 0;       // pixelX, pixelY
        
            // Legacy
            if( 'detail' in event ) {
                sY = event.detail;
            }
            if( 'wheelDelta' in event ) {
                sY = -event.wheelDelta / 120;
            }
            if( 'wheelDeltaY' in event ) {
                sY = -event.wheelDeltaY / 120;
            }
            if( 'wheelDeltaX' in event ) {
                sX = -event.wheelDeltaX / 120;
            }
        
            // side scrolling on FF with DOMMouseScroll
            if( 'axis' in event && event.axis === event.HORIZONTAL_AXIS ) {
                sX = sY;
                sY = 0;
            }
        
            pX = sX * PIXEL_STEP;
            pY = sY * PIXEL_STEP;
        
            if( 'deltaY' in event ) {
                pY = event.deltaY;
            }
            if( 'deltaX' in event ) {
                pX = event.deltaX;
            }
        
            if( (pX || pY) && event.deltaMode ) {
                if( event.deltaMode === 1 ) {          // delta in LINE units
                    pX *= LINE_HEIGHT;
                    pY *= LINE_HEIGHT;
                } else {                             // delta in PAGE units
                    pX *= PAGE_HEIGHT;
                    pY *= PAGE_HEIGHT;
                }
            }
        
            // Fall-back if spin cannot be determined
            if( pX && !sX ) {
                sX = (pX < 1) ? -1 : 1;
            }
            if( pY && !sY ) {
                sY = (pY < 1) ? -1 : 1;
            }
        
            return {
                spinX: sX,
                spinY: sY,
                pixelX: pX,
                pixelY: pY
            };
        }

        /*=========================
          Parallax
          ===========================*/
        function setParallaxTransform(el, progress) {
            el = $(el);
            var p, pX, pY;
            var rtlFactor = s.rtl ? -1 : 1;
        
            p = el.attr('data-swiper-parallax') || '0';
            pX = el.attr('data-swiper-parallax-x');
            pY = el.attr('data-swiper-parallax-y');
            if (pX || pY) {
                pX = pX || '0';
                pY = pY || '0';
            }
            else {
                if (s.isHorizontal()) {
                    pX = p;
                    pY = '0';
                }
                else {
                    pY = p;
                    pX = '0';
                }
            }
        
            if ((pX).indexOf('%') >= 0) {
                pX = parseInt(pX, 10) * progress * rtlFactor + '%';
            }
            else {
                pX = pX * progress * rtlFactor + 'px' ;
            }
            if ((pY).indexOf('%') >= 0) {
                pY = parseInt(pY, 10) * progress + '%';
            }
            else {
                pY = pY * progress + 'px' ;
            }
        
            el.transform('translate3d(' + pX + ', ' + pY + ',0px)');
        }
        s.parallax = {
            setTranslate: function () {
                s.container.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function(){
                    setParallaxTransform(this, s.progress);
        
                });
                s.slides.each(function () {
                    var slide = $(this);
                    slide.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function () {
                        var progress = Math.min(Math.max(slide[0].progress, -1), 1);
                        setParallaxTransform(this, progress);
                    });
                });
            },
            setTransition: function (duration) {
                if (typeof duration === 'undefined') duration = s.params.speed;
                s.container.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function(){
                    var el = $(this);
                    var parallaxDuration = parseInt(el.attr('data-swiper-parallax-duration'), 10) || duration;
                    if (duration === 0) parallaxDuration = 0;
                    el.transition(parallaxDuration);
                });
            }
        };
        

        /*=========================
          Zoom
          ===========================*/
        s.zoom = {
            // "Global" Props
            scale: 1,
            currentScale: 1,
            isScaling: false,
            gesture: {
                slide: undefined,
                slideWidth: undefined,
                slideHeight: undefined,
                image: undefined,
                imageWrap: undefined,
                zoomMax: s.params.zoomMax
            },
            image: {
                isTouched: undefined,
                isMoved: undefined,
                currentX: undefined,
                currentY: undefined,
                minX: undefined,
                minY: undefined,
                maxX: undefined,
                maxY: undefined,
                width: undefined,
                height: undefined,
                startX: undefined,
                startY: undefined,
                touchesStart: {},
                touchesCurrent: {}
            },
            velocity: {
                x: undefined,
                y: undefined,
                prevPositionX: undefined,
                prevPositionY: undefined,
                prevTime: undefined
            },
            // Calc Scale From Multi-touches
            getDistanceBetweenTouches: function (e) {
                if (e.targetTouches.length < 2) return 1;
                var x1 = e.targetTouches[0].pageX,
                    y1 = e.targetTouches[0].pageY,
                    x2 = e.targetTouches[1].pageX,
                    y2 = e.targetTouches[1].pageY;
                var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
                return distance;
            },
            // Events
            onGestureStart: function (e) {
                var z = s.zoom;
                if (!s.support.gestures) {
                    if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
                        return;
                    }
                    z.gesture.scaleStart = z.getDistanceBetweenTouches(e);
                }
                if (!z.gesture.slide || !z.gesture.slide.length) {
                    z.gesture.slide = $(this);
                    if (z.gesture.slide.length === 0) z.gesture.slide = s.slides.eq(s.activeIndex);
                    z.gesture.image = z.gesture.slide.find('img, svg, canvas');
                    z.gesture.imageWrap = z.gesture.image.parent('.' + s.params.zoomContainerClass);
                    z.gesture.zoomMax = z.gesture.imageWrap.attr('data-swiper-zoom') || s.params.zoomMax ;
                    if (z.gesture.imageWrap.length === 0) {
                        z.gesture.image = undefined;
                        return;
                    }
                }
                z.gesture.image.transition(0);
                z.isScaling = true;
            },
            onGestureChange: function (e) {
                var z = s.zoom;
                if (!s.support.gestures) {
                    if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
                        return;
                    }
                    z.gesture.scaleMove = z.getDistanceBetweenTouches(e);
                }
                if (!z.gesture.image || z.gesture.image.length === 0) return;
                if (s.support.gestures) {
                    z.scale = e.scale * z.currentScale;
                }
                else {
                    z.scale = (z.gesture.scaleMove / z.gesture.scaleStart) * z.currentScale;
                }
                if (z.scale > z.gesture.zoomMax) {
                    z.scale = z.gesture.zoomMax - 1 + Math.pow((z.scale - z.gesture.zoomMax + 1), 0.5);
                }
                if (z.scale < s.params.zoomMin) {
                    z.scale =  s.params.zoomMin + 1 - Math.pow((s.params.zoomMin - z.scale + 1), 0.5);
                }
                z.gesture.image.transform('translate3d(0,0,0) scale(' + z.scale + ')');
            },
            onGestureEnd: function (e) {
                var z = s.zoom;
                if (!s.support.gestures) {
                    if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2) {
                        return;
                    }
                }
                if (!z.gesture.image || z.gesture.image.length === 0) return;
                z.scale = Math.max(Math.min(z.scale, z.gesture.zoomMax), s.params.zoomMin);
                z.gesture.image.transition(s.params.speed).transform('translate3d(0,0,0) scale(' + z.scale + ')');
                z.currentScale = z.scale;
                z.isScaling = false;
                if (z.scale === 1) z.gesture.slide = undefined;
            },
            onTouchStart: function (s, e) {
                var z = s.zoom;
                if (!z.gesture.image || z.gesture.image.length === 0) return;
                if (z.image.isTouched) return;
                if (s.device.os === 'android') e.preventDefault();
                z.image.isTouched = true;
                z.image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
                z.image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
            },
            onTouchMove: function (e) {
                var z = s.zoom;
                if (!z.gesture.image || z.gesture.image.length === 0) return;
                s.allowClick = false;
                if (!z.image.isTouched || !z.gesture.slide) return;
        
                if (!z.image.isMoved) {
                    z.image.width = z.gesture.image[0].offsetWidth;
                    z.image.height = z.gesture.image[0].offsetHeight;
                    z.image.startX = s.getTranslate(z.gesture.imageWrap[0], 'x') || 0;
                    z.image.startY = s.getTranslate(z.gesture.imageWrap[0], 'y') || 0;
                    z.gesture.slideWidth = z.gesture.slide[0].offsetWidth;
                    z.gesture.slideHeight = z.gesture.slide[0].offsetHeight;
                    z.gesture.imageWrap.transition(0);
                    if (s.rtl) z.image.startX = -z.image.startX;
                    if (s.rtl) z.image.startY = -z.image.startY;
                }
                // Define if we need image drag
                var scaledWidth = z.image.width * z.scale;
                var scaledHeight = z.image.height * z.scale;
        
                if (scaledWidth < z.gesture.slideWidth && scaledHeight < z.gesture.slideHeight) return;
        
                z.image.minX = Math.min((z.gesture.slideWidth / 2 - scaledWidth / 2), 0);
                z.image.maxX = -z.image.minX;
                z.image.minY = Math.min((z.gesture.slideHeight / 2 - scaledHeight / 2), 0);
                z.image.maxY = -z.image.minY;
        
                z.image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
                z.image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
        
                if (!z.image.isMoved && !z.isScaling) {
                    if (s.isHorizontal() &&
                        (Math.floor(z.image.minX) === Math.floor(z.image.startX) && z.image.touchesCurrent.x < z.image.touchesStart.x) ||
                        (Math.floor(z.image.maxX) === Math.floor(z.image.startX) && z.image.touchesCurrent.x > z.image.touchesStart.x)
                        ) {
                        z.image.isTouched = false;
                        return;
                    }
                    else if (!s.isHorizontal() &&
                        (Math.floor(z.image.minY) === Math.floor(z.image.startY) && z.image.touchesCurrent.y < z.image.touchesStart.y) ||
                        (Math.floor(z.image.maxY) === Math.floor(z.image.startY) && z.image.touchesCurrent.y > z.image.touchesStart.y)
                        ) {
                        z.image.isTouched = false;
                        return;
                    }
                }
                e.preventDefault();
                e.stopPropagation();
        
                z.image.isMoved = true;
                z.image.currentX = z.image.touchesCurrent.x - z.image.touchesStart.x + z.image.startX;
                z.image.currentY = z.image.touchesCurrent.y - z.image.touchesStart.y + z.image.startY;
        
                if (z.image.currentX < z.image.minX) {
                    z.image.currentX =  z.image.minX + 1 - Math.pow((z.image.minX - z.image.currentX + 1), 0.8);
                }
                if (z.image.currentX > z.image.maxX) {
                    z.image.currentX = z.image.maxX - 1 + Math.pow((z.image.currentX - z.image.maxX + 1), 0.8);
                }
        
                if (z.image.currentY < z.image.minY) {
                    z.image.currentY =  z.image.minY + 1 - Math.pow((z.image.minY - z.image.currentY + 1), 0.8);
                }
                if (z.image.currentY > z.image.maxY) {
                    z.image.currentY = z.image.maxY - 1 + Math.pow((z.image.currentY - z.image.maxY + 1), 0.8);
                }
        
                //Velocity
                if (!z.velocity.prevPositionX) z.velocity.prevPositionX = z.image.touchesCurrent.x;
                if (!z.velocity.prevPositionY) z.velocity.prevPositionY = z.image.touchesCurrent.y;
                if (!z.velocity.prevTime) z.velocity.prevTime = Date.now();
                z.velocity.x = (z.image.touchesCurrent.x - z.velocity.prevPositionX) / (Date.now() - z.velocity.prevTime) / 2;
                z.velocity.y = (z.image.touchesCurrent.y - z.velocity.prevPositionY) / (Date.now() - z.velocity.prevTime) / 2;
                if (Math.abs(z.image.touchesCurrent.x - z.velocity.prevPositionX) < 2) z.velocity.x = 0;
                if (Math.abs(z.image.touchesCurrent.y - z.velocity.prevPositionY) < 2) z.velocity.y = 0;
                z.velocity.prevPositionX = z.image.touchesCurrent.x;
                z.velocity.prevPositionY = z.image.touchesCurrent.y;
                z.velocity.prevTime = Date.now();
        
                z.gesture.imageWrap.transform('translate3d(' + z.image.currentX + 'px, ' + z.image.currentY + 'px,0)');
            },
            onTouchEnd: function (s, e) {
                var z = s.zoom;
                if (!z.gesture.image || z.gesture.image.length === 0) return;
                if (!z.image.isTouched || !z.image.isMoved) {
                    z.image.isTouched = false;
                    z.image.isMoved = false;
                    return;
                }
                z.image.isTouched = false;
                z.image.isMoved = false;
                var momentumDurationX = 300;
                var momentumDurationY = 300;
                var momentumDistanceX = z.velocity.x * momentumDurationX;
                var newPositionX = z.image.currentX + momentumDistanceX;
                var momentumDistanceY = z.velocity.y * momentumDurationY;
                var newPositionY = z.image.currentY + momentumDistanceY;
        
                //Fix duration
                if (z.velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - z.image.currentX) / z.velocity.x);
                if (z.velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - z.image.currentY) / z.velocity.y);
                var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        
                z.image.currentX = newPositionX;
                z.image.currentY = newPositionY;
        
                // Define if we need image drag
                var scaledWidth = z.image.width * z.scale;
                var scaledHeight = z.image.height * z.scale;
                z.image.minX = Math.min((z.gesture.slideWidth / 2 - scaledWidth / 2), 0);
                z.image.maxX = -z.image.minX;
                z.image.minY = Math.min((z.gesture.slideHeight / 2 - scaledHeight / 2), 0);
                z.image.maxY = -z.image.minY;
                z.image.currentX = Math.max(Math.min(z.image.currentX, z.image.maxX), z.image.minX);
                z.image.currentY = Math.max(Math.min(z.image.currentY, z.image.maxY), z.image.minY);
        
                z.gesture.imageWrap.transition(momentumDuration).transform('translate3d(' + z.image.currentX + 'px, ' + z.image.currentY + 'px,0)');
            },
            onTransitionEnd: function (s) {
                var z = s.zoom;
                if (z.gesture.slide && s.previousIndex !== s.activeIndex) {
                    z.gesture.image.transform('translate3d(0,0,0) scale(1)');
                    z.gesture.imageWrap.transform('translate3d(0,0,0)');
                    z.gesture.slide = z.gesture.image = z.gesture.imageWrap = undefined;
                    z.scale = z.currentScale = 1;
                }
            },
            // Toggle Zoom
            toggleZoom: function (s, e) {
                var z = s.zoom;
                if (!z.gesture.slide) {
                    z.gesture.slide = s.clickedSlide ? $(s.clickedSlide) : s.slides.eq(s.activeIndex);
                    z.gesture.image = z.gesture.slide.find('img, svg, canvas');
                    z.gesture.imageWrap = z.gesture.image.parent('.' + s.params.zoomContainerClass);
                }
                if (!z.gesture.image || z.gesture.image.length === 0) return;
        
                var touchX, touchY, offsetX, offsetY, diffX, diffY, translateX, translateY, imageWidth, imageHeight, scaledWidth, scaledHeight, translateMinX, translateMinY, translateMaxX, translateMaxY, slideWidth, slideHeight;
        
                if (typeof z.image.touchesStart.x === 'undefined' && e) {
                    touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
                    touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
                }
                else {
                    touchX = z.image.touchesStart.x;
                    touchY = z.image.touchesStart.y;
                }
        
                if (z.scale && z.scale !== 1) {
                    // Zoom Out
                    z.scale = z.currentScale = 1;
                    z.gesture.imageWrap.transition(300).transform('translate3d(0,0,0)');
                    z.gesture.image.transition(300).transform('translate3d(0,0,0) scale(1)');
                    z.gesture.slide = undefined;
                }
                else {
                    // Zoom In
                    z.scale = z.currentScale = z.gesture.imageWrap.attr('data-swiper-zoom') || s.params.zoomMax;
                    if (e) {
                        slideWidth = z.gesture.slide[0].offsetWidth;
                        slideHeight = z.gesture.slide[0].offsetHeight;
                        offsetX = z.gesture.slide.offset().left;
                        offsetY = z.gesture.slide.offset().top;
                        diffX = offsetX + slideWidth/2 - touchX;
                        diffY = offsetY + slideHeight/2 - touchY;
        
                        imageWidth = z.gesture.image[0].offsetWidth;
                        imageHeight = z.gesture.image[0].offsetHeight;
                        scaledWidth = imageWidth * z.scale;
                        scaledHeight = imageHeight * z.scale;
        
                        translateMinX = Math.min((slideWidth / 2 - scaledWidth / 2), 0);
                        translateMinY = Math.min((slideHeight / 2 - scaledHeight / 2), 0);
                        translateMaxX = -translateMinX;
                        translateMaxY = -translateMinY;
        
                        translateX = diffX * z.scale;
                        translateY = diffY * z.scale;
        
                        if (translateX < translateMinX) {
                            translateX =  translateMinX;
                        }
                        if (translateX > translateMaxX) {
                            translateX = translateMaxX;
                        }
        
                        if (translateY < translateMinY) {
                            translateY =  translateMinY;
                        }
                        if (translateY > translateMaxY) {
                            translateY = translateMaxY;
                        }
                    }
                    else {
                        translateX = 0;
                        translateY = 0;
                    }
                    z.gesture.imageWrap.transition(300).transform('translate3d(' + translateX + 'px, ' + translateY + 'px,0)');
                    z.gesture.image.transition(300).transform('translate3d(0,0,0) scale(' + z.scale + ')');
                }
            },
            // Attach/Detach Events
            attachEvents: function (detach) {
                var action = detach ? 'off' : 'on';
        
                if (s.params.zoom) {
                    var target = s.slides;
                    var passiveListener = s.touchEvents.start === 'touchstart' && s.support.passiveListener && s.params.passiveListeners ? {passive: true, capture: false} : false;
                    // Scale image
                    if (s.support.gestures) {
                        s.slides[action]('gesturestart', s.zoom.onGestureStart, passiveListener);
                        s.slides[action]('gesturechange', s.zoom.onGestureChange, passiveListener);
                        s.slides[action]('gestureend', s.zoom.onGestureEnd, passiveListener);
                    }
                    else if (s.touchEvents.start === 'touchstart') {
                        s.slides[action](s.touchEvents.start, s.zoom.onGestureStart, passiveListener);
                        s.slides[action](s.touchEvents.move, s.zoom.onGestureChange, passiveListener);
                        s.slides[action](s.touchEvents.end, s.zoom.onGestureEnd, passiveListener);
                    }
        
                    // Move image
                    s[action]('touchStart', s.zoom.onTouchStart);
                    s.slides.each(function (index, slide){
                        if ($(slide).find('.' + s.params.zoomContainerClass).length > 0) {
                            $(slide)[action](s.touchEvents.move, s.zoom.onTouchMove);
                        }
                    });
                    s[action]('touchEnd', s.zoom.onTouchEnd);
        
                    // Scale Out
                    s[action]('transitionEnd', s.zoom.onTransitionEnd);
                    if (s.params.zoomToggle) {
                        s.on('doubleTap', s.zoom.toggleZoom);
                    }
                }
            },
            init: function () {
                s.zoom.attachEvents();
            },
            destroy: function () {
                s.zoom.attachEvents(true);
            }
        };

        /*=========================
          Plugins API. Collect all and init all plugins
          ===========================*/
        s._plugins = [];
        for (var plugin in s.plugins) {
            var p = s.plugins[plugin](s, s.params[plugin]);
            if (p) s._plugins.push(p);
        }
        // Method to call all plugins event/method
        s.callPlugins = function (eventName) {
            for (var i = 0; i < s._plugins.length; i++) {
                if (eventName in s._plugins[i]) {
                    s._plugins[i][eventName](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
                }
            }
        };

        /*=========================
          Events/Callbacks/Plugins Emitter
          ===========================*/
        function normalizeEventName (eventName) {
            if (eventName.indexOf('on') !== 0) {
                if (eventName[0] !== eventName[0].toUpperCase()) {
                    eventName = 'on' + eventName[0].toUpperCase() + eventName.substring(1);
                }
                else {
                    eventName = 'on' + eventName;
                }
            }
            return eventName;
        }
        s.emitterEventListeners = {
        
        };
        s.emit = function (eventName) {
            // Trigger callbacks
            if (s.params[eventName]) {
                s.params[eventName](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
            }
            var i;
            // Trigger events
            if (s.emitterEventListeners[eventName]) {
                for (i = 0; i < s.emitterEventListeners[eventName].length; i++) {
                    s.emitterEventListeners[eventName][i](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
                }
            }
            // Trigger plugins
            if (s.callPlugins) s.callPlugins(eventName, arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
        };
        s.on = function (eventName, handler) {
            eventName = normalizeEventName(eventName);
            if (!s.emitterEventListeners[eventName]) s.emitterEventListeners[eventName] = [];
            s.emitterEventListeners[eventName].push(handler);
            return s;
        };
        s.off = function (eventName, handler) {
            var i;
            eventName = normalizeEventName(eventName);
            if (typeof handler === 'undefined') {
                // Remove all handlers for such event
                s.emitterEventListeners[eventName] = [];
                return s;
            }
            if (!s.emitterEventListeners[eventName] || s.emitterEventListeners[eventName].length === 0) return;
            for (i = 0; i < s.emitterEventListeners[eventName].length; i++) {
                if(s.emitterEventListeners[eventName][i] === handler) s.emitterEventListeners[eventName].splice(i, 1);
            }
            return s;
        };
        s.once = function (eventName, handler) {
            eventName = normalizeEventName(eventName);
            var _handler = function () {
                handler(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
                s.off(eventName, _handler);
            };
            s.on(eventName, _handler);
            return s;
        };

        // Accessibility tools
        s.a11y = {
            makeFocusable: function ($el) {
                $el.attr('tabIndex', '0');
                return $el;
            },
            addRole: function ($el, role) {
                $el.attr('role', role);
                return $el;
            },
        
            addLabel: function ($el, label) {
                $el.attr('aria-label', label);
                return $el;
            },
        
            disable: function ($el) {
                $el.attr('aria-disabled', true);
                return $el;
            },
        
            enable: function ($el) {
                $el.attr('aria-disabled', false);
                return $el;
            },
        
            onEnterKey: function (event) {
                if (event.keyCode !== 13) return;
                if ($(event.target).is(s.params.nextButton)) {
                    s.onClickNext(event);
                    if (s.isEnd) {
                        s.a11y.notify(s.params.lastSlideMessage);
                    }
                    else {
                        s.a11y.notify(s.params.nextSlideMessage);
                    }
                }
                else if ($(event.target).is(s.params.prevButton)) {
                    s.onClickPrev(event);
                    if (s.isBeginning) {
                        s.a11y.notify(s.params.firstSlideMessage);
                    }
                    else {
                        s.a11y.notify(s.params.prevSlideMessage);
                    }
                }
                if ($(event.target).is('.' + s.params.bulletClass)) {
                    $(event.target)[0].click();
                }
            },
        
            liveRegion: $('<span class="' + s.params.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>'),
        
            notify: function (message) {
                var notification = s.a11y.liveRegion;
                if (notification.length === 0) return;
                notification.html('');
                notification.html(message);
            },
            init: function () {
                // Setup accessibility
                if (s.params.nextButton && s.nextButton && s.nextButton.length > 0) {
                    s.a11y.makeFocusable(s.nextButton);
                    s.a11y.addRole(s.nextButton, 'button');
                    s.a11y.addLabel(s.nextButton, s.params.nextSlideMessage);
                }
                if (s.params.prevButton && s.prevButton && s.prevButton.length > 0) {
                    s.a11y.makeFocusable(s.prevButton);
                    s.a11y.addRole(s.prevButton, 'button');
                    s.a11y.addLabel(s.prevButton, s.params.prevSlideMessage);
                }
        
                $(s.container).append(s.a11y.liveRegion);
            },
            initPagination: function () {
                if (s.params.pagination && s.params.paginationClickable && s.bullets && s.bullets.length) {
                    s.bullets.each(function () {
                        var bullet = $(this);
                        s.a11y.makeFocusable(bullet);
                        s.a11y.addRole(bullet, 'button');
                        s.a11y.addLabel(bullet, s.params.paginationBulletMessage.replace(/{{index}}/, bullet.index() + 1));
                    });
                }
            },
            destroy: function () {
                if (s.a11y.liveRegion && s.a11y.liveRegion.length > 0) s.a11y.liveRegion.remove();
            }
        };
        

        /*=========================
          Init/Destroy
          ===========================*/
        s.init = function () {
            if (s.params.loop) s.createLoop();
            s.updateContainerSize();
            s.updateSlidesSize();
            s.updatePagination();
            if (s.params.scrollbar && s.scrollbar) {
                s.scrollbar.set();
                if (s.params.scrollbarDraggable) {
                    s.scrollbar.enableDraggable();
                }
            }
            if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
                if (!s.params.loop) s.updateProgress();
                s.effects[s.params.effect].setTranslate();
            }
            if (s.params.loop) {
                s.slideTo(s.params.initialSlide + s.loopedSlides, 0, s.params.runCallbacksOnInit);
            }
            else {
                s.slideTo(s.params.initialSlide, 0, s.params.runCallbacksOnInit);
                if (s.params.initialSlide === 0) {
                    if (s.parallax && s.params.parallax) s.parallax.setTranslate();
                    if (s.lazy && s.params.lazyLoading) {
                        s.lazy.load();
                        s.lazy.initialImageLoaded = true;
                    }
                }
            }
            s.attachEvents();
            if (s.params.observer && s.support.observer) {
                s.initObservers();
            }
            if (s.params.preloadImages && !s.params.lazyLoading) {
                s.preloadImages();
            }
            if (s.params.zoom && s.zoom) {
                s.zoom.init();
            }
            if (s.params.autoplay) {
                s.startAutoplay();
            }
            if (s.params.keyboardControl) {
                if (s.enableKeyboardControl) s.enableKeyboardControl();
            }
            if (s.params.mousewheelControl) {
                if (s.enableMousewheelControl) s.enableMousewheelControl();
            }
            // Deprecated hashnavReplaceState changed to replaceState for use in hashnav and history
            if (s.params.hashnavReplaceState) {
                s.params.replaceState = s.params.hashnavReplaceState;
            }
            if (s.params.history) {
                if (s.history) s.history.init();
            }
            if (s.params.hashnav) {
                if (s.hashnav) s.hashnav.init();
            }
            if (s.params.a11y && s.a11y) s.a11y.init();
            s.emit('onInit', s);
        };
        
        // Cleanup dynamic styles
        s.cleanupStyles = function () {
            // Container
            s.container.removeClass(s.classNames.join(' ')).removeAttr('style');
        
            // Wrapper
            s.wrapper.removeAttr('style');
        
            // Slides
            if (s.slides && s.slides.length) {
                s.slides
                    .removeClass([
                      s.params.slideVisibleClass,
                      s.params.slideActiveClass,
                      s.params.slideNextClass,
                      s.params.slidePrevClass
                    ].join(' '))
                    .removeAttr('style')
                    .removeAttr('data-swiper-column')
                    .removeAttr('data-swiper-row');
            }
        
            // Pagination/Bullets
            if (s.paginationContainer && s.paginationContainer.length) {
                s.paginationContainer.removeClass(s.params.paginationHiddenClass);
            }
            if (s.bullets && s.bullets.length) {
                s.bullets.removeClass(s.params.bulletActiveClass);
            }
        
            // Buttons
            if (s.params.prevButton) $(s.params.prevButton).removeClass(s.params.buttonDisabledClass);
            if (s.params.nextButton) $(s.params.nextButton).removeClass(s.params.buttonDisabledClass);
        
            // Scrollbar
            if (s.params.scrollbar && s.scrollbar) {
                if (s.scrollbar.track && s.scrollbar.track.length) s.scrollbar.track.removeAttr('style');
                if (s.scrollbar.drag && s.scrollbar.drag.length) s.scrollbar.drag.removeAttr('style');
            }
        };
        
        // Destroy
        s.destroy = function (deleteInstance, cleanupStyles) {
            // Detach evebts
            s.detachEvents();
            // Stop autoplay
            s.stopAutoplay();
            // Disable draggable
            if (s.params.scrollbar && s.scrollbar) {
                if (s.params.scrollbarDraggable) {
                    s.scrollbar.disableDraggable();
                }
            }
            // Destroy loop
            if (s.params.loop) {
                s.destroyLoop();
            }
            // Cleanup styles
            if (cleanupStyles) {
                s.cleanupStyles();
            }
            // Disconnect observer
            s.disconnectObservers();
        
            // Destroy zoom
            if (s.params.zoom && s.zoom) {
                s.zoom.destroy();
            }
            // Disable keyboard/mousewheel
            if (s.params.keyboardControl) {
                if (s.disableKeyboardControl) s.disableKeyboardControl();
            }
            if (s.params.mousewheelControl) {
                if (s.disableMousewheelControl) s.disableMousewheelControl();
            }
            // Disable a11y
            if (s.params.a11y && s.a11y) s.a11y.destroy();
            // Delete history popstate
            if (s.params.history && !s.params.replaceState) {
                window.removeEventListener('popstate', s.history.setHistoryPopState);
            }
            if (s.params.hashnav && s.hashnav)  {
                s.hashnav.destroy();
            }
            // Destroy callback
            s.emit('onDestroy');
            // Delete instance
            if (deleteInstance !== false) s = null;
        };
        
        s.init();
        

    
        // Return swiper instance
        return s;
    };
    

    /*==================================================
        Prototype
    ====================================================*/
    Swiper.prototype = {
        isSafari: (function () {
            var ua = window.navigator.userAgent.toLowerCase();
            return (ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0);
        })(),
        isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent),
        isArray: function (arr) {
            return Object.prototype.toString.apply(arr) === '[object Array]';
        },
        /*==================================================
        Browser
        ====================================================*/
        browser: {
            ie: window.navigator.pointerEnabled || window.navigator.msPointerEnabled,
            ieTouch: (window.navigator.msPointerEnabled && window.navigator.msMaxTouchPoints > 1) || (window.navigator.pointerEnabled && window.navigator.maxTouchPoints > 1),
            lteIE9: (function() {
                // create temporary DIV
                var div = document.createElement('div');
                // add content to tmp DIV which is wrapped into the IE HTML conditional statement
                div.innerHTML = '<!--[if lte IE 9]><i></i><![endif]-->';
                // return true / false value based on what will browser render
                return div.getElementsByTagName('i').length === 1;
            })()
        },
        /*==================================================
        Devices
        ====================================================*/
        device: (function () {
            var ua = window.navigator.userAgent;
            var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
            var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
            var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
            var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
            return {
                ios: ipad || iphone || ipod,
                android: android
            };
        })(),
        /*==================================================
        Feature Detection
        ====================================================*/
        support: {
            touch : (window.Modernizr && Modernizr.touch === true) || (function () {
                return !!(('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);
            })(),
    
            transforms3d : (window.Modernizr && Modernizr.csstransforms3d === true) || (function () {
                var div = document.createElement('div').style;
                return ('webkitPerspective' in div || 'MozPerspective' in div || 'OPerspective' in div || 'MsPerspective' in div || 'perspective' in div);
            })(),
    
            flexbox: (function () {
                var div = document.createElement('div').style;
                var styles = ('alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient').split(' ');
                for (var i = 0; i < styles.length; i++) {
                    if (styles[i] in div) return true;
                }
            })(),
    
            observer: (function () {
                return ('MutationObserver' in window || 'WebkitMutationObserver' in window);
            })(),
    
            passiveListener: (function () {
                var supportsPassive = false;
                try {
                    var opts = Object.defineProperty({}, 'passive', {
                        get: function() {
                            supportsPassive = true;
                        }
                    });
                    window.addEventListener('testPassiveListener', null, opts);
                } catch (e) {}
                return supportsPassive;
            })(),
    
            gestures: (function () {
                return 'ongesturestart' in window;
            })()
        },
        /*==================================================
        Plugins
        ====================================================*/
        plugins: {}
    };
    

    /*===========================
    Dom7 Library
    ===========================*/
    var Dom7 = (function () {
        var Dom7 = function (arr) {
            var _this = this, i = 0;
            // Create array-like object
            for (i = 0; i < arr.length; i++) {
                _this[i] = arr[i];
            }
            _this.length = arr.length;
            // Return collection with methods
            return this;
        };
        var $ = function (selector, context) {
            var arr = [], i = 0;
            if (selector && !context) {
                if (selector instanceof Dom7) {
                    return selector;
                }
            }
            if (selector) {
                // String
                if (typeof selector === 'string') {
                    var els, tempParent, html = selector.trim();
                    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
                        var toCreate = 'div';
                        if (html.indexOf('<li') === 0) toCreate = 'ul';
                        if (html.indexOf('<tr') === 0) toCreate = 'tbody';
                        if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
                        if (html.indexOf('<tbody') === 0) toCreate = 'table';
                        if (html.indexOf('<option') === 0) toCreate = 'select';
                        tempParent = document.createElement(toCreate);
                        tempParent.innerHTML = selector;
                        for (i = 0; i < tempParent.childNodes.length; i++) {
                            arr.push(tempParent.childNodes[i]);
                        }
                    }
                    else {
                        if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
                            // Pure ID selector
                            els = [document.getElementById(selector.split('#')[1])];
                        }
                        else {
                            // Other selectors
                            els = (context || document).querySelectorAll(selector);
                        }
                        for (i = 0; i < els.length; i++) {
                            if (els[i]) arr.push(els[i]);
                        }
                    }
                }
                // Node/element
                else if (selector.nodeType || selector === window || selector === document) {
                    arr.push(selector);
                }
                //Array of elements or instance of Dom
                else if (selector.length > 0 && selector[0].nodeType) {
                    for (i = 0; i < selector.length; i++) {
                        arr.push(selector[i]);
                    }
                }
            }
            return new Dom7(arr);
        };
        Dom7.prototype = {
            // Classes and attriutes
            addClass: function (className) {
                if (typeof className === 'undefined') {
                    return this;
                }
                var classes = className.split(' ');
                for (var i = 0; i < classes.length; i++) {
                    for (var j = 0; j < this.length; j++) {
                        this[j].classList.add(classes[i]);
                    }
                }
                return this;
            },
            removeClass: function (className) {
                var classes = className.split(' ');
                for (var i = 0; i < classes.length; i++) {
                    for (var j = 0; j < this.length; j++) {
                        this[j].classList.remove(classes[i]);
                    }
                }
                return this;
            },
            hasClass: function (className) {
                if (!this[0]) return false;
                else return this[0].classList.contains(className);
            },
            toggleClass: function (className) {
                var classes = className.split(' ');
                for (var i = 0; i < classes.length; i++) {
                    for (var j = 0; j < this.length; j++) {
                        this[j].classList.toggle(classes[i]);
                    }
                }
                return this;
            },
            attr: function (attrs, value) {
                if (arguments.length === 1 && typeof attrs === 'string') {
                    // Get attr
                    if (this[0]) return this[0].getAttribute(attrs);
                    else return undefined;
                }
                else {
                    // Set attrs
                    for (var i = 0; i < this.length; i++) {
                        if (arguments.length === 2) {
                            // String
                            this[i].setAttribute(attrs, value);
                        }
                        else {
                            // Object
                            for (var attrName in attrs) {
                                this[i][attrName] = attrs[attrName];
                                this[i].setAttribute(attrName, attrs[attrName]);
                            }
                        }
                    }
                    return this;
                }
            },
            removeAttr: function (attr) {
                for (var i = 0; i < this.length; i++) {
                    this[i].removeAttribute(attr);
                }
                return this;
            },
            data: function (key, value) {
                if (typeof value === 'undefined') {
                    // Get value
                    if (this[0]) {
                        var dataKey = this[0].getAttribute('data-' + key);
                        if (dataKey) return dataKey;
                        else if (this[0].dom7ElementDataStorage && (key in this[0].dom7ElementDataStorage)) return this[0].dom7ElementDataStorage[key];
                        else return undefined;
                    }
                    else return undefined;
                }
                else {
                    // Set value
                    for (var i = 0; i < this.length; i++) {
                        var el = this[i];
                        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
                        el.dom7ElementDataStorage[key] = value;
                    }
                    return this;
                }
            },
            // Transforms
            transform : function (transform) {
                for (var i = 0; i < this.length; i++) {
                    var elStyle = this[i].style;
                    elStyle.webkitTransform = elStyle.MsTransform = elStyle.msTransform = elStyle.MozTransform = elStyle.OTransform = elStyle.transform = transform;
                }
                return this;
            },
            transition: function (duration) {
                if (typeof duration !== 'string') {
                    duration = duration + 'ms';
                }
                for (var i = 0; i < this.length; i++) {
                    var elStyle = this[i].style;
                    elStyle.webkitTransitionDuration = elStyle.MsTransitionDuration = elStyle.msTransitionDuration = elStyle.MozTransitionDuration = elStyle.OTransitionDuration = elStyle.transitionDuration = duration;
                }
                return this;
            },
            //Events
            on: function (eventName, targetSelector, listener, capture) {
                function handleLiveEvent(e) {
                    var target = e.target;
                    if ($(target).is(targetSelector)) listener.call(target, e);
                    else {
                        var parents = $(target).parents();
                        for (var k = 0; k < parents.length; k++) {
                            if ($(parents[k]).is(targetSelector)) listener.call(parents[k], e);
                        }
                    }
                }
                var events = eventName.split(' ');
                var i, j;
                for (i = 0; i < this.length; i++) {
                    if (typeof targetSelector === 'function' || targetSelector === false) {
                        // Usual events
                        if (typeof targetSelector === 'function') {
                            listener = arguments[1];
                            capture = arguments[2] || false;
                        }
                        for (j = 0; j < events.length; j++) {
                            this[i].addEventListener(events[j], listener, capture);
                        }
                    }
                    else {
                        //Live events
                        for (j = 0; j < events.length; j++) {
                            if (!this[i].dom7LiveListeners) this[i].dom7LiveListeners = [];
                            this[i].dom7LiveListeners.push({listener: listener, liveListener: handleLiveEvent});
                            this[i].addEventListener(events[j], handleLiveEvent, capture);
                        }
                    }
                }
    
                return this;
            },
            off: function (eventName, targetSelector, listener, capture) {
                var events = eventName.split(' ');
                for (var i = 0; i < events.length; i++) {
                    for (var j = 0; j < this.length; j++) {
                        if (typeof targetSelector === 'function' || targetSelector === false) {
                            // Usual events
                            if (typeof targetSelector === 'function') {
                                listener = arguments[1];
                                capture = arguments[2] || false;
                            }
                            this[j].removeEventListener(events[i], listener, capture);
                        }
                        else {
                            // Live event
                            if (this[j].dom7LiveListeners) {
                                for (var k = 0; k < this[j].dom7LiveListeners.length; k++) {
                                    if (this[j].dom7LiveListeners[k].listener === listener) {
                                        this[j].removeEventListener(events[i], this[j].dom7LiveListeners[k].liveListener, capture);
                                    }
                                }
                            }
                        }
                    }
                }
                return this;
            },
            once: function (eventName, targetSelector, listener, capture) {
                var dom = this;
                if (typeof targetSelector === 'function') {
                    targetSelector = false;
                    listener = arguments[1];
                    capture = arguments[2];
                }
                function proxy(e) {
                    listener(e);
                    dom.off(eventName, targetSelector, proxy, capture);
                }
                dom.on(eventName, targetSelector, proxy, capture);
            },
            trigger: function (eventName, eventData) {
                for (var i = 0; i < this.length; i++) {
                    var evt;
                    try {
                        evt = new window.CustomEvent(eventName, {detail: eventData, bubbles: true, cancelable: true});
                    }
                    catch (e) {
                        evt = document.createEvent('Event');
                        evt.initEvent(eventName, true, true);
                        evt.detail = eventData;
                    }
                    this[i].dispatchEvent(evt);
                }
                return this;
            },
            transitionEnd: function (callback) {
                var events = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'],
                    i, j, dom = this;
                function fireCallBack(e) {
                    /*jshint validthis:true */
                    if (e.target !== this) return;
                    callback.call(this, e);
                    for (i = 0; i < events.length; i++) {
                        dom.off(events[i], fireCallBack);
                    }
                }
                if (callback) {
                    for (i = 0; i < events.length; i++) {
                        dom.on(events[i], fireCallBack);
                    }
                }
                return this;
            },
            // Sizing/Styles
            width: function () {
                if (this[0] === window) {
                    return window.innerWidth;
                }
                else {
                    if (this.length > 0) {
                        return parseFloat(this.css('width'));
                    }
                    else {
                        return null;
                    }
                }
            },
            outerWidth: function (includeMargins) {
                if (this.length > 0) {
                    if (includeMargins)
                        return this[0].offsetWidth + parseFloat(this.css('margin-right')) + parseFloat(this.css('margin-left'));
                    else
                        return this[0].offsetWidth;
                }
                else return null;
            },
            height: function () {
                if (this[0] === window) {
                    return window.innerHeight;
                }
                else {
                    if (this.length > 0) {
                        return parseFloat(this.css('height'));
                    }
                    else {
                        return null;
                    }
                }
            },
            outerHeight: function (includeMargins) {
                if (this.length > 0) {
                    if (includeMargins)
                        return this[0].offsetHeight + parseFloat(this.css('margin-top')) + parseFloat(this.css('margin-bottom'));
                    else
                        return this[0].offsetHeight;
                }
                else return null;
            },
            offset: function () {
                if (this.length > 0) {
                    var el = this[0];
                    var box = el.getBoundingClientRect();
                    var body = document.body;
                    var clientTop  = el.clientTop  || body.clientTop  || 0;
                    var clientLeft = el.clientLeft || body.clientLeft || 0;
                    var scrollTop  = window.pageYOffset || el.scrollTop;
                    var scrollLeft = window.pageXOffset || el.scrollLeft;
                    return {
                        top: box.top  + scrollTop  - clientTop,
                        left: box.left + scrollLeft - clientLeft
                    };
                }
                else {
                    return null;
                }
            },
            css: function (props, value) {
                var i;
                if (arguments.length === 1) {
                    if (typeof props === 'string') {
                        if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
                    }
                    else {
                        for (i = 0; i < this.length; i++) {
                            for (var prop in props) {
                                this[i].style[prop] = props[prop];
                            }
                        }
                        return this;
                    }
                }
                if (arguments.length === 2 && typeof props === 'string') {
                    for (i = 0; i < this.length; i++) {
                        this[i].style[props] = value;
                    }
                    return this;
                }
                return this;
            },
    
            //Dom manipulation
            each: function (callback) {
                for (var i = 0; i < this.length; i++) {
                    callback.call(this[i], i, this[i]);
                }
                return this;
            },
            html: function (html) {
                if (typeof html === 'undefined') {
                    return this[0] ? this[0].innerHTML : undefined;
                }
                else {
                    for (var i = 0; i < this.length; i++) {
                        this[i].innerHTML = html;
                    }
                    return this;
                }
            },
            text: function (text) {
                if (typeof text === 'undefined') {
                    if (this[0]) {
                        return this[0].textContent.trim();
                    }
                    else return null;
                }
                else {
                    for (var i = 0; i < this.length; i++) {
                        this[i].textContent = text;
                    }
                    return this;
                }
            },
            is: function (selector) {
                if (!this[0]) return false;
                var compareWith, i;
                if (typeof selector === 'string') {
                    var el = this[0];
                    if (el === document) return selector === document;
                    if (el === window) return selector === window;
    
                    if (el.matches) return el.matches(selector);
                    else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
                    else if (el.mozMatchesSelector) return el.mozMatchesSelector(selector);
                    else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
                    else {
                        compareWith = $(selector);
                        for (i = 0; i < compareWith.length; i++) {
                            if (compareWith[i] === this[0]) return true;
                        }
                        return false;
                    }
                }
                else if (selector === document) return this[0] === document;
                else if (selector === window) return this[0] === window;
                else {
                    if (selector.nodeType || selector instanceof Dom7) {
                        compareWith = selector.nodeType ? [selector] : selector;
                        for (i = 0; i < compareWith.length; i++) {
                            if (compareWith[i] === this[0]) return true;
                        }
                        return false;
                    }
                    return false;
                }
    
            },
            index: function () {
                if (this[0]) {
                    var child = this[0];
                    var i = 0;
                    while ((child = child.previousSibling) !== null) {
                        if (child.nodeType === 1) i++;
                    }
                    return i;
                }
                else return undefined;
            },
            eq: function (index) {
                if (typeof index === 'undefined') return this;
                var length = this.length;
                var returnIndex;
                if (index > length - 1) {
                    return new Dom7([]);
                }
                if (index < 0) {
                    returnIndex = length + index;
                    if (returnIndex < 0) return new Dom7([]);
                    else return new Dom7([this[returnIndex]]);
                }
                return new Dom7([this[index]]);
            },
            append: function (newChild) {
                var i, j;
                for (i = 0; i < this.length; i++) {
                    if (typeof newChild === 'string') {
                        var tempDiv = document.createElement('div');
                        tempDiv.innerHTML = newChild;
                        while (tempDiv.firstChild) {
                            this[i].appendChild(tempDiv.firstChild);
                        }
                    }
                    else if (newChild instanceof Dom7) {
                        for (j = 0; j < newChild.length; j++) {
                            this[i].appendChild(newChild[j]);
                        }
                    }
                    else {
                        this[i].appendChild(newChild);
                    }
                }
                return this;
            },
            prepend: function (newChild) {
                var i, j;
                for (i = 0; i < this.length; i++) {
                    if (typeof newChild === 'string') {
                        var tempDiv = document.createElement('div');
                        tempDiv.innerHTML = newChild;
                        for (j = tempDiv.childNodes.length - 1; j >= 0; j--) {
                            this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
                        }
                        // this[i].insertAdjacentHTML('afterbegin', newChild);
                    }
                    else if (newChild instanceof Dom7) {
                        for (j = 0; j < newChild.length; j++) {
                            this[i].insertBefore(newChild[j], this[i].childNodes[0]);
                        }
                    }
                    else {
                        this[i].insertBefore(newChild, this[i].childNodes[0]);
                    }
                }
                return this;
            },
            insertBefore: function (selector) {
                var before = $(selector);
                for (var i = 0; i < this.length; i++) {
                    if (before.length === 1) {
                        before[0].parentNode.insertBefore(this[i], before[0]);
                    }
                    else if (before.length > 1) {
                        for (var j = 0; j < before.length; j++) {
                            before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
                        }
                    }
                }
            },
            insertAfter: function (selector) {
                var after = $(selector);
                for (var i = 0; i < this.length; i++) {
                    if (after.length === 1) {
                        after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
                    }
                    else if (after.length > 1) {
                        for (var j = 0; j < after.length; j++) {
                            after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
                        }
                    }
                }
            },
            next: function (selector) {
                if (this.length > 0) {
                    if (selector) {
                        if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) return new Dom7([this[0].nextElementSibling]);
                        else return new Dom7([]);
                    }
                    else {
                        if (this[0].nextElementSibling) return new Dom7([this[0].nextElementSibling]);
                        else return new Dom7([]);
                    }
                }
                else return new Dom7([]);
            },
            nextAll: function (selector) {
                var nextEls = [];
                var el = this[0];
                if (!el) return new Dom7([]);
                while (el.nextElementSibling) {
                    var next = el.nextElementSibling;
                    if (selector) {
                        if($(next).is(selector)) nextEls.push(next);
                    }
                    else nextEls.push(next);
                    el = next;
                }
                return new Dom7(nextEls);
            },
            prev: function (selector) {
                if (this.length > 0) {
                    if (selector) {
                        if (this[0].previousElementSibling && $(this[0].previousElementSibling).is(selector)) return new Dom7([this[0].previousElementSibling]);
                        else return new Dom7([]);
                    }
                    else {
                        if (this[0].previousElementSibling) return new Dom7([this[0].previousElementSibling]);
                        else return new Dom7([]);
                    }
                }
                else return new Dom7([]);
            },
            prevAll: function (selector) {
                var prevEls = [];
                var el = this[0];
                if (!el) return new Dom7([]);
                while (el.previousElementSibling) {
                    var prev = el.previousElementSibling;
                    if (selector) {
                        if($(prev).is(selector)) prevEls.push(prev);
                    }
                    else prevEls.push(prev);
                    el = prev;
                }
                return new Dom7(prevEls);
            },
            parent: function (selector) {
                var parents = [];
                for (var i = 0; i < this.length; i++) {
                    if (selector) {
                        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
                    }
                    else {
                        parents.push(this[i].parentNode);
                    }
                }
                return $($.unique(parents));
            },
            parents: function (selector) {
                var parents = [];
                for (var i = 0; i < this.length; i++) {
                    var parent = this[i].parentNode;
                    while (parent) {
                        if (selector) {
                            if ($(parent).is(selector)) parents.push(parent);
                        }
                        else {
                            parents.push(parent);
                        }
                        parent = parent.parentNode;
                    }
                }
                return $($.unique(parents));
            },
            find : function (selector) {
                var foundElements = [];
                for (var i = 0; i < this.length; i++) {
                    var found = this[i].querySelectorAll(selector);
                    for (var j = 0; j < found.length; j++) {
                        foundElements.push(found[j]);
                    }
                }
                return new Dom7(foundElements);
            },
            children: function (selector) {
                var children = [];
                for (var i = 0; i < this.length; i++) {
                    var childNodes = this[i].childNodes;
    
                    for (var j = 0; j < childNodes.length; j++) {
                        if (!selector) {
                            if (childNodes[j].nodeType === 1) children.push(childNodes[j]);
                        }
                        else {
                            if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) children.push(childNodes[j]);
                        }
                    }
                }
                return new Dom7($.unique(children));
            },
            remove: function () {
                for (var i = 0; i < this.length; i++) {
                    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
                }
                return this;
            },
            add: function () {
                var dom = this;
                var i, j;
                for (i = 0; i < arguments.length; i++) {
                    var toAdd = $(arguments[i]);
                    for (j = 0; j < toAdd.length; j++) {
                        dom[dom.length] = toAdd[j];
                        dom.length++;
                    }
                }
                return dom;
            }
        };
        $.fn = Dom7.prototype;
        $.unique = function (arr) {
            var unique = [];
            for (var i = 0; i < arr.length; i++) {
                if (unique.indexOf(arr[i]) === -1) unique.push(arr[i]);
            }
            return unique;
        };
    
        return $;
    })();
    

    /*===========================
     Get Dom libraries
     ===========================*/
    var swiperDomPlugins = ['jQuery', 'Zepto', 'Dom7'];
    for (var i = 0; i < swiperDomPlugins.length; i++) {
    	if (window[swiperDomPlugins[i]]) {
    		addLibraryPlugin(window[swiperDomPlugins[i]]);
    	}
    }
    // Required DOM Plugins
    var domLib;
    if (typeof Dom7 === 'undefined') {
    	domLib = window.Dom7 || window.Zepto || window.jQuery;
    }
    else {
    	domLib = Dom7;
    }

    /*===========================
    Add .swiper plugin from Dom libraries
    ===========================*/
    function addLibraryPlugin(lib) {
        lib.fn.swiper = function (params) {
            var firstInstance;
            lib(this).each(function () {
                var s = new Swiper(this, params);
                if (!firstInstance) firstInstance = s;
            });
            return firstInstance;
        };
    }
    
    if (domLib) {
        if (!('transitionEnd' in domLib.fn)) {
            domLib.fn.transitionEnd = function (callback) {
                var events = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'],
                    i, j, dom = this;
                function fireCallBack(e) {
                    /*jshint validthis:true */
                    if (e.target !== this) return;
                    callback.call(this, e);
                    for (i = 0; i < events.length; i++) {
                        dom.off(events[i], fireCallBack);
                    }
                }
                if (callback) {
                    for (i = 0; i < events.length; i++) {
                        dom.on(events[i], fireCallBack);
                    }
                }
                return this;
            };
        }
        if (!('transform' in domLib.fn)) {
            domLib.fn.transform = function (transform) {
                for (var i = 0; i < this.length; i++) {
                    var elStyle = this[i].style;
                    elStyle.webkitTransform = elStyle.MsTransform = elStyle.msTransform = elStyle.MozTransform = elStyle.OTransform = elStyle.transform = transform;
                }
                return this;
            };
        }
        if (!('transition' in domLib.fn)) {
            domLib.fn.transition = function (duration) {
                if (typeof duration !== 'string') {
                    duration = duration + 'ms';
                }
                for (var i = 0; i < this.length; i++) {
                    var elStyle = this[i].style;
                    elStyle.webkitTransitionDuration = elStyle.MsTransitionDuration = elStyle.msTransitionDuration = elStyle.MozTransitionDuration = elStyle.OTransitionDuration = elStyle.transitionDuration = duration;
                }
                return this;
            };
        }
        if (!('outerWidth' in domLib.fn)) {
            domLib.fn.outerWidth = function (includeMargins) {
                if (this.length > 0) {
                    if (includeMargins)
                        return this[0].offsetWidth + parseFloat(this.css('margin-right')) + parseFloat(this.css('margin-left'));
                    else
                        return this[0].offsetWidth;
                }
                else return null;
            };
        }
    }

    window.Swiper = Swiper;
})();
/*===========================
Swiper AMD Export
===========================*/
if (typeof(module) !== 'undefined')
{
    module.exports = window.Swiper;
}
else if (typeof define === 'function' && define.amd) {
    define([], function () {
        'use strict';
        return window.Swiper;
    });
}
//# sourceMappingURL=maps/swiper.js.map

/*!
 * The MIT License (MIT)
 * 
 * Copyright (c) 2016 Mykhailo Stadnyk <mikhus@gmail.com>
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * @version 2.1.5
 */
!function(e){"use strict";function t(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(t||(t="undefined"==typeof window?global:window),void 0!==t[e])return t[e];for(var i=["webkit","moz","ms","o"],r=0,o=i.length,n=e.charAt(0).toUpperCase()+e.substr(1);r<o;r++){var a=t[i[r]+n];if(void 0!==a)return a}return null}function n(e,t,i,r,o,a,l){if("function"!=typeof r)throw new TypeError("Invalid animation rule:",r);var s=e-i,d=s/o,u=0;d>1&&(d=1),1!==d&&(u=r(d),isFinite(u)&&!isNaN(u)&&(d=u)),t&&t(d),s<o?l.frame=G(function(e){return n(e,t,i,r,o,a,l)}):(a&&a(),l.inProgress=!1)}function a(){Array.prototype.constructor.apply(this,arguments)}function l(e){if(!(e instanceof DOMException&&2152923147===e.result))throw e}function s(e){return e.majorTicks instanceof Array||(e.majorTicks=e.majorTicks?[e.majorTicks]:[]),e.majorTicks.length||(e.majorTicks.push(K.formatMajorTickNumber(e.minValue,e)),e.majorTicks.push(K.formatMajorTickNumber(e.maxValue,e))),["right"!==e.tickSide,"left"!==e.tickSide]}function d(e,t,i,r,o,n){e.beginPath(),e.moveTo(t+n,i),e.lineTo(t+r-n,i),e.quadraticCurveTo(t+r,i,t+r,i+n),e.lineTo(t+r,i+o-n),e.quadraticCurveTo(t+r,i+o,t+r-n,i+o),e.lineTo(t+n,i+o),e.quadraticCurveTo(t,i+o,t,i+o-n),e.lineTo(t,i+n),e.quadraticCurveTo(t,i,t+n,i),e.closePath()}function u(e,t){var i=t.valueDec,r=t.valueInt,o=0,n=void 0,a=void 0,l=void 0;if(e=parseFloat(e),l=e<0,e=Math.abs(e),i>0){for(a=e.toFixed(i).toString().split("."),n=r-a[0].length;o<n;++o)a[0]="0"+a[0];a=(l?"-":"")+a[0]+"."+a[1]}else{for(a=Math.round(e).toString(),n=r-a.length;o<n;++o)a="0"+a;a=(l?"-":"")+a}return a}function c(e,t){var i=void 0,r=!1;return i=0===t.majorTicksDec?Math.round(e).toString():e.toFixed(t.majorTicksDec),t.majorTicksInt>1?(r=~i.indexOf("."),~i.indexOf("-")?"-"+[t.majorTicksInt+t.majorTicksDec+2+(r?1:0)-i.length].join("0")+i.replace("-",""):[t.majorTicksInt+t.majorTicksDec+1+(r?1:0)-i.length].join("0")+i):i}function h(e){return e*Math.PI/180}function f(e,t){return{x:-e*Math.sin(t),y:e*Math.cos(t)}}function v(e,t,i,r){var o=!(arguments.length>4&&void 0!==arguments[4])||arguments[4],n=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0,a=e.createLinearGradient(o?0:n,o?n:0,o?0:r,o?r:0);return a.addColorStop(0,t),a.addColorStop(1,i),a}function m(e,t){if(arguments.length>2&&void 0!==arguments[2]&&arguments[2])return e.restore(),!0;e.save();var i=t.borderShadowWidth;return i&&(e.shadowBlur=i,e.shadowColor=t.colorBorderShadow),!0}function p(e,t){t.needleShadow&&(e.shadowOffsetX=2,e.shadowOffsetY=2,e.shadowBlur=10,e.shadowColor=t.colorNeedleShadowDown)}function g(e,t,i){return e["font"+t+"Style"]+" "+e["font"+t+"Weight"]+" "+e["font"+t+"Size"]*i+"px "+e["font"+t]}function w(e){e.shadowOffsetX=null,e.shadowOffsetY=null,e.shadowBlur=null,e.shadowColor="",e.strokeStyle=null,e.lineWidth=0,e.save()}function b(e,t,i,r){t.valueTextShadow&&(e.shadowOffsetX=i,e.shadowOffsetY=i,e.shadowBlur=r,e.shadowColor=t.colorValueTextShadow)}function y(e,t,i,r,o,n){if(t.valueBox){w(e);var a=t.valueDec?1+t.valueDec:0,l="9".repeat(Math.max.apply(null,[String(parseInt(i)).length+a].concat(t.majorTicks.map(function(e){return String(parseInt(e,10)).length+a})))),s=t.valueText||u(i,t),c=n/200,h=n/100,f=.4*h,v=1.2*h;e.font=g(t,"Value",c),b(e,t,f,v);var m=e.measureText(t.valueText?s:"-"+u(Number(l),t)).width;w(e);var p=parseFloat(t.fontValueSize)*c+f+v,y=h*parseFloat(t.valueBoxStroke),x=2*n-2*y,k=m+10*h,T=1.1*p+f+v,S=h*t.valueBoxBorderRadius,O=(parseFloat(t.valueBoxWidth)||0)/100*x;O>k&&(k=O),k>x&&(k=x);var A=r-k/2,C=o-T/2,V=o-5.75*h;if(e.beginPath(),S?d(e,A,C,k,T,S):e.rect(A,C,k,T),y){var N=e.createRadialGradient(r,V,10*h,r,V,20*h);N.addColorStop(0,t.colorValueBoxRect),N.addColorStop(1,t.colorValueBoxRectEnd),e.strokeStyle=N,e.lineWidth=y,e.stroke()}t.colorValueBoxShadow&&(e.shadowBlur=1.2*h,e.shadowColor=t.colorValueBoxShadow),t.colorValueBoxBackground&&(e.fillStyle=t.colorValueBoxBackground,e.fill()),e.closePath(),e.restore(),b(e,t,f,v),e.fillStyle=t.colorValueText,e.textAlign="center",e.textBaseline="alphabetic",e.fillText(s,A+k/2,o+T/2-p/3),e.restore()}}function x(e){var t=e.value,i=e.minValue,r=e.maxValue,o=.01*(r-i);return{normal:t<i?i:t>r?r:t,indented:t<i?i-o:t>r?r+o:t}}function k(e,t,i,r,o){i.beginPath(),i.arc(0,0,J(e),0,2*Q,!0),i.lineWidth=t,i.strokeStyle=o?K.linearGradient(i,r,o,e):r,i.stroke(),i.closePath()}function T(e,t){var i=X.pixelRatio;return e.maxRadius||(e.maxRadius=e.max-t.borderShadowWidth-t.borderOuterWidth*i-t.borderMiddleWidth*i-t.borderInnerWidth*i+(t.borderOuterWidth?.5:0)+(t.borderMiddleWidth?.5:0)+(t.borderInnerWidth?.5:0)),e.maxRadius}function S(e,t){var i=X.pixelRatio,r=t.borderShadowWidth*i,o=e.max-r-t.borderOuterWidth*i/2,n=o-t.borderOuterWidth*i/2-t.borderMiddleWidth*i/2+.5,a=n-t.borderMiddleWidth*i/2-t.borderInnerWidth*i/2+.5,l=T(e,t),s=void 0,d=!1;e.save(),t.borderOuterWidth&&(d=K.drawShadow(e,t,d),k(o,t.borderOuterWidth*i,e,t.colorBorderOuter,t.colorBorderOuterEnd)),t.borderMiddleWidth&&(d=K.drawShadow(e,t,d),k(n,t.borderMiddleWidth*i,e,t.colorBorderMiddle,t.colorBorderMiddleEnd)),t.borderInnerWidth&&(d=K.drawShadow(e,t,d),k(a,t.borderInnerWidth*i,e,t.colorBorderInner,t.colorBorderInnerEnd)),K.drawShadow(e,t,d),e.beginPath(),e.arc(0,0,J(l),0,2*Q,!0),t.colorPlateEnd?(s=e.createRadialGradient(0,0,l/2,0,0,l),s.addColorStop(0,t.colorPlate),s.addColorStop(1,t.colorPlateEnd)):s=t.colorPlate,e.fillStyle=s,e.fill(),e.closePath(),e.restore()}function O(e,t){var i=e.max*(parseFloat(t.highlightsWidth)||0)/100;if(i){var r=J(C(e,t)-i/2),o=0,n=t.highlights.length,a=(t.maxValue-t.minValue)/t.ticksAngle;for(e.save();o<n;o++){var l=t.highlights[o];e.beginPath(),e.rotate(ee),e.arc(0,0,r,K.radians(t.startAngle+(l.from-t.minValue)/a),K.radians(t.startAngle+(l.to-t.minValue)/a),!1),e.strokeStyle=l.color,e.lineWidth=i,e.stroke(),e.closePath(),e.restore(),e.save()}}}function A(e,t){var i=C(e,t),r=void 0,o=void 0,n=void 0,a=0,l=0,s=Math.abs(t.minorTicks)||0,d=t.ticksAngle/(t.maxValue-t.minValue);for(e.lineWidth=X.pixelRatio,e.strokeStyle=t.colorMinorTicks||t.colorStrokeTicks,e.save(),t.exactTicks?(o=t.maxValue-t.minValue,r=s?o/s:0,l=(Z.mod(t.majorTicks[0],s)||0)*d):r=s*(t.majorTicks.length-1);a<r;++a)(n=t.startAngle+l+a*(t.ticksAngle/r))<=t.ticksAngle+t.startAngle&&(e.rotate(K.radians(n)),e.beginPath(),e.moveTo(0,i),e.lineTo(0,i-.075*e.max),P(e))}function C(e,t){var i=e.max/100;return T(e,t)-5*i-(t.barWidth?2*(parseFloat(t.barStrokeWidth)||0)+((parseFloat(t.barWidth)||0)+5)*i:0)}function V(e,t){K.prepareTicks(t);var i=J(C(e,t)),r=void 0,o=void 0,n=t.majorTicks.length,a=X.pixelRatio;for(e.lineWidth=2*a,e.save(),o=t.colorMajorTicks instanceof Array?t.colorMajorTicks:new Array(n).fill(t.colorStrokeTicks||t.colorMajorTicks),r=0;r<n;++r)e.strokeStyle=o[r],e.rotate(K.radians(N(t,t.exactTicks?t.majorTicks[r]:r,n))),e.beginPath(),e.moveTo(0,i),e.lineTo(0,i-.15*e.max),P(e);t.strokeTicks&&(e.strokeStyle=t.colorStrokeTicks||o[0],e.rotate(ee),e.beginPath(),e.arc(0,0,i,K.radians(t.startAngle),K.radians(t.startAngle+t.ticksAngle),!1),P(e))}function N(e,t,i){if(e.exactTicks){var r=e.ticksAngle/(e.maxValue-e.minValue);return e.startAngle+r*(t-e.minValue)}return e.startAngle+t*(e.ticksAngle/(i-1))}function P(e){e.stroke(),e.restore(),e.closePath(),e.save()}function j(e,t){var i=C(e,t)-.15*e.max,r={},o=0,n=t.majorTicks.length,a="needle"!==t.animationTarget,l=t.colorNumbers instanceof Array?t.colorNumbers:new Array(n).fill(t.colorNumbers),s=a?-(t.value-t.minValue)/(t.maxValue-t.minValue)*t.ticksAngle:0;for(a&&(e.save(),e.rotate(-K.radians(s))),e.font=K.font(t,"Numbers",e.max/200),e.lineWidth=0,e.textAlign="center",e.textBaseline="middle";o<n;++o){var d=s+N(t,t.exactTicks?t.majorTicks[o]:o,n),u=e.measureText(t.majorTicks[o]).width,c=t.fontNumbersSize,h=Math.sqrt(u*u+c*c)/2,f=K.radialPoint(i-h-t.numbersMargin/100*e.max,K.radians(d));360===d&&(d=0),r[d]||(r[d]=!0,e.fillStyle=l[o],e.fillText(t.majorTicks[o],f.x,f.y))}a&&e.restore()}function M(e,t){t.title&&(e.save(),e.font=K.font(t,"Title",e.max/200),e.fillStyle=t.colorTitle,e.textAlign="center",e.fillText(t.title,0,-e.max/4.25,.8*e.max),e.restore())}function B(e,t){t.units&&(e.save(),e.font=K.font(t,"Units",e.max/200),e.fillStyle=t.colorUnits,e.textAlign="center",e.fillText(t.units,0,e.max/3.25,.8*e.max),e.restore())}function W(e,t){if(t.needle){var i=t.ticksAngle<360?K.normalizedValue(t).indented:t.value,r=T(e,t),o=J(r/100*t.needleCircleSize),n=J(r/100*t.needleCircleSize*.75),a=J(r/100*t.needleEnd),l=J(t.needleStart?r/100*t.needleStart:0),s=r/100*t.needleWidth,d=r/100*t.needleWidth/2,u=X.pixelRatio,c="needle"!==t.animationTarget;e.save(),K.drawNeedleShadow(e,t),e.rotate(K.radians(c?t.startAngle:t.startAngle+(i-t.minValue)/(t.maxValue-t.minValue)*t.ticksAngle)),e.fillStyle=K.linearGradient(e,t.colorNeedle,t.colorNeedleEnd,a-l),"arrow"===t.needleType?(e.beginPath(),e.moveTo(-d,-l),e.lineTo(-s,0),e.lineTo(-1*u,a),e.lineTo(u,a),e.lineTo(s,0),e.lineTo(d,-l),e.closePath(),e.fill(),e.beginPath(),e.lineTo(-.5*u,a),e.lineTo(-1*u,a),e.lineTo(-s,0),e.lineTo(-d,-l),e.lineTo(d/2*u-2*u,-l),e.closePath(),e.fillStyle=t.colorNeedleShadowUp,e.fill()):(e.beginPath(),e.moveTo(-d,a),e.lineTo(-d,l),e.lineTo(d,l),e.lineTo(d,a),e.closePath(),e.fill()),t.needleCircleSize&&(e.restore(),K.drawNeedleShadow(e,t),t.needleCircleOuter&&(e.beginPath(),e.arc(0,0,o,0,2*Q,!0),e.fillStyle=K.linearGradient(e,t.colorNeedleCircleOuter,t.colorNeedleCircleOuterEnd,o),e.fill(),e.closePath()),t.needleCircleInner&&(e.beginPath(),e.arc(0,0,n,0,2*Q,!0),e.fillStyle=K.linearGradient(e,t.colorNeedleCircleInner,t.colorNeedleCircleInnerEnd,n),e.fill(),e.closePath()),e.restore())}}function _(e,t,i){K.drawValueBox(e,t,i,0,e.max-.33*e.max,e.max)}function E(e,t){var i=e.max/100,r=T(e,t)-5*i,o=parseFloat(t.barStrokeWidth)||0,n=(parseFloat(t.barWidth)||0)*i,a=r-2*o-n,l=(r-a)/2,s=a+l,d=o/s,u=t.startAngle,c=t.startAngle+t.ticksAngle;e.save(),e.rotate(ee),o&&(e.beginPath(),e.arc(0,0,s,K.radians(u)-d,K.radians(c)+d,!1),e.strokeStyle=t.colorBarStroke,e.lineWidth=2*l,e.stroke(),e.closePath()),n&&(e.beginPath(),e.arc(0,0,s,K.radians(u),K.radians(c),!1),e.strokeStyle=t.colorBar,e.lineWidth=n,e.stroke(),e.closePath(),t.barShadow&&(e.beginPath(),e.arc(0,0,r,K.radians(u),K.radians(c),!1),e.clip(),e.beginPath(),e.strokeStyle=t.colorBar,e.lineWidth=1,e.shadowBlur=t.barShadow,e.shadowColor=t.colorBarShadow,e.shadowOffsetX=0,e.shadowOffsetY=0,e.arc(0,0,r,K.radians(t.startAngle),K.radians(t.startAngle+t.ticksAngle),!1),e.stroke(),e.closePath(),e.restore(),e.rotate(ee)),t.barProgress&&(e.beginPath(),e.arc(0,0,s,K.radians(u),K.radians(u+(K.normalizedValue(t).normal-t.minValue)/(t.maxValue-t.minValue)*t.ticksAngle),!1),e.strokeStyle=t.colorBarProgress,e.lineWidth=n,e.stroke(),e.closePath())),e.restore()}function R(e){return e.options.animatedValue?e.options.value:e.value}var I=function e(t,i,r){null===t&&(t=Function.prototype);var o=Object.getOwnPropertyDescriptor(t,i);if(void 0===o){var n=Object.getPrototypeOf(t);return null===n?void 0:e(n,i,r)}if("value"in o)return o.value;var a=o.get;if(void 0!==a)return a.call(r)},D=function e(t,i,r,o){var n=Object.getOwnPropertyDescriptor(t,i);if(void 0===n){var a=Object.getPrototypeOf(t);null!==a&&e(a,i,r,o)}else if("value"in n&&n.writable)n.value=r;else{var l=n.set;void 0!==l&&l.call(o,r)}return r},z=function(){function e(e,t){for(var i=0;i<t.length;i++){var r=t[i];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,i,r){return i&&e(t.prototype,i),r&&e(t,r),t}}();Object.assign||Object.defineProperty(Object,"assign",{enumerable:!1,configurable:!0,writable:!0,value:function(e,t){if(void 0===e||null===e)throw new TypeError("Cannot convert first argument to object");for(var i=Object(e),r=1;r<arguments.length;r++){var o=arguments[r];if(void 0!==o&&null!==o)for(var n=Object.keys(Object(o)),a=0,l=n.length;a<l;a++){var s=n[a],d=Object.getOwnPropertyDescriptor(o,s);void 0!==d&&d.enumerable&&(i[s]=o[s])}}return i}}),Array.prototype.indexOf||Object.defineProperty(Array.prototype,"indexOf",{value:function(e,t){var i;if(null===this)throw new TypeError('"this" is null or not defined');var r=Object(this),o=r.length>>>0;if(0===o)return-1;var n=+t||0;if(Math.abs(n)===1/0&&(n=0),n>=o)return-1;for(i=Math.max(n>=0?n:o-Math.abs(n),0);i<o;){if(i in r&&r[i]===e)return i;i++}return-1}}),Array.prototype.fill||Object.defineProperty(Array.prototype,"fill",{value:function(e){if(null===this)throw new TypeError("this is null or not defined");for(var t=Object(this),i=t.length>>>0,r=arguments[1],o=r>>0,n=o<0?Math.max(i+o,0):Math.min(o,i),a=arguments[2],l=void 0===a?i:a>>0,s=l<0?Math.max(i+l,0):Math.min(l,i);n<s;)t[n]=e,n++;return t}}),"undefined"==typeof window&&(window="undefined"==typeof global?{}:global);var F=function(){function e(){r(this,e),this._events={},this.addListener=this.on,this.removeListener=this.off}return z(e,[{key:"emit",value:function(e){if(this._events[e]){for(var t=0,i=this._events[e].length,r=arguments.length,o=Array(r>1?r-1:0),n=1;n<r;n++)o[n-1]=arguments[n];for(;t<i;t++)this._events[e][t]&&this._events[e][t].apply(this,o)}}},{key:"once",value:function(e){for(var t=arguments.length,i=Array(t>1?t-1:0),r=1;r<t;r++)i[r-1]=arguments[r];for(var o=0,n=i.length,a=this;o<n;o++)!function(){var t=i[o],r=function i(){a.off(e,i),t.apply(a,arguments)};i[o]=r}();this.on.apply(this,[e].concat(i))}},{key:"on",value:function(e){this._events[e]||(this._events[e]=[]);for(var t=0,i=arguments.length<=1?0:arguments.length-1;t<i;t++)this._events[e].push(arguments.length<=t+1?void 0:arguments[t+1])}},{key:"off",value:function(e){if(this._events[e])for(var t=0,i=arguments.length<=1?0:arguments.length-1;t<i;t++)for(var r=arguments.length<=t+1?void 0:arguments[t+1],o=void 0;~(o=this._events[e].indexOf(r));)this._events[e].splice(o,1)}},{key:"removeAllListeners",value:function(e){delete this._events[e]}},{key:"listeners",get:function(){return this._events}}]),e}(),G=o("requestAnimationFrame")||function(e){return setTimeout(function(){return e((new Date).getTime())},1e3/60)},L={linear:function(e){return e},quad:function(e){return Math.pow(e,2)},dequad:function(e){return 1-L.quad(1-e)},quint:function(e){return Math.pow(e,5)},dequint:function(e){return 1-Math.pow(1-e,5)},cycle:function(e){return 1-Math.sin(Math.acos(e))},decycle:function(e){return Math.sin(Math.acos(1-e))},bounce:function(e){return 1-L.debounce(1-e)},debounce:function(e){for(var t=0,i=1;1;t+=i,i/=2)if(e>=(7-4*t)/11)return-Math.pow((11-6*t-11*e)/4,2)+Math.pow(i,2)},elastic:function(e){return 1-L.delastic(1-e)},delastic:function(e){return Math.pow(2,10*(e-1))*Math.cos(20*Math.PI*1.5/3*e)}},U=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"linear",i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:250,o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:function(){},n=arguments.length>3&&void 0!==arguments[3]?arguments[3]:function(){};if(r(this,e),this.duration=i,this.rule=t,this.draw=o,this.end=n,"function"!=typeof this.draw)throw new TypeError("Invalid animation draw callback:",o);if("function"!=typeof this.end)throw new TypeError("Invalid animation end callback:",n)}return z(e,[{key:"animate",value:function(e,t){var i=this;this.frame&&this.cancel();var r=window.performance&&window.performance.now?window.performance.now():o("animationStartTime")||Date.now();e=e||this.draw,t=t||this.end,this.draw=e,this.end=t,this.frame=G(function(o){return n(o,e,r,L[i.rule]||i.rule,i.duration,t,i)})}},{key:"cancel",value:function(){if(this.frame){(o("cancelAnimationFrame")||function(e){})(this.frame),this.frame=null}}},{key:"destroy",value:function(){this.cancel(),this.draw=null,this.end=null}}]),e}();U.rules=L;var q=function(){function t(i,o,n){r(this,t),this.options=i,this.element=o.toLowerCase(),this.type=t.toDashed(n),this.Type=e[n],this.mutationsObserved=!1,this.isObservable=!!window.MutationObserver,window.GAUGES_NO_AUTO_INIT||t.domReady(this.traverse.bind(this))}return z(t,[{key:"isValidNode",value:function(e){return!(!e.tagName||e.tagName.toLowerCase()!==this.element||e.getAttribute("data-type")!==this.type)}},{key:"traverse",value:function(){for(var e=document.getElementsByTagName(this.element),t=0,i=e.length;t<i;t++)this.process(e[t]);this.isObservable&&!this.mutationsObserved&&(new MutationObserver(this.observe.bind(this)).observe(document.body,{childList:!0,subtree:!0,attributes:!0,characterData:!0,attributeOldValue:!0,characterDataOldValue:!0}),this.mutationsObserved=!0)}},{key:"observe",value:function(e){for(var t=0,i=e.length;t<i;t++){var r=e[t];if("attributes"===r.type&&"data-type"===r.attributeName&&this.isValidNode(r.target)&&r.oldValue!==this.type)setTimeout(this.process.bind(this,r.target));else if(r.addedNodes&&r.addedNodes.length)for(var o=0,n=r.addedNodes.length;o<n;o++)setTimeout(this.process.bind(this,r.addedNodes[o]))}}},{key:"process",value:function(e){var i=this;if(!this.isValidNode(e))return null;var r=void 0,o=JSON.parse(JSON.stringify(this.options)),n=null;for(r in o)if(o.hasOwnProperty(r)){var a=t.toAttributeName(r),l=t.parse(e.getAttribute(a));null!==l&&void 0!==l&&(o[r]=l)}return o.renderTo=e,n=new this.Type(o),n.draw&&n.draw(),this.isObservable?(n.observer=new MutationObserver(function(r){r.forEach(function(r){if("attributes"===r.type){var o=r.attributeName.toLowerCase(),a=e.getAttribute(o).toLowerCase();if("data-type"===o&&a&&a!==i.type)n.observer.disconnect(),delete n.observer,n.destroy&&n.destroy();else if("data-"===o.substr(0,5)){var l=o.substr(5).split("-").map(function(e,t){return t?e.charAt(0).toUpperCase()+e.substr(1):e}).join(""),s={};s[l]=t.parse(e.getAttribute(r.attributeName)),"value"===l?n&&(n.value=s[l]):n.update&&n.update(s)}}})}),n.observer.observe(e,{attributes:!0}),n):n}}],[{key:"parse",value:function(e){if("true"===e)return!0;if("false"===e)return!1;if("undefined"!==e){if("null"===e)return null;if(/^[-+#.\w\d\s]+(?:,[-+#.\w\d\s]*)+$/.test(e))return e.split(",");try{return JSON.parse(e)}catch(e){}return e}}},{key:"toDashed",value:function(e){for(var t=e.split(/(?=[A-Z])/),i=1,r=t.length,o=t[0].toLowerCase();i<r;i++)o+="-"+t[i].toLowerCase();return o}},{key:"toCamelCase",value:function(e){for(var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=e.split(/-/),r=0,o=i.length,n="";r<o;r++)n+=r||t?i[r][0].toUpperCase()+i[r].substr(1).toLowerCase():i[r].toLowerCase();return n}},{key:"toAttributeName",value:function(e){return"data-"+t.toDashed(e)}},{key:"domReady",value:function(e){if(/comp|inter|loaded/.test((window.document||{}).readyState+""))return e();window.addEventListener?window.addEventListener("DOMContentLoaded",e,!1):window.attachEvent&&window.attachEvent("onload",e)}}]),t}(),X=function(){function e(t,i,o){r(this,e),e.collection.push(this),this.width=i||0,this.height=o||0,this.element=t,this.init()}return z(e,[{key:"init",value:function(){var t=e.pixelRatio;this.element.width=this.width*t,this.element.height=this.height*t,this.element.style.width=this.width+"px",this.element.style.height=this.height+"px",this.elementClone=this.element.cloneNode(!0),this.context=this.element.getContext("2d"),this.contextClone=this.elementClone.getContext("2d"),this.drawWidth=this.element.width,this.drawHeight=this.element.height,this.drawX=this.drawWidth/2,this.drawY=this.drawHeight/2,this.minSide=this.drawX<this.drawY?this.drawX:this.drawY,this.elementClone.initialized=!1,this.contextClone.translate(this.drawX,this.drawY),this.contextClone.save(),this.context.translate(this.drawX,this.drawY),this.context.save(),this.context.max=this.contextClone.max=this.minSide,this.context.maxRadius=this.contextClone.maxRadius=null}},{key:"destroy",value:function(){var t=e.collection.indexOf(this);~t&&e.collection.splice(t,1),this.context.clearRect(-this.drawX,-this.drawY,this.drawWidth,this.drawHeight),this.context.max=null,delete this.context.max,this.context.maxRadius=null,delete this.context.maxRadius,this.context=null,this.contextClone=null,this.elementClone=null,this.element=null,this.onRedraw=null}},{key:"commit",value:function(){var t=e.pixelRatio;return 1!==t&&(this.contextClone.scale(t,t),this.contextClone.save()),this}},{key:"redraw",value:function(){return this.init(),this.onRedraw&&this.onRedraw(),this}}],[{key:"redraw",value:function(){for(var t=0,i=e.collection.length;t<i;t++)e.collection[t].redraw()}},{key:"pixelRatio",get:function(){return window.devicePixelRatio||1}}]),e}();X.collection=[],window.matchMedia&&window.matchMedia("screen and (min-resolution: 2dppx)").addListener(X.redraw);var Y={renderTo:null,width:0,height:0,minValue:0,maxValue:100,value:0,units:!1,exactTicks:!1,majorTicks:[0,20,40,60,80,100],minorTicks:10,strokeTicks:!0,animatedValue:!1,animateOnInit:!1,title:!1,borders:!0,numbersMargin:1,listeners:null,valueInt:3,valueDec:2,majorTicksInt:1,majorTicksDec:0,animation:!0,animationDuration:500,animationRule:"cycle",colorPlate:"#fff",colorPlateEnd:"",colorMajorTicks:"#444",colorMinorTicks:"#666",colorStrokeTicks:"",colorTitle:"#888",colorUnits:"#888",colorNumbers:"#444",colorNeedle:"rgba(240,128,128,1)",colorNeedleEnd:"rgba(255,160,122,.9)",colorValueText:"#444",colorValueTextShadow:"rgba(0,0,0,0.3)",colorBorderShadow:"rgba(0,0,0,0.5)",colorBorderOuter:"#ddd",colorBorderOuterEnd:"#aaa",colorBorderMiddle:"#eee",colorBorderMiddleEnd:"#f0f0f0",colorBorderInner:"#fafafa",colorBorderInnerEnd:"#ccc",colorValueBoxRect:"#888",colorValueBoxRectEnd:"#666",colorValueBoxBackground:"#babab2",colorValueBoxShadow:"rgba(0,0,0,1)",colorNeedleShadowUp:"rgba(2,255,255,0.2)",colorNeedleShadowDown:"rgba(188,143,143,0.45)",colorBarStroke:"#222",colorBar:"#ccc",colorBarProgress:"#888",colorBarShadow:"#000",fontNumbers:"Arial",fontTitle:"Arial",fontUnits:"Arial",fontValue:"Arial",fontNumbersSize:20,fontTitleSize:24,fontUnitsSize:22,fontValueSize:26,fontNumbersStyle:"normal",fontTitleStyle:"normal",fontUnitsStyle:"normal",fontValueStyle:"normal",fontNumbersWeight:"normal",fontTitleWeight:"normal",fontUnitsWeight:"normal",fontValueWeight:"normal",needle:!0,needleShadow:!0,needleType:"arrow",needleStart:5,needleEnd:85,needleWidth:4,borderOuterWidth:3,borderMiddleWidth:3,borderInnerWidth:3,borderShadowWidth:3,valueBox:!0,valueBoxStroke:5,valueBoxWidth:0,valueText:"",valueTextShadow:!0,valueBoxBorderRadius:2.5,highlights:[{from:20,to:60,color:"#eee"},{from:60,to:80,color:"#ccc"},{from:80,to:100,color:"#999"}],highlightsWidth:15,barWidth:20,barStrokeWidth:0,barProgress:!0,barShadow:0};a.prototype=Object.create(Array.prototype),a.prototype.constructor=a,a.prototype.get=function(e){if("string"==typeof e)for(var t=0,i=this.length;t<i;t++){var r=this[t].options.renderTo.tagName?this[t].options.renderTo:document.getElementById(this[t].options.renderTo||"");if(r.getAttribute("id")===e)return this[t]}else if("number"==typeof e)return this[e];return null};var H="2.1.5",J=(Math.round,Math.abs),$=new a;$.version=H;var Z=function(o){function n(i){r(this,n);var o=t(this,(n.__proto__||Object.getPrototypeOf(n)).call(this)),a=o.constructor.name;if("BaseGauge"===a)throw new TypeError("Attempt to instantiate abstract class!");if($.push(o),i.listeners&&Object.keys(i.listeners).forEach(function(e){(i.listeners[e]instanceof Array?i.listeners[e]:[i.listeners[e]]).forEach(function(t){o.on(e,t)})}),o.version=H,o.type=e[a]||n,o.initialized=!1,i.minValue=parseFloat(i.minValue),i.maxValue=parseFloat(i.maxValue),i.value=parseFloat(i.value)||0,i.borders||(i.borderInnerWidth=i.borderMiddleWidth=i.borderOuterWidth=0),!i.renderTo)throw TypeError("Canvas element was not specified when creating the Gauge object!");var l=i.renderTo.tagName?i.renderTo:document.getElementById(i.renderTo);if(!(l instanceof HTMLCanvasElement))throw TypeError("Given gauge canvas element is invalid!");return i.width=parseFloat(i.width)||0,i.height=parseFloat(i.height)||0,i.width&&i.height||(i.width||(i.width=l.parentNode?l.parentNode.offsetWidth:l.offsetWidth),i.height||(i.height=l.parentNode?l.parentNode.offsetHeight:l.offsetHeight)),o.options=i||{},o.options.animateOnInit&&(o._value=o.options.value,o.options.value=o.options.minValue),o.canvas=new X(l,i.width,i.height),o.canvas.onRedraw=o.draw.bind(o),o.animation=new U(i.animationRule,i.animationDuration),o}return i(n,o),z(n,[{key:"update",value:function(e){return Object.assign(this.options,this.type.configure(e||{})),this.canvas.width=this.options.width,this.canvas.height=this.options.height,this.animation.rule=this.options.animationRule,this.animation.duration=this.options.animationDuration,this.canvas.redraw(),this}},{key:"destroy",value:function(){var e=$.indexOf(this);~e&&$.splice(e,1),this.canvas.destroy(),this.canvas=null,this.animation.destroy(),this.animation=null,this.emit("destroy")}},{key:"draw",value:function(){return this.options.animateOnInit&&!this.initialized&&(this.value=this._value,this.initialized=!0,this.emit("init")),this.emit("render"),this}},{key:"value",set:function(e){var t=this;e=n.ensureValue(e,this.options.minValue);var i=this.options.value;if(e!==i)if(this.options.animation){if(this.animation.frame&&(this.options.value=this._value,this._value===e))return this.animation.cancel(),void delete this._value;void 0===this._value&&(this._value=e),this.emit("animationStart"),this.animation.animate(function(r){var o=i+(e-i)*r;t.options.animatedValue&&t.emit("value",o,t.value),t.options.value=o,t.draw(),t.emit("animate",r,t.options.value)},function(){void 0!==t._value&&(t.emit("value",t._value,t.value),t.options.value=t._value,delete t._value),t.draw(),t.emit("animationEnd")})}else this.emit("value",e,this.value),this.options.value=e,this.draw()},get:function(){return void 0===this._value?this.options.value:this._value}}],[{key:"configure",value:function(e){return e}},{key:"initialize",value:function(e,t){return new q(t,"canvas",e)}},{key:"fromElement",value:function(e){var t=q.toCamelCase(e.getAttribute("data-type")),i=e.attributes,r=0,o=i.length,n={};if(t){for(/Gauge$/.test(t)||(t+="Gauge");r<o;r++)n[q.toCamelCase(i[r].name.replace(/^data-/,""),!1)]=q.parse(i[r].value);new q(n,e.tagName,t).process(e)}}},{key:"ensureValue",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return e=parseFloat(e),!isNaN(e)&&isFinite(e)||(e=parseFloat(t)||0),e}},{key:"mod",value:function(e,t){return(e%t+t)%t}},{key:"version",get:function(){return H}}]),n}(F);void 0!==e&&(e.BaseGauge=Z,e.gauges=(window.document||{}).gauges=$);var K={roundRect:d,padValue:u,formatMajorTickNumber:c,radians:h,radialPoint:f,linearGradient:v,drawNeedleShadow:p,drawValueBox:y,verifyError:l,prepareTicks:s,drawShadow:m,font:g,normalizedValue:x},Q=Math.PI,ee=Q/2,te=Object.assign({},Y,{ticksAngle:270,startAngle:45,colorNeedleCircleOuter:"#f0f0f0",colorNeedleCircleOuterEnd:"#ccc",colorNeedleCircleInner:"#e8e8e8",colorNeedleCircleInnerEnd:"#f5f5f5",needleCircleSize:10,needleCircleInner:!0,needleCircleOuter:!0,needleStart:20,animationTarget:"needle",useMinPath:!1,barWidth:0}),ie=function(e){function o(e){return r(this,o),e=Object.assign({},te,e||{}),t(this,(o.__proto__||Object.getPrototypeOf(o)).call(this,o.configure(e)))}return i(o,e),z(o,[{key:"draw",value:function(){try{var e=this.canvas,t=[-e.drawX,-e.drawY,e.drawWidth,e.drawHeight],i=t[0],r=t[1],n=t[2],a=t[3],l=this.options;if("needle"===l.animationTarget){if(!e.elementClone.initialized){var s=e.contextClone;s.clearRect(i,r,n,a),s.save(),this.emit("beforePlate"),S(s,l),this.emit("beforeHighlights"),O(s,l),this.emit("beforeMinorTicks"),A(s,l),this.emit("beforeMajorTicks"),V(s,l),this.emit("beforeNumbers"),j(s,l),this.emit("beforeTitle"),M(s,l),this.emit("beforeUnits"),B(s,l),e.elementClone.initialized=!0}this.canvas.commit(),e.context.clearRect(i,r,n,a),e.context.save(),e.context.drawImage(e.elementClone,i,r,n,a),e.context.save(),this.emit("beforeProgressBar"),E(e.context,l),this.emit("beforeValueBox"),_(e.context,l,R(this)),this.emit("beforeNeedle"),W(e.context,l)}else{var d=-K.radians((l.value-l.minValue)/(l.maxValue-l.minValue)*l.ticksAngle);if(e.context.clearRect(i,r,n,a),e.context.save(),this.emit("beforePlate"),S(e.context,l),e.context.rotate(d),this.emit("beforeHighlights"),O(e.context,l),this.emit("beforeMinorTicks"),A(e.context,l),this.emit("beforeMajorTicks"),V(e.context,l),this.emit("beforeNumbers"),j(e.context,l),this.emit("beforeProgressBar"),E(e.context,l),e.context.rotate(-d),e.context.save(),!e.elementClone.initialized){var u=e.contextClone;u.clearRect(i,r,n,a),u.save(),this.emit("beforeTitle"),M(u,l),this.emit("beforeUnits"),B(u,l),this.emit("beforeNeedle"),W(u,l),e.elementClone.initialized=!0}e.context.drawImage(e.elementClone,i,r,n,a)}this.emit("beforeValueBox"),_(e.context,l,R(this)),I(o.prototype.__proto__||Object.getPrototypeOf(o.prototype),"draw",this).call(this)}catch(e){K.verifyError(e)}return this}},{key:"value",set:function(e){e=Z.ensureValue(e,this.options.minValue),this.options.animation&&360===this.options.ticksAngle&&this.options.useMinPath&&(this._value=e,e=this.options.value+((e-this.options.value)%360+540)%360-180),D(o.prototype.__proto__||Object.getPrototypeOf(o.prototype),"value",e,this)},get:function(){return I(o.prototype.__proto__||Object.getPrototypeOf(o.prototype),"value",this)}}],[{key:"configure",value:function(e){return e.barWidth>50&&(e.barWidth=50),isNaN(e.startAngle)&&(e.startAngle=45),isNaN(e.ticksAngle)&&(e.ticksAngle=270),e.ticksAngle>360&&(e.ticksAngle=360),e.ticksAngle<0&&(e.ticksAngle=0),e.startAngle<0&&(e.startAngle=0),e.startAngle>360&&(e.startAngle=360),e}}]),o}(Z);void 0!==e&&(e.RadialGauge=ie),Z.initialize("RadialGauge",te),"undefined"!=typeof module&&Object.assign(e,{Collection:a,GenericOptions:Y,Animation:U,BaseGauge:Z,drawings:K,SmartCanvas:X,DomObserver:q,vendorize:o})}("undefined"!=typeof module?module.exports:window);
/* 
 * Angular JS Multi Select
 * Creates a dropdown-like button with checkboxes. 
 *
 * Project started on: Tue, 14 Jan 2014 - 5:18:02 PM
 * Current version: 4.0.0
 * 
 * Released under the MIT License
 * --------------------------------------------------------------------------------
 * The MIT License (MIT)
 *
 * Copyright (c) 2014 Ignatius Steven (https://github.com/isteven)
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy 
 * of this software and associated documentation files (the "Software"), to deal 
 * in the Software without restriction, including without limitation the rights 
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell 
 * copies of the Software, and to permit persons to whom the Software is 
 * furnished to do so, subject to the following conditions: 
 *
 * The above copyright notice and this permission notice shall be included in all 
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR 
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, 
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE 
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER 
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, 
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE 
 * SOFTWARE.
 * --------------------------------------------------------------------------------
 */

'use strict'

angular.module( 'isteven-multi-select', ['ng'] ).directive( 'istevenMultiSelect' , [ '$sce', '$timeout', '$templateCache', function ( $sce, $timeout, $templateCache ) {
    return {
        restrict: 
            'AE',

        scope: 
        {   
            // models
            inputModel      : '=',
            outputModel     : '=',

            // settings based on attribute
            isDisabled      : '=',

            // callbacks
            onClear         : '&',  
            onClose         : '&',
            onSearchChange  : '&',  
            onItemClick     : '&',            
            onOpen          : '&', 
            onReset         : '&',  
            onSelectAll     : '&',  
            onSelectNone    : '&',  

            // i18n
            translation     : '='   
        },
        
        /* 
         * The rest are attributes. They don't need to be parsed / binded, so we can safely access them by value.
         * - buttonLabel, directiveId, helperElements, itemLabel, maxLabels, orientation, selectionMode, minSearchLength,
         *   tickProperty, disableProperty, groupProperty, searchProperty, maxHeight, outputProperties
         */
                                                         
         templateUrl: 
            'isteven-multi-select.htm',                            

        link: function ( $scope, element, attrs ) {                       

            $scope.backUp           = [];
            $scope.varButtonLabel   = '';               
            $scope.spacingProperty  = '';
            $scope.indexProperty    = '';                        
            $scope.orientationH     = false;
            $scope.orientationV     = true;
            $scope.filteredModel    = [];
            $scope.inputLabel       = { labelFilter: '' };                        
            $scope.tabIndex         = 0;            
            $scope.lang             = {};
            $scope.helperStatus     = {
                all     : true,
                none    : true,
                reset   : true,
                filter  : true
            };

            var 
                prevTabIndex        = 0,
                helperItems         = [],
                helperItemsLength   = 0,
                checkBoxLayer       = '',
                scrolled            = false,
                selectedItems       = [],
                formElements        = [],
                vMinSearchLength    = 0,
                clickedItem         = null                

            // v3.0.0
            // clear button clicked
            $scope.clearClicked = function( e ) {                
                $scope.inputLabel.labelFilter = '';
                $scope.updateFilter();
                $scope.select( 'clear', e );                
            }

            // A little hack so that AngularJS ng-repeat can loop using start and end index like a normal loop
            // http://stackoverflow.com/questions/16824853/way-to-ng-repeat-defined-number-of-times-instead-of-repeating-over-array
            $scope.numberToArray = function( num ) {
                return new Array( num );   
            }

            // Call this function when user type on the filter field
            $scope.searchChanged = function() {                                                
                if ( $scope.inputLabel.labelFilter.length < vMinSearchLength && $scope.inputLabel.labelFilter.length > 0 ) {
                    return false;
                }                
                $scope.updateFilter();
            }

            $scope.updateFilter = function()
            {      
                // we check by looping from end of input-model
                $scope.filteredModel = [];
                var i = 0;

                if ( typeof $scope.inputModel === 'undefined' ) {
                    return false;                   
                }

                for( i = $scope.inputModel.length - 1; i >= 0; i-- ) {

                    // if it's group end, we push it to filteredModel[];
                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.inputModel[ i ][ attrs.groupProperty ] === false ) {
                        $scope.filteredModel.push( $scope.inputModel[ i ] );
                    }
                    
                    // if it's data 
                    var gotData = false;
                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] === 'undefined' ) {                        
                        
                        // If we set the search-key attribute, we use this loop. 
                        if ( typeof attrs.searchProperty !== 'undefined' && attrs.searchProperty !== '' ) {

                            for (var key in $scope.inputModel[ i ]  ) {
                                if ( 
                                    typeof $scope.inputModel[ i ][ key ] !== 'boolean'
                                    && String( $scope.inputModel[ i ][ key ] ).toUpperCase().indexOf( $scope.inputLabel.labelFilter.toUpperCase() ) >= 0                                     
                                    && attrs.searchProperty.indexOf( key ) > -1
                                ) {
                                    gotData = true;
                                    break;
                                }
                            }                        
                        }
                        // if there's no search-key attribute, we use this one. Much better on performance.
                        else {
                            for ( var key in $scope.inputModel[ i ]  ) {
                                if ( 
                                    typeof $scope.inputModel[ i ][ key ] !== 'boolean'
                                    && String( $scope.inputModel[ i ][ key ] ).toUpperCase().indexOf( $scope.inputLabel.labelFilter.toUpperCase() ) >= 0                                     
                                ) {
                                    gotData = true;
                                    break;
                                }
                            }                        
                        }

                        if ( gotData === true ) {    
                            // push
                            $scope.filteredModel.push( $scope.inputModel[ i ] );
                        }
                    }

                    // if it's group start
                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.inputModel[ i ][ attrs.groupProperty ] === true ) {

                        if ( typeof $scope.filteredModel[ $scope.filteredModel.length - 1 ][ attrs.groupProperty ] !== 'undefined' 
                                && $scope.filteredModel[ $scope.filteredModel.length - 1 ][ attrs.groupProperty ] === false ) {
                            $scope.filteredModel.pop();
                        }
                        else {
                            $scope.filteredModel.push( $scope.inputModel[ i ] );
                        }
                    }
                }                

                $scope.filteredModel.reverse();  
                
                $timeout( function() {                    

                    $scope.getFormElements();               
                    
                    // Callback: on filter change                      
                    if ( $scope.inputLabel.labelFilter.length > vMinSearchLength ) {

                        var filterObj = [];

                        angular.forEach( $scope.filteredModel, function( value, key ) {
                            if ( typeof value !== 'undefined' ) {                   
                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {                                                                    
                                    var tempObj = angular.copy( value );
                                    var index = filterObj.push( tempObj );                                
                                    delete filterObj[ index - 1 ][ $scope.indexProperty ];
                                    delete filterObj[ index - 1 ][ $scope.spacingProperty ];      
                                }
                            }
                        });

                        $scope.onSearchChange({ 
                            data: 
                            {
                                keyword: $scope.inputLabel.labelFilter, 
                                result: filterObj 
                            } 
                        });
                    }
                },0);
            };

            // List all the input elements. We need this for our keyboard navigation.
            // This function will be called everytime the filter is updated. 
            // Depending on the size of filtered mode, might not good for performance, but oh well..
            $scope.getFormElements = function() {                                     
                formElements = [];

                var 
                    selectButtons   = [],
                    inputField      = [],
                    checkboxes      = [],
                    clearButton     = [];
                
                // If available, then get select all, select none, and reset buttons
                if ( $scope.helperStatus.all || $scope.helperStatus.none || $scope.helperStatus.reset ) {                                                       
                    selectButtons = element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'button' );                    
                    // If available, then get the search box and the clear button
                    if ( $scope.helperStatus.filter ) {                                            
                        // Get helper - search and clear button. 
                        inputField =    element.children().children().next().children().children().next()[ 0 ].getElementsByTagName( 'input' );                    
                        clearButton =   element.children().children().next().children().children().next()[ 0 ].getElementsByTagName( 'button' );                        
                    }
                }
                else {
                    if ( $scope.helperStatus.filter ) {   
                        // Get helper - search and clear button. 
                        inputField =    element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'input' );                    
                        clearButton =   element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'button' );
                    }
                }
               
                // Get checkboxes
                if ( !$scope.helperStatus.all && !$scope.helperStatus.none && !$scope.helperStatus.reset && !$scope.helperStatus.filter ) {
                    checkboxes = element.children().children().next()[ 0 ].getElementsByTagName( 'input' );
                }
                else {
                    checkboxes = element.children().children().next().children().next()[ 0 ].getElementsByTagName( 'input' );
                }

                // Push them into global array formElements[] 
                for ( var i = 0; i < selectButtons.length ; i++ )   { formElements.push( selectButtons[ i ] );  }
                for ( var i = 0; i < inputField.length ; i++ )      { formElements.push( inputField[ i ] );     }
                for ( var i = 0; i < clearButton.length ; i++ )     { formElements.push( clearButton[ i ] );    }
                for ( var i = 0; i < checkboxes.length ; i++ )      { formElements.push( checkboxes[ i ] );     }                                
            }            

            // check if an item has attrs.groupProperty (be it true or false)
            $scope.isGroupMarker = function( item , type ) {
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === type ) return true; 
                return false;
            }

            $scope.removeGroupEndMarker = function( item ) {
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === false ) return false; 
                return true;
            }                       

            // call this function when an item is clicked
            $scope.syncItems = function( item, e, ng_repeat_index ) {                                      

                e.preventDefault();
                e.stopPropagation();

                // if the directive is globaly disabled, do nothing
                if ( typeof attrs.disableProperty !== 'undefined' && item[ attrs.disableProperty ] === true ) {                                        
                    return false;
                }

                // if item is disabled, do nothing
                if ( typeof attrs.isDisabled !== 'undefined' && $scope.isDisabled === true ) {                        
                    return false;
                }                                

                // if end group marker is clicked, do nothing
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === false ) {
                    return false;
                }                

                var index = $scope.filteredModel.indexOf( item );       

                // if the start of group marker is clicked ( only for multiple selection! )
                // how it works:
                // - if, in a group, there are items which are not selected, then they all will be selected
                // - if, in a group, all items are selected, then they all will be de-selected                
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === true ) {                                  

                    // this is only for multiple selection, so if selection mode is single, do nothing
                    if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
                        return false;
                    }
                    
                    var i,j,k;
                    var startIndex = 0;
                    var endIndex = $scope.filteredModel.length - 1;
                    var tempArr = [];

                    // nest level is to mark the depth of the group.
                    // when you get into a group (start group marker), nestLevel++
                    // when you exit a group (end group marker), nextLevel--
                    var nestLevel = 0;                    

                    // we loop throughout the filtered model (not whole model)
                    for( i = index ; i < $scope.filteredModel.length ; i++) {  

                        // this break will be executed when we're done processing each group
                        if ( nestLevel === 0 && i > index ) 
                        {
                            break;
                        }
                    
                        if ( typeof $scope.filteredModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.filteredModel[ i ][ attrs.groupProperty ] === true ) {
                            
                            // To cater multi level grouping
                            if ( tempArr.length === 0 ) {
                                startIndex = i + 1; 
                            }                            
                            nestLevel = nestLevel + 1;
                        }                                                

                        // if group end
                        else if ( typeof $scope.filteredModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.filteredModel[ i ][ attrs.groupProperty ] === false ) {

                            nestLevel = nestLevel - 1;                            

                            // cek if all are ticked or not                            
                            if ( tempArr.length > 0 && nestLevel === 0 ) {                                

                                var allTicked = true;       

                                endIndex = i;

                                for ( j = 0; j < tempArr.length ; j++ ) {                                
                                    if ( typeof tempArr[ j ][ $scope.tickProperty ] !== 'undefined' &&  tempArr[ j ][ $scope.tickProperty ] === false ) {
                                        allTicked = false;
                                        break;
                                    }
                                }                                                                                    

                                if ( allTicked === true ) {
                                    for ( j = startIndex; j <= endIndex ; j++ ) {
                                        if ( typeof $scope.filteredModel[ j ][ attrs.groupProperty ] === 'undefined' ) {
                                            if ( typeof attrs.disableProperty === 'undefined' ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = false;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = false;
                                            }
                                            else if ( $scope.filteredModel[ j ][ attrs.disableProperty ] !== true ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = false;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = false;
                                            }
                                        }
                                    }                                
                                }

                                else {
                                    for ( j = startIndex; j <= endIndex ; j++ ) {
                                        if ( typeof $scope.filteredModel[ j ][ attrs.groupProperty ] === 'undefined' ) {
                                            if ( typeof attrs.disableProperty === 'undefined' ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = true;                                                
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = true;

                                            }                                            
                                            else if ( $scope.filteredModel[ j ][ attrs.disableProperty ] !== true ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = true;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = true;
                                            }
                                        }
                                    }                                
                                }                                                                                    
                            }
                        }
            
                        // if data
                        else {                            
                            tempArr.push( $scope.filteredModel[ i ] );                                                                                    
                        }
                    }                                 
                }

                // if an item (not group marker) is clicked
                else {

                    // If it's single selection mode
                    if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
                        
                        // first, set everything to false
                        for( i=0 ; i < $scope.filteredModel.length ; i++) {                            
                            $scope.filteredModel[ i ][ $scope.tickProperty ] = false;                            
                        }        
                        for( i=0 ; i < $scope.inputModel.length ; i++) {                            
                            $scope.inputModel[ i ][ $scope.tickProperty ] = false;                            
                        }        
                        
                        // then set the clicked item to true
                        $scope.filteredModel[ index ][ $scope.tickProperty ] = true;                                                                 
                    }   

                    // Multiple
                    else {
                        $scope.filteredModel[ index ][ $scope.tickProperty ]   = !$scope.filteredModel[ index ][ $scope.tickProperty ];
                    }

                    // we refresh input model as well
                    var inputModelIndex = $scope.filteredModel[ index ][ $scope.indexProperty ];                                        
                    $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = $scope.filteredModel[ index ][ $scope.tickProperty ];                    
                }                                  

                // we execute the callback function here
                clickedItem = angular.copy( item );                                                    
                if ( clickedItem !== null ) {                        
                    $timeout( function() {
                        delete clickedItem[ $scope.indexProperty ];
                        delete clickedItem[ $scope.spacingProperty ];      
                        $scope.onItemClick( { data: clickedItem } );
                        clickedItem = null;                    
                    }, 0 );                                                 
                }                                    
                
                $scope.refreshOutputModel();
                $scope.refreshButton();                              

                // We update the index here
                prevTabIndex = $scope.tabIndex;
                $scope.tabIndex = ng_repeat_index + helperItemsLength;
                                
                // Set focus on the hidden checkbox 
                e.target.focus();

                // set & remove CSS style
                $scope.removeFocusStyle( prevTabIndex );
                $scope.setFocusStyle( $scope.tabIndex );

                if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
                    // on single selection mode, we then hide the checkbox layer
                    $scope.toggleCheckboxes( e );       
                }
            }     

            // update $scope.outputModel
            $scope.refreshOutputModel = function() {            
                
                $scope.outputModel  = [];
                var 
                    outputProps     = [],
                    tempObj         = {};

                // v4.0.0
                if ( typeof attrs.outputProperties !== 'undefined' ) {                    
                    outputProps = attrs.outputProperties.split(' ');                
                    angular.forEach( $scope.inputModel, function( value, key ) {                    
                        if ( 
                            typeof value !== 'undefined' 
                            && typeof value[ attrs.groupProperty ] === 'undefined' 
                            && value[ $scope.tickProperty ] === true 
                        ) {
                            tempObj         = {};
                            angular.forEach( value, function( value1, key1 ) {                                
                                if ( outputProps.indexOf( key1 ) > -1 ) {                                                                         
                                    tempObj[ key1 ] = value1;                                    
                                }
                            });
                            var index = $scope.outputModel.push( tempObj );                                                               
                            delete $scope.outputModel[ index - 1 ][ $scope.indexProperty ];
                            delete $scope.outputModel[ index - 1 ][ $scope.spacingProperty ];                                      
                        }
                    });         
                }
                else {
                    angular.forEach( $scope.inputModel, function( value, key ) {                    
                        if ( 
                            typeof value !== 'undefined' 
                            && typeof value[ attrs.groupProperty ] === 'undefined' 
                            && value[ $scope.tickProperty ] === true 
                        ) {
                            var temp = angular.copy( value );
                            var index = $scope.outputModel.push( temp );                                                               
                            delete $scope.outputModel[ index - 1 ][ $scope.indexProperty ];
                            delete $scope.outputModel[ index - 1 ][ $scope.spacingProperty ];                                      
                        }
                    });         
                }
            }

            // refresh button label
            $scope.refreshButton = function() {

                $scope.varButtonLabel   = '';                
                var ctr                 = 0;                  

                // refresh button label...
                if ( $scope.outputModel.length === 0 ) {
                    // https://github.com/isteven/angular-multi-select/pull/19                    
                    $scope.varButtonLabel = $scope.lang.nothingSelected;
                }
                else {                
                    var tempMaxLabels = $scope.outputModel.length;
                    if ( typeof attrs.maxLabels !== 'undefined' && attrs.maxLabels !== '' ) {
                        tempMaxLabels = attrs.maxLabels;
                    }

                    // if max amount of labels displayed..
                    if ( $scope.outputModel.length > tempMaxLabels ) {
                        $scope.more = true;
                    }
                    else {
                        $scope.more = false;
                    }                
                    
                    angular.forEach( $scope.inputModel, function( value, key ) {
                        if ( typeof value !== 'undefined' && value[ attrs.tickProperty ] === true ) {                        
                            if ( ctr < tempMaxLabels ) {                            
                                $scope.varButtonLabel += ( $scope.varButtonLabel.length > 0 ? '</div>, <div class="buttonLabel">' : '<div class="buttonLabel">') + $scope.writeLabel( value, 'buttonLabel' );
                            }
                            ctr++;
                        }
                    });                

                    if ( $scope.more === true ) {
                        // https://github.com/isteven/angular-multi-select/pull/16
                        if (tempMaxLabels > 0) {
                            $scope.varButtonLabel += ', ... ';
                        }
                        $scope.varButtonLabel += '(' + $scope.outputModel.length + ')';                        
                    }
                }
                $scope.varButtonLabel = $sce.trustAsHtml( $scope.varButtonLabel + '<span class="caret"></span>' );                
            }

            // Check if a checkbox is disabled or enabled. It will check the granular control (disableProperty) and global control (isDisabled)
            // Take note that the granular control has higher priority.
            $scope.itemIsDisabled = function( item ) {
                
                if ( typeof attrs.disableProperty !== 'undefined' && item[ attrs.disableProperty ] === true ) {                                        
                    return true;
                }
                else {             
                    if ( $scope.isDisabled === true ) {                        
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                
            }

            // A simple function to parse the item label settings. Used on the buttons and checkbox labels.
            $scope.writeLabel = function( item, type ) {
                
                // type is either 'itemLabel' or 'buttonLabel'
                var temp    = attrs[ type ].split( ' ' );                    
                var label   = '';                

                angular.forEach( temp, function( value, key ) {                    
                    item[ value ] && ( label += '&nbsp;' + value.split( '.' ).reduce( function( prev, current ) {
                        return prev[ current ]; 
                    }, item ));        
                });
                
                if ( type.toUpperCase() === 'BUTTONLABEL' ) {                    
                    return label;
                }
                return $sce.trustAsHtml( label );
            }                                

            // UI operations to show/hide checkboxes based on click event..
            $scope.toggleCheckboxes = function( e ) {                                    
                
                // We grab the button
                var clickedEl = element.children()[0];

                // Just to make sure.. had a bug where key events were recorded twice
                angular.element( document ).off( 'click', $scope.externalClickListener );
                angular.element( document ).off( 'keydown', $scope.keyboardListener );        

                // The idea below was taken from another multi-select directive - https://github.com/amitava82/angular-multiselect 
                // His version is awesome if you need a more simple multi-select approach.                                

                // close
                if ( angular.element( checkBoxLayer ).hasClass( 'show' )) {                         

                    angular.element( checkBoxLayer ).removeClass( 'show' );                    
                    angular.element( clickedEl ).removeClass( 'buttonClicked' );                    
                    angular.element( document ).off( 'click', $scope.externalClickListener );
                    angular.element( document ).off( 'keydown', $scope.keyboardListener );                                    

                    // clear the focused element;
                    $scope.removeFocusStyle( $scope.tabIndex );
                    if ( typeof formElements[ $scope.tabIndex ] !== 'undefined' ) {
                        formElements[ $scope.tabIndex ].blur();
                    }

                    // close callback
                    $timeout( function() {
                        $scope.onClose();
                    }, 0 );

                    // set focus on button again
                    element.children().children()[ 0 ].focus();
                } 
                // open
                else                 
                {    
                    // clear filter
                    $scope.inputLabel.labelFilter = '';                
                    $scope.updateFilter();                                

                    helperItems = [];
                    helperItemsLength = 0;

                    angular.element( checkBoxLayer ).addClass( 'show' );
                    angular.element( clickedEl ).addClass( 'buttonClicked' );       

                    // Attach change event listener on the input filter. 
                    // We need this because ng-change is apparently not an event listener.                    
                    angular.element( document ).on( 'click', $scope.externalClickListener );
                    angular.element( document ).on( 'keydown', $scope.keyboardListener );  

                    // to get the initial tab index, depending on how many helper elements we have. 
                    // priority is to always focus it on the input filter                                                                
                    $scope.getFormElements();
                    $scope.tabIndex = 0;

                    var helperContainer = angular.element( element[ 0 ].querySelector( '.helperContainer' ) )[0];                
                    
                    if ( typeof helperContainer !== 'undefined' ) {
                        for ( var i = 0; i < helperContainer.getElementsByTagName( 'BUTTON' ).length ; i++ ) {
                            helperItems[ i ] = helperContainer.getElementsByTagName( 'BUTTON' )[ i ];
                        }
                        helperItemsLength = helperItems.length + helperContainer.getElementsByTagName( 'INPUT' ).length;
                    }
                    
                    // focus on the filter element on open. 
                    if ( element[ 0 ].querySelector( '.inputFilter' ) ) {                        
                        element[ 0 ].querySelector( '.inputFilter' ).focus();    
                        $scope.tabIndex = $scope.tabIndex + helperItemsLength - 2;
                        // blur button in vain
                        angular.element( element ).children()[ 0 ].blur();
                    }
                    // if there's no filter then just focus on the first checkbox item
                    else {                  
                        if ( !$scope.isDisabled ) {                        
                            $scope.tabIndex = $scope.tabIndex + helperItemsLength;
                            if ( $scope.inputModel.length > 0 ) {
                                formElements[ $scope.tabIndex ].focus();
                                $scope.setFocusStyle( $scope.tabIndex );
                                // blur button in vain
                                angular.element( element ).children()[ 0 ].blur();
                            }                            
                        }
                    }                          

                    // open callback
                    $scope.onOpen();
                }                            
            }
            
            // handle clicks outside the button / multi select layer
            $scope.externalClickListener = function( e ) {                   

                var targetsArr = element.find( e.target.tagName );
                for (var i = 0; i < targetsArr.length; i++) {                                        
                    if ( e.target == targetsArr[i] ) {
                        return;
                    }
                }

                angular.element( checkBoxLayer.previousSibling ).removeClass( 'buttonClicked' );                    
                angular.element( checkBoxLayer ).removeClass( 'show' );
                angular.element( document ).off( 'click', $scope.externalClickListener ); 
                angular.element( document ).off( 'keydown', $scope.keyboardListener );                
                
                // close callback                
                $timeout( function() {
                    $scope.onClose();
                }, 0 );

                // set focus on button again
                element.children().children()[ 0 ].focus();
            }
   
            // select All / select None / reset buttons
            $scope.select = function( type, e ) {

                var helperIndex = helperItems.indexOf( e.target );
                $scope.tabIndex = helperIndex;

                switch( type.toUpperCase() ) {
                    case 'ALL':
                        angular.forEach( $scope.filteredModel, function( value, key ) {                            
                            if ( typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {                                
                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {                                
                                    value[ $scope.tickProperty ] = true;
                                }
                            }
                        });                            
                        $scope.refreshOutputModel();                                    
                        $scope.refreshButton();                                                  
                        $scope.onSelectAll();                                                
                        break;
                    case 'NONE':
                        angular.forEach( $scope.filteredModel, function( value, key ) {
                            if ( typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {                        
                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {                                
                                    value[ $scope.tickProperty ] = false;
                                }
                            }
                        });               
                        $scope.refreshOutputModel();                                    
                        $scope.refreshButton();                                                                          
                        $scope.onSelectNone();                        
                        break;
                    case 'RESET':            
                        angular.forEach( $scope.filteredModel, function( value, key ) {                            
                            if ( typeof value[ attrs.groupProperty ] === 'undefined' && typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {                        
                                var temp = value[ $scope.indexProperty ];                                
                                value[ $scope.tickProperty ] = $scope.backUp[ temp ][ $scope.tickProperty ];
                            }
                        });               
                        $scope.refreshOutputModel();                                    
                        $scope.refreshButton();                                                                          
                        $scope.onReset();                        
                        break;
                    case 'CLEAR':
                        $scope.tabIndex = $scope.tabIndex + 1;
                        $scope.onClear();    
                        break;
                    case 'FILTER':                        
                        $scope.tabIndex = helperItems.length - 1;
                        break;
                    default:                        
                }                                                                                 
            }            

            // just to create a random variable name                
            function genRandomString( length ) {                
                var possible    = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
                var temp        = '';
                for( var i=0; i < length; i++ ) {
                     temp += possible.charAt( Math.floor( Math.random() * possible.length ));
                }
                return temp;
            }

            // count leading spaces
            $scope.prepareGrouping = function() {
                var spacing     = 0;                                                
                angular.forEach( $scope.filteredModel, function( value, key ) {
                    value[ $scope.spacingProperty ] = spacing;                    
                    if ( value[ attrs.groupProperty ] === true ) {
                        spacing+=2;
                    }                    
                    else if ( value[ attrs.groupProperty ] === false ) {
                        spacing-=2;
                    }                 
                });
            }

            // prepare original index
            $scope.prepareIndex = function() {
                var ctr = 0;
                angular.forEach( $scope.filteredModel, function( value, key ) {
                    value[ $scope.indexProperty ] = ctr;
                    ctr++;
                });
            }

            // navigate using up and down arrow
            $scope.keyboardListener = function( e ) { 
                
                var key = e.keyCode ? e.keyCode : e.which;      
                var isNavigationKey = false;                                                

                // ESC key (close)
                if ( key === 27 ) {
                    e.preventDefault();                   
                    e.stopPropagation();
                    $scope.toggleCheckboxes( e );
                }                    
                
                
                // next element ( tab, down & right key )                    
                else if ( key === 40 || key === 39 || ( !e.shiftKey && key == 9 ) ) {                    
                    
                    isNavigationKey = true;
                    prevTabIndex = $scope.tabIndex; 
                    $scope.tabIndex++;                         
                    if ( $scope.tabIndex > formElements.length - 1 ) {
                        $scope.tabIndex = 0;
                        prevTabIndex = formElements.length - 1; 
                    }                                                            
                    while ( formElements[ $scope.tabIndex ].disabled === true ) {
                        $scope.tabIndex++;
                        if ( $scope.tabIndex > formElements.length - 1 ) {
                            $scope.tabIndex = 0;                            
                        }                                                                                    
                        if ( $scope.tabIndex === prevTabIndex ) {
                            break;
                        }
                    }              
                }
                  
                // prev element ( shift+tab, up & left key )
                else if ( key === 38 || key === 37 || ( e.shiftKey && key == 9 ) ) { 
                    isNavigationKey = true;
                    prevTabIndex = $scope.tabIndex; 
                    $scope.tabIndex--;                              
                    if ( $scope.tabIndex < 0 ) {
                        $scope.tabIndex = formElements.length - 1;
                        prevTabIndex = 0;
                    }                                         
                    while ( formElements[ $scope.tabIndex ].disabled === true ) {                        
                        $scope.tabIndex--;
                        if ( $scope.tabIndex === prevTabIndex ) {
                            break;
                        }                                            
                        if ( $scope.tabIndex < 0 ) {
                            $scope.tabIndex = formElements.length - 1;
                        }                             
                    }                                                     
                }                    

                if ( isNavigationKey === true ) {                                         
                    
                    e.preventDefault();

                    // set focus on the checkbox                    
                    formElements[ $scope.tabIndex ].focus();    
                    var actEl = document.activeElement;                     
                    
                    if ( actEl.type.toUpperCase() === 'CHECKBOX' ) {                                                   
                        $scope.setFocusStyle( $scope.tabIndex );
                        $scope.removeFocusStyle( prevTabIndex );
                    }                    
                    else {
                        $scope.removeFocusStyle( prevTabIndex );
                        $scope.removeFocusStyle( helperItemsLength );
                        $scope.removeFocusStyle( formElements.length - 1 );
                    } 
                }                

                isNavigationKey = false;
            }

            // set (add) CSS style on selected row
            $scope.setFocusStyle = function( tabIndex ) {                                
                angular.element( formElements[ tabIndex ] ).parent().parent().parent().addClass( 'multiSelectFocus' );                        
            }

            // remove CSS style on selected row
            $scope.removeFocusStyle = function( tabIndex ) {                
                angular.element( formElements[ tabIndex ] ).parent().parent().parent().removeClass( 'multiSelectFocus' );
            }

            /*********************
             *********************             
             *
             * 1) Initializations
             *
             *********************
             *********************/

            // attrs to $scope - attrs-$scope - attrs - $scope
            // Copy some properties that will be used on the template. They need to be in the $scope.
            $scope.groupProperty    = attrs.groupProperty;   
            $scope.tickProperty     = attrs.tickProperty;
            $scope.directiveId      = attrs.directiveId;
            
            // Unfortunately I need to add these grouping properties into the input model
            var tempStr = genRandomString( 5 );
            $scope.indexProperty = 'idx_' + tempStr;
            $scope.spacingProperty = 'spc_' + tempStr;         

            // set orientation css            
            if ( typeof attrs.orientation !== 'undefined' ) {

                if ( attrs.orientation.toUpperCase() === 'HORIZONTAL' ) {                    
                    $scope.orientationH = true;
                    $scope.orientationV = false;
                }
                else 
                {
                    $scope.orientationH = false;
                    $scope.orientationV = true;
                }
            }            

            // get elements required for DOM operation
            checkBoxLayer = element.children().children().next()[0];

            // set max-height property if provided
            if ( typeof attrs.maxHeight !== 'undefined' ) {                
                var layer = element.children().children().children()[0];
                angular.element( layer ).attr( "style", "height:" + attrs.maxHeight + "; overflow-y:scroll;" );                                
            }

            // some flags for easier checking            
            for ( var property in $scope.helperStatus ) {
                if ( $scope.helperStatus.hasOwnProperty( property )) {                    
                    if ( 
                        typeof attrs.helperElements !== 'undefined' 
                        && attrs.helperElements.toUpperCase().indexOf( property.toUpperCase() ) === -1 
                    ) {
                        $scope.helperStatus[ property ] = false;
                    }
                }
            }
            if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' )  {
                $scope.helperStatus[ 'all' ] = false;
                $scope.helperStatus[ 'none' ] = false;
            }

            // helper button icons.. I guess you can use html tag here if you want to. 
            $scope.icon        = {};            
            $scope.icon.selectAll  = '&#10003;';    // a tick icon
            $scope.icon.selectNone = '&times;';     // x icon
            $scope.icon.reset      = '&#8630;';     // undo icon            
            // this one is for the selected items
            $scope.icon.tickMark   = '&#10003;';    // a tick icon 

            // configurable button labels                       
            if ( typeof attrs.translation !== 'undefined' ) {
                $scope.lang.selectAll       = $sce.trustAsHtml( $scope.icon.selectAll  + '&nbsp;&nbsp;' + $scope.translation.selectAll );
                $scope.lang.selectNone      = $sce.trustAsHtml( $scope.icon.selectNone + '&nbsp;&nbsp;' + $scope.translation.selectNone );
                $scope.lang.reset           = $sce.trustAsHtml( $scope.icon.reset      + '&nbsp;&nbsp;' + $scope.translation.reset );
                $scope.lang.search          = $scope.translation.search;                
                $scope.lang.nothingSelected = $sce.trustAsHtml( $scope.translation.nothingSelected );                
            }
            else {
                $scope.lang.selectAll       = $sce.trustAsHtml( $scope.icon.selectAll  + '&nbsp;&nbsp;Select All' );                
                $scope.lang.selectNone      = $sce.trustAsHtml( $scope.icon.selectNone + '&nbsp;&nbsp;Select None' );
                $scope.lang.reset           = $sce.trustAsHtml( $scope.icon.reset      + '&nbsp;&nbsp;Reset' );
                $scope.lang.search          = 'Search...';
                $scope.lang.nothingSelected = 'None Selected';                
            }
            $scope.icon.tickMark = $sce.trustAsHtml( $scope.icon.tickMark );
                
            // min length of keyword to trigger the filter function
            if ( typeof attrs.MinSearchLength !== 'undefined' && parseInt( attrs.MinSearchLength ) > 0 ) {
                vMinSearchLength = Math.floor( parseInt( attrs.MinSearchLength ) );
            }

            /*******************************************************
             *******************************************************
             *
             * 2) Logic starts here, initiated by watch 1 & watch 2
             *
             *******************************************************
             *******************************************************/
            
            // watch1, for changes in input model property
            // updates multi-select when user select/deselect a single checkbox programatically
            // https://github.com/isteven/angular-multi-select/issues/8            
            $scope.$watch( 'inputModel' , function( newVal ) {                                 
                if ( newVal ) {                            
                    $scope.refreshOutputModel();                                    
                    $scope.refreshButton();                                                  
                }
            }, true );
            
            // watch2 for changes in input model as a whole
            // this on updates the multi-select when a user load a whole new input-model. We also update the $scope.backUp variable
            $scope.$watch( 'inputModel' , function( newVal ) {  
                if ( newVal ) {
                    $scope.backUp = angular.copy( $scope.inputModel );    
                    $scope.updateFilter();
                    $scope.prepareGrouping();
                    $scope.prepareIndex();                                                              
                    $scope.refreshOutputModel();                
                    $scope.refreshButton();                                                                                                                 
                }
            });                        

            // watch for changes in directive state (disabled or enabled)
            $scope.$watch( 'isDisabled' , function( newVal ) {         
                $scope.isDisabled = newVal;                               
            });            
            
            // this is for touch enabled devices. We don't want to hide checkboxes on scroll. 
            var onTouchStart = function( e ) { 
            	$scope.$apply( function() {
            		$scope.scrolled = false;
            	}); 
            };
            angular.element( document ).bind( 'touchstart', onTouchStart);
            var onTouchMove = function( e ) { 
            	$scope.$apply( function() {
            		$scope.scrolled = true;                
            	});
            };
            angular.element( document ).bind( 'touchmove', onTouchMove);            

            // unbind document events to prevent memory leaks
            $scope.$on( '$destroy', function () {
			    angular.element( document ).unbind( 'touchstart', onTouchStart);
            	angular.element( document ).unbind( 'touchmove', onTouchMove);
            });
        }
    }
}]).run( [ '$templateCache' , function( $templateCache ) {
    var template = 
        '<span class="multiSelect inlineBlock">' +
            // main button
            '<button id="{{directiveId}}" type="button"' +                
                'ng-click="toggleCheckboxes( $event ); refreshSelectedItems(); refreshButton(); prepareGrouping; prepareIndex();"' +
                'ng-bind-html="varButtonLabel"' +
                'ng-disabled="disable-button"' +
            '>' +
            '</button>' +
            // overlay layer
            '<div class="checkboxLayer">' +
                // container of the helper elements
                '<div class="helperContainer" ng-if="helperStatus.filter || helperStatus.all || helperStatus.none || helperStatus.reset ">' +
                    // container of the first 3 buttons, select all, none and reset
                    '<div class="line" ng-if="helperStatus.all || helperStatus.none || helperStatus.reset ">' +
                        // select all
                        '<button type="button" class="helperButton"' +
                            'ng-disabled="isDisabled"' + 
                            'ng-if="helperStatus.all"' +
                            'ng-click="select( \'all\', $event );"' +
                            'ng-bind-html="lang.selectAll">' +
                        '</button>'+
                        // select none
                        '<button type="button" class="helperButton"' +
                            'ng-disabled="isDisabled"' + 
                            'ng-if="helperStatus.none"' +
                            'ng-click="select( \'none\', $event );"' +
                            'ng-bind-html="lang.selectNone">' +
                        '</button>'+
                        // reset
                        '<button type="button" class="helperButton reset"' +
                            'ng-disabled="isDisabled"' + 
                            'ng-if="helperStatus.reset"' +
                            'ng-click="select( \'reset\', $event );"' +
                            'ng-bind-html="lang.reset">'+
                        '</button>' +
                    '</div>' +
                    // the search box
                    '<div class="line" style="position:relative" ng-if="helperStatus.filter">'+
                        // textfield                
                        '<input placeholder="{{lang.search}}" type="text"' +
                            'ng-click="select( \'filter\', $event )" '+
                            'ng-model="inputLabel.labelFilter" '+
                            'ng-change="searchChanged()" class="inputFilter"'+
                            '/>'+
                        // clear button
                        '<button type="button" class="clearButton" ng-click="clearClicked( $event )" >×</button> '+
                    '</div> '+
                '</div> '+
                // selection items
                '<div class="checkBoxContainer">'+
                    '<div '+
                        'ng-repeat="item in filteredModel | filter:removeGroupEndMarker" class="multiSelectItem"'+
                        'ng-class="{selected: item[ tickProperty ], horizontal: orientationH, vertical: orientationV, multiSelectGroup:item[ groupProperty ], disabled:itemIsDisabled( item )}"'+
                        'ng-click="syncItems( item, $event, $index );" '+
                        'ng-mouseleave="removeFocusStyle( tabIndex );"> '+
                        // this is the spacing for grouped items
                        '<div class="acol" ng-if="item[ spacingProperty ] > 0" ng-repeat="i in numberToArray( item[ spacingProperty ] ) track by $index">'+                        
                    '</div>  '+        
                    '<div class="acol">'+
                        '<label>'+                                
                            // input, so that it can accept focus on keyboard click
                            '<input class="checkbox focusable" type="checkbox" '+
                                'ng-disabled="itemIsDisabled( item )" '+
                                'ng-checked="item[ tickProperty ]" '+
                                'ng-click="syncItems( item, $event, $index )" />'+
                            // item label using ng-bind-hteml
                            '<span '+
                                'ng-class="{disabled:itemIsDisabled( item )}" '+
                                'ng-bind-html="writeLabel( item, \'itemLabel\' )">'+
                            '</span>'+
                        '</label>'+
                    '</div>'+
                    // the tick/check mark
                    '<span class="tickMark" ng-if="item[ groupProperty ] !== true && item[ tickProperty ] === true" ng-bind-html="icon.tickMark"></span>'+
                '</div>'+
            '</div>'+
        '</div>'+
    '</span>';
	$templateCache.put( 'isteven-multi-select.htm' , template );
}]); 

(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
(function (global){(function (){
var smooth = require('chaikin-smooth');
global.window.smooth = smooth;
}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"chaikin-smooth":2}],2:[function(require,module,exports){
var copy = require('vec2-copy')

module.exports = function(input, output) {
    if (!Array.isArray(output))
        output = []

    if (input.length>0)
        output.push(copy([0, 0], input[0]))
    for (var i=0; i<input.length-1; i++) {
        var p0 = input[i]
        var p1 = input[i+1]
        var p0x = p0[0],
            p0y = p0[1],
            p1x = p1[0],
            p1y = p1[1]

        var Q = [ 0.75 * p0x + 0.25 * p1x, 0.75 * p0y + 0.25 * p1y ]
        var R = [ 0.25 * p0x + 0.75 * p1x, 0.25 * p0y + 0.75 * p1y ]
        output.push(Q)
        output.push(R)
    }
    if (input.length > 1)
        output.push(copy([0, 0], input[ input.length-1 ]))
    return output
}
},{"vec2-copy":3}],3:[function(require,module,exports){
module.exports = function vec2Copy(out, a) {
    out[0] = a[0]
    out[1] = a[1]
    return out
}
},{}]},{},[1]);

!function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a="function"==typeof require&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}for(var i="function"==typeof require&&require,o=0;o<r.length;o++)s(r[o]);return s}({1:[function(require,module,exports){"use strict";function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}Object.defineProperty(exports,"__esModule",{value:!0});var _metergauge=require("./metergauge.link"),_metergauge2=_interopRequireDefault(_metergauge),meterGaugeComponent=function(){return{restrict:"E",scope:{gaugeconfig:"="},link:_metergauge2.default}};exports.default=meterGaugeComponent},{"./metergauge.link":3}],2:[function(require,module,exports){"use strict";function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}Object.defineProperty(exports,"__esModule",{value:!0});var _metergauge=require("./metergauge.component"),_metergauge2=_interopRequireDefault(_metergauge),meterGaugeModule=angular.module("meterGauge",[]).directive("meterGauge",_metergauge2.default);exports.default=meterGaugeModule},{"./metergauge.component":1}],3:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var meterGaugeComponentLink=function(scope,element,attrs){var element=element[0],config=scope.gaugeconfig;if(!config)return void console.error("No config found");var meterGauge=function(d3){function drawGauge(opt){function labelXcalc(d,i){var tickAngle=d+90,tickAngleRad=dToR(tickAngle),labelW=opt.labelFontSize/(tickLabelText[i].toString().length/2),x1=originX+(labelStart-labelW)*Math.cos(tickAngleRad);return x1}function labelYcalc(d,i){var tickAngle=d+90,tickAngleRad=dToR(tickAngle),y1=originY+labelStart*Math.sin(tickAngleRad)+opt.labelFontSize/2;return y1}if("undefined"==typeof opt)var opt={};"undefined"==typeof opt.gaugeRadius&&(opt.gaugeRadius=150),"undefined"==typeof opt.minVal&&(opt.minVal=0),"undefined"==typeof opt.maxVal&&(opt.maxVal=100),"undefined"==typeof opt.tickSpaceMinVal&&(opt.tickSpaceMinVal=1),"undefined"==typeof opt.tickSpaceMajVal&&(opt.tickSpaceMajVal=10),"undefined"==typeof opt.divID&&(opt.divID="vizBox"),"undefined"==typeof opt.needleVal&&(opt.needleVal=60),"undefined"==typeof opt.gaugeUnits&&(opt.gaugeUnits="%"),"undefined"==typeof opt.padding&&(opt.padding=.05),"undefined"==typeof opt.edgeWidth&&(opt.edgeWidth=.05),"undefined"==typeof opt.tickEdgeGap&&(opt.tickEdgeGap=.05),"undefined"==typeof opt.tickLengthMaj&&(opt.tickLengthMaj=.15),"undefined"==typeof opt.tickLengthMin&&(opt.tickLengthMin=.05),"undefined"==typeof opt.needleTickGap&&(opt.needleTickGap=.05),"undefined"==typeof opt.needleLengthNeg&&(opt.needleLengthNeg=.2),"undefined"==typeof opt.pivotRadius&&(opt.pivotRadius=.1),"undefined"==typeof opt.ticknessGaugeBasis&&(opt.ticknessGaugeBasis=200),"undefined"==typeof opt.needleWidth&&(opt.needleWidth=5),"undefined"==typeof opt.tickWidthMaj&&(opt.tickWidthMaj=3),"undefined"==typeof opt.tickWidthMin&&(opt.tickWidthMin=1),"undefined"==typeof opt.labelFontSize&&(opt.labelFontSize=18),"undefined"==typeof opt.zeroTickAngle&&(opt.zeroTickAngle=60),"undefined"==typeof opt.maxTickAngle&&(opt.maxTickAngle=300),"undefined"==typeof opt.zeroNeedleAngle&&(opt.zeroNeedleAngle=40),"undefined"==typeof opt.maxNeedleAngle&&(opt.maxNeedleAngle=320),"undefined"==typeof opt.tickColMaj&&(opt.tickColMaj="#0099CC"),"undefined"==typeof opt.tickColMin&&(opt.tickColMin="#000"),"undefined"==typeof opt.outerEdgeCol&&(opt.outerEdgeCol="#0099CC"),"undefined"==typeof opt.pivotCol&&(opt.pivotCol="#999"),"undefined"==typeof opt.innerCol&&(opt.innerCol="#fff"),"undefined"==typeof opt.unitsLabelCol&&(opt.unitsLabelCol="#000"),"undefined"==typeof opt.tickLabelCol&&(opt.tickLabelCol="#000"),"undefined"==typeof opt.needleCol&&(opt.needleCol="#0099CC");var defaultFonts='"Helvetica Neue", Helvetica, Arial, sans-serif';"undefined"==typeof opt.tickFont&&(opt.tickFont=defaultFonts),"undefined"==typeof opt.unitsFont&&(opt.unitsFont=defaultFonts),opt.padding=opt.padding*opt.gaugeRadius,opt.edgeWidth=opt.edgeWidth*opt.gaugeRadius,opt.tickEdgeGap=opt.tickEdgeGap*opt.gaugeRadius,opt.tickLengthMaj=opt.tickLengthMaj*opt.gaugeRadius,opt.tickLengthMin=opt.tickLengthMin*opt.gaugeRadius,opt.needleTickGap=opt.needleTickGap*opt.gaugeRadius,opt.needleLengthNeg=opt.needleLengthNeg*opt.gaugeRadius,opt.pivotRadius=opt.pivotRadius*opt.gaugeRadius,opt.needleWidth=opt.needleWidth*(opt.gaugeRadius/opt.ticknessGaugeBasis),opt.tickWidthMaj=opt.tickWidthMaj*(opt.gaugeRadius/opt.ticknessGaugeBasis),opt.tickWidthMin=opt.tickWidthMin*(opt.gaugeRadius/opt.ticknessGaugeBasis),opt.labelFontSize=opt.labelFontSize*(opt.gaugeRadius/opt.ticknessGaugeBasis);var needleLengthPos=opt.gaugeRadius-opt.padding-opt.edgeWidth-opt.tickEdgeGap-opt.tickLengthMaj-opt.needleTickGap,needlePathLength=opt.needleLengthNeg+needleLengthPos,needlePathStart=opt.needleLengthNeg*-1,tickStartMaj=opt.gaugeRadius-opt.padding-opt.edgeWidth-opt.tickEdgeGap-opt.tickLengthMaj,tickStartMin=opt.gaugeRadius-opt.padding-opt.edgeWidth-opt.tickEdgeGap-opt.tickLengthMin,labelStart=tickStartMaj-opt.labelFontSize,innerEdgeRadius=opt.gaugeRadius-opt.padding-opt.edgeWidth,outerEdgeRadius=opt.gaugeRadius-opt.padding,originX=opt.gaugeRadius,originY=opt.gaugeRadius;opt.labelFontSize<6&&(opt.labelFontSize=0);for(var valueScale=d3.scaleLinear().domain([opt.minVal,opt.maxVal]).range([opt.zeroTickAngle,opt.maxTickAngle]),counter=0,tickAnglesMaj=[],tickAnglesMin=[],tickSpacingMajDeg=valueScale(opt.tickSpaceMajVal)-valueScale(0),tickSpacingMinDeg=valueScale(opt.tickSpaceMinVal)-valueScale(0),i=opt.zeroTickAngle;i<=opt.maxTickAngle;i+=tickSpacingMajDeg)tickAnglesMaj.push(opt.zeroTickAngle+tickSpacingMajDeg*counter),counter++;counter=0;for(var i=opt.zeroTickAngle;i<=opt.maxTickAngle;i+=tickSpacingMinDeg){var exists=0;tickAnglesMaj.forEach(function(d){opt.zeroTickAngle+tickSpacingMinDeg*counter==d&&(exists=1)}),0==exists&&tickAnglesMin.push(opt.zeroTickAngle+tickSpacingMinDeg*counter),counter++}counter=0;for(var tickLabelText=[],i=opt.zeroTickAngle;i<=opt.maxTickAngle;i+=tickSpacingMajDeg)tickLabelText.push(opt.minVal+opt.tickSpaceMajVal*counter),counter++;var svgWidth=2*opt.gaugeRadius,svgHeight=2*opt.gaugeRadius,svg=d3.select(element).append("svg").attr("id","SVGbox-"+opt.divID).attr("width",svgWidth).attr("height",svgHeight),circleGroup=svg.append("svg:g").attr("id","circles"),tickCalcMaj=(circleGroup.append("svg:circle").attr("cx",originX).attr("cy",originY).attr("r",outerEdgeRadius).style("fill",opt.outerEdgeCol).style("stroke","none"),circleGroup.append("svg:circle").attr("cx",originX).attr("cy",originY).attr("r",innerEdgeRadius).style("fill",opt.innerCol).style("stroke","none"),circleGroup.append("svg:circle").attr("cx",originX).attr("cy",originY).attr("r",opt.pivotRadius).style("fill",opt.pivotCol).style("stroke","none"),function(){function pathCalc(d,i){var tickAngle=d+90,tickAngleRad=dToR(tickAngle),y1=originY+tickStartMaj*Math.sin(tickAngleRad),y2=originY+(tickStartMaj+opt.tickLengthMaj)*Math.sin(tickAngleRad),x1=originX+tickStartMaj*Math.cos(tickAngleRad),x2=originX+(tickStartMaj+opt.tickLengthMaj)*Math.cos(tickAngleRad),lineData=[{x:x1,y:y1},{x:x2,y:y2}],lineFunc=d3.line().x(function(d){return d.x}).y(function(d){return d.y}),lineSVG=lineFunc(lineData);return lineSVG}return pathCalc}),tickCalcMin=function(){function pathCalc(d,i){var tickAngle=d+90,tickAngleRad=dToR(tickAngle),y1=originY+tickStartMin*Math.sin(tickAngleRad),y2=originY+(tickStartMin+opt.tickLengthMin)*Math.sin(tickAngleRad),x1=originX+tickStartMin*Math.cos(tickAngleRad),x2=originX+(tickStartMin+opt.tickLengthMin)*Math.cos(tickAngleRad),lineData=[{x:x1,y:y1},{x:x2,y:y2}],lineFunc=d3.line().x(function(d){return d.x}).y(function(d){return d.y}),lineSVG=lineFunc(lineData);return lineSVG}return pathCalc},pathTickMaj=tickCalcMaj(),pathTickMin=tickCalcMin(),ticks=svg.append("svg:g").attr("id","tickMarks"),ticksMin=ticks.append("svg:g").attr("id","minorTickMarks"),ticksMaj=ticks.append("svg:g").attr("id","majorTickMarks"),tickLabels=(ticksMin.selectAll("path").data(tickAnglesMin).enter().append("path").attr("d",pathTickMin).style("stroke",opt.tickColMin).style("stroke-width",opt.tickWidthMin+"px"),ticksMaj.selectAll("path").data(tickAnglesMaj).enter().append("path").attr("d",pathTickMaj).style("stroke",opt.tickColMaj).style("stroke-width",opt.tickWidthMaj+"px"),svg.append("svg:g").attr("id","tickLabels")),unitLabels=(tickLabels.selectAll("text").data(tickAnglesMaj).enter().append("text").attr("x",function(d,i){return labelXcalc(d,i)}).attr("y",function(d,i){return labelYcalc(d,i)}).attr("font-size",opt.labelFontSize).attr("text-anchor","middle").style("fill",opt.tickLabelCol).style("font-weight","bold").attr("font-family",opt.tickFont).text(function(d,i){return tickLabelText[i]}),svg.append("svg:g").attr("id","unitLabels")),unitsLabel=unitLabels.selectAll("text").data([0]).enter().append("text").attr("x",function(d,i){return labelXcalc(d,i)}).attr("y",function(d,i){return labelYcalc(d,i)}).attr("font-size",1.5*opt.labelFontSize).attr("text-anchor","middle").style("fill",opt.unitsLabelCol).style("font-weight","bold").attr("font-family",opt.unitsFont).text(opt.gaugeUnits),needleAngle=[opt.zeroNeedleAngle],needleCalc=function(){function pathCalc(d,i){var nAngleRad=dToR(d+90),y1=originY+needlePathStart*Math.sin(nAngleRad),y2=originY+(needlePathStart+needlePathLength)*Math.sin(nAngleRad),x1=originX+needlePathStart*Math.cos(nAngleRad),x2=originX+(needlePathStart+needlePathLength)*Math.cos(nAngleRad),lineData=[{x:x1,y:y1},{x:x2,y:y2}],lineFunc=d3.line().x(function(d){return d.x}).y(function(d){return d.y}),lineSVG=lineFunc(lineData);return lineSVG}return pathCalc},pathNeedle=needleCalc(),needleGroup=svg.append("svg:g").attr("id","needle"),needlePath=needleGroup.selectAll("path").data(needleAngle).enter().append("path").attr("d",pathNeedle).style("stroke",opt.needleCol).style("stroke-width",opt.needleWidth+"px");needlePath.transition().duration(1e3).attrTween("transform",function(d,i,a){needleAngle=valueScale(opt.needleVal),needleAngle>opt.maxTickAngle&&(needleAngle=opt.maxNeedleAngle),needleAngle<opt.zeroTickAngle&&(needleAngle=opt.zeroNeedleAngle);var needleCentre=originX+","+originY,needleRot=needleAngle-opt.zeroNeedleAngle;return d3.interpolateString("rotate(0,"+needleCentre+")","rotate("+needleRot+","+needleCentre+")")}),unitsLabel.transition().duration(1e3).tween("text",function(d){var i=d3.interpolateString(opt.minVal,opt.needleVal),self=this;return function(t){self.textContent=Math.round(i(t))+" "+opt.gaugeUnits}}),this.updateGauge=function(newVal){void 0==newVal&&opt.minVal;var needlePath=needleGroup.selectAll("path"),oldVal=opt.needleVal;needlePath.transition().duration(3e3).ease(d3.easeCubicIn).attrTween("transform",function(d,i,a){var needleAngleOld=valueScale(oldVal)-opt.zeroNeedleAngle,needleAngleNew=valueScale(newVal)-opt.zeroNeedleAngle;needleAngleOld+opt.zeroNeedleAngle>opt.maxTickAngle&&(needleAngleOld=opt.maxNeedleAngle-opt.zeroNeedleAngle),needleAngleOld+opt.zeroNeedleAngle<opt.zeroTickAngle&&(needleAngleOld=0),needleAngleNew+opt.zeroNeedleAngle>opt.maxTickAngle&&(needleAngleNew=opt.maxNeedleAngle-opt.zeroNeedleAngle),needleAngleNew+opt.zeroNeedleAngle<opt.zeroTickAngle&&(needleAngleNew=0);var needleCentre=originX+","+originY;return d3.interpolateString("rotate("+needleAngleOld+","+needleCentre+")","rotate("+needleAngleNew+","+needleCentre+")")}),unitsLabel.transition().duration(3e3).ease(d3.easeCubicIn).tween("text",function(d){var i=d3.interpolateString(oldVal,newVal),self=this;return function(t){self.textContent=Math.round(i(t))+" "+opt.gaugeUnits}}),opt.needleVal=newVal}}function dToR(angleDeg){var angleRad=angleDeg*(Math.PI/180);return angleRad}return drawGauge}(d3),gauge=new meterGauge(config);scope.$watch("gaugeconfig.needleVal",function(newVal){gauge.updateGauge(newVal)})};exports.default=meterGaugeComponentLink},{}]},{},[2]);
(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms', [
    'yatch-sentinel.services',
    'rzModule',
    'uiGmapgoogle-maps',
    'uiSwitch'
  ])
    .config(function ($stateProvider, $translatePartialLoaderProvider) {


      $stateProvider
        .state('boat.alarms', {
          url: '/alarm/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/alarm/header.html',
              controller: 'alarmHeaderController',
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/alarm/index.html',
              controller: 'alarmIndexController',
              controllerAs: 'vm',
              resolve: {
                alarms: function (sentinelService, $stateParams) {
                  return sentinelService.getSentinelAlarms($stateParams.sentinelId);
                },
                sensors: function (sentinelService, $stateParams) {
                  return sentinelService.getSentinelSensors($stateParams.sentinelId);
                },
                currentSentinel: function (userService, $stateParams) {
                  return userService.getUserSentinelById($stateParams.sentinelId);
                },
                connectivity: function (sentinelService, $stateParams) {
                  return sentinelService.getLatestConnectivityStatus($stateParams.sentinelId);
                }
              }
            }
          },
          data: {
            pageTitle: 'YS6 Alarms'
          },
          headerClass: 'half',
          mobileHeader: {
            visible: true,
            title: 'Header.Alarms'
          }
        })
        .state('boat.position_alarm', {
          url: '/position-alarm/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/alarm/position/header.html',
              controller: 'positionAlarmHeaderController',
              controllerAs: 'vm'
            },
            'extra_header@boat': {
              templateUrl: 'app/main/alarm/position/map.html',
              controller: 'positionAlarmMapController',
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/alarm/position/position.html',
              controller: 'positionAlarmController',
              controllerAs: 'vm',
              resolve: {
                location: function (sentinelService, $stateParams) {
                  return sentinelService.getSentinelLocation($stateParams.sentinelId);
                },
                geoFenceAlarm: function (sentinelService, $stateParams) {
                  return sentinelService.getGeofenceAlarm($stateParams.sentinelId);
                }
              }
            }
          },
          headerClass: 'half',
          mobileHeader: {
            visible: true,
            title: 'Header.Position'
          },
          data: {
            pageTitle: 'Position alarm'
          }
        })
        .state('boat.safe_return_alarm', {
          url: '/safe-return-alarm/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/alarm/safe-return/header.html',
              controller: 'safeReturnAlarmHeaderController',
              controllerAs: 'vm'
            },
            'extra_header@boat': {
              templateUrl: 'app/main/alarm/safe-return/map.html',
              controller: 'safeReturnAlarmMapController',
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/alarm/safe-return/safe-return.html',
              controller: 'safeReturnAlarmController',
              controllerAs: 'vm',
              resolve: {
                location: function (sentinelService, $stateParams) {
                  return sentinelService.getSentinelLocation($stateParams.sentinelId);
                },
                safeReturnAlarm: function (sentinelService, $stateParams) {
                  return sentinelService.getSafeReturnAlarm($stateParams.sentinelId);
                },
                userContacts: function (userService) {
                  return userService.getUserContacts();
                },
                status: function (sentinelService, $stateParams) {
                  return sentinelService.getSentinelSensorStatuses($stateParams.sentinelId);
                },
                countries: function (http) {
                  return http.get("assets/countries.json");
                }
              }
            }
          },
          headerClass: 'half',
          mobileHeader: {
            visible: true,
            title: 'Header.SafeReturn'
          },
          data: {
            pageTitle: 'Safe Return alarm'
          }
        })
        .state('boat.battery_alarm', {
          url: '/battery-alarm/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/alarm/battery/header.html',
              controller: 'batteryAlarmHeaderController',
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/alarm/battery/battery.html',
              controller: 'batteryAlarmController',
              controllerAs: 'vm',
              resolve: {
                batteryAlarms: function (sentinelService, $stateParams) {
                  return sentinelService.getBatteryAlarm($stateParams.sentinelId);
                },
                voltageSensors: function (sentinelService, $stateParams, sensorTypes) {
                  return sentinelService.getSentinelSensorsBySensorType($stateParams.sentinelId, sensorTypes.voltageSensor.id);
                }
              }
            }
          },
          headerClass: 'half',
          mobileHeader: {
            visible: true,
            title: 'Header.Battery'
          },
          data: {
            pageTitle: 'Battery alarm'
          }
        })
        .state('boat.shorepower_alarm', {
          url: '/shorepower-alarm/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/alarm/shorepower/header.html',
              controller: 'shorePowerAlarmHeaderController',
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/alarm/shorepower/shorepower.html',
              controller: 'shorepowerAlarmController',
              controllerAs: 'vm',
              resolve: {
                sensors: function (sentinelService, $stateParams, sensorTypes) {
                  return sentinelService.getSentinelSensorsBySensorType($stateParams.sentinelId, sensorTypes.mainSupplySensor.id);
                },
                mainSupplyAlarms: function (sentinelService, $stateParams) {
                  return sentinelService.getMainSupplyAlarms($stateParams.sentinelId);
                },
                sensorType: function (sentinelService, sensorTypes) {
                  return sentinelService.getSensorTypeById(sensorTypes.mainSupplySensor.id);
                }
              }
            }
          },
          headerClass: 'half',
          mobileHeader: {
            visible: true,
            title: 'Header.ShorePower'
          },
          data: {
            pageTitle: 'Shore power alarm'
          }
        })
        .state('boat.temperature_alarm', {
          url: '/temperature-alarm/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/alarm/temperature/header.html',
              controller: 'temperatureAlarmHeaderController',
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/alarm/temperature/temperature.html',
              controller: 'temperatureAlarmController',
              controllerAs: 'vm',
              resolve: {
                sensors: function (sentinelService, $stateParams, sensorTypes) {
                  return sentinelService.getSentinelSensorsBySensorType($stateParams.sentinelId, sensorTypes.temperatureSensor.id);
                },
                temperatureAlarms: function (sentinelService, $stateParams) {
                  return sentinelService.getTemperatureAlarms($stateParams.sentinelId);
                },
                sensorType: function (sentinelService, sensorTypes) {
                  return sentinelService.getSensorTypeById(sensorTypes.temperatureSensor.id);
                }
              }
            }
          },
          headerClass: 'half',
          mobileHeader: {
            visible: true,
            title: 'Header.Temperature'
          },
          data: {
            pageTitle: 'Temperature alarm'
          }
        })
        .state('boat.high_water_alarm', {
          url: '/high-water-alarm/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/alarm/highwater/header.html',
              controller: 'highWaterAlarmHeaderController',
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/alarm/highwater/highwater.html',
              controller: 'highWaterAlarmController',
              controllerAs: 'vm',
              resolve: {
                sensors: function (sentinelService, $stateParams, sensorTypes) {
                  return sentinelService.getSentinelSensorsBySensorType($stateParams.sentinelId, sensorTypes.bilgeSensor.id);
                },
                highWaterAlarms: function (sentinelService, $stateParams) {
                  return sentinelService.getBilgeAlarms($stateParams.sentinelId);
                },
                sensorType: function (sentinelService, sensorTypes) {
                  return sentinelService.getSensorTypeById(sensorTypes.bilgeSensor.id);
                }

              }
            }
          },
          headerClass: 'half',
          mobileHeader: {
            visible: true,
            title: 'Header.HighWater'
          },
          data: {
            pageTitle: 'High water alarm'
          }
        })
        .state('boat.motion_detector_alarm', {
          url: '/motion-detector-alarm/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/alarm/motiondetector/header.html',
              controller: 'motionDetectionAlarmHeaderController',
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/alarm/motiondetector/motiondetector.html',
              controller: 'motionDetectorAlarmController',
              controllerAs: 'vm',
              resolve: {
                sensors: function (sentinelService, $stateParams, sensorTypes) {
                  return sentinelService.getSentinelSensorsBySensorType($stateParams.sentinelId, sensorTypes.pirSensor.id);
                },
                motionDetectorAlarms: function (sentinelService, $stateParams) {
                  return sentinelService.getPirAlarms($stateParams.sentinelId);
                },
                sensorType: function (sentinelService, sensorTypes) {
                  return sentinelService.getSensorTypeById(sensorTypes.pirSensor.id);
                }
              }
            }
          },
          headerClass: 'half',
          mobileHeader: {
            visible: true,
            title: 'Header.MotionDetection'
          },
          data: {
            pageTitle: 'Motion alarm'
          }
        })
        .state('boat.door_alarm', {
          url: '/door-alarm/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/alarm/door/header.html',
              controller: 'doorAlarmHeaderController',
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/alarm/door/door.html',
              controller: 'doorAlarmController',
              controllerAs: 'vm',
              resolve: {
                sensors: function (sentinelService, $stateParams, sensorTypes) {
                  return sentinelService.getSentinelSensorsBySensorType($stateParams.sentinelId, sensorTypes.doorSensor.id);
                },
                doorAlarms: function (sentinelService, $stateParams) {
                  return sentinelService.getDoorAlarm($stateParams.sentinelId);
                },
                sensorType: function (sentinelService, sensorTypes) {
                  return sentinelService.getSensorTypeById(sensorTypes.doorSensor.id);
                }
              }
            }
          },
          headerClass: 'half',
          mobileHeader: {
            visible: true,
            title: 'Header.Door'
          },
          data: {
            pageTitle: 'Door alarm'
          }
        })
        .state('boat.shock_alarm', {
          url: '/shock-alarm/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/alarm/shock/header.html',
              controller: 'shockAlarmHeaderController',
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/alarm/shock/shock.html',
              controller: 'shockAlarmController',
              controllerAs: 'vm',
              resolve: {
                sensors: function (sentinelService, $stateParams, sensorTypes) {
                  return sentinelService.getSentinelSensorsBySensorType($stateParams.sentinelId, sensorTypes.vibrationSensor.id);
                },
                shockAlarms: function (sentinelService, $stateParams) {
                  return sentinelService.getShockAlarm($stateParams.sentinelId);
                }
              }
            }
          },
          headerClass: 'half',
          mobileHeader: {
            visible: true,
            title: 'Header.Shock'
          },
          data: {
            pageTitle: 'Shock alarms'
          }
        })
        .state('boat.tilt_alarm', {
          url: '/tilt-alarm/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/alarm/tilt/header.html',
              controller: 'tiltAlarmHeaderController',
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/alarm/tilt/tilt.html',
              controller: 'tiltAlarmController',
              controllerAs: 'vm',
              resolve: {
                sensors: function (sentinelService, $stateParams, sensorTypes) {
                  return sentinelService.getSentinelSensorsBySensorType($stateParams.sentinelId, sensorTypes.tiltSensor.id);
                },
                tiltAlarm: function (sentinelService, $stateParams) {
                  return sentinelService.getTiltAlarm($stateParams.sentinelId);
                }
              }
            }
          },
          headerClass: 'half',
          mobileHeader: {
            visible: true,
            title: 'Header.Tilt'
          },
          data: {
            pageTitle: 'Tilt alarms'
          }
        })
        .state('boat.item_security_alarm', {
          url: '/item-security/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/alarm/item-security/header.html',
              controller: 'itemSecurityHeaderController',
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/alarm/item-security/item-security.html',
              controller: 'itemSecurityAlarmController',
              controllerAs: 'vm',
              resolve: {
                itemSecurityAlarms: function (sentinelService, $stateParams) {
                  return sentinelService.getBeaconAlarm($stateParams.sentinelId);
                },
                sensors: function (sentinelService, $stateParams, sensorTypes) {
                  return sentinelService.getSentinelSensorsBySensorType($stateParams.sentinelId, sensorTypes.beaconSensor.id);
                },
                sensorType: function (sentinelService, sensorTypes) {
                  return sentinelService.getSensorTypeById(sensorTypes.doorSensor.id);
                }
              }
            }
          },
          headerClass: 'half',
          mobileHeader: {
            visible: true,
            title: 'Header.ItemSecurity'
          },
          data: {
            pageTitle: 'Item security alarms'
          }
        })
        .state('boat.nmea_alarms', {
          url: '/nmea/alarm/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/alarm/nmea/header.html',
              controller: 'nmeaAlarmHeaderController',
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/alarm/nmea/index.html',
              controller: 'nmeaAlarmIndexController',
              controllerAs: 'vm',
              resolve: {
                alarms: function (sentinelService, $stateParams) {
                  return sentinelService.getSentinelAlarms($stateParams.sentinelId);
                },
                currentSentinel: function (userService, $stateParams) {
                  return userService.getUserSentinelById($stateParams.sentinelId);
                },
                nmeaAlarmsStatus: function (nmeaService, $stateParams) {
                  return nmeaService.getNmeaAlarmsStatus($stateParams.sentinelId);
                }
              }
            }
          },
          data: {
            pageTitle: 'NMEA Alarms'
          },
          headerClass: 'half',
          mobileHeader: {
            visible: true,
            title: 'Header.NmeaAlarms'
          }
        })
        .state('boat.nmea_current_trip_alarm',
        {
          url: '/nmea-current-trip/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/alarm/nmea/current-trip-alarm/header.html',
              controller: 'nmeaAlarm1HeaderController',
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/alarm/nmea/current-trip-alarm/alarm1.html',
              controller: 'nmeaAlarm1Controller',
              controllerAs: 'vm',
              resolve: {
                currentTripAlarm: function (nmeaService, $stateParams) {
                  return nmeaService.getCurrentTripAlarm($stateParams.sentinelId);
                }
              }
            }
          },
          headerClass: 'half',
          mobileHeader: {
            visible: true,
            title: 'Header.CurrentTrip'
          },
          data: {
            pageTitle: 'Current Trip'
          }
        })
        .state('boat.nmea_speed_limit_alarm',
        {
          url: '/nmea-speed-limit/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/alarm/nmea/speed-limit/header.html',
              controller: 'nmeaAlarm7HeaderController',
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/alarm/nmea/speed-limit/alarm7.html',
              controller: 'nmeaAlarm7Controller',
              controllerAs: 'vm',
              resolve: {
                speedLimitAlarm: function (nmeaService, $stateParams) {
                  return nmeaService.getSpeedLimitAlarm($stateParams.sentinelId);
                }
              }
            }
          },
          headerClass: 'half',
          mobileHeader: {
            visible: true,
            title: 'Header.SpeedLimit'
          },
          data: {
            pageTitle: 'Speed Limit'
          }
        })


        .state('boat.nmea_pos_speed_alarm', {
          url: '/nmea-pos-speed/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/alarm/nmea/pos-and-speed/header.html',
              controller: 'nmeaAlarm3HeaderController',
              controllerAs: 'vm'
            },
            'extra_header@boat': {
              templateUrl: 'app/main/alarm/nmea/pos-and-speed/map.html',
              controller: 'nmeaAlarm3MapController',
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/alarm/nmea/pos-and-speed/alarm3.html',
              controller: 'nmeaAlarm3Controller',
              controllerAs: 'vm',
              resolve: {
                location: function (nmeaService, $stateParams) {
                  return nmeaService.getSentinelLocation($stateParams.sentinelId,null,true);//new location which we send
                },
                geoFenceAlarm: function (nmeaService, $stateParams) {
                  return nmeaService.getGeofenceAlarm($stateParams.sentinelId);//old location
                }
              }
            }
          },
          headerClass: 'half',
          mobileHeader: {
            visible: true,
            title: 'Header.PositionAndSpeed'
          },
          data: {
            pageTitle: 'Position & Speed'
          }
        })
        .state('boat.nmea_water_depth_alarm', {
          url: '/nmea-water-depth/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/alarm/nmea/water-depth/header.html',
              controller: 'nmeaAlarm2HeaderController',
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/alarm/nmea/water-depth/alarm2.html',
              controller: 'nmeaAlarm2Controller',
              controllerAs: 'vm',
              resolve: {
                waterDepthAlarm: function (nmeaService, $stateParams) {
                  return nmeaService.getWaterDepthAlarm($stateParams.sentinelId);
                },
                hasWaterDepthDbData: function (nmeaService, $stateParams, nmeaDataFieldEnum) {
                  return nmeaService.getNmeaDbDataStatusForAlarm($stateParams.sentinelId, nmeaDataFieldEnum.Pgn128267Depth);
                }
              }
            }
          },
          headerClass: 'half',
          mobileHeader: {
            visible: true,
            title: 'Header.WaterDepth'
          },
          data: {
            pageTitle: 'Water Depth'
          }
        })
        .state('boat.nmea_engine_alarm_list', {
          url: '/nmea-engines/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/alarm/nmea/engine/header.html',
              controller: 'nmeaAlarm4HeaderController',
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/alarm/nmea/engine/alarm4.html',
              controller: 'nmeaAlarm4Controller',
              controllerAs: 'vm',
              resolve: {
                allUserSentinelEngines: function (nmeaService, $stateParams) {
                  return nmeaService.getAllEnginesDataByUserSentinelId($stateParams.sentinelId);
                }
              }
            }
          },
          headerClass: 'half',
          mobileHeader: {
            visible: true,
            title: 'Header.Engines'
          },
          data: {
            pageTitle: 'Engines'
          }
        })
        .state('boat.nmea_fluid_alarm', {
          url: '/nmea-fluid/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/alarm/nmea/fluid/header.html',
              controller: 'nmeaAlarm5HeaderController',
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/alarm/nmea/fluid/alarm5.html',
              controller: 'nmeaAlarm5Controller',
              controllerAs: 'vm',
              resolve: {
                fluidLevelAlarms: function (nmeaService, $stateParams) {
                  return nmeaService.getFluidLevelsAlarm($stateParams.sentinelId);
                }
              }
            }
          },
          headerClass: 'half',
          mobileHeader: {
            visible: true,
            title: 'Header.Fluid'
          },
          data: {
            pageTitle: 'Fluid'
          }
        })
        .state('boat.nmea_wind_speed_alarm', {
          url: '/wind-speed/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/alarm/nmea/wind-speed/header.html',
              controller: 'nmeaAlarm10HeaderController',
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/alarm/nmea/wind-speed/alarm10.html',
              controller: 'nmeaAlarm10Controller',
              controllerAs: 'vm',
              resolve: {
                windSpeedAlarm: function (nmeaService, $stateParams) {
                  return nmeaService.getWindSpeedAlarm($stateParams.sentinelId);
                },
                hasWindSpeedDbData: function (nmeaService, $stateParams, nmeaDataFieldEnum) {
                  return nmeaService.getNmeaDbDataStatusForAlarm($stateParams.sentinelId, nmeaDataFieldEnum.Pgn130306WindSpeed);
                }
              }
            }
          },
          headerClass: 'half',
          mobileHeader: {
            visible: true,
            title: 'Header.WindSpeed'
          },
          data: {
            pageTitle: 'Wind Speed'
          }
        })
        .state('boat.nmea_power_alarm_list', {
          url: '/nmea-power-instances/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/alarm/nmea/power/header.html',
              controller: 'nmeaPowerInstancesHeaderController',
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/alarm/nmea/power/alarm.html',
              controller: 'nmeaPowerInstancesController',
              controllerAs: 'vm',
              resolve: {
                allUserSentinelPowerInstances: function (nmeaService, $stateParams) {
                  return nmeaService.getAllPowerInstancesToRename($stateParams.sentinelId);
                }
              }
            }
          },
          headerClass: 'half',
          mobileHeader: {
            visible: true,
            title: 'Header.PowerInstances'
          },
          data: {
            pageTitle: 'Yacht Sentinel | Power Instances'
          }
        })

        .state('boat.nmea_temp_hum_alarm', {
          url: '/nmea-temp-hum/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/alarm/nmea/temp-and-hum/header.html',
              controller: 'nmeaAlarm8HeaderController',
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/alarm/nmea/temp-and-hum/alarm8.html',
              controller: 'nmeaAlarm8Controller',
              controllerAs: 'vm',
              resolve: {
                tempHumidityAlarm: function (nmeaService, $stateParams) {
                  return nmeaService.getTempHumidityAlarm($stateParams.sentinelId);
                }
              }
            }
          },
          headerClass: 'half',
          mobileHeader: {
            visible: true,
            title: 'Header.TemperatureAndHumidity'
          },
          data: {
            pageTitle: 'Temperature & Humidity'
          }
        })
        .state('boat.nmea_manufacturer_set_alarm', {
          url: '/nmea-manufacturer-set/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/alarm/nmea/manufacturer-set/header.html',
              controller: 'nmeaAlarm9HeaderController',
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/alarm/nmea/manufacturer-set/alarm9.html',
              controller: 'nmeaAlarm9Controller',
              controllerAs: 'vm',
              resolve: {

              }
            }
          },
          headerClass: 'half',
          mobileHeader: {
            visible: true,
            title: 'Header.ManufacturerSet'
          },
          data: {
            pageTitle: 'Manufacturer Set'
          }
        })
        .state('boat.nmea_engine_alarm', {
          url: '/:sentinelId/nmea-engine-alarm/:instanceNumber',
          views: {
            'header@boat': {
              templateUrl: 'app/main/alarm/nmea/engine/engine-details/header.html',
              controller: 'nmeaEngineAlarmHeaderController',
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/alarm/nmea/engine/engine-details/alarm.html',
              controller: 'nmeaEngineAlarmController',
              controllerAs: 'vm',
              resolve: {
                engineAlarm: function (nmeaService, $stateParams) {
                  return nmeaService.getEngineAlarm($stateParams.sentinelId, $stateParams.instanceNumber);
                }
              }
            }
          },
          headerClass: 'half',
          mobileHeader: {
            visible: true,
            title: 'Header.EngineAlarm'
          },
          data: {
            pageTitle: 'Engine Alarm'
          }
        })
        .state('boat.nmea_power_alarm', {
          url: '/:sentinelId/nmea-power-alarm/:instanceNumber?sourceId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/alarm/nmea/power/power-details/header.html',
              controller: 'nmeaAlarm6HeaderController',
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/alarm/nmea/power/power-details/alarm6.html',
              controller: 'nmeaAlarm6Controller',
              controllerAs: 'vm',
              resolve: {
                powerAlarm: function (nmeaService, $stateParams) {
                  return nmeaService.getPowerAlarm($stateParams.sentinelId, $stateParams.instanceNumber, $stateParams.sourceId);
                }
              }
            }
          },
          headerClass: 'half',
          mobileHeader: {
            visible: true,
            title: 'Header.PowerInstances'
          },
          data: {
            pageTitle: 'Yacht Sentinel | Power Alarm'
          }
        });
      $translatePartialLoaderProvider.addPart('app/main/alarm');
      $translatePartialLoaderProvider.addPart('app/main/alarm/battery');
      $translatePartialLoaderProvider.addPart('app/main/alarm/door');
      $translatePartialLoaderProvider.addPart('app/main/alarm/highwater');
      $translatePartialLoaderProvider.addPart('app/main/alarm/motiondetector');
      $translatePartialLoaderProvider.addPart('app/main/alarm/position');
      $translatePartialLoaderProvider.addPart('app/main/alarm/shock');
      $translatePartialLoaderProvider.addPart('app/main/alarm/shorepower');
      //$translatePartialLoaderProvider.addPart('app/main/alarm/temperature');
      $translatePartialLoaderProvider.addPart('app/main/alarm/tilt');
      $translatePartialLoaderProvider.addPart('app/main/alarm/safe-return');
      //$translatePartialLoaderProvider.addPart('app/main/alarm/item-security');
      $translatePartialLoaderProvider.addPart('app/main/alarm/nmea');
      $translatePartialLoaderProvider.addPart('app/main/alarm/nmea/current-trip-alarm');
      $translatePartialLoaderProvider.addPart('app/main/alarm/nmea/pos-and-speed');
      $translatePartialLoaderProvider.addPart('app/main/alarm/nmea/water-depth');
      $translatePartialLoaderProvider.addPart('app/main/alarm/nmea/engine');
      $translatePartialLoaderProvider.addPart('app/main/alarm/nmea/fluid');
      $translatePartialLoaderProvider.addPart('app/main/alarm/nmea/power');
      $translatePartialLoaderProvider.addPart('app/main/alarm/nmea/power/power-details');
      $translatePartialLoaderProvider.addPart('app/main/alarm/nmea/speed-limit');
      $translatePartialLoaderProvider.addPart('app/main/alarm/nmea/temp-and-hum');
      $translatePartialLoaderProvider.addPart('app/main/alarm/nmea/manufacturer-set');
      $translatePartialLoaderProvider.addPart('app/main/alarm/nmea/engine/engine-details');
      $translatePartialLoaderProvider.addPart('app/main/alarm/nmea/wind-speed');
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .service('nmeaAlarm6Service', function () {
      return {
        data: []
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('nmeaAlarm6HeaderController', function (nmeaAlarm6Service) {
      var vm = this;
      if (nmeaAlarm6Service.data.nmeaAlarm6) {
        vm.lastUpdated = nmeaAlarm6Service.data.nmeaAlarm6.dateUpdated == null ? nmeaAlarm6Service.data.nmeaAlarm6.dateAdded : nmeaAlarm6Service.data.nmeaAlarm6.dateUpdated;
      } else {
        vm.lastUpdated = 'None';
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('nmeaAlarm6Controller', function (settingEnum, sessionService, $filter, powerAlarm, navigationService, toastr, sentinelService, nmeaService, $state, $stateParams, $rootScope) {
      var vm = this;
      vm.hasAmpHoursData = powerAlarm.hasAmpHoursData;
      vm.hasBatteryCaseTempData = powerAlarm.hasBatteryCaseTempData;
      vm.hasCurrentData = powerAlarm.hasCurrentData;
      vm.hasStateOfChargeData = powerAlarm.hasStateOfChargeData;
      vm.hasStateOfHealthData = powerAlarm.hasStateOfHealthData;
      vm.hasTimeRemainingData = powerAlarm.hasTimeRemainingData;
      vm.hasVoltageData = powerAlarm.hasVoltageData;

      navigationService.navigation = {
        backState: 'boat.nmea_alarms',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.goBack = function () {
        $rootScope.goBack();
      };
      var minBatteryCaseTemp = -20;
      var maxBatteryCaseTemp = 50;
      var settings = sessionService.getUserSettings();
      var tempSetting = settings.find(function (x) {
        return x.id === settingEnum.Temperature.id
      });
      if (tempSetting && tempSetting.userSettingViewModel) {
        //Convert to Fahrenhite
        if (tempSetting.userSettingViewModel.allow_Setting_Value == 3) {
          minBatteryCaseTemp = +(((minBatteryCaseTemp * 1.8) + 32).toFixed(1));
          maxBatteryCaseTemp = +(((maxBatteryCaseTemp * 1.8) + 32).toFixed(1));
        }
        //Convert to Kelvin
        if (tempSetting.userSettingViewModel.allow_Setting_Value == 24) {
          minBatteryCaseTemp = +((minBatteryCaseTemp + tempSetting.userSettingViewModel.allowed_Setting_Value.multiply_Factor).toFixed(1));
          maxBatteryCaseTemp = +((maxBatteryCaseTemp + tempSetting.userSettingViewModel.allowed_Setting_Value.multiply_Factor).toFixed(1));
        }
      }


      vm.nmeaAlarm6Current = {
        options: {
          floor: 1,
          ceil: 50,
          step: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value) {
            return value + " A";
          }
        },
        alarm: {
          min: 10,
          max: 50
        },
        current: false,
        instanceNumber: $stateParams.instanceNumber,
        nmeaInstanceSourceId: $stateParams.sourceId
      };

      vm.nmeaAlarm6Current.enabled = powerAlarm.currentAlarm == null ? false : powerAlarm.currentAlarm.enabled;
      if (powerAlarm.currentAlarm && powerAlarm.currentAlarm.alarmValue != null) {
        vm.nmeaAlarm6Current.alarm.min = powerAlarm.currentAlarm.alarmValue.min;
        vm.nmeaAlarm6Current.alarm.max = powerAlarm.currentAlarm.alarmValue.max;
      }

      vm.nmeaAlarm6StateOfCharge = {
        options: {
          floor: 45,
          ceil: 100,
          step: 5,
          precision: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'orangered'
          },
          translate: function (value) {
            return value + " %";
          }
        },
        alarm: {
          triggerValue: 50
        },
        stateOfCharge: false,
        instanceNumber: $stateParams.instanceNumber,
        nmeaInstanceSourceId: $stateParams.sourceId
      };
      vm.nmeaAlarm6StateOfCharge.enabled = powerAlarm.stateOfChargeAlarm == null ? false : powerAlarm.stateOfChargeAlarm.enabled;
      if (powerAlarm.stateOfChargeAlarm && powerAlarm.stateOfChargeAlarm.alarmValue != null) {
        vm.nmeaAlarm6StateOfCharge.alarm.triggerValue = powerAlarm.stateOfChargeAlarm.alarmValue.triggerValue;
      }

      vm.nmeaAlarm6Voltage = {
        options: {
          floor: 0,
          ceil: 50,
          step: 0.1,
          precision: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'orangered'
          },
          translate: function (value) {
            return value + " V";
          }
        },
        alarm: {
          triggerValue: 3.8
        },
        voltage: false,
        instanceNumber: $stateParams.instanceNumber,
        nmeaInstanceSourceId: $stateParams.sourceId
      };
      vm.nmeaAlarm6Voltage.enabled = powerAlarm.voltageAlarm == null ? false : powerAlarm.voltageAlarm.enabled;
      if (powerAlarm.voltageAlarm && powerAlarm.voltageAlarm.alarmValue != null) {
        vm.nmeaAlarm6Voltage.alarm.triggerValue = powerAlarm.voltageAlarm.alarmValue.triggerValue;
      }


      vm.nmeaAlarm6BatteryCaseTemperature = {
        options: {
          floor: minBatteryCaseTemp,
          ceil: maxBatteryCaseTemp,
          step: 0.1,
          precision: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value, sliderId, label) {
            switch (label) {
              case 'model':
                return '<b>' + $filter('temperature')(value) + '</b>';
              case 'high':
                return '<b>' + $filter('temperature')(value) + '</b>';
              default:
                return '<b>' + $filter('temperature')(value) + '</b>';
            }
          }
        },
        alarm: {
          min: 0,
          max: maxBatteryCaseTemp
        },
        current: false,
        instanceNumber: $stateParams.instanceNumber,
        nmeaInstanceSourceId: $stateParams.sourceId
      };

      vm.nmeaAlarm6BatteryCaseTemperature.enabled = powerAlarm.batteryCaseTempAlarm == null ? false : powerAlarm.batteryCaseTempAlarm.enabled;
      if (powerAlarm.batteryCaseTempAlarm && powerAlarm.batteryCaseTempAlarm.alarmValue != null) {
        vm.nmeaAlarm6BatteryCaseTemperature.alarm.min = powerAlarm.batteryCaseTempAlarm.alarmValue.min;
        vm.nmeaAlarm6BatteryCaseTemperature.alarm.max = powerAlarm.batteryCaseTempAlarm.alarmValue.max;
      }



      // vm.nmeaAlarm6BatteryCaseTemperature = {
      //   options: {
      //     floor: minBatteryCaseTemp,
      //     ceil: maxBatteryCaseTemp,
      //     step: 0.1,
      //     precision: 1,
      //     showSelectionBar: true,
      //     getSelectionBarColor: function () {
      //       return 'orangered'
      //     },
      //     translate: function (value, sliderId, label) {
      //       switch (label) {
      //         case 'model':
      //           return '<b>' + $filter('temperature')(value) + '</b>';
      //         case 'high':
      //           return '<b>' + $filter('temperature')(value) + '</b>';
      //         default:
      //           return '<b>' + $filter('temperature')(value) + '</b>';
      //       }
      //     }
      //   },
      //   alarm: {
      //     triggerValue: 3.8
      //   },
      //   batteryCaseTemperature: false,
      //   instanceNumber: $stateParams.instanceNumber
      // };
      // vm.nmeaAlarm6BatteryCaseTemperature.enabled = powerAlarm.batteryCaseTempAlarm == null ? false : powerAlarm.batteryCaseTempAlarm.enabled;
      // if (powerAlarm.batteryCaseTempAlarm && powerAlarm.batteryCaseTempAlarm.alarmValue != null) {
      //   vm.nmeaAlarm6BatteryCaseTemperature.alarm.triggerValue = powerAlarm.batteryCaseTempAlarm.alarmValue.triggerValue;
      // }

      vm.nmeaAlarm6StateOfHealth = {
        options: {
          floor: 45,
          ceil: 100,
          step: 5,
          precision: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'orangered'
          },
          translate: function (value) {
            return value + " %";
          }
        },
        alarm: {
          triggerValue: 50
        },
        stateOfHealth: false,
        instanceNumber: $stateParams.instanceNumber,
        nmeaInstanceSourceId: $stateParams.sourceId
      };
      vm.nmeaAlarm6StateOfHealth.enabled = powerAlarm.stateOfHealthAlarm == null ? false : powerAlarm.stateOfHealthAlarm.enabled;
      if (powerAlarm.stateOfHealthAlarm && powerAlarm.stateOfHealthAlarm.alarmValue != null) {
        vm.nmeaAlarm6StateOfHealth.alarm.triggerValue = powerAlarm.stateOfHealthAlarm.alarmValue.triggerValue;
      }

      vm.nmeaAlarm6TimeRemaining = {
        options: {
          floor: 5,
          ceil: 50,
          step: 5,
          precision: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'orangered'
          },
          translate: function (value) {
            return value + " hrs";
          }
        },
        alarm: {
          triggerValue: 3.8
        },
        timeRemaining: false,
        instanceNumber: $stateParams.instanceNumber,
        nmeaInstanceSourceId: $stateParams.sourceId
      };
      vm.nmeaAlarm6TimeRemaining.enabled = powerAlarm.timeRemainingAlarm == null ? false : powerAlarm.timeRemainingAlarm.enabled;
      if (powerAlarm.timeRemainingAlarm && powerAlarm.timeRemainingAlarm.alarmValue != null) {
        vm.nmeaAlarm6TimeRemaining.alarm.triggerValue = powerAlarm.timeRemainingAlarm.alarmValue.triggerValue;
      }

      vm.nmeaAlarm6AmpHours = {
        options: {
          floor: 20,
          ceil: 500,
          step: 5,
          precision: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'orangered'
          },
          translate: function (value) {
            return value + " Ah";
          }
        },
        alarm: {
          triggerValue: 230
        },
        ampHours: false,
        instanceNumber: $stateParams.instanceNumber,
        nmeaInstanceSourceId: $stateParams.sourceId
      };
      vm.nmeaAlarm6AmpHours.enabled = powerAlarm.ampHoursAlarm == null ? false : powerAlarm.ampHoursAlarm.enabled;
      if (powerAlarm.ampHoursAlarm && powerAlarm.ampHoursAlarm.alarmValue != null) {
        vm.nmeaAlarm6AmpHours.alarm.triggerValue = powerAlarm.ampHoursAlarm.alarmValue.triggerValue;
      }


      vm.updateAlarms = function () {
        nmeaService.updatePowerAlarm($stateParams.sentinelId, {
          stateOfChargeAlarm: angular.copy(vm.nmeaAlarm6StateOfCharge),
          voltageAlarm: angular.copy(vm.nmeaAlarm6Voltage),
          currentAlarm: angular.copy(vm.nmeaAlarm6Current),
          batteryCaseTempAlarm: angular.copy(vm.nmeaAlarm6BatteryCaseTemperature),
          stateOfHealthAlarm: angular.copy(vm.nmeaAlarm6StateOfHealth),
          timeRemainingAlarm: angular.copy(vm.nmeaAlarm6TimeRemaining),
          ampHoursAlarm: angular.copy(vm.nmeaAlarm6AmpHours)
        }, function () {
          toastr.success('Power Alarms Updated');
          $state.go('boat.nmea_alarms', {
            sentinelId: $stateParams.sentinelId
          });
        });
      }

      vm.hasSupportForFeature = function (hasData) {
        if (!hasData) {
          toastr.error("Your NMEA network does not support this feature!");
        }
      }

      vm.hasAccess = false;
      vm.canUserAccessTheSentinel = function () {
        sentinelService.canUserAccessTheSentinel($stateParams.sentinelId, function (response) {
          if (response != null) {
            vm.hasAccess = response;
          } else {
            vm.hasAccess = true;
          }
        });
      }
      vm.canUserAccessTheSentinel();
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .service('nmeaEngineAlarmService', function () {
      return {
        data: []
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('nmeaEngineAlarmHeaderController', function (nmeaEngineAlarmService) {
      var vm = this;
      if (nmeaEngineAlarmService.data.nmeaEngineAlarm) {
        vm.lastUpdated = nmeaEngineAlarmService.data.nmeaEngineAlarm.dateUpdated == null ? nmeaEngineAlarmService.data.nmeaEngineAlarm.dateAdded : nmeaEngineAlarmService.data.nmeaEngineAlarm.dateUpdated;
      } else {
        vm.lastUpdated = 'None';
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('nmeaEngineAlarmController', function (engineAlarm, navigationService,
      sessionService, $filter, toastr, settingEnum, sentinelService, nmeaService, $state, $stateParams, $rootScope) {
      var vm = this;
      vm.currentTotalEngineHours = engineAlarm.totalEngineHours;
      vm.hasAlternatorPotentialData = engineAlarm.hasAlternatorPotentialData;
      vm.hasBoostData = engineAlarm.hasBoostData;
      vm.hasEngineLoadData = engineAlarm.hasEngineLoadData;
      vm.hasEngineTemperatureData = engineAlarm.hasEngineTemperatureData;
      vm.hasEngineTorqueData = engineAlarm.hasEngineTorqueData;
      vm.hasFuelPressureData = engineAlarm.hasFuelPressureData;
      vm.hasFuelRateData = engineAlarm.hasFuelRateData;
      vm.hasOilTemperatureData = engineAlarm.hasOilTemperatureData;
      vm.hasRpmData = engineAlarm.hasRpmData;
      vm.hasTransmissionOilPressureData = engineAlarm.hasTransmissionOilPressureData;
      vm.hasTransmissionOilTemperatureData = engineAlarm.hasTransmissionOilTemperatureData;
      vm.hasEngineOilPressureData = engineAlarm.hasEngineOilPressureData;
      navigationService.navigation = {
        backState: 'boat.nmea_alarms',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.goBack = function () {
        $rootScope.goBack();
      };
      var min = 0;
      var engineOilTempMax = 100;
      var engineTempMax = 120;
      var transmissionOilTempMax = 100;
      var settings = sessionService.getUserSettings();
      var tempSetting = settings.find(function (x) {
        return x.id === settingEnum.Temperature.id
      });
      if (tempSetting && tempSetting.userSettingViewModel) {
        //Convert to Fahrenhite
        if (tempSetting.userSettingViewModel.allow_Setting_Value == 3) {
          min = +(((min * 1.8) + 32).toFixed(1));
          engineOilTempMax = +(((engineOilTempMax * 1.8) + 32).toFixed(1));
          engineTempMax = +(((engineTempMax * 1.8) + 32).toFixed(1));
          transmissionOilTempMax = +(((transmissionOilTempMax * 1.8) + 32).toFixed(1));
        }
        //Convert to Kelvin
        if (tempSetting.userSettingViewModel.allow_Setting_Value == 24) {
          min = +((min + tempSetting.userSettingViewModel.allowed_Setting_Value.multiply_Factor).toFixed(1));
          engineOilTempMax = +((engineOilTempMax + tempSetting.userSettingViewModel.allowed_Setting_Value.multiply_Factor).toFixed(1));
          engineTempMax = +((engineTempMax + tempSetting.userSettingViewModel.allowed_Setting_Value.multiply_Factor).toFixed(1));
          transmissionOilTempMax = +((transmissionOilTempMax + tempSetting.userSettingViewModel.allowed_Setting_Value.multiply_Factor).toFixed(1));
        }
      }
      vm.nmeaEngineAlarmBoost = {
        options: {
          floor: 0,
          ceil: 100,
          step: 5,
          precision: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value) {
            return value + " psi";
          }
        },
        alarm: {
          triggerValue: 3.8
        },
        boost: false,
        instanceNumber: $stateParams.instanceNumber
      };
      vm.nmeaEngineAlarmBoost.enabled = engineAlarm.boostAlarm == null ? false : engineAlarm.boostAlarm.enabled;
      if (engineAlarm.boostAlarm && engineAlarm.boostAlarm.alarmValue != null) {
        vm.nmeaEngineAlarmBoost.alarm.triggerValue = engineAlarm.boostAlarm.alarmValue.triggerValue;
      }

      vm.nmeaEngineAlarmRpm = {
        options: {
          floor: 0,
          ceil: 40,
          step: 5,
          precision: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value) {
            return value + " rpm";
          }
        },
        alarm: {
          triggerValue: 3.8
        },
        rpm: false,
        instanceNumber: $stateParams.instanceNumber
      };
      vm.nmeaEngineAlarmRpm.enabled = engineAlarm.rpmAlarm == null ? false : engineAlarm.rpmAlarm.enabled;
      if (engineAlarm.rpmAlarm && engineAlarm.rpmAlarm.alarmValue != null) {
        vm.nmeaEngineAlarmRpm.alarm.triggerValue = engineAlarm.rpmAlarm.alarmValue.triggerValue / 100;
      }

      vm.nmeaEngineAlarmOilTemperature = {
        options: {
          floor: min,
          ceil: engineOilTempMax,
          step: 5,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value, sliderId, label) {
            switch (label) {
              case 'model':
                return '<b>' + $filter('temperature')(value) + '</b>';
              case 'high':
                return '<b>' + $filter('temperature')(value) + '</b>';
              default:
                return '<b>' + $filter('temperature')(value) + '</b>';
            }
          }
        },
        alarm: {
          min: min,
          max: engineOilTempMax
        },
        oilTemperature: false,
        instanceNumber: $stateParams.instanceNumber
      };
      vm.nmeaEngineAlarmOilTemperature.enabled = engineAlarm.oilTemperatureAlarm == null ? false : engineAlarm.oilTemperatureAlarm.enabled;
      if (engineAlarm.oilTemperatureAlarm && engineAlarm.oilTemperatureAlarm.alarmValue != null) {
        vm.nmeaEngineAlarmOilTemperature.alarm.min = engineAlarm.oilTemperatureAlarm.alarmValue.min;
        vm.nmeaEngineAlarmOilTemperature.alarm.max = engineAlarm.oilTemperatureAlarm.alarmValue.max;
      }

      vm.nmeaEngineAlarmEngineTemperature = {
        options: {
          floor: min,
          ceil: engineTempMax,
          step: 5,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value, sliderId, label) {
            switch (label) {
              case 'model':
                return '<b>' + $filter('temperature')(value) + '</b>';
              case 'high':
                return '<b>' + $filter('temperature')(value) + '</b>';
              default:
                return '<b>' + $filter('temperature')(value) + '</b>';
            }
          }
        },
        alarm: {
          min: min,
          max: engineTempMax
        },
        engineTemperature: false,
        instanceNumber: $stateParams.instanceNumber
      };
      vm.nmeaEngineAlarmEngineTemperature.enabled = engineAlarm.engineTemperatureAlarm == null ? false : engineAlarm.engineTemperatureAlarm.enabled;
      if (engineAlarm.engineTemperatureAlarm && engineAlarm.engineTemperatureAlarm.alarmValue != null) {
        vm.nmeaEngineAlarmEngineTemperature.alarm.min = engineAlarm.engineTemperatureAlarm.alarmValue.min;
        vm.nmeaEngineAlarmEngineTemperature.alarm.max = engineAlarm.engineTemperatureAlarm.alarmValue.max;
      }

      vm.nmeaEngineAlarmFuelRate = {
        options: {
          floor: 5,
          ceil: 30,
          step: 1,
          precision: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value) {
            return value + " l/hr";
          }
        },
        alarm: {
          triggerValue: 3.8
        },
        fuelRate: false,
        instanceNumber: $stateParams.instanceNumber
      };
      vm.nmeaEngineAlarmFuelRate.enabled = engineAlarm.fuelRateAlarm == null ? false : engineAlarm.fuelRateAlarm.enabled;
      if (engineAlarm.fuelRateAlarm && engineAlarm.fuelRateAlarm.alarmValue != null) {
        vm.nmeaEngineAlarmFuelRate.alarm.triggerValue = engineAlarm.fuelRateAlarm.alarmValue.triggerValue;
      }

      vm.nmeaEngineAlarmFuelPressure = {
        options: {
          floor: 0,
          ceil: 100,
          step: 5,
          precision: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value) {
            return value + " psi";
          }
        },
        alarm: {
          triggerValue: 3.8
        },
        fuelPressure: false,
        instanceNumber: $stateParams.instanceNumber
      };
      vm.nmeaEngineAlarmFuelPressure.enabled = engineAlarm.fuelPressureAlarm == null ? false : engineAlarm.fuelPressureAlarm.enabled;
      if (engineAlarm.fuelPressureAlarm && engineAlarm.fuelPressureAlarm.alarmValue != null) {
        vm.nmeaEngineAlarmFuelPressure.alarm.triggerValue = engineAlarm.fuelPressureAlarm.alarmValue.triggerValue;
      }

      vm.nmeaEngineAlarmEngineLoad = {
        options: {
          floor: 0,
          ceil: 100,
          step: 5,
          precision: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value) {
            return value + " %";
          }
        },
        alarm: {
          triggerValue: 3.8
        },
        engineLoad: false,
        instanceNumber: $stateParams.instanceNumber
      };
      vm.nmeaEngineAlarmEngineLoad.enabled = engineAlarm.engineLoadAlarm == null ? false : engineAlarm.engineLoadAlarm.enabled;
      if (engineAlarm.engineLoadAlarm && engineAlarm.engineLoadAlarm.alarmValue != null) {
        vm.nmeaEngineAlarmEngineLoad.alarm.triggerValue = engineAlarm.engineLoadAlarm.alarmValue.triggerValue;
      }

      vm.nmeaEngineAlarmEngineTorque = {
        options: {
          floor: 0,
          ceil: 100,
          step: 5,
          precision: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value) {
            return value + " %";
          }
        },
        alarm: {
          triggerValue: 3.8
        },
        engineTorque: false,
        instanceNumber: $stateParams.instanceNumber
      };
      vm.nmeaEngineAlarmEngineTorque.enabled = engineAlarm.engineTorqueAlarm == null ? false : engineAlarm.engineTorqueAlarm.enabled;
      if (engineAlarm.engineTorqueAlarm && engineAlarm.engineTorqueAlarm.alarmValue != null) {
        vm.nmeaEngineAlarmEngineTorque.alarm.triggerValue = engineAlarm.engineTorqueAlarm.alarmValue.triggerValue;
      }

      vm.nmeaEngineAlarmAlternatorPotential = {
        options: {
          floor: 0,
          ceil: 50,
          step: 1,
          precision: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'orangered'
          },
          translate: function (value) {
            return value + " V";
          }
        },
        alarm: {
          triggerValue: 3.8
        },
        alternatorPotential: false,
        instanceNumber: $stateParams.instanceNumber
      };
      vm.nmeaEngineAlarmAlternatorPotential.enabled = engineAlarm.alternatorPotentialAlarm == null ? false : engineAlarm.alternatorPotentialAlarm.enabled;
      if (engineAlarm.alternatorPotentialAlarm && engineAlarm.alternatorPotentialAlarm.alarmValue != null) {
        vm.nmeaEngineAlarmAlternatorPotential.alarm.triggerValue = engineAlarm.alternatorPotentialAlarm.alarmValue.triggerValue;
      }

      vm.nmeaEngineAlarmTransmissionOilPressure = {
        options: {
          floor: 0,
          ceil: 90,
          step: 5,
          precision: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value) {
            return value + " psi";
          }
        },
        alarm: {
          triggerValue: 3.8
        },
        transmissionOilPressure: false,
        instanceNumber: $stateParams.instanceNumber
      };
      vm.nmeaEngineAlarmTransmissionOilPressure.enabled = engineAlarm.transmissionOilPressureAlarm == null ? false : engineAlarm.transmissionOilPressureAlarm.enabled;
      if (engineAlarm.transmissionOilPressureAlarm && engineAlarm.transmissionOilPressureAlarm.alarmValue != null) {
        vm.nmeaEngineAlarmTransmissionOilPressure.alarm.triggerValue = engineAlarm.transmissionOilPressureAlarm.alarmValue.triggerValue;
      }

      vm.nmeaEngineAlarmTransmissionOilTemperature = {
        options: {
          floor: min,
          ceil: transmissionOilTempMax,
          step: 5,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value, sliderId, label) {
            switch (label) {
              case 'model':
                return '<b>' + $filter('temperature')(value) + '</b>';
              case 'high':
                return '<b>' + $filter('temperature')(value) + '</b>';
              default:
                return '<b>' + $filter('temperature')(value) + '</b>';
            }
          }
        },
        alarm: {
          min: min,
          max: transmissionOilTempMax
        },
        transmissionOilTemperature: false,
        instanceNumber: $stateParams.instanceNumber
      };
      vm.nmeaEngineAlarmTransmissionOilTemperature.enabled = engineAlarm.transmissionOilTemperatureAlarm == null ? false : engineAlarm.transmissionOilTemperatureAlarm.enabled;
      if (engineAlarm.transmissionOilTemperatureAlarm && engineAlarm.transmissionOilTemperatureAlarm.alarmValue != null) {
        vm.nmeaEngineAlarmTransmissionOilTemperature.alarm.min = engineAlarm.transmissionOilTemperatureAlarm.alarmValue.min;
        vm.nmeaEngineAlarmTransmissionOilTemperature.alarm.max = engineAlarm.transmissionOilTemperatureAlarm.alarmValue.max;
      }

      vm.nmeaEngineAlarmEngineOilPressure = {
        options: {
          floor: 0,
          ceil: 100,
          step: 5,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value, sliderId, label) {
            switch (label) {
              case 'model':
                return '<b>' + value + " psi" + '</b>';
              case 'high':
                return '<b>' + value + " psi" + '</b>';
              default:
                return '<b>' + value + " psi" + '</b>';
            }
          }
        },
        alarm: {
          min: 0,
          max: 0
        },
        engineOilPressure: false,
        instanceNumber: $stateParams.instanceNumber
      };
      vm.nmeaEngineAlarmEngineOilPressure.enabled = engineAlarm.engineOilPressureAlarm == null ? false : engineAlarm.engineOilPressureAlarm.enabled;
      if (engineAlarm.engineOilPressureAlarm && engineAlarm.engineOilPressureAlarm.alarmValue != null) {
        vm.nmeaEngineAlarmEngineOilPressure.alarm.min = engineAlarm.engineOilPressureAlarm.alarmValue.min;
        vm.nmeaEngineAlarmEngineOilPressure.alarm.max = engineAlarm.engineOilPressureAlarm.alarmValue.max;
      }




      vm.engineHoursAlerts = [];
      if (engineAlarm.engineHoursAlarm && engineAlarm.engineHoursAlarm.alarmValue.length > 0) {
        vm.engineHoursAlerts = engineAlarm.engineHoursAlarm.alarmValue;
      }

      vm.deleteEngineHourAlert = function (engineHoursAlert) {
        var alertToDelete = vm.engineHoursAlerts.find(function (alert) {
          return alert.description == engineHoursAlert.description && alert.hours == engineHoursAlert.hours;
        });
        var indexToDelete = vm.engineHoursAlerts.indexOf(alertToDelete);
        vm.engineHoursAlerts.splice(indexToDelete, 1);
      };

      vm.addEngineHourAlert = function () {
        if (vm.engineHoursAlerts.length < 10) {
          var alert = {
            hours: "",
            description: ""
          }
          vm.engineHoursAlerts.push(alert);
        } else {
          toastr.error("Max Limit Reached!!");
        }
      };


      vm.updateAlarms = function () {
        vm.engineHoursAlarm = {
          enabled: false,
          alarm: vm.engineHoursAlerts,
          instanceNumber: $stateParams.instanceNumber
        }
        if (vm.engineHoursAlerts.length > 0) {
          var emptyHoursField = vm.engineHoursAlerts.find(function (engineHoursAlert) {
            return engineHoursAlert.hours == "" || engineHoursAlert.hours == undefined;
          });
          var emptyDescriptionField = vm.engineHoursAlerts.find(function (engineHoursAlert) {
            return engineHoursAlert.description == "" || engineHoursAlert.description == undefined;
          });
          if (emptyHoursField != undefined || emptyDescriptionField != undefined) {
            toastr.error('Please Enter Valid Alert Data!');
            return;
          } else {
            vm.engineHoursAlarm.enabled = true;
          }
        }
        nmeaService.updateEngineAlarm($stateParams.sentinelId, {
          rpmAlarm: angular.copy(vm.nmeaEngineAlarmRpm),
          fuelPressureAlarm: angular.copy(vm.nmeaEngineAlarmFuelPressure),
          fuelRateAlarm: angular.copy(vm.nmeaEngineAlarmFuelRate),
          transmissionOilPressureAlarm: angular.copy(vm.nmeaEngineAlarmTransmissionOilPressure),
          engineTemperatureAlarm: angular.copy(vm.nmeaEngineAlarmEngineTemperature),
          oilTemperatureAlarm: angular.copy(vm.nmeaEngineAlarmOilTemperature),
          engineLoadAlarm: angular.copy(vm.nmeaEngineAlarmEngineLoad),
          engineTorqueAlarm: angular.copy(vm.nmeaEngineAlarmEngineTorque),
          alternatorPotentialAlarm: angular.copy(vm.nmeaEngineAlarmAlternatorPotential),
          boostAlarm: angular.copy(vm.nmeaEngineAlarmBoost),
          transmissionOilTemperatureAlarm: angular.copy(vm.nmeaEngineAlarmTransmissionOilTemperature),
          engineHoursAlarm: angular.copy(vm.engineHoursAlarm),
          engineOilPressureAlarm: angular.copy(vm.nmeaEngineAlarmEngineOilPressure)
        }, function () {
          toastr.success('Engine Alarms Updated');
          $state.go('boat.nmea_alarms', {
            sentinelId: $stateParams.sentinelId
          });
        });
      }

      vm.hasSupportForFeature = function (hasData) {
        if (!hasData) {
          toastr.error("Your NMEA network does not support this feature!");
        }
      }

      vm.hasAccess = false;
      vm.canUserAccessTheSentinel = function () {
        sentinelService.canUserAccessTheSentinel($stateParams.sentinelId, function (response) {
          if (response != null) {
            vm.hasAccess = response;
          } else {
            vm.hasAccess = true;
          }
        });
      }
      vm.canUserAccessTheSentinel();
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.forum', ['yatch-sentinel.services'])
    .config(function ($stateProvider,$translatePartialLoaderProvider) {
      $stateProvider
        .state('forum', {
          url: '/forum/:sentinelId',
          templateUrl: 'app/main/forum/index/index.html',
          controller:'forumIndexController',
          controllerAs: 'vm',
          resolve: {
            forumCategories: function (tenantService) {
              return tenantService.getAllTenantCategories();
            },
            forumCategoriesHierarchy:function(tenantService)
            {
              return tenantService.getCategoriesHierarchy();
            },
            latestPosts:function(tenantService)
            {
              return tenantService.getLatestPosts();
            }
          }
        }).state('forum_category', {
          url: '/:sentinelId/category/:categoryId',
          templateUrl: 'app/main/forum/category/category.html',
          controller:'forumCategoryController',
          controllerAs: 'vm',
          resolve: {
            forumCategory: function (tenantService,$stateParams) {
              return tenantService.getTenantCategory($stateParams.categoryId);
            },
            forumCategoryPosts:function(tenantService,$stateParams)
            {
              return tenantService.getForumCategoryPosts($stateParams.categoryId);
            },
            forumCategoriesHierarchy:function(tenantService)
            {
              return tenantService.getCategoriesHierarchy();
            },
            latestPosts:function(tenantService)
            {
              return tenantService.getLatestPosts();
            }
          }
        }).state('forum_post', {
          url: '/:sentinelId/category/:categoryId/post/:postId',
          templateUrl: 'app/main/forum/category/post/post.html',
          controller:'forumPostController',
          controllerAs: 'vm',
          resolve: {
            forumPosts: function (tenantService,$stateParams) {
              return tenantService.getForumPosts($stateParams.categoryId,$stateParams.postId);
            },
            forumCategory: function (tenantService,$stateParams) {
              return tenantService.getTenantCategory($stateParams.categoryId);
            },
            latestPosts:function(tenantService)
            {
              return tenantService.getLatestPosts();
            }
          }
        });
        $translatePartialLoaderProvider.addPart('app/main/forum/index');
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.forum')
    .controller('forumPostController', function ($stateParams,$sce, $timeout, latestPosts, forumPosts, toastr, forumCategory, config, sessionService, userService, $stateParams, tenantService, cfpLoadingBar, $timeout) {
      var vm = this;
      vm.show = false;
      vm.disableButton = false;
      vm.showProgressBar = false;
      vm.flowProgressValue = 0;
      vm.latestPosts = latestPosts;
      vm.sentinelId = $stateParams.sentinelId;
      vm.stateCheck=true;
      vm.chk=sessionService.getLoginState();
      if(vm.chk=="redirect")
      {
        vm.stateCheck=false;
      }
      vm.forum = {
        title: "message",
        forumAttachmentIds: []
      };
      vm.hideCategory = true;
      vm.forumPosts = forumPosts;
      vm.forumCategory = forumCategory;
      vm.categoryId = forumCategory.id;
      vm.categoryName = forumCategory.name;
      var post = vm.forumPosts.filter(function (p) {
        return p.parentForumPostId == null;
      });

      if (post.length > 0) {
        vm.mainPost = post[0];
      }
      vm.hideDialog = function (hide) {
        vm.show = false;
      };
      vm.loggedInProfilePicture = config.apiUrl + sessionService.getUser().profilePicture + '?access_token=' + sessionService.getAuthToken().access_token;
      console.log(vm.loggedInProfilePicture);
      vm.getProfileImageLinks = function () {

        angular.forEach(vm.forumPosts, function (post, key) {
          post.description = $sce.trustAsHtml(post.description);
          post.profilePicture = config.apiUrl + post.user.profilePicture + '?access_token=' + sessionService.getAuthToken().access_token;
        });
        angular.forEach(vm.latestPosts, function (post, key) {
          post.profilePicture = config.apiUrl + post.user.profilePicture + '?access_token=' + sessionService.getAuthToken().access_token;
        });
      }
      vm.updateNumberOfViews = function (id) {
        tenantService.updateNumberOfViews(id, function (response) {

        });
      }
      vm.createForumPostMessage = function (form) {
        userService.createForumPostMessage($stateParams.categoryId, $stateParams.postId, vm.forum, function (response) {
          toastr.success("Message Posted Successfully.");
          vm.forum = {
            title: "message",
            forumAttachmentIds: [],
            description: ""
          };
          vm.uploadedFiles = [];
          $timeout(function () {
            form.$setPristine();
            form.$setUntouched();
            form.$submitted = false;
          });
          tenantService.getForumPosts(vm.forumCategory.id, $stateParams.postId, function (response) {
            vm.forumPosts = response;
            vm.getProfileImageLinks();
          })
        });
      }
      vm.uploadedFiles = [];
      vm.uploadApi = {

        target: config.apiUrl + "api/attachment/",
        headers: {
          Authorization: 'Bearer ' + sessionService.getAuthToken().access_token
        },
        method: 'POST',
        permanentErrors: [500, 501],
        singleFile: true,
        chunkSize: Number.MAX_VALUE
      };
      vm.onUploadStarted = function (file, flow) {
        vm.showProgressBar = true;
        vm.disableButton = true;
      };

      vm.flowProgress = function (flow) {
        vm.flowProgressValue = flow.progress() * 100;
      }

      vm.onUploadComplete = function () {
        vm.showProgressBar = false;
        vm.disableButton = false;
      };
      vm.onUploadSuccess = function (file, $attachmentId) {
        cfpLoadingBar.complete();
        var attachmentId = Number($attachmentId);

        vm.forum.forumAttachmentIds.push(attachmentId);
        file.attachmentId = $attachmentId;
        vm.uploadedFiles.push(file);
        toastr.success('File Uploaded successfully');
      };

      vm.deleteUploadedFile = function (file) {
        if (confirm("Are you sure you want to Delete this File?")) {
          const fileIndexToDelete = vm.uploadedFiles.indexOf(file);
          vm.uploadedFiles.splice(fileIndexToDelete, 1);
          const attachmentIndexToDelete = vm.forum.forumAttachmentIds.filter(function (index) {
            return index == file.attachmentId;
          });
          const removedAttachmentId = vm.forum.forumAttachmentIds.indexOf(attachmentIndexToDelete[0]);
          vm.forum.forumAttachmentIds.splice(removedAttachmentId, 1);
          toastr.success("File Deleted Successfully.");
        }
      };
      vm.downloadFile = function (file) {
        userService
          .downloadForumAttachment(file.id, function (response) {
            window.open(response);
          });
      };
      vm.getProfileImageLinks();
      vm.updateNumberOfViews($stateParams.postId);
      $timeout(function () {
        var divs = $('.m_m_area_wrap_fm iframe');
        for (var i = 0; i < divs.length; i++) {
          var iframe = $(divs[i]);
          if (iframe.length > 0) {
            iframe[0].setAttribute('width', '100%');
            iframe[0].setAttribute('height', '350px');
          }
        }
      }, 0);
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .service('nmeaAlarm10Service', function () {
      return {
        data: []
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('nmeaAlarm10HeaderController', function (nmeaAlarm10Service) {
      var vm = this;
      if (nmeaAlarm10Service.data.nmeaAlarm10) {
        vm.lastUpdated = nmeaAlarm10Service.data.nmeaAlarm10.dateUpdated == null ? nmeaAlarm10Service.data.nmeaAlarm10.dateAdded : nmeaAlarm10Service.data.nmeaAlarm10.dateUpdated;
      } else {
        vm.lastUpdated = 'None';
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('nmeaAlarm10Controller', function (hasWindSpeedDbData, settingEnum, sessionService, $filter, windSpeedAlarm, navigationService, toastr, $state, sentinelService, nmeaService, $stateParams, $rootScope) {
      var vm = this;
      vm.hasWindSpeedDbData = hasWindSpeedDbData;

      navigationService.navigation = {
        backState: 'boat.nmea_alarms',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.goBack = function () {
        $rootScope.goBack();
      };
      var minSpeed = 0;
      var maxSpeed = 120;
      var settings = sessionService.getUserSettings();
      var speedSetting = settings.find(function (x) {
        return x.id === settingEnum.Speed.id
      });
      if (speedSetting && speedSetting.userSettingViewModel) {
        //Convert From Primary Unit
        minSpeed = +((minSpeed * speedSetting.userSettingViewModel.allowed_Setting_Value.multiply_Factor).toFixed(1));
        maxSpeed = +((maxSpeed * speedSetting.userSettingViewModel.allowed_Setting_Value.multiply_Factor).toFixed(1));
      }
      vm.nmeaAlarm10WindSpeed = {
        options: {
          floor: minSpeed,
          ceil: maxSpeed,
          step: 5,
          precision: 5,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value, sliderId, label) {
            switch (label) {
              case 'model':
                return '<b>' + $filter('speed')(value) + '</b>';
              case 'high':
                return '<b>' + $filter('speed')(value) + '</b>';
              default:
                return '<b>' + $filter('speed')(value) + '</b>';
            }
          }
        },
        alarm: {
          triggerValue: 3.8
        },
        windSpeed: false
      };
      vm.nmeaAlarm10WindSpeed.enabled = windSpeedAlarm == null ? false : windSpeedAlarm.enabled;
      if (windSpeedAlarm && windSpeedAlarm.alarmValue != null) {
        vm.nmeaAlarm10WindSpeed.alarm.triggerValue = windSpeedAlarm.alarmValue.triggerValue;
      }

      vm.updateAlarms = function () {
        nmeaService.updateWindSpeedAlarm($stateParams.sentinelId, angular.copy(vm.nmeaAlarm10WindSpeed), function () {
          toastr.success('Wind speed Alarm Updated');
          $state.go('boat.nmea_alarms', {
            sentinelId: $stateParams.sentinelId
          });
        });
      }

      vm.hasSupportForFeature = function (hasData) {
        if (!hasData) {
          toastr.error("Your NMEA network does not support this feature!");
        }
      }

      vm.hasAccess = false;
      vm.canUserAccessTheSentinel = function () {
        sentinelService.canUserAccessTheSentinel($stateParams.sentinelId, function (response) {
          if (response != null) {
            vm.hasAccess = response;
          } else {
            vm.hasAccess = true;
          }
        });
      }
      vm.canUserAccessTheSentinel();
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .service('nmeaAlarm2Service', function () {
      return {
        data: []
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('nmeaAlarm2HeaderController', function (nmeaAlarm2Service) {
      var vm = this;
      if (nmeaAlarm2Service.data.nmeaAlarm2) {
        vm.lastUpdated = nmeaAlarm2Service.data.nmeaAlarm2.dateUpdated == null ? nmeaAlarm2Service.data.nmeaAlarm2.dateAdded : nmeaAlarm2Service.data.nmeaAlarm2.dateUpdated;
      } else {
        vm.lastUpdated = 'None';
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('nmeaAlarm2Controller', function (hasWaterDepthDbData, settingEnum, sessionService, $filter, waterDepthAlarm, navigationService, toastr, $state, sentinelService, nmeaService, $stateParams, $rootScope) {
      var vm = this;
      vm.hasWaterDepthDbData = hasWaterDepthDbData;

      navigationService.navigation = {
        backState: 'boat.nmea_alarms',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.goBack = function () {
        $rootScope.goBack();
      };
      var minDepth = 0;
      var maxDepth = 8;
      var settings = sessionService.getUserSettings();
      var heightSetting = settings.find(function (x) {
        return x.id === settingEnum.Height.id
      });
      if (heightSetting && heightSetting.userSettingViewModel) {
        //Convert From Primary Unit
        minDepth = +((minDepth * heightSetting.userSettingViewModel.allowed_Setting_Value.multiply_Factor).toFixed(1));
        maxDepth = +((maxDepth * heightSetting.userSettingViewModel.allowed_Setting_Value.multiply_Factor).toFixed(1));
      }
      vm.nmeaAlarm2WaterDepth = {
        options: {
          floor: minDepth,
          ceil: maxDepth,
          step: 1,
          precision: 1,
          disabled: true,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'orangered'
          },
          translate: function (value, sliderId, label) {
            switch (label) {
              case 'model':
                return '<b>' + $filter('height')(value) + '</b>';
              case 'high':
                return '<b>' + $filter('height')(value) + '</b>';
              default:
                return '<b>' + $filter('height')(value) + '</b>';
            }
          }
        },
        alarm: {
          triggerValue: 3.8
        },
        waterDepth: false
      };
      vm.nmeaAlarm2WaterDepth.enabled = waterDepthAlarm == null ? false : waterDepthAlarm.enabled;
      if (waterDepthAlarm && waterDepthAlarm.alarmValue != null) {
        vm.nmeaAlarm2WaterDepth.alarm.triggerValue = waterDepthAlarm.alarmValue.triggerValue;
      }

      vm.updateAlarms = function () {
        nmeaService.updateWaterDepthAlarm($stateParams.sentinelId, angular.copy(vm.nmeaAlarm2WaterDepth), function () {
          toastr.success('Water Depth Alarm Updated');
          $state.go('boat.nmea_alarms', {
            sentinelId: $stateParams.sentinelId
          });
        });
      }

      vm.hasAccess = false;
      vm.canUserAccessTheSentinel = function () {
        sentinelService.canUserAccessTheSentinel($stateParams.sentinelId, function (response) {
          if (response != null) {
            vm.hasAccess = response;
          } else {
            vm.hasAccess = true;
          }
        });
      }
      vm.canUserAccessTheSentinel();
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .service('nmeaAlarm8Service', function () {
      return {
        data: []
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('nmeaAlarm8HeaderController', function (nmeaAlarm8Service) {
      var vm = this;
      if (nmeaAlarm8Service.data.nmeaAlarm8) {
        vm.lastUpdated = nmeaAlarm8Service.data.nmeaAlarm8.dateUpdated == null ? nmeaAlarm8Service.data.nmeaAlarm8.dateAdded : nmeaAlarm8Service.data.nmeaAlarm8.dateUpdated;
      } else {
        vm.lastUpdated = 'None';
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('nmeaAlarm8Controller', function (tempHumidityAlarm, navigationService, toastr, sentinelService, nmeaService, $state, $filter, $stateParams, settingEnum, sessionService, $rootScope) {
      var vm = this;
      vm.hasBailWellTempData = tempHumidityAlarm.hasBailWellTempData;
      vm.hasDewPointTempData = tempHumidityAlarm.hasDewPointTempData;
      vm.hasEngineRoomTempData = tempHumidityAlarm.hasEngineRoomTempData;
      vm.hasExhaustGasTempData = tempHumidityAlarm.hasExhaustGasTempData;
      vm.hasFreezerTempData = tempHumidityAlarm.hasFreezerTempData;
      vm.hasHeatingSystemTempData = tempHumidityAlarm.hasHeatingSystemTempData;
      vm.hasInsideHumidityData = tempHumidityAlarm.hasInsideHumidityData;
      vm.hasInsideTempData = tempHumidityAlarm.hasInsideTempData;
      vm.hasLiveWellTempData = tempHumidityAlarm.hasLiveWellTempData;
      vm.hasMainCabinTempData = tempHumidityAlarm.hasMainCabinTempData;
      vm.hasOutsideHumidityData = tempHumidityAlarm.hasOutsideHumidityData;
      vm.hasOutsideTempData = tempHumidityAlarm.hasOutsideTempData;
      vm.hasReferigerationTempData = tempHumidityAlarm.hasReferigerationTempData;
      vm.hasSeaTempData = tempHumidityAlarm.hasSeaTempData;
      vm.hasWindChillTempData = tempHumidityAlarm.hasWindChillTempData;

      navigationService.navigation = {
        backState: 'boat.nmea_alarms',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.goBack = function () {
        $rootScope.goBack();
      };
      var min = -20;
      var max = 60;
      var minHumidity = -20;
      var maxHumidity = 60;
      var settings = sessionService.getUserSettings();
      var tempSetting = settings.find(function (x) {
        return x.id === settingEnum.Temperature.id
      });
      if (tempSetting && tempSetting.userSettingViewModel) {
        //Convert to Fahrenhite
        if (tempSetting.userSettingViewModel.allow_Setting_Value == 3) {
          min = +(((min * 1.8) + 32).toFixed(1));
          max = +(((max * 1.8) + 32).toFixed(1));
        }
        //Convert to Kelvin
        if (tempSetting.userSettingViewModel.allow_Setting_Value == 24) {
          min = +((min + tempSetting.userSettingViewModel.allowed_Setting_Value.multiply_Factor).toFixed(1));
          max = +((max + tempSetting.userSettingViewModel.allowed_Setting_Value.multiply_Factor).toFixed(1));
        }
      }
      vm.nmeaAlarm8SeaTemperature = {
        options: {
          floor: min,
          ceil: max,
          step: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value, sliderId, label) {
            switch (label) {
              case 'model':
                return '<b>' + $filter('temperature')(value) + '</b>';
              case 'high':
                return '<b>' + $filter('temperature')(value) + '</b>';
              default:
                return '<b>' + $filter('temperature')(value) + '</b>';
            }
          }
        },
        alarm: {
          min: min,
          max: max
        },
        seaTemperature: false
      };
      vm.nmeaAlarm8SeaTemperature.enabled = tempHumidityAlarm.seaTempAlarm == null ? false : tempHumidityAlarm.seaTempAlarm.enabled;
      if (tempHumidityAlarm.seaTempAlarm && tempHumidityAlarm.seaTempAlarm.alarmValue != null) {
        vm.nmeaAlarm8SeaTemperature.alarm.min = tempHumidityAlarm.seaTempAlarm.alarmValue.min;
        vm.nmeaAlarm8SeaTemperature.alarm.max = tempHumidityAlarm.seaTempAlarm.alarmValue.max;
      }

      vm.nmeaAlarm8OutsideTemperature = {
        options: {
          floor: min,
          ceil: max,
          step: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value, sliderId, label) {
            switch (label) {
              case 'model':
                return '<b>' + $filter('temperature')(value) + '</b>';
              case 'high':
                return '<b>' + $filter('temperature')(value) + '</b>';
              default:
                return '<b>' + $filter('temperature')(value) + '</b>';
            }
          }
        },
        alarm: {
          min: min,
          max: max
        },
        outsideTemperature: false
      };
      vm.nmeaAlarm8OutsideTemperature.enabled = tempHumidityAlarm.outsideTempAlarm == null ? false : tempHumidityAlarm.outsideTempAlarm.enabled;
      if (tempHumidityAlarm.outsideTempAlarm && tempHumidityAlarm.outsideTempAlarm.alarmValue != null) {
        vm.nmeaAlarm8OutsideTemperature.alarm.min = tempHumidityAlarm.outsideTempAlarm.alarmValue.min;
        vm.nmeaAlarm8OutsideTemperature.alarm.max = tempHumidityAlarm.outsideTempAlarm.alarmValue.max;
      }

      vm.nmeaAlarm8InsideTemperature = {
        options: {
          floor: min,
          ceil: max,
          step: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value, sliderId, label) {
            switch (label) {
              case 'model':
                return '<b>' + $filter('temperature')(value) + '</b>';
              case 'high':
                return '<b>' + $filter('temperature')(value) + '</b>';
              default:
                return '<b>' + $filter('temperature')(value) + '</b>';
            }
          }
        },
        alarm: {
          min: min,
          max: max
        },
        insideTemperature: false
      };
      vm.nmeaAlarm8InsideTemperature.enabled = tempHumidityAlarm.insideTempAlarm == null ? false : tempHumidityAlarm.insideTempAlarm.enabled;
      if (tempHumidityAlarm.insideTempAlarm && tempHumidityAlarm.insideTempAlarm.alarmValue != null) {
        vm.nmeaAlarm8InsideTemperature.alarm.min = tempHumidityAlarm.insideTempAlarm.alarmValue.min;
        vm.nmeaAlarm8InsideTemperature.alarm.max = tempHumidityAlarm.insideTempAlarm.alarmValue.max;
      }

      vm.nmeaAlarm8EngineRoomTemperature = {
        options: {
          floor: min,
          ceil: max,
          step: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value, sliderId, label) {
            switch (label) {
              case 'model':
                return '<b>' + $filter('temperature')(value) + '</b>';
              case 'high':
                return '<b>' + $filter('temperature')(value) + '</b>';
              default:
                return '<b>' + $filter('temperature')(value) + '</b>';
            }
          }
        },
        alarm: {
          min: min,
          max: max
        },
        roomTemperature: false
      };
      vm.nmeaAlarm8EngineRoomTemperature.enabled = tempHumidityAlarm.engineRoomTempAlarm == null ? false : tempHumidityAlarm.engineRoomTempAlarm.enabled;
      if (tempHumidityAlarm.engineRoomTempAlarm && tempHumidityAlarm.engineRoomTempAlarm.alarmValue != null) {
        vm.nmeaAlarm8EngineRoomTemperature.alarm.min = tempHumidityAlarm.engineRoomTempAlarm.alarmValue.min;
        vm.nmeaAlarm8EngineRoomTemperature.alarm.max = tempHumidityAlarm.engineRoomTempAlarm.alarmValue.max;
      }

      vm.nmeaAlarm8MainCabinTemperature = {
        options: {
          floor: min,
          ceil: max,
          step: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value, sliderId, label) {
            switch (label) {
              case 'model':
                return '<b>' + $filter('temperature')(value) + '</b>';
              case 'high':
                return '<b>' + $filter('temperature')(value) + '</b>';
              default:
                return '<b>' + $filter('temperature')(value) + '</b>';
            }
          }
        },
        alarm: {
          min: min,
          max: max
        },
        cabinTemperature: false
      };
      vm.nmeaAlarm8MainCabinTemperature.enabled = tempHumidityAlarm.mainCabinTempAlarm == null ? false : tempHumidityAlarm.mainCabinTempAlarm.enabled;
      if (tempHumidityAlarm.mainCabinTempAlarm && tempHumidityAlarm.mainCabinTempAlarm.alarmValue != null) {
        vm.nmeaAlarm8MainCabinTemperature.alarm.min = tempHumidityAlarm.mainCabinTempAlarm.alarmValue.min;
        vm.nmeaAlarm8MainCabinTemperature.alarm.max = tempHumidityAlarm.mainCabinTempAlarm.alarmValue.max;
      }

      vm.nmeaAlarm8LiveWellTemperature = {
        options: {
          floor: min,
          ceil: max,
          step: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value, sliderId, label) {
            switch (label) {
              case 'model':
                return '<b>' + $filter('temperature')(value) + '</b>';
              case 'high':
                return '<b>' + $filter('temperature')(value) + '</b>';
              default:
                return '<b>' + $filter('temperature')(value) + '</b>';
            }
          }
        },
        alarm: {
          min: min,
          max: max
        },
        liveWellTemperature: false
      };
      vm.nmeaAlarm8LiveWellTemperature.enabled = tempHumidityAlarm.liveWellTempAlarm == null ? false : tempHumidityAlarm.liveWellTempAlarm.enabled;
      if (tempHumidityAlarm.liveWellTempAlarm && tempHumidityAlarm.liveWellTempAlarm.alarmValue != null) {
        vm.nmeaAlarm8LiveWellTemperature.alarm.min = tempHumidityAlarm.liveWellTempAlarm.alarmValue.min;
        vm.nmeaAlarm8LiveWellTemperature.alarm.max = tempHumidityAlarm.liveWellTempAlarm.alarmValue.max;
      }

      vm.nmeaAlarm8BailWellTemperature = {
        options: {
          floor: min,
          ceil: max,
          step: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value, sliderId, label) {
            switch (label) {
              case 'model':
                return '<b>' + $filter('temperature')(value) + '</b>';
              case 'high':
                return '<b>' + $filter('temperature')(value) + '</b>';
              default:
                return '<b>' + $filter('temperature')(value) + '</b>';
            }
          }
        },
        alarm: {
          min: min,
          max: max
        },
        bailWellTemperature: false
      };
      vm.nmeaAlarm8BailWellTemperature.enabled = tempHumidityAlarm.bailWellTempAlarm == null ? false : tempHumidityAlarm.bailWellTempAlarm.enabled;
      if (tempHumidityAlarm.bailWellTempAlarm && tempHumidityAlarm.bailWellTempAlarm.alarmValue != null) {
        vm.nmeaAlarm8BailWellTemperature.alarm.min = tempHumidityAlarm.bailWellTempAlarm.alarmValue.min;
        vm.nmeaAlarm8BailWellTemperature.alarm.max = tempHumidityAlarm.bailWellTempAlarm.alarmValue.max;
      }

      vm.nmeaAlarm8RefrigerationTemperature = {
        options: {
          floor: min,
          ceil: max,
          step: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value, sliderId, label) {
            switch (label) {
              case 'model':
                return '<b>' + $filter('temperature')(value) + '</b>';
              case 'high':
                return '<b>' + $filter('temperature')(value) + '</b>';
              default:
                return '<b>' + $filter('temperature')(value) + '</b>';
            }
          }
        },
        alarm: {
          min: min,
          max: max
        },
        refrigerationTemperature: false
      };
      vm.nmeaAlarm8RefrigerationTemperature.enabled = tempHumidityAlarm.referigerationTempAlarm == null ? false : tempHumidityAlarm.referigerationTempAlarm.enabled;
      if (tempHumidityAlarm.referigerationTempAlarm && tempHumidityAlarm.referigerationTempAlarm.alarmValue != null) {
        vm.nmeaAlarm8RefrigerationTemperature.alarm.min = tempHumidityAlarm.referigerationTempAlarm.alarmValue.min;
        vm.nmeaAlarm8RefrigerationTemperature.alarm.max = tempHumidityAlarm.referigerationTempAlarm.alarmValue.max;
      }

      vm.nmeaAlarm8HeatingSystemTemperature = {
        options: {
          floor: min,
          ceil: max,
          step: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value, sliderId, label) {
            switch (label) {
              case 'model':
                return '<b>' + $filter('temperature')(value) + '</b>';
              case 'high':
                return '<b>' + $filter('temperature')(value) + '</b>';
              default:
                return '<b>' + $filter('temperature')(value) + '</b>';
            }
          }
        },
        alarm: {
          min: min,
          max: max
        },
        heatingSystemTemperature: false
      };
      vm.nmeaAlarm8HeatingSystemTemperature.enabled = tempHumidityAlarm.heatingSystemTempAlarm == null ? false : tempHumidityAlarm.heatingSystemTempAlarm.enabled;
      if (tempHumidityAlarm.heatingSystemTempAlarm && tempHumidityAlarm.heatingSystemTempAlarm.alarmValue != null) {
        vm.nmeaAlarm8HeatingSystemTemperature.alarm.min = tempHumidityAlarm.heatingSystemTempAlarm.alarmValue.min;
        vm.nmeaAlarm8HeatingSystemTemperature.alarm.max = tempHumidityAlarm.heatingSystemTempAlarm.alarmValue.max;
      }

      vm.nmeaAlarm8DewPointTemperature = {
        options: {
          floor: min,
          ceil: max,
          step: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value, sliderId, label) {
            switch (label) {
              case 'model':
                return '<b>' + $filter('temperature')(value) + '</b>';
              case 'high':
                return '<b>' + $filter('temperature')(value) + '</b>';
              default:
                return '<b>' + $filter('temperature')(value) + '</b>';
            }
          }
        },
        alarm: {
          min: min,
          max: max
        },
        dewPointTemperature: false
      };
      vm.nmeaAlarm8DewPointTemperature.enabled = tempHumidityAlarm.dewPointTempAlarm == null ? false : tempHumidityAlarm.dewPointTempAlarm.enabled;
      if (tempHumidityAlarm.dewPointTempAlarm && tempHumidityAlarm.dewPointTempAlarm.alarmValue != null) {
        vm.nmeaAlarm8DewPointTemperature.alarm.min = tempHumidityAlarm.dewPointTempAlarm.alarmValue.min;
        vm.nmeaAlarm8DewPointTemperature.alarm.max = tempHumidityAlarm.dewPointTempAlarm.alarmValue.max;
      }

      vm.nmeaAlarm8WindChillTemperature = {
        options: {
          floor: min,
          ceil: max,
          step: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value, sliderId, label) {
            switch (label) {
              case 'model':
                return '<b>' + $filter('temperature')(value) + '</b>';
              case 'high':
                return '<b>' + $filter('temperature')(value) + '</b>';
              default:
                return '<b>' + $filter('temperature')(value) + '</b>';
            }
          }
        },
        alarm: {
          min: min,
          max: max
        },
        windChillTemperature: false
      };
      vm.nmeaAlarm8WindChillTemperature.enabled = tempHumidityAlarm.windChillTempAlarm == null ? false : tempHumidityAlarm.windChillTempAlarm.enabled;
      if (tempHumidityAlarm.windChillTempAlarm && tempHumidityAlarm.windChillTempAlarm.alarmValue != null) {
        vm.nmeaAlarm8WindChillTemperature.alarm.min = tempHumidityAlarm.windChillTempAlarm.alarmValue.min;
        vm.nmeaAlarm8WindChillTemperature.alarm.max = tempHumidityAlarm.windChillTempAlarm.alarmValue.max;
      }

      vm.nmeaAlarm8FreezerTemperature = {
        options: {
          floor: min,
          ceil: max,
          step: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value, sliderId, label) {
            switch (label) {
              case 'model':
                return '<b>' + $filter('temperature')(value) + '</b>';
              case 'high':
                return '<b>' + $filter('temperature')(value) + '</b>';
              default:
                return '<b>' + $filter('temperature')(value) + '</b>';
            }
          }
        },
        alarm: {
          min: min,
          max: max
        },
        freezerTemperature: false
      };
      vm.nmeaAlarm8FreezerTemperature.enabled = tempHumidityAlarm.freezerTempAlarm == null ? false : tempHumidityAlarm.freezerTempAlarm.enabled;
      if (tempHumidityAlarm.freezerTempAlarm && tempHumidityAlarm.freezerTempAlarm.alarmValue != null) {
        vm.nmeaAlarm8FreezerTemperature.alarm.min = tempHumidityAlarm.freezerTempAlarm.alarmValue.min;
        vm.nmeaAlarm8FreezerTemperature.alarm.max = tempHumidityAlarm.freezerTempAlarm.alarmValue.max;
      }

      vm.nmeaAlarm8ExhaustGasTemperature = {
        options: {
          floor: min,
          ceil: 100,
          step: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value, sliderId, label) {
            switch (label) {
              case 'model':
                return '<b>' + $filter('temperature')(value) + '</b>';
              case 'high':
                return '<b>' + $filter('temperature')(value) + '</b>';
              default:
                return '<b>' + $filter('temperature')(value) + '</b>';
            }
          }
        },
        alarm: {
          min: 0,
          max: 60
        },
        exhaustGasTemperature: false
      };
      vm.nmeaAlarm8ExhaustGasTemperature.enabled = tempHumidityAlarm.exhaustGasTempAlarm == null ? false : tempHumidityAlarm.exhaustGasTempAlarm.enabled;
      if (tempHumidityAlarm.exhaustGasTempAlarm && tempHumidityAlarm.exhaustGasTempAlarm.alarmValue != null) {
        vm.nmeaAlarm8ExhaustGasTemperature.alarm.min = tempHumidityAlarm.exhaustGasTempAlarm.alarmValue.min;
        vm.nmeaAlarm8ExhaustGasTemperature.alarm.max = tempHumidityAlarm.exhaustGasTempAlarm.alarmValue.max;
      }

      vm.nmeaAlarm8InsideHumidity = {
        options: {
          floor: minHumidity,
          ceil: maxHumidity,
          step: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value) {
            return value + " %";
          }
        },
        alarm: {
          min: minHumidity,
          max: maxHumidity
        },
        insideHumidity: false
      };
      vm.nmeaAlarm8InsideHumidity.enabled = tempHumidityAlarm.insideHumidityAlarm == null ? false : tempHumidityAlarm.insideHumidityAlarm.enabled;
      if (tempHumidityAlarm.insideHumidityAlarm && tempHumidityAlarm.insideHumidityAlarm.alarmValue != null) {
        vm.nmeaAlarm8InsideHumidity.alarm.min = tempHumidityAlarm.insideHumidityAlarm.alarmValue.min;
        vm.nmeaAlarm8InsideHumidity.alarm.max = tempHumidityAlarm.insideHumidityAlarm.alarmValue.max;
      }

      vm.nmeaAlarm8OutsideHumidity = {
        options: {
          floor: minHumidity,
          ceil: maxHumidity,
          step: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value) {
            return value + " %";
          }
        },
        alarm: {
          min: minHumidity,
          max: maxHumidity
        },
        outsideHumidity: false
      };
      vm.nmeaAlarm8OutsideHumidity.enabled = tempHumidityAlarm.outsideHumidityAlarm == null ? false : tempHumidityAlarm.outsideHumidityAlarm.enabled;
      if (tempHumidityAlarm.outsideHumidityAlarm && tempHumidityAlarm.outsideHumidityAlarm.alarmValue != null) {
        vm.nmeaAlarm8OutsideHumidity.alarm.min = tempHumidityAlarm.outsideHumidityAlarm.alarmValue.min;
        vm.nmeaAlarm8OutsideHumidity.alarm.max = tempHumidityAlarm.outsideHumidityAlarm.alarmValue.max;
      }

      vm.updateAlarms = function () {
        nmeaService.updateTempHumidityAlarm($stateParams.sentinelId, {
          seaTempAlarm: angular.copy(vm.nmeaAlarm8SeaTemperature),
          outsideTempAlarm: angular.copy(vm.nmeaAlarm8OutsideTemperature),
          insideTempAlarm: angular.copy(vm.nmeaAlarm8InsideTemperature),
          engineRoomTempAlarm: angular.copy(vm.nmeaAlarm8EngineRoomTemperature),
          mainCabinTempAlarm: angular.copy(vm.nmeaAlarm8MainCabinTemperature),
          liveWellTempAlarm: angular.copy(vm.nmeaAlarm8LiveWellTemperature),
          bailWellTempAlarm: angular.copy(vm.nmeaAlarm8BailWellTemperature),
          referigerationTempAlarm: angular.copy(vm.nmeaAlarm8RefrigerationTemperature),
          insideHumidityAlarm: angular.copy(vm.nmeaAlarm8InsideHumidity),
          outsideHumidityAlarm: angular.copy(vm.nmeaAlarm8OutsideHumidity),
          heatingSystemTempAlarm: angular.copy(vm.nmeaAlarm8HeatingSystemTemperature),
          dewPointTempAlarm: angular.copy(vm.nmeaAlarm8DewPointTemperature),
          windChillTempAlarm: angular.copy(vm.nmeaAlarm8WindChillTemperature),
          freezerTempAlarm: angular.copy(vm.nmeaAlarm8FreezerTemperature),
          exhaustGasTempAlarm: angular.copy(vm.nmeaAlarm8ExhaustGasTemperature)
        }, function () {
          toastr.success('Temperature and Humidity Alarms Updated');
          $state.go('boat.nmea_alarms', {
            sentinelId: $stateParams.sentinelId
          });
        });
      }

      vm.hasSupportForFeature = function (hasData) {
        if (!hasData) {
          toastr.error("Your NMEA network does not support this feature!");
        }
      }

      vm.hasAccess = false;
      vm.canUserAccessTheSentinel = function () {
        sentinelService.canUserAccessTheSentinel($stateParams.sentinelId, function (response) {
          if (response != null) {
            vm.hasAccess = response;
          } else {
            vm.hasAccess = true;
          }
        });
      }
      vm.canUserAccessTheSentinel();
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .service('nmeaAlarm7Service', function () {
      return {
        data: []
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('nmeaAlarm7HeaderController', function (nmeaAlarm7Service) {
      var vm = this;
      if (nmeaAlarm7Service.data.nmeaAlarm7) {
        vm.lastUpdated = nmeaAlarm7Service.data.nmeaAlarm7.dateUpdated == null ? nmeaAlarm7Service.data.nmeaAlarm7.dateAdded : nmeaAlarm7Service.data.nmeaAlarm7.dateUpdated;
      } else {
        vm.lastUpdated = 'None';
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('nmeaAlarm7Controller', function ( navigationService, toastr, sentinelService
      ,speedLimitAlarm, nmeaService, $state, $stateParams, $rootScope) {
      var vm = this;
      navigationService.navigation = {
        backState: 'boat.nmea_alarms',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.goBack = function () {
        $rootScope.goBack();
      };


      vm.nmeaAlarm7SpeedOverGround = {
        options: {
          floor: 0,
          ceil: 50,
          step: 1,
          precision: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value) {
            return value + " knots";
          }
        },
        alarm: {
          triggerValue: 3.8
        },
        speedOverGroundAlarm: false
      };
      vm.nmeaAlarm7SpeedOverGround.enabled = speedLimitAlarm.speedOverGroundAlarm == null ? false : speedLimitAlarm.speedOverGroundAlarm.enabled;
      if (speedLimitAlarm.speedOverGroundAlarm && speedLimitAlarm.speedOverGroundAlarm.alarmValue != null) {
        vm.nmeaAlarm7SpeedOverGround.alarm.triggerValue = speedLimitAlarm.speedOverGroundAlarm.alarmValue.triggerValue;
      }
      vm.nmeaAlarm7SpeedOverWater = {
        options: {
          floor: 0,
          ceil: 50,
          step: 1,
          precision: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value) {
            return value + " knots";
          }
        },
        alarm: {
          triggerValue: 3.8
        },
        speedOverWaterAlarm: false
      };
      vm.nmeaAlarm7SpeedOverWater.enabled = speedLimitAlarm.speedOverWaterAlarm == null ? false : speedLimitAlarm.speedOverWaterAlarm.enabled;
      if (speedLimitAlarm.speedOverWaterAlarm && speedLimitAlarm.speedOverWaterAlarm.alarmValue != null) {
        vm.nmeaAlarm7SpeedOverWater.alarm.triggerValue = speedLimitAlarm.speedOverWaterAlarm.alarmValue.triggerValue;
      }

      vm.updateAlarms = function () {
        nmeaService.updateSpeedLimitAlarm($stateParams.sentinelId, {
          speedOverGroundAlarm: angular.copy(vm.nmeaAlarm7SpeedOverGround),
          speedOverWaterAlarm: angular.copy(vm.nmeaAlarm7SpeedOverWater)
        }, function () {
          toastr.success('Speed Limit Alarms Updated');
          $state.go('boat.nmea_alarms', {
            sentinelId: $stateParams.sentinelId
          });
        });
      };

      vm.hasAccess = false;
      vm.canUserAccessTheSentinel = function () {
        sentinelService.canUserAccessTheSentinel($stateParams.sentinelId, function (response) {
          if (response != null) {
            vm.hasAccess = response;
          } else {
            vm.hasAccess = true;
          }
        });
      }
      vm.canUserAccessTheSentinel();
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .service('nmeaAlarmService', function () {
      return {
        data: []
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('nmeaPowerInstancesHeaderController', function (nmeaAlarmService) {
      var vm = this;
      if (nmeaAlarmService.data.nmeaAlarm) {
        vm.lastUpdated = nmeaAlarmService.data.nmeaAlarm.dateUpdated == null ? nmeaAlarmService.data.nmeaAlarm.dateAdded : nmeaAlarmService.data.nmeaAlarm.dateUpdated;
      } else {
        vm.lastUpdated = 'None';
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('nmeaPowerInstancesController', function (nmeaDcTypesEnum, allUserSentinelPowerInstances, navigationService, sentinelService, toastr, $stateParams, $rootScope, $state) {
      var vm = this;
      navigationService.navigation = {
        backState: 'boat.nmea_alarms',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.goBack = function () {
        $rootScope.goBack();
      };
      vm.powerInstances = allUserSentinelPowerInstances;
      vm.nmeaDcTypesEnum = nmeaDcTypesEnum;

      vm.hasAccess = false;
      vm.canUserAccessTheSentinel = function () {
        sentinelService.canUserAccessTheSentinel($stateParams.sentinelId, function (response) {
          if (response != null) {
            vm.hasAccess = response;
          } else {
            vm.hasAccess = true;
          }
        });
      }
      vm.canUserAccessTheSentinel();

      vm.goToPowerAlarm = function (instanceNumber, sourceId) {
        if (vm.hasAccess) {
          $state.go("boat.nmea_power_alarm", {
            sentinelId: $stateParams.sentinelId,
            instanceNumber: instanceNumber,
            sourceId: sourceId
          });
        } else {
          toastr.error("UnAuthorized Access!");
        }
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .service('nmeaAlarm9Service', function () {
      return {
        data: []
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('nmeaAlarm9HeaderController', function (nmeaAlarm9Service) {
      var vm = this;
      if (nmeaAlarm9Service.data.nmeaAlarm9) {
        vm.lastUpdated = nmeaAlarm9Service.data.nmeaAlarm9.dateUpdated == null ? nmeaAlarm9Service.data.nmeaAlarm9.dateAdded : nmeaAlarm9Service.data.nmeaAlarm9.dateUpdated;
      } else {
        vm.lastUpdated = 'None';
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('nmeaAlarm9Controller', function (navigationService, sentinelService, $stateParams, $rootScope) {
      var vm = this;
      navigationService.navigation = {
        backState: 'boat.nmea_alarms',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.goBack = function () {
        $rootScope.goBack();
      };
      vm.nmeaAlarm9CheckEngine = true;
      vm.nmeaAlarm9OverTemperature = true;
      vm.nmeaAlarm9LowOilPressure = true;
      vm.nmeaAlarm9LowOilLevel = true;
      vm.nmeaAlarm9LowFuelPressure = true;
      vm.nmeaAlarm9LowSystemVoltage = true;
      vm.nmeaAlarm9LowCoolantLevel = true;
      vm.nmeaAlarm9WaterFlow = true;
      vm.nmeaAlarm9WaterInFuel = true;
      vm.nmeaAlarm9ChargeIndicator = true;
      vm.nmeaAlarm9PreheatIndicator = true;
      vm.nmeaAlarm9HighBoostPressure = true;
      vm.nmeaAlarm9RevLimitExceeded = true;
      vm.nmeaAlarm9EGRSystem = true;
      vm.nmeaAlarm9EngineEmergencyStopMode = true;
      vm.nmeaAlarm9PowerReduction = true;
      vm.nmeaAlarm9EngineCommError = true;
      vm.nmeaAlarm9SubOrSecondaryThrottle = true;
      vm.nmeaAlarm9NeutralStartProtect = true;
      vm.nmeaAlarm9EngineShuttingDown = true;
      vm.nmeaAlarm9SailDrive = true;
      vm.nmeaAlarm9CheckTransmission = true;
      vm.nmeaAlarm9OverTemperatureTransmission = true;
      vm.nmeaAlarm9LowOilPressureTransmission = true;
      vm.nmeaAlarm9LowOilLevelTransmission = true;


      // if (boostAlarm != null) {
      //   vm.nmeaBoostAlarm.alarm = boostAlarm;
      //   vm.nmeaBoostAlarm.alarm.alarmValue.boost = 12;
      //   vm.nmeaBoostAlarm.alarm.alarmValue.triggerValue = 3.8;
      // }


      // if (boostAlarm != null) {
      //   vm.nmeaBoostAlarm.alarm = boostAlarm;
      //   if (vm.nmeaBoostAlarm.alarm.alarmValue.boost == 24) {
      //     vm.nmeaBoostAlarm.options.floor = 22;
      //     vm.nmeaBoostAlarm.options.ceil = 30;
      //     vm.nmeaBoostAlarm.boost = true;
      //   }
      // }

      // vm.handleSentinelBoostChange = function () {
      //   // false means 12 volts
      //   if (vm.nmeaBoostAlarm.boost == false) {
      //     vm.set12PsiSentinelBoostOption();
      //   } else {
      //     vm.set24PsiSentinelBoostOption();
      //   }
      // };
      // vm.set12PsiSentinelBoostOption = function () {
      //   vm.nmeaBoostAlarm.alarm.alarmValue.boost = 12;
      //   vm.nmeaBoostAlarm.alarm.alarmValue.triggerValue = 12.1;
      //   vm.nmeaBoostAlarm.options.floor = 12;
      //   vm.nmeaBoostAlarm.options.ceil = 15;
      // };

      // vm.set24PsiSentinelBoostOption = function () {
      //   vm.nmeaBoostAlarm.alarm.alarmValue.boost = 24;
      //   vm.nmeaBoostAlarm.alarm.alarmValue.triggerValue = 22.1;
      //   vm.nmeaBoostAlarm.options.floor = 22;
      //   vm.nmeaBoostAlarm.options.ceil = 30;
      // };


      vm.updateAlarms = function () {

      }
      vm.hasAccess = false;
      vm.canUserAccessTheSentinel = function () {
        sentinelService.canUserAccessTheSentinel($stateParams.sentinelId, function (response) {
          if (response != null) {
            vm.hasAccess = response;
          } else {
            vm.hasAccess = true;
          }
        });
      }
      vm.canUserAccessTheSentinel();
    });
})();

(function () {
  'use strict;'
  
  angular.module('yatch-sentinel.alarms')
    .service('nmeaAlarm3Service', function () {
      return {
        data: {
          location: {
            center: {
              latitude: 0,
              longitude: 0
            },
            zoom: 16
          },
          geoFenceAlarm: {

          }
        }
      };
    });
})();

(function () {
  "use strict;";
  angular
    .module("yatch-sentinel.alarms")
    .controller(
      "nmeaAlarm3MapController",
      function (nmeaAlarm3Service, $scope, $rootScope, RecenterMap, $timeout) {
        var vm = this;
        vm.goBack = function () {
          $rootScope.goBack();
        };

        vm.maxRadius = 4000;
        vm.minRadius = 200;
        $scope.$on("positionAlarmRange", function (evt, data) {
          if (!data) {
            vm.maxRadius = 200;
            vm.minRadius = 40;
          } else {
            vm.maxRadius = 4000;
            vm.minRadius = 200;
          }
        });
        vm.sentinelLocation = nmeaAlarm3Service.data.location;
        vm.geoFenceAlarm = nmeaAlarm3Service.data.geoFenceAlarm.map;
        var recenterMapControl = new RecenterMap(ol.proj.fromLonLat([0, 0]));
        vm.map = new ol.Map({
          controls: ol.control.defaults().extend([recenterMapControl]),
          target: "map",
          layers: [
            new ol.layer.Tile({
              source: new ol.source.OSM({
                attributions: [],
              }),
            }),
            new ol.layer.Tile({
              source: new ol.source.XYZ({
                url: "https://t1.openseamap.org/seamark/{z}/{x}/{y}.png",
              }),
            }),
          ],
          view: new ol.View({
            center: ol.proj.fromLonLat([0, 0]),
            zoom: 16,
          }),
        });
        if (vm.sentinelLocation && vm.sentinelLocation.center) {
          vm.map
            .getView()
            .setCenter(
              ol.proj.fromLonLat([
                vm.sentinelLocation.center.longitude,
                vm.sentinelLocation.center.latitude,
              ])
            );
          vm.map.removeControl(recenterMapControl);
          recenterMapControl = new RecenterMap(
            ol.proj.fromLonLat([
              vm.sentinelLocation.center.longitude,
              vm.sentinelLocation.center.latitude,
            ])
          );
          vm.map.addControl(recenterMapControl);

          vm.iconFeature = new ol.Feature({
            geometry: new ol.geom.Point(
              ol.proj.fromLonLat([
                vm.sentinelLocation.center.longitude,
                vm.sentinelLocation.center.latitude,
              ])
            ),
          });
          // vm.circleFeature = new ol.Feature({
          //   geometry: new ol.geom.Circle(ol.proj.fromLonLat([vm.sentinelLocation.center.longitude, vm.sentinelLocation.center.latitude]), 50)
          // });
          var iconStyle = new ol.style.Style({
            image: new ol.style.Icon({
              src: "assets/images/boat-location.png",
              scale: 1,
            }),
          });

          vm.iconFeature.setStyle(iconStyle);

          var vectorSource = new ol.source.Vector({
            features: [vm.iconFeature],
          });

          var vectorLayer = new ol.layer.Vector({
            source: vectorSource,
          });
          vm.map.addLayer(vectorLayer);

          // working on circle
          vm.circleFeature = new ol.Feature({
            geometry: new ol.geom.Circle(ol.proj.fromLonLat([0, 0]), 0),
          });
          var circleSource = new ol.source.Vector({
            features: [vm.circleFeature],
          });
          var circleLayer = new ol.layer.Vector({
            source: circleSource,
          });
          vm.map.addLayer(circleLayer);
          var modify = new ol.interaction.Modify({
            source: circleSource,
          });
          vm.map.addInteraction(modify);
          // vm.map.addInteraction(
          //   new ol.interaction.Snap({ source: circleSource })
          // );
          modify.on("modifyend", function (params) {
            var radius = vm.circleFeature.getGeometry().getRadius();
            var center = ol.proj.toLonLat(
              vm.circleFeature.getGeometry().getCenter()
            );

            if (vm.geoFenceAlarm.alarm == null) {
              nmeaAlarm3Service.data.geoFenceAlarm.map.center = {
                latitude: center[1],
                longitude: center[0],
              };
              $timeout(function () {
                if (radius <= vm.maxRadius) {
                  if(radius<=vm.minRadius){
                    vm.geoFenceAlarm.map.radius = vm.minRadius;
                    vm.circleFeature.getGeometry().setRadius(vm.minRadius);
                  }else{
                    vm.geoFenceAlarm.map.radius = radius;
                    vm.circleFeature.getGeometry().setRadius(radius);
                  }
                } else {
                  vm.geoFenceAlarm.map.radius = vm.maxRadius;
                  vm.circleFeature.getGeometry().setRadius(vm.maxRadius);
                }
              });
            }else{
              nmeaAlarm3Service.data.geoFenceAlarm.alarm.alarmValue.center = {
                latitude: center[1],
                longitude: center[0],
              };
              $timeout(function () {
                if (radius <= vm.maxRadius) {
                  if(radius<=vm.minRadius){
                    vm.geoFenceAlarm.alarm.alarmValue.radius = vm.minRadius;
                    vm.circleFeature.getGeometry().setRadius(vm.minRadius);
                  }else{
                    vm.geoFenceAlarm.alarm.alarmValue.radius = radius;
                    vm.circleFeature.getGeometry().setRadius(radius);
                  }
                } else {
                  vm.geoFenceAlarm.alarm.alarmValue.radius = vm.maxRadius;
                  vm.circleFeature.getGeometry().setRadius(vm.maxRadius);
                }
              });
            }
          });
        }
        $scope.$watch(
          function () {
            return nmeaAlarm3Service.data;
          },
          function () {
            vm.sentinelLocation = nmeaAlarm3Service.data.location;
            vm.geoFenceAlarm = nmeaAlarm3Service.data.geoFenceAlarm;

            vm.map.removeControl(recenterMapControl);
            recenterMapControl = new RecenterMap(
              ol.proj.fromLonLat([
                vm.sentinelLocation.center.longitude,
                vm.sentinelLocation.center.latitude,
              ])
            );
            vm.map.addControl(recenterMapControl);

            vm.map
              .getView()
              .setCenter(
                ol.proj.fromLonLat([
                  vm.sentinelLocation.center.longitude,
                  vm.sentinelLocation.center.latitude,
                ])
              );
            vm.iconFeature.setGeometry(
              new ol.geom.Point(
                ol.proj.fromLonLat([
                  vm.sentinelLocation.center.longitude,
                  vm.sentinelLocation.center.latitude,
                ])
              )
            );

            if (vm.geoFenceAlarm.alarm != null) {
              vm.circleFeature.setGeometry(
                new ol.geom.Circle(
                  ol.proj.fromLonLat([
                    vm.geoFenceAlarm.alarm.alarmValue.center.longitude,
                    vm.geoFenceAlarm.alarm.alarmValue.center.latitude,
                  ]),
                  vm.geoFenceAlarm.alarm.alarmValue.radius
                )
              );
            } else {
              vm.circleFeature.setGeometry(
                new ol.geom.Circle(
                  ol.proj.fromLonLat([
                    vm.geoFenceAlarm.map.center.longitude,
                    vm.geoFenceAlarm.map.center.latitude,
                  ]),
                  vm.geoFenceAlarm.map.radius
                )
              );
            }
          },
          true
        );
      }
    );
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('nmeaAlarm3HeaderController', function (nmeaAlarm3Service) {
      var vm = this;
      vm.geoFenceAlarm = nmeaAlarm3Service.data.geoFenceAlarm;
      if (vm.geoFenceAlarm && vm.geoFenceAlarm.alarm) {
        vm.lastUpdated = vm.geoFenceAlarm.alarm.dateUpdated == null ? vm.geoFenceAlarm.alarm.dateAdded : vm.geoFenceAlarm.alarm.dateUpdated;
      } else {
        vm.lastUpdated = 'None';
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('nmeaAlarm3Controller', function (settingEnum, sessionService, $filter, nmeaService, navigationService, location, geoFenceAlarm,
      $stateParams, sentinelService, toastr, nmeaAlarm3Service, $state, $translate,$rootScope) {
      var vm = this;
      $translate(['ShortRange.Text', 'LongRange.Text']).then(function (translations) {
        vm.translations = translations;
      });
      var geoFenceAlarmIn = angular.copy(geoFenceAlarm.geoFenceMoveIn);
      var geoFenceAlarmOut = geoFenceAlarm.geoFenceMoveOut;
      navigationService.navigation = {
        backState: 'boat.nmea_alarms',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.hasLocation = location;
      var minSpeed = 1;
      var maxSpeed = 10;
      var settings = sessionService.getUserSettings();
      var speedSetting = settings.find(function (x) {
        return x.id === settingEnum.Speed.id
      });
      if (speedSetting && speedSetting.userSettingViewModel) {
        //Convert From Primary Unit
        minSpeed = +((minSpeed * speedSetting.userSettingViewModel.allowed_Setting_Value.multiply_Factor).toFixed(1));
        maxSpeed = +((maxSpeed * speedSetting.userSettingViewModel.allowed_Setting_Value.multiply_Factor).toFixed(1));
      }
      vm.nmeaAlarm2Sog = {
        options: {
          floor: minSpeed,
          ceil: maxSpeed,
          step: 1,
          precision: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value, sliderId, label) {
            switch (label) {
              case 'model':
                return '<b>' + $filter('speed')(value) + '</b>';
              case 'high':
                return '<b>' + $filter('speed')(value) + '</b>';
              default:
                return '<b>' + $filter('speed')(value) + '</b>';
            }
          }
        },
        alarm: {
          triggerValue: 3.8,
          center: {
            latitude: (location && location.latitude) || 0,
            longitude: (location && location.longitude) || 0
          }
        },
        sog: false
      };
      vm.nmeaAlarm2Sog.enabled = geoFenceAlarm.speedLimit == null ? false : geoFenceAlarm.speedLimit.enabled;


      if (location == null) {
        vm.noPositionData = true
      } else {
        vm.noPositionData = false
      }

      if (geoFenceAlarm.speedLimit && geoFenceAlarm.speedLimit.alarmValue != null) {
        vm.nmeaAlarm2Sog.alarm.triggerValue = geoFenceAlarm.speedLimit.alarmValue.triggerValue;
        vm.nmeaAlarm2Sog.alarm.center = geoFenceAlarm.speedLimit.alarmValue.center;
      }
      vm.sliderOptions = {
        floor: 40,
        ceil: 200,
        minLimit: 40,
        maxLimit: 200,
        step: 20,
        translate: function (value) {
          return value + "m";
        }
      };

      /**
       * Get distance from center
       */
      var getDistance = function (p1, p2) {
        var rad = function (x) {
          return x * Math.PI / 180;
        };
        var R = 6378137; // Earth’s mean radius in meter
        var dLat = rad(p2.lat - p1.lat);
        var dLong = rad(p2.lng - p1.lng);
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos(rad(p1.lat)) * Math.cos(rad(p2.lat)) *
          Math.sin(dLong / 2) * Math.sin(dLong / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c;
        return d; // returns the distance in meter
      };


      vm.sentinelLocation = {
        center: {
          latitude: (location && location.latitude) || 0,
          longitude: (location && location.longitude) || 0
        },
        zoom: 16,
        marker: {
          id: (location && location.id) || 0,
          coords: {
            latitude: (location && location.latitude) || 0,
            longitude: (location && location.longitude) || 0
          },
          options: {
            title: 'Boat location',
            icon: 'assets/images/boat-location.png'
          },
          show: true
        },
        fill: {
          color: '#00FFFFFF',
          opacity: 0.0
        },
        stroke: {
          color: '#000000',
          weight: 2,
          opacity: 0.5
        }
      };

      vm.geoFenceAlarm = {
        map: {
          center: {
            latitude: vm.sentinelLocation.center.latitude || 0,
            longitude: vm.sentinelLocation.center.longitude || 0
          },
          radius: 40
        },
        geodesic: true, // optional: defaults to false
        draggable: true, // optional: defaults to false
        clickable: true, // optional: defaults to true
        editable: true, // optional: defaults to false
        visible: true, // optional: defaults to true,
        fill: {
          color: '#08B21F',
          opacity: 0.5
        },
        stroke: {
          color: '#08B21F',
          weight: 2,
          opacity: 1
        },
        events: {
          "dragend": function () {
            vm.distance = getDistance({
              lat: vm.sentinelLocation.center.latitude,
              lng: vm.sentinelLocation.center.longitude
            }, {
              lat: vm.geoFenceAlarm.map.center.latitude,
              lng: vm.geoFenceAlarm.map.center.longitude
            });
          }
        },
        moveOutEnabled: (geoFenceAlarmOut && geoFenceAlarmOut.enabled) || false,
        moveInEnabled: (geoFenceAlarmIn && geoFenceAlarmIn.enabled) || false
      };
      if (geoFenceAlarmOut == null) {
        vm.geoFenceAlarm.map.center = angular.copy(vm.sentinelLocation.center);
      } else {
        vm.geoFenceAlarm.map = geoFenceAlarmOut.alarmValue;
        vm.geoFenceAlarm.alarm = geoFenceAlarmOut;
      }


      /**
       * Update service so that map can be updated
       */
      nmeaAlarm3Service.data.location = vm.sentinelLocation;
      nmeaAlarm3Service.data.geoFenceAlarm = vm.geoFenceAlarm;

      vm.distance = getDistance({
        lat: vm.sentinelLocation.center.latitude,
        lng: vm.sentinelLocation.center.longitude
      }, {
        lat: vm.geoFenceAlarm.map.center.latitude,
        lng: vm.geoFenceAlarm.map.center.longitude
      });

      vm.hasSupportForFeature = function (hasData) {
        if (!hasData) {
          toastr.error("No Location Found !");
        }
      }
      vm.saveGeofenceAlarm = function () {
        if (!vm.nmeaAlarm2Sog.alarm.center) {
          vm.nmeaAlarm2Sog.alarm.center = {
            latitude: (location && location.latitude) || 0,
            longitude: (location && location.longitude) || 0
          }
        }
        vm.nmeaAlarm2Sog.alarm.radius = vm.geoFenceAlarm.map.radius;
        var alarm = {
          moveOutAlarm: {
            alarmValue: angular.toJson(vm.geoFenceAlarm.map),
            enabled: vm.geoFenceAlarm.moveOutEnabled
          },
          moveInAlarm: {
            alarmValue: angular.toJson(vm.geoFenceAlarm.map),
            enabled: vm.geoFenceAlarm.moveInEnabled
          },
          speedLimit: angular.copy(vm.nmeaAlarm2Sog)
        };
        nmeaService.updateGeoFenceAlarm($stateParams.sentinelId, alarm, function () {
          toastr.success('Alarm updated successfully');
          $state.go('boat.nmea_alarms', {
            sentinelId: $stateParams.sentinelId
          });
        });
      };

      vm.resetGeoFenceToCurrentLocation = function () {
        vm.geoFenceAlarm.map.center = {
          latitude: (location && location.latitude) || 0,
          longitude: (location && location.longitude) || 0
        };
        vm.sentinelLocation.center = {
          latitude: (location && location.latitude) || 0,
          longitude: (location && location.longitude) || 0
        }
        vm.distance = getDistance({
          lat: vm.sentinelLocation.center.latitude,
          lng: vm.sentinelLocation.center.longitude
        }, {
          lat: vm.geoFenceAlarm.map.center.latitude,
          lng: vm.geoFenceAlarm.map.center.longitude
        });
      };
      vm.hasAccess = false;
      vm.canUserAccessTheSentinel = function () {
        sentinelService.canUserAccessTheSentinel($stateParams.sentinelId, function (response) {
          if (response != null) {
            vm.hasAccess = response;
          } else {
            vm.hasAccess = true;
          }
        });
      }
      vm.canUserAccessTheSentinel();
      if (vm.geoFenceAlarm.map.radius > 200) {
        vm.positionAlarmRange = true;
      }
      vm.handleRangeChange = function () {
        $rootScope.$broadcast("positionAlarmRange",vm.positionAlarmRange);
        if (vm.positionAlarmRange) {
          vm.sliderOptions = {
            floor: 200,
            ceil: 4000,
            minLimit: 200,
            maxLimit: 4000,
            step: 20,
            translate: function (value) {
              return value + "m";
            }
          };
          if (vm.geoFenceAlarm.map.radius < 200) {
            vm.geoFenceAlarm.map.radius = 201
          }
        } else {
          vm.sliderOptions = {
            floor: 40,
            ceil: 200,
            minLimit: 40,
            maxLimit: 200,
            step: 20,
            translate: function (value) {
              return value + "m";
            }
          };
          if (vm.geoFenceAlarm.map.radius > 200) {
            vm.geoFenceAlarm.map.radius = 199;
          }
        }
      };
      vm.handleRangeChange();
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .service('nmeaAlarm5Service', function () {
      return {
        data: []
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('nmeaAlarm5HeaderController', function (nmeaAlarm5Service) {
      var vm = this;
      if (nmeaAlarm5Service.data.nmeaAlarm5) {
        vm.lastUpdated = nmeaAlarm5Service.data.nmeaAlarm5.dateUpdated == null ? nmeaAlarm5Service.data.nmeaAlarm5.dateAdded : nmeaAlarm5Service.data.nmeaAlarm5.dateUpdated;
      } else {
        vm.lastUpdated = 'None';
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('nmeaAlarm5Controller', function (fluidLevelAlarms, nmeaFluidTypesEnum, navigationService, toastr, sentinelService, nmeaService, $state, $stateParams, $rootScope) {
      var vm = this;
      vm.fluidLevelAlarms = fluidLevelAlarms;
      vm.nmeaFluidTypesEnum = nmeaFluidTypesEnum;
      vm.fluidLevelAlarms.forEach(function (fluidAlarm) {
        if (fluidAlarm.nmeaFluidTypeId == nmeaFluidTypesEnum.Fuel) {
          fluidAlarm.class = "green";
          fluidAlarm.nmeaAlarm = {
            options: {
              floor: 0,
              ceil: 100,
              step: 5,
              precision: 1,
              showSelectionBar: true,
              getSelectionBarColor: function () {
                return 'orangered'
              },
              translate: function (value) {
                return value + "%";
              }
            },
            alarm: {
              triggerValue: 3.8
            },
            fuel: false
          };
          fluidAlarm.nmeaAlarm.enabled = fluidAlarm.sentinelAlarm == null ? false : fluidAlarm.sentinelAlarm.enabled;
          if (fluidAlarm.sentinelAlarm && fluidAlarm.sentinelAlarm.alarmValue != null) {
            fluidAlarm.nmeaAlarm.alarm.triggerValue = fluidAlarm.sentinelAlarm.alarmValue.triggerValue;
          }
        } else if (fluidAlarm.nmeaFluidTypeId == nmeaFluidTypesEnum.FreshWater) {
          fluidAlarm.class = "green";
          fluidAlarm.nmeaAlarm = {
            options: {
              floor: 0,
              ceil: 100,
              step: 5,
              precision: 1,
              showSelectionBar: true,
              getSelectionBarColor: function () {
                return 'orangered'
              },
              translate: function (value) {
                return value + "%";
              }
            },
            alarm: {
              triggerValue: 3.8
            },
            freshWater: false
          };
          fluidAlarm.nmeaAlarm.enabled = fluidAlarm.sentinelAlarm == null ? false : fluidAlarm.sentinelAlarm.enabled;
          if (fluidAlarm.sentinelAlarm && fluidAlarm.sentinelAlarm.alarmValue != null) {
            fluidAlarm.nmeaAlarm.alarm.triggerValue = fluidAlarm.sentinelAlarm.alarmValue.triggerValue;
          }
        } else if (fluidAlarm.nmeaFluidTypeId == nmeaFluidTypesEnum.WasteWater) {
          fluidAlarm.class = "red";
          fluidAlarm.nmeaAlarm = {
            options: {
              floor: 0,
              ceil: 100,
              step: 5,
              precision: 1,
              showSelectionBar: true,
              getSelectionBarColor: function () {
                return 'lightgreen'
              },
              translate: function (value) {
                return value + "%";
              }
            },
            alarm: {
              triggerValue: 3.8
            },
            wasteWater: false
          };
          fluidAlarm.nmeaAlarm.enabled = fluidAlarm.sentinelAlarm == null ? false : fluidAlarm.sentinelAlarm.enabled;
          if (fluidAlarm.sentinelAlarm && fluidAlarm.sentinelAlarm.alarmValue != null) {
            fluidAlarm.nmeaAlarm.alarm.triggerValue = fluidAlarm.sentinelAlarm.alarmValue.triggerValue;
          }
        } else if (fluidAlarm.nmeaFluidTypeId == nmeaFluidTypesEnum.LiveWell) {
          fluidAlarm.class = "green";
          fluidAlarm.nmeaAlarm = {
            options: {
              floor: 0,
              ceil: 100,
              step: 5,
              precision: 1,
              showSelectionBar: true,
              getSelectionBarColor: function () {
                return 'orangered'
              },
              translate: function (value) {
                return value + "%";
              }
            },
            alarm: {
              triggerValue: 3.8
            },
            liveWell: false
          };
          fluidAlarm.nmeaAlarm.enabled = fluidAlarm.sentinelAlarm == null ? false : fluidAlarm.sentinelAlarm.enabled;
          if (fluidAlarm.sentinelAlarm && fluidAlarm.sentinelAlarm.alarmValue != null) {
            fluidAlarm.nmeaAlarm.alarm.triggerValue = fluidAlarm.sentinelAlarm.alarmValue.triggerValue;
          }
        } else if (fluidAlarm.nmeaFluidTypeId == nmeaFluidTypesEnum.Oil) {
          fluidAlarm.class = "green";
          fluidAlarm.nmeaAlarm = {
            options: {
              floor: 0,
              ceil: 100,
              step: 5,
              precision: 1,
              showSelectionBar: true,
              getSelectionBarColor: function () {
                return 'orangered'
              },
              translate: function (value) {
                return value + "%";
              }
            },
            alarm: {
              triggerValue: 3.8
            },
            oil: false
          };
          fluidAlarm.nmeaAlarm.enabled = fluidAlarm.sentinelAlarm == null ? false : fluidAlarm.sentinelAlarm.enabled;
          if (fluidAlarm.sentinelAlarm && fluidAlarm.sentinelAlarm.alarmValue != null) {
            fluidAlarm.nmeaAlarm.alarm.triggerValue = fluidAlarm.sentinelAlarm.alarmValue.triggerValue;
          }
        } else if (fluidAlarm.nmeaFluidTypeId == nmeaFluidTypesEnum.BlackWater) {
          fluidAlarm.class = "red";
          fluidAlarm.nmeaAlarm = {
            options: {
              floor: 0,
              ceil: 100,
              step: 5,
              precision: 1,
              showSelectionBar: true,
              getSelectionBarColor: function () {
                return 'lightgreen'
              },
              translate: function (value) {
                return value + "%";
              }
            },
            alarm: {
              triggerValue: 3.8
            },
            blackWater: false
          };
          fluidAlarm.nmeaAlarm.enabled = fluidAlarm.sentinelAlarm == null ? false : fluidAlarm.sentinelAlarm.enabled;
          if (fluidAlarm.sentinelAlarm && fluidAlarm.sentinelAlarm.alarmValue != null) {
            fluidAlarm.nmeaAlarm.alarm.triggerValue = fluidAlarm.sentinelAlarm.alarmValue.triggerValue;
          }
        }
      });

      navigationService.navigation = {
        backState: 'boat.nmea_alarms',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.goBack = function () {
        $rootScope.goBack();
      };

      vm.updateAlarms = function () {
        vm.fluidLevelAlarms.forEach(function (fluidAlarm) {
          fluidAlarm.sentinelAlarm = angular.copy(fluidAlarm.nmeaAlarm)
          fluidAlarm.sentinelAlarm.instanceNumber = fluidAlarm.nmeaInstance.nmeaInstanceNumber;
          fluidAlarm.sentinelAlarm.nmeaInstanceSourceId = fluidAlarm.nmeaInstance.sourceId;
        });
        nmeaService.updateFluidLevelsAlarm($stateParams.sentinelId, vm.fluidLevelAlarms, function () {
          toastr.success('Fluid Levels Alarms Updated');
          $state.go('boat.nmea_alarms', {
            sentinelId: $stateParams.sentinelId
          });
        });
      }

      vm.hasAccess = false;
      vm.canUserAccessTheSentinel = function () {
        sentinelService.canUserAccessTheSentinel($stateParams.sentinelId, function (response) {
          if (response != null) {
            vm.hasAccess = response;
          } else {
            vm.hasAccess = true;
          }
        });
      }
      vm.canUserAccessTheSentinel();
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .service('nmeaAlarm1Service', function () {
      return {
        data: []
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('nmeaAlarm1HeaderController', function (nmeaAlarm1Service) {
      var vm = this;
      if (nmeaAlarm1Service.data.nmeaAlarm1) {
        vm.lastUpdated = nmeaAlarm1Service.data.nmeaAlarm1.dateUpdated == null ? nmeaAlarm1Service.data.nmeaAlarm1.dateAdded : nmeaAlarm1Service.data.nmeaAlarm1.dateUpdated;
      } else {
        vm.lastUpdated = 'None';
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('nmeaAlarm1Controller', function (settingEnum, sessionService, $filter, currentTripAlarm, navigationService, toastr, sentinelService, nmeaService, $state, $stateParams, $rootScope) {
      var vm = this;
      vm.hasTimeToEmptyData = currentTripAlarm.hasTimeToEmptyData;
      vm.hasDistanceToEmptyData = currentTripAlarm.hasDistanceToEmptyData;
      vm.hasTripDistanceData = currentTripAlarm.hasTripDistanceData;
      vm.hasTripRunTimeData = currentTripAlarm.hasTripRunTimeData;

      navigationService.navigation = {
        backState: 'boat.nmea_alarms',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.goBack = function () {
        $rootScope.goBack();
      };
      var minDistance = 0;
      var maxDistance = 185.2;
      var settings = sessionService.getUserSettings();
      var distanceSetting = settings.find(function (x) {
        return x.id === settingEnum.Distance.id
      });
      if (distanceSetting && distanceSetting.userSettingViewModel) {
        //Convert From Primary Unit
        minDistance = +((minDistance * distanceSetting.userSettingViewModel.allowed_Setting_Value.multiply_Factor).toFixed(1));
        maxDistance = +((maxDistance * distanceSetting.userSettingViewModel.allowed_Setting_Value.multiply_Factor).toFixed(1));
      }
      vm.nmeaAlarm1TimeToEmpty = {
        options: {
          floor: 0,
          ceil: 100,
          step: 0.5,
          precision: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'orangered'
          },
          translate: function (value) {
            return value + "hrs";
          }
        },
        alarm: {
          triggerValue: 3.5
        },
        timeToEmpty: false
      };
      vm.nmeaAlarm1TimeToEmpty.enabled = currentTripAlarm.timeToEmptyAlarm == null ? false : currentTripAlarm.timeToEmptyAlarm.enabled;
      if (currentTripAlarm.timeToEmptyAlarm && currentTripAlarm.timeToEmptyAlarm.alarmValue != null) {
        vm.nmeaAlarm1TimeToEmpty.alarm.triggerValue = currentTripAlarm.timeToEmptyAlarm.alarmValue.triggerValue;
      }

      vm.nmeaAlarm1DistanceToEmpty = {
        options: {
          floor: minDistance,
          ceil: maxDistance,
          step: 5,
          precision: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'orangered'
          },
          translate: function (value, sliderId, label) {
            switch (label) {
              case 'model':
                return '<b>' + $filter('distance')(value) + '</b>';
              case 'high':
                return '<b>' + $filter('distance')(value) + '</b>';
              default:
                return '<b>' + $filter('distance')(value) + '</b>';
            }
          }
        },
        alarm: {
          triggerValue: 25
        },
        distanceToEmpty: false
      };
      vm.nmeaAlarm1DistanceToEmpty.enabled = currentTripAlarm.distanceToEmptyAlarm == null ? false : currentTripAlarm.distanceToEmptyAlarm.enabled;
      if (currentTripAlarm.distanceToEmptyAlarm && currentTripAlarm.distanceToEmptyAlarm.alarmValue != null) {
        vm.nmeaAlarm1DistanceToEmpty.alarm.triggerValue = currentTripAlarm.distanceToEmptyAlarm.alarmValue.triggerValue;
      }

      vm.nmeaAlarm1TripDistance = {
        options: {
          floor: minDistance,
          ceil: maxDistance,
          step: 5,
          precision: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value, sliderId, label) {
            switch (label) {
              case 'model':
                return '<b>' + $filter('distance')(value) + '</b>';
              case 'high':
                return '<b>' + $filter('distance')(value) + '</b>';
              default:
                return '<b>' + $filter('distance')(value) + '</b>';
            }
          }
        },
        alarm: {
          triggerValue: 25
        },
        tripDistance: false
      };
      vm.nmeaAlarm1TripDistance.enabled = currentTripAlarm.tripDistanceAlarm == null ? false : currentTripAlarm.tripDistanceAlarm.enabled;
      if (currentTripAlarm.tripDistanceAlarm && currentTripAlarm.tripDistanceAlarm.alarmValue != null) {
        vm.nmeaAlarm1TripDistance.alarm.triggerValue = currentTripAlarm.tripDistanceAlarm.alarmValue.triggerValue;
      }

      vm.nmeaAlarm1TripRunTime = {
        options: {
          floor: 0,
          ceil: 100,
          step: 0.5,
          precision: 1,
          showSelectionBar: true,
          getSelectionBarColor: function () {
            return 'lightgreen'
          },
          translate: function (value) {
            return value + "hrs";
          }
        },
        alarm: {
          triggerValue: 3.5
        },
        tripRunTime: false
      };
      vm.nmeaAlarm1TripRunTime.enabled = currentTripAlarm.tripRunTimeAlarm == null ? false : currentTripAlarm.tripRunTimeAlarm.enabled;
      if (currentTripAlarm.tripRunTimeAlarm && currentTripAlarm.tripRunTimeAlarm.alarmValue != null) {
        vm.nmeaAlarm1TripRunTime.alarm.triggerValue = currentTripAlarm.tripRunTimeAlarm.alarmValue.triggerValue;
      }

      vm.updateAlarms = function () {
        nmeaService.updateCurrentTripAlarm($stateParams.sentinelId, {
          timeToEmptyAlarm: angular.copy(vm.nmeaAlarm1TimeToEmpty),
          distanceToEmptyAlarm: angular.copy(vm.nmeaAlarm1DistanceToEmpty),
          tripDistanceAlarm: angular.copy(vm.nmeaAlarm1TripDistance),
          tripRunTimeAlarm: angular.copy(vm.nmeaAlarm1TripRunTime)
        }, function () {
          toastr.success('Current Trip Alarms Updated');
          $state.go('boat.nmea_alarms', {
            sentinelId: $stateParams.sentinelId
          });
        });
      };

      vm.hasSupportForFeature = function (hasData) {
        if (!hasData) {
          toastr.error("Your NMEA network does not support this feature!");
        }
      }

      vm.hasAccess = false;
      vm.canUserAccessTheSentinel = function () {
        sentinelService.canUserAccessTheSentinel($stateParams.sentinelId, function (response) {
          if (response != null) {
            vm.hasAccess = response;
          } else {
            vm.hasAccess = true;
          }
        });
      }
      vm.canUserAccessTheSentinel();
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .service('nmeaAlarm4Service', function () {
      return {
        data: []
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('nmeaAlarm4HeaderController', function (nmeaAlarm4Service) {
      var vm = this;
      if (nmeaAlarm4Service.data.nmeaAlarm4) {
        vm.lastUpdated = nmeaAlarm4Service.data.nmeaAlarm4.dateUpdated == null ? nmeaAlarm4Service.data.nmeaAlarm4.dateAdded : nmeaAlarm4Service.data.nmeaAlarm4.dateUpdated;
      } else {
        vm.lastUpdated = 'None';
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('nmeaAlarm4Controller', function (allUserSentinelEngines, navigationService, sentinelService, toastr, $stateParams, $rootScope, $state) {
      var vm = this;
      navigationService.navigation = {
        backState: 'boat.nmea_alarms',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.goBack = function () {
        $rootScope.goBack();
      };
      vm.engines = [];

      if (allUserSentinelEngines.length > 0) {
        allUserSentinelEngines.forEach(function (engine) {
          if (engine.hasData) {
            var obj = {
              id: engine.instanceNumber,
              engineName: engine.engineName,
              hasData: engine.hasData
            };
            vm.engines.push(obj);
          }
        });
      }

      vm.hasAccess = false;
      vm.canUserAccessTheSentinel = function () {
        sentinelService.canUserAccessTheSentinel($stateParams.sentinelId, function (response) {
          if (response != null) {
            vm.hasAccess = response;
          } else {
            vm.hasAccess = true;
          }
        });
      }
      vm.canUserAccessTheSentinel();

      vm.goToEngineAlarm = function (engine) {
        if (vm.hasAccess && engine.hasData) {
          $state.go("boat.nmea_engine_alarm", {
            sentinelId: $stateParams.sentinelId,
            instanceNumber: engine.id
          });
        } else {
          toastr.error("UnAuthorized Access!");
        }
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.tutorial', [])
    .config(function ($stateProvider,$translatePartialLoaderProvider) {
      $stateProvider
        .state('tutorial', {
          url: '/tutorial',
          templateUrl: 'app/main/tutorial/tutorial.html',
          controller: function(oemConfig){
            var vm = this;
            vm.oemConfig = angular.copy(oemConfig);
          },
          controllerAs: 'vm'
        });
        $translatePartialLoaderProvider.addPart('app/main/tutorial');
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.tutorial')
    .directive('swiper', function (swiper) {
      return {
        restrict: 'A',
        link: function (scope, elem) {
          scope.swiper = new swiper(elem, {
            pagination: '.swiper-pagination',
            paginationClickable: true
          });
        },
        controller: function ($scope) {
          $scope.next = function(){
            $scope.swiper.slideNext();
          };
        }
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.sensors', [
    'yatch-sentinel.services'
  ])
    .config(function ($stateProvider, $translatePartialLoaderProvider) {
      $stateProvider
        .state('boat.sensors', {
          url: '/sensors/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/sensors/index/header.html',
              controller: function(oemConfig){
                var vm = this;
                vm.oemConfig = angular.copy(oemConfig);
              },
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/sensors/index/index.html',
              controller: 'sensorIndexController',
              controllerAs: 'vm',
              resolve: {
                sharedUserPermissions: function (userService, $stateParams) {
                  return userService.getSharedUserPermissions($stateParams.sentinelId);
                },
                sensorTypes: function (sentinelService, $stateParams) {
                  return sentinelService.getSentinelSensors($stateParams.sentinelId);
                },
                userSentinelCameras: function (cameraService, $stateParams) {
                  return cameraService.getAllCamerasByUserSentinelId($stateParams.sentinelId);
                },
                userSentinel: function (sentinelService, $stateParams) {
                  return sentinelService.getSentinel($stateParams.sentinelId);
                },
                engines: function (nmeaService, $stateParams) {
                  return nmeaService.getAllEnginesInstancesToRename($stateParams.sentinelId);
                },
                powerInstances: function (nmeaService, $stateParams) {
                  return nmeaService.getAllPowerInstancesToRename($stateParams.sentinelId);
                }
              }
            }
          },
          data: {
            pageTitle: 'Sensors'
          },
          headerClass: 'h75',
          mobileHeader: {
            visible: true,
            title: 'Header.RenameSensors'
          }
        })
        .state('boat.rename_sensor', {
          url: '/:sentinelId/rename-sensor/:sensorId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/sensors/index/header.html',
              controller: function(oemConfig){
                var vm = this;
                vm.oemConfig = angular.copy(oemConfig);
              },
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/sensors/rename/rename.html',
              controller: 'sensorRenameController',
              controllerAs: 'vm',
              resolve: {
                sensor: function (sentinelService, $stateParams) {
                  return sentinelService.getSentinelSensor($stateParams.sentinelId, $stateParams.sensorId);
                }
              }
            }
          },
          data: {
            pageTitle: 'Rename sensor'
          },
          headerClass: 'h75',
          mobileHeader: {
            visible: true,
            title: 'Header.RenameSensors'
          }
        })
        .state('boat.rename_camera', {
          url: '/:sentinelId/rename-camera/:cameraId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/sensors/index/header.html',
              controller: function(oemConfig){
                var vm = this;
                vm.oemConfig = angular.copy(oemConfig);
              },
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/sensors/rename_camera/rename_camera.html',
              controller: 'cameraRenameController',
              controllerAs: 'vm',
              resolve: {
                camera: function (cameraService, $stateParams) {
                  return cameraService.getCamera($stateParams.cameraId);
                }
              }
            }
          },
          data: {
            pageTitle: 'Rename sensor'
          },
          headerClass: 'h75',
          mobileHeader: {
            visible: true,
            title: 'Header.RenameSensors'
          }
        })
        .state('boat.rename_nmea_instance', {
          url: '/:sentinelId/rename-nmea-instance/:instanceType/?instanceNumber?instanceName?sourceId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/sensors/index/header.html',
              controller: function(oemConfig){
                var vm = this;
                vm.oemConfig = angular.copy(oemConfig);
              },
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/sensors/rename_nmea_instance/rename.html',
              controller: 'nmeaInstanceRenameController',
              controllerAs: 'vm',
              resolve: {
              }
            }
          },
          data: {
            pageTitle: 'Rename NMEA Instance'
          },
          headerClass: 'h75',
          mobileHeader: {
            visible: true,
            title: 'Header.RenameSensors'
          }
        });

      $translatePartialLoaderProvider.addPart('app/main/sensors/index');
      $translatePartialLoaderProvider.addPart('app/main/sensors/rename');
      $translatePartialLoaderProvider.addPart('app/main/sensors/rename_camera');
      $translatePartialLoaderProvider.addPart('app/main/sensors/rename_nmea_instance');
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.sensors')
    .controller('nmeaInstanceRenameController', function (nmeaService, sentinelService, toastr, $state, $stateParams, navigationService) {
      var vm = this;
      vm.newName = $stateParams.instanceName;
      navigationService.navigation = {
        backState: 'boat.sensors',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.saveChanges = function () {
        nmeaService.updateNmeaInstanceName($stateParams.sentinelId, $stateParams.instanceNumber, $stateParams.sourceId, $stateParams.instanceType, vm.newName)
          .then(function () {
            toastr.success('NMEA Instance Name Changed Successfully!');
            $state.go('boat.sensors', {
              sentinelId: $stateParams.sentinelId
            });
          });
      };
      vm.hasAccess = false;
      vm.canUserAccessTheSentinel = function () {
        sentinelService.canUserAccessTheSentinel($stateParams.sentinelId, function (response) {
          if (response != null) {
            vm.hasAccess = response;
          }
          else {
            vm.hasAccess = true;
          }
        });
      }
      vm.canUserAccessTheSentinel();
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.sensors')
    .controller('sensorRenameController', function (sensor, sentinelService, toastr, $state, $stateParams, navigationService) {
      var vm = this;
      vm.sensor = sensor;
      navigationService.navigation = {
        backState: 'boat.sensors',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.saveChanges = function () {
        sentinelService.updateSentinelSensor(vm.sensor, function () {
          toastr.success('Sensor name changed successfully.');
          $state.go('boat.sensors', {
            sentinelId: $stateParams.sentinelId
          });
        });
      };
      vm.hasAccess = false;
      vm.canUserAccessTheSentinel = function () {
        sentinelService.canUserAccessTheSentinel($stateParams.sentinelId, function (response) {
          if (response != null) {
            vm.hasAccess = response;
          }
          else {
            vm.hasAccess = true;
          }
        });
      }
      vm.canUserAccessTheSentinel();
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.sensors')
    .controller('cameraRenameController', function (camera, cameraService, sentinelService, toastr, $state, $stateParams, navigationService) {
      var vm = this;
      vm.camera = camera;
      vm.newName = camera.name;
      navigationService.navigation = {
        backState: 'boat.sensors',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.saveChanges = function () {
        if (vm.newName == "") {
          toastr.error("Invalid Name!");
          return;
        }
        else if (vm.newName != vm.camera.name && vm.newName != "") {
          cameraService.updateCameraByCameraId(vm.camera.cameraId, vm.newName, function () {
            toastr.success('Camera name changed successfully.');
            $state.go('boat.sensors', {
              sentinelId: $stateParams.sentinelId
            });
          });
        } else {
          toastr.success('Camera name changed successfully.');
          $state.go('boat.sensors', {
            sentinelId: $stateParams.sentinelId
          });
        }
      };
      vm.hasAccess = false;
      vm.canUserAccessTheSentinel = function () {
        sentinelService.canUserAccessTheSentinel($stateParams.sentinelId, function (response) {
          if (response != null) {
            vm.hasAccess = response;
          }
          else {
            vm.hasAccess = true;
          }
        });
      }
      vm.canUserAccessTheSentinel();
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.sensors')
    .controller('sensorIndexController', function (nmeaDcTypesEnum, powerInstances, engines, sharedUserPermissions, $translate, $state, 
      userSentinel, userSentinelCameras, sensorTypes, cameraService, toastr, $uibModal, 
      $stateParams, navigationService, sentinelService) {
      var vm = this;
      vm.cameras = userSentinelCameras;
      vm.engines = engines;
      vm.powerInstances = powerInstances;
      vm.nmeaDcTypesEnum = nmeaDcTypesEnum;
      navigationService.navigation = {
        backState: 'boat.home',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.sharedUserPermissions = sharedUserPermissions;

      function init() {
        if (sensorTypes == null) {
          $uibModal.open({
            templateUrl: 'app/main/sensors/index/error-box-dialog.html',
            size: 'lg'
          });
        } else {
          vm.sensorTypes = [];
          for (var i = 0, j = -1; i < sensorTypes.length; i++) {
            if (sensorTypes[i].id == 3) continue;
            if (i % 3 == 0) {
              vm.sensorTypes.push([]);
              j++;
            }
            vm.sensorTypes[j].push(sensorTypes[i]);
          }
        }
      }
      init();

      vm.deleteSensor = function (sensor) {
        if (confirm("Are you sure you want to delete this sensor?")) {
          sentinelService.deleteSensor(sensor.userSentinelId, sensor.id)
            .then(function () {
              sentinelService.getSentinelSensors($stateParams.sentinelId)
                .then(function (response) {
                  sensorTypes = response;
                  init();
                });
            }, function (errResp) {
              toastr.success(errResp);
            });
        }
      }

      vm.deleteCamera = function (camera) {
        if (userSentinel.imei.length == 15) {
          $translate(['Camera_delete_confirmation', 'CameraDeletionScheduled'])
            .then(function (translations) {
              if (confirm(translations.Camera_delete_confirmation)) {
                cameraService.deleteCamera(camera.cameraId, function () {
                  toastr.success(translations.CameraDeletionScheduled);
                  $state.go('boat.cameras', { sentinelId: $stateParams.sentinelId });
                });
              }
            });
        } else {
          toastr.success("This feature is only Available for Live Account!")
          return;
        }
      }

      vm.renameCamera = function (camera) {
        if (userSentinel.imei.length == 15) {
          $state.go('boat.rename_camera', {
            sentinelId: $stateParams.sentinelId,
            cameraId: camera.cameraId
          });
        }
        else {
          toastr.success("This feature is only Available for Live Account!")
          return;
        }
      }

    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.nmea', [
    'yatch-sentinel.services'
  ]).config(function ($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider
      .state('boat.nmea', {
        url: '/:sentinelId/nmea',
        views: {
          'header@boat': {
            templateUrl: 'app/main/nmea/index/header.html',
            controller: function (oemConfig) {
              var vm = this;
              vm.oemConfig = angular.copy(oemConfig);
            },
            controllerAs: 'vm'
          },
          'content@boat': {
            templateUrl: 'app/main/nmea/index/nmea.index.controller.html',
            controller: 'nmeaIndexController',
            controllerAs: 'vm',
            resolve: {
              nmeaMappings: function (http) {
                return http.get("assets/nmeaMappings.json");
              },
              nmeaDashboardAlerts: function (nmeaService, $stateParams) {
                return nmeaService.getLatestDashboardAlertsData($stateParams.sentinelId,true);
              },
              lastUpdatedOn: function (nmeaService, $stateParams) {
                return nmeaService.getLastUpdatedOnNmeaData($stateParams.sentinelId,true);
              },
              currentTripNmeaData: function (nmeaService, $stateParams) {
                return nmeaService.getLatestCurrentTripNmeaData($stateParams.sentinelId,true);
              },
              engineWidgetNmeaData: function (nmeaService, $stateParams) {
                return nmeaService.getLatestEngineWidgetNmeaData($stateParams.sentinelId,true);
              },
              courseNmeaData: function (nmeaService, $stateParams) {
                return nmeaService.getLatestCourseNmeaData($stateParams.sentinelId,true);
              },
              powerNmeaData: function (nmeaService, $stateParams) {
                return nmeaService.getLatestPowerNmeaData($stateParams.sentinelId,true);
              },
              fluidLevelNmeaData: function (nmeaService, $stateParams) {
                return nmeaService.getLatestFluidLevelNmeaData($stateParams.sentinelId,true);
              },
              temperatureNmeaData: function (nmeaService, $stateParams) {
                return nmeaService.getLatestTemperatureNmeaData($stateParams.sentinelId,true);
              },
              humidityNmeaData: function (nmeaService, $stateParams) {
                return nmeaService.getLatestHumidityNmeaData($stateParams.sentinelId,true);
              },
              currentSentinel: function (userService, $stateParams) {
                return userService.getUserSentinelById($stateParams.sentinelId);
              }
            }
          }
        },
        headerClass: 'half white',
        mobileHeader: {
          visible: true,
          title: 'Header.NmeaDashboard'
        },
        data: {
          pageTitle: 'NMEA Dashboard'
        },
        bodyClass: 'nmea-background'
      })
      .state('boat.engine-details', {
        url: '/:sentinelId/nmea/engine',
        views: {
          'header@boat': {
            templateUrl: 'app/main/nmea/engine-details/header.html',
            controller: function (oemConfig) {
              var vm = this;
              vm.oemConfig = angular.copy(oemConfig);
            },
            controllerAs: 'vm'
          },
          'content@boat': {
            templateUrl: 'app/main/nmea/engine-details/engine-details.controller.html',
            controller: 'engineDetailsController',
            controllerAs: 'vm',
            resolve: {
              nmeaMappings: function (http) {
                return http.get("assets/nmeaMappings.json");
              },
              enginesData: function (nmeaService, $stateParams) {
                return nmeaService.getLatestEngineDataByAllEngineInstances($stateParams.sentinelId,true);
              },
              speedGraphData: function (nmeaService, $stateParams, nmeaGraphIntervalEnum, nmeaDataFieldEnum) {
                return nmeaService.getEngineDetailsNmeaGraphData(nmeaGraphIntervalEnum.Daily, $stateParams.sentinelId, null, nmeaDataFieldEnum.Pgn129026Sog,true);
              },
              currentSentinel: function (userService, $stateParams) {
                return userService.getUserSentinelById($stateParams.sentinelId);
              }
            }
          }
        },
        data: {
          pageTitle: 'Engine Details'
        },
        headerClass: 'half white',
        mobileHeader: {
          visible: true,
          title: 'Header.Engines'
        }
      })
      .state('boat.power-details', {
        url: '/:sentinelId/nmea/power',
        views: {
          'header@boat': {
            templateUrl: 'app/main/nmea/power-details/header.html',
            controller: function (oemConfig) {
              var vm = this;
              vm.oemConfig = angular.copy(oemConfig);
            },
            controllerAs: 'vm'
          },
          'content@boat': {
            templateUrl: 'app/main/nmea/power-details/power-details.controller.html',
            controller: 'powerDetailsController',
            controllerAs: 'vm',
            resolve: {
              nmeaMappings: function (http) {
                return http.get("assets/nmeaMappings.json");
              },
              powerData: function (nmeaService, $stateParams) {
                return nmeaService.getAllPowerDetailsNmeaData($stateParams.sentinelId,true);
              },
              currentSentinel: function (userService, $stateParams) {
                return userService.getUserSentinelById($stateParams.sentinelId);
              },
              powerGraphData: function (nmeaService, $stateParams, nmeaGraphIntervalEnum,nmeaDcTypesEnum, nmeaDataFieldEnum) {
                return nmeaService.getPowerDetailsNmeaGraphData(nmeaGraphIntervalEnum.Daily, $stateParams.sentinelId, nmeaDcTypesEnum.Battery,nmeaDcTypesEnum.Battery, nmeaDataFieldEnum.Pgn127506StateOfCharge,true);
              }
            }
          }
        },
        data: {
          pageTitle: 'Power Details'
        },
        headerClass: 'half white',
        mobileHeader: {
          visible: true,
          title: 'Header.Power'
        }
      });
    $translatePartialLoaderProvider.addPart('app/main/nmea/index');
    $translatePartialLoaderProvider.addPart('app/main/nmea/engine-details');
    $translatePartialLoaderProvider.addPart('app/main/nmea/power-details');
    $translatePartialLoaderProvider.addPart('app/main/nmea/graph-modal');
  });

})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.nmea')
    .controller('powerDetailsController', function (currentSentinel, powerGraphData, nmeaMappings, $translate, nmeaService, nmeaGraphIntervalEnum, powerData, navigationService, $scope, $rootScope, $stateParams, am4themes_animated, $timeout, am4core, am4charts, nmeaDcTypesEnum, nmeaDataFieldEnum, notificationHub) {
      var vm = this;
      vm.nmeaPowerInstances = [];
      vm.currentPowerInstanceName = '';
      vm.nmeaGraphIntervalEnum = nmeaGraphIntervalEnum;
      vm.nmeaDataFieldEnum = nmeaDataFieldEnum;
      vm.currentSentinel = currentSentinel;
      vm.showSampleData = false;
      vm.powerGraphData = powerGraphData;
      if (vm.currentSentinel.imei.length != 15) {
        vm.showSampleData = true;
      }
      vm.currentGraphData = [];
      if (vm.powerGraphData != null) {
        if (vm.powerGraphData.length > 0) {
          vm.currentGraphData = vm.powerGraphData[vm.powerGraphData.length - 1];
        }
      }

      powerData.forEach(function (powerDataInstance) {
        var obj = {
          instanceNumber: powerDataInstance.instanceNumber,
          nmeaSourceId: powerDataInstance.nmeaSourceId
        };
        var nmeaDataDcTypeField = powerDataInstance.userSentinelNmeaData.find(function (nmeaData) {
          return nmeaData.nmeaDataFieldEnumId == nmeaDataFieldEnum.Pgn127506DcType;
        });
        var stateOfChargeField = powerDataInstance.userSentinelNmeaData.find(function (nmeaData) {
          return nmeaData.nmeaDataFieldEnumId == nmeaDataFieldEnum.Pgn127506StateOfCharge;
        });
        var stateOfHealthField = powerDataInstance.userSentinelNmeaData.find(function (nmeaData) {
          return nmeaData.nmeaDataFieldEnumId == nmeaDataFieldEnum.Pgn127506StateOfHealth;
        });
        var timeRemaining = powerDataInstance.userSentinelNmeaData.find(function (nmeaData) {
          return nmeaData.nmeaDataFieldEnumId == nmeaDataFieldEnum.Pgn127506TimeRemaining;
        });
        var ampHours = powerDataInstance.userSentinelNmeaData.find(function (nmeaData) {
          return nmeaData.nmeaDataFieldEnumId == nmeaDataFieldEnum.Pgn127506AmpHours;
        });
        var voltage = powerDataInstance.userSentinelNmeaData.find(function (nmeaData) {
          return nmeaData.nmeaDataFieldEnumId == nmeaDataFieldEnum.Pgn127508Voltage;
        });
        var current = powerDataInstance.userSentinelNmeaData.find(function (nmeaData) {
          return nmeaData.nmeaDataFieldEnumId == nmeaDataFieldEnum.Pgn127508Current;
        });
        var temperature = powerDataInstance.userSentinelNmeaData.find(function (nmeaData) {
          return nmeaData.nmeaDataFieldEnumId == nmeaDataFieldEnum.Pgn127508Temperature;
        });
        if (stateOfChargeField == undefined) {
          obj.stateOfCharge = undefined;
        } else {
          obj.stateOfCharge = stateOfChargeField.nmeaDataFieldValue;
        }
        if (stateOfHealthField == undefined) {
          obj.stateOfHealth = undefined;
        } else {
          obj.stateOfHealth = stateOfHealthField.nmeaDataFieldValue;
        }
        if (timeRemaining == undefined) {
          obj.timeRemaining = undefined;
        } else {
          obj.timeRemaining = timeRemaining.nmeaDataFieldValue;
        }
        if (ampHours == undefined) {
          obj.ampHours = undefined;
        } else {
          obj.ampHours = ampHours.nmeaDataFieldValue;
        }
        if (voltage == undefined) {
          obj.voltage = undefined;
        } else {
          obj.voltage = voltage.nmeaDataFieldValue;
        }
        if (current == undefined) {
          obj.current = undefined;
        } else {
          obj.current = current.nmeaDataFieldValue;
        }
        if (temperature == undefined) {
          obj.batteryCaseTemperature = undefined;
        } else {
          obj.batteryCaseTemperature = temperature.nmeaDataFieldValue;
        }
        obj.name = powerDataInstance.instanceName;
        if (+nmeaDataDcTypeField.nmeaDataFieldValue === nmeaDcTypesEnum.Battery) {
          obj.sourceId = +nmeaDataDcTypeField.nmeaDataFieldValue;
          vm.nmeaPowerInstances.push(obj);
        } else if (+nmeaDataDcTypeField.nmeaDataFieldValue === nmeaDcTypesEnum.SolarCell) {
          obj.sourceId = +nmeaDataDcTypeField.nmeaDataFieldValue;
          vm.nmeaPowerInstances.push(obj);
        } else if (+nmeaDataDcTypeField.nmeaDataFieldValue === nmeaDcTypesEnum.WindPower) {
          obj.sourceId = +nmeaDataDcTypeField.nmeaDataFieldValue;
          vm.nmeaPowerInstances.push(obj);
        } else if (+nmeaDataDcTypeField.nmeaDataFieldValue === -1) {
          obj.sourceId = +nmeaDataDcTypeField.nmeaDataFieldValue;
          vm.nmeaPowerInstances.push(obj);
        }
      });

      navigationService.navigation = {
        backState: 'boat.nmea',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.goBack = function () {
        $rootScope.goBack();
      };
      var hub = new notificationHub();
      hub.on('pushNmeaData', function (data) {
        console.log("Data Recieved");
        var currentPgnMapping = nmeaMappings.find(function (mapping) {
          return mapping.Pgn === data.pgn && mapping.Controller == "Power";
        });
        if (currentPgnMapping != undefined &&
          data.userSentinelId == $stateParams.sentinelId) {
          currentPgnMapping.Functions.forEach(function (funcName) {
            $scope.$eval(funcName).call([], data.instance, data.nmeaData, data.source);
          });
          $rootScope.$apply();
        }
      });
      $scope.$on("$destroy", function () {
        hub.off('pushNmeaData');
      });

      //////////////////////////////////////// Graph Related Functionality////////////////////////////////////////////////////
      vm.isActiveInterval = nmeaGraphIntervalEnum.Daily;

      vm.getDailyGraphData = function () {
        vm.isActiveInterval = nmeaGraphIntervalEnum.Daily;
        vm.getGraphData(vm.currentPowerInstanceName, vm.currentName, vm.currentInstance, vm.currentNmeaDataFieldId, vm.currentSourceId, vm.currentUnit);
      };
      vm.getWeeklyGraphData = function () {
        vm.isActiveInterval = nmeaGraphIntervalEnum.Weekly;
        vm.getGraphData(vm.currentPowerInstanceName, vm.currentName, vm.currentInstance, vm.currentNmeaDataFieldId, vm.currentSourceId, vm.currentUnit);
      };
      vm.getMonthlyGraphData = function () {
        vm.isActiveInterval = nmeaGraphIntervalEnum.Monthly;
        vm.getGraphData(vm.currentPowerInstanceName, vm.currentName, vm.currentInstance, vm.currentNmeaDataFieldId, vm.currentSourceId, vm.currentUnit);
      };

      vm.getGraphData = function (powerInstanceName, name, instance, nmeaDataFieldId, sourceId, unit) {
        $translate([name])
          .then(function (translations) {
            vm.currentSelected = translations[name];
            vm.currentPowerInstanceName = powerInstanceName;
            vm.currentName = name;
            vm.currentInstance = instance;
            vm.currentNmeaDataFieldId = nmeaDataFieldId;
            vm.currentSourceId = sourceId;
            vm.currentUnit = unit;
            nmeaService.getPowerDetailsNmeaGraphData(vm.isActiveInterval, $stateParams.sentinelId, instance, sourceId, nmeaDataFieldId, true)
              .then(function (response) {
                if (response && response.length > 0) {
                  vm.powerGraphData = response;
                  if (response != null) {
                    if (response.length > 0) {
                      vm.currentGraphData = response[response.length - 1] + " " + unit;
                      if (vm.chart) {
                        vm.chart.data = vm.powerGraphData;
                        vm.chart.invalidateData();
                      }
                    }
                  }
                } else {
                  vm.powerGraphData = [];
                }

              });
          });
      };

      vm.getGraphData(vm.nmeaPowerInstances[0].name, 'StateOfCharge.Text', vm.nmeaPowerInstances[0].instanceNumber, nmeaDataFieldEnum.Pgn127506StateOfCharge, vm.nmeaPowerInstances[0].sourceId, '%');
      ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      vm.updateStateOfChargeValues = function (instanceNumber, nmeaData, nmeaSourceId) {
        var nmeaDataDcTypeField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127506DcType;
        });
        var nmeaDataStateOfChargeField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127506StateOfCharge;
        });

        if (nmeaDataDcTypeField != null) {
          nmeaPowerDcType = +nmeaDataDcTypeField.nmeaDataFieldValue;
          stateOfCharge = +nmeaDataStateOfChargeField.nmeaDataFieldValue;
          stateOfCharge = stateOfCharge.toFixed(1);
          if (nmeaPowerDcType === nmeaDcTypesEnum.Battery) {
            var isExisting = vm.nmeaPowerInstances.find(function (nmeaPowerInstance) {
              return nmeaPowerInstance.instanceNumber == instanceNumber && nmeaPowerInstance.nmeaSourceId == nmeaSourceId;
            });
            var obj = {
              instanceNumber: instanceNumber,
              name: "Battery " + instanceNumber,
              nmeaSourceId: nmeaSourceId,
              stateOfCharge: stateOfCharge,
              voltage: 0,
              current: 0,
              batteryCaseTemperature: 0,
              stateOfHealth: 0,
              timeRemaining: 0,
              ampHours: 0
            };
            if (isExisting == null) {
              vm.nmeaPowerInstances.push(obj);
            } else {
              isExisting.stateOfCharge = stateOfCharge;
            }
          } else if (nmeaPowerDcType === nmeaDcTypesEnum.SolarCell) {
            var isExisting = vm.nmeaPowerInstances.find(function (nmeaPowerInstance) {
              return nmeaPowerInstance.instanceNumber == instanceNumber && nmeaPowerInstance.nmeaSourceId == nmeaSourceId;
            });
            var obj = {
              instanceNumber: instanceNumber,
              nmeaSourceId: nmeaSourceId,
              name: "Solar Power " + instanceNumber,
              stateOfCharge: stateOfCharge,
              voltage: 0,
              current: 0,
              batteryCaseTemperature: 0,
              stateOfHealth: 0,
              timeRemaining: 0,
              ampHours: 0
            };
            if (isExisting == null) {
              vm.nmeaPowerInstances.push(obj);
            } else {
              isExisting.stateOfCharge = stateOfCharge;
            }
          } else if (nmeaPowerDcType === nmeaDcTypesEnum.WindPower) {
            var isExisting = vm.nmeaPowerInstances.find(function (nmeaPowerInstance) {
              return nmeaPowerInstance.instanceNumber == instanceNumber && nmeaPowerInstance.nmeaSourceId == nmeaSourceId;
            });
            var obj = {
              instanceNumber: instanceNumber,
              nmeaSourceId: nmeaSourceId,
              name: "Wind Power " + instanceNumber,
              stateOfCharge: stateOfCharge,
              voltage: 0,
              current: 0,
              batteryCaseTemperature: 0,
              stateOfHealth: 0,
              timeRemaining: 0,
              ampHours: 0
            };
            if (isExisting == null) {
              vm.nmeaPowerInstances.push(obj);
            } else {
              isExisting.stateOfCharge = stateOfCharge;
            }
          }
        }

      };

      vm.updateStateOfHealthValues = function (instanceNumber, nmeaData, nmeaSourceId) {
        var nmeaDataDcTypeField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127506DcType;
        });
        var nmeaDataStateOfHealthField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127506StateOfHealth;
        });

        if (nmeaDataDcTypeField != null) {
          nmeaPowerDcType = +nmeaDataDcTypeField.nmeaDataFieldValue;
          stateOfHealth = +nmeaDataStateOfHealthField.nmeaDataFieldValue;
          stateOfHealth = stateOfHealth.toFixed(1);
          if (nmeaPowerDcType === nmeaDcTypesEnum.Battery) {
            var isExisting = vm.nmeaPowerInstances.find(function (nmeaPowerInstance) {
              return nmeaPowerInstance.instanceNumber == instanceNumber && nmeaPowerInstance.nmeaSourceId == nmeaSourceId;
            });
            var obj = {
              instanceNumber: instanceNumber,
              nmeaSourceId: nmeaSourceId,
              name: "Battery " + instanceNumber,
              stateOfCharge: 0,
              voltage: 0,
              current: 0,
              batteryCaseTemperature: 0,
              stateOfHealth: stateOfHealth,
              timeRemaining: 0,
              ampHours: 0
            };
            if (isExisting == null) {
              vm.nmeaPowerInstances.push(obj);
            } else {
              isExisting.stateOfHealth = stateOfHealth;
            }
          } else if (nmeaPowerDcType === nmeaDcTypesEnum.SolarCell) {
            var isExisting = vm.nmeaPowerInstances.find(function (nmeaPowerInstance) {
              return nmeaPowerInstance.instanceNumber == instanceNumber && nmeaPowerInstance.nmeaSourceId == nmeaSourceId;
            });
            var obj = {
              instanceNumber: instanceNumber,
              nmeaSourceId: nmeaSourceId,
              name: "Solar Power " + instanceNumber,
              stateOfCharge: 0,
              voltage: 0,
              current: 0,
              batteryCaseTemperature: 0,
              stateOfHealth: stateOfHealth,
              timeRemaining: 0,
              ampHours: 0
            };
            if (isExisting == null) {
              vm.nmeaPowerInstances.push(obj);
            } else {
              isExisting.stateOfHealth = stateOfHealth;
            }
          } else if (nmeaPowerDcType === nmeaDcTypesEnum.WindPower) {
            var isExisting = vm.nmeaPowerInstances.find(function (nmeaPowerInstance) {
              return nmeaPowerInstance.instanceNumber == instanceNumber && nmeaPowerInstance.nmeaSourceId == nmeaSourceId;
            });
            var obj = {
              instanceNumber: instanceNumber,
              nmeaSourceId: nmeaSourceId,
              name: "Wind Power " + instanceNumber,
              stateOfCharge: 0,
              voltage: 0,
              current: 0,
              batteryCaseTemperature: 0,
              stateOfHealth: stateOfHealth,
              timeRemaining: 0,
              ampHours: 0
            };
            if (isExisting == null) {
              vm.nmeaPowerInstances.push(obj);
            } else {
              isExisting.stateOfHealth = stateOfHealth;
            }
          }
        }

      };

      vm.updateTimeRemainingValues = function (instanceNumber, nmeaData, nmeaSourceId) {
        var nmeaDataDcTypeField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127506DcType;
        });
        var nmeaDataTimeRemainingField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127506TimeRemaining;
        });

        if (nmeaDataDcTypeField != null) {
          nmeaPowerDcType = +nmeaDataDcTypeField.nmeaDataFieldValue;
          timeRemaining = +nmeaDataTimeRemainingField.nmeaDataFieldValue;
          timeRemaining = timeRemaining.toFixed(1);
          if (nmeaPowerDcType === nmeaDcTypesEnum.Battery) {
            var isExisting = vm.nmeaPowerInstances.find(function (nmeaPowerInstance) {
              return nmeaPowerInstance.instanceNumber == instanceNumber && nmeaPowerInstance.nmeaSourceId == nmeaSourceId;
            });
            var obj = {
              instanceNumber: instanceNumber,
              nmeaSourceId: nmeaSourceId,
              name: "Battery " + instanceNumber,
              stateOfCharge: 0,
              voltage: 0,
              current: 0,
              batteryCaseTemperature: 0,
              stateOfHealth: 0,
              timeRemaining: timeRemaining,
              ampHours: 0
            };
            if (isExisting == null) {
              vm.nmeaPowerInstances.push(obj);
            } else {
              isExisting.timeRemaining = timeRemaining;
            }
          } else if (nmeaPowerDcType === nmeaDcTypesEnum.SolarCell) {
            var isExisting = vm.nmeaPowerInstances.find(function (nmeaPowerInstance) {
              return nmeaPowerInstance.instanceNumber == instanceNumber && nmeaPowerInstance.nmeaSourceId == nmeaSourceId;
            });
            var obj = {
              instanceNumber: instanceNumber,
              nmeaSourceId:nmeaSourceId,
              name: "Solar Power " + instanceNumber,
              stateOfCharge: 0,
              voltage: 0,
              current: 0,
              batteryCaseTemperature: 0,
              stateOfHealth: 0,
              timeRemaining: timeRemaining,
              ampHours: 0
            };
            if (isExisting == null) {
              vm.nmeaPowerInstances.push(obj);
            } else {
              isExisting.timeRemaining = timeRemaining;
            }
          } else if (nmeaPowerDcType === nmeaDcTypesEnum.WindPower) {
            var isExisting = vm.nmeaPowerInstances.find(function (nmeaPowerInstance) {
              return nmeaPowerInstance.instanceNumber == instanceNumber && nmeaPowerInstance.nmeaSourceId == nmeaSourceId;
            });
            var obj = {
              instanceNumber: instanceNumber,
              nmeaSourceId: nmeaSourceId,
              name: "Wind Power " + instanceNumber,
              stateOfCharge: 0,
              voltage: 0,
              current: 0,
              batteryCaseTemperature: 0,
              stateOfHealth: 0,
              timeRemaining: timeRemaining,
              ampHours: 0
            };
            if (isExisting == null) {
              vm.nmeaPowerInstances.push(obj);
            } else {
              isExisting.timeRemaining = timeRemaining;
            }
          }
        }

      };

      vm.updateAmpHoursValues = function (instanceNumber, nmeaData, nmeaSourceId) {
        var nmeaDataDcTypeField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127506DcType;
        });
        var nmeaDataAmpHoursField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127506AmpHours;
        });

        if (nmeaDataDcTypeField != null) {
          nmeaPowerDcType = +nmeaDataDcTypeField.nmeaDataFieldValue;
          ampHours = +nmeaDataAmpHoursField.nmeaDataFieldValue;
          ampHours = ampHours.toFixed(1);
          if (nmeaPowerDcType === nmeaDcTypesEnum.Battery) {
            var isExisting = vm.nmeaPowerInstances.find(function (nmeaPowerInstance) {
              return nmeaPowerInstance.instanceNumber == instanceNumber && nmeaPowerInstance.nmeaSourceId == nmeaSourceId;
            });
            var obj = {
              instanceNumber: instanceNumber,
              nmeaSourceId: nmeaSourceId,
              name: "Battery " + instanceNumber,
              stateOfCharge: 0,
              voltage: 0,
              current: 0,
              batteryCaseTemperature: 0,
              stateOfHealth: 0,
              timeRemaining: 0,
              ampHours: ampHours
            };
            if (isExisting == null) {
              vm.nmeaPowerInstances.push(obj);
            } else {
              isExisting.ampHours = ampHours;
            }
          } else if (nmeaPowerDcType === nmeaDcTypesEnum.SolarCell) {
            var isExisting = vm.nmeaPowerInstances.find(function (nmeaPowerInstance) {
              return nmeaPowerInstance.instanceNumber == instanceNumber && nmeaPowerInstance.nmeaSourceId == nmeaSourceId;
            });
            var obj = {
              instanceNumber: instanceNumber,
              nmeaSourceId: nmeaSourceId,
              name: "Solar Power " + instanceNumber,
              stateOfCharge: 0,
              voltage: 0,
              current: 0,
              batteryCaseTemperature: 0,
              stateOfHealth: 0,
              timeRemaining: 0,
              ampHours: ampHours
            };
            if (isExisting == null) {
              vm.nmeaPowerInstances.push(obj);
            } else {
              isExisting.ampHours = ampHours;
            }
          } else if (nmeaPowerDcType === nmeaDcTypesEnum.WindPower) {
            var isExisting = vm.nmeaPowerInstances.find(function (nmeaPowerInstance) {
              return nmeaPowerInstance.instanceNumber == instanceNumber && nmeaPowerInstance.nmeaSourceId == nmeaSourceId;
            });
            var obj = {
              instanceNumber: instanceNumber,
              nmeaSourceId: nmeaSourceId,
              name: "Wind Power " + instanceNumber,
              stateOfCharge: 0,
              voltage: 0,
              current: 0,
              batteryCaseTemperature: 0,
              stateOfHealth: 0,
              timeRemaining: 0,
              ampHours: ampHours
            };
            if (isExisting == null) {
              vm.nmeaPowerInstances.push(obj);
            } else {
              isExisting.ampHours = ampHours;
            }
          }
        }

      };

      vm.updateBatteryVoltageValues = function (instanceNumber, nmeaData, nmeaSourceId) {
        var nmeaDataBatteryVoltageField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127508Voltage;
        });
        if (nmeaDataBatteryVoltageField != null) {
          batteryVoltage = +nmeaDataBatteryVoltageField.nmeaDataFieldValue;
          batteryVoltage = batteryVoltage.toFixed(1);
          var isExisting = vm.nmeaPowerInstances.find(function (nmeaPowerInstance) {
            return nmeaPowerInstance.instanceNumber == instanceNumber && nmeaPowerInstance.nmeaSourceId == nmeaSourceId;
          });
          isExisting.voltage = batteryVoltage;
        }
      };

      vm.updateBatteryCurrentValues = function (instanceNumber, nmeaData, nmeaSourceId) {
        var nmeaDataBatteryCurrentField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127508Current;
        });
        if (nmeaDataBatteryCurrentField != null) {
          batteryCurrent = +nmeaDataBatteryCurrentField.nmeaDataFieldValue;
          batteryCurrent = batteryCurrent.toFixed(1);
          var isExisting = vm.nmeaPowerInstances.find(function (nmeaPowerInstance) {
            return nmeaPowerInstance.instanceNumber == instanceNumber && nmeaPowerInstance.nmeaSourceId == nmeaSourceId;
          });
          isExisting.current = batteryCurrent;
        }
      };

      vm.updateBatteryCaseTemperatureValues = function (instanceNumber, nmeaData, nmeaSourceId) {
        var nmeaDataBatteryCaseTemperatureField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127508Temperature;
        });
        if (nmeaDataBatteryCaseTemperatureField != null) {
          batteryTempInC = +nmeaDataBatteryCaseTemperatureField.nmeaDataFieldValue;
          batteryTempInC = batteryTempInC.toFixed(1);
          var isExisting = vm.nmeaPowerInstances.find(function (nmeaPowerInstance) {
            return nmeaPowerInstance.instanceNumber == instanceNumber && nmeaPowerInstance.nmeaSourceId == nmeaSourceId;
          });
          isExisting.batteryCaseTemperature = batteryTempInC;
        }

      };
      ///////////////////////////////////////////////////////////////
      $timeout(function () {
        am4core.useTheme(am4themes_animated);
        vm.chart = am4core.create("chartdiv", am4charts.XYChart);
        // chart.data = vm.graphData.map(function(d){
        //   return {
        //     date: d.label,
        //     value: d.value
        //   };
        // })

        // Set input format for the dates
        vm.chart.dateFormatter.inputDateFormat = "yyyy-MM-dd HH:mm:ssZ";

        // Create axes
        var dateAxis = new am4charts.DateAxis();
        dateAxis.dateFormatter = new am4core.DateFormatter();
        // dateAxis.dateFormatter.dateFormat  = "yyyy-MM-dd HH:mm:ss";
        // dateAxis.dateFormats.setKey("day", "MMM dd HH:mm");
        // dateAxis.dateFormats.setKey("hour", "MMM dd HH:mm");
        dateAxis.dateFormats.setKey("minute", "dd/MMM/yyyy HH:mm");
        dateAxis.baseInterval = {
          "timeUnit": "minute",
          "count": 15
        }
        vm.chart.xAxes.push(dateAxis);
        var yAxes = new am4charts.ValueAxis();
        yAxes.numberFormatter = new am4core.NumberFormatter();
        yAxes.numberFormatter.numberFormat = "#.#";
        vm.chart.yAxes.push(yAxes);
        // Create series
        var series = vm.chart.series.push(new am4charts.LineSeries());
        series.dataFields.valueY = "value";
        series.dataFields.dateX = "label";
        series.tooltipText = "{value}"
        series.strokeWidth = 2;
        series.minBulletDistance = 15;

        // Drop-shaped tooltips
        series.tooltip.background.cornerRadius = 20;
        series.tooltip.background.strokeOpacity = 0;
        series.tooltip.pointerOrientation = "vertical";
        series.tooltip.label.minWidth = 40;
        series.tooltip.label.minHeight = 40;
        series.tooltip.label.textAlign = "middle";
        series.tooltip.label.textValign = "middle";

        // Make bullets grow on hover
        var bullet = series.bullets.push(new am4charts.CircleBullet());
        bullet.circle.strokeWidth = 2;
        bullet.circle.radius = 4;
        bullet.circle.fill = am4core.color("#fff");

        var bullethover = bullet.states.create("hover");
        bullethover.properties.scale = 1.3;

        //Make a panning cursor
        vm.chart.cursor = new am4charts.XYCursor();
        vm.chart.cursor.behavior = "panXY";
        vm.chart.cursor.xAxis = dateAxis;
        vm.chart.cursor.snapToSeries = series;

        // Create vertical scrollbar and place it before the value axis
        // chart.scrollbarY = new am4core.Scrollbar();
        // chart.scrollbarY.parent = chart.leftAxesContainer;
        // chart.scrollbarY.toBack();

        // Create a horizontal scrollbar with previe and place it underneath the date axis
        vm.chart.scrollbarX = new am4charts.XYChartScrollbar();
        vm.chart.scrollbarX.series.push(series);
        vm.chart.scrollbarX.parent = vm.chart.bottomAxesContainer;

        //dateAxis.start = 0.79;
        dateAxis.keepSelection = true;
        vm.chart.data = angular.copy(vm.powerGraphData);
      }, 100)


    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.nmea')
    .controller('nmeaIndexController', function (sessionService, settingEnum, allowedUnitsEnum, nmeaDashboardAlerts, currentSentinel, nmeaDcTypesEnum,
      nmeaTemperatureSourceEnum, nmeaDataFieldEnum, moment, $uibModal, nmeaService, nmeaEngineAlertsEnum, lastUpdatedOn, currentTripNmeaData, engineWidgetNmeaData,
      courseNmeaData, powerNmeaData, fluidLevelNmeaData, temperatureNmeaData, humidityNmeaData, navigationService, nmeaFluidTypesEnum,
      nmeaMappings, $stateParams, $scope, $state, $rootScope, notificationHub, oemConfig, userService, toastr, SweetAlert) {
      var vm = this;
      vm.oemConfig = angular.copy(oemConfig);
      var settings = sessionService.getUserSettings();
      var tempSetting = settings.find(function (x) {
        return x.id === settingEnum.Temperature.id;
      });
      var speedSetting = settings.find(function (x) {
        return x.id === settingEnum.Speed.id;
      });
      vm.nmeaFluidTypesEnum = nmeaFluidTypesEnum;
      vm.alerts = [];
      vm.currentSentinel = currentSentinel;
      vm.showSampleData = false;
      if (vm.currentSentinel.imei.length != 15) {
        vm.showSampleData = true;
      }

      vm.lastUpdatedOn = lastUpdatedOn;
      vm.nmeaDataFieldEnum = nmeaDataFieldEnum;
      vm.currentTripCount = 0;
      vm.nmeaTimeToEmptyInHr = currentTripNmeaData.timeToEmpty;
      if (vm.nmeaTimeToEmptyInHr != null) {
        vm.currentTripCount = vm.currentTripCount + 1;
      }
      vm.nmeaDistanceToEmptyInNm = currentTripNmeaData.distanceToEmpty;
      if (vm.nmeaDistanceToEmptyInNm != null) {
        vm.currentTripCount = vm.currentTripCount + 1;
      }
      vm.nmeaTripTimeInHr = currentTripNmeaData.tripTime;
      if (vm.nmeaTripTimeInHr != null) {
        vm.currentTripCount = vm.currentTripCount + 1;
      }
      vm.totalComulativeDistance = currentTripNmeaData.totalComulativeDistance;
      if (vm.totalComulativeDistance != null) {
        vm.currentTripCount = vm.currentTripCount + 1;
      }
      vm.nmeaWaterDepth = courseNmeaData.waterDepth;
      vm.nmeaCogInDeg = courseNmeaData.cog;
      vm.nmeaSogInKnots = courseNmeaData.sog;
      vm.nmeaSowInKnots = courseNmeaData.sow;
      vm.nmeaWindSpeedInKnots = courseNmeaData.windSpeed;
      vm.nmeaWindAngleInDegree = courseNmeaData.windAngle;
      vm.nmeaTemperatureSourceEnum = nmeaTemperatureSourceEnum;

      vm.temperatureCount = 0;
      vm.insideTemperature = temperatureNmeaData.inside;
      if (vm.insideTemperature != null) {
        vm.temperatureCount = vm.temperatureCount + 1;
      }
      vm.outsideTemperature = temperatureNmeaData.outside;
      if (vm.outsideTemperature != null) {
        vm.temperatureCount = vm.temperatureCount + 1;
      }
      vm.seaTemperature = temperatureNmeaData.sea;
      if (vm.seaTemperature != null) {
        vm.temperatureCount = vm.temperatureCount + 1;
      }
      vm.engineRoomTemperature = temperatureNmeaData.engineRoom;
      if (vm.engineRoomTemperature != null) {
        vm.temperatureCount = vm.temperatureCount + 1;
      }
      vm.mainCabinTemperature = temperatureNmeaData.mainCabin;
      if (vm.mainCabinTemperature != null) {
        vm.temperatureCount = vm.temperatureCount + 1;
      }
      vm.liveWellTemperature = temperatureNmeaData.liveWell;
      if (vm.liveWellTemperature != null) {
        vm.temperatureCount = vm.temperatureCount + 1;
      }
      vm.bailWellTemperature = temperatureNmeaData.bailWell;
      if (vm.bailWellTemperature != null) {
        vm.temperatureCount = vm.temperatureCount + 1;
      }
      vm.refrigerationTemperature = temperatureNmeaData.refrigration;
      if (vm.refrigerationTemperature != null) {
        vm.temperatureCount = vm.temperatureCount + 1;
      }
      vm.heatingSystemTemperature = temperatureNmeaData.heatingSystem;
      if (vm.heatingSystemTemperature != null) {
        vm.temperatureCount = vm.temperatureCount + 1;
      }
      vm.dewPointTemperature = temperatureNmeaData.dewPoint;
      if (vm.dewPointTemperature != null) {
        vm.temperatureCount = vm.temperatureCount + 1;
      }
      vm.windChillTemperature = temperatureNmeaData.windChill;
      if (vm.windChillTemperature != null) {
        vm.temperatureCount = vm.temperatureCount + 1;
      }
      vm.freezerTemperature = temperatureNmeaData.freezer;
      if (vm.freezerTemperature != null) {
        vm.temperatureCount = vm.temperatureCount + 1;
      }
      vm.exhaustGasTemperature = temperatureNmeaData.exhaustGas;
      if (vm.exhaustGasTemperature != null) {
        vm.temperatureCount = vm.temperatureCount + 1;
      }

      vm.insideHumidity = humidityNmeaData.inside;
      vm.outsideHumidity = humidityNmeaData.outside;

      vm.engineSlides = [];

      vm.nmeaPowerInstances = [];
      vm.nmeaFluidInstances = [];

      if (engineWidgetNmeaData.length > 0) {
        engineWidgetNmeaData.forEach(function (engine) {
          var obj = {
            index: vm.engineSlides.length,
            id: engine.instanceNumber,
            engineName: engine.engineName,
            boostValue: engine.boost,
            speedValue: engine.speed,
            rpmValue: engine.rpm,
            oilPressureValue: engine.oilPressure,
            tilTrimValue: engine.tiltTrim,
            fuelLevelValue: engine.fuelLevel,
            engineTempValue: engine.engineTemperature,
            totalHours: engine.totalHours,
            isValidData: engine.isValidData
          };
          if (engine.totalHours != undefined) {
            if (vm.totalofTotalEngineHours == undefined) {
              vm.totalofTotalEngineHours = 0;
              vm.totalEnginesWithHoursCount = 0;
            }
            vm.totalofTotalEngineHours += engine.totalHours;
            vm.totalEnginesWithHoursCount += 1;
          }
          var isExisting = vm.engineSlides.find(function (engineSlide) {
            return engineSlide.id == engine.instanceNumber;
          });
          if (isExisting == null) {
            vm.engineSlides.push(obj);
          } else {
            var indexToDelete = vm.engineSlides.indexOf(isExisting);
            vm.engineSlides.splice(indexToDelete, 1, obj);
          }
        });
        if (vm.totalofTotalEngineHours != undefined) {
          vm.totalofTotalEngineHours = vm.totalofTotalEngineHours / vm.totalEnginesWithHoursCount;
          vm.totalofTotalEngineHours = vm.totalofTotalEngineHours;
        }
      }

      function mapPowerData() {
        vm.nmeaPowerInstances = [];
        if (powerNmeaData.length > 0) {
          var batteryTypeDataInstances = powerNmeaData.filter(function (
            powerData
          ) {
            return (
              powerData.nmeaDataFieldEnumId ==
              nmeaDataFieldEnum.Pgn127506DcType &&
              powerData.nmeaDataFieldValue == nmeaDcTypesEnum.Battery
            );
          });
          batteryTypeDataInstances.forEach(function (batteryDataInstance) {
            var powerData = powerNmeaData.find(function (powerData) {
              return (
                powerData.nmeaInstanceId ==
                batteryDataInstance.nmeaInstanceId &&
                powerData.nmeaDataFieldEnumId ==
                nmeaDataFieldEnum.Pgn127506StateOfCharge
              );
            });
            var current = powerNmeaData.find(function (powerData) {
              return (
                powerData.nmeaInstance.nmeaInstanceNumber ==
                batteryDataInstance.nmeaInstance.nmeaInstanceNumber &&
                powerData.nmeaDataFieldEnumId ==
                nmeaDataFieldEnum.Pgn127508Current &&
                powerData.nmeaInstance.sourceId ==
                batteryDataInstance.nmeaInstance.sourceId
              );
            });
            var volt = powerNmeaData.find(function (powerData) {
              return (
                powerData.nmeaInstance.nmeaInstanceNumber ==
                batteryDataInstance.nmeaInstance.nmeaInstanceNumber &&
                powerData.nmeaDataFieldEnumId ==
                nmeaDataFieldEnum.Pgn127508Voltage &&
                powerData.nmeaInstance.sourceId ==
                batteryDataInstance.nmeaInstance.sourceId
              );
            });
            var batteryObj = {
              icon: "assets/images/Battery-bank-4.png",
              class: "m-b-5 m-t-10",
              name: batteryDataInstance.nmeaInstance.instanceName,
              value:
                powerData == null ? null : powerData.nmeaDataFieldValue || null,
              instanceNumber:
                batteryDataInstance.nmeaInstance.nmeaInstanceNumber,
              instanceId: batteryDataInstance.nmeaInstance.id,
              sourceId: nmeaDcTypesEnum.Battery,
              nmeaSourceId: batteryDataInstance.nmeaInstance.sourceId,
              nmeaDataFieldEnumId: nmeaDataFieldEnum.Pgn127506StateOfCharge,
              voltage: volt == null ? null : volt.nmeaDataFieldValue,
              current: current == null ? null : current.nmeaDataFieldValue,
              dcType: batteryDataInstance.nmeaDataFieldValue,
            };
            vm.nmeaPowerInstances.push(batteryObj);
          });
          ////////////////////////////////////////////////
          var solarTypeDataInstances = powerNmeaData.filter(function (
            powerData
          ) {
            return (
              powerData.nmeaDataFieldEnumId ==
              nmeaDataFieldEnum.Pgn127506DcType &&
              powerData.nmeaDataFieldValue == nmeaDcTypesEnum.SolarCell
            );
          });
          solarTypeDataInstances.forEach(function (solarDataInstance) {
            var powerData = powerNmeaData.find(function (powerData) {
              return (
                powerData.nmeaInstanceId == solarDataInstance.nmeaInstanceId &&
                powerData.nmeaDataFieldEnumId ==
                nmeaDataFieldEnum.Pgn127506StateOfCharge
              );
            });
            var current = powerNmeaData.find(function (powerData) {
              return (
                powerData.nmeaInstance.nmeaInstanceNumber ==
                solarDataInstance.nmeaInstance.nmeaInstanceNumber &&
                powerData.nmeaInstance.sourceId ==
                solarDataInstance.nmeaInstance.sourceId &&
                powerData.nmeaDataFieldEnumId ==
                nmeaDataFieldEnum.Pgn127508Current
              );
            });
            var volt = powerNmeaData.find(function (powerData) {
              return (
                powerData.nmeaInstance.nmeaInstanceNumber ==
                solarDataInstance.nmeaInstance.nmeaInstanceNumber &&
                powerData.nmeaInstance.sourceId ==
                solarDataInstance.nmeaInstance.sourceId &&
                powerData.nmeaDataFieldEnumId ==
                nmeaDataFieldEnum.Pgn127508Voltage
              );
            });
            var solarObj = {
              icon: "assets/images/Solar-cell.png",
              class: "m-b-5 m-t-10 m-l-30",
              name: solarDataInstance.nmeaInstance.instanceName,
              value: powerData == null ? null : powerData.nmeaDataFieldValue,
              instanceNumber: solarDataInstance.nmeaInstance.nmeaInstanceNumber,
              instanceId: solarDataInstance.nmeaInstance.id,
              sourceId: nmeaDcTypesEnum.SolarCell,
              nmeaSourceId: solarDataInstance.nmeaInstance.sourceId,
              nmeaDataFieldEnumId: nmeaDataFieldEnum.Pgn127506StateOfCharge,
              voltage: volt == null ? null : volt.nmeaDataFieldValue,
              current: current == null ? null : current.nmeaDataFieldValue,
              dcType: solarDataInstance.nmeaDataFieldValue,
            };
            vm.nmeaPowerInstances.push(solarObj);
          });
          ////////////////////////////////////////////////
          var windTypeDataInstances = powerNmeaData.filter(function (
            powerData
          ) {
            return (
              powerData.nmeaDataFieldEnumId ==
              nmeaDataFieldEnum.Pgn127506DcType &&
              powerData.nmeaDataFieldValue == nmeaDcTypesEnum.WindPower
            );
          });
          windTypeDataInstances.forEach(function (windDataInstance) {
            var powerData = powerNmeaData.find(function (powerData) {
              return (
                powerData.nmeaInstanceId == windDataInstance.nmeaInstanceId &&
                powerData.nmeaDataFieldEnumId ==
                nmeaDataFieldEnum.Pgn127506StateOfCharge
              );
            });
            var current = powerNmeaData.find(function (powerData) {
              return (
                powerData.nmeaInstance.nmeaInstanceNumber ==
                windDataInstance.nmeaInstance.nmeaInstanceNumber &&
                powerData.nmeaInstance.sourceId ==
                windDataInstance.nmeaInstance.sourceId &&
                powerData.nmeaDataFieldEnumId ==
                nmeaDataFieldEnum.Pgn127508Current
              );
            });
            var volt = powerNmeaData.find(function (powerData) {
              return (
                powerData.nmeaInstance.nmeaInstanceNumber ==
                windDataInstance.nmeaInstance.nmeaInstanceNumber &&
                powerData.nmeaInstance.sourceId ==
                windDataInstance.nmeaInstance.sourceId &&
                powerData.nmeaDataFieldEnumId ==
                nmeaDataFieldEnum.Pgn127508Voltage
              );
            });
            var windObj = {
              icon: "assets/images/Wind-generator.png",
              class: "m-b-5 m-t-10",
              name: windDataInstance.nmeaInstance.instanceName,
              value: powerData == null ? null : powerData.nmeaDataFieldValue,
              instanceNumber: windDataInstance.nmeaInstance.nmeaInstanceNumber,
              instanceId: windDataInstance.nmeaInstance.id,
              sourceId: nmeaDcTypesEnum.WindPower,
              nmeaSourceId: windDataInstance.nmeaInstance.sourceId,
              nmeaDataFieldEnumId: nmeaDataFieldEnum.Pgn127506StateOfCharge,
              voltage: volt == null ? null : volt.nmeaDataFieldValue,
              current: current == null ? null : current.nmeaDataFieldValue,
              dcType: windDataInstance.nmeaDataFieldValue,
            };
            vm.nmeaPowerInstances.push(windObj);
          });
          var unknownInstances = powerNmeaData.filter(function (powerData) {
            return (
              powerData.nmeaDataFieldEnumId ==
              nmeaDataFieldEnum.Pgn127506DcType &&
              powerData.nmeaDataFieldValue == "-1"
            );
          });
          unknownInstances.forEach(function (unknownInstance) {
            var powerData = powerNmeaData.find(function (powerData) {
              return (
                powerData.nmeaInstanceId == unknownInstance.nmeaInstanceId &&
                powerData.nmeaDataFieldEnumId ==
                nmeaDataFieldEnum.Pgn127506StateOfCharge
              );
            });
            var current = powerNmeaData.find(function (powerData) {
              return (
                powerData.nmeaInstance.nmeaInstanceNumber ==
                unknownInstance.nmeaInstance.nmeaInstanceNumber &&
                powerData.nmeaInstance.sourceId ==
                unknownInstance.nmeaInstance.sourceId &&
                powerData.nmeaDataFieldEnumId ==
                nmeaDataFieldEnum.Pgn127508Current
              );
            });
            var volt = powerNmeaData.find(function (powerData) {
              return (
                powerData.nmeaInstance.nmeaInstanceNumber ==
                unknownInstance.nmeaInstance.nmeaInstanceNumber &&
                powerData.nmeaInstance.sourceId ==
                unknownInstance.nmeaInstance.sourceId &&
                powerData.nmeaDataFieldEnumId ==
                nmeaDataFieldEnum.Pgn127508Voltage
              );
            });
            var windObj = {
              icon: "assets/images/power source.png",
              class: "m-b-5 m-t-10",
              name: unknownInstance.nmeaInstance.instanceName,
              value: powerData == null ? null : powerData.nmeaDataFieldValue,
              instanceNumber: unknownInstance.nmeaInstance.nmeaInstanceNumber,
              instanceId: unknownInstance.nmeaInstance.id,
              sourceId: nmeaDcTypesEnum.WindPower,
              nmeaSourceId: unknownInstance.nmeaInstance.sourceId,
              nmeaDataFieldEnumId: nmeaDataFieldEnum.Pgn127506StateOfCharge,
              voltage: volt == null ? null : volt.nmeaDataFieldValue,
              current: current == null ? null : current.nmeaDataFieldValue,
              dcType: unknownInstance.nmeaDataFieldValue,
            };
            vm.nmeaPowerInstances.push(windObj);
          });
        }
      }
      mapPowerData();

      function mapFluidData() {
        vm.nmeaFluidInstances = [];
        if (fluidLevelNmeaData.length > 0) {
          /////////////////////Fuel Type///////////////////////////
          var fluidFuelTypeDataInstances = fluidLevelNmeaData.filter(function (
            fluidData
          ) {
            return (
              fluidData.nmeaDataFieldEnumId ==
              nmeaDataFieldEnum.Pgn127505Type &&
              fluidData.nmeaDataFieldValue == nmeaFluidTypesEnum.Fuel
            );
          });
          fluidFuelTypeDataInstances.forEach(function (fluidDataInstance) {
            var fluidData = fluidLevelNmeaData.find(function (fluidData) {
              return (
                fluidData.nmeaInstanceId == fluidDataInstance.nmeaInstanceId &&
                fluidData.nmeaDataFieldEnumId ==
                nmeaDataFieldEnum.Pgn127505Level
              );
            });

            var fluidCapacity = fluidLevelNmeaData.find(function (fluidData) {
              return (
                fluidData.nmeaInstanceId == fluidDataInstance.nmeaInstanceId &&
                fluidData.nmeaDataFieldEnumId ==
                nmeaDataFieldEnum.Pgn127505Capacity
              );
            });

            var fuelObj = {
              canvasId:
                "fuelLevelGauge_" +
                fluidDataInstance.nmeaInstanceId,
              value:
                fluidData == null
                  ? null
                  : Math.round(fluidData.nmeaDataFieldValue, 1) || null,
              sourceId: nmeaFluidTypesEnum.Fuel,
              dcType: "Fuel",
              name: fluidDataInstance.nmeaInstance.instanceName,
              instanceNumber: fluidDataInstance.nmeaInstance.nmeaInstanceNumber,
              nmeaSourceId:fluidDataInstance.nmeaInstance.sourceId,
            };

            setTimeout(function () {
              drawVerticalProgressGauge(
                fuelObj.canvasId,
                Math.round(fluidData.nmeaDataFieldValue, 1)
              );
            }, 500); //Draws Vertical Progress Bar Gauge

            vm.nmeaFluidInstances.push(fuelObj);
          });
          /////////////////////Fuel Type///////////////////////////

          /////////////////////Fresh Water Type///////////////////////////
          var fluidFreshWaterTypeDataInstances = fluidLevelNmeaData.filter(
            function (fluidData) {
              return (
                fluidData.nmeaDataFieldEnumId ==
                nmeaDataFieldEnum.Pgn127505Type &&
                fluidData.nmeaDataFieldValue == nmeaFluidTypesEnum.FreshWater
              );
            }
          );
          fluidFreshWaterTypeDataInstances.forEach(function (
            fluidDataInstance
          ) {
            var fluidData = fluidLevelNmeaData.find(function (fluidData) {
              return (
                fluidData.nmeaInstanceId == fluidDataInstance.nmeaInstanceId &&
                fluidData.nmeaDataFieldEnumId ==
                nmeaDataFieldEnum.Pgn127505Level
              );
            });

            var fluidCapacity = fluidLevelNmeaData.find(function (fluidData) {
              return (
                fluidData.nmeaInstanceId == fluidDataInstance.nmeaInstanceId &&
                fluidData.nmeaDataFieldEnumId ==
                nmeaDataFieldEnum.Pgn127505Capacity
              );
            });
            var freshWaterObj = {
              canvasId:
                "freshWaterGauge_" +
                fluidDataInstance.nmeaInstanceId,
              value:
                fluidData == null
                  ? null
                  : Math.round(fluidData.nmeaDataFieldValue, 1) || null,
              sourceId: nmeaFluidTypesEnum.FreshWater,
              dcType: "Fresh Water",
              name: fluidDataInstance.nmeaInstance.instanceName,
              instanceNumber: fluidDataInstance.nmeaInstance.nmeaInstanceNumber,
              nmeaSourceId:fluidDataInstance.nmeaInstance.sourceId,
            };

            setTimeout(function () {
              drawVerticalProgressGauge(
                freshWaterObj.canvasId,
                Math.round(fluidData.nmeaDataFieldValue, 1)
              );
            }, 500); //Draws Vertical Progress Bar Gauge

            vm.nmeaFluidInstances.push(freshWaterObj);
          });
          /////////////////////Fresh Water Type///////////////////////////

          /////////////////////Waste Water Type///////////////////////////
          var fluidWasteWaterTypeDataInstances = fluidLevelNmeaData.filter(
            function (fluidData) {
              return (
                fluidData.nmeaDataFieldEnumId ==
                nmeaDataFieldEnum.Pgn127505Type &&
                fluidData.nmeaDataFieldValue == nmeaFluidTypesEnum.WasteWater
              );
            }
          );
          fluidWasteWaterTypeDataInstances.forEach(function (
            fluidDataInstance
          ) {
            var fluidData = fluidLevelNmeaData.find(function (fluidData) {
              return (
                fluidData.nmeaInstanceId == fluidDataInstance.nmeaInstanceId &&
                fluidData.nmeaDataFieldEnumId ==
                nmeaDataFieldEnum.Pgn127505Level
              );
            });

            var fluidCapacity = fluidLevelNmeaData.find(function (fluidData) {
              return (
                fluidData.nmeaInstanceId == fluidDataInstance.nmeaInstanceId &&
                fluidData.nmeaDataFieldEnumId ==
                nmeaDataFieldEnum.Pgn127505Capacity
              );
            });
            var wasteWaterObj = {
              canvasId:
                "wasteWaterGauge_" +
                fluidDataInstance.nmeaInstanceId,
              value:
                fluidData == null
                  ? null
                  : Math.round(fluidData.nmeaDataFieldValue, 1) || null,
              sourceId:nmeaFluidTypesEnum.WasteWater,
              dcType: "Waste Water",
              name: fluidDataInstance.nmeaInstance.instanceName,
              instanceNumber: fluidDataInstance.nmeaInstance.nmeaInstanceNumber,
              nmeaSourceId:fluidDataInstance.nmeaInstance.sourceId,
            };

            setTimeout(function () {
              drawReverseVerticalProgressGauge(
                wasteWaterObj.canvasId,
                Math.round(fluidData.nmeaDataFieldValue, 1)
              );
            }, 500); //Draws Vertical Progress Bar Gauge

            vm.nmeaFluidInstances.push(wasteWaterObj);
          });
          /////////////////////Waste Water Type///////////////////////////

          /////////////////////Live Well Type///////////////////////////
          var fluidLiveWellTypeDataInstances = fluidLevelNmeaData.filter(
            function (fluidData) {
              return (
                fluidData.nmeaDataFieldEnumId ==
                nmeaDataFieldEnum.Pgn127505Type &&
                fluidData.nmeaDataFieldValue == nmeaFluidTypesEnum.LiveWell
              );
            }
          );
          fluidLiveWellTypeDataInstances.forEach(function (fluidDataInstance) {
            var fluidData = fluidLevelNmeaData.find(function (fluidData) {
              return (
                fluidData.nmeaInstanceId == fluidDataInstance.nmeaInstanceId &&
                fluidData.nmeaDataFieldEnumId ==
                nmeaDataFieldEnum.Pgn127505Level
              );
            });

            var fluidCapacity = fluidLevelNmeaData.find(function (fluidData) {
              return (
                fluidData.nmeaInstanceId == fluidDataInstance.nmeaInstanceId &&
                fluidData.nmeaDataFieldEnumId ==
                nmeaDataFieldEnum.Pgn127505Capacity
              );
            });
            var liveWellObj = {
              canvasId:
                "liveWellLevelGauge_" +
                fluidDataInstance.nmeaInstanceId,
              value:
                fluidData == null
                  ? null
                  : Math.round(fluidData.nmeaDataFieldValue, 1) || null,
              sourceId:  nmeaFluidTypesEnum.LiveWell,
              dcType: "Live Well",
              name: fluidDataInstance.nmeaInstance.instanceName,
              instanceNumber: fluidDataInstance.nmeaInstance.nmeaInstanceNumber,
              nmeaSourceId:fluidDataInstance.nmeaInstance.sourceId,
            };

            setTimeout(function () {
              drawVerticalProgressGauge(
                liveWellObj.canvasId,
                Math.round(fluidData.nmeaDataFieldValue, 1)
              );
            }, 500); //Draws Vertical Progress Bar Gauge

            vm.nmeaFluidInstances.push(liveWellObj);
          });
          /////////////////////Live Well Type///////////////////////////

          /////////////////////Oil Type///////////////////////////
          var fluidOilTypeDataInstances = fluidLevelNmeaData.filter(function (
            fluidData
          ) {
            return (
              fluidData.nmeaDataFieldEnumId ==
              nmeaDataFieldEnum.Pgn127505Type &&
              fluidData.nmeaDataFieldValue == nmeaFluidTypesEnum.Oil
            );
          });
          fluidOilTypeDataInstances.forEach(function (fluidDataInstance) {
            var fluidData = fluidLevelNmeaData.find(function (fluidData) {
              return (
                fluidData.nmeaInstanceId == fluidDataInstance.nmeaInstanceId &&
                fluidData.nmeaDataFieldEnumId ==
                nmeaDataFieldEnum.Pgn127505Level
              );
            });

            var fluidCapacity = fluidLevelNmeaData.find(function (fluidData) {
              return (
                fluidData.nmeaInstanceId == fluidDataInstance.nmeaInstanceId &&
                fluidData.nmeaDataFieldEnumId ==
                nmeaDataFieldEnum.Pgn127505Capacity
              );
            });
            var oilObj = {
              canvasId:
                "oilLevelGauge_" +
                fluidDataInstance.nmeaInstanceId,
              value:
                fluidData == null
                  ? null
                  : Math.round(fluidData.nmeaDataFieldValue, 1) || null,
              sourceId: nmeaFluidTypesEnum.Oil,
              dcType: "Oil",
              name: fluidDataInstance.nmeaInstance.instanceName,
              instanceNumber: fluidDataInstance.nmeaInstance.nmeaInstanceNumber,
              nmeaSourceId:fluidDataInstance.nmeaInstance.sourceId,
            };

            setTimeout(function () {
              drawVerticalProgressGauge(
                oilObj.canvasId,
                Math.round(fluidData.nmeaDataFieldValue, 1)
              );
            }, 500); //Draws Vertical Progress Bar Gauge

            vm.nmeaFluidInstances.push(oilObj);
          });
          /////////////////////Oil Type///////////////////////////

          /////////////////////Black Water Type///////////////////////////
          var fluidBlackWaterTypeDataInstances = fluidLevelNmeaData.filter(
            function (fluidData) {
              return (
                fluidData.nmeaDataFieldEnumId ==
                nmeaDataFieldEnum.Pgn127505Type &&
                fluidData.nmeaDataFieldValue == nmeaFluidTypesEnum.BlackWater
              );
            }
          );
          fluidBlackWaterTypeDataInstances.forEach(function (
            fluidDataInstance
          ) {
            var fluidData = fluidLevelNmeaData.find(function (fluidData) {
              return (
                fluidData.nmeaInstanceId == fluidDataInstance.nmeaInstanceId &&
                fluidData.nmeaDataFieldEnumId ==
                nmeaDataFieldEnum.Pgn127505Level
              );
            });

            var fluidCapacity = fluidLevelNmeaData.find(function (fluidData) {
              return (
                fluidData.nmeaInstanceId == fluidDataInstance.nmeaInstanceId &&
                fluidData.nmeaDataFieldEnumId ==
                nmeaDataFieldEnum.Pgn127505Capacity
              );
            });
            var blackWaterObj = {
              canvasId:
                "blackWaterGauge_" +
                fluidDataInstance.nmeaInstanceId,
              value:
                fluidData == null
                  ? null
                  : Math.round(fluidData.nmeaDataFieldValue, 1) || null,
                  sourceId: nmeaFluidTypesEnum.BlackWater,
              dcType: "Black Water",
              name: fluidDataInstance.nmeaInstance.instanceName,
              instanceNumber: fluidDataInstance.nmeaInstance.nmeaInstanceNumber,
              nmeaSourceId:fluidDataInstance.nmeaInstance.sourceId,
            };

            setTimeout(function () {
              drawReverseVerticalProgressGauge(
                blackWaterObj.canvasId,
                Math.round(fluidData.nmeaDataFieldValue, 1)
              );
            }, 500); //Draws Vertical Progress Bar Gauge

            vm.nmeaFluidInstances.push(blackWaterObj);
          });
          /////////////////////Black Water Type///////////////////////////
        }
      }
      mapFluidData();

      if (nmeaDashboardAlerts.length > 0) {
        nmeaDashboardAlerts.forEach(function (alertValue) {
          if (alertValue == nmeaEngineAlertsEnum.CheckEngine) {
            var obj = {
              image: "Check_engine.png",
              text: "CheckEngine.Text",
            };
            vm.alerts.push(obj);
          } else if (alertValue == nmeaEngineAlertsEnum.OverTemperature) {
            var obj = {
              image: "Over_temperature.png",
              text: "OverTemperature.Text",
            };
            vm.alerts.push(obj);
          } else if (alertValue == nmeaEngineAlertsEnum.LowOilPressure) {
            var obj = {
              image: "Low_oil_pressure.png",
              text: "LowOilPressure.Text",
            };
            vm.alerts.push(obj);
          } else if (alertValue == nmeaEngineAlertsEnum.LowOilLevel) {
            var obj = {
              image: "Low_oil_level.png",
              text: "LowOilLevel.Text",
            };
            vm.alerts.push(obj);
          } else if (alertValue == nmeaEngineAlertsEnum.LowFuelPressure) {
            var obj = {
              image: "Low_fuel_pressure.png",
              text: "LowFuelPressure.Text",
            };
            vm.alerts.push(obj);
          } else if (alertValue == nmeaEngineAlertsEnum.LowSystemVoltage) {
            var obj = {
              image: "Power_reduction.png",
              text: "LowSystemVoltage.Text",
            };
            vm.alerts.push(obj);
          } else if (alertValue == nmeaEngineAlertsEnum.LowCoolantLevel) {
            var obj = {
              image: "Low_coolant_level.png",
              text: "LowCoolantLevel.Text",
            };
            vm.alerts.push(obj);
          } else if (alertValue == nmeaEngineAlertsEnum.WaterFlow) {
            var obj = {
              image: "Water_flow.png",
              text: "WaterFlow.Text",
            };
            vm.alerts.push(obj);
          } else if (alertValue == nmeaEngineAlertsEnum.WaterInFuel) {
            var obj = {
              image: "Water_in_fuel.png",
              text: "WaterInFuel.Text",
            };
            vm.alerts.push(obj);
          } else if (alertValue == nmeaEngineAlertsEnum.ChargeIndicator) {
            var obj = {
              image: "Charge_indicator.png",
              text: "ChargeIndicator.Text",
            };
            vm.alerts.push(obj);
          } else if (alertValue == nmeaEngineAlertsEnum.PreheatIndicator) {
            var obj = {
              image: "Preheat_indicator.png",
              text: "PreheatIndicator.Text",
            };
            vm.alerts.push(obj);
          } else if (alertValue == nmeaEngineAlertsEnum.HighBoostPressure) {
            var obj = {
              image: "rev_limit.png",
              text: "HighBoostPressure.Text",
            };
            vm.alerts.push(obj);
          } else if (alertValue == nmeaEngineAlertsEnum.RevLimitExceeded) {
            var obj = {
              image: "rev_limit.png",
              text: "RevLimitExceeded.Text",
            };
            vm.alerts.push(obj);
          } else if (alertValue == nmeaEngineAlertsEnum.EGRSystem) {
            var obj = {
              image: "EGR_system_alert.png",
              text: "EGRSystem.Text",
            };
            vm.alerts.push(obj);
          } else if (
            alertValue == nmeaEngineAlertsEnum.ThrottlePositionSensor
          ) {
            var obj = {
              image: "Throttle_position_sensor.png",
              text: "ThrottlePositionSensor.Text",
            };
            vm.alerts.push(obj);
          } else if (alertValue == nmeaEngineAlertsEnum.EngineEmergencyStop) {
            var obj = {
              image: "Engine_emergency_stop_mode.png",
              text: "EngineEmergencyStop.Text",
            };
            vm.alerts.push(obj);
          }
        });
      }

      vm.sentinelId = $stateParams.sentinelId;
      vm.activeEngineSlide = 0; //Carousel initial active slide
      vm.activeBilgePumpSlide = 0; //Carousel initial active slide
      var currentDate = new Date();
      vm.currentDay = currentDate.getDay(); //Current Day

      navigationService.navigation = {
        backState: "boat.home",
        backStateParams: {
          sentinelId: $stateParams.sentinelId,
        },
      };
      vm.goBack = function () {
        $rootScope.goBack();
      };

      var hub = new notificationHub();
      hub.on("pushNmeaData", function (data) {
        console.log("Data Recieved");
        var currentPgnMapping = nmeaMappings.find(function (mapping) {
          return mapping.Pgn === data.pgn && mapping.Controller == "Dashboard";
        });
        if (
          currentPgnMapping != undefined &&
          data.userSentinelId == $stateParams.sentinelId
        ) {
          currentPgnMapping.Functions.forEach(function (funcName) {
            $scope.$eval(funcName).call([], data.instance, data.nmeaData, data.source);
          });
          vm.lastUpdatedOn = moment.utc().format("YYYY-MM-DDTHH:mm:ss");
          $rootScope.$apply();
        }
      });
      $scope.$on("$destroy", function () {
        hub.off("pushNmeaData");
      });

      vm.enabled = true;
      vm.showYS6Dashboard = function () {
        sessionService.setDashboardSwitch(false);
        $state.go("boat.status", {
          sentinelId: $stateParams.sentinelId,
        });
      };

      vm.openGraphDialoge = function (
        sentinelId,
        nmeaDataFieldEnumId,
        instanceNumber,
        sourceId,
        intanceType,
        intanceName,
        nmeaSourceId
      ) {
        $uibModal.open({
          templateUrl: "app/main/nmea/graph-modal/modal.controller.html",
          controller: "modalGraphController",
          controllerAs: "vm",
          windowClass: "graph-modal",
          size: "lg",
          resolve: {
            graphData: function () {
              return nmeaService.getNmeaGraphData({
                intervalId: 1,
                instanceNumber: instanceNumber,
                nmeaDataFieldEnum: nmeaDataFieldEnumId,
                sentinelId: sentinelId,
                sourceId: sourceId,
                getByDate: true,
                nmeaSourceId: nmeaSourceId
              });
            },
            intanceType: function () {
              return intanceType;
            },
            intanceName: function () {
              return intanceName;
            },
            sourceId: function () {
              return sourceId;
            },
            instanceNumber: function () {
              return instanceNumber;
            },
            nmeaEnumId: function () {
              return nmeaDataFieldEnumId;
            },
            nmeaSourceId: function() {
              return nmeaSourceId;
            }
          }
        });
      };

      vm.days = [
        {
          //Timeline Hard-Coded Days
          name: "Sunday",
          onTime: "",
        },
        {
          name: "Monday",
          onTime: "",
        },
        {
          name: "Tuesday",
          onTime: "",
        },
        {
          name: "Wednesday",
          onTime: "",
        },
        {
          name: "Thursday",
          onTime: "",
        },
        {
          name: "Friday",
          onTime: "",
        },
        {
          name: "Saturday",
          onTime: "",
        },
      ];

      vm.bilgePumpSlides = [
        //Bilge Pump Slides
        {
          id: 0,
          bilgePumpSwitch: "Off",
          days: [
            {
              name: "Sunday",
              onTime: "",
            },
            {
              name: "Monday",
              onTime: "",
            },
            {
              name: "Tuesday",
              onTime: "",
            },
            {
              name: "Wednesday",
              onTime: "",
            },
            {
              name: "Thursday",
              onTime: "",
            },
            {
              name: "Friday",
              onTime: "",
            },
            {
              name: "Saturday",
              onTime: "",
            },
          ],
        },
        {
          id: 1,
          bilgePumpSwitch: "Off",
          days: [
            {
              name: "Sunday",
              onTime: "",
            },
            {
              name: "Monday",
              onTime: "",
            },
            {
              name: "Tuesday",
              onTime: "",
            },
            {
              name: "Wednesday",
              onTime: "",
            },
            {
              name: "Thursday",
              onTime: "",
            },
            {
              name: "Friday",
              onTime: "",
            },
            {
              name: "Saturday",
              onTime: "",
            },
          ],
        },
        {
          id: 2,
          bilgePumpSwitch: "Off",
          days: [
            {
              name: "Sunday",
              onTime: "",
            },
            {
              name: "Monday",
              onTime: "",
            },
            {
              name: "Tuesday",
              onTime: "",
            },
            {
              name: "Wednesday",
              onTime: "",
            },
            {
              name: "Thursday",
              onTime: "",
            },
            {
              name: "Friday",
              onTime: "",
            },
            {
              name: "Saturday",
              onTime: "",
            },
          ],
        },
        {
          id: 3,
          bilgePumpSwitch: "Off",
          days: [
            {
              name: "Sunday",
              onTime: "",
            },
            {
              name: "Monday",
              onTime: "",
            },
            {
              name: "Tuesday",
              onTime: "",
            },
            {
              name: "Wednesday",
              onTime: "",
            },
            {
              name: "Thursday",
              onTime: "",
            },
            {
              name: "Friday",
              onTime: "",
            },
            {
              name: "Saturday",
              onTime: "",
            },
          ],
        },
        {
          id: 4,
          bilgePumpSwitch: "Off",
          days: [
            {
              name: "Sunday",
              onTime: "",
            },
            {
              name: "Monday",
              onTime: "",
            },
            {
              name: "Tuesday",
              onTime: "",
            },
            {
              name: "Wednesday",
              onTime: "",
            },
            {
              name: "Thursday",
              onTime: "",
            },
            {
              name: "Friday",
              onTime: "",
            },
            {
              name: "Saturday",
              onTime: "",
            },
          ],
        },
      ];

      vm.bilgePumpSlides.forEach(function (slide, sliderIndex) {
        if (sliderIndex % 2 == 0) {
          slide.bilgePumpSwitch = "Off";
        } else {
          slide.bilgePumpSwitch = "On";
        }
        slide.days.forEach(function (day, index) {
          if (day.name == vm.days[vm.currentDay].name) {
            day.onTime = Math.floor(Math.random() * 4) + ":00h"; // Blige Pump 'On' Time Value For Today
            return;
          } else if (vm.currentDay < index) {
            day.onTime = undefined;
          } else {
            day.onTime = Math.floor(Math.random() * 4) + ":00h"; // Blige Pump 'On' Time Value For Days before Today
          }
        });
      });

      setTimeout(function () {
        vm.onInit(); //Initializes All data to display in Engine Carousel
      }, 0);

      degreeToRadians = function (degrees) {
        var pi = Math.PI;
        return degrees * (pi / 180);
      };

      drawArc = function (
        canvasId,
        engineName,
        height,
        width,
        radius,
        startAngleInDegrees,
        endAngleInDegrees,
        lineWidth,
        currentValue,
        unit
      ) {
        var c = document.getElementById(canvasId);
        if (height != null) {
          c.height = height;
        }
        if (width != null) {
          c.width = width;
        }
        var centerX = c.width / 2;
        var centerY = c.height / 2;
        if (canvasId == "trimGauge_" + engineName) {
          centerX = 90;
          centerY = 25;
        }
        var ctx = c.getContext("2d");
        ctx.beginPath();
        if (currentValue != undefined) {
          ctx.textAlign = "center";
          ctx.font = '25px "proximanova", Arial, sans-serif';
          ctx.fillStyle = "#ffffff";
          if (
            canvasId != "trimGauge_" + engineName &&
            canvasId != "speedGauge_" + engineName
          ) {
            ctx.fillText(currentValue.toString(), centerX, centerY); //Draws the Current Value in Center of Gauge
          } else if (canvasId == "speedGauge_" + engineName) {
            ctx.font = '40px "proximanova", Arial, sans-serif';
            ctx.fillText(currentValue.toString(), centerX, centerY); //Draws the Current Value in Center of Gauge
          }
          ctx.font = 'bold 17px "proximanova", Arial, sans-serif';
          if (canvasId == "speedGauge_" + engineName) {
            ctx.fillText("Speed", centerX, centerY + 20); //Draws the Gauge Name
          } else if (canvasId == "boostGauge_" + engineName) {
            ctx.fillText("Boost", centerX, centerY + 20); //Draws the Gauge Name
          } else if (canvasId == "oilPressureGauge_" + engineName) {
            ctx.fillText("Oil Pressure", centerX, centerY + 20); //Draws the Gauge Name
          } else if (canvasId == "rpmGauge_" + engineName) {
            ctx.fillText("RPM", centerX, centerY + 20); //Draws the Gauge Name
          }
          if (canvasId == "rpmGauge_" + engineName) {
            ctx.font = 'bold 15px "proximanova", Arial, sans-serif';
            ctx.fillStyle = "#cc0000";
            ctx.fillText(unit, centerX, centerY + 35); //Draws the Gauge Unit for only RPM Gauge
          } else if (canvasId == "trimGauge_" + engineName) {
            ctx.font = 'bold 9px "proximanova", Arial, sans-serif';
            ctx.fillStyle = "#ffffff";
            ctx.fillText("TRIM", centerX - 55, centerY + 20); //Draws The 'TRIM' Labels for only Trim Gauge
            ctx.fillText("KUS", centerX + 55, centerY + 20); //Draws The 'KUS' Labels for only Trim Gauge
            ctx.font = 'bold 13px "proximanova", Arial, sans-serif';
            ctx.fillText(
              currentValue.toString() + unit,
              centerX + 2,
              centerY + 30
            ); //Draws the Gauge Unit for only Trim Gauge
          } else {
            ctx.font = 'bold 15px "proximanova", Arial, sans-serif';
            ctx.fillStyle = "#cc0000";
            ctx.fillText(unit, centerX, centerY + 40); //Draws the Gauge Unit for All gauges except RPM Gauge
          }
        }
        ctx.lineWidth = lineWidth;
        var startAngle = degreeToRadians(startAngleInDegrees);
        var endAngle = degreeToRadians(endAngleInDegrees);
        ctx.arc(centerX, centerY, radius, startAngle, endAngle);
        ctx.strokeStyle = "#ffffff";
        ctx.stroke();
      };

      drawBreaks = function (canvasId, engineName, radius, lineWidth) {
        if (
          canvasId == "speedGauge_" + engineName ||
          canvasId == "oilPressureGauge_" + engineName
        ) {
          radius = radius + 30;
        } else if (canvasId == "trimGauge_" + engineName) {
          radius = radius - 10;
        } else {
          radius = radius + 20;
        }
        var breakDistance = 5;
        var breakLineLength = 2;
        if (canvasId == "trimGauge_" + engineName) {
          breakDistance = 45;
          breakLineLength = 1;
        }
        var angleDifference = 30;
        var loopValue = 36;
        var c = document.getElementById(canvasId);
        var ctx = c.getContext("2d");
        ctx.beginPath();
        var centerX = c.width / 2;
        var centerY = c.height / 2;
        ctx.translate(centerX, centerY);
        for (var i = -loopValue; i <= loopValue; i++) {
          //Defines the Arc Start and Point
          angle = (Math.PI / angleDifference) * i;

          if (canvasId == "trimGauge_" + engineName) {
            sineAngle = -Math.sin(angle);
            cosAngle = Math.cos(angle);
          } else {
            sineAngle = Math.sin(angle);
            cosAngle = -Math.cos(angle);
          }

          if (i % breakDistance == 0) {
            //Draws Bigger Lines
            ctx.lineWidth = lineWidth;
            iPointX = sineAngle * (radius - radius / breakLineLength);
            iPointY = cosAngle * (radius - radius / breakLineLength);
            oPointX = sineAngle * (radius - radius / 14);
            oPointY = cosAngle * (radius - radius / 14);
          } else {
            //Draws Smaller Lines
            ctx.lineWidth = 0.01; //Hides Smaller Lines
            iPointX = sineAngle * (radius - radius / 5.5);
            iPointY = cosAngle * (radius - radius / 5.5);
            oPointX = sineAngle * (radius - radius / 7);
            oPointY = cosAngle * (radius - radius / 7);
          }
          ctx.beginPath();
          ctx.moveTo(iPointX, iPointY);
          ctx.lineTo(oPointX, oPointY);
          ctx.strokeStyle = "#033154";
          ctx.stroke();
          ctx.closePath();
        }
      };

      drawLabels = function (canvasId, engineName, radius) {
        var c = document.getElementById(canvasId);
        var ctx = c.getContext("2d");
        ctx.beginPath();
        if (canvasId != "trimGauge_" + engineName) {
          radius = radius + 35;
        } else {
          radius = radius + 20;
        }
        var increment = 0;
        var loopCounter = 0;
        var breakDistance; //To Increase or decrease number of labels shown...that is 0,10,20..100 etc
        var loopStartValue = 20;
        var loopEndValue = 20;
        if (
          canvasId == "speedGauge_" + engineName ||
          canvasId == "oilPressureGauge_" + engineName
        ) {
          breakDistance = 10;
        } else {
          breakDistance = 5;
        }
        if (canvasId == "boostGauge_" + engineName) {
          loopStartValue = 36;
          loopEndValue = 5;
        }
        if (canvasId == "trimGauge_" + engineName) {
          loopStartValue = 12;
          loopEndValue = 12;
        }
        for (var i = -loopStartValue; i <= loopEndValue; i++) {
          //Defines the Arc Start and Point
          angle = (Math.PI / 30) * i;
          if (canvasId == "trimGauge_" + engineName) {
            sineAngle = -Math.sin(angle);
            cosAngle = Math.cos(angle);
          } else {
            sineAngle = Math.sin(angle);
            cosAngle = -Math.cos(angle);
          }
          if (i % breakDistance == 0) {
            wPointX = sineAngle * (radius - radius / 14);
            wPointY = cosAngle * (radius - radius / 14);
            ctx.fillStyle = "#ffffff";
            if (canvasId == "boostGauge_" + engineName) {
              loopCounter++;
              if (loopCounter % 2 != 0) {
                ctx.fillText(increment, wPointX - 2, wPointY + 4); //prints labels only for Whole Numbers in case of boostGauge
              }
              increment += 12.5;
            } else if (canvasId == "trimGauge_" + engineName) {
              loopCounter++;
              if (loopCounter % 2 != 0) {
                ctx.fillText(increment, wPointX - 2, wPointY - 10); //prints labels only for trimGauge
              }
              increment += 25;
            } else {
              ctx.fillText(increment, wPointX - 2, wPointY + 4); //prints labels for all Gauges except boost gauge
            }
          }
          if (canvasId == "speedGauge_" + engineName) {
            increment += 3;
          } else if (canvasId == "oilPressureGauge_" + engineName) {
            increment += 1.5;
          } else if (canvasId == "rpmGauge_" + engineName) {
            increment += 2;
          }
        }
        ctx.closePath();
      };

      drawGauge = function (
        canvasId,
        engineName,
        height,
        width,
        radius,
        startAngleInDegrees,
        currentValue,
        maxValue,
        unit
      ) {
        var multiplyingFactor = 240 / maxValue; //Finds the multiplying factor to measure end angle for Arc
        if (canvasId == "trimGauge_" + engineName) {
          multiplyingFactor = 120 / maxValue;
        }
        var endAngleInDegrees =
          startAngleInDegrees + currentValue * multiplyingFactor;
        drawArc(
          canvasId,
          engineName,
          height,
          width,
          radius,
          startAngleInDegrees,
          endAngleInDegrees,
          7,
          currentValue,
          unit
        );
        drawBreaks(canvasId, engineName, radius, 2);
        drawLabels(canvasId, engineName, radius);
      };

      clearCanvas = function (canvasId, height, width) {
        var c = document.getElementById(canvasId);
        var ctx = c.getContext("2d");
        ctx.clearRect(0, 0, width, height);
      };

      drawHorizontalRoundRect = function (
        ctx,
        x,
        y,
        width,
        height,
        fill,
        lineWidth,
        text,
        textWidth,
        radius
      ) {
        ctx.beginPath();
        ctx.lineWidth = lineWidth;
        ctx.moveTo(x + radius, y);
        if (textWidth != undefined) {
          //Draws Gap for Text in Gauge Border
          ctx.lineTo(x + width / 2 - (radius + 4), y);
          ctx.moveTo(x + width / 2 - (radius + 4) + (textWidth + 3), y);
        }
        ctx.lineTo(x + width - radius, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        ctx.lineTo(x + width, y + height - radius);
        ctx.quadraticCurveTo(
          x + width,
          y + height,
          x + width - radius,
          y + height
        );
        ctx.lineTo(x + radius, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
        if (radius == 10) {
          //radius is used to curve the corners of the rectangles
          //Draws Text in Gauge Border
          ctx.fillStyle = "rgb(255,250,250)"; //White Color for Text
          ctx.fillText(text, x + width / 2 - (radius + 2), y - 1);
          ctx.fillStyle = "#033154"; //Blue Color for Filling inside border
        }
        ctx.strokeStyle = "rgb(255,250,250)"; //White Color for Border
        ctx.stroke();
        if (fill) {
          ctx.fill();
        }
      };

      drawHorizontalProgressGauge = function (
        canvasId,
        currentValue,
        maxValue,
        unit
      ) {
        var c = document.getElementById(canvasId);
        c.height = 70;
        c.width = 140;
        var ctx = c.getContext("2d");
        if (Math.abs(currentValue) > maxValue) {
          maxValue = Math.abs(currentValue);
        }
        var percentage = (Math.abs(currentValue) / maxValue) * 100;
        var maxLoopValue = Math.ceil(percentage / 10);
        ctx.strokeStyle = "rgb(255,250,250)";
        ctx.fillStyle = "#033154";
        var valueString = Math.round(currentValue) + unit;
        var textWidth = ctx.measureText(valueString).width;
        drawHorizontalRoundRect(
          ctx,
          5,
          10,
          128,
          40,
          true,
          4,
          valueString,
          textWidth,
          10
        ); //Draws Border for gauge
        var increment = 0;
        for (var i = 1; i <= maxLoopValue; i++) {
          if (i < 3) {
            ctx.fillStyle = "rgba(255,0,0,0.9)";
            drawHorizontalRoundRect(
              ctx,
              10 + increment,
              14,
              10,
              32,
              true,
              0.3,
              null,
              null,
              0
            ); //Draws Red Bars for gauge
          } else {
            ctx.fillStyle = "rgb(255,250,250)";
            drawHorizontalRoundRect(
              ctx,
              10 + increment,
              14,
              10,
              32,
              true,
              0.3,
              null,
              null,
              0
            ); //Draws White Bars for gauge
          }
          increment += 12;
        }
      };

      drawReverseHorizontalProgressGauge = function (
        canvasId,
        currentValue,
        maxValue,
        unit
      ) {
        var c = document.getElementById(canvasId);
        c.height = 70;
        c.width = 140;
        var ctx = c.getContext("2d");
        if (Math.abs(currentValue) > maxValue) {
          maxValue = Math.abs(currentValue);
        }
        var percentage = (Math.abs(currentValue) / maxValue) * 100;
        var maxLoopValue = Math.ceil(percentage / 10);
        ctx.strokeStyle = "rgb(255,250,250)";
        ctx.fillStyle = "#033154";
        var valueString = Math.round(currentValue) + unit;
        var textWidth = ctx.measureText(valueString).width;
        drawHorizontalRoundRect(
          ctx,
          5,
          10,
          128,
          40,
          true,
          4,
          valueString,
          textWidth,
          10
        ); //Draws Border for gauge
        var increment = 0;
        for (var i = 1; i <= maxLoopValue; i++) {
          if (i < 6) {
            ctx.fillStyle = "rgb(255,250,250)";
            drawHorizontalRoundRect(
              ctx,
              10 + increment,
              14,
              10,
              32,
              true,
              0.3,
              null,
              null,
              0
            ); //Draws Red Bars for gauge
          } else {
            ctx.fillStyle = "rgba(255,0,0,0.9)";
            drawHorizontalRoundRect(
              ctx,
              10 + increment,
              14,
              10,
              32,
              true,
              0.3,
              null,
              null,
              0
            ); //Draws White Bars for gauge
          }
          increment += 12;
        }
      };

      drawVerticalRoundRect = function (
        ctx,
        y,
        x,
        height,
        width,
        fill,
        lineWidth,
        radius
      ) {
        ctx.beginPath();
        ctx.lineWidth = lineWidth;
        ctx.moveTo(x + radius, y);
        ctx.lineTo(x + width - radius, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        ctx.lineTo(x + width, y + height - radius);
        ctx.quadraticCurveTo(
          x + width,
          y + height,
          x + width - radius,
          y + height
        );
        ctx.lineTo(x + radius, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.strokeStyle = "rgb(255,250,250)";
        ctx.stroke();
        if (fill) {
          ctx.fill();
        }
      };

      drawVerticalProgressGauge = function (canvasId, currentValue, maxValue) {
        var c = document.getElementById(canvasId);
        c.height = 140;
        c.width = 60;
        var ctx = c.getContext("2d");
        if (Math.abs(currentValue) > maxValue) {
          maxValue = Math.abs(currentValue);
          if (maxValue < 100) {
            maxValue = 100;
          }
        }
        var percentage = (currentValue / maxValue) * 100;
        var maxLoopValue = Math.ceil(currentValue / 10);
        ctx.strokeStyle = "rgb(255,250,250)";
        ctx.fillStyle = "#033154";
        drawVerticalRoundRect(ctx, 5, 10, 128, 40, true, 4, 10);
        var increment = 107;
        for (var i = 1; i <= maxLoopValue; i++) {
          if (i < 3) {
            ctx.fillStyle = "rgba(255,0,0,0.9)";
            drawVerticalRoundRect(
              ctx,
              10 + increment,
              14,
              10,
              32,
              true,
              0.3,
              5
            ); //Draws Red Bars for gauge
          } else {
            ctx.fillStyle = "rgb(255,250,250)";
            drawVerticalRoundRect(
              ctx,
              10 + increment,
              14,
              10,
              32,
              true,
              0.3,
              5
            ); //Draws White Bars for gauge
          }
          increment -= 12;
        }
        ctx.fillStyle = "rgba(255,0,0,0.9)";
        ctx.fillText(increment + 10, 150, 150);
      };

      drawReverseVerticalProgressGauge = function (
        canvasId,
        currentValue,
        maxValue
      ) {
        var c = document.getElementById(canvasId);
        c.height = 140;
        c.width = 60;
        var ctx = c.getContext("2d");
        if (Math.abs(currentValue) > maxValue) {
          maxValue = Math.abs(currentValue);
          if (maxValue < 100) {
            maxValue = 100;
          }
        }
        var percentage = (currentValue / maxValue) * 100;
        var maxLoopValue = Math.ceil(currentValue / 10);
        ctx.strokeStyle = "rgb(255,250,250)";
        ctx.fillStyle = "#033154";
        drawVerticalRoundRect(ctx, 5, 10, 128, 40, true, 4, 10);
        var increment = 107;
        for (var i = 1; i <= maxLoopValue; i++) {
          if (i < 8) {
            ctx.fillStyle = "rgb(255,250,250)";
            drawVerticalRoundRect(
              ctx,
              10 + increment,
              14,
              10,
              32,
              true,
              0.3,
              5
            ); //Draws White Bars for gauge
          } else {
            ctx.fillStyle = "rgba(255,0,0,0.9)";
            drawVerticalRoundRect(
              ctx,
              10 + increment,
              14,
              10,
              32,
              true,
              0.3,
              5
            ); //Draws Red Bars for gauge
          }
          increment -= 12;
        }
        ctx.fillStyle = "rgba(255,0,0,0.9)";
        ctx.fillText(increment + 10, 150, 150);
      };

      vm.onInit = function () {
        var tempUnit =
          tempSetting.userSettingViewModel.allowed_Setting_Value.unit;
        var speedUnit =
          speedSetting.userSettingViewModel.allowed_Setting_Value.unit;
        var engineTempMaxValue = 150;
        if (
          tempSetting.userSettingViewModel.allowed_Setting_Value
            .allowedUnitId == allowedUnitsEnum.Kelvins
        ) {
          engineTempMaxValue = 423.15;
        } else if (
          tempSetting.userSettingViewModel.allowed_Setting_Value
            .allowedUnitId == allowedUnitsEnum.Farenheit
        ) {
          engineTempMaxValue = 302;
        }
        angular.forEach(vm.engineSlides, function (slide) {
          if (slide.fuelLevelValue > 100) {
            slide.fuelLevelValue = 100;
          }
          if (slide.tilTrimValue < 0) {
            slide.tilTrimValue = 0;
          }
          if (slide.tilTrimValue > 100) {
            slide.tilTrimValue = 100;
          }

          setTimeout(function () {
            drawArc(
              "speedGauge_" + slide.engineName,
              slide.engineName,
              300,
              300,
              125,
              150,
              30,
              2,
              null,
              null
            ); //Draws Outer Circle only for Gauge
            drawArc(
              "boostGauge_" + slide.engineName,
              slide.engineName,
              300,
              220,
              80,
              60,
              300,
              2,
              null,
              null
            ); //Draws Outer Circle only for Gauge
            drawArc(
              "rpmGauge_" + slide.engineName,
              slide.engineName,
              250,
              220,
              80,
              150,
              30,
              2,
              null,
              null
            ); //Draws Outer Circle only for Gauge
            drawArc(
              "oilPressureGauge_" + slide.engineName,
              slide.engineName,
              280,
              280,
              110,
              150,
              30,
              2,
              null,
              null
            ); //Draws Outer Circle only for Gauge
            drawArc(
              "trimGauge_" + slide.engineName,
              slide.engineName,
              120,
              180,
              60,
              30,
              150,
              2,
              null,
              null
            ); //Draws Outer Circle only for Gauge

            drawGauge(
              "speedGauge_" + slide.engineName,
              slide.engineName,
              null,
              null,
              117,
              150,
              slide.speedValue,
              120,
              speedUnit
            ); //Draws Inner Circle and Gaps and Labels for Gauge
            drawGauge(
              "boostGauge_" + slide.engineName,
              slide.engineName,
              null,
              null,
              72,
              60,
              slide.boostValue,
              100,
              "PSI"
            ); //Draws Inner Circle and Gaps and Labels for Gauge
            drawGauge(
              "rpmGauge_" + slide.engineName,
              slide.engineName,
              null,
              null,
              72,
              150,
              slide.rpmValue,
              80,
              "x 100"
            ); //Draws Inner Circle and Gaps and Labels for Gauge
            drawGauge(
              "oilPressureGauge_" + slide.engineName,
              slide.engineName,
              null,
              null,
              102,
              150,
              slide.oilPressureValue,
              60,
              "PSI"
            ); //Draws Inner Circle and Gaps and Labels for Gauge
            drawGauge(
              "trimGauge_" + slide.engineName,
              slide.engineName,
              null,
              null,
              52,
              30,
              slide.tilTrimValue,
              100,
              "°"
            ); //Draws Inner Circle and Gaps and Labels for Gauge

            drawReverseHorizontalProgressGauge(
              "engineTemperatureGauge_" + slide.engineName,
              slide.engineTempValue,
              engineTempMaxValue,
              tempUnit
            );
          }, 0);
        });
      };

      initGuagesIfNull = function (engineInstance) {
        var slide = vm.engineSlides.find(function (slide) {
          return slide.id == engineInstance;
        });
        var tempUnit =
          tempSetting.userSettingViewModel.allowed_Setting_Value.unit;
        var speedUnit =
          speedSetting.userSettingViewModel.allowed_Setting_Value.unit;
        var engineTempMaxValue = 150;
        if (
          tempSetting.userSettingViewModel.allowed_Setting_Value
            .allowedUnitId == allowedUnitsEnum.Kelvins
        ) {
          engineTempMaxValue = 423.15;
        } else if (
          tempSetting.userSettingViewModel.allowed_Setting_Value
            .allowedUnitId == allowedUnitsEnum.Farenheit
        ) {
          engineTempMaxValue = 302;
        }
        setTimeout(function () {
          clearCanvas("boostGauge_" + slide.engineName, 300, 220);
          drawArc(
            "boostGauge_" + slide.engineName,
            slide.engineName,
            300,
            220,
            80,
            60,
            300,
            2,
            null,
            null
          ); //Draws Outer Circle only for Gauge
          drawGauge(
            "boostGauge_" + slide.engineName,
            slide.engineName,
            null,
            null,
            72,
            60,
            0,
            100,
            "PSI"
          ); //Draws Inner Circle and Gaps and Labels for Gauge
          clearCanvas("rpmGauge_" + slide.engineName, 250, 220);
          drawArc(
            "rpmGauge_" + slide.engineName,
            slide.engineName,
            250,
            220,
            80,
            150,
            30,
            2,
            null,
            null
          ); //Draws Outer Circle only for Gauge
          drawGauge(
            "rpmGauge_" + slide.engineName,
            slide.engineName,
            null,
            null,
            72,
            150,
            0,
            80,
            "x 100"
          ); //Draws Inner Circle and Gaps and Labels for Gauge
          clearCanvas("trimGauge_" + slide.engineName, 120, 180);
          drawArc(
            "trimGauge_" + slide.engineName,
            slide.engineName,
            120,
            180,
            60,
            30,
            150,
            2,
            null,
            null
          ); //Draws Outer Circle only for Gauge
          drawGauge(
            "trimGauge_" + slide.engineName,
            slide.engineName,
            null,
            null,
            52,
            30,
            0,
            100,
            "°"
          ); //Draws Inner Circle and Gaps and Labels for Gauge
          clearCanvas("oilPressureGauge_" + slide.engineName, 280, 280);
          drawArc(
            "oilPressureGauge_" + slide.engineName,
            slide.engineName,
            280,
            280,
            110,
            150,
            30,
            2,
            null,
            null
          ); //Draws Outer Circle only for Gauge
          drawGauge(
            "oilPressureGauge_" + slide.engineName,
            slide.engineName,
            null,
            null,
            102,
            150,
            0,
            60,
            "PSI"
          ); //Draws Inner Circle and Gaps and Labels for Gauge
          clearCanvas("engineTemperatureGauge_" + slide.engineName, 70, 140);
          drawReverseHorizontalProgressGauge(
            "engineTemperatureGauge_" + slide.engineName,
            0,
            engineTempMaxValue,
            tempUnit
          ); //Draws Horizontal Progress Bar Gauge
          clearCanvas("speedGauge_" + slide.engineName, 300, 300);
          drawArc(
            "speedGauge_" + slide.engineName,
            slide.engineName,
            300,
            300,
            125,
            150,
            30,
            2,
            null,
            null
          ); //Draws Outer Circle only for Gauge
          drawGauge(
            "speedGauge_" + slide.engineName,
            slide.engineName,
            null,
            null,
            117,
            150,
            0,
            120,
            speedUnit
          ); //Draws Inner Circle and Gaps and Labels for Gauge
        }, 0);
      };

      vm.UpdateDashboardAlerts = function (engineInstance, nmeaData) {
        var nmeaDataAlertsField = nmeaData.find(function (data) {
          return (
            data.nmeaDataFieldEnumId ===
            nmeaDataFieldEnum.Pgn127489DiscreteStatus1
          );
        });

        if (nmeaDataAlertsField != null) {
          vm.alerts = [];
          var alerts = angular.fromJson(nmeaDataAlertsField.nmeaDataFieldValue);
          alerts.forEach(function (alertValue) {
            if (+alertValue == nmeaEngineAlertsEnum.CheckEngine) {
              var obj = {
                image: "Check_engine.png",
                text: "CheckEngine.Text",
              };
              vm.alerts.push(obj);
            } else if (+alertValue == nmeaEngineAlertsEnum.OverTemperature) {
              var obj = {
                image: "Over_temperature.png",
                text: "OverTemperature.Text",
              };
              vm.alerts.push(obj);
            } else if (+alertValue == nmeaEngineAlertsEnum.LowOilPressure) {
              var obj = {
                image: "Low_oil_pressure.png",
                text: "LowOilPressure.Text",
              };
              vm.alerts.push(obj);
            } else if (+alertValue == nmeaEngineAlertsEnum.LowOilLevel) {
              var obj = {
                image: "Low_oil_level.png",
                text: "LowOilLevel.Text",
              };
              vm.alerts.push(obj);
            } else if (+alertValue == nmeaEngineAlertsEnum.LowFuelPressure) {
              var obj = {
                image: "Low_fuel_pressure.png",
                text: "LowFuelPressure.Text",
              };
              vm.alerts.push(obj);
            } else if (+alertValue == nmeaEngineAlertsEnum.LowSystemVoltage) {
              var obj = {
                image: "Power_reduction.png",
                text: "LowSystemVoltage.Text",
              };
              vm.alerts.push(obj);
            } else if (+alertValue == nmeaEngineAlertsEnum.LowCoolantLevel) {
              var obj = {
                image: "Low_coolant_level.png",
                text: "LowCoolantLevel.Text",
              };
              vm.alerts.push(obj);
            } else if (+alertValue == nmeaEngineAlertsEnum.WaterFlow) {
              var obj = {
                image: "Water_flow.png",
                text: "WaterFlow.Text",
              };
              vm.alerts.push(obj);
            } else if (+alertValue == nmeaEngineAlertsEnum.WaterInFuel) {
              var obj = {
                image: "Water_in_fuel.png",
                text: "WaterInFuel.Text",
              };
              vm.alerts.push(obj);
            } else if (+alertValue == nmeaEngineAlertsEnum.ChargeIndicator) {
              var obj = {
                image: "Charge_indicator.png",
                text: "ChargeIndicator.Text",
              };
              vm.alerts.push(obj);
            } else if (+alertValue == nmeaEngineAlertsEnum.PreheatIndicator) {
              var obj = {
                image: "Preheat_indicator.png",
                text: "PreheatIndicator.Text",
              };
              vm.alerts.push(obj);
            } else if (+alertValue == nmeaEngineAlertsEnum.HighBoostPressure) {
              var obj = {
                image: "rev_limit.png",
                text: "HighBoostPressure.Text",
              };
              vm.alerts.push(obj);
            } else if (+alertValue == nmeaEngineAlertsEnum.RevLimitExceeded) {
              var obj = {
                image: "rev_limit.png",
                text: "RevLimitExceeded.Text",
              };
              vm.alerts.push(obj);
            } else if (+alertValue == nmeaEngineAlertsEnum.EGRSystem) {
              var obj = {
                image: "EGR_system_alert.png",
                text: "EGRSystem.Text",
              };
              vm.alerts.push(obj);
            } else if (
              +alertValue == nmeaEngineAlertsEnum.ThrottlePositionSensor
            ) {
              var obj = {
                image: "Throttle_position_sensor.png",
                text: "ThrottlePositionSensor.Text",
              };
              vm.alerts.push(obj);
            } else if (
              +alertValue == nmeaEngineAlertsEnum.EngineEmergencyStop
            ) {
              var obj = {
                image: "Engine_emergency_stop_mode.png",
                text: "EngineEmergencyStop.Text",
              };
              vm.alerts.push(obj);
            }
          });
        }
      };

      vm.UpdateEngineBoost = function (engineInstance, nmeaData) {
        var nmeaDataBoostField = nmeaData.find(function (data) {
          return (
            data.nmeaDataFieldEnumId ===
            nmeaDataFieldEnum.Pgn127488BoostPressure
          );
        });
        var engine = vm.engineSlides.find(function (eng) {
          return eng.id === engineInstance;
        });

        if (nmeaDataBoostField != null) {
          if (engine == null) {
            vm.engineSlides.push({
              index: vm.engineSlides.length,
              id: engineInstance,
              engineName: "Engine " + engineInstance,
            });
            initGuagesIfNull(engineInstance);
          }
          engineBoost = +nmeaDataBoostField.nmeaDataFieldValue;
          engineBoost = +engineBoost.toFixed(1);
          var slide = vm.engineSlides.find(function (slide) {
            return slide.id == engineInstance;
          });
          setTimeout(function () {
            clearCanvas("boostGauge_" + slide.engineName, 300, 220);
            drawArc(
              "boostGauge_" + slide.engineName,
              slide.engineName,
              300,
              220,
              80,
              60,
              300,
              2,
              null,
              null
            ); //Draws Outer Circle only for Gauge
            drawGauge(
              "boostGauge_" + slide.engineName,
              slide.engineName,
              null,
              null,
              72,
              60,
              engineBoost,
              100,
              "PSI"
            ); //Draws Inner Circle and Gaps and Labels for Gauge
          }, 0);
        }
      };

      vm.UpdateEngineRpm = function (engineInstance, nmeaData) {
        var nmeaDataRpmField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127488Speed;
        });
        var engine = vm.engineSlides.find(function (eng) {
          return eng.id === engineInstance;
        });

        if (nmeaDataRpmField != null) {
          if (engine == null) {
            vm.engineSlides.push({
              index: vm.engineSlides.length,
              id: engineInstance,
              engineName: "Engine " + engineInstance,
            });
            initGuagesIfNull(engineInstance);
          }

          engineRpm = +nmeaDataRpmField.nmeaDataFieldValue;
          engineRpm = (engineRpm / 100).toFixed(1);
          var slide = vm.engineSlides.find(function (slide) {
            return slide.id == engineInstance;
          });
          setTimeout(function () {
            clearCanvas("rpmGauge_" + slide.engineName, 250, 220);
            drawArc(
              "rpmGauge_" + slide.engineName,
              slide.engineName,
              250,
              220,
              80,
              150,
              30,
              2,
              null,
              null
            ); //Draws Outer Circle only for Gauge
            drawGauge(
              "rpmGauge_" + slide.engineName,
              slide.engineName,
              null,
              null,
              72,
              150,
              engineRpm,
              80,
              "x 100"
            ); //Draws Inner Circle and Gaps and Labels for Gauge
          }, 0);
        }
      };

      vm.UpdateEngineTiltTrim = function (engineInstance, nmeaData) {
        var nmeaDataTiltTrimField = nmeaData.find(function (data) {
          return (
            data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127488TiltTrim
          );
        });
        var engine = vm.engineSlides.find(function (eng) {
          return eng.id === engineInstance;
        });

        if (nmeaDataTiltTrimField != null) {
          if (engine == null) {
            vm.engineSlides.push({
              index: vm.engineSlides.length,
              id: engineInstance,
              engineName: "Engine " + engineInstance,
            });
            initGuagesIfNull(engineInstance);
          }

          engineTiltTrim = +nmeaDataTiltTrimField.nmeaDataFieldValue;
          engineTiltTrim = +engineTiltTrim.toFixed(1);
          if (engineTiltTrim < 0) {
            engineTiltTrim = 0;
          }
          if (engineTiltTrim > 100) {
            engineTiltTrim = 100;
          }
          var slide = vm.engineSlides.find(function (slide) {
            return slide.id == engineInstance;
          });
          setTimeout(function () {
            clearCanvas("trimGauge_" + slide.engineName, 120, 180);
            drawArc(
              "trimGauge_" + slide.engineName,
              slide.engineName,
              120,
              180,
              60,
              30,
              150,
              2,
              null,
              null
            ); //Draws Outer Circle only for Gauge
            drawGauge(
              "trimGauge_" + slide.engineName,
              slide.engineName,
              null,
              null,
              52,
              30,
              engineTiltTrim,
              100,
              "°"
            ); //Draws Inner Circle and Gaps and Labels for Gauge
          }, 0);
        }
      };

      vm.UpdateEngineOilPressure = function (engineInstance, nmeaData) {
        var nmeaDataOilPressureField = nmeaData.find(function (data) {
          return (
            data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127489OilPressure
          );
        });
        var engine = vm.engineSlides.find(function (eng) {
          return eng.id === engineInstance;
        });

        if (nmeaDataOilPressureField != null) {
          if (engine == null) {
            vm.engineSlides.push({
              index: vm.engineSlides.length,
              id: engineInstance,
              engineName: "Engine " + engineInstance,
            });
            initGuagesIfNull(engineInstance);
          }
          engineOilPressure = +nmeaDataOilPressureField.nmeaDataFieldValue;
          engineOilPressure = +engineOilPressure.toFixed(1);
          var slide = vm.engineSlides.find(function (slide) {
            return slide.id == engineInstance;
          });
          setTimeout(function () {
            clearCanvas("oilPressureGauge_" + slide.engineName, 280, 280);
            drawArc(
              "oilPressureGauge_" + slide.engineName,
              slide.engineName,
              280,
              280,
              110,
              150,
              30,
              2,
              null,
              null
            ); //Draws Outer Circle only for Gauge
            drawGauge(
              "oilPressureGauge_" + slide.engineName,
              slide.engineName,
              null,
              null,
              102,
              150,
              engineOilPressure,
              60,
              "PSI"
            ); //Draws Inner Circle and Gaps and Labels for Gauge
          }, 0);
        }
      };

      vm.UpdateEngineTotalHours = function (engineInstance, nmeaData) {
        var nmeaDataTripTimeField = nmeaData.find(function (data) {
          return (
            data.nmeaDataFieldEnumId ===
            nmeaDataFieldEnum.Pgn127489TotalEngineHours
          );
        });
        var engine = vm.engineSlides.find(function (eng) {
          return eng.id === engineInstance;
        });
        if (nmeaDataTripTimeField != undefined) {
          var hours = +nmeaDataTripTimeField.nmeaDataFieldValue;
          hours = +hours.toFixed(1);
          if (engine == null) {
            if (vm.totalofTotalEngineHours == undefined) {
              vm.totalofTotalEngineHours = 0;
              vm.totalEnginesWithHoursCount = 0;
            }
            vm.totalofTotalEngineHours += hours;
            vm.totalEnginesWithHoursCount += 1;
          } else {
            if (vm.totalofTotalEngineHours == undefined) {
              vm.totalofTotalEngineHours = hours;
              vm.totalEnginesWithHoursCount = 1;
            } else {
              if (engine.totalHours == undefined) {
                vm.totalofTotalEngineHours += hours;
                vm.totalEnginesWithHoursCount += 1;
              } else {
                vm.totalofTotalEngineHours = vm.totalofTotalEngineHours - engine.totalHours;
                vm.totalofTotalEngineHours += hours;
              }
            }
          }
          if (vm.totalofTotalEngineHours != undefined) {
            vm.totalofTotalEngineHours = vm.totalofTotalEngineHours / vm.totalEnginesWithHoursCount;
            vm.totalofTotalEngineHours = vm.totalofTotalEngineHours
          }
        }
      };

      vm.UpdateEngineTemperature = function (engineInstance, nmeaData) {
        var nmeaDataEngineTemperatureField = nmeaData.find(function (data) {
          return (
            data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127489Temperature
          );
        });
        var engine = vm.engineSlides.find(function (eng) {
          return eng.id === engineInstance;
        });
        var tempUnit =
          tempSetting.userSettingViewModel.allowed_Setting_Value.unit;
        var engineTempMaxValue = 150;
        if (
          tempSetting.userSettingViewModel.allowed_Setting_Value
            .allowedUnitId == allowedUnitsEnum.Kelvins
        ) {
          engineTempMaxValue = 423.15;
        } else if (
          tempSetting.userSettingViewModel.allowed_Setting_Value
            .allowedUnitId == allowedUnitsEnum.Farenheit
        ) {
          engineTempMaxValue = 302;
        }

        if (nmeaDataEngineTemperatureField != null) {
          if (engine == null) {
            vm.engineSlides.push({
              index: vm.engineSlides.length,
              id: engineInstance,
              engineName: "Engine " + engineInstance,
            });
            initGuagesIfNull(engineInstance);
          }
          engineTemperature = +nmeaDataEngineTemperatureField.nmeaDataFieldValue;
          engineTemperature = +engineTemperature.toFixed(1);
          var slide = vm.engineSlides.find(function (slide) {
            return slide.id == engineInstance;
          });
          setTimeout(function () {
            // clearCanvas("oilTemperatureGauge_" + slide.engineName, 70, 140);
            // drawHorizontalProgressGauge("oilTemperatureGauge_" + slide.engineName, engineOilTemperatureInC, 100, tempUnit); //Draws Horizontal Progress Bar Gauge
            clearCanvas("engineTemperatureGauge_" + slide.engineName, 70, 140);
            drawReverseHorizontalProgressGauge(
              "engineTemperatureGauge_" + slide.engineName,
              engineTemperature,
              engineTempMaxValue,
              tempUnit
            ); //Draws Horizontal Progress Bar Gauge
          }, 0);
        }
      };

      vm.UpdateTimeToEmpty = function (engineInstance, nmeaData) {
        vm.currentTripCount = 0;
        var nmeaDataTimeToEmptyField = nmeaData.find(function (data) {
          return (
            data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127496TimeToEmpty
          );
        });

        if (nmeaDataTimeToEmptyField != null) {
          vm.nmeaTimeToEmptyInHr = +nmeaDataTimeToEmptyField.nmeaDataFieldValue;
          vm.nmeaTimeToEmptyInHr = +vm.nmeaTimeToEmptyInHr.toFixed(1);
        }
      };

      vm.UpdateDistanceToEmpty = function (engineInstance, nmeaData) {
        var nmeaDataDistanceToEmptyField = nmeaData.find(function (data) {
          return (
            data.nmeaDataFieldEnumId ===
            nmeaDataFieldEnum.Pgn127496DistanceToEmpty
          );
        });

        if (nmeaDataDistanceToEmptyField != null) {
          vm.nmeaDistanceToEmptyInNm = +nmeaDataDistanceToEmptyField.nmeaDataFieldValue;
          vm.nmeaDistanceToEmptyInNm = +vm.nmeaDistanceToEmptyInNm.toFixed(1);
        }
      };

      vm.UpdateTotalComulativeDistance = function (engineInstance, nmeaData) {
        var nmeaDataDistanceToEmptyField = nmeaData.find(function (data) {
          return (
            data.nmeaDataFieldEnumId ===
            nmeaDataFieldEnum.Pgn128275TotalCumulativeDistance
          );
        });

        if (nmeaDataDistanceToEmptyField != null) {
          vm.totalComulativeDistance = +nmeaDataDistanceToEmptyField.nmeaDataFieldValue;
          vm.totalComulativeDistance = +vm.totalComulativeDistance.toFixed(1);
        }
      };

      vm.UpdateTripTime = function (engineInstance, nmeaData) {
        var nmeaDataTripTimeField = nmeaData.find(function (data) {
          return (
            data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127496TripRunTime
          );
        });

        if (nmeaDataTripTimeField != null) {
          vm.nmeaTripTimeInHr = +nmeaDataTripTimeField.nmeaDataFieldValue;
          vm.nmeaTripTimeInHr = +vm.nmeaTripTimeInHr.toFixed(1);
        }
      };

      vm.UpdateSpeed = function (engineInstance, nmeaData) {
        var nmeaDataSpeedField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn129026Sog;
        });
        var speedUnit =
          speedSetting.userSettingViewModel.allowed_Setting_Value.unit;

        if (nmeaDataSpeedField != null) {
          vm.nmeaSpeedInKnots = +nmeaDataSpeedField.nmeaDataFieldValue;
          vm.nmeaSpeedInKnots = +vm.nmeaSpeedInKnots.toFixed(1);

          if (vm.engineSlides.length == 0) {
            vm.engineSlides.push({
              index: vm.engineSlides.length,
              id: engineInstance,
              engineName: "Engine " + engineInstance,
            });
            initGuagesIfNull(engineInstance);

            var slide = vm.engineSlides.find(function (slide) {
              return slide.id == engineInstance;
            });
            setTimeout(function () {
              clearCanvas("speedGauge_" + slide.engineName, 300, 300);
              drawArc(
                "speedGauge_" + slide.engineName,
                slide.engineName,
                300,
                300,
                125,
                150,
                30,
                2,
                null,
                null
              ); //Draws Outer Circle only for Gauge
              drawGauge(
                "speedGauge_" + slide.engineName,
                slide.engineName,
                null,
                null,
                117,
                150,
                vm.nmeaSpeedInKnots,
                120,
                speedUnit
              ); //Draws Inner Circle and Gaps and Labels for Gauge
            }, 0);
          } else {
            angular.forEach(vm.engineSlides, function (slide) {
              setTimeout(function () {
                clearCanvas("speedGauge_" + slide.engineName, 300, 300);
                drawArc(
                  "speedGauge_" + slide.engineName,
                  slide.engineName,
                  300,
                  300,
                  125,
                  150,
                  30,
                  2,
                  null,
                  null
                ); //Draws Outer Circle only for Gauge
                drawGauge(
                  "speedGauge_" + slide.engineName,
                  slide.engineName,
                  null,
                  null,
                  117,
                  150,
                  vm.nmeaSpeedInKnots,
                  120,
                  speedUnit
                ); //Draws Inner Circle and Gaps and Labels for Gauge
              }, 0);
            });
          }
        }
      };

      vm.UpdateSog = function (engineInstance, nmeaData) {
        var nmeaDataSogField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn129026Sog;
        });

        if (nmeaDataSogField != null) {
          vm.nmeaSogInKnots = +nmeaDataSogField.nmeaDataFieldValue;
          vm.nmeaSogInKnots = +vm.nmeaSogInKnots.toFixed(1);
        }
      };

      vm.UpdateCog = function (engineInstance, nmeaData) {
        var nmeaDataCogField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn129026Cog;
        });

        if (nmeaDataCogField != null) {
          vm.nmeaCogInDeg = +nmeaDataCogField.nmeaDataFieldValue;
          vm.nmeaCogInDeg = +vm.nmeaCogInDeg.toFixed(1);
        }
      };

      vm.UpdateSow = function (engineInstance, nmeaData) {
        var nmeaDataCogField = nmeaData.find(function (data) {
          return (
            data.nmeaDataFieldEnumId ===
            nmeaDataFieldEnum.Pgn128259SpeedWaterReferenced
          );
        });

        if (nmeaDataCogField != null) {
          vm.nmeaSowInKnots = +nmeaDataCogField.nmeaDataFieldValue;
          vm.nmeaSowInKnots = +vm.nmeaSowInKnots.toFixed(1);
        }
      };

      vm.UpdateWindSpeed = function (engineInstance, nmeaData) {
        var nmeaDataWindSpeedField = nmeaData.find(function (data) {
          return (
            data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn130306WindSpeed
          );
        });

        if (nmeaDataWindSpeedField != null) {
          vm.nmeaWindSpeedInKnots = +nmeaDataWindSpeedField.nmeaDataFieldValue;
          vm.nmeaWindSpeedInKnots = +vm.nmeaWindSpeedInKnots.toFixed(1);
        }
      };

      vm.UpdateWindAngle = function (engineInstance, nmeaData) {
        var nmeaDataWindAngleField = nmeaData.find(function (data) {
          return (
            data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn130306WindAngle
          );
        });

        if (nmeaDataWindAngleField != null) {
          vm.nmeaWindAngleInDegree = +nmeaDataWindAngleField.nmeaDataFieldValue;
          vm.nmeaWindAngleInDegree = +vm.nmeaWindAngleInDegree.toFixed(1);
        }
      };

      vm.UpdateWaterDepth = function (engineInstance, nmeaData) {
        var nmeaDataWaterDepthField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn128267Depth;
        });

        if (nmeaDataWaterDepthField != null) {
          vm.nmeaWaterDepth = +nmeaDataWaterDepthField.nmeaDataFieldValue;
          vm.nmeaWaterDepth = +vm.nmeaWaterDepth.toFixed(1);
        }
      };

      vm.UpdatePowerValues = function (instanceNumber, nmeaData , nmeaSourceId) {
        var nmeaDataDcTypeField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127506DcType;
        });
        var nmeaDataStateOfChargeField = nmeaData.find(function (data) {
          return (
            data.nmeaDataFieldEnumId ===
            nmeaDataFieldEnum.Pgn127506StateOfCharge
          );
        });

        if (nmeaDataDcTypeField != null) {
          nmeaPowerDcType = +nmeaDataDcTypeField.nmeaDataFieldValue;
          stateOfCharge = +nmeaDataStateOfChargeField.nmeaDataFieldValue;
          stateOfCharge = +stateOfCharge.toFixed(1);
          if (nmeaPowerDcType === nmeaDcTypesEnum.Battery) {
            var obj = {
              icon: "assets/images/Battery-bank-4.png",
              class: "m-b-5 m-t-10",
              name: "Battery ",
              value: stateOfCharge,
              sourceId: nmeaDcTypesEnum.Battery,
              instanceNumber: instanceNumber,
              nmeaSourceId: nmeaSourceId
            };
            var isExisting = vm.nmeaPowerInstances.find(function (
              nmeaPowerInstance
            ) {
              return nmeaPowerInstance.instanceNumber == instanceNumber && nmeaPowerInstance.nmeaSourceId == nmeaSourceId;
            });
            if (isExisting == null) {
              var batteryInstancesCount = vm.nmeaPowerInstances.filter(
                function (nmeaPowerInstance) {
                  return nmeaPowerInstance.sourceId == nmeaDcTypesEnum.Battery;
                }
              ).length;
              obj.name = obj.name + (batteryInstancesCount + 1);
              vm.nmeaPowerInstances.push(obj);
            } else {
              obj.name = isExisting.name;
              var indexToDelete = vm.nmeaPowerInstances.indexOf(isExisting);
              vm.nmeaPowerInstances.splice(indexToDelete, 1, obj);
            }
          } else if (nmeaPowerDcType === nmeaDcTypesEnum.SolarCell) {
            var obj = {
              icon: "assets/images/Solar-cell.png",
              class: "m-b-5 m-t-10 m-l-30",
              name: "Solar Cell ",
              value: stateOfCharge,
              sourceId: nmeaDcTypesEnum.SolarCell,
              instanceNumber: instanceNumber,
              nmeaSourceId: nmeaSourceId
            };
            var isExisting = vm.nmeaPowerInstances.find(function (
              nmeaPowerInstance
            ) {
              return nmeaPowerInstance.instanceNumber == instanceNumber && nmeaPowerInstance.nmeaSourceId == nmeaSourceId
            });
            if (isExisting == null) {
              var solarCellInstancesCount = vm.nmeaPowerInstances.filter(
                function (nmeaPowerInstance) {
                  return (
                    nmeaPowerInstance.sourceId == nmeaDcTypesEnum.SolarCell
                  );
                }
              ).length;
              obj.name = obj.name + (solarCellInstancesCount + 1);
              vm.nmeaPowerInstances.push(obj);
            } else {
              obj.name = isExisting.name;
              var indexToDelete = vm.nmeaPowerInstances.indexOf(isExisting);
              vm.nmeaPowerInstances.splice(indexToDelete, 1, obj);
            }
          } else if (nmeaPowerDcType === nmeaDcTypesEnum.WindPower) {
            var obj = {
              icon: "assets/images/Wind-generator.png",
              class: "m-b-5 m-t-10",
              name: "Wind Power ",
              value: stateOfCharge,
              sourceId: nmeaDcTypesEnum.WindPower,
              instanceNumber: instanceNumber,
              nmeaSourceId: nmeaSourceId
            };
            var isExisting = vm.nmeaPowerInstances.find(function (
              nmeaPowerInstance
            ) {
              return nmeaPowerInstance.instanceNumber == instanceNumber  && nmeaPowerInstance.nmeaSourceId == nmeaSourceId;
            });
            if (isExisting == null) {
              var windPowerInstancesCount = vm.nmeaPowerInstances.filter(
                function (nmeaPowerInstance) {
                  return (
                    nmeaPowerInstance.sourceId == nmeaDcTypesEnum.WindPower
                  );
                }
              ).length;
              obj.name = obj.name + (windPowerInstancesCount + 1);
              vm.nmeaPowerInstances.push(obj);
            } else {
              obj.name = isExisting.name;
              var indexToDelete = vm.nmeaPowerInstances.indexOf(isExisting);
              vm.nmeaPowerInstances.splice(indexToDelete, 1, obj);
            }
          }
        }
      };

      vm.UpdateHumidityValues = function (engineInstance, nmeaData) {
        var nmeaDataHumiditySourceField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn130313Source;
        });
        var nmeaDataActualHumidityField = nmeaData.find(function (data) {
          return (
            data.nmeaDataFieldEnumId ===
            nmeaDataFieldEnum.Pgn130313ActualHumidity
          );
        });

        if (nmeaDataHumiditySourceField != null) {
          nmeaHumiditySource = +nmeaDataHumiditySourceField.nmeaDataFieldValue;
          nmeaActualHumidity = +nmeaDataActualHumidityField.nmeaDataFieldValue;
          nmeaActualHumidity = +nmeaActualHumidity.toFixed(1);
          if (nmeaHumiditySource == 0) {
            vm.insideHumidity = nmeaActualHumidity;
          } else if (nmeaHumiditySource == 1) {
            vm.outsideHumidity = nmeaActualHumidity;
          }
        }
      };

      vm.UpdateTemperatureValues = function (engineInstance, nmeaData) {
        var nmeaDataTemperatureSourceField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn130316Source;
        });
        var nmeaDataActualTemperatureField = nmeaData.find(function (data) {
          return (
            data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn130316Temperature
          );
        });

        if (nmeaDataTemperatureSourceField != null) {
          nmeaTemperatureSource = +nmeaDataTemperatureSourceField.nmeaDataFieldValue;
          nmeaActualTemperature = +nmeaDataActualTemperatureField.nmeaDataFieldValue;
          nmeaActualTemperature = +nmeaActualTemperature.toFixed(1);

          if (
            nmeaTemperatureSource == nmeaTemperatureSourceEnum.SeaTemperature
          ) {
            vm.seaTemperature = nmeaActualTemperature;
          } else if (
            nmeaTemperatureSource ==
            nmeaTemperatureSourceEnum.OutsideTemperature
          ) {
            vm.outsideTemperature = nmeaActualTemperature;
          } else if (
            nmeaTemperatureSource == nmeaTemperatureSourceEnum.InsideTemperature
          ) {
            vm.insideTemperature = nmeaActualTemperature;
          } else if (
            nmeaTemperatureSource ==
            nmeaTemperatureSourceEnum.EngineRoomTemperature
          ) {
            vm.engineRoomTemperature = nmeaActualTemperature;
          } else if (
            nmeaTemperatureSource ==
            nmeaTemperatureSourceEnum.MainCabinTemperature
          ) {
            vm.mainCabinTemperature = nmeaActualTemperature;
          } else if (
            nmeaTemperatureSource ==
            nmeaTemperatureSourceEnum.LiveWellTemperature
          ) {
            vm.liveWellTemperature = nmeaActualTemperature;
          } else if (
            nmeaTemperatureSource ==
            nmeaTemperatureSourceEnum.BailWellTemperature
          ) {
            vm.bailWellTemperature = nmeaActualTemperature;
          } else if (
            nmeaTemperatureSource ==
            nmeaTemperatureSourceEnum.RefrigerationTemperature
          ) {
            vm.refrigerationTemperature = nmeaActualTemperature;
          } else if (
            nmeaTemperatureSource ==
            nmeaTemperatureSourceEnum.HeatingSystemTemperature
          ) {
            vm.heatingSystemTemperature = nmeaActualTemperature;
          } else if (
            nmeaTemperatureSource ==
            nmeaTemperatureSourceEnum.DewPointTemperature
          ) {
            vm.dewPointTemperature = nmeaActualTemperature;
          } else if (
            nmeaTemperatureSource ==
            nmeaTemperatureSourceEnum.WindChillTemperatureAndApparent
          ) {
            vm.windChillTemperature = nmeaActualTemperature;
          } else if (
            nmeaTemperatureSource ==
            nmeaTemperatureSourceEnum.FreezerTemperature
          ) {
            vm.freezerTemperature = nmeaActualTemperature;
          } else if (
            nmeaTemperatureSource ==
            nmeaTemperatureSourceEnum.ExhaustGasTemperature
          ) {
            vm.exhaustGasTemperature = nmeaActualTemperature;
          }
        }
      };

      vm.UpdateFluidValues = function (instanceNumber, nmeaData, nmeaSourceId) {
        var nmeaDataFluidSourceField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127505Type;
        });
        var nmeaDataFluidLevelField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127505Level;
        });
        var nmeaDataFluidCapacityField = nmeaData.find(function (data) {
          return (
            data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127505Capacity
          );
        });


        if (nmeaDataFluidSourceField != null) {

          nmeaFluidSource = +nmeaDataFluidSourceField.nmeaDataFieldValue;
          nmeaFluidLevel = +nmeaDataFluidLevelField.nmeaDataFieldValue;
          nmeaFluidLevel = +nmeaFluidLevel.toFixed(1);
          nmeaFluidCapacity = 0;
          if (nmeaDataFluidCapacityField != undefined) {
            nmeaFluidCapacity = +nmeaDataFluidCapacityField.nmeaDataFieldValue;
            nmeaFluidCapacity = +nmeaFluidCapacity.toFixed(1);
          }

          if (nmeaFluidSource == nmeaFluidTypesEnum.Fuel) {
           var fuelObj = {
              canvasId: "fuelLevelGauge_" + nmeaDataFluidSourceField.nmeaInstanceId,
              value: nmeaFluidLevel,
              sourceId: nmeaFluidTypesEnum.Fuel,
              dcType: 'Fuel',
              name: 'Fuel Tank ',
              instanceNumber: instanceNumber,
              nmeaSourceId:nmeaSourceId,
            };

            var isExisting = vm.nmeaFluidInstances.find(function (
              nmeaFluidInstance
            ) {
              return nmeaFluidInstance.instanceNumber == instanceNumber && nmeaFluidInstance.nmeaSourceId == nmeaSourceId;
            });
            if (isExisting == null) {
              var fuelInstancesCount = vm.nmeaFluidInstances.filter(function (
                nmeaFluidInstance
              ) {
                return nmeaFluidInstance.dcType == "Fuel";
              }).length;
              fuelObj.name = fuelObj.name + (fuelInstancesCount + 1);
              vm.nmeaFluidInstances.push(fuelObj);
            } else {
              fuelObj.name = isExisting.name;
              var indexToDelete = vm.nmeaFluidInstances.indexOf(isExisting);
              vm.nmeaFluidInstances.splice(indexToDelete, 1, fuelObj);
            }

            setTimeout(function () {
              clearCanvas(fuelObj.canvasId, 140, 60);
              drawVerticalProgressGauge(
                fuelObj.canvasId,
                nmeaFluidLevel,
                nmeaFluidCapacity
              ); //Draws Vertical Progress Bar Gauge
            }, 0);
          } else if (nmeaFluidSource == nmeaFluidTypesEnum.FreshWater) {
            var freshWaterObj = {
              canvasId: "freshWaterGauge_" + nmeaDataFluidSourceField.nmeaInstanceId,
              value: nmeaFluidLevel,
              sourceId: nmeaFluidTypesEnum.FreshWater,
              dcType: 'Fresh Water',
              name: 'Fresh Water Tank ',
              instanceNumber: instanceNumber,
              nmeaSourceId:nmeaSourceId,
            };

            var isExisting = vm.nmeaFluidInstances.find(function (
              nmeaFluidInstance
            ) {
              return nmeaFluidInstance.instanceNumber == instanceNumber && nmeaFluidInstance.nmeaSourceId == nmeaSourceId;
            });
            if (isExisting == null) {
              var freshWaterInstancesCount = vm.nmeaFluidInstances.filter(
                function (nmeaFluidInstance) {
                  return nmeaFluidInstance.dcType == "Fresh Water";
                }
              ).length;
              freshWaterObj.name =
                freshWaterObj.name + (freshWaterInstancesCount + 1);
              vm.nmeaFluidInstances.push(freshWaterObj);
            } else {
              freshWaterObj.name = isExisting.name;
              var indexToDelete = vm.nmeaFluidInstances.indexOf(isExisting);
              vm.nmeaFluidInstances.splice(indexToDelete, 1, freshWaterObj);
            }

            setTimeout(function () {
              clearCanvas(freshWaterObj.canvasId, 140, 60);
              drawVerticalProgressGauge(
                freshWaterObj.canvasId,
                nmeaFluidLevel,
                nmeaFluidCapacity
              ); //Draws Vertical Progress Bar Gauge
            }, 0);
          } else if (nmeaFluidSource == nmeaFluidTypesEnum.WasteWater) {
            var wasteWaterObj = {
              canvasId: "wasteWaterGauge_" + nmeaDataFluidSourceField.nmeaInstanceId,
              value: nmeaFluidLevel,
              sourceId:nmeaFluidTypesEnum.WasteWater,
              dcType: 'Waste Water',
              name: 'Waste Water Tank ',
              instanceNumber: instanceNumber,
              nmeaSourceId:nmeaSourceId,
            };

            var isExisting = vm.nmeaFluidInstances.find(function (
              nmeaFluidInstance
            ) {
              return nmeaFluidInstance.instanceNumber == instanceNumber && nmeaFluidInstance.nmeaSourceId == nmeaSourceId;
            });
            if (isExisting == null) {
              var wasteWaterInstancesCount = vm.nmeaFluidInstances.filter(
                function (nmeaFluidInstance) {
                  return nmeaFluidInstance.dcType == "Waste Water";
                }
              ).length;
              wasteWaterObj.name =
                wasteWaterObj.name + (wasteWaterInstancesCount + 1);
              vm.nmeaFluidInstances.push(wasteWaterObj);
            } else {
              wasteWaterObj.name = isExisting.name;
              var indexToDelete = vm.nmeaFluidInstances.indexOf(isExisting);
              vm.nmeaFluidInstances.splice(indexToDelete, 1, wasteWaterObj);
            }

            setTimeout(function () {
              clearCanvas(wasteWaterObj.canvasId, 140, 60);
              drawReverseVerticalProgressGauge(
                wasteWaterObj.canvasId,
                nmeaFluidLevel,
                nmeaFluidCapacity
              ); //Draws Vertical Progress Bar Gauge
            }, 0);
          } else if (nmeaFluidSource == nmeaFluidTypesEnum.LiveWell) {
            var liveWellObj = {
              canvasId: "liveWellLevelGauge_" + nmeaDataFluidSourceField.nmeaInstanceId,
              value: nmeaFluidLevel,
              sourceId: nmeaFluidTypesEnum.LiveWell,
              dcType: 'Live Well',
              name: 'Live Well Tank ',
              instanceNumber: instanceNumber,
              nmeaSourceId:nmeaSourceId,
            };

            var isExisting = vm.nmeaFluidInstances.find(function (
              nmeaFluidInstance
            ) {
              return nmeaFluidInstance.instanceNumber == instanceNumber && nmeaFluidInstance.nmeaSourceId == nmeaSourceId;
            });
            if (isExisting == null) {
              var liveWellInstancesCount = vm.nmeaFluidInstances.filter(
                function (nmeaFluidInstance) {
                  return nmeaFluidInstance.dcType == "Live Well";
                }
              ).length;
              liveWellObj.name =
                liveWellObj.name + (liveWellInstancesCount + 1);
              vm.nmeaFluidInstances.push(liveWellObj);
            } else {
              liveWellObj.name = isExisting.name;
              var indexToDelete = vm.nmeaFluidInstances.indexOf(isExisting);
              vm.nmeaFluidInstances.splice(indexToDelete, 1, liveWellObj);
            }

            setTimeout(function () {
              clearCanvas(liveWellObj.canvasId, 140, 60);
              drawVerticalProgressGauge(
                liveWellObj.canvasId,
                nmeaFluidLevel,
                nmeaFluidCapacity
              ); //Draws Vertical Progress Bar Gauge
            }, 0);
          } else if (nmeaFluidSource == nmeaFluidTypesEnum.Oil) {
            var oilObj = {
              canvasId: "oilLevelGauge_" + nmeaDataFluidSourceField.nmeaInstanceId,
              value: nmeaFluidLevel,
              sourceId: nmeaFluidTypesEnum.Oil,
              dcType: 'Oil',
              name: 'Oil Tank ',
              instanceNumber: instanceNumber,
              nmeaSourceId:nmeaSourceId,
            };

            var isExisting = vm.nmeaFluidInstances.find(function (
              nmeaFluidInstance
            ) {
              return nmeaFluidInstance.instanceNumber == instanceNumber && nmeaFluidInstance.nmeaSourceId == nmeaSourceId;
            });
            if (isExisting == null) {
              var oilInstancesCount = vm.nmeaFluidInstances.filter(function (
                nmeaFluidInstance
              ) {
                return nmeaFluidInstance.dcType == "Oil";
              }).length;
              oilObj.name = oilObj.name + (oilInstancesCount + 1);
              vm.nmeaFluidInstances.push(oilObj);
            } else {
              oilObj.name = isExisting.name;
              var indexToDelete = vm.nmeaFluidInstances.indexOf(isExisting);
              vm.nmeaFluidInstances.splice(indexToDelete, 1, oilObj);
            }

            setTimeout(function () {
              clearCanvas(oilObj.canvasId, 140, 60);
              drawVerticalProgressGauge(
                oilObj.canvasId,
                nmeaFluidLevel,
                nmeaFluidCapacity
              ); //Draws Vertical Progress Bar Gauge
            }, 0);
          } else if (nmeaFluidSource == nmeaFluidTypesEnum.BlackWater) {

            var blackWaterObj = {
              canvasId: "blackWaterGauge_" + nmeaDataFluidSourceField.nmeaInstanceId,
              value: nmeaFluidLevel,
              sourceId:  nmeaFluidTypesEnum.BlackWater,
              dcType: 'Black Water',
              name: 'Black Water Tank ',
              instanceNumber: instanceNumber,
              nmeaSourceId:nmeaSourceId,
            };

            var isExisting = vm.nmeaFluidInstances.find(function (
              nmeaPowerInstance
            ) {
              return nmeaPowerInstance.instanceNumber == instanceNumber && nmeaFluidInstance.nmeaSourceId == nmeaSourceId;
            });
            if (isExisting == null) {
              var blackWaterInstancesCount = vm.nmeaFluidInstances.filter(
                function (nmeaFluidInstance) {
                  return nmeaFluidInstance.dcType == "Black Water";
                }
              ).length;
              blackWaterObj.name =
                blackWaterObj.name + (blackWaterInstancesCount + 1);
              vm.nmeaFluidInstances.push(blackWaterObj);
            } else {
              blackWaterObj.name = isExisting.name;
              var indexToDelete = vm.nmeaFluidInstances.indexOf(isExisting);
              vm.nmeaFluidInstances.splice(indexToDelete, 1, blackWaterObj);
            }

            setTimeout(function () {
              clearCanvas(blackWaterObj.canvasId, 140, 60);
              drawReverseVerticalProgressGauge(
                blackWaterObj.canvasId,
                nmeaFluidLevel,
                nmeaFluidCapacity
              ); //Draws Vertical Progress Bar Gauge
            }, 0);
          }
        }
      };

      // vm.updateSonoffStatus = function () {
      //   if (confirm("Are you sure you want to continue ?"))
      //   {
      //   userService.updateSonoffStatus($stateParams.sentinelId, function (response) {
      //     toastr.success('Status Updated Successfully');
      //   });
      //   }
      // };

      vm.updateSonoffStatus = function () {
        var check = sessionService.getSonoffRememberMe();
        if (check) {
          if (vm.currentSentinel.sonoffSensorId != null) {
            userService.updateSonoffStatus($stateParams.sentinelId)
              .then(function (response) {
                if (response != "") {
                  toastr.error(response);
                }
              }, function (error) {
                toastr.error(error.exceptionMessage);
              });
          }
        }
        else {
          if (vm.currentSentinel.sonoffSensorId != null) {
            SweetAlert.swal({
              title: "Are you sure?",
              text: "Your NMEA network is about to turn ON. It will remain on for 5 minutes and then automatically turn OFF. Would you like to continue?<br />" +
                "<div style=\"padding: 15px;text-align:left\">" +
                "<div class=\"round\">" +
                "<input style=\"visibility: hidden !important;\" type=\"checkbox\" id=\"show-nmea-switch-prompt\" /> <label for=\"round\"></label>" +
                "</div>" +
                "<label for=\"show-nmea-switch-prompt\" class=\"action-label\" style=\"color: #797979;\">Do not show again</label>" +
                "</div>",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55", confirmButtonText: "Yes, Update it",
              cancelButtonText: "Cancel",
              closeOnConfirm: true,
              closeOnCancel: true, html: true
            },
              function (isConfirm) {
                if (isConfirm) {
                  var checkbox = $('#show-nmea-switch-prompt').prop("checked");
                  if (checkbox) {
                    sessionService.setSonoffRememberMe(true);
                  }
                  userService.updateSonoffStatus($stateParams.sentinelId)
                    .then(function (response) {
                      if (response != "") {
                        toastr.error(response);
                      }
                    }, function (error) {
                      toastr.error(error.exceptionMessage);
                    });
                }
              });
          }
          else {
            SweetAlert.swal({
              title: "Sentinel Domotics",
              text: "NMEA switch not available",
              type: "error",
              showCancelButton: false,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Ok",
              closeOnConfirm: true
            },
              function () {

              });

            // SweetAlert.swal("Good job!", "You clicked the button!", "success");
          }
        }
      };
      // if (confirm("Your NMEA network is about to turn ON, this will remain ON for 5 minutes and then automatically turn OFF. Are you happy to continue?")) {
      //   userService.updateSonoffStatus($stateParams.sentinelId)
      //     .then(function (response) {
      //         toastr.success("Sonoff Device has been turned on.");
      //     }, function (error) {
      //       toastr.error("Update unsuccessful, connection unavailable. Please try again later.");
      //     });
      // }

      vm.addPowerSourceNameAndType = function (nmeaPowerInstance) {
        nmeaService.addPowerSourceNameAndType($stateParams.sentinelId, {
          nmeaDataFieldEnumId: nmeaDataFieldEnum.Pgn127506DcType,
          NmeaInstance: {
            NmeaInstanceNumber: nmeaPowerInstance.instanceNumber,
            InstanceName: nmeaPowerInstance.newName,
            SourceId: nmeaPowerInstance.nmeaSourceId
          },
          nmeaDataFieldValue: nmeaPowerInstance.newValue,
        }).then(function () {
          nmeaService.getLatestPowerNmeaData($stateParams.sentinelId, true)
            .then(function (response) {
              powerNmeaData = response;
              mapPowerData();
            });
        });
      }
      vm.updateBatteryVoltageValues = function (instanceNumber, nmeaData , nmeaSourceId) {
        var nmeaDataBatteryVoltageField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127508Voltage;
        });
        if (nmeaDataBatteryVoltageField != null) {
          batteryVoltage = +nmeaDataBatteryVoltageField.nmeaDataFieldValue;
          batteryVoltage = batteryVoltage.toFixed(1);
          var obj = {
            icon: "assets/images/power source.png",
            class: "m-b-5 m-t-10",
            name: "Power source ",
            current: batteryVoltage,
            sourceId: nmeaDcTypesEnum.Battery,
            instanceNumber: instanceNumber,
            dcType: -1,
            nmeaSourceId: nmeaSourceId
          };
          var isExisting = vm.nmeaPowerInstances.find(function (nmeaPowerInstance) {
            return nmeaPowerInstance.instanceNumber == instanceNumber && nmeaPowerInstance.nmeaSourceId == nmeaSourceId;
          });
          if (isExisting == null) {
            obj.name = obj.name + (vm.nmeaPowerInstances.length + 1);
            vm.nmeaPowerInstances.push(obj);
          } else {
            isExisting.voltage = batteryVoltage;
          }
        }
      };

      vm.updateBatteryCurrentValues = function (instanceNumber, nmeaData, nmeaSourceId) {
        var nmeaDataBatteryCurrentField = nmeaData.find(function (data) {
          return (
            data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127508Current
          );
        });
        if (nmeaDataBatteryCurrentField != null) {
          batteryCurrent = +nmeaDataBatteryCurrentField.nmeaDataFieldValue;
          batteryCurrent = batteryCurrent.toFixed(1);
          var obj = {
            icon: "assets/images/power source.png",
            class: "m-b-5 m-t-10",
            name: "Power source ",
            current: batteryCurrent,
            sourceId: nmeaDcTypesEnum.Battery,
            instanceNumber: instanceNumber,
            dcType: -1,
            nmeaSourceId: nmeaSourceId
          };
          var isExisting = vm.nmeaPowerInstances.find(function (
            nmeaPowerInstance
          ) {
            return nmeaPowerInstance.instanceNumber == instanceNumber && nmeaPowerInstance.nmeaSourceId == nmeaSourceId;
          });
          if (isExisting == null) {
            obj.name = obj.name + (vm.nmeaPowerInstances.length + 1);
            vm.nmeaPowerInstances.push(obj);
          } else {
            isExisting.current = batteryCurrent;
          }
        }
      };
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.nmea')
    .controller('modalGraphController', function (intanceType, nmeaEnumId, intanceName, sourceId, instanceNumber, graphData, $translate, am4core, am4charts,
      nmeaGraphIntervalEnum, nmeaService, $stateParams, am4themes_animated, $timeout, nmeaSourceId) {
      var vm = this;
      vm.intanceType = intanceType;
      vm.intanceName = intanceName;
      vm.nmeaGraphIntervalEnum = nmeaGraphIntervalEnum;
      //////////////////////////////////////// Graph Related Functionality////////////////////////////////////////////////////
      vm.graphData = graphData;
      if (graphData != null) {
        if (graphData.length > 0) {
          vm.currentValue = graphData[graphData.length - 1];
        }
      }
      vm.currentInstance = instanceNumber;
      vm.currentNmeaDataFieldId = nmeaEnumId;
      vm.currentUnit = "knots";
      vm.isActiveInterval = vm.nmeaGraphIntervalEnum.Daily;
      vm.currentSourceId = sourceId;


      vm.getDailyGraphData = function () {
        vm.isActiveInterval = vm.nmeaGraphIntervalEnum.Daily;
        vm.getGraphData(vm.currentInstance, vm.currentNmeaDataFieldId, vm.currentUnit);
      };
      vm.getWeeklyGraphData = function () {
        vm.isActiveInterval = vm.nmeaGraphIntervalEnum.Weekly;
        vm.getGraphData(vm.currentInstance, vm.currentNmeaDataFieldId, vm.currentUnit);
      };
      vm.getMonthlyGraphData = function () {
        vm.isActiveInterval = vm.nmeaGraphIntervalEnum.Monthly;
        vm.getGraphData(vm.currentInstance, vm.currentNmeaDataFieldId, vm.currentUnit);
      };

      vm.getGraphData = function (instance, nmeaDataFieldId, unit) {
        $translate([])
          .then(function () {
            vm.currentInstance = instance;
            vm.currentNmeaDataFieldId = nmeaDataFieldId;
            vm.currentUnit = unit;
            nmeaService.getNmeaGraphData({ intervalId: vm.isActiveInterval, instanceNumber: instance, nmeaDataFieldEnum: nmeaDataFieldId, sentinelId: $stateParams.sentinelId, sourceId: vm.currentSourceId,getByDate:true, nmeaSourceId: nmeaSourceId })
              .then(function (response) {
                vm.graphData = response;
                if (response != null) {
                  if (response.length > 0) {
                    vm.currentValue = response[response.length - 1] + " " + unit;
                    if (vm.chart) {
                      vm.chart.data = vm.graphData;
                      vm.chart.invalidateData();
                    }
                  }
                }
              });
          });
      }
      ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      $timeout(function () {
        am4core.useTheme(am4themes_animated);
        vm.chart = am4core.create("chartdiv", am4charts.XYChart);
        // chart.data = vm.graphData.map(function(d){
        //   return {
        //     date: d.label,
        //     value: d.value
        //   };
        // })
        vm.chart.dateFormatter.inputDateFormat = "yyyy-MM-dd HH:mm:ss";

        // Set input format for the dates


        // Create axes
        var dateAxis = new am4charts.DateAxis();
        dateAxis.dateFormatter = new am4core.DateFormatter();
        // dateAxis.dateFormatter.dateFormat  = "yyyy-MM-dd HH:mm:ss";
        // dateAxis.dateFormats.setKey("day", "MMM dd HH:mm");
        // dateAxis.dateFormats.setKey("hour", "MMM dd HH:mm");
        dateAxis.dateFormats.setKey("minute", "dd/MMM/yyyy HH:mm");
        dateAxis.baseInterval = {
          "timeUnit": "minute",
          "count": 15
        }
        vm.chart.xAxes.push(dateAxis);
        var yAxes = new am4charts.ValueAxis();
        yAxes.numberFormatter = new am4core.NumberFormatter();
        yAxes.numberFormatter.numberFormat = "#.#";
        vm.chart.yAxes.push(yAxes);
        // Create series
        var series = vm.chart.series.push(new am4charts.LineSeries());
        series.dataFields.valueY = "value";
        series.dataFields.dateX = "label";
        series.tooltipText = "{valueY}";
        series.strokeWidth = 2;
        series.minBulletDistance = 15;

        // Drop-shaped tooltips
        series.tooltip.background.cornerRadius = 20;
        series.tooltip.background.strokeOpacity = 0;
        series.tooltip.pointerOrientation = "vertical";
        series.tooltip.label.minWidth = 40;
        series.tooltip.label.minHeight = 40;
        series.tooltip.label.textAlign = "middle";
        series.tooltip.label.textValign = "middle";

        // Make bullets grow on hover
        var bullet = series.bullets.push(new am4charts.CircleBullet());
        bullet.circle.strokeWidth = 2;
        bullet.circle.radius = 4;
        bullet.circle.fill = am4core.color("#fff");

        var bullethover = bullet.states.create("hover");
        bullethover.properties.scale = 1.3;

        //Make a panning cursor
        vm.chart.cursor = new am4charts.XYCursor();
        vm.chart.cursor.behavior = "panXY";
        vm.chart.cursor.xAxis = dateAxis;
        vm.chart.cursor.snapToSeries = series;

        // Create vertical scrollbar and place it before the value axis
        //  vm.chart.scrollbarY = new am4core.Scrollbar();
        //  vm.chart.scrollbarY.parent = vm.chart.leftAxesContainer;
        //  vm.chart.scrollbarY.toBack();

        //Create a horizontal scrollbar with previe and place it underneath the date axis
        vm.chart.scrollbarX = new am4charts.XYChartScrollbar();
        vm.chart.scrollbarX.series.push(series);
        vm.chart.scrollbarX.parent = vm.chart.bottomAxesContainer;

        //dateAxis.start = 0.79;
        dateAxis.keepSelection = true;
        vm.chart.data = angular.copy(vm.graphData);
      }, 100)
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.nmea')
    .controller('engineDetailsController', function (enginesData, currentSentinel, $translate, am4themes_animated, $timeout, am4core, am4charts, speedGraphData, nmeaGraphIntervalEnum, nmeaService, navigationService, $rootScope, $stateParams, notificationHub, nmeaMappings, $scope, nmeaDataFieldEnum) {
      var vm = this;
      vm.engineInstancesData = [];
      vm.currentEngineName = '';
      vm.speedGraphData = speedGraphData;
      vm.currentGraphData = [];
      if (vm.speedGraphData != null) {
        if (vm.speedGraphData.length > 0) {
          vm.currentGraphData = vm.speedGraphData[vm.speedGraphData.length - 1];
        }
      }
      if (enginesData.length > 0) {
        enginesData.forEach(function (engine) {
          var obj = {
            instanceNumber: engine.instanceNumber,
            nmeaSpeedInKnots: engine.speed,
            nmeaBoostInPsi: engine.boost,
            nmeaRpm: engine.rpm,
            nmeaTrim: engine.tiltTrim,
            nmeaOilPressureInPsi: engine.oilPressure,
            nmeaOilTemperatureInC: engine.oilTemperature,
            fuelLevel: engine.fuelLevel,
            nmeaEngineTemperatureInC: engine.engineTemperature,
            nmeaAlternatorPotential: engine.alternatorPotential,
            nmeaFuelRate: engine.fuelRate,
            nmeaTotalEngineHours: engine.engineHours,
            nmeaCoolantPressure: engine.engineCoolantPressure,
            nmeaFuelPressure: engine.fuelPressure,
            nmeaEngineLoad: engine.engineLoad,
            nmeaEngineTorque: engine.engineTorque,
            engineName: engine.engineName
          };
          var isExisting = vm.engineInstancesData.find(function (engineSlide) {
            return engineSlide.id == engine.instanceNumber;
          });
          if (isExisting == null) {
            vm.engineInstancesData.push(obj);
          } else {
            var indexToDelete = vm.engineInstancesData.indexOf(isExisting);
            vm.engineInstancesData.splice(indexToDelete, 1, obj);
          }
        });
      }
      vm.nmeaDataFieldEnum = nmeaDataFieldEnum;
      vm.nmeaGraphIntervalEnum = nmeaGraphIntervalEnum;
      vm.showSampleData = false;
      vm.currentSentinel = currentSentinel;
      vm.showSampleData = false;
      if (vm.currentSentinel.imei.length != 15) {
        vm.showSampleData = true;
      }
      navigationService.navigation = {
        backState: 'boat.nmea',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.goBack = function () {
        $rootScope.goBack();
      };
      var hub = new notificationHub();
      hub.on('pushNmeaData', function (data) {
        console.log("Data Recieved");
        var currentPgnMapping = nmeaMappings.find(function (mapping) {
          return mapping.Pgn === data.pgn && mapping.Controller == "Engine";
        });
        if (currentPgnMapping != undefined &&
          data.userSentinelId == $stateParams.sentinelId) {
          currentPgnMapping.Functions.forEach(function (funcName) {
            $scope.$eval(funcName).call([], data.instance, data.nmeaData);
          });
          $rootScope.$apply();
        }
      });
      $scope.$on("$destroy", function () {
        hub.off('pushNmeaData');
      });

      vm.currentName = "Speed.Text";
      vm.currentInstance = null;
      vm.currentNmeaDataFieldId = nmeaDataFieldEnum.Pgn129026Sog;
      vm.currentUnit = "knots";
      vm.currentSelected = "Speed";
      vm.isActiveInterval = nmeaGraphIntervalEnum.Daily;

      vm.getDailyGraphData = function () {
        vm.isActiveInterval = nmeaGraphIntervalEnum.Daily;
        vm.getGraphData(vm.currentEngineName, vm.currentName, vm.currentInstance, vm.currentNmeaDataFieldId, vm.currentUnit);
      };
      vm.getWeeklyGraphData = function () {
        vm.isActiveInterval = nmeaGraphIntervalEnum.Weekly;
        vm.getGraphData(vm.currentEngineName, vm.currentName, vm.currentInstance, vm.currentNmeaDataFieldId, vm.currentUnit);
      };
      vm.getMonthlyGraphData = function () {
        vm.isActiveInterval = nmeaGraphIntervalEnum.Monthly;
        vm.getGraphData(vm.currentEngineName, vm.currentName, vm.currentInstance, vm.currentNmeaDataFieldId, vm.currentUnit);
      };

      vm.getGraphData = function (engineName, name, instance, nmeaDataFieldId, unit) {
        $translate([name])
          .then(function (translations) {
            vm.currentSelected = translations[name];
            vm.currentEngineName = engineName;
            vm.currentName = name;
            vm.currentInstance = instance;
            vm.currentNmeaDataFieldId = nmeaDataFieldId;
            vm.currentUnit = unit;
            nmeaService.getEngineDetailsNmeaGraphData(vm.isActiveInterval, $stateParams.sentinelId, instance, nmeaDataFieldId,true)
              .then(function (response) {
                if (response.length > 0) {
                  vm.speedGraphData = response;
                  if (response != null) {
                    if (response.length > 0) {
                      vm.currentGraphData = response[response.length - 1] + " " + unit;
                      if (vm.chart) {
                        vm.chart.data = vm.speedGraphData;
                        vm.chart.invalidateData();
                      }
                    }
                  }

                } else {
                  vm.speedGraphData = [];
                }
              });
          });
      }
      ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      vm.UpdateSpeed = function (engineInstance, nmeaData) {
        var nmeaDataSpeedField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn129026Sog;
        });
        var engine = vm.engineInstancesData.find(function (eng) {
          return eng.instanceNumber === engineInstance;
        });

        if (nmeaDataSpeedField != null) {
          if (engine != null) {
            engine.nmeaSpeedInKnots = +nmeaDataSpeedField.nmeaDataFieldValue;
            engine.nmeaSpeedInKnots = engine.nmeaSpeedInKnots.toFixed(1);
          }
        }

      };

      vm.UpdateBoost = function (engineInstance, nmeaData) {
        var nmeaDataBoostField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127488BoostPressure;
        });
        var engine = vm.engineInstancesData.find(function (eng) {
          return eng.instanceNumber === engineInstance;
        });

        if (nmeaDataBoostField != null) {
          if (engine != null) {
            engine.nmeaBoostInPsi = +nmeaDataBoostField.nmeaDataFieldValue;
            engine.nmeaBoostInPsi = engine.nmeaBoostInPsi.toFixed(1);
          }
        }
      };

      vm.UpdateRpm = function (engineInstance, nmeaData) {
        var nmeaDataRpmField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127488Speed;
        });
        var engine = vm.engineInstancesData.find(function (eng) {
          return eng.instanceNumber === engineInstance;
        });

        if (nmeaDataRpmField != null) {
          if (engine != null) {
            value = +nmeaDataRpmField.nmeaDataFieldValue;
            engine.nmeaRpm = (value / 100).toFixed(1);
          }
        }

      };

      vm.UpdateTrim = function (engineInstance, nmeaData) {
        var nmeaDataTiltTrimField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127488TiltTrim;
        });
        var engine = vm.engineInstancesData.find(function (eng) {
          return eng.instanceNumber === engineInstance;
        });

        if (nmeaDataTiltTrimField != null) {
          if (engine != null) {
            engine.nmeaTrim = +nmeaDataTiltTrimField.nmeaDataFieldValue;
            engine.nmeaTrim = engine.nmeaTrim.toFixed(1);
          }
        }

      };

      vm.UpdateFuelLevel = function (engineInstance, nmeaData) {
        //fluid check
        var nmeaDataFluidSourceField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127505Type;
        });
        var engine = vm.engineInstancesData.find(function (eng) {
          return eng.instanceNumber === engineInstance;
        });

        if (nmeaDataFluidSourceField != null) {
          if (engine != null) {
            engine.fuelLevel = +nmeaDataFluidSourceField.nmeaDataFieldValue;
            engine.fuelLevel = engine.fuelLevel.toFixed(1);
          }
        }

      };
      vm.UpdateFuelRate = function (engineInstance, nmeaData) {
        var nmeaDataFuelRateField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127489FuelRate;
        });

        var engine = vm.engineInstancesData.find(function (eng) {
          return eng.instanceNumber === engineInstance;
        });

        if (nmeaDataFuelRateField != null) {
          if (engine != null) {
            engine.nmeaFuelRate = +nmeaDataFuelRateField.nmeaDataFieldValue;
            engine.nmeaFuelRate = engine.nmeaFuelRate.toFixed(1);
          }
        }

      };

      vm.UpdateOilPressure = function (engineInstance, nmeaData) {
        var nmeaDataOilPressureField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127489OilPressure;
        });
        var engine = vm.engineInstancesData.find(function (eng) {
          return eng.instanceNumber === engineInstance;
        });

        if (nmeaDataOilPressureField != null) {
          if (engine != null) {
            engine.nmeaOilPressureInPsi = +nmeaDataOilPressureField.nmeaDataFieldValue;
            engine.nmeaOilPressureInPsi = engine.nmeaOilPressureInPsi.toFixed(1);
          }
        }

      };

      vm.UpdateOilTemperature = function (engineInstance, nmeaData) {
        var nmeaDataOilTemperatureField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127489OilTemperature;
        });
        var engine = vm.engineInstancesData.find(function (eng) {
          return eng.instanceNumber === engineInstance;
        });

        if (nmeaDataOilTemperatureField != null) {
          if (engine != null) {
            engine.nmeaOilTemperatureInC = +nmeaDataOilTemperatureField.nmeaDataFieldValue;
            engine.nmeaOilTemperatureInC = engine.nmeaOilTemperatureInC.toFixed(1);
          }
        }
      };

      vm.UpdateEngineTemperature = function (engineInstance, nmeaData) {
        var nmeaDataEngineTemperatureField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127489Temperature;
        });
        var engine = vm.engineInstancesData.find(function (eng) {
          return eng.instanceNumber === engineInstance;
        });

        if (nmeaDataEngineTemperatureField != null) {
          if (engine != null) {
            engine.nmeaEngineTemperatureInC = +nmeaDataEngineTemperatureField.nmeaDataFieldValue;
            engine.nmeaEngineTemperatureInC = engine.nmeaEngineTemperatureInC.toFixed(1);
          }
        }

      };

      vm.UpdateAlternatorPotential = function (engineInstance, nmeaData) {
        var nmeaDataAlternatorPotentialField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127489AlternatorPotential;
        });
        var engine = vm.engineInstancesData.find(function (eng) {
          return eng.instanceNumber === engineInstance;
        });

        if (nmeaDataAlternatorPotentialField != null) {
          if (engine != null) {
            engine.nmeaAlternatorPotential = +nmeaDataAlternatorPotentialField.nmeaDataFieldValue;
            engine.nmeaAlternatorPotential = engine.nmeaAlternatorPotential.toFixed(1);
          }
        }

      };


      vm.UpdateFuelPressure = function (engineInstance, nmeaData) {
        var nmeaDataFuelPressureField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127489FuelPressure;
        });
        var engine = vm.engineInstancesData.find(function (eng) {
          return eng.instanceNumber === engineInstance;
        });

        if (nmeaDataFuelPressureField != null) {
          if (engine != null) {
            engine.nmeaFuelPressure = +nmeaDataFuelPressureField.nmeaDataFieldValue;
            engine.nmeaFuelPressure = engine.nmeaFuelPressure.toFixed(1);
          }
        }
      };

      vm.UpdateTotalEngineHours = function (engineInstance, nmeaData) {
        var nmeaDataTotalEngineHoursField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127489TotalEngineHours;
        });
        var engine = vm.engineInstancesData.find(function (eng) {
          return eng.instanceNumber === engineInstance;
        });

        if (nmeaDataTotalEngineHoursField != null) {
          if (engine != null) {
            engine.nmeaTotalEngineHours = +nmeaDataTotalEngineHoursField.nmeaDataFieldValue;
            //engine.nmeaTotalEngineHours = engine.nmeaTotalEngineHours.toFixed(1);
          }
        }

      };

      vm.UpdateCoolantPressure = function (engineInstance, nmeaData) {
        var nmeaDataCoolantPressureField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127489CoolantPressure;
        });
        var engine = vm.engineInstancesData.find(function (eng) {
          return eng.instanceNumber === engineInstance;
        });

        if (nmeaDataCoolantPressureField != null) {
          if (engine != null) {
            engine.nmeaCoolantPressure = +nmeaDataCoolantPressureField.nmeaDataFieldValue;
            engine.nmeaCoolantPressure = engine.nmeaCoolantPressure.toFixed(1);
          }
        }

      };



      vm.UpdateEngineLoad = function (engineInstance, nmeaData) {
        var nmeaDataEngineLoadField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127489PercentEngineLoad;
        });

        var engine = vm.engineInstancesData.find(function (eng) {
          return eng.instanceNumber === engineInstance;
        });

        if (nmeaDataEngineLoadField != null) {
          if (engine != null) {
            engine.nmeaEngineLoad = +nmeaDataEngineLoadField.nmeaDataFieldValue;
            engine.nmeaEngineLoad = engine.nmeaEngineLoad.toFixed(1);
            if (engine.nmeaEngineLoad < 0) {
              engine.nmeaEngineLoad = 0;
            }
          }
        }


      };

      vm.UpdateEngineTorque = function (engineInstance, nmeaData) {
        var nmeaDataEngineTorqueField = nmeaData.find(function (data) {
          return data.nmeaDataFieldEnumId === nmeaDataFieldEnum.Pgn127489PercentEngineTorque;
        });

        var engine = vm.engineInstancesData.find(function (eng) {
          return eng.instanceNumber === engineInstance;
        });

        if (nmeaDataEngineTorqueField != null) {
          if (engine != null) {
            engine.nmeaEngineTorque = +nmeaDataEngineTorqueField.nmeaDataFieldValue;
            engine.nmeaEngineTorque = engine.nmeaEngineTorque.toFixed(1);
          }
        }

      };
      //////////////////////////////////////////////////////////////////////////////////

      $timeout(function () {
        am4core.useTheme(am4themes_animated);
        vm.chart = am4core.create("chartdiv", am4charts.XYChart);
        // chart.data = vm.graphData.map(function(d){
        //   return {
        //     date: d.label,
        //     value: d.value
        //   };
        // })
        vm.chart.dateFormatter.inputDateFormat = "yyyy-MM-dd HH:mm:ss";

        // Set input format for the dates


        // Create axes
        var dateAxis = new am4charts.DateAxis();
        dateAxis.dateFormatter = new am4core.DateFormatter();
        // dateAxis.dateFormatter.dateFormat  = "yyyy-MM-dd HH:mm:ss";
        // dateAxis.dateFormats.setKey("day", "MMM dd HH:mm");
        // dateAxis.dateFormats.setKey("hour", "MMM dd HH:mm");
        dateAxis.dateFormats.setKey("minute", "dd/MMM/yyyy HH:mm");
        dateAxis.baseInterval = {
          "timeUnit": "minute",
          "count": 15
        }
        vm.chart.xAxes.push(dateAxis);
        var yAxes = new am4charts.ValueAxis();
        yAxes.numberFormatter = new am4core.NumberFormatter();
        yAxes.numberFormatter.numberFormat = "#.#";
        vm.chart.yAxes.push(yAxes);
        // Create series
        var series = vm.chart.series.push(new am4charts.LineSeries());
        series.dataFields.valueY = "value";
        series.dataFields.dateX = "label";
        series.tooltipText = "{valueY}";
        series.strokeWidth = 2;
        series.minBulletDistance = 15;

        // Drop-shaped tooltips
        series.tooltip.background.cornerRadius = 20;
        series.tooltip.background.strokeOpacity = 0;
        series.tooltip.pointerOrientation = "vertical";
        series.tooltip.label.minWidth = 40;
        series.tooltip.label.minHeight = 40;
        series.tooltip.label.textAlign = "middle";
        series.tooltip.label.textValign = "middle";

        // Make bullets grow on hover
        var bullet = series.bullets.push(new am4charts.CircleBullet());
        bullet.circle.strokeWidth = 2;
        bullet.circle.radius = 4;
        bullet.circle.fill = am4core.color("#fff");

        var bullethover = bullet.states.create("hover");
        bullethover.properties.scale = 1.3;

        //Make a panning cursor
        vm.chart.cursor = new am4charts.XYCursor();
        vm.chart.cursor.behavior = "panXY";
        vm.chart.cursor.xAxis = dateAxis;
        vm.chart.cursor.snapToSeries = series;

        // Create vertical scrollbar and place it before the value axis
        //  vm.chart.scrollbarY = new am4core.Scrollbar();
        //  vm.chart.scrollbarY.parent = vm.chart.leftAxesContainer;
        //  vm.chart.scrollbarY.toBack();

        //Create a horizontal scrollbar with previe and place it underneath the date axis
        vm.chart.scrollbarX = new am4charts.XYChartScrollbar();
        vm.chart.scrollbarX.series.push(series);
        vm.chart.scrollbarX.parent = vm.chart.bottomAxesContainer;

        //dateAxis.start = 0.79;
        dateAxis.keepSelection = true;
        vm.chart.data = angular.copy(vm.speedGraphData);

      }, 100);

    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.boats', [
    'yatch-sentinel.services',
    'flow'
  ]).config(function ($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider
      .state('boat.manage_boats', {
        url: '/manage-boats/:sentinelId',
        views: {
          'header@boat': {
            templateUrl: 'app/main/boats/index/header.html',
            controller: function (oemConfig) {
              var vm = this;
              vm.oemConfig = angular.copy(oemConfig);
            },
            controllerAs: 'vm'
          },
          'content@boat': {
            templateUrl: 'app/main/boats/index/manage-boats.html',
            controller: 'boatsController',
            controllerAs: 'vm',
            resolve: {
              boats: function (userService) {
                return userService.getUserSentinels();
              },
              sharedSentinels: function (userService) {
                return userService.getSharedSentinels();
              }
            }
          }
        },
        headerClass: 'half',
        mobileHeader: {
          visible: true,
          title: 'Header.ManageBoats'
        },
        data: {
          pageTitle: 'Boats'
        }
      });
    $translatePartialLoaderProvider.addPart('app/main/boats/edit');
    $translatePartialLoaderProvider.addPart('app/main/boats/index');
  });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.boats')
    .controller('chatController', function (cfpLoadingBar, toastr, moment, config, chatGroupRecipient, navigationService, chatService, groupMessages, $stateParams, sessionService,
      chatHub, $timeout, $scope) {
      var vm = this;
      vm.groupMessages = groupMessages;
      vm.user = sessionService.getUser();
      vm.recipient = chatGroupRecipient;
      if (vm.recipient.profilePicture) {
        vm.recipient.profilePicture = config.apiUrl + vm.recipient.profilePicture + '?access_token=' + sessionService.getAuthToken().access_token;
      }
      navigationService.navigation = {
        backState: 'boat.home',
        backStateParams: {}
      };
      vm.message = '';
      vm.init = function () {
        vm.hub = new chatHub();
        vm.hub.setAccessToken(sessionService.getAuthToken().access_token);
        vm.hub.connect();
        $timeout(function () {
          vm.hub.on('NewMessage', function (data) {
            $scope.$apply(function (s) {
              s.vm.groupMessages.push(data);
              s.vm.scrollToBottom(true);
            });
          })
        }, 500);
        vm.scrollToBottom(true);
      };
      
      vm.sendMessage = function () {
        if (vm.message == '') {
          toastr.error('Cannot Send Empty Message!');
          return;
        } else {
          chatService.sendMessage($stateParams.groupId, {
            message: vm.message
          }).then(function (response) {
            var newMessageObj = {
              id: response,
              chatGroupId: $stateParams.groupId,
              senderUserId: vm.user.id,
              message: vm.message,
              createdDate: moment().toDate()
            };
            vm.groupMessages.push(newMessageObj);
            vm.scrollToBottom(true);
            // form.$setPristine();
            vm.message = '';
          });
        }
      };

      vm.uploadAttachment = function () {
        document.getElementById("attachment").click();
      }

      vm.uploadApi = {
        target: config.apiUrl + "api/attachment",
        headers: {
          Authorization: 'Bearer ' + sessionService.getAuthToken().access_token
        },
        method: 'POST',
        permanentErrors: [500, 501],
        chunkSize: Number.MAX_VALUE
      };

      vm.onUploadStarted = function (file, flow) {
        vm.showProgressBar = true;
      };

      vm.flowProgress = function (flow) {
        vm.flowProgressValue = flow.progress() * 100;
      }

      vm.onUploadComplete = function () {
        vm.showProgressBar = false;
        cfpLoadingBar.complete();
      };

      vm.onUploadSuccess = function (file, $message, flow) {
        chatService.sendMessage($stateParams.groupId, {
          message: file.name,
          attachmentId: $message
        })
          .then(function (response) {
            vm.groupMessages.push({
              message: file.name,
              attachmentId: $message,
              id: response,
              chatGroupId: $stateParams.groupId,
              senderUserId: vm.user.id,
              createdDate: moment().toDate()
            });
            vm.scrollToBottom(true);
          });
      };

      vm.downloadFile = function (attachmentId) {
        window.open(config.apiUrl + 'api/chat/' + $stateParams.groupId + '/attachment/' + attachmentId + '?access_token=' + sessionService.getAuthToken().access_token, '_blank');
      }

      vm.scrollToBottom = function(force) {
        $timeout(function(){
          var chat = document.getElementById('chat-messages');
          var shouldScroll = chat.scrollHeight - chat.clientHeight <= chat.scrollTop + 1;
    
          if (force || shouldScroll) {
            // chat.scrollTop = chat.scrollHeight - chat.clientHeight;
            $('#chat-messages').animate({ scrollTop: chat.scrollHeight - chat.clientHeight }, 0);
          }
        },0);
      };

      vm.init();
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.boats')
    .controller('helpCenterController', function (toastr, navigationService, chatService, $state) {
      var vm = this;
      navigationService.navigation = {
        backState: 'boat.home',
        backStateParams: {}
      };
      vm.model = {
        name: '',
        email: '',
        phoneNumber: '',
        question: ''
      };

      vm.startChat = function () {
        if (vm.model.name == '' ||
          vm.model.email == '' ||
          vm.model.phoneNumber == '' ||
          vm.model.question == '') {
          toastr.error('Please Enter All Fields!');
          return;
        } else {
          chatService.startChart(vm.model).then(function (response) {
            vm.group = response;
            // form.$setPristine();
            $state.go('boat.chat', { groupId: vm.group.id });
          });
        }
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.forum')
    .controller('forumIndexController', function ($stateParams,$scope, forumCategories, forumCategoriesHierarchy, latestPosts, config, sessionService, tenantService) {
      var vm = this;
      vm.show = false;
      vm.hideCategory = false;
      vm.forumCategories = forumCategories;
      vm.forumCategoriesHierarchy = forumCategoriesHierarchy;
      vm.isCollapsed = false;
      vm.latestPosts = latestPosts;
      vm.sentinelId = $stateParams.sentinelId;
      vm.stateCheck=true;
      vm.chk=sessionService.getLoginState();
      if(vm.chk=="redirect")
      {
        vm.stateCheck=false;
      }
      vm.toggleAccordions = function (forumCategory) {
        forumCategory.isCollapsed = !forumCategory.isCollapsed;
      };

      vm.saveChanges = function () {
      };
      vm.getImageLinks = function () {
        angular.forEach(vm.forumCategories, function (category, key) {
          angular.forEach(category.forumChildCategories, function (childCategory, key) {
            if (childCategory.latestPost != null) {
              childCategory.latestPost.profilePicture = config.apiUrl + childCategory.latestPost.user.profilePicture + '?access_token=' + sessionService.getAuthToken().access_token;
            }
          });
        });
      }
      vm.getImageLinks();
      vm.getProfileImageLinks = function () {
        angular.forEach(vm.latestPosts, function (post, key) {
          post.profilePicture = config.apiUrl + post.user.profilePicture + '?access_token=' + sessionService.getAuthToken().access_token;
        });
      }
      vm.getProfileImageLinks();
      vm.hideDialog = function (hide) {
        vm.show = false;
        if (hide) {
          tenantService.getAllTenantCategories(function (response) {
            vm.forumCategories = response;
            tenantService.getLatestPosts(function (latestPosts) {
              vm.latestPosts = latestPosts;
              vm.getImageLinks();
              vm.getProfileImageLinks();
            });
          });
        }
      };
      vm.newPostBoatDialog = function (boat) {
        $uibModal.open({
          templateUrl: 'app/main/forum/new/new-dialog.html',
          controller: 'boatEditDialogController',
          controllerAs: 'vm',
          windowClass: 'contact-modal',
          resolve: {
            boat: function () {
              return angular.copy(boat);
            }
          }
        }).result.then(function () {
        });
      };
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.forum')
    .controller('forumCategoryController', function ($stateParams,latestPosts, tenantService, forumCategoriesHierarchy, forumCategory, forumCategoryPosts, sessionService, config) {
      var vm = this;
      vm.show = false;
      vm.hideCategory = true;
      vm.forumCategoriesHierarchy = forumCategoriesHierarchy;
      vm.forumCategory = forumCategory;
      vm.forumCategoryPosts = forumCategoryPosts;
      vm.latestPosts = latestPosts;
      vm.sentinelId = $stateParams.sentinelId;
      vm.stateCheck=true;
      vm.chk=sessionService.getLoginState();
      if(vm.chk=="redirect")
      {
        vm.stateCheck=false;
      }
      vm.getProfileImageLinks = function () {
        angular.forEach(vm.forumCategoryPosts, function (post, key) {
          post.profilePicture = config.apiUrl + post.user.profilePicture + '?access_token=' + sessionService.getAuthToken().access_token;
          if (post.latestReply != null) {
            post.latestReply.user.profilePicture = config.apiUrl + post.latestReply.user.profilePicture + '?access_token=' + sessionService.getAuthToken().access_token;
          }
        });
      }
      vm.getImageLinks = function () {
        angular.forEach(vm.latestPosts, function (post, key) {
          post.profilePicture = config.apiUrl + post.user.profilePicture + '?access_token=' + sessionService.getAuthToken().access_token;
        });
      }
      vm.hideDialog = function (hide) {
        vm.show = false;
        if (hide) {
          tenantService.getForumCategoryPosts(vm.forumCategory.id, function (response) {
            vm.forumCategoryPosts = response;
            tenantService.getLatestPosts(function (latestPosts) {
              vm.latestPosts = latestPosts;
              vm.getProfileImageLinks();
              vm.getImageLinks();
            });
          })
        };
      }
      vm.getProfileImageLinks();
      vm.getImageLinks();

    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .service('tiltAlarmService', function () {
      return {
        data: {}
      }
    });
})();

(function () {
    'use strict;'
    angular.module('yatch-sentinel.alarms')
    .controller('tiltAlarmHeaderController', function (tiltAlarmService,oemConfig) {
        var vm = this;
        vm.oemConfig = angular.copy(oemConfig);
        vm.lastUpdated = tiltAlarmService.data == null ? "None" : tiltAlarmService.data.lastUpdated;
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('tiltAlarmController',
      function (navigationService, sensors, tiltAlarm, sentinelService, $stateParams, toastr, $state, tiltAlarmService,$rootScope) {
        var vm = this;
        navigationService.navigation = {
          backState: 'boat.alarms',
          backStateParams: {
            sentinelId: $stateParams.sentinelId
          }
        };
        vm.goBack = function () {
          $rootScope.goBack();
        };
        tiltAlarmService.data = tiltAlarm;
        vm.tiltAlarm = {
          value: 15,
          maximum: 50,
          minimum: 15,
          options: {
            floor: 15,
            ceil: 50,
            step: 0.5,
            precision: 1,
            showSelectionBar: true,
            translate: function (input) {
              return input + String.fromCharCode(176);
            }
          }
        };
        vm.tiltAlarm.enabled = tiltAlarm == null ? false : tiltAlarm.enabled;
        if (tiltAlarm && tiltAlarm.alarmValue != null) {
          vm.tiltAlarm.value = tiltAlarm.alarmValue.maximum;
        }

        vm.saveTiltAlarms = function () {

          sentinelService.saveTiltAlarm($stateParams.sentinelId, {
              alarmValue: angular.toJson({
                maximum: vm.tiltAlarm.value,
                minimum: vm.tiltAlarm.minimum
              }),
              enabled: vm.tiltAlarm.enabled
            },
            function () {
              toastr.success('Tilt alarms updated');
              $state.go('boat.alarms', {
                sentinelId: $stateParams.sentinelId
              });
            });
        };
        vm.hasAccess = false;
        vm.canUserAccessTheSentinel = function () {
          sentinelService.canUserAccessTheSentinel($stateParams.sentinelId, function (response) {
            if (response != null) {
              vm.hasAccess = response;
            } else {
              vm.hasAccess = true;
            }
          });
        }
        vm.canUserAccessTheSentinel();
      });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .service('temperatureAlarmService', function () {
      return {
        data: []
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('temperatureAlarmHeaderController', function (temperatureAlarmService, $filter, oemConfig) {
      var vm = this;
      vm.oemConfig = angular.copy(oemConfig);
      if(temperatureAlarmService.data.length == 0){
          vm.lastUpdated = 'None';
          return;
      }
      var latest = $filter('orderBy')(temperatureAlarmService.data.filter(function (a) {
        return a.dateUpdated != null;
      }), 'dateUpdated', true);
      if (latest && latest.length > 0) {
        vm.lastUpdated = latest[0].dateUpdated;
      } else {
         latest = $filter('orderBy')(temperatureAlarmService.data, 'dateAdded', true);
        vm.lastUpdated = latest[0].dateAdded;
      }

    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('temperatureAlarmController', function (navigationService, sensors, sensorType, $uibModal, temperatureAlarms, $stateParams,
      $filter, sentinelService, toastr, sessionService, $state, temperatureAlarmService, $translatePartialLoader, $translate, $rootScope, settingEnum) {
      var vm = this;
      $translatePartialLoader.addPart('app/main/alarm/temperature');
      $translate.refresh();
      navigationService.navigation = {
        backState: 'boat.alarms',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.goBack = function () {
        $rootScope.goBack();
      };
      var min = -20;
      var max = 60;
      var settings = sessionService.getUserSettings();
      var tempSetting = settings.find(function (x) {
        return x.Id === settingEnum.Temperature.Id
      });
      if (tempSetting && tempSetting.userSettingViewModel) {
        // Fahrenhite
        if (tempSetting.userSettingViewModel.allow_Setting_Value == 3) {
          min = (min * 1.8) + 32;
          max = (max * 1.8) + 32;
        }
      }
      if (sensors.length == 0) {
        var buyNowLink = sensorType.buyNowLink;
        vm.sentinelId = $stateParams.sentinelId;
        $uibModal.open({
          templateUrl: 'app/main/common/error-box-dialog.html',
          controllerAs: 'vm',
          controller: function (buyNowLink) {
            var vm = this;
            vm.buyNowLink = buyNowLink;
          },
          size: 'lg',
          resolve: {
            buyNowLink: function () {
              return buyNowLink;
            }
          }
        }).closed.then(function () {
          $state.go('boat.alarms', { sentinelId: vm.sentinelId });
        });
      }
      vm.sensors = sensors;
      temperatureAlarmService.data = temperatureAlarms;
      vm.sensors.forEach(function (s) {
        s.alarm = {
          alarmValue: {
            min: min,
            max: max
          }
        };
        var alarm = temperatureAlarms.filter(function (a) {
          return a.sentinelSensorId == s.id;
        })[0];
        if (alarm) {
          s.alarm = alarm;
          s.enabled = alarm.enabled;
        } else {
          s.enabled = false;
        }
      });

      vm.sentinelAlarmSlider = {
        options: {
          floor: min,
          ceil: max,
          step: 1,
          translate: function (value, sliderId, label) {
            switch (label) {
              case 'model':
                return '<b>' + $filter('temperature')(value) + '</b>';
              case 'high':
                return '<b>' + $filter('temperature')(value) + '</b>';
              default:
                return '<b>' + $filter('temperature')(value) + '</b>';
            }
          }
        }
      };

      vm.updateAlarm = function () {
        var alarms = vm.sensors.map(function (s) {
          return {
            enabled: s.enabled,
            sentinelSensorId: s.id,
            alarmValue: s.alarm.alarmValue
          };
        });
        sentinelService.updateTemperatureAlarms($stateParams.sentinelId, alarms, function () {
          toastr.success('Temperature alarms updated');
          $state.go('boat.alarms', {
            sentinelId: $stateParams.sentinelId
          });
        });
      };
      vm.hasAccess = false;
      vm.canUserAccessTheSentinel = function () {
        sentinelService.canUserAccessTheSentinel($stateParams.sentinelId, function (response) {
          if (response != null) {
            vm.hasAccess = response;
          }
          else {
            vm.hasAccess = true;
          }
        });
      }
      vm.canUserAccessTheSentinel();
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('shorepowerAlarmController', function (navigationService, sensors, $uibModal, sensorType, mainSupplyAlarms, sentinelService, $stateParams, toastr,
       $state, shorePowerAlarmService, $rootScope) {
      var vm = this;
      navigationService.navigation = {
        backState: 'boat.alarms',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.goBack = function () {
        $rootScope.goBack();
      };
      shorePowerAlarmService.data = mainSupplyAlarms;
      if (sensors.length == 0) {
        var buyNowLink = sensorType.buyNowLink;
        vm.sentinelId = $stateParams.sentinelId;
        $uibModal.open({
          templateUrl: 'app/main/common/error-box-dialog.html',
          controllerAs: 'vm',
          controller: function (buyNowLink) {
            var vm = this;
            vm.buyNowLink = buyNowLink;
          },
          size: 'lg',
          resolve: {
            buyNowLink: function () {
              return buyNowLink;
            }
          }
        }).closed.then(function () {
          $state.go('boat.alarms', { sentinelId: vm.sentinelId });
        });
      }
      vm.sensors = sensors;
      vm.sensors.forEach(function (s) {
        var alarm = mainSupplyAlarms.filter(function (a) {
          return a.sentinelSensorId == s.id;
        });
        if (alarm && alarm.length > 0) {
          s.enabled = alarm[0].enabled;
        } else {
          s.enabled = false;
        }
      });

      vm.updateAlarm = function () {

        sentinelService.updateMainSupplyAlarm($stateParams.sentinelId,
          vm.sensors.map(function (s) {
            return {
              enabled: s.enabled,
              sentinelSensorId: s.id
            }
          }),
          function () {
            toastr.success('Shorepower alarms updated');
            $state.go('boat.alarms', {
              sentinelId: $stateParams.sentinelId
            });
          });
      };
      vm.hasAccess = false;
      vm.canUserAccessTheSentinel = function () {
        sentinelService.canUserAccessTheSentinel($stateParams.sentinelId, function (response) {
          if (response != null) {
            vm.hasAccess = response;
          }
          else {
            vm.hasAccess = true;
          }
        });
      }
      vm.canUserAccessTheSentinel();
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .service('shorePowerAlarmService', function () {
      return {
        data: []
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('shorePowerAlarmHeaderController', function (shorePowerAlarmService, $filter,oemConfig) {
      var vm = this;
      vm.oemConfig = angular.copy(oemConfig);
      if (shorePowerAlarmService.data.length == 0) {
        vm.lastUpdated = 'None';
        return;
      }
      var latest = $filter('orderBy')(shorePowerAlarmService.data.filter(function (a) {
        return a.dateUpdated != null;
      }), 'dateUpdated', true);
      if (latest && latest.length > 0) {
        vm.lastUpdated = latest[0].dateUpdated;
      } else {
        latest = $filter('orderBy')(shorePowerAlarmService.data, 'dateAdded', true);
        vm.lastUpdated = latest[0].dateAdded;
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .service('shockAlarmService', function () {
      return {
        data: {}
      };
    });
})();

(function(){
    'use strict;'
    angular.module('yatch-sentinel.alarms')
    .controller('shockAlarmHeaderController', function(shockAlarmService,oemConfig){
        var vm = this;
        vm.oemConfig = angular.copy(oemConfig);
        vm.lastUpdated = shockAlarmService.data.dateUpdated == null ? 'None': shockAlarmService.data.dateUpdated;
    });
})();
(function() {
  "use strict;";
  angular
    .module("yatch-sentinel.alarms")
    .controller("shockAlarmController", function(
      navigationService,
      sensors,
      shockAlarms,
      sentinelService,
      $stateParams,
      toastr,
      $state,
      shockAlarmService,
      $rootScope,
      $translate
    ) {
      var vm = this;
      navigationService.navigation = {
        backState: "boat.alarms",
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.severity = {
        anchor: {
          Mild: {
            minimum: 1,
            maximum: 3,
            Label: "Mild"
          },
          Moderate: {
            minimum: 3,
            maximum: 6,
            Label: "Moderate"
          },
          Severe: {
            minimum: 6,
            maximum: 8,
            Label: "Severe"
          }
        },
        sea: {
          Mild: {
            minimum: 2,
            maximum: 5,
            Label: "Mild"
          },
          Moderate: {
            minimum: 5,
            maximum: 8,
            Label: "Moderate"
          },
          Severe: {
            minimum: 9,
            maximum: 999,
            Label: "Severe"
          }
        }
      };
      $translate(["Steps.Mild", "Steps.Moderate", "Steps.Severe"])
      .then(function(translations){
        vm.sliderOptions = {
          showTicksValues: true,
          stepsArray: ["Steps.Mild", "Steps.Moderate", "Steps.Severe"],
          translate: function(value) {
            return translations[value];
          }
        };
      });
      vm.sliderOptions = {
        showTicksValues: true,
        stepsArray: ["Steps.Mild", "Steps.Moderate", "Steps.Severe"]
      };
      vm.goBack = function() {
        $rootScope.goBack();
      };

      if (!shockAlarms.mildShockAlarm) {
        shockAlarms.mildShockAlarm = {
          enabled: false,
          alarmValue: angular.toJson({
            minimum: vm.severity.anchor["Mild"].minimum,
            maximum: vm.severity.anchor["Mild"].maximum,
            Label: "Mild"
          })
        };
      }

      if (!shockAlarms.severeShockAlarm) {
        shockAlarms.severeShockAlarm = {
          enabled: false,
          alarmValue: angular.toJson({
            minimum: vm.severity.sea["Mild"].minimum,
            maximum: vm.severity.sea["Mild"].maximum,
            Label: "Mild"
          })
        };
      }

      shockAlarms.mildShockAlarm.alarmValue = angular.fromJson(
        shockAlarms.mildShockAlarm.alarmValue
      );
      shockAlarms.mildShockAlarm.severity =
        "Steps." + shockAlarms.mildShockAlarm.alarmValue.Label;

      shockAlarms.severeShockAlarm.alarmValue = angular.fromJson(
        shockAlarms.severeShockAlarm.alarmValue
      );
      shockAlarms.severeShockAlarm.severity =
      "Steps." + shockAlarms.severeShockAlarm.alarmValue.Label;

      shockAlarmService.data = shockAlarms;
      vm.mildShockAlarm = shockAlarms.mildShockAlarm;
      vm.severeShockAlarm = shockAlarms.severeShockAlarm;
      vm.updateAlarm = function() {
        vm.mildShockAlarm.alarmValue =
          vm.severity.anchor[vm.mildShockAlarm.severity.replace("Steps.","")];
        vm.severeShockAlarm.alarmValue =
          vm.severity.sea[vm.severeShockAlarm.severity.replace("Steps.","")];
        sentinelService.updateShockAlarm(
          $stateParams.sentinelId,
          {
            mildShockAlarm: vm.mildShockAlarm,
            severeShockAlarm: vm.severeShockAlarm
          },
          function() {
            toastr.success("Shock alarms updated");
            $state.go("boat.alarms", {
              sentinelId: $stateParams.sentinelId
            });
          }
        );
      };
      vm.hasAccess = false;
      vm.canUserAccessTheSentinel = function() {
        sentinelService.canUserAccessTheSentinel(
          $stateParams.sentinelId,
          function(response) {
            if (response != null) {
              vm.hasAccess = response;
            } else {
              vm.hasAccess = true;
            }
          }
        );
      };
      vm.canUserAccessTheSentinel();
    });
})();

(function () {
    'use strict;'
    angular.module('yatch-sentinel.alarms')
        .service('safeReturnMapAlarmService', function () {
            return {
                data: {
                    location: {
                        center: {
                            latitude: 0,
                            longitude: 0
                        },
                        zoom: 16
                    },
                    safeReturnAlarm: {
                        
                    }
                }
            };
        })
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('safeReturnAlarmMapController', function (safeReturnMapAlarmService, $scope, $rootScope, $timeout, RecenterMap) {
      var vm = this;
      vm.goBack = function () {
        $rootScope.goBack();
      };
      vm.sentinelLocation = safeReturnMapAlarmService.data.location;
      var recenterMapControl = new RecenterMap(ol.proj.fromLonLat([0, 0]));
      vm.map = new ol.Map({
        controls: ol.control.defaults().extend([recenterMapControl]),
        target: 'map',
        layers: [
          new ol.layer.Tile({
            source: new ol.source.OSM({
              attributions: []
            }),
          }),
          new ol.layer.Tile({
            source: new ol.source.XYZ({
              url: "https://t1.openseamap.org/seamark/{z}/{x}/{y}.png",
            })
          })
        ],
        view: new ol.View({
          center: ol.proj.fromLonLat([0, 0]),
          zoom: 16
        }),
      });
      $timeout(function () {
        if (vm.sentinelLocation && vm.sentinelLocation.map.center && vm.sentinelLocation.map.center) {
          vm.map.removeControl(recenterMapControl);
          recenterMapControl = new RecenterMap(ol.proj.fromLonLat([vm.sentinelLocation.map.center.longitude, vm.sentinelLocation.map.center.latitude]));
          vm.map.addControl(recenterMapControl);

          vm.map.getView().setCenter(ol.proj.fromLonLat([vm.sentinelLocation.map.center.longitude, vm.sentinelLocation.map.center.latitude]));
          vm.iconFeature = new ol.Feature({
            geometry: new ol.geom.Point(ol.proj.fromLonLat([vm.sentinelLocation.map.center.longitude, vm.sentinelLocation.map.center.latitude]))
          });

          var iconStyle = new ol.style.Style({
            image: new ol.style.Icon({
              src: 'assets/images/boat-location.png',
              scale: 1,
            }),
          });

          vm.iconFeature.setStyle(iconStyle);

          var vectorSource = new ol.source.Vector({
            features: [vm.iconFeature],
          });

          var vectorLayer = new ol.layer.Vector({
            source: vectorSource,
          });

          if (vm.safeReturnAlarm && vm.safeReturnAlarm.map && vm.safeReturnAlarm.map.center) {
            vm.circleFeature = new ol.Feature({
              geometry: new ol.geom.Circle(ol.proj.fromLonLat([vm.safeReturnAlarm.map.center.longitude, vm.safeReturnAlarm.map.center.latitude]), 50)
            });
          }
          else if (vm.safeReturnAlarm && vm.safeReturnAlarm.alarmValue && vm.safeReturnAlarm.alarmValue.center) {
            vm.circleFeature = new ol.Feature({
              geometry: new ol.geom.Circle(ol.proj.fromLonLat([vm.safeReturnAlarm.alarmValue.center.longitude, vm.safeReturnAlarm.alarmValue.center.latitude]), vm.safeReturnAlarm.alarmValue.radius)
            });
          }
          else {
            vm.circleFeature = new ol.Feature({
              geometry: new ol.geom.Circle(ol.proj.fromLonLat([vm.sentinelLocation.map.center.longitude, vm.sentinelLocation.map.center.latitude]), 50)
            });
          }

          var circleSource = new ol.source.Vector({
            features: [vm.circleFeature],
          });

          var circleLayer = new ol.layer.Vector({
            source: circleSource,
          });

          vm.map.addLayer(circleLayer);
          vm.map.addLayer(vectorLayer);
          var modify = new ol.interaction.Modify({
            source: circleSource
          });
          vm.map.addInteraction(modify);
          vm.map.addInteraction(new ol.interaction.Snap({ source: circleSource }));
          modify.on('modifyend', function (params) {
            var radius = vm.circleFeature.getGeometry().getRadius();
            var center = ol.proj.toLonLat(vm.circleFeature.getGeometry().getCenter());
            safeReturnMapAlarmService.data.location.markers[1] = {
              coords: {
                latitude: center[1],
                longitude: center[0]
              }
            };
            $timeout(function () {
              if (radius <= 200) {
                safeReturnMapAlarmService.data.location.map.radius = radius;
              }
              else {
                vm.circleFeature.getGeometry().setRadius(200);
                safeReturnMapAlarmService.data.location.map.radius = 200;
              }
            });
          });
        }
      });
      $scope.$watch(function () {
        return safeReturnMapAlarmService.data;
      }, function () {
        vm.sentinelLocation = safeReturnMapAlarmService.data.location;
        vm.safeReturnAlarm = safeReturnMapAlarmService.data.safeReturnAlarm;

        vm.map.removeControl(recenterMapControl);
        recenterMapControl = new RecenterMap(ol.proj.fromLonLat([vm.sentinelLocation.map.center.longitude, vm.sentinelLocation.map.center.latitude]));
        vm.map.addControl(recenterMapControl);

        if (vm.circleFeature) {
          vm.circleFeature.getGeometry().setRadius(safeReturnMapAlarmService.data.location.map.radius);
        }
      }, true);
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('safeReturnAlarmHeaderController', function (safeReturnMapAlarmService, oemConfig) {
      var vm = this;
      vm.oemConfig = angular.copy(oemConfig);
      vm.safeReturnAlarm = safeReturnMapAlarmService.data.safeReturnAlarm;
      if (vm.safeReturnAlarm && vm.safeReturnAlarm.dateUpdated != undefined && vm.safeReturnAlarm.dateUpdated != null) {
        vm.lastUpdated = vm.safeReturnAlarm.dateUpdated == null ? vm.safeReturnAlarm.dateAdded : vm.safeReturnAlarm.dateUpdated;
      } else {
        vm.lastUpdated = 'None';
      }
    });
})();

(function () {
    'use strict;'
    angular.module('yatch-sentinel.alarms')
        .controller('safeReturnAlarmController',
        function (navigationService, location, safeReturnAlarm, alarmTypes, $stateParams, sentinelService, toastr,
            safeReturnMapAlarmService, $state, userContacts, $scope, status, countries, $uibModal, userService) {
            var vm = this;
            vm.boatStatus = status;
            vm.isUpdateCase = false;
            vm.contacts = userContacts;
            vm.unSelectedContacts = [];

            var safeReturnAlarm = angular.copy(safeReturnAlarm);
            navigationService.navigation = {
                backState: 'boat.alarms',
                backStateParams: {
                    sentinelId: $stateParams.sentinelId
                }
            };
            if (location == null) {
                vm.noPositionData = true
            } else {
                vm.noPositionData = false
            }
            $scope.$watch(function () {
                return vm.sentinelLocation.isDaily
            }, function () {
                if (!vm.sentinelLocation.isDaily) {
                    if (vm.sentinelLocation.map.startTime) {
                        vm.sentinelLocation.map.startTime = moment(vm.sentinelLocation.map.startTime).format("DD MMMM[,] YYYY hh:mm:ss a");
                    }
                    else {
                        vm.sentinelLocation.map.startTime = moment().format("DD MMMM[,] YYYY hh:mm:ss a");
                    }
                }
            })
            vm.sliderOptions = {
                floor: 40,
                ceil: 200,
                minLimit: 40,
                maxLimit: 200,
                step: 10,
                translate: function (value) {
                    return value + "m";
                }
            };
            vm.sentinelLocation = {
                map: {
                    center: {
                        latitude: (location && location.latitude) || 0,
                        longitude: (location && location.longitude) || 0
                    },
                    radius: 201,
                    startTime: "",
                    message: "This email was automatically generated by my Yacht Sentinel 6 boat monitoring system as I have not returned in time."
                },
                control: {},
                zoom: 18,
                markers: [{
                    id: (location && location.id) || 0,
                    coords: {
                        latitude: (location && location.latitude) || 0,
                        longitude: (location && location.longitude) || 0
                    },
                    options: {
                        title: 'Boat location',
                        icon: 'assets/images/boat-location.png'
                    },
                    show: true
                }],
                geodesic: true, // optional: defaults to false
                draggable: true, // optional: defaults to false
                clickable: true, // optional: defaults to true
                editable: true, // optional: defaults to false
                visible: true, // optional: defaults to true
                isDaily: true,
                fill: {
                    color: '#08B21F',
                    opacity: 0.5
                },
                stroke: {
                    color: '#08B21F',
                    weight: 2,
                    opacity: 1
                },
                events: {
                    click: function (map, eventName, originalEventArgs) {
                        var e = originalEventArgs[0];
                        var lat = e.latLng.lat(), lon = e.latLng.lng();
                        var marker = {
                            id: Date.now(),
                            coords: {
                                latitude: lat,
                                longitude: lon
                            },
                            options: {
                                title: 'Safe Return location',
                            },
                            radius: vm.sentinelLocation.map.radius,
                            show: true
                        };
                        if (vm.sentinelLocation.markers.length > 0) {
                            vm.sentinelLocation.markers[1] = marker;
                        } else {
                            vm.sentinelLocation.markers.push(marker);
                        }
                        console.log(vm.sentinelLocation.markers);
                        this.$apply();
                    }
                },
                Enabled: (safeReturnAlarm && safeReturnAlarm.Enabled) || false
            };

            vm.safeReturnAlarm = {
                map: {
                    center: {
                        latitude: 0,
                        longitude: 0
                    },
                    radius: 201,
                    startTime: "",
                    message: "This email was automatically generated by my Yacht Sentinel 6 boat monitoring system as I have not returned in time. ",
                    offSet: "",
                    isDaily: false
                },
                Enabled: (safeReturnAlarm && safeReturnAlarm.enabled) || false
            };
            if (safeReturnAlarm == null || !safeReturnAlarm.enabled) {
                vm.safeReturnAlarm.map.center = angular.copy(vm.sentinelLocation.map.center);
                vm.contacts.forEach(function (contact) {
                    contact.isSelected = true;
                });
            }
            else {
                vm.isUpdateCase = true;
                vm.safeReturnAlarm.map = safeReturnAlarm.alarmValue;
                vm.safeReturnAlarm.alarm = safeReturnAlarm;
                vm.sentinelLocation.map.message = safeReturnAlarm.alarmValue.message;
                vm.sentinelLocation.isDaily = safeReturnAlarm.alarmValue.isDaily;
                vm.sentinelLocation.map.startTime = moment(safeReturnAlarm.alarmValue.startTime).format('DD MMMM[,] YYYY hh:mm:ss a')
                vm.sentinelLocation.map.radius = safeReturnAlarm.alarmValue.radius;
                vm.sentinelLocation.Enabled = safeReturnAlarm.enabled;
                vm.sentinelLocation.markers.push({
                    id: safeReturnAlarm.id,
                    coords: {
                        latitude: safeReturnAlarm.alarmValue.center.latitude,
                        longitude: safeReturnAlarm.alarmValue.center.longitude
                    },
                    options: {
                        title: 'Safe Return location',
                    },
                    radius: safeReturnAlarm.alarmValue.radius,
                    show: true
                });
                vm.contacts.forEach(function (contact) {
                    contact.isSelected = false;
                });
                safeReturnAlarm.alarmValue.contacts.forEach(function (contactId) {
                    vm.contacts.forEach(function (contact) {
                        if (contact.id == contactId) {
                            contact.isSelected = true;
                        }
                    });
                });
                vm.unSelectedContacts = vm.contacts.filter(function (contact) {
                    return !contact.isSelected;
                });
            }

            /**
             * Update service so that map can be updated
             */
            safeReturnMapAlarmService.data.location = vm.sentinelLocation;
            safeReturnMapAlarmService.data.safeReturnAlarm = safeReturnAlarm;

            vm.saveSafeReturnAlarm = function () {
                var alarm = {
                    alarmValue: "",
                    enabled: vm.sentinelLocation.Enabled
                };
                var zoneOffSet = moment().zone();
                var offSet = zoneOffSet / 60;
                var selectedContacts = vm.contacts.filter(function (contact) {
                    return contact.isSelected;
                });
                if (selectedContacts.length == 0) {
                    toastr.error('Please Select Atleast 1 Contact First!');
                    return;
                }
                var selectedContactIds = selectedContacts.map(function (selectedContact) {
                    return selectedContact.id;
                });
                var alarmValue = {};
                if (vm.sentinelLocation.markers[1] && vm.sentinelLocation.Enabled) {
                    alarmValue = {
                        offSet: offSet,
                        center: {
                            latitude: vm.sentinelLocation.markers[1].coords.latitude,
                            longitude: vm.sentinelLocation.markers[1].coords.longitude
                        },
                        message: vm.sentinelLocation.map.message,
                        radius: vm.sentinelLocation.map.radius,
                        isDaily: vm.sentinelLocation.isDaily,
                        startTime: moment(vm.sentinelLocation.map.startTime).toISOString(),
                        contacts: selectedContactIds
                    }
                    alarm.alarmValue = angular.toJson(alarmValue);
                }
                if (vm.sentinelLocation.markers[1] == undefined && vm.sentinelLocation.Enabled) {
                    toastr.error('Please Mark Return Destination First!');
                    return;
                } else if ((alarmValue.message == "" || alarmValue.message == undefined) && vm.sentinelLocation.Enabled) {
                    toastr.error('Please Enter SOS Message First!');
                    return;
                } else if ((alarmValue.startTime == "" || alarmValue.startTime == undefined || alarmValue.startTime == "Invalid date") && vm.sentinelLocation.Enabled) {
                    toastr.error('Please Enter Alarm Date/Time First!');
                    return;
                }
                sentinelService.updateSafeReturnAlarm($stateParams.sentinelId, alarm, function () {
                    toastr.success('Alarm updated successfully');
                    $state.go('boat.alarms', {
                        sentinelId: $stateParams.sentinelId
                    });
                });
            };

            vm.resetSafeReturnToCurrentLocation = function () {
                if (safeReturnAlarm == null) {
                    vm.sentinelLocation.markers.splice(1, 1);
                    vm.sentinelLocation.map.center = {
                        latitude: (location && location.latitude) || 0,
                        longitude: (location && location.longitude) || 0
                    }
                    vm.contacts.forEach(function (contact) {
                        contact.isSelected = true;
                    });
                }
                else if (vm.sentinelLocation.markers[1] == undefined) {
                    vm.sentinelLocation.markers.push({
                        id: safeReturnAlarm.id,
                        coords: {
                            latitude: safeReturnAlarm.alarmValue.center.latitude,
                            longitude: safeReturnAlarm.alarmValue.center.longitude
                        },
                        options: {
                            title: 'Safe Return location',
                        },
                        radius: safeReturnAlarm.alarmValue.radius,
                        show: true
                    });
                    vm.sentinelLocation.map.radius = safeReturnAlarm.alarmValue.radius;
                    vm.sentinelLocation.map.message = safeReturnAlarm.alarmValue.message;
                    vm.sentinelLocation.Enabled = safeReturnAlarm.enabled;
                    vm.sentinelLocation.isDaily = safeReturnAlarm.alarmValue.isDaily;
                    vm.sentinelLocation.map.startTime = safeReturnAlarm.alarmValue.startTime;
                    vm.contacts.forEach(function (contact) {
                        contact.isSelected = false;
                    });
                    safeReturnAlarm.alarmValue.contacts.forEach(function (contactId) {
                        vm.contacts.forEach(function (contact) {
                            if (contact.id == contactId) {
                                contact.isSelected = true;
                            }
                        });
                    });
                }
                else if (vm.sentinelLocation.markers[1] != undefined) {
                    vm.sentinelLocation.markers[1].coords.latitude = safeReturnAlarm.alarmValue.center.latitude;
                    vm.sentinelLocation.markers[1].coords.longitude = safeReturnAlarm.alarmValue.center.longitude;
                    vm.sentinelLocation.map.radius = safeReturnAlarm.alarmValue.radius;
                    vm.sentinelLocation.map.message = safeReturnAlarm.alarmValue.message;
                    vm.sentinelLocation.Enabled = !safeReturnAlarm.Enabled;
                    vm.sentinelLocation.isDaily = !safeReturnAlarm.alarmValue.isDaily;
                    vm.sentinelLocation.map.startTime = safeReturnAlarm.alarmValue.startTime;
                    vm.contacts.forEach(function (contact) {
                        contact.isSelected = false;
                    });
                    safeReturnAlarm.alarmValue.contacts.forEach(function (contactId) {
                        vm.contacts.forEach(function (contact) {
                            if (contact.id == contactId) {
                                contact.isSelected = true;
                            }
                        });
                    });
                    vm.sentinelLocation.map.center = {
                        latitude: safeReturnAlarm.alarmValue.center.latitude,
                        longitude: safeReturnAlarm.alarmValue.center.longitude
                    }
                }
            };

            vm.deleteSafeReturnLocation = function () {
                vm.sentinelLocation.markers.splice(1, 1);
                vm.sentinelLocation.map.center = {
                    latitude: (location && location.latitude) || 0,
                    longitude: (location && location.longitude) || 0
                };
                vm.contacts.forEach(function (contact) {
                    contact.isSelected = true;
                });
            };

            vm.hasAccess = false;
            vm.canUserAccessTheSentinel = function () {
                sentinelService.canUserAccessTheSentinel($stateParams.sentinelId, function (response) {
                    if (response != null) {
                        vm.hasAccess = response;
                    } else {
                        vm.hasAccess = true;
                    }
                });
            }
            vm.canUserAccessTheSentinel();

            vm.markSelectedContact = function (contact) {
                contact.isSelected = !contact.isSelected;
                vm.unSelectedContacts = vm.contacts.filter(function (contact) {
                    return !contact.isSelected;
                });
            };

            vm.newContactDialog = function () {
                $uibModal.open({
                    templateUrl: 'app/main/contacts/new-contact-dialog.html',
                    controller: 'newContactDialogController',
                    controllerAs: 'vm',
                    windowClass: 'contact-modal',
                    resolve: {
                        countries: function () {
                            return countries;
                        }
                    }
                }).result.then(function (contact) {
                    contact.isSelected = true;
                    vm.contacts.push(contact);
                });
            };

            vm.existingContactDialog = function () {
                $uibModal.open({
                    templateUrl: 'app/main/alarm/safe-return/existing-contact-dialog.html',
                    controller: 'existingContactDialogController',
                    controllerAs: 'vm',
                    windowClass: 'contact-modal',
                    resolve: {
                        contacts: function () {
                            return angular.copy(vm.unSelectedContacts);
                        }
                    }
                }).result.then(function (newContacts) {
                    vm.contacts.forEach(function (contact) {
                        newContacts.forEach(function (newContact) {
                            if (contact.id == newContact.id) {
                                contact.isSelected = true;
                            }
                        })
                    });
                    vm.unSelectedContacts = vm.contacts.filter(function (contact) {
                        return !contact.isSelected;
                    });
                });
            };

        });

})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('existingContactDialogController', function (userService, toastr, $uibModalInstance, contacts) {
      var vm = this;
      vm.newContacts = contacts;

      vm.saveContact = function () {
        var selectedContacts = vm.newContacts.filter(function (contact) {
          return contact.isSelected;
        });

        $uibModalInstance.close(selectedContacts);
      };

    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .service('positionMapAlarmService', function () {
      return {
        data: {
          location: {
            center: {
              latitude: 0,
              longitude: 0
            },
            zoom: 16
          },
          geoFenceAlarm:{
            
          }
        }
      };
    })
})();

(function () {
  "use strict;";
  angular
    .module("yatch-sentinel.alarms")
    .controller(
      "positionAlarmMapController",
      function (
        positionMapAlarmService,
        $scope,
        $rootScope,
        $timeout,
        RecenterMap
      ) {
        var vm = this;
        vm.goBack = function () {
          $rootScope.goBack();
        };

        vm.maxRadius = 4000;
        vm.minRadius = 200;
        $scope.$on("positionAlarmRange", function (evt, data) {
          if (!data) {
            vm.maxRadius = 200;
            vm.minRadius = 40;
          } else {
            vm.maxRadius = 4000;
            vm.minRadius = 200;
          }
        });
        vm.sentinelLocation = positionMapAlarmService.data.location;

        var recenterMapControl = new RecenterMap(ol.proj.fromLonLat([0, 0]));
        vm.map = new ol.Map({
          controls: ol.control.defaults().extend([recenterMapControl]),
          target: "map",
          layers: [
            new ol.layer.Tile({
              source: new ol.source.OSM({
                attributions: [],
              }),
            }),
            new ol.layer.Tile({
              source: new ol.source.XYZ({
                url: "https://t1.openseamap.org/seamark/{z}/{x}/{y}.png",
              }),
            }),
          ],
          view: new ol.View({
            center: ol.proj.fromLonLat([0, 0]),
            zoom: 16,
          }),
        });

        if (
          vm.sentinelLocation &&
          vm.sentinelLocation.center &&
          vm.sentinelLocation.center
        ) {
          vm.map
            .getView()
            .setCenter(
              ol.proj.fromLonLat([
                vm.sentinelLocation.center.longitude,
                vm.sentinelLocation.center.latitude,
              ])
            );
          vm.map.removeControl(recenterMapControl);
          recenterMapControl = new RecenterMap(
            ol.proj.fromLonLat([
              vm.sentinelLocation.center.longitude,
              vm.sentinelLocation.center.latitude,
            ])
          );
          vm.map.addControl(recenterMapControl);

          vm.iconFeature = new ol.Feature({
            geometry: new ol.geom.Point(
              ol.proj.fromLonLat([
                vm.sentinelLocation.center.longitude,
                vm.sentinelLocation.center.latitude,
              ])
            ),
          });

          var iconStyle = new ol.style.Style({
            image: new ol.style.Icon({
              src: "assets/images/boat-location.png",
              scale: 1,
            }),
          });

          vm.iconFeature.setStyle(iconStyle);

          var vectorSource = new ol.source.Vector({
            features: [vm.iconFeature],
          });

          var vectorLayer = new ol.layer.Vector({
            source: vectorSource,
          });

          vm.map.addLayer(vectorLayer);

          // working on circle

          vm.circleFeature = new ol.Feature({
            geometry: new ol.geom.Circle(ol.proj.fromLonLat([0, 0]), 0),
          });

          var circleSource = new ol.source.Vector({
            features: [vm.circleFeature],
          });
          var circleLayer = new ol.layer.Vector({
            source: circleSource,
          });
          vm.map.addLayer(circleLayer);
          var modify = new ol.interaction.Modify({
            source: circleSource,
          });
          vm.map.addInteraction(modify);
          // vm.map.addInteraction(
          //   new ol.interaction.Snap({ source: circleSource })
          // );
          modify.on("modifyend", function (params) {
            var radius = vm.circleFeature.getGeometry().getRadius();
            var center = ol.proj.toLonLat(
              vm.circleFeature.getGeometry().getCenter()
            );

            if (vm.geoFenceAlarm.alarm == null) {
              positionMapAlarmService.data.geoFenceAlarm.map.center = {
                latitude: center[1],
                longitude: center[0],
              };
              $timeout(function () {
                if (radius <= vm.maxRadius) {
                  if (radius <= vm.minRadius) {
                    vm.geoFenceAlarm.map.radius = vm.minRadius;
                    vm.circleFeature.getGeometry().setRadius(vm.minRadius);
                  } else {
                    vm.geoFenceAlarm.map.radius = radius;
                    vm.circleFeature.getGeometry().setRadius(radius);
                  }
                } else {
                  vm.geoFenceAlarm.map.radius = vm.maxRadius;
                  vm.circleFeature.getGeometry().setRadius(vm.maxRadius);
                }
              });
            } else {
              positionMapAlarmService.data.geoFenceAlarm.alarm.alarmValue.center =
                {
                  latitude: center[1],
                  longitude: center[0],
                };
              $timeout(function () {
                if (radius <= vm.maxRadius) {
                  if (radius <= vm.minRadius) {
                    vm.geoFenceAlarm.alarm.alarmValue.radius = vm.minRadius;
                    vm.circleFeature.getGeometry().setRadius(vm.minRadius);
                  } else {
                    vm.geoFenceAlarm.alarm.alarmValue.radius = radius;
                    vm.circleFeature.getGeometry().setRadius(radius);
                  }
                } else {
                  vm.geoFenceAlarm.alarm.alarmValue.radius = vm.maxRadius;
                  vm.circleFeature.getGeometry().setRadius(vm.maxRadius);
                }
              });
            }
          });
        }
        $scope.$watch(
          function () {
            return positionMapAlarmService.data;
          },
          function () {
            vm.sentinelLocation = positionMapAlarmService.data.location;
            vm.geoFenceAlarm = positionMapAlarmService.data.geoFenceAlarm;

            vm.map.removeControl(recenterMapControl);
            recenterMapControl = new RecenterMap(
              ol.proj.fromLonLat([
                vm.sentinelLocation.center.longitude,
                vm.sentinelLocation.center.latitude,
              ])
            );
            vm.map.addControl(recenterMapControl);

            vm.map
              .getView()
              .setCenter(
                ol.proj.fromLonLat([
                  vm.sentinelLocation.center.longitude,
                  vm.sentinelLocation.center.latitude,
                ])
              );

            vm.iconFeature.setGeometry(
              new ol.geom.Point(
                ol.proj.fromLonLat([
                  vm.sentinelLocation.center.longitude,
                  vm.sentinelLocation.center.latitude,
                ])
              )
            );

            if (vm.geoFenceAlarm.alarm == null) {
              vm.circleFeature.setGeometry(
                new ol.geom.Circle(
                  ol.proj.fromLonLat([
                    vm.geoFenceAlarm.map.center.longitude,
                    vm.geoFenceAlarm.map.center.latitude,
                  ]),
                  vm.geoFenceAlarm.map.radius
                )
              );
            } else {
              vm.circleFeature.setGeometry(
                new ol.geom.Circle(
                  ol.proj.fromLonLat([
                    vm.geoFenceAlarm.alarm.alarmValue.center.longitude,
                    vm.geoFenceAlarm.alarm.alarmValue.center.latitude,
                  ]),
                  vm.geoFenceAlarm.alarm.alarmValue.radius
                )
              );
            }
          },
          true
        );
      }
    );
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('positionAlarmHeaderController', function (positionMapAlarmService, oemConfig) {
      var vm = this;
      vm.oemConfig = angular.copy(oemConfig);
      vm.geoFenceAlarm = positionMapAlarmService.data.geoFenceAlarm;
      if (vm.geoFenceAlarm && vm.geoFenceAlarm.alarm) {
        vm.lastUpdated = vm.geoFenceAlarm.alarm.dateUpdated == null ? vm.geoFenceAlarm.alarm.dateAdded : vm.geoFenceAlarm.alarm.dateUpdated;
      } else {
        vm.lastUpdated = 'None';
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('positionAlarmController',
      function (navigationService, location, geoFenceAlarm, $rootScope,alarmTypes, $stateParams, sentinelService, toastr, positionMapAlarmService, $state) {
        var vm = this;
        var geoFenceAlarmIn=angular.copy(geoFenceAlarm.geoFenceMoveIn);
        geoFenceAlarm = geoFenceAlarm.geoFenceMoveOut;
        navigationService.navigation = {
          backState: 'boat.alarms',
          backStateParams: {
            sentinelId: $stateParams.sentinelId
          }
        };
        if (location == null) {
          vm.noPositionData = true
        } else {
          vm.noPositionData = false
        }
        vm.sliderOptions = {
          floor: 40,
          ceil: 200,
          minLimit: 40,
          maxLimit: 200,
          step: 20,
          translate: function (value) {
            return value + "m";
          }
        };

        /**
         * Get distance from center
         */
        var getDistance = function (p1, p2) {
          var rad = function (x) {
            return x * Math.PI / 180;
          };
          var R = 6378137; // Earth’s mean radius in meter
          var dLat = rad(p2.lat - p1.lat);
          var dLong = rad(p2.lng - p1.lng);
          var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(rad(p1.lat)) * Math.cos(rad(p2.lat)) *
            Math.sin(dLong / 2) * Math.sin(dLong / 2);
          var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
          var d = R * c;
          return d; // returns the distance in meter
        };


        vm.sentinelLocation = {
          center: {
            latitude: (location && location.latitude) || 0,
            longitude: (location && location.longitude) || 0
          },
          zoom: 16,
          marker: {
            id: (location && location.id) || 0,
            coords: {
              latitude: (location && location.latitude) || 0,
              longitude: (location && location.longitude) || 0
            },
            options: {
              title: 'Boat location',
              icon: 'assets/images/boat-location.png'
            },
            show: true
          },
          fill: {
            color: '#00FFFFFF',
            opacity: 0.0
          },
          stroke: {
            color: '#000000',
            weight: 2,
            opacity: 0.5
          }
        };

        vm.geoFenceAlarm = {
          map: {
            center: {
              latitude: vm.sentinelLocation.center.latitude || 0,
              longitude: vm.sentinelLocation.center.longitude || 0
            },
            radius: 40
          },
          geodesic: true, // optional: defaults to false
          draggable: true, // optional: defaults to false
          clickable: true, // optional: defaults to true
          editable: true, // optional: defaults to false
          visible: true, // optional: defaults to true,
          fill: {
            color: '#08B21F',
            opacity: 0.5
          },
          stroke: {
            color: '#08B21F',
            weight: 2,
            opacity: 1
          },
          events: {
            "dragend": function () {
              vm.distance = getDistance({
                lat: vm.sentinelLocation.center.latitude,
                lng: vm.sentinelLocation.center.longitude
              }, {
                  lat: vm.geoFenceAlarm.map.center.latitude,
                  lng: vm.geoFenceAlarm.map.center.longitude
                });
            }
          },
          moveOutEnabled: (geoFenceAlarm && geoFenceAlarm.enabled) || false,
          moveInEnabled: (geoFenceAlarmIn && geoFenceAlarmIn.enabled) || false
        };
        if (geoFenceAlarm == null) {
          vm.geoFenceAlarm.map.center = angular.copy(vm.sentinelLocation.center);
        } else {
          vm.geoFenceAlarm.map = geoFenceAlarm.alarmValue;
          vm.geoFenceAlarm.alarm = geoFenceAlarm;
        }

        /**
         * Update service so that map can be updated
         */
        positionMapAlarmService.data.location = vm.sentinelLocation;
        positionMapAlarmService.data.geoFenceAlarm = vm.geoFenceAlarm;

        vm.distance = getDistance({
          lat: vm.sentinelLocation.center.latitude,
          lng: vm.sentinelLocation.center.longitude
        }, {
            lat: vm.geoFenceAlarm.map.center.latitude,
            lng: vm.geoFenceAlarm.map.center.longitude
          });


        vm.saveGeofenceAlarm = function () {
          var alarm = {
            moveOutAlarm: {
              alarmValue: angular.toJson(vm.geoFenceAlarm.map),
              enabled: vm.geoFenceAlarm.moveOutEnabled
            },
            moveInAlarm: {
              alarmValue: angular.toJson(vm.geoFenceAlarm.map),
              enabled: vm.geoFenceAlarm.moveInEnabled
            }
          };
          sentinelService.updateGeoFenceAlarm($stateParams.sentinelId, alarm, function () {
            toastr.success('Alarm updated successfully');
            $state.go('boat.alarms', {
              sentinelId: $stateParams.sentinelId
            });
          });
        };

        vm.resetGeoFenceToCurrentLocation = function () {
          vm.geoFenceAlarm.map.center = {
            latitude: (location && location.latitude) || 0,
            longitude: (location && location.longitude) || 0
          };
          vm.sentinelLocation.center = {
            latitude: (location && location.latitude) || 0,
            longitude: (location && location.longitude) || 0
          }
          vm.distance = getDistance({
            lat: vm.sentinelLocation.center.latitude,
            lng: vm.sentinelLocation.center.longitude
          }, {
              lat: vm.geoFenceAlarm.map.center.latitude,
              lng: vm.geoFenceAlarm.map.center.longitude
            });
        };
        vm.hasAccess = false;
        vm.canUserAccessTheSentinel = function () {
          sentinelService.canUserAccessTheSentinel($stateParams.sentinelId, function (response) {
            if (response != null) {
              vm.hasAccess = response;
            } else {
              vm.hasAccess = true;
            }
          });
        }
        vm.canUserAccessTheSentinel();
        if (vm.geoFenceAlarm.map.radius > 200) {
          vm.positionAlarmRange = true;
        }
        vm.handleRangeChange = function () {
          $rootScope.$broadcast("positionAlarmRange",vm.positionAlarmRange);
          if (vm.positionAlarmRange) {
            vm.sliderOptions = {
              floor: 200,
              ceil: 4000,
              minLimit: 200,
              maxLimit: 4000,
              step: 20,
              translate: function (value) {
                return value + "m";
              }
            };
            if (vm.geoFenceAlarm.map.radius < 200) {
              vm.geoFenceAlarm.map.radius = 201
            }
          } else {
            vm.sliderOptions = {
              floor: 40,
              ceil: 200,
              minLimit: 40,
              maxLimit: 200,
              step: 20,
              translate: function (value) {
                return value + "m";
              }
            };
            if (vm.geoFenceAlarm.map.radius > 200) {
              vm.geoFenceAlarm.map.radius = 199;
            }
          }
        };
        vm.handleRangeChange();
      });

})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .service('alarmService', function () {
      return {
        data: []
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('nmeaAlarmIndexController', function ($uibModal, sessionService, toastr,
       nmeaAlarmsStatus, $state, alarms, $stateParams, alarmService, navigationService, currentSentinel, $rootScope) {
      var vm = this;
      vm.nmeaAlarmsStatus = nmeaAlarmsStatus;
      var statusType = {
        disArm: 1,
        arm: 2,
        off: 0
      }
      vm.goBack = function () {
        $rootScope.goBack();
      };
      alarmService.data = alarms;
      vm.currentSentinelId = $stateParams.sentinelId;
      vm.currentSentinel = currentSentinel;
      vm.enabled = true;
      // vm.turnedOff = false;
      // if (vm.currentSentinel.status == statusType.disArm) {
      //   vm.isDisArmed = true
      // }
      // else if (vm.currentSentinel.status == statusType.off) {
      //   vm.turnedOff = true;
      // }
      navigationService.navigation = {
        backState: 'boat.home',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.positionAlarm = false;
      vm.showYS6Alarms = function () {
        sessionService.setAlarmSwitch(false);
        $state.go("boat.alarms", {
          sentinelId: $stateParams.sentinelId
        })
      }

      vm.showBilgePumpAlarm = function () {
        toastr.success('Coming Soon!!');
      };

      vm.showErrorBox = function () {
        $uibModal.open({
          templateUrl: 'app/main/alarm/nmea/error-box-dialog.html',
          controllerAs: 'vm',
          controller: function () {
          },
          size: 'lg',
          resolve: {
          }
        }).closed.then(function () {

        });
      }

      vm.goToTimeToEmptyAlarm = function () {
        if (vm.nmeaAlarmsStatus.hasTimeToEmptyData) {
          $state.go("boat.nmea_current_trip_alarm", {
            sentinelId: $stateParams.sentinelId
          });
        }
        else {
          vm.showErrorBox();
        }
      }
      vm.goToSpeedLimitAlarm = function () {
        if (vm.nmeaAlarmsStatus.hasSpeedLimitData) {
          $state.go("boat.nmea_speed_limit_alarm", {
            sentinelId: $stateParams.sentinelId
          });
        }
        else {
          vm.showErrorBox();
        }
      }
      vm.goToPositionAndSpeedAlarm = function () {
        if (vm.nmeaAlarmsStatus.hasPositionAndSpeedData) {
          $state.go("boat.nmea_pos_speed_alarm", {
            sentinelId: $stateParams.sentinelId
          });
        }
        else {
          vm.showErrorBox();
        }
      }

      vm.goToWaterDepthAlarm = function () {
        if (vm.nmeaAlarmsStatus.hasWaterDepthData) {
          $state.go("boat.nmea_water_depth_alarm", {
            sentinelId: $stateParams.sentinelId
          });
        }
        else {
          vm.showErrorBox();
        }
      }

      vm.goToEnginesAlarm = function () {
        if (vm.nmeaAlarmsStatus.hasEnginesData) {
          $state.go("boat.nmea_engine_alarm_list", {
            sentinelId: $stateParams.sentinelId
          });
        }
        else {
          vm.showErrorBox();
        }
      }

      vm.goToFluidLevelsAlarm = function () {
        if (vm.nmeaAlarmsStatus.hasFluidLevelData) {
          $state.go("boat.nmea_fluid_alarm", {
            sentinelId: $stateParams.sentinelId
          });
        }
        else {
          vm.showErrorBox();
        }
      }

      vm.goToPowerAlarm = function () {
        if (vm.nmeaAlarmsStatus.hasPowerData) {
          $state.go("boat.nmea_power_alarm_list", {
            sentinelId: $stateParams.sentinelId
          });
        }
        else {
          vm.showErrorBox();
        }
      }

      vm.goToTemperatureAndHumidityAlarm = function () {
        if (vm.nmeaAlarmsStatus.hasTempAndHumidityData) {
          $state.go("boat.nmea_temp_hum_alarm", {
            sentinelId: $stateParams.sentinelId
          });
        }
        else {
          vm.showErrorBox();
        }
      }

      vm.goToWindSpeedAlarm = function () {
        if (vm.nmeaAlarmsStatus.hasWindSpeedData) {
          $state.go("boat.nmea_wind_speed_alarm", {
            sentinelId: $stateParams.sentinelId
          });
        }
        else {
          vm.showErrorBox();
        }
      }

    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('nmeaAlarmHeaderController', function (alarmService, $filter, moment) {
      var vm = this;
      vm.alarms = alarmService.data;

      var latest = $filter('orderBy')(vm.alarms.filter(function (a) {
        return a.dateUpdated != null
      }), 'dateUpdated', true);
      if (latest && latest.length > 0) {
        vm.lastUpdated = $filter('utcDate')(latest[0].dateUpdated);
      } else {
        vm.lastUpdated = 'None'
      }

      latest = $filter('orderBy')(vm.alarms, 'dateAdded', true);
      if (latest && latest.length > 0) {
        vm.lastAdded = $filter('utcDate')(latest[0].dateAdded);
      } else {
        vm.lastAdded = 'None';
      }

      if (vm.lastUpdated != null) {
        if (moment(vm.lastUpdated) > moment(vm.lastAdded)) {
          vm.timeStamp = vm.lastUpdated;
        } else {
          vm.timeStamp = vm.lastAdded;
        }
      } else {
        vm.timeStamp = vm.lastAdded;
      }

    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('motionDetectorAlarmController',
    function (navigationService, sensors, motionDetectorAlarms, $uibModal, sensorType, sentinelService, $stateParams, toastr, $state, motionDetectionAlarmService,$rootScope) {
      var vm = this;
      navigationService.navigation = {
        backState: 'boat.alarms',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.goBack = function () {
        $rootScope.goBack();
      };
      if (sensors.length == 0) {
        var buyNowLink = sensorType.buyNowLink;
        vm.sentinelId = $stateParams.sentinelId;
        $uibModal.open({
          templateUrl: 'app/main/common/error-box-dialog.html',
          controllerAs: 'vm',
          controller: function (buyNowLink) {
            var vm = this;
            vm.buyNowLink = buyNowLink;
          },
          size: 'lg',
          resolve: {
            buyNowLink: function () {
              return buyNowLink;
            }
          }
        }).closed.then(function () {
          $state.go('boat.alarms', { sentinelId: vm.sentinelId });
        });
      }
      motionDetectionAlarmService.data = motionDetectorAlarms;
      vm.sensors = sensors;
      vm.sensors.forEach(function (s) {
        var alarm = motionDetectorAlarms.filter(function (a) {
          return a.sentinelSensorId == s.id;
        });
        if (alarm && alarm.length > 0) {
          s.enabled = alarm[0].enabled;
        } else {
          s.enabled = false;
        }
      });

      vm.updateAlarm = function () {

        sentinelService.updateMotionDetectorAlarm($stateParams.sentinelId,
          vm.sensors.map(function (s) {
            return {
              enabled: s.enabled,
              sentinelSensorId: s.id
            }
          }),
          function () {
            toastr.success('Motion detector alarms updated');
            $state.go('boat.alarms', {
              sentinelId: $stateParams.sentinelId
            });
          });
      };
      vm.hasAccess = false;
      vm.canUserAccessTheSentinel = function () {
        sentinelService.canUserAccessTheSentinel($stateParams.sentinelId, function (response) {
          if (response != null) {
            vm.hasAccess = response;
          }
          else {
            vm.hasAccess = true;
          }
        });
      }
      vm.canUserAccessTheSentinel();
    });
})();

(function(){
    'use strict;'
    angular.module('yatch-sentinel.alarms')
    .service('motionDetectionAlarmService', function(){
        return {
            data: []
        }
    });
})();
(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('motionDetectionAlarmHeaderController', function (motionDetectionAlarmService, $filter, oemConfig) {
        var vm = this;
        vm.oemConfig = angular.copy(oemConfig);
        if(motionDetectionAlarmService.data.length == 0){
          vm.lastUpdated = 'None';
          return;
      }
      var latest = $filter('orderBy')(motionDetectionAlarmService.data.filter(function (a) {
        return a.dateUpdated != null;
      }), 'dateUpdated', true);
      if (latest && latest.length > 0) {
        vm.lastUpdated = latest[0].dateUpdated;
      } else {
        var latest = $filter('orderBy')(motionDetectionAlarmService.data, 'dateAdded', true);
        vm.lastUpdated = latest[0].dateAdded;
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('itemSecurityHeaderController', function (itemSecurityAlarmService, $filter, oemConfig) {
      var vm = this;
      vm.oemConfig =  angular.copy(oemConfig);
      if(itemSecurityAlarmService.data && itemSecurityAlarmService.data.length >0){
        var filtered = $filter('orderBy')(itemSecurityAlarmService.data,'dateUpdated', true)[0];
        vm.lastUpdated = filtered.dateUpdated;
      }
      else{
        vm.lastUpdated = 'None';
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('itemSecurityAlarmController',
    function (navigationService, sensors, sensorType,itemSecurityAlarms, $stateParams, sentinelService, $uibModal, toastr, $state, itemSecurityAlarmService, 
      $translate,$translatePartialLoader, $rootScope) {
      var vm = this;
      $translatePartialLoader.addPart('app/main/alarm/item-security');
      $translate.refresh();
      vm.sensors = sensors;
      navigationService.navigation = {
        backState: 'boat.alarms',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.goBack = function () {
        $rootScope.goBack();
      };
      itemSecurityAlarmService.data = itemSecurityAlarms;
      vm.sliderOptions = {
        showTicksValues: true,
        stepsArray: []
      };
      $translate(['Steps.Near', 'Steps.Medium','Steps.Far'])
      .then(function(translations){
        vm.sliderOptions = {
          showTicksValues: true,
          stepsArray: ['Steps.Near', 'Steps.Medium', 'Steps.Far'],
          translate: function(value){
            return translations[value];
          }
        };
      });
      if (sensors.length == 0) {
        var buyNowLink = sensorType.buyNowLink;
        vm.sentinelId = $stateParams.sentinelId;
        $uibModal.open({
          templateUrl: 'app/main/common/error-box-dialog.html',
          controllerAs: 'vm',
          controller: function (buyNowLink) {
            var vm = this;
            vm.buyNowLink = buyNowLink;
          },
          size: 'lg',
          resolve: {
            buyNowLink: function () {
              return buyNowLink;
            }
          }
        }).closed.then(function () {
          $state.go('boat.alarms', { sentinelId: vm.sentinelId });
        });
      }
      vm.sensors.forEach(function (s) {
        var alarm = itemSecurityAlarms.filter(function (a) {
          return a.sentinelSensorId == s.id;
        });
        /*vm.itemSecurityAlarm = {
          alarmValue: (itemSecurityAlarm && itemSecurityAlarm.alarmValue) || 'Near',
          enabled: (itemSecurityAlarm && itemSecurityAlarm.enabled) || false
        };*/
        if (alarm && alarm.length > 0) {
          var alarmObject = alarm[0];
          s.enabled = alarmObject.enabled;
          if (alarmObject.alarmValue != null && alarmObject.alarmValue != undefined) {
            var alarmValue = angular.fromJson(alarmObject.alarmValue);
            if (alarmValue.minimum == 20 && alarmValue.maximum == 50) {
              s.alarmValue = 'Steps.Near'
            } else if (alarmValue.minimum == 51 && alarmValue.maximum == 100) {
              s.alarmValue = 'Steps.Medium'
            } else if (alarmValue.minimum == 101 && alarmValue.maximum == 200) {
              s.alarmValue = 'Steps.Far'
            }
          }
        } else {
          s.enabled = false;
          s.alarmValue = 'Steps.Near'
        }
      });

      vm.saveItemSecurityAlarm = function () {
        sentinelService.updateBeaconAlarm($stateParams.sentinelId, vm.sensors.map(function (s) {
          return {
            enabled: s.enabled,
            sentinelSensorId: s.id,
            alarmValue: s.alarmValue.replace("Steps.","")
          }
        }), function () {
          toastr.success('Item security alarm updated');
          $state.go('boat.alarms', {
            sentinelId: $stateParams.sentinelId
          });
        });
      };
      vm.hasAccess = false;
      vm.canUserAccessTheSentinel = function () {
        sentinelService.canUserAccessTheSentinel($stateParams.sentinelId, function (response) {
          if (response != null) {
            vm.hasAccess = response;
          } else {
            vm.hasAccess = true;
          }
        });
      }
      vm.canUserAccessTheSentinel();
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .service('itemSecurityAlarmService',function () {
      return {
        data: {}
      };
    });
})();

(function () {
    'use strict;'
    angular
        .module('yatch-sentinel.alarms')
        .service('highwaterAlarmHeaderService', function () {
            return {
                data: {}
            };
        })
        .controller('highWaterAlarmHeaderController', function (highwaterAlarmHeaderService, $filter, oemConfig) {
            var vm = this;
            vm.oemConfig = angular.copy(oemConfig);
            if(highwaterAlarmHeaderService.data && highwaterAlarmHeaderService.data.length >0){
                var filterred = $filter("orderBy")(highwaterAlarmHeaderService.data, 'dateUpdated', true)[0];
                vm.lastUpdated = filterred.dateUpdated;
            }
            else{
                vm.lastUpdated = 'None';
            }
        });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('highWaterAlarmController', function (navigationService, sensors, $uibModal, highWaterAlarms, sentinelService, $stateParams, toastr, $state, 
      sensorType,highwaterAlarmHeaderService, $rootScope) {
      var vm = this;
      highwaterAlarmHeaderService.data = highWaterAlarms;
      navigationService.navigation = {
        backState: 'boat.alarms',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.goBack = function () {
        $rootScope.goBack();
      };
      if (sensors.length == 0) {
        var buyNowLink = sensorType.buyNowLink;
        vm.sentinelId = $stateParams.sentinelId;
        $uibModal.open({
          templateUrl: 'app/main/common/error-box-dialog.html',
          controllerAs: 'vm',
          controller: function (buyNowLink) {
            var vm = this;
            vm.buyNowLink = buyNowLink;
          },
          size: 'lg',
          resolve: {
            buyNowLink: function () {
              return buyNowLink;
            }
          }
        }).closed.then(function () {
          $state.go('boat.alarms', { sentinelId: vm.sentinelId });
        });
      }
      vm.sensors = sensors;
      vm.sensors.forEach(function (s) {
        var alarm = highWaterAlarms.filter(function (a) {
          return a.sentinelSensorId == s.id;
        });
        if (alarm && alarm.length > 0) {
          s.enabled = alarm[0].enabled;
        } else {
          s.enabled = false;
        }
      });

      vm.updateAlarm = function () {

        sentinelService.updateBilgeAlarms($stateParams.sentinelId,
          vm.sensors.map(function (s) {
            return {
              enabled: s.enabled,
              sentinelSensorId: s.id
            }
          }),
          function () {
            toastr.success('High water alarm updated.');
            $state.go('boat.alarms', {
              sentinelId: $stateParams.sentinelId
            });
          });
      };
      vm.hasAccess = false;
      vm.canUserAccessTheSentinel = function () {
        sentinelService.canUserAccessTheSentinel($stateParams.sentinelId, function (response) {
          if (response != null) {
            vm.hasAccess = response;
          }
          else {
            vm.hasAccess = true;
          }
        });
      }
      vm.canUserAccessTheSentinel();
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .service('doorAlarmService', function () {
      return {
        data: {}
      };
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('doorAlarmHeaderController', function (doorAlarmService, $filter, oemConfig) {
      var vm = this;
      vm.oemConfig = angular.copy(oemConfig);

      if (doorAlarmService.data && doorAlarmService.data.length > 0) {
        var filtered = $filter('orderBy')(doorAlarmService.data,'dateUpdated', true)[0];
        vm.lastUpdated = filtered.dateUpdated;
      } else {
        vm.lastUpdated = 'None';
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('doorAlarmController',
    function (sensors, doorAlarms, sensorType,sentinelService, $stateParams, toastr, $state, doorAlarmService, $uibModal, navigationService,$rootScope) {
      var vm = this;
      vm.sensors = sensors;
      if (vm.sensors.length == 0) {
        var buyNowLink = sensorType.buyNowLink;
        vm.sentinelId = $stateParams.sentinelId;
        $uibModal.open({
          templateUrl: 'app/main/common/error-box-dialog.html',
          controllerAs: 'vm',
          controller: function (buyNowLink) {
            var vm = this;
            vm.buyNowLink = buyNowLink;
          },
          size: 'lg',
          resolve: {
            buyNowLink: function () {
              return buyNowLink;
            }
          }
        }).closed.then(function () {
          $state.go('boat.alarms', { sentinelId: vm.sentinelId });
        });
      }
      vm.sensors.forEach(function (s) {
        var alarm = doorAlarms.filter(function (a) {
          return a.sentinelSensorId == s.id;
        });
        if (alarm && alarm.length > 0) {
          s.enabled = alarm[0].enabled;
        } else {
          s.enabled = false;
        }
      });
      navigationService.navigation = {
        backState: 'boat.alarms',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.goBack = function () {
        $rootScope.goBack();
      };
      if (doorAlarms != null) {
        vm.enableDoorAlarm = doorAlarms.enabled;
        doorAlarmService.data = doorAlarms;
      } else {
        vm.enableDoorAlarm = false;
      }
      vm.updateAlarm = function () {

        sentinelService.updateDoorAlarm($stateParams.sentinelId, vm.sensors.map(function (s) {
          return {
            enabled: s.enabled,
            sentinelSensorId: s.id
          }
        }),
          function () {
            toastr.success('Door alarms updated');
            $state.go('boat.alarms', {
              sentinelId: $stateParams.sentinelId
            });
          });
      };
      vm.hasAccess = false;
      vm.canUserAccessTheSentinel = function () {
        sentinelService.canUserAccessTheSentinel($stateParams.sentinelId, function (response) {
          if (response != null) {
            vm.hasAccess = response;
          }
          else {
            vm.hasAccess = true;
          }
        });
      }
      vm.canUserAccessTheSentinel();

    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .service('batteryAlarmService', function () {
      return {
        data: []
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('batteryAlarmHeaderController', function (batteryAlarmService, $filter, moment, oemConfig) {
      var vm = this;
      vm.oemConfig = oemConfig;
      if (batteryAlarmService.data.boatBatteryAlarm && batteryAlarmService.data.sentinelBatteryAlarm) {
        var sentinelBatteryLatest = batteryAlarmService.data.sentinelBatteryAlarm.dateUpdated == null ? batteryAlarmService.data.sentinelBatteryAlarm.dateAdded : batteryAlarmService.data.sentinelBatteryAlarm.dateUpdated;
        var boatBatteryLatest = batteryAlarmService.data.boatBatteryAlarm.dateUpdated == null ? batteryAlarmService.data.boatBatteryAlarm.dateAdded : batteryAlarmService.data.boatBatteryAlarm.dateUpdated;
        if (moment(sentinelBatteryLatest) > moment(boatBatteryLatest)) {
          vm.lastUpdated = sentinelBatteryLatest
        } else {
          vm.lastUpdated = boatBatteryLatest;
        }
      } else if (batteryAlarmService.data.boatBatteryAlarm) {
        vm.lastUpdated = batteryAlarmService.data.boatBatteryAlarm.dateUpdated == null ? batteryAlarmService.data.boatBatteryAlarm.dateAdded : batteryAlarmService.data.boatBatteryAlarm.dateUpdated;

      } else if (batteryAlarmService.data.sentinelBatteryAlarm) {
        vm.lastUpdated = batteryAlarmService.data.sentinelBatteryAlarm.dateUpdated == null ? batteryAlarmService.data.sentinelBatteryAlarm.dateAdded : batteryAlarmService.data.sentinelBatteryAlarm.dateUpdated;

      } else {
        vm.lastUpdated = 'None';
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('batteryAlarmController', function (navigationService, voltageSensors, batteryAlarms, sentinelService, toastr, $stateParams, $state, batteryAlarmService, $rootScope, oemConfig) {
      var vm = this;
      vm.oemConfig = angular.copy(oemConfig);
      navigationService.navigation = {
        backState: 'boat.alarms',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.goBack = function () {
        $rootScope.goBack();
      };
      vm.voltageSensors = voltageSensors;
      vm.radius = 100;
      vm.radioModel = 12;
      batteryAlarmService.data = batteryAlarms;
      vm.sentinelBatteryAlarm = {
        options: {
          floor: 12,
          ceil: 15,
          step: 0.1,
          precision: 2,
          translate: function (value) {
            return value + "v";
          }
        },
        alarm: {
          enabled: false,
          alarmValue: {
            triggerValue: 3.8
          }
        },
        battery: false

      };
      vm.boatBatteryAlarm = {
        options: {
          floor: 12,
          ceil: 15,
          step: 0.1,
          precision: 2,
          translate: function (value) {
            return value + "v";
          }
        },
        alarm: {
          enabled: false,
          alarmValue: {
            triggerValue: 12.1,
            battery: 12
          }

        },
        battery: false
      }
      var voltageBatteryAlarmObj = {
        options: {
          floor: 12,
          ceil: 15,
          step: 0.1,
          precision: 2,
          translate: function (value) {
            return value + "v";
          }
        },
        alarm: {
          enabled: false,
          alarmValue: {
            triggerValue: 12.1,
            battery: 12
          }
        },
        battery: false,
        enabled: false
      }

      if (batteryAlarms.sentinelBatteryAlarm != null) {
        vm.sentinelBatteryAlarm.alarm = batteryAlarms.sentinelBatteryAlarm;
        vm.sentinelBatteryAlarm.alarm.alarmValue.triggerValue = 3.8;
      }


      if (batteryAlarms.boatBatteryAlarm != null) {
        vm.boatBatteryAlarm.alarm = batteryAlarms.boatBatteryAlarm;
        if (vm.boatBatteryAlarm.alarm.alarmValue.battery == 24) {
          vm.radioModel = 24;
          vm.boatBatteryAlarm.options.floor = 22;
          vm.boatBatteryAlarm.options.ceil = 30;
          vm.boatBatteryAlarm.battery = true;
        }
        else if (vm.boatBatteryAlarm.alarm.alarmValue.battery == 36) {
          vm.radioModel = 36;
          vm.boatBatteryAlarm.options.floor = 34;
          vm.boatBatteryAlarm.options.ceil = 40;
          vm.boatBatteryAlarm.battery = true;
        }
      }
      vm.voltageSensors.forEach(function (s) {
        if (!batteryAlarms.voltageBatteryAlarms) return;
        var alarm = batteryAlarms.voltageBatteryAlarms.filter(function (a) {
          return a.sentinelSensorId == s.id;
        });
        if (alarm && alarm.length > 0) {
          var alarmObject = alarm[0];
          alarmObject.alarmValue = angular.fromJson(alarmObject.alarmValue);
          var newVoltageBatteryAlarmObj = angular.copy(voltageBatteryAlarmObj);
          newVoltageBatteryAlarmObj.alarm = alarmObject;
          if (newVoltageBatteryAlarmObj.alarm.alarmValue.battery == 24) {
            newVoltageBatteryAlarmObj.options.floor = 22;
            newVoltageBatteryAlarmObj.options.ceil = 30;
            newVoltageBatteryAlarmObj.battery = true;
          }
          s.voltageAlarm = angular.copy(newVoltageBatteryAlarmObj);
          s.voltageAlarm.enabled = newVoltageBatteryAlarmObj.alarm.enabled;
          s.voltageAlarm.sentinelSensorId = s.id;
        } else {
          s.voltageAlarm = angular.copy(voltageBatteryAlarmObj);
          s.voltageAlarm.sentinelSensorId = s.id;
        }
      });

      vm.handleSentinelBatteryChange = function () {
        // false means 12 volts
        if (vm.sentinelBatteryAlarm.battery == false) {
          vm.set12VSentinelBatteryOption();
        } else {
          vm.set24VSentinelBatteryOption();
        }
      };
      vm.set12VSentinelBatteryOption = function () {
        vm.sentinelBatteryAlarm.alarm.alarmValue.triggerValue = 3.8;
        vm.sentinelBatteryAlarm.options.floor = 12;
        vm.sentinelBatteryAlarm.options.ceil = 15;
      };

      vm.set24VSentinelBatteryOption = function () {
        // vm.sentinelBatteryAlarm.alarm.alarmValue.battery = 24;
        // vm.sentinelBatteryAlarm.alarm.alarmValue.triggerValue = 24.1;
        // vm.sentinelBatteryAlarm.options.floor = 24;
        // vm.sentinelBatteryAlarm.options.ceil = 30;
      };

      vm.handleBoatBatteryChange = function () {
        // false means 12 volts
        if(vm.oemConfig.ys6Alarms.battery.batteryOptions() == 2){
          if (vm.boatBatteryAlarm.battery == false) {
            vm.set12VBoatBatteryOption();
          } else {
            vm.set24VBoatBatteryOption();
          }
        }
        else if(vm.oemConfig.ys6Alarms.battery.batteryOptions() == 3){
          if (vm.radioModel == 12) {
            vm.set12VBoatBatteryOption();
          } else if (vm.radioModel == 24) {
            vm.set24VBoatBatteryOption();
          } else {
            vm.set36VBoatBatteryOption();
          }
        }

      };
      vm.handleVoltageBatteryChange = function (voltageBatteryAlarm) {
        // false means 12 volts
        if (voltageBatteryAlarm.battery == false) {
          vm.set12VVoltageBatteryOption(voltageBatteryAlarm);
        } else {
          vm.set24VVoltageBatteryOption(voltageBatteryAlarm);
        }
      };
      vm.set12VBoatBatteryOption = function () {
        vm.boatBatteryAlarm.alarm.alarmValue.battery = 12;
        vm.boatBatteryAlarm.alarm.alarmValue.triggerValue = 12.1;
        vm.boatBatteryAlarm.options.floor = 12;
        vm.boatBatteryAlarm.options.ceil = 15;
      };

      vm.set24VBoatBatteryOption = function () {
        vm.boatBatteryAlarm.alarm.alarmValue.battery = 24;
        vm.boatBatteryAlarm.alarm.alarmValue.triggerValue = 22.1;
        vm.boatBatteryAlarm.options.floor = 22;
        vm.boatBatteryAlarm.options.ceil = 30;
      };

      vm.set36VBoatBatteryOption = function () {
        vm.boatBatteryAlarm.alarm.alarmValue.battery = 36;
        vm.boatBatteryAlarm.alarm.alarmValue.triggerValue = 34.1;
        vm.boatBatteryAlarm.options.floor = 34;
        vm.boatBatteryAlarm.options.ceil = 40;
      };


      vm.set12VVoltageBatteryOption = function (voltageBatteryAlarmToUpdate) {
        voltageBatteryAlarmToUpdate.alarm.alarmValue.battery = 12;
        voltageBatteryAlarmToUpdate.alarm.alarmValue.triggerValue = 12.1;
        voltageBatteryAlarmToUpdate.options.floor = 12;
        voltageBatteryAlarmToUpdate.options.ceil = 15;
      };

      vm.set24VVoltageBatteryOption = function (voltageAlarmToUpdate) {
        voltageAlarmToUpdate.alarm.alarmValue.battery = 24;
        voltageAlarmToUpdate.alarm.alarmValue.triggerValue = 22.1;
        voltageAlarmToUpdate.options.floor = 22;
        voltageAlarmToUpdate.options.ceil = 30;
      };
      vm.updateAlarms = function () {
        var voltageAlarms = vm.voltageSensors.map(function (element) {
          return element.voltageAlarm;
        });
        sentinelService.updateBatteryAlarm($stateParams.sentinelId, {
          boatBatteryAlarm: angular.copy(vm.boatBatteryAlarm.alarm),
          sentinelBatteryAlarm: angular.copy(vm.sentinelBatteryAlarm.alarm),
          voltageBatteryAlarms: angular.copy(voltageAlarms)
        }, function () {
          toastr.success('Battery alarm updated');
          $state.go('boat.alarms', {
            sentinelId: $stateParams.sentinelId
          });
        });
      }
      vm.hasAccess = false;
      vm.canUserAccessTheSentinel = function () {
        sentinelService.canUserAccessTheSentinel($stateParams.sentinelId, function (response) {
          if (response != null) {
            vm.hasAccess = response;
          } else {
            vm.hasAccess = true;
          }
        });
      }
      vm.canUserAccessTheSentinel();
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.cameras', [
    'yatch-sentinel.services',
    'angular-timeline',
    'angular-scroll-animate',
    'flow'
  ]).config(function ($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider
      .state('boat.cameras', {
        url: '/:sentinelId/cameras',
        views: {
          'header@boat': {
            templateUrl: 'app/main/cameras/index/header.html',
            controller: function(oemConfig){
              var vm = this;
              vm.oemConfig = angular.copy(oemConfig);
            },
            controllerAs: 'vm'
          },
          'content@boat': {
            templateUrl: 'app/main/cameras/index/cameras.html',
            controller: 'camerasController',
            controllerAs: 'vm',
            resolve: {
              userSentinelCameras: function (cameraService, $stateParams) {
                return cameraService.getAllCamerasByUserSentinelId($stateParams.sentinelId);
              },
              userSentinelTuyaCameras: function (tuyaCameraService, $stateParams) {
                return tuyaCameraService.allUserSentinelDevices(
                  $stateParams.sentinelId
                );
              }
            }
          }
        },
        headerClass: 'half',
        mobileHeader: {
          visible: true,
          title: 'Header.Cameras'
        },
        data: {
          pageTitle: 'Cameras'
        }
      })
      .state('boat.camera_details', {
        url: '/:sentinelId/cameras/:cameraId/details',
        views: {
          'header@boat': {
            templateUrl: 'app/main/cameras/details/header.html',
            controller: 'cameraHeaderController',
            controllerAs: 'vm',
            resolve: {
              camera: function (cameraService, $stateParams) {
                return cameraService.getCamera($stateParams.cameraId);
              }
            }
          },
          'content@boat': {
            templateUrl: 'app/main/cameras/details/cameras.details.controller.html',
            controller: 'cameraDetailsController',
            controllerAs: 'vm',
            resolve: {
              sharedUserPermissions: function (userService, $stateParams) {
                return userService.getSharedUserPermissions($stateParams.sentinelId);
              },
              userSentinelCameraEvents: function (cameraService, $stateParams) {
                return cameraService.userSentinelCameraEvents($stateParams.sentinelId, $stateParams.cameraId, 1, 10);
              },
              userSentinelCamera: function (cameraService, $stateParams) {
                return cameraService.getUserSentinelCamera($stateParams.cameraId);
              }
            }
          }
        },
        headerClass: 'half blank',
        mobileHeader: {
          visible: true,
          title: 'Header.CameraDetails'
        },
        data: {
          pageTitle: 'Cameras Details'
        }
      })
      .state('boat.camera_settings', {
        url: '/:sentinelId/cameras/:cameraId/settings',
        views: {
          'header@boat': {
            templateUrl: 'app/main/cameras/setting/header.html'
          },
          'content@boat': {
            templateUrl: 'app/main/cameras/setting/cameras.settings.controller.html',
            controller: 'cameraSettingsController',
            controllerAs: 'vm',
            resolve: {
              camera: function (cameraService, $stateParams) {
                return cameraService.getCamera($stateParams.cameraId);
              },
              cameraFirmwareStatus: function (cameraService, $stateParams) {
                return cameraService.getCameraFirmwareStatus($stateParams.cameraId);
              },
              cameraMode: function (cameraService, $stateParams) {
                return cameraService.getCameraMode($stateParams.cameraId);
              },
              userSentinelCamera: function (cameraService, $stateParams) {
                return cameraService.getUserSentinelCamera($stateParams.cameraId);
              },
              cameraStatus: function(cameraService, $stateParams){
                return cameraService.getCameraStatus($stateParams.cameraId);
              },
              cameraWifiStatus: function(cameraService, $stateParams){
                return cameraService.getCameraWifiStatus($stateParams.cameraId);
              },
              cameraSimStatus: function(cameraService, $stateParams){
                return cameraService.getCameraSimStatus($stateParams.cameraId);
              }
            }
          }
        },
        headerClass: 'half blank',
        mobileHeader: {
          visible: true,
          title: 'Header.CameraSettings'
        },
        data: {
          pageTitle: 'Cameras Settings'
        }
      }) .state("boat.tuyaCamera_details", {
        url: "/:sentinelId/tuyacameras/:cameraId/details?tuyaDeviceId",
        views: {
          "header@boat": {
            templateUrl: "app/main/cameras/tuyaDetails/header.html",
            controller: "tuyaCameraHeaderController",
            controllerAs: "vm",
            resolve: {
              cameraName: function (tuyaCameraService, $stateParams) {
                return tuyaCameraService.getCameraName($stateParams.cameraId);
            },
           },
          },
          "content@boat": {
            templateUrl:
              "app/main/cameras/tuyaDetails/tuyaCameras.details.controller.html",
            controller: "tuyaCameraDetailsController",
            controllerAs: "vm",
            resolve : {
              settings: function (tuyaCameraService, $stateParams) {
                return tuyaCameraService.getSettings($stateParams.cameraId);
              },
              events: function(tuyaCameraService, $stateParams){
                return tuyaCameraService.getCameraEvents($stateParams.tuyaDeviceId, $stateParams.sentinelId, 1);
              }
            }
          },
        },
        headerClass: "half blank",
        mobileHeader: {
          visible: true,
          title: "Header.CameraDetails",
        },
        data: {
          pageTitle: "Yacht Sentinel | Camera Details",
        },
      })
      .state("boat.tuyaCamera_setting", {
        url: "/:sentinelId/tuyaCamera/:cameraId/settings",
        views: {
          "header@boat": {
            templateUrl: "app/main/cameras/tuyaSettings/header.html",
            controller: function (oemConfig) {
              var vm = this;
              vm.oemConfig = angular.copy(oemConfig);
            },
            controllerAs: "vm",
          },
          "content@boat": {
            templateUrl:
              "app/main/cameras/tuyaSettings/tuyaCameras.settings.controller.html",
            controller: "tuyaCameraSettingsController",
            controllerAs: "vm",
            resolve: {
               settings: function (tuyaCameraService, $stateParams) {
                 return tuyaCameraService.getSettings($stateParams.cameraId);
             },
            },
          },
        },
        headerClass: "half blank",
        mobileHeader: {
          visible: true,
          title: "Header.CameraSettings",
        },
        data: {
          pageTitle: "Yacht Sentinel | Camera Settings",
        },
      });
    $translatePartialLoaderProvider.addPart('app/main/cameras/index');
    $translatePartialLoaderProvider.addPart('app/main/cameras/details');
    $translatePartialLoaderProvider.addPart('app/main/cameras/setting');
  });
})();

(function () {
  "use strict;";
  angular
    .module("yatch-sentinel.cameras")
    .controller(
      "tuyaCameraSettingsController",
      function (
        $translate,
        $translatePartialLoader,
        tuyaCameraService,
        $rootScope,
        navigationService,
        $state,
        $stateParams,
        toastr,
        settings
      ) {
        var vm = this;
        vm.goBack = function () {
          $rootScope.goBack();
        };
        navigationService.navigation = {
          backState: "boat.tuyaCamera_details",
          backStateParams: {
            sentinelId: $stateParams.sentinelId,
            cameraId: $stateParams.cameraId
          },
        };

        //todo: Settings variables
        vm.tuyaCameraSettings = settings;

        vm.cameraName = vm.tuyaCameraSettings.cameraName;
        vm.cameraMode=vm.tuyaCameraSettings.isArmed?"Armed":"Disarmed";
        vm.userSentinelId = $stateParams.sentinelId;
        vm.nightVision = vm.tuyaCameraSettings.nightVision;
        vm.isNightVisionSupported = vm.tuyaCameraSettings.isNightVisionSupport;

        vm.armedMode = vm.tuyaCameraSettings.isArmed;
        vm.isArmedModeSupported = vm.tuyaCameraSettings.isArmedSupport;
        //todo: Settings variables

        vm.showConfirm = function () {
          // if (userSentinelCamera.isLiveAccount) {
          $translate(["Camera_delete_confirmation"]).then(function (
            translations
          ) {
            var v = translations["Camera_delete_confirmation"];
            if (confirm(v)) {
              vm.removeCamera();
            }
            return v;
          });
          //  } else {
          //    toastr.success("This feature is only Available to Live Accounts!");
          //   return;
          //  }
        };

        vm.removeCamera = function () {
          tuyaCameraService
            .deleteCamera($stateParams.cameraId, vm.userSentinelId)
            .then(function () {
              $translate(["CameraDeletionScheduled"]).then(function (
                translations
              ) {
                var v = translations["CameraDeletionScheduled"];
                toastr.success(v);
                $state.go("boat.cameras", {
                  sentinelId: $stateParams.sentinelId,
                });
              });
            });
        };

        vm.nightVisionFunc = function () {
          tuyaCameraService
            .nightVision($stateParams.cameraId, !vm.nightVision)
            .then(function (resp) {
              if (resp) {
                vm.nightVision = !vm.nightVision;
                if( vm.nightVision){
                  toastr.success("night mode is on");
                }else{
                  toastr.success("night mode is off");
                }
              } else {
                toastr.success("night mode is not active");
              }
            });
        };

        vm.armedFunc = function () {
          tuyaCameraService
            .armed($stateParams.cameraId, !vm.armedMode)
            .then(function (resp) {
              if (resp) {
                vm.armedMode = !vm.armedMode;
                if(vm.armedMode){
                  toastr.success("Camera is armed");
                }else{
                  toastr.success("Camera is disarmed");
                }

              } else {
                toastr.success("night mode is not active");
              }
            });
        };
      }
    );
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.cameras')
    .controller('cameraSettingsController', function (userSentinelCamera, $translate, cameraMode, cameraService,
      cameraFirmwareStatus, camera, navigationService, $state, $stateParams, toastr, cameraStatus, cameraWifiStatus, cameraSimStatus) {
      var vm = this;
      vm.camera = camera;
      vm.cameraMode = cameraMode;
      vm.cameraFirmwareStatus = cameraFirmwareStatus;
      vm.userSentinelCamera = userSentinelCamera;
      vm.cameraStatus = cameraStatus;
      vm.cameraWifiStatus = cameraWifiStatus;
      vm.cameraSimStatus = cameraSimStatus;
      navigationService.navigation = {
        backState: 'boat.camera_details',
        backStateParams: {
          sentinelId: $stateParams.sentinelId,
          cameraId: $stateParams.cameraId
        }
      };

      vm.removeCamera = function () {
        if (userSentinelCamera.isLiveAccount) {
          $translate(['Camera_delete_confirmation', 'CameraDeletionScheduled'])
            .then(function (translations) {
              if (confirm(translations.Camera_delete_confirmation)) {
                cameraService.deleteCamera($stateParams.cameraId, function () {
                  toastr.success(translations.CameraDeletionScheduled);
                  $state.go('boat.cameras', { sentinelId: $stateParams.sentinelId });
                });
              }
            });
        } else {
          toastr.success("This feature is only Available to Live Accounts!");
          return;
        }
      }

      vm.upgradeFirmware = function () {
        $translate(['Firmware_Upgrade_Successfully', 'Firmware_Upgrade_Confirmation'])
          .then(function (translations) {
            if (confirm(translations.Firmware_Upgrade_Confirmation)) {
              var v = translations['Firmware_Upgrade_Successfully'];
              cameraService.updateCameraFirmwareStatus($stateParams.cameraId, vm.cameraFirmwareStatus.targetVersion, function (response) {
                if (response.statusDetails.WasSuccessful) {
                  vm.cameraFirmwareStatus.status = "upgrading";
                  toastr.success(v);
                }
              });
            }
          });
      }

    });
})();

(function () {
  "use strict;";
  angular
    .module("yatch-sentinel.cameras")
    .controller(
      "tuyaCameraDetailsController",
      function (
        $timeout,
        tuyaCameraService,
        $rootScope,
        navigationService,
        cfpLoadingBar,
        $stateParams,
        config,
        sessionService,
        $timeout,
        toastr,
        settings,
        $state,
        events
      ) {
        var vm = this;
        vm.showTrialVideo = false;
        vm.sentinelId = $stateParams.sentinelId;
        vm.cameraId = $stateParams.cameraId;
        vm.tuyaCameraSettings = settings;
        vm.cameraId = $stateParams.cameraId;
        vm.isWatchLive = false;
        vm.snapshot = "";
        vm.imageLoaded = "";
        vm.videoLoaded = false;
        vm.eventsPageNumber = 1;
        vm.reload = false;
        vm.video = "";
        vm.showSnapshotBool = false;
        vm.showVideoBool = false;
        vm.events = [];
        vm.nightVision = vm.tuyaCameraSettings.nightVision;
        vm.isNightVisionSupported = vm.tuyaCameraSettings.isNightVisionSupport;

        vm.armedMode = vm.tuyaCameraSettings.isArmed;
        vm.isArmedModeSupported = vm.tuyaCameraSettings.isArmedSupport;

        vm.isSirenSupported = vm.tuyaCameraSettings.isSirenSupport;
        vm.siren = vm.tuyaCameraSettings.siren;
        vm.isPlaySiren = false;


        vm.videoPlayer = "";

        navigationService.navigation = {
          backState: "boat.cameras",
          backStateParams: {
            sentinelId: $stateParams.sentinelId,
          },
        };

        if (events && events.length > 0) {
          angular.forEach(events, function (event) {
            if (event.cameraEventTypeId == 1) //motion
            {
              vm.events.push({
                badgeClass: 'danger',
                badgeIconClass: 'glyphicon-camera',
                title: 'Camera Motion Alert',
                time: event.createdDate,
                object: event,
                cameraEventTypeId: 1
              })
            }
            else if (event.cameraEventTypeId == 2) // snapshot
            {
              vm.events.push({
                badgeClass: 'info',
                badgeIconClass: 'glyphicon-camera',
                title: 'Snapshot taken',
                time: event.createdDate,
                object: event,
                cameraEventTypeId: 2
              })
            }
          });

        }
        $rootScope.$on(
          "$stateChangeStart",
          function (event, toState, toParams, fromState, fromParams) {
            if (vm.isWatchLive) {
              vm.closeLiveWatch();
            }
          }
        );

        vm.viewSettings = function () {
          $state.go("boat.tuyaCamera_setting", {
            sentinelId: $stateParams.sentinelId,
            cameraId: $stateParams.cameraId,
          });
        };


        vm.viewLiveFeed = function () {
          cfpLoadingBar.start();
          tuyaCameraService
            .getLiveStream($stateParams.cameraId)
            .then(function (res) {
              vm.isWatchLive = true;
              vm.video = res.url;
              setTimeout(function () {
                var player = videojs("tuyaVideoPlayer", {
                  controls: false,
                  autoplay: true,
                  preload: "auto",
                  muted: true
                });
                vm.videoPlayer = player;
                cfpLoadingBar.complete();
              }, 500);
            });

        };



        vm.closeLiveWatch = function () {
          vm.videoPlayer.dispose();
          vm.videoPlayer = null;
          vm.isWatchLive = false;
          vm.video = "";
        };


        vm.nightVisionFunc = function () {
          tuyaCameraService
            .nightVision($stateParams.cameraId, !vm.nightVision)
            .then(function (resp) {
              if (resp) {
                vm.nightVision = !vm.nightVision;
                if (vm.nightVision) {
                  toastr.success("night mode is on");
                } else {
                  toastr.success("night mode is off");
                }
              } else {
                toastr.success("night mode is not active");
              }
            });
        };

        vm.armedFunc = function () {
          tuyaCameraService
            .armed($stateParams.cameraId, !vm.armedMode)
            .then(function (resp) {
              if (resp) {
                vm.armedMode = !vm.armedMode;
                if (vm.armedMode) {
                  toastr.success("Camera is armed");
                } else {
                  toastr.success("Camera is disarmed");
                }
              } else {
                toastr.success("Camera armed is not active");
              }
            });
        };

        vm.playSirenFunc = function () {
          if (!vm.isPlaySiren) {
            vm.isPlaySiren = true;
            tuyaCameraService
              .playSiren($stateParams.cameraId, !vm.siren)
              .then(function (resp) {
                if (resp) {
                  setTimeout(function () {
                    tuyaCameraService
                      .playSiren($stateParams.cameraId, false)
                      .then(function (offResponse) {
                        vm.isPlaySiren = false
                      });
                  }, 5000);
                } else {
                  toastr.success("siren is not active");
                }
              });

          }

        };
        vm.animateElementIn = function ($el) {
          $el.removeClass('timeline-hidden');
          $el.addClass('bounce-in');
        };

        vm.animateElementOut = function ($el) {
          $el.addClass('timeline-hidden');
          $el.removeClass('bounce-in');
        };

        vm.showSnapshot = function (event) {
          if (event.snapshotAttachment.blobUri == null) {
            tuyaCameraService.getSnapshotUrl($stateParams.tuyaDeviceId, $stateParams.sentinelId, event.snapshotAttachmentId).then(function (response) {
              event.snapshotAttachment.blobUri = response;
              event.showVideoBool = false;
              event.showSnapshotBool = true;
            });
          } else {
            event.showVideoBool = false;
            event.showSnapshotBool = true;
          }
        };

        vm.hideSnapshot = function (event) {
          event.showSnapshotBool = false;
        };

        vm.downloadSnapshot = function (event) {
          if (event.snapshotAttachmentId != null) {
            vm.isSnapShot = true;
            vm.isVideo = false;
          }
          if (vm.isSnapShot) {
            var url = config.apiUrl + "api/tuya/devices/"+ $stateParams.tuyaDeviceId + "/" + $stateParams.sentinelId + "/snapshot/" + event.snapshotAttachmentId + "/download";
            var token = sessionService.getAuthToken();
            if (token) {
              url += "?access_token=" + token.access_token;
            }
            url += "&isSnapShot=" + vm.isSnapShot;
            url += "&isVideo=" + vm.isVideo;
            window.location.href = url;
          }
        };

      }
    );
})();

(function () {
    'use strict;'
    angular.module('yatch-sentinel.cameras')
        .controller('tuyaCameraHeaderController', function ( cameraName,$state, $timeout) {
          vm=this;
          vm.cameraName=cameraName
            $timeout(function(){
               $state.current.mobileHeader.title = vm.cameraName;
            },0);
        });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.cameras')
    .controller('cameraDetailsController', function (userSentinelCamera, userSentinelCameraEvents, sharedUserPermissions, $rootScope, navigationService, $stateParams,
      cameraService, config, sessionService, $scope, cfpLoadingBar, $interval, $timeout, cameraService, $state) {
      var vm = this;
      vm.showTrialVideo = false;
      vm.sentinelId = $stateParams.sentinelId;
      vm.cameraId = $stateParams.cameraId;
      vm.userSentinelCamera = userSentinelCamera;
      vm.sharedUserPermissions = sharedUserPermissions;
      if (sharedUserPermissions != null || sharedUserPermissions != undefined) {
        vm.canViewLive = sharedUserPermissions.canViewLive;
        vm.canViewAlert = sharedUserPermissions.canViewAlerts;
      } else {
        vm.canViewLive = true;
        vm.canViewAlert = true;
      }
      vm.snapshot = "";
      vm.imageLoaded = "";
      vm.videoLoaded = "";
      vm.video = "";
      vm.showSnapshotBool = false;
      vm.showVideoBool = false;
      vm.events = [];
      vm.eventsPageNumber = 1;
      vm.reload = false;
      vm.isSnapShot = false;
      vm.isVideo = false;
      if (userSentinelCameraEvents != undefined && userSentinelCameraEvents.length > 0) {
        userSentinelCameraEvents.forEach(function (event) {
          if (event.cameraEventTypeId == 1) //motion
          {
            vm.events.push({
              badgeClass: 'danger',
              badgeIconClass: 'glyphicon-camera',
              title: 'Camera Motion Alert',
              time: event.createdDate,
              object: event,
              cameraEventTypeId:1
            })
          }
          else if (event.cameraEventTypeId == 2) // snapshot
          {
            vm.events.push({
              badgeClass: 'info',
              badgeIconClass: 'glyphicon-camera',
              title: 'Snapshot taken',
              time: event.createdDate,
              object: event,
              cameraEventTypeId:2
            })
          }

        });
      }
      vm.showLoadMore = true;

      vm.getEvents = function () {
        vm.eventsPageNumber = vm.eventsPageNumber + 1;
        cameraService.userSentinelCameraEvents($stateParams.sentinelId, $stateParams.cameraId, vm.eventsPageNumber, 10, function (response) {
          if (response != undefined && response.length > 0) {
            response.forEach(function (event) {
              if (event.cameraEventTypeId == 1) //motion
              {
                vm.events.push({
                  badgeClass: 'danger',
                  badgeIconClass: 'glyphicon-camera',
                  title: 'Camera Motion Alert',
                  time: event.createdDate,
                  object: event,
                  cameraEventTypeId:1
                })
              }
              else if (event.cameraEventTypeId == 2) // snapshot
              {
                vm.events.push({
                  badgeClass: 'info',
                  badgeIconClass: 'glyphicon-camera',
                  title: 'Snapshot taken',
                  time: event.createdDate,
                  object: event,
                  cameraEventTypeId:2
                })
              }

            });
          }
          if (response != undefined && response.length < 10) {
            vm.showLoadMore = false;
          }
        });
      };
      vm.downloadSnapShot = function (event) {
        if (event.snapshotAttachmentId != null) {
          vm.isSnapShot = true;
          vm.isVideo = false;
        }
        if (vm.isSnapShot) {
          var url = config.apiUrl + "api/camera/userSentinel/" + $stateParams.sentinelId + "/attachment/" + event.snapshotAttachmentId + "/download";
          var token = sessionService.getAuthToken();
          if (token) {
            url += "?access_token=" + token.access_token;
          }
          url += "&isSnapShot=" + vm.isSnapShot;
          url += "&isVideo=" + vm.isVideo;
          window.location.href = url;
        }
      };
      vm.downloadVideo = function (event) {
        if (event.videoAttachmentId != null) {
          vm.isSnapShot = false;
          vm.isVideo = true;
        }
        if (vm.isVideo) {
          var url = config.apiUrl + "api/camera/userSentinel/" + $stateParams.sentinelId + "/attachment/" + event.snapshotAttachmentId + "/download";
          var token = sessionService.getAuthToken();
          if (token) {
            url += "?access_token=" + token.access_token;
          }
          url += "&isSnapShot=" + vm.isSnapShot;
          url += "&isVideo=" + vm.isVideo;
          window.location.href = url;
        }
      };
      vm.showSnapshot = function (event) {
        if (event.snapshotAttachment.blobUri == null) {
          cameraService.getAttachmentBlobUri($stateParams.sentinelId, event.snapshotAttachmentId, function (response) {
            event.snapshotAttachment.blobUri = response;
            event.showVideoBool = false;
            event.showSnapshotBool = true;
          });
        } else {
          event.showVideoBool = false;
          event.showSnapshotBool = true;
        }
      };

      vm.hideSnapshot = function (event) {
        event.showSnapshotBool = false;
      };

      vm.showVideo = function (event) {
        if (event.videoAttachment.blobUri == null) {
          cameraService.getAttachmentBlobUri($stateParams.sentinelId, event.videoAttachmentId, function (response) {
            event.videoAttachment.blobUri = response;
            event.showSnapshotBool = false;
            event.showVideoBool = true;
          });
        } else {
          event.showSnapshotBool = false;
          event.showVideoBool = true;
        }
      };

      vm.hideVideo = function (event) {
        event.showVideoBool = false;
      };

      navigationService.navigation = {
        backState: 'boat.cameras',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };

      vm.animateElementIn = function ($el) {
        $el.removeClass('timeline-hidden');
        $el.addClass('bounce-in');
      };

      vm.animateElementOut = function ($el) {
        $el.addClass('timeline-hidden');
        $el.removeClass('bounce-in');
      };

      function guid() {
        function s4() {
          return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
      }

      vm.takeSnapshot = function () {
        vm.closeLiveFeed();
        cfpLoadingBar.start();
        if (userSentinelCamera.isLiveAccount) {
          var url = config.apiUrl + "api/camera/" + $stateParams.cameraId + "/snapshot";
          var token = sessionService.getAuthToken();
          if (token) {
            url += "?access_token=" + token.access_token;
          }
          var uuid = guid();
          url += '&_=' + uuid;
          vm.snapshot = url;
          var snapshot = document.getElementById('snapshot');

          snapshot.onload = function () {
            vm.imageLoaded = "True";
            $scope.$apply();
            cfpLoadingBar.complete();
          };
        } else {
          var uri = vm.events[0].object.snapshotAttachment.blobUri;
          if (uri == null) {
            cameraService.getAttachmentBlobUri($stateParams.sentinelId, vm.events[0].object.snapshotAttachmentId, function (response) {
              vm.events[0].object.snapshotAttachment.blobUri = response;
              vm.snapshot = response;
              var snapshot = document.getElementById('snapshot');

              cfpLoadingBar.start();
              snapshot.onload = function () {
                vm.imageLoaded = "True";
                $scope.$apply();
                cfpLoadingBar.complete();
              };
            });
          } else if (uri != null) {
            vm.snapshot = uri;
            var snapshot = document.getElementById('snapshot');

            snapshot.onload = function () {
              vm.imageLoaded = "True";
              $scope.$apply();
              cfpLoadingBar.complete();
            };
          }
        }
      }
      vm.viewLiveFeed = function () {
        vm.closeSnapshot();
        cfpLoadingBar.start();
        if (userSentinelCamera.isLiveAccount) {
          if (vm.streamInterval) {
            $interval.cancel(vm.streamInterval);
          }
          cameraService.getCameraStream($stateParams.cameraId, function (res) {
            vm.video = res;
            cfpLoadingBar.start();
            var video = document.getElementById('video');
            video.setAttribute('src', vm.video);
            video.onload = function () {
              vm.videoLoaded = "True";
              $scope.$apply();
              cfpLoadingBar.complete();
              vm.streamMax = 30;
              vm.streamValue = 0;
              vm.streamInterval = $interval(function () {
                vm.streamValue += 1;
              }, 1000);
              $timeout(function () {
                $interval.cancel(vm.streamInterval);
                vm.closeLiveFeed();
              }, (vm.streamMax - 1) * 1000);
            };
          })
        } else {
          var uri = vm.events[1].object.videoAttachment.blobUri;
          if (uri == null) {
            cameraService.getAttachmentBlobUri($stateParams.sentinelId, vm.events[1].object.videoAttachmentId, function (response) {
              cfpLoadingBar.start();
              vm.events[1].object.videoAttachment.blobUri = response;
              vm.trialVideo = response;
              vm.videoLoaded = "True";
              vm.showTrialVideo = true;
              cfpLoadingBar.complete();
            });
          } else if (uri != null) {
            cfpLoadingBar.start();
            vm.video = uri;
            vm.videoLoaded = "True";
            vm.showTrialVideo = true;
            cfpLoadingBar.complete();
          }
        }
      }
      vm.closeLiveFeed = function () {
        if (vm.streamInterval) {
          $interval.cancel(vm.streamInterval);
        }
        var video = document.querySelector("#video");
        video.setAttribute('src', '');
        vm.videoLoaded = "";
        vm.video = "";
      }
      vm.closeSnapshot = function () {
        vm.imageLoaded = "";
        vm.snapshot = "";
      }
      vm.viewSettings = function () {
        vm.closeLiveFeed();
        vm.closeSnapshot();
        $state.go('boat.camera_settings', { sentinelId: $stateParams.sentinelId, cameraId: $stateParams.cameraId });
      }

    });
})();

(function () {
    'use strict;'
    angular.module('yatch-sentinel.cameras')
        .controller('cameraHeaderController', function (camera) {
            var vm = this;
            vm.camera = camera;
        });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.cameras')
    .controller('camerasController', function (userSentinelCameras,navigationService,userSentinelTuyaCameras, $state, $stateParams, oemConfig) {
      var vm = this;
      vm.oemConfig = angular.copy(oemConfig);
      vm.userSentinelCameras = userSentinelCameras;
      vm.totalUserSentinelCameras = userSentinelCameras.length;
      vm.userSentinelTuyaCameras=userSentinelTuyaCameras;

      navigationService.navigation = {
        backState: 'boat.home',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };

      vm.viewTuyaDetails = function (device) {
        $state.go('boat.tuyaCamera_details', { sentinelId: $stateParams.sentinelId, cameraId: device.did, tuyaDeviceId: device.id });
      }

      vm.viewDetails = function (cameraId) {
        $state.go('boat.camera_details', { sentinelId: $stateParams.sentinelId, cameraId: cameraId });
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.accountSettings', [
    'yatch-sentinel.services',
    'yatch-sentinel.common'
  ]).config(function ($stateProvider,$translatePartialLoaderProvider) {
    $stateProvider
      .state('boat.accountSettings', {
        url: '/accountSettings/:sentinelId',
        views: {
          'header@boat': {
            templateUrl: 'app/main/account-settings/header.html',
            controller: function(oemConfig){
              var vm = this;
              vm.oemConfig = angular.copy(oemConfig);
            },
            controllerAs: 'vm'
          },
          'content@boat': {
            templateUrl: 'app/main/account-settings/accountSettings.html',
            controller: 'accountSettingsController',
            controllerAs: 'vm',
            resolve: {
              countries: function (http) {
                return http.get("assets/countries.json");
              }
            }
          }
        },
        headerClass: 'half',
        mobileHeader: {
          visible: true,
          title: 'Header.AccountSettings'
        }
      });
      $translatePartialLoaderProvider.addPart('app/main/account-settings');
  });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.accountSettings')
    .controller('acceptTermsDialogController', function ($uibModalInstance, accountService, oemConfig, user, toastr, login) {
      var vm = this;
      vm.login = login;
      vm.user = user;
      vm.oemConfig = angular.copy(oemConfig);
      vm.disableTerms = true;
      vm.user.acceptTerms = false;
      vm.checkTermsAndConditions = function () {
        //If Button is disabled it will be enabled and vice versa.
        vm.disableTerms = !vm.user.acceptTerms;
      }
      vm.updateFpAccount = function (form) {
        if (vm.login) {
          $uibModalInstance.close();
        }
        else{
          vm.user.isAccountChanged = true;
          accountService.update(vm.user, function(response) {
            $uibModalInstance.close(response);
          }, function (error) {
            toastr.error(error.exceptionMessage);
          })
        }
      }
    });
})();

(function () {
  "use strict;";
  angular
    .module("yatch-sentinel.boats")
    .controller(
      "boatsController",
      function (
        $q,
        accountService,
        navigationService,
        boats,
        sharedSentinels,
        imeiService,
        toastr,
        config,
        $uibModal,
        userService,
        $rootScope,
        oemConfig,
        $translate,
        sessionService,
        $scope
      ) {
        var vm = this;
        vm.oemConfig = angular.copy(oemConfig);
        vm.isNmeaOnly = false;
        navigationService.navigation = {
          backState: "boat.home",
          backStateParams: {},
        };
        vm.sentinel = {};
        vm.sharedSentinels = sharedSentinels;
        vm.flow = {
          target: config.apiUrl + "api/barcode/scan",
          method: "POST",
          permanentErrors: [500],
          singleFile: true,
          testChunks: false,
          chunkSize: 10 * 1024 * 1024,
        };

        $translate("SellBoatConfirmation.Text").then(function (translations) {
          vm.SellBoatConfirmation = translations;
        });

        vm.fileSuccess = function ($file, $message) {
          var imei = angular.fromJson($message);
          vm.sentinel.imei = imei;
        };

        vm.validateImei = function (imei) {
          return imeiService.validate(imei);
        };
        vm.sentinels = boats;
        vm.validateW2k1Key = function (serialKey) {
          return $q(function (resolve, reject) {
            if (serialKey == undefined || serialKey == "") {
              vm.sentinel.w2K1SerialKeyId = null;
              resolve(true);
            } else {
              accountService.validateW2K1SerialKey(
                serialKey,
                function (response) {
                  if (response == null) {
                    reject(false);
                  } else {
                    vm.sentinel.w2K1SerialKeyId = response.id;
                    resolve(true);
                  }
                }
              );
            }
          });
        };
        vm.addNewBoat = function (form) {
          if (vm.sentinel.mmsi == undefined || vm.sentinel.mmsi == null) {
            vm.sentinel.mmsi = "";
          }
          if (!vm.isNmeaOnly) {
            userService.addUserSeninel(vm.sentinel, function (response) {
              // userService.getUserSentinels(function (sentinelsResponse) {
              //   vm.sentinels = sentinelsResponse;
              // });
              userService.getUserSentinels().then(function (userSentinels) {
                vm.sentinels = angular.copy(userSentinels);
                userService
                  .getSharedSentinels()
                  .then(function (sharedSentinels) {
                    vm.sharedSentinels = sharedSentinels;
                    sharedSentinels.forEach(function (s) {
                      userSentinels.push(s);
                    });
                    $rootScope.$broadcast("sentinelUpdated", userSentinels);
                  });
              });
              //vm.sentinel.id = response;
              //vm.sentinels.push(vm.sentinel);
              vm.sentinel = {};
              form.$setPristine();
              toastr.success("Boat Created Successfully");
            });
          } else if (vm.isNmeaOnly) {
            userService.addNmeaOnlyUserSeninel(
              vm.sentinel,
              function (response) {
                // userService.getUserSentinels(function (sentinelsResponse) {
                //   vm.sentinels = sentinelsResponse;
                // });
                userService.getUserSentinels().then(function (userSentinels) {
                  vm.sentinels = angular.copy(userSentinels);
                  userService
                    .getSharedSentinels()
                    .then(function (sharedSentinels) {
                      vm.sharedSentinels = sharedSentinels;
                      sharedSentinels.forEach(function (s) {
                        userSentinels.push(s);
                      });
                      $rootScope.$broadcast("sentinelUpdated", userSentinels);
                    });
                });
                //vm.sentinel.id = response;
                //vm.sentinels.push(vm.sentinel);
                vm.sentinel = {};
                form.$setPristine();
                toastr.success("NMEA Only Boat Created Successfully");
              }
            );
          }
          vm.w2K1SerialKey = "";
        };

        vm.editBoatDialog = function (boat) {
          $uibModal
            .open({
              templateUrl: "app/main/boats/edit/edit-dialog.html",
              controller: "boatEditDialogController",
              controllerAs: "vm",
              windowClass: "contact-modal",
              resolve: {
                boat: function () {
                  return angular.copy(boat);
                },
              },
            })
            .result.then(function () {
              userService.getUserSentinels(function (response) {
                vm.sentinels = response;
                $rootScope.$broadcast("sentinelUpdated", response);
              });
            });
        };

        vm.deleteBoat = function (boat) {
          if (confirm("Are you sure you want to continue ?")) {
            userService.deleteUserSentinel(boat.id).then(
              function () {
                toastr.success(
                  "You Will Be Notified By Email after Process Completes."
                );
                userService.getUserSentinels().then(function (userSentinels) {
                  vm.sentinels = angular.copy(userSentinels);
                  userService
                    .getSharedSentinels()
                    .then(function (sharedSentinels) {
                      vm.sharedSentinels = sharedSentinels;
                      sharedSentinels.forEach(function (s) {
                        userSentinels.push(s);
                      });
                      $rootScope.$broadcast("sentinelUpdated", userSentinels);
                    });
                });
              },
              function (error) {
                toastr.error(error);
              }
            );
          }
        };

        vm.sellBoat = function (boat) {
          if (confirm(vm.SellBoatConfirmation)) {
            $uibModal.open({
              templateUrl:
                "app/main/boats/selectSellBoatTo/selectSellBoatTo.html",
              controller: "selectSellBoatToController",
              controllerAs: "vm",
              windowClass: "contact-modal",
              resolve: {
                boat: function () {
                  return angular.copy(boat);
                },
              },
            });

          }
        };

        var deregister =  $rootScope.$on("successfullySellBoat", function () {

          $translate("SellBoatSuccessfully.Text").then(function (translations) {
            toastr.success(translations);
          });
          userService.getUserSentinels().then(function (userSentinels) {
            vm.sentinels = angular.copy(userSentinels);
            userService.getSharedSentinels().then(function (sharedSentinels) {
              vm.sharedSentinels = sharedSentinels;
              sharedSentinels.forEach(function (s) {
                userSentinels.push(s);
              });
              $rootScope.$broadcast("sentinelUpdated", userSentinels);
            });
          });

          accountService.me(function (response) {
            sessionService.setUser(response);
            vm.user = angular.copy(sessionService.getUser());
          });
        })

        $scope.$on('$destroy', deregister)

        vm.deleteSharedBoat = function (boat) {
          if (confirm("Are you sure you want to continue ?")) {
            userService.deleteSharedBoat(boat.id).then(function () {
              userService.getUserSentinels().then(function (userSentinels) {
                vm.sentinels = angular.copy(userSentinels);
                userService
                  .getSharedSentinels()
                  .then(function (sharedSentinels) {
                    vm.sharedSentinels = sharedSentinels;
                    sharedSentinels.forEach(function (s) {
                      userSentinels.push(s);
                    });
                    $rootScope.$broadcast("sentinelUpdated", userSentinels);
                  });
              });
            });
          }
        };
      }
    );
})();

(function () {
  "use strict;";
  angular
    .module("yatch-sentinel.boats")
    .controller(
      "selectSellBoatToController",
      function (
        boat,
        $translate,
        toastr,
        oemConfig,
        $rootScope,
        userService,
        $uibModalInstance,
        $uibModal,
        accountService,
        sessionService,
        $scope

      ) {
        var vm = this;
        vm.oemConfig = angular.copy(oemConfig);
        vm.sentinel = angular.copy(boat);
        vm.boatId = vm.sentinel.id;
        vm.sellTo = "default";
        vm.showEmail = false;
        vm.email = "";
        vm.showOrHideEmailField = function () {
          if (vm.sellTo == "existing") {
            vm.showEmail = true;
          } else vm.showEmail = false;
        };
        vm.saveChanges = function () {
          if (vm.sellTo == "default") {
            userService.sellUserSentinel(vm.boatId, null, null, vm.sellTo).then(
              function (res) {
                if(res==0){
                  vm.OpenInputDialog()
                }else{
                  $rootScope.$emit("successfullySellBoat", {});
                }
                $uibModalInstance.close(res);
              },
              function (err) {
                toastr.error(err.exceptionMessage);
              }
            );
          } else {
            userService
              .sellUserSentinel(vm.boatId, vm.email, null, vm.sellTo)
              .then(
                function (res) {

                  if(res==0){
                    vm.OpenInputDialog()
                  }else{
                    $rootScope.$emit("successfullySellBoat", {});
                  }
                  $uibModalInstance.close(res);
                },
                function (err) {
                  toastr.error(err.exceptionMessage);
                }
              );
          }
        };

        vm.OpenInputDialog = function () {
          $uibModal
            .open({
              templateUrl: "app/main/boats/getEmailnPassword/input.dialog.html",
              controller: "boatInputDialogController",
              controllerAs: "vm",
              windowClass: "contact-modal",
              resolve: {
                boat: function () {
                  return angular.copy(boat);
                },
              },
            })
            .result.then(function () {
              $rootScope.$emit("successfullySellBoat", {});
            });
        };


      }
    );
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.boats')
    .controller('boatEditDialogController', function (oemConfig, $q, accountService, boat, $uibModalInstance, config, imeiService, sentinelService, toastr) {
      var vm = this;
      vm.oemConfig = angular.copy(oemConfig);
      vm.sentinel = angular.copy(boat);
      if (vm.sentinel.w2K1SerialKeyId != null) {
        vm.w2K1SerialKey = vm.sentinel.validW2K1SerialKey.w2K1SerialKey;
      }
      vm.flow = {
        target: config.apiUrl + "api/barcode/scan",
        method: 'POST',
        permanentErrors: [500],
        singleFile: true,
        testChunks: false,
        chunkSize: 10 * 1024 * 1024
      };

      vm.fileSuccess = function ($file, $message) {
        var imei = (angular.fromJson($message));
        vm.sentinel.imei = imei;
      };

      vm.validateImei = function (imei) {
        if (imei == boat.imei) return true;
        return imeiService.validate(imei);
      };
      vm.validateW2k1Key = function (serialKey) {
        return $q(function (resolve, reject) {
          if (serialKey == undefined || serialKey == "") {
            vm.sentinel.w2K1SerialKeyId = null;
            resolve(true);
          } else {
            accountService.validateW2K1SerialKey(serialKey, function (response) {
              if (response == null) {
                if (vm.sentinel.validW2K1SerialKey != undefined && vm.sentinel.validW2K1SerialKey.w2K1SerialKey == serialKey) {
                  resolve(true);
                }
                reject(false)
              } else {
                vm.sentinel.w2K1SerialKeyId = response.id;
                resolve(true);
              }
            });
          }
        });

      };
      vm.saveChanges = function () {
        if (vm.sentinel.imei != boat.imei && boat.isCameraOnly) {
          vm.sentinel.isCameraOnly = false;
          sentinelService.updateCameraOnlyBoat(vm.sentinel)
          .then(function () {
            toastr.success('Boat settings updated');
            $uibModalInstance.close();
          },function(err){
            toastr.error(err.exceptionMessage)
          });
        } else {
          sentinelService.saveBoatSettings(vm.sentinel)
          .then(function () {
            toastr.success('Boat settings updated');
            $uibModalInstance.close();
          }, function(err){
            toastr.error(err.exceptionMessage)
          })
        }
      };

    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.boats')
    .controller('boatInputDialogController', function ($translate,oemConfig, $q, userService, boat, $uibModalInstance, config, imeiService, sentinelService, toastr) {
      var vm = this;
      vm.oemConfig = angular.copy(oemConfig);
      vm.sentinel = angular.copy(boat);

      vm.boatId=vm.sentinel.id
      vm.email="";
      vm.password="";


      vm.saveChanges = function () {
         if  (vm.email!="" && vm.password!=""){
          userService.sellUserSentinel( vm.boatId,vm.email,vm.password,"default")
          .then(function (res) {
            $rootScope.$emit("successfullySellBoat", {});
            $uibModalInstance.close();
          }, function(err){
            toastr.error(err.exceptionMessage)
          })
         }

      };

    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.services', [])
    .service('config', function (oemConfig) {
      var environment = "Test";


      if (environment === 'Development') {
        if (oemConfig.oem == '') {
          return {
            apiUrl: 'http://localhost:6475/',
            webUrl: 'http://localhost:3000/',
            captchaKey: '6LcTXQ4UAAAAAO-dUVOJ-Ifcpq7lcMZU0ALlpT30',
            googleSenderId: '146044897013',
            environment:environment,
            tenant:''
          }
        }
        else if (oemConfig.oem == 'fp') {
          return {
            apiUrl: 'http://localhost:6475/',
            webUrl: 'http://localhost:3000/',
            captchaKey: '6LcTXQ4UAAAAAO-dUVOJ-Ifcpq7lcMZU0ALlpT30',
            googleSenderId: '146044897013',
            environment:environment,
            tenant:'104F76E8-05B0-41BE-8814-EE9365E06D83'
          }
        }
        else if (oemConfig.oem == 'sp2') {
          return {
            apiUrl: 'http://localhost:6475/',
            webUrl: 'http://localhost:3000/',
            captchaKey: '6LcTXQ4UAAAAAO-dUVOJ-Ifcpq7lcMZU0ALlpT30',
            googleSenderId: '664391514575',
            environment:environment,
            tenant:''
          }
        }
      } else if (environment === 'Production') {
        if (oemConfig.oem == '') {
          return {
            apiUrl: 'https://app.yacht-sentinel.com/service/',
            webUrl: 'https://app.yacht-sentinel.com/',
            captchaKey: '6LcTXQ4UAAAAAO-dUVOJ-Ifcpq7lcMZU0ALlpT30',
            googleSenderId: '624240181193',
            environment:environment,
            tenant:''
          }
        }
        else if (oemConfig.oem == 'fp') {
          return {
            apiUrl: 'https://app.yacht-sentinel.com/service/',
            webUrl: 'https://fp.yacht-sentinel.com/',
            captchaKey: '6LcTXQ4UAAAAAO-dUVOJ-Ifcpq7lcMZU0ALlpT30',
            googleSenderId: '624240181193',
            environment:environment,
            tenant:'104F76E8-05B0-41BE-8814-EE9365E06D83'
          }
        }
        else if (oemConfig.oem == 'sp2') {
          return {
            apiUrl: 'https://app.sentinel-point.com/service/',
            webUrl: 'https://app.sentinel-point.com/',
            captchaKey: '6LcTXQ4UAAAAAO-dUVOJ-Ifcpq7lcMZU0ALlpT30',
            googleSenderId: '689309698726',
            environment:environment,
            tenant:''
          }
        }

      } else if (environment === 'Test') {
        if (oemConfig.oem == '') {
          return {
            apiUrl: 'https://test.yacht-sentinel.com/service/',
            webUrl: 'https://test.yacht-sentinel.com/',
            captchaKey: '6LcTXQ4UAAAAAO-dUVOJ-Ifcpq7lcMZU0ALlpT30',
            googleSenderId: '146044897013',
            environment:environment,
            tenant:''
          }
        }
        else if (oemConfig.oem == 'fp') {
          return {
            apiUrl: 'https://test.yacht-sentinel.com/service/',
            webUrl: 'https://test-fp.yacht-sentinel.com/',
            captchaKey: '6LcTXQ4UAAAAAO-dUVOJ-Ifcpq7lcMZU0ALlpT30',
            googleSenderId: '146044897013',
            environment:environment,
            tenant:'104F76E8-05B0-41BE-8814-EE9365E06D83'
          }
        }
        else if (oemConfig.oem == 'sp2') {
          return {
            apiUrl: 'https://test.sentinel-point.com/service/',
            webUrl: 'https://test.sentinel-point.com/',
            captchaKey: '6LcTXQ4UAAAAAO-dUVOJ-Ifcpq7lcMZU0ALlpT30',
            googleSenderId: '664391514575',
            environment:environment,
            tenant:''
          }
        }

      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.services')
    .factory('notificationHub', function ($log, config, toastr, Hub) {
      var hub = new Hub('NotificationHub', {

        //client side methods
        listeners: {},

        //query params sent on initial connection
        queryParams: {
          'token': ''
        },

        //handle connection error
        errorHandler: function (error) {
          $log.error(error);
        },
        //specify a non default root
        rootPath: config.apiUrl + "signalr",
        useSharedConnection: true,
        autoConnect: false,
        stateChanged: function (state) {
          switch (state.newState) {
            case $.signalR.connectionState.connected:
              {
                toastr.info('Connected to notification server.');
                break;
              }
          }
        }
      });
      return function () {
        var events = [];
        hub.on('pushNotification', function (msg) {
          angular.forEach(events, function (event) {
            if (event.name == 'pushNotification') {
              event.callback(msg);
            }
          });
        });

        hub.on('pushStatusNotification', function (msg) {
          angular.forEach(events, function (event) {
            if (event.name == 'pushStatusNotification') {
              event.callback(msg);
            }
          });
        });

        hub.on('pushNmeaData', function (msg) {
          angular.forEach(events, function (event) {
            if (event.name == 'pushNmeaData') {
              event.callback(msg);
            }
          });
        });

        return {
          on: function (event, fn) {
            events.push({
              name: event,
              callback: fn
            })
          },
          off: function (event) {
            var event = events.filter(function(e){
              return e.name == event;
            })[0];
            if(event){
              var index = events.indexOf(event);
              events.splice(index, 1);
            }
          },
          connect: function () {
            hub.connect();
          },
          disconnect: function () {
            events = [];
            hub.disconnect();
            hub.proxy.off('pushNotification');
          },
          setAccessToken: function (token) {
            hub.connection.qs.access_token = token;
          }
        }
      };
    });

})();

(function () {
    'use strict;'
    angular.module('yatch-sentinel.services')
        .factory('chatHub', function ($log, config, toastr, Hub) {
            var hub = new Hub('ChatHub', {

                //client side methods
                listeners: {},

                //query params sent on initial connection
                queryParams: {
                   
                },

                //handle connection error
                errorHandler: function (error) {
                    $log.error(error);
                },
                //specify a non default root
                rootPath: config.apiUrl + "signalr",
                useSharedConnection: false,
                autoConnect: false,
                stateChanged: function (state) {
                    switch (state.newState) {
                        case $.signalR.connectionState.connected:
                            {
                                toastr.info('Connected to chat server.');
                                break;
                            }
                    }
                }
            });
            return function () {
                var events = [];
                hub.on('NewMessage', function (msg) {
                    angular.forEach(events, function (event) {
                        if (event.name == 'NewMessage') {
                            event.callback(msg);
                        }
                    });
                });

                return {
                    on: function (event, fn) {
                        events.push({
                            name: event,
                            callback: fn
                        })
                    },
                    off: function (event) {
                        var event = events.filter(function (e) {
                            return e.name == event;
                        })[0];
                        if (event) {
                            var index = events.indexOf(event);
                            events.splice(index, 1);
                        }
                    },
                    connect: function () {
                        hub.connect();
                    },
                    _connect: function () {
                        hub.invoke('connect');
                    },
                    disconnect: function () {
                        events = [];
                        hub.disconnect();
                        hub.proxy.off('pushNotification');
                    },
                    setAccessToken: function (token) {
                        hub.connection.qs.access_token = token;
                    }
                }
            };
        });

})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.weather', [
    'yatch-sentinel.services',
    'flow'
  ]).config(function ($stateProvider,$translatePartialLoaderProvider) {
    $stateProvider
      .state('boat.weather', {
        url: '/weather/:sentinelId',
        views: {
          'header@boat': {
            templateUrl: 'app/main/weather/header.html',
            controller: function(oemConfig){
              var vm = this;
              vm.oemConfig = angular.copy(oemConfig);
            },
            controllerAs: 'vm'
          },
          'content@boat': {
            templateUrl: 'app/main/weather/weather.html',
            controller: 'weatherController',
            controllerAs: 'vm',
            resolve: {
              sentinelWeather: function (sentinelService, $stateParams, moment) {
                var sentinelWeatherDate = moment();
                return sentinelService.getSentinelWeather(sentinelWeatherDate.format("YYYY/MM/DD"), $stateParams.sentinelId);
              },
              foreCast: function (sentinelService, $stateParams, moment) {
                var sentinelWeatherDate = moment();
                return sentinelService.getForeCast(sentinelWeatherDate.format("YYYY/MM/DD"), $stateParams.sentinelId)
              }
            }
          }
        },
        headerClass: 'half',
        mobileHeader: {
          visible: true,
          title: 'Header.Weather'
        },
        data: {
          pageTitle: 'Weather'
        }
      });
      $translatePartialLoaderProvider.addPart('app/main/weather');
  });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.weather')
    .controller('weatherController', function (sentinelWeather, foreCast, $uibModal, $stateParams, $state, navigationService, oemConfig) {
      var vm = this;
      vm.oemConfig = angular.copy(oemConfig);
      vm.showMoreInfo = false;
      vm.show7days = false;
      vm.sentinelId = $stateParams.sentinelId;
      vm.showTides = true;
      navigationService.navigation = {
        backState: 'boat.home',
        backStateParams: {
            sentinelId: $stateParams.sentinelId
        }
      };
      if (sentinelWeather == null) {
        var modalInstance = $uibModal.open({
          templateUrl: 'app/main/weather/error-box-dialog.html',
          size: 'lg'
        }).closed.then(function () {
          $state.go('boat.home', { sentinelId: vm.sentinelId });
        });
      }
      else {
        vm.sentinelWeather = sentinelWeather;
        vm.weatherDetails = sentinelWeather.sentinelWeatherDetail.filter(function (w) {
          return w.time == 1200;
        })[0];
        vm.foreCast = foreCast;
        vm.foreCast.forEach(function (weather) {
          weather.weatherDetails = weather.sentinelWeatherDetail.filter(function (w) {
            return w.time == 1200;
          })[0];
        });
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.update_password', [
      'yatch-sentinel.services'
    ])
    .config(function ($stateProvider) {
      $stateProvider
        .state('update-password', {
          url: '/update-password',
          templateUrl: 'app/main/update-password/update-password.html',
          controller: 'updatePasswordController',
          controllerAs: 'vm',
          resolve: {
            user : function(sessionService){
              return sessionService.getUser();
            },
            sentinels: function(userService){
              return userService.getUserSentinels();
            }
          }
        });
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.update_password')
    .controller('updatePasswordController',
      function (accountService, $location, toastr, user, $state, sentinels) {
        var vm = this;
        vm.user = user;
        vm.sentinels = sentinels;
        vm.passwordValidationStatus = {
          minLength: false,
          upperCase: false,
          lowerCase: false,
          number: false
        };

        vm.updatePassword = function () {
          accountService.updatePassword({
            emailAddress: vm.user.emailAddress,
            password: vm.account.password
          }).then(function (response) {
              toastr.success('Password updated successfully');
              vm.navigateToHome();
            });
        };
        vm.onPasswordChange = function ($event) {
          var value = $event.target.value;
          if (value.length >= 8) {
            vm.passwordValidationStatus.minLength = true;
          } else {
            vm.passwordValidationStatus.minLength = false;
          }

          const lowerCaseRegex = /^(.*[a-z]).*$/gm
          var foundLower = value.match(lowerCaseRegex);
          if (foundLower && foundLower.length > 0) {
            vm.passwordValidationStatus.lowerCase = true
          }
          else {
            vm.passwordValidationStatus.lowerCase = false
          }

          const upperCaseRegex = /^(.*[A-Z]).*$/gm
          var foundUpper = value.match(upperCaseRegex);
          if (foundUpper && foundUpper.length > 0) {
            vm.passwordValidationStatus.upperCase = true
          }
          else {
            vm.passwordValidationStatus.upperCase = false
          }

          const numberRegex = /^(?=.*\d).*$/gm
          var foundNumber = value.match(numberRegex);
          if (foundNumber && foundNumber.length > 0) {
            vm.passwordValidationStatus.number = true
          }
          else {
            vm.passwordValidationStatus.number = false
          }
        }
        vm.skipPasswordUpdate = function () {
          accountService.skipPasswordUpdate(vm.user.id).then(function(success){
            vm.navigateToHome();
          });
        }
        vm.navigateToHome = function () {
          var isAdmin = false;
          for (var i = 0; i < vm.user.userRoles.length; i++) {
            if (vm.user.userRoles[i].roleId == 1) {
              isAdmin = true;
            }
            if (isAdmin) {
              break;
            }
          }
          if (isAdmin) {
            $state.go("admin.home");
          } else {
            if (vm.sentinels.length == 0) {
              $state.go("boat.home", {
                sentinelId: ""
              });
            } else {
              $state.go("boat.home", {
                sentinelId: sentinels[0].id
              });
            }
          }
        }
      })
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.status', [
    'yatch-sentinel.services',
    'yatch-sentinel.filters'
  ])
    .config(function ($stateProvider,$translatePartialLoaderProvider) {
      $stateProvider
        .state('boat.status', {
          url: '/status/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/status/header.html',
              controller: 'statusHeaderController',
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/status/status.html',
              controller: 'boatStatusController',
              controllerAs: 'vm',
              resolve: {
                status: function (sentinelService, $stateParams) {
                  return sentinelService.getSentinelSensorStatuses($stateParams.sentinelId);
                },
                currentSentinel: function (userService, $stateParams) {
                  return userService.getUserSentinelById($stateParams.sentinelId);
                }
              }
            }
          },
          data: {
            pageTitle: 'YS6 Dashboard'
          },
          headerClass: 'half',
          mobileHeader: {
            visible: true,
            title: 'Header.Ys6Dashboard'
          }
        });
        $translatePartialLoaderProvider.addPart('app/main/status');
    });
})();

(function(){
    'use strict;'
    angular.module('yatch-sentinel.status')
    .service('boatStatusService',function(){
        return {
            data: {}
        };
    })
})();
(function () {
  'use strict;'
  angular.module('yatch-sentinel.status')
    .controller('statusHeaderController', function (boatStatusService, oemConfig) {
        var vm = this;
        vm.oemConfig = angular.copy(oemConfig);
        vm.status = boatStatusService.data;
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.status')
    .controller('boatStatusController', function (sessionService, status, $stateParams, $state, boatStatusService,
      navigationService, currentSentinel, oemConfig) {
      var vm = this;
      vm.oemConfig = angular.copy(oemConfig);
      var statusType = {
        disArm: 1,
        arm: 2,
        off: 0
      }
      vm.shorePowerStatusEnum =
        {
          on: 1,
          off: 0,
          notPurchased: 2
        }
      vm.isDisArmed = false;
      vm.isOff = false;
      vm.currentSentinel = currentSentinel;
      vm.isOnline = vm.currentSentinel.isOnline;
      if (vm.currentSentinel.status == statusType.disArm) {
        vm.isDisArmed = true
      }
      if (vm.currentSentinel.status == statusType.off) {
        vm.isOff = true;
      }
      navigationService.navigation = {
        backState: 'boat.home',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      boatStatusService.data = status;
      vm.status = status;
      vm.sentinelId = $stateParams.sentinelId;

      vm.showNmeaDashboard = function () {
        sessionService.setDashboardSwitch(true);
        $state.go("boat.nmea", {
          sentinelId: $stateParams.sentinelId
        })
      };
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.sos', [])
    .config(function ($stateProvider,$translatePartialLoaderProvider) {
      $stateProvider
        .state('boat.sos', {
          url: '/sos/:sentinelId',
          views: {
            'header@boat': {
                templateUrl: 'app/main/sos/header.html',
                controller: 'sosHeaderController',
                controllerAs: 'vm'
            }
          },
          data: {
            pageTitle: 'SOS',
            hideMainContent: true
          },
          headerClass: 'sos'
        });
        $translatePartialLoaderProvider.addPart('app/main/sos');
      });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.sos')
    .controller('sosHeaderController', function ($uibModal, $stateParams, oemConfig) {
      var vm = this;
      vm.oemConfig = angular.copy(oemConfig);
      vm.showSosDialog = function () {
        $uibModal.open({
          templateUrl: 'app/main/sos/sos.html',
          size: 'lg',
          controller: 'sosController',
          controllerAs: 'vm',
          resolve: {
            sentinelId: function () {
              return $stateParams.sentinelId
            }
          }
        });
      };
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.sos')
    .controller('sosController', function (userService, toastr, sentinelId, $uibModalInstance, oemConfig) {
      var vm = this;
      vm.oemConfig = angular.copy(oemConfig);
      vm.sendSos = function () {
        userService.sendSosMessage(sentinelId, vm.extraMessage, function () {
          toastr.success('SOS message sent successfully');
          $uibModalInstance.close()
        });
      };
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.sharedUsers', [
    'yatch-sentinel.services',
    'isteven-multi-select'
  ]).config(function ($stateProvider,$translatePartialLoaderProvider) {
    $stateProvider
      .state('boat.sharedUsers', {
        url: '/sharedUsers/:sentinelId',
        views: {
          'header@boat': {
            templateUrl: 'app/main/shared-users/header.html',
            controller: 'sharedUsersHeaderController',
            controllerAs: 'vm'
          },
          'content@boat': {
            templateUrl: 'app/main/shared-users/shared-users.html',
            controller: 'sharedUsersController',
            controllerAs: 'vm',
            resolve: {
              users: function (userService) {
                return userService.getSharedUsers();
              },
              boats: function (userService) {
                return userService.getUserSentinels();
              }
            }
          }
        },
        headerClass: 'h75',
        data: {
          pageTitle: 'Shared Users'
        },
        mobileHeader: {
          visible: true,
          title: 'Header.SharedUsers'
        }
      });
      $translatePartialLoaderProvider.addPart('app/main/shared-users');
  });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.sharedUsers')
    .service('sharedUsersService', function () {
      return {
        list: {
          users: []
        },

        user: {}

      }
    })
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.sharedUsers')
    .controller('sharedUsersHeaderController', function (sharedUsersService, userService, toastr, $uibModal, oemConfig) {
      var vm = this;
      vm.oemConfig = angular.copy(oemConfig);
      function getUsers() {
        userService.getSharedUsers(function (response) {
          sharedUsersService.list.users = response;
        });
      }


      vm.showNewsSharedUserDialog = function () {
        $uibModal.open({
          templateUrl: 'app/main/shared-users/new-shared-user-dialog.html',
          controller: function ($uibModalInstance, sharedUsersService, userService, toastr, boats, oemConfig) {
            var vm = this;
            vm.oemConfig =  oemConfig;
            vm.sentinels = boats;
            vm.sharedUser = {
              sentinels: []
            };

            vm.addNewUser = function () {
              if (vm.sharedUser.sentinels.length == 0) {
                toastr.error('No boat selected');
                return;
              }
              var model = {
                sharedUserEmail: vm.sharedUser.emailAddress,
                userSentinelIds: vm.sharedUser.sentinels.map(function (s) {
                  return s.id
                }),
                canEdit: false
              };
              userService.createSharedUsers(model, function () {
                vm.sharedUser.sentinels = [];
                vm.sharedUser.emailAddress = '';
                toastr.success('Shared boat/boats shared with user.');
                $uibModalInstance.close();
              });
            };

          },
          controllerAs: 'vm',
          windowClass: 'contact-modal',
          resolve: {
            boats: function (userService) {
              return userService.getUserSentinels();
            }
          }
        }).result.then(function () {
          getUsers();
        });
      };

    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.sharedUsers')
    .controller('sharedUsersController', function (toastr, users, userService, roles, boats, navigationService, sharedUsersService, $stateParams, oemConfig) {
      var vm = this;
      vm.oemConfig = angular.copy(oemConfig);
      sharedUsersService.list.users = angular.copy(users);
      vm.userList = sharedUsersService.list;
      vm.sentinels = boats;
      vm.sharedUser = sharedUsersService.user;
      navigationService.navigation = {
        backState: 'boat.home',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      function getUsers() {
        userService.getSharedUsers(function (response) {
          vm.userList.users = response;
        });
      }

      vm.setUserEditPermission = function (userId, canEdit) {
        userService.setUserEditPermission(userId, canEdit, function () {
          toastr.success('User permission updated');
        });
      };

      vm.setUserViewLivePermission = function (userId, canViewLive) {
        userService.setUserViewLivePermission(userId, canViewLive, function () {
          toastr.success('User permission updated');
        });
      };

      vm.setUserViewAlertsPermission = function (userId, canViewAlerts) {
        userService.setUserViewAlertsPermission(userId, canViewAlerts, function () {
          toastr.success('User permission updated');
        });
      };


      vm.deleteUser = function (userId) {
        if (confirm('Are you sure you want to delete this user?')) {
          userService.deleteSharedUser(userId, function () {
            toastr.success('User deleted successfully.');
            getUsers();
          });
        }
      };
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.reset_password', [
      'yatch-sentinel.services'
    ])
    .config(function ($stateProvider) {
      $stateProvider
        .state('reset-password', {
          url: '/reset-password',
          templateUrl: 'app/main/reset-password/reset-password.html',
          controller: 'resetPasswordController',
          controllerAs: 'vm'
        });
    });
})();

(function () {
    'use strict;'
    angular.module('yatch-sentinel.reset_password')
        .controller('resetPasswordController',
        function (accountService, $location, toastr) {
            var vm = this;
            vm.passwordValidationStatus = {
              minLength: false,
              upperCase: false,
              lowerCase: false,
              number: false
            };
            vm.changePassword = function () {
                var queryString = $location.search();
                accountService.changePassword({
                    emailAddress: queryString.emailAddress,
                    token: queryString.token,
                    password: vm.account.password
                }, function () {
                    toastr.success('Password changed successfully');
                    $location.url("/login");
                });
            };

            vm.onPasswordChange = function ($event) {
              var value = $event.target.value;
              if (value.length >= 8) {
                vm.passwordValidationStatus.minLength = true;
              } else {
                vm.passwordValidationStatus.minLength = false;
              }

              const lowerCaseRegex = /^(.*[a-z]).*$/gm
              var foundLower = value.match(lowerCaseRegex);
              if (foundLower && foundLower.length > 0) {
                vm.passwordValidationStatus.lowerCase = true
              }
              else {
                vm.passwordValidationStatus.lowerCase = false
              }

              const upperCaseRegex = /^(.*[A-Z]).*$/gm
              var foundUpper = value.match(upperCaseRegex);
              if (foundUpper && foundUpper.length > 0) {
                vm.passwordValidationStatus.upperCase = true
              }
              else {
                vm.passwordValidationStatus.upperCase = false
              }

              const numberRegex = /^(?=.*\d).*$/gm
              var foundNumber = value.match(numberRegex);
              if (foundNumber && foundNumber.length > 0) {
                vm.passwordValidationStatus.number = true
              }
              else {
                vm.passwordValidationStatus.number = false
              }
            }

        });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.register', ['vcRecaptcha','flow','ui.validate'])
    .config(function ($stateProvider, vcRecaptchaServiceProvider,$translatePartialLoaderProvider) {
      vcRecaptchaServiceProvider.setSiteKey("6Lf2QTMUAAAAAJF1e1NSMDXJul7ZulweKJyXTKpm");
      $stateProvider
        .state('register', {
            url : '/register',
            templateUrl : 'app/main/register/register.html',
            controller: 'registerAccountController',
            controllerAs : 'vm',
            resolve:{
              countries: function(http){
                return http.get("assets/countries.json");
              }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/register');
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.register')
    .filter('html', function ($sce) {
      return function (input) {
        return $sce.trustAsHtml(input);
      }
    })
    .directive('ngBindHtmlStr', function ($sce, $parse) {
      return {
        restrict: 'A',
        link: function (scope, elem, attrs) {
          $html = (attrs.ngBindHtmlStr);
          angular.element(elem).append($html);
        }
      }
    })
    .controller('registerAccountController',
      function (accountService, vcRecaptchaService, toastr, $state, config,
        sessionService, imeiService, countries, $q, oemConfig) {
        var vm = this;
        vm.passwordValidationStatus = {
          minLength: false,
          upperCase: false,
          lowerCase: false,
          number: false
        };
        vm.oemConfig = angular.copy(oemConfig);
        vm.countries = countries;
        vm.account = {
          isCameraOnly: false
        };
        vm.createAccount = function (form) {
          vm.account.country = vm.account.selectedCountry[0].name;
          vm.account.countryCode = vm.account.selectedCountry[0].dial_code;
          if (vm.ysHubOnly) {
            accountService.createAccount(vm.account, function () {
              vm.account = {};
              form.$setPristine();
              toastr.success('Account created');
              $state.go('login');
            }, function (error) {
              vcRecaptchaService.reload(vm.widgetId);
              vm.response = null;
              toastr.error(error.exceptionMessage);
            });
          } else if (vm.account.isCameraOnly) {
            accountService.createCameraOnlyAccount(vm.account, function () {
              vm.account = {};
              form.$setPristine();
              toastr.success('Camera Only Account created');
              $state.go('login');
            }, function (error) {
              vcRecaptchaService.reload(vm.widgetId);
              vm.response = null;
              toastr.error(error.exceptionMessage);
            });
          } else if (vm.isNmeaOnly) {
            accountService.createNmeaOnlyAccount(vm.account, function () {
              vm.account = {};
              form.$setPristine();
              toastr.success('NMEA Only Account created');
              $state.go('login');
            }, function (error) {
              vcRecaptchaService.reload(vm.widgetId);
              vm.response = null;
              toastr.error(error.exceptionMessage);
            });
          }
        };

        vm.flow = {
          target: config.apiUrl + "api/barcode/scan",
          method: 'POST',
          permanentErrors: [500],
          singleFile: true,
          testChunks: false,
          chunkSize: 10 * 1024 * 1024
        };

        vm.fileSuccess = function ($file, $message) {
          var imei = (angular.fromJson($message));
          vm.account.imei = imei;
        };

        vm.validateImei = function (imei) {
          return imeiService.validate(imei)
        };

        vm.validateW2k1Key = function (serialKey) {
          return $q(function (resolve, reject) {
            accountService.validateW2K1SerialKey(serialKey, function (response) {
              if (response == null) {
                reject(false)
              } else {
                vm.account.W2K1SerialKeyId = response.id;
                resolve(true);
              }
            });
          });

        };
        vm.onPasswordChange = function ($event) {
          var value = $event.target.value;
          if (value.length >= 8) {
            vm.passwordValidationStatus.minLength = true;
          } else {
            vm.passwordValidationStatus.minLength = false;
          }

          const lowerCaseRegex = /^(.*[a-z]).*$/gm
          var foundLower = value.match(lowerCaseRegex);
          if (foundLower && foundLower.length > 0) {
            vm.passwordValidationStatus.lowerCase = true
          }
          else {
            vm.passwordValidationStatus.lowerCase = false
          }

          const upperCaseRegex = /^(.*[A-Z]).*$/gm
          var foundUpper = value.match(upperCaseRegex);
          if (foundUpper && foundUpper.length > 0) {
            vm.passwordValidationStatus.upperCase = true
          }
          else {
            vm.passwordValidationStatus.upperCase = false
          }

          const numberRegex = /^(?=.*\d).*$/gm
          var foundNumber = value.match(numberRegex);
          if (foundNumber && foundNumber.length > 0) {
            vm.passwordValidationStatus.number = true
          }
          else {
            vm.passwordValidationStatus.number = false
          }
        }

        /**
         *
         *  reCaptcha work
         */
        vm.setResponse = function (response) {
          vm.response = response;
        };
        vm.setWidgetId = function (widgetId) {
          vm.widgetId = widgetId;
        };
        vm.cbExpiration = function () {
          vcRecaptchaService.reload(vm.widgetId);
          vm.response = null;
        };

        vm.productionSelectionChange = function (type) {
          if (type == 0) {
            vm.account.isCameraOnly = true
            vm.isCameraOnly = true;
            vm.ysHubOnly = false;
            vm.isNmeaOnly = false;
          }
          else if (type == 1) {
            vm.account.isCameraOnly = false;
            vm.isCameraOnly = false;
            vm.ysHubOnly = true;
            vm.isNmeaOnly = false;
          }
          else if (type == 2) {
            vm.isNmeaOnly = true;
            vm.account.isCameraOnly = false;
            vm.isCameraOnly = false;
            vm.ysHubOnly = false;
          }
        };
        vm.productionSelectionChange(false);
        if (!vm.oemConfig.register.showOptions()) {
          vm.productionSelectionChange(1);
        }
      });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.redirect',
    [
      'yatch-sentinel.services',
      'yatch-sentinel.register',
      'yatch-sentinel.home',
      'yatch-sentinel.forget_password'
    ])
    .config(function ($stateProvider, $translatePartialLoaderProvider) {
      $stateProvider
        .state('redirect', {
          url: '/redirect?access_token',
          templateUrl: 'app/main/redirect/redirect.html',
          controller: 'redirectController',
          controllerAs: 'vm'
        });
      $translatePartialLoaderProvider.addPart('app/main/redirect');
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.redirect')
    .controller('redirectController',
      function (sessionService, accountService, toastr, $state, $location, oemConfig) {
        var vm = this;
        vm.oemConfig = angular.copy(oemConfig);
        vm.rememberMe = false;
        vm.getAccessTokenForIframe = function () {
          var access_token = $location.search().access_token;
          var state = $location.search().state;
          if (access_token != null && access_token != "") {
            sessionService.setAuthToken({
              access_token: access_token
            }, true);
            accountService.me(function (user) {
              sessionService.setUser(user);
              sessionService.setLoginState("redirect");
            });
            $state.go(state, {
            })
          }
        }
        vm.getAccessTokenForIframe();
      });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.register')
    .filter('html', function ($sce) {
      return function (input) {
        return $sce.trustAsHtml(input);
      }
    })
    .directive('ngBindHtmlStr', function ($sce, $parse) {
      return {
        restrict: 'A',
        link: function (scope, elem, attrs) {
          $html = (attrs.ngBindHtmlStr);
          angular.element(elem).append($html);
        }
      }
    })
    .controller('privacyController',
      function (oemConfig, accountService, toastr, $state,$location,$anchorScroll) {
        var vm = this;
        vm.oemConfig = angular.copy(oemConfig);
        vm.hideCheckBox = false;        
        vm.scrollTo = function (id) {
          var old = $location.hash();
          $location.hash(id);
          $anchorScroll();
          $location.hash(old);
        }
        if ($state.params.isPrivacy != undefined) {
          vm.hideCheckBox = true;
          if ($state.params.isPrivacy == "true") {
            vm.scrollTo('privacyPolicyTitle');
          }
        }
        vm.createAccount = function (form) {
          // if(vm.account.agreed==false)
          // {
          accountService.updateAgreedStatus(vm.account.agreed, function (sharedSentinels) {
            vm.account = {};
            form.$setPristine();
            toastr.success('Account Activated');
            $state.go('boat.home');
          });
          // accountService.updateAgreedStatus(vm.account.agreed, function (response) {
          //   debugger
          //   vm.account = {};
          //   form.$setPristine();
          //   toastr.success('Account Activated');
          //   $state.go('boat.home');
          // }, function (error) {
          //   vm.response = null;
          //   toastr.error(error.exceptionMessage);
          // });

        };

      });

})();

(function () {
  'use strict;'
  angular
    .module('yatch-sentinel.notifications', ['yatch-sentinel.services'])
    .config(function ($stateProvider, $translatePartialLoaderProvider) {
      $stateProvider.state('boat.notifications', {
        url: '/notifications/:sentinelId',
        views: {
          'header@boat': {
            templateUrl: 'app/main/notifications/header.html',
            controller: function(oemConfig){
              var vm = this;
              vm.oemConfig = angular.copy(oemConfig);
            },
            controllerAs: 'vm'
          },
          'content@boat': {
            templateUrl: 'app/main/notifications/notifications.html',
            controller: 'notificationsController',
            controllerAs: 'vm',
            resolve: {
              notifications: function (sentinelService) {
                return sentinelService.getSentinelNotifications(1, 5);
              }
            }
          }
        },
        headerClass: 'h75',
        bodyClass: 'notification-box',
        mobileHeader: {
          visible: true,
          title: 'Header.Notifications'
        },
        data: {
          pageTitle: 'Notifications'
        }
      });
      $translatePartialLoaderProvider.addPart('app/main/notifications');
    })
    .directive('notificationMap', function ($timeout, $compile, uiGmapGoogleMapApi, $parse) {
      return {
        restrict: 'E',
        template: '<div class="map_div" style="height: 20rem"></div>',
        link: function (scope, elem, attrs) {
          $timeout(function () {
            uiGmapGoogleMapApi
              .then(function () {
                var mapDiv = $(elem).children()[0];
                mapDiv.id = "google_map_" + Math.floor((Math.random() * 10) + 1);
                var location = $parse(attrs.location)(scope);
                var myLatLng = {
                  lat: location.latitude,
                  lng: location.longitude
                };
                scope.map = new google
                  .maps
                  .Map(document.getElementById(mapDiv.id), {
                    zoom: 15,
                    center: myLatLng,
                    styles: [
                      {
                        "featureType": "water",
                        "stylers": [
                          {
                            "color": "#3ab4e6"
                          }
                        ]
                      }
                    ]
                  });
                var controlString = '<div class="row"><div class="col-sm-12" style="margin-left: 10px"><div class="bt' +
                  'n-group"><label class="btn btn-primary" ng-model="vm.mapType" uib-btn-radio="\'m' +
                  'aritime\'">Maritime map</label><label class="btn btn-primary" ng-model="vm.mapTy' +
                  'pe" uib-btn-radio="\'google\'">Google map</label></div></div></div>';
                var centerControlDiv = $compile(controlString)(scope);
                centerControlDiv.index = 1;
                scope
                  .map
                  .controls[google.maps.ControlPosition.LEFT_TOP]
                  .push(centerControlDiv[0]);
                var marker = new google
                  .maps
                  .Marker({
                    position: {
                      lat: location.latitude,
                      lng: location.longitude
                    },
                    map: scope.map,
                    icon: {
                      url: 'assets/images/boat-location.png'
                    }
                  });
              });

          }, 0);
        }
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.notifications')
    .controller('notificationsController',
      function ($stateParams, cameraService, navigationService, notifications, toastr, $sessionStorage, sentinelService, $scope, notificationHub, $rootScope) {
        var vm = this;
        angular.forEach(notifications.read, function (read) {
          if (read.userSentinel.w2K1SerialKeyId != null && read.extraData != null) {
            var location = angular.fromJson(read.extraData);
            var latitude = location.find(function (item) {
              return item.Key == 59; 
            });
            var longitude = location.find(function (item) {
              return item.Key == 60; 
            });
            read.sentinelLocationId = 0;
            read.sentinelLocation = {
              latitude: Number.parseFloat(latitude.Value),
              longitude: Number.parseFloat(longitude.Value) 
            }
          }
        });

        angular.forEach(notifications.unread, function (unread) {
          if (unread.userSentinel.w2K1SerialKeyId != null && unread.extraData != null) {
            var location = angular.fromJson(unread.extraData);
            var latitude = location.find(function (item) {
              return item.Key == 59; 
            });
            var longitude = location.find(function (item) {
              return item.Key == 60; 
            });
            unread.sentinelLocationId = 0;
            unread.sentinelLocation = {
              latitude: Number.parseFloat(latitude.Value),
              longitude: Number.parseFloat(longitude.Value) 
            }
          }
        });

        angular.forEach(notifications.journalLog, function (journalLog) {
          if (journalLog.userSentinel.w2K1SerialKeyId != null && journalLog.extraData != null) {
            var location = angular.fromJson(journalLog.extraData);
            var latitude = location.find(function (item) {
              return item.Key == 59; 
            });
            var longitude = location.find(function (item) {
              return item.Key == 60; 
            });
            journalLog.sentinelLocationId = 0;
            journalLog.sentinelLocation = {
              latitude: Number.parseFloat(latitude.Value),
              longitude: Number.parseFloat(longitude.Value) 
            }
          }
        });

        vm.mapType = "google";
        vm.showReadMessagesMap = false;
        vm.showNewMessagesMap = false;
        vm.status = {
          isopen: false
        };
        navigationService.navigation = {
          backState: 'boat.home',
          backStateParams: {}
        };
        $scope.$emit('update_notification', {
          unreadNotificationCount: notifications.unread.length
        });
        vm.toggleDropdown = function ($event) {
          $event.preventDefault();
          $event.stopPropagation();
          vm.status.isopen = !vm.status.isopen;
        };

        var hub = new notificationHub();
        hub.on('pushNotification', function () {
          vm.unReadMessagesPageNumber = 0;
          vm.getUnReadNotifications();
          $rootScope.$apply();
        });
        $scope.$on('$destroy', function () {
          hub.off('pushNotification');
        });

        vm.showSnapshot = function (notification) {
          if (notification.snapshotAttachmentUri == undefined) {
            cameraService.getAttachmentBlobUri(notification.userSentinelId, notification.userSentinelCameraEvent.snapshotAttachmentId, function (response) {
              notification.snapshotAttachmentUri = response;
              notification.showSnapshotBool = !notification.showSnapshotBool;
              notification.showVideoBool = false;
              notification.showMapBool = false;
            });
          } else {
            notification.showSnapshotBool = !notification.showSnapshotBool;
            notification.showVideoBool = false;
            notification.showMapBool = false;
          }
        }
        vm.hideSnapshot = function (notification) {

          notification.showSnapshotBool = false;
        }
        vm.hideVideo = function (notification) {

          notification.showVideoBool = false;
        }
        vm.hideMap = function (notification) {

          notification.showMapBool = false;
        }

        vm.showVideo = function (notification) {
          if (notification.videoAttachmentUri == undefined) {
            cameraService.getAttachmentBlobUri(notification.userSentinelId, notification.userSentinelCameraEvent.videoAttachmentId, function (response) {
              notification.videoAttachmentUri = response;
              notification.showVideoBool = !notification.showVideoBool;
              notification.showSnapshotBool = false;
              notification.showMapBool = false;
            });
          } else {
            notification.showVideoBool = !notification.showVideoBool;
            notification.showSnapshotBool = false;
            notification.showMapBool = false;
          }
        }

        vm.showMap = function (notification) {
          notification.showMapBool = !notification.showMapBool;
          notification.showVideoBool = false;
          notification.showSnapshotBool = false;
        }

    
        function mapLocation(notification) {
          if (notification.sentinelLocationId == null)
            return notification;
          else {
            vm.maritimeLocation = notification.sentinelLocation;
            return angular.extend(notification, {
              map: {
                center: {
                  latitude: notification.sentinelLocation.latitude,
                  longitude: notification.sentinelLocation.longitude
                },
                zoom: 16,
                marker: {
                  options: {
                    title: 'Boat location',
                    icon: 'assets/images/boat-location.png'
                  },
                  show: true
                }
              }
            });
          }

        }

        notifications.read.map(function (notification) {
          return mapLocation(notification);
        });
        notifications.unread.map(function (notification) {
          return mapLocation(notification);
        });
        notifications.journalLog.map(function (notification) {
          return mapLocation(notification);
        });

        vm.notifications = notifications;
        vm.readMessagesPageNumber = 1;
        vm.unReadMessagesPageNumber = 0;
        vm.journalLogPageNumber = 1;
        vm.getReadNotificationsSimple = function () {
          vm.readMessagesPageNumber += 1;
          sentinelService.getReadNotifications(vm.readMessagesPageNumber, 5, '', function (response) {
            angular.forEach(response, function (readMessage) {
              vm.notifications.read.push(mapLocation(readMessage));
            });
          });
        };
        vm.markAllNotificationsSeen = function () {
          sentinelService.markAllNotificationsSeen(function (response) {
            sentinelService.getSentinelNotifications(1, 5, function (response) {
              vm.notifications = response;
              $scope.$emit('update_notification_to_zero', {
                unreadNotificationCount: 0
              });
            });
          });
        }
        vm.getJournalLog = function () {
          vm.journalLogPageNumber += 1;
          sentinelService.getJournalLog(vm.journalLogPageNumber, 5, function (response) {
            angular.forEach(response, function (readMessage) {
              vm.notifications.journalLog.push(mapLocation(readMessage));
            });
          });
        };
        vm.getReadNotifications = function (orderBy) {
          if (orderBy != undefined) {
            orderBy = orderBy + " desc"
          }
          sentinelService.getReadNotifications(1, 5, orderBy, function (response) {
            vm.notifications.read = [];
            angular.forEach(response, function (readMessage) {
              vm.notifications.read.push(mapLocation(readMessage));
            });
          });
        };

        vm.showLoadMore = true;
        vm.getUnReadNotifications = function () {
          vm.unReadMessagesPageNumber = vm.unReadMessagesPageNumber + 1;
          sentinelService.getUnReadNotifications(vm.unReadMessagesPageNumber, 5, function (response) {
            angular.forEach(response, function (unreadMessage) {
              vm.notifications.unread.push(unreadMessage);
            });
            $scope.$emit('update_notification', {
              unreadNotificationCount: response.length
            });
            vm.showLoadMore = response.length == 5;
          });
        };
        if (notifications.unread.length < 5) {
          vm.showLoadMore = false;
        }

        vm.getNotifications = function () {
          sentinelService.getSentinelNotifications(1, 5);
        };


      });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.metrics', [
    'yatch-sentinel.services'
  ]).config(function ($stateProvider,$translatePartialLoaderProvider) {
    $stateProvider
      .state('boat.metrics', {
        url: '/metrics/:sentinelId',
        views: {
          'header@boat': {
            templateUrl: 'app/main/metrics/header.html',
            controller: function (oemConfig) {
              var vm = this;
              vm.oemConfig = angular.copy(oemConfig);
            },
            controllerAs: 'vm'
          },
          'content@boat': {
            templateUrl: 'app/main/metrics/metrics.html',
            controller: 'metricsController',
            controllerAs: 'vm',
            resolve: {
              settings: function (userService, $stateParams) {
                return userService.getSettings();
              }
            }
          }
        },
        headerClass: 'half',
        mobileHeader: {
          visible: true,
          title: 'Header.Metrics'
        },
        data: {
          pageTitle: 'Metrics'
        }
      });
      $translatePartialLoaderProvider.addPart('app/main/metrics');
  });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.metrics')
    .controller('metricsController', function (navigationService,settings, userService, toastr, sessionService) {
      var vm = this;
      vm.settings = settings;
      navigationService.navigation = {
        backState: 'boat.home',
        backStateParams: {}
      };
      vm.saveSettings = function () {
        var settings = [];
        angular.forEach(vm.settings, function (s) {
          var setting = {
            settingId: 0,
            allowedSettingValueId: 0
          }
          setting.settingId = s.id;
          if (s.userSettingViewModel == null) {
            setting.allowedSettingValueId = s.allowedSettingValues.filter(function (asv) {
              return asv.isPrimary;
            })[0].id;
          } else {
            setting.allowedSettingValueId = s.userSettingViewModel.allow_Setting_Value;
          }
          settings.push(setting);
        });
        userService.saveSettings(settings, function (response) {
          userService.getSettings(function (response) {
            sessionService.setUserSettings(response);
            toastr.success('Settings saved successfully');
          });
        });
      }
    });
})();

(function () {
  "use strict;";
  angular
    .module("yatch-sentinel.nmea_map", [
      "yatch-sentinel.services",
      "uiGmapgoogle-maps",
    ])
    .config(function ($stateProvider, $translatePartialLoaderProvider) {
      $stateProvider.state("boat.nmea_map", {
        url: "/nmea/map/:sentinelId",
        views: {
          "header@boat": {
            templateUrl: "app/main/map-nmea/header.html",
            controller: "nmeaMapHeaderController",
            controllerAs: "vm",
          },
          "extra_header@boat": {
            templateUrl: "app/main/map-nmea/map-nmea.html",
            controller: "nmeaMapController",
            controllerAs: "vm",
            resolve: {
              location: function (nmeaService, $stateParams) {
                return nmeaService.getSentinelLocation(
                  $stateParams.sentinelId,
                  null,
                  true
                );
              },
            },
          },
        },
        data: {
          pageTitle: "NMEA Map",
          hideMainContent: true,
        },
        headerClass: "half",
        mobileHeader: {
          visible: true,
          title: "Header.NmeaMap",
        },
      });
      $translatePartialLoaderProvider.addPart("app/main/map-nmea");
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.nmea_map')
    .controller('nmeaMapHeaderController', function (nmeaMapService, oemConfig) {
        var vm = this;
        vm.oemConfig = angular.copy(oemConfig);
        vm.location = nmeaMapService.data;
    });
})();

(function () {
  'use strict;'
  angular
    .module('yatch-sentinel.nmea_map')
    .controller('nmeaMapController', function (userService,sessionService,$state, $compile, $scope, navigationService, $filter, location, boatMapService, $stateParams, $q, nmeaService, $, uiGmapGoogleMapApi, $timeout) {
      var vm = this;
      vm.mapType = "maritime";
      navigationService.navigation = {
        backState: 'boat.home',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.enabled = true;
      vm.maritimeLocation = angular.copy(location);
      boatMapService.data = location;
      if (location == undefined) {
        vm.hideMap = true;
      } else {
        vm.hideMap = false;
      }
      vm.initMap = function () {
        uiGmapGoogleMapApi
          .then(function () {
            if (location != undefined) {
              var myLatLng = {
                lat: location.latitude,
                lng: location.longitude
              };
              $timeout(function () {
                vm.map = new google
                  .maps
                  .Map(document.getElementById('google_map'), {
                    zoom: 15,
                    center: myLatLng,
                    styles: [
                      {
                        "featureType": "water",
                        "stylers": [
                          {
                            "color": "#3ab4e6"
                          }
                        ]
                      }
                    ]
                  });

                var controlString = '<div class="row"><div class="col-sm-12" style="margin-left: 10px"><div class="bt' +
                  'n-group"><label class="btn btn-primary" ng-model="vm.mapType" uib-btn-radio="\'m' +
                  'aritime\'">Maritime map</label><label class="btn btn-primary" ng-model="vm.mapTy' +
                  'pe" uib-btn-radio="\'google\'">Google map</label></div></div></div>';
                var centerControlDiv = $compile(controlString)($scope);
                centerControlDiv.index = 1;
                vm
                  .map
                  .controls[google.maps.ControlPosition.LEFT_TOP]
                  .push(centerControlDiv[0]);

                var contentString = '<div class="co-box" ng-non-bindable><label>Latitude</label><p>' + $filter('number')(location.latitude, 4) + '</p><label>Longitude</label><p>' + $filter('number')(location.longitude, 4) + '</p></div>';
                var infowindow = new google
                  .maps
                  .InfoWindow({ content: contentString });
                google
                  .maps
                  .event
                  .addListener(infowindow, 'domready', function () {
                    var iwOuter = $('.gm-style-iw');
                    iwOuter.css({ "top": "20p" });

                    /* The DIV we want to change is above the .gm-style-iw DIV.
                 * So, we use jQuery and create a iwBackground variable,
                 * and took advantage of the existing reference to .gm-style-iw for the previous DIV with .prev().
                 */
                    var iwBackground = iwOuter.prev();

                    // Remove the background shadow DIV
                    iwBackground
                      .children(':nth-child(2)')
                      .css({ 'display': 'none' });

                    // Remove the white background DIV
                    iwBackground
                      .children(':nth-child(4)')
                      .css({ 'display': 'none' });

                    // Moves the infowindow 115px to the right.
                    iwOuter
                      .parent()
                      .parent()
                      .css({ left: '12px' });

                    // /hide arrow
                    iwBackground
                      .children(':nth-child(1)')
                      .css({ 'display': 'none' });
                    iwBackground
                      .children(':nth-child(3)')
                      .css({ 'left': '70px' });
                    var closeDiv = iwOuter.next();
                    closeDiv.css({ 'top': '22px', 'left': '113px', 'border-radius': '5px' });

                  });
                var marker = new google
                  .maps
                  .Marker({
                    position: {
                      lat: location.latitude,
                      lng: location.longitude
                    },
                    map: vm.map,
                    icon: {
                      url: 'assets/images/boat-location.png'
                    }
                  });
                marker.addListener('click', function () {
                  infowindow.open(vm.map, marker);
                });
                vm.getNearByMarines();
                vm.getDistributorMapData();
              });
            }
          });
      };

      /*Get Near By Marines */
      vm.markers = [];
      vm.getNearByMarines = function () {
        nmeaService
          .getNearByMarines($stateParams.sentinelId, function (response) {
            if (response.length > 0) {
              uiGmapGoogleMapApi
                .then(function () {
                  var service = new google
                    .maps
                    .places
                    .PlacesService(vm.map);
                  angular.forEach(response, function (l) {
                    service
                      .getDetails({
                        placeId: l.placeId
                      }, function (place, status) {
                        if (status === google.maps.places.PlacesServiceStatus.OK) {
                          var marker = new google
                            .maps
                            .Marker({
                              position: {
                                lat: parseFloat(l.latitude),
                                lng: parseFloat(l.longitude)
                              },
                              map: vm.map,
                              title: l.name
                            });
                          var imageUrl = '';
                          if (place.photos != undefined && place.photos.length > 0) {
                            var imageUrl = place
                              .photos[0]
                              .getUrl({ 'maxWidth': 500, 'maxHeight': 200 });
                          }
                          hoursText = "Not Found <br/><br/>";
                          if (place.opening_hours != undefined && place.opening_hours.weekday_text.length > 0) {
                            hoursText = "<p> <ul>";
                            for (var i = 0; i < place.opening_hours.weekday_text.length; i++) {
                              var weekday = "<li>" + place.opening_hours.weekday_text[i] + "</li>";
                              hoursText = hoursText + weekday;
                            }
                            hoursText = hoursText + "</ul></p>"
                          }
                          var phoneNumber;
                          if (place.international_phone_number) {
                            phoneNumber = place
                              .international_phone_number
                              .replace(/\s/g, '');
                          }
                          var infowindow = new google
                            .maps
                            .InfoWindow({
                              content: "<div id='content'><p> <img style='width:auto' src=" + imageUrl + "></p><p> <b>Name</b></p><p> " + l.name + " </p><p> <b>Address</b></p><p> " + place.formatted_address + " </p><p> <b> <a href=callto:" + phoneNumber + ">" + place.international_phone_number + "</a></b></p><p> <b>Opening Hours</b></p>" + hoursText + "</div>"
                            });
                          marker.addListener('click', function () {
                            infowindow.open(vm.map, marker);
                          });
                        }
                      });
                  })
                });
            }
          });
      };

      // vm.sentinelLocation = {
      //   center: {
      //     latitude: location.latitude,
      //     longitude: location.longitude
      //   },
      //   zoom: 15,
      //   fill: {
      //     color: '#00FFFFFF',
      //     opacity: 0.0
      //   },
      //   stroke: {
      //     color: '#000000',
      //     weight: 2,
      //     opacity: 0.5
      //   },
      //   windowControl: {},
      //   onMarkerClick: function () {
      //     $timeout(function () {
      //       var windows = vm
      //         .sentinelLocation
      //         .windowControl
      //         .getGWindows();
      //       google
      //         .maps
      //         .event
      //         .addListener(windows[0], 'domready', function () {
      //           // Reference to the DIV which receives the contents of the infowindow using
      //           // jQuery

      //         });
      //     }, 0);

      //   }
      // };

      vm.showYS6Map = function () {
        sessionService.setMapSwitch(false);
        $state.go("boat.map", {
          sentinelId: $stateParams.sentinelId
        })
      }
      vm.getDistributorMapData=function()
      {
        console.log(location);
        if(location!=null)
        {
        userService.getDistributorMapData(location.latitude,location.longitude ,function(response)
          {
            if(response.length>0)
            {
          //    console.log(response);
              response.forEach(function(data) {

                var marker = new google
                .maps
                .Marker({
                  position: {
                    lat: parseFloat(data.latitude),
                    lng: parseFloat(data.longitude)
                  },
                  map: vm.map,
                  title: data.name,
                  icon: {
                    url: 'assets/images/fp-dealer.png'
                  }

                });
                var infowindow = new google
                .maps
                .InfoWindow({
                  content: "<div id='content'><p> <b>Name</b></p><p> " + data.name + " </p><p> <b>Address</b></p><p> " + data.address + " </p><p> <b>Email</b></p><p> " + data.email + " </p><p> <b>Country</b></p><p> " + data.country + " </p><p> <b>City</b></p><p> " + data.city + " </p><p> <b>Latitude</b></p><p> " + data.latitude + " </p><p> <b>Longitude</b></p><p> " + data.longitude + " </p><p> <b>Open Hours</b></p><p> " + data.openingHours + " </p><p> <b>Closed Days</b></p><p> " + data.closedDays + " </p><p> <b>Telephone</b></p><p> " + data.telephone + " </p><p> <b>Website</b></p><p><a style='text-transform: lowercase;' href=\"" + data.website +"\"" + "target=_blank>"+data.website+"</a> </p></div>"
                });
              marker.addListener('click', function () {
                infowindow.open(vm.map, marker);
              });

              });

            }
          });
      }
    }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.nmea_map')
    .service('nmeaMapService', function () {
      return {
        data: {}
      };
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.map', [
      'yatch-sentinel.services',
      'uiGmapgoogle-maps'
    ])
    .config(function ($stateProvider,$translatePartialLoaderProvider) {
      $stateProvider
        .state('boat.map', {
          url: '/map/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/map/header.html',
              controller: 'boatMapHeaderController',
              controllerAs: 'vm'
            },
            'extra_header@boat': {
              templateUrl: 'app/main/map/map.html',
              controller: 'boatMapController',
              controllerAs: 'vm',
              resolve: {
                location: function (sentinelService, $stateParams) {
                  return sentinelService.getSentinelLocation($stateParams.sentinelId);
                },
                currentSentinel: function (userService, $stateParams) {
                  return userService.getUserSentinelById($stateParams.sentinelId);
                }
              }
            }
          },
          data: {
            pageTitle: 'YS6 Map',
            hideMainContent: true
          },
          headerClass: 'half',
          mobileHeader: {
            visible: true,
            title: 'Header.Map'
          }
        });
        $translatePartialLoaderProvider.addPart('app/main/map');
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.map')
    .service('boatMapService', function () {
      return {
        data: {}
      };
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.map')
    .controller('boatMapHeaderController', function (boatMapService, oemConfig) {
        var vm = this;
        vm.oemConfig = angular.copy(oemConfig);
        vm.location = boatMapService.data;
    });
})();

(function () {
  'use strict;'
  angular
    .module('yatch-sentinel.map')
    .controller('boatMapController', function (oemConfig, userService, sessionService, $state, currentSentinel, $compile, $scope, navigationService, $filter, location, boatMapService, $stateParams, $q, sentinelService, $, uiGmapGoogleMapApi, $timeout) {
      var vm = this;
      vm.oemConfig = angular.copy(oemConfig);
      vm.mapType = "maritime";
      navigationService.navigation = {
        backState: 'boat.home',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.maritimeLocation = angular.copy(location);
      vm.currentSentinel = currentSentinel;
      boatMapService.data = location;
      var boatLocation = location;
      if (location == undefined) {
        vm.hideMap = true;
      } else {
        vm.hideMap = false;
      }
      vm.initMap = function () {
        uiGmapGoogleMapApi
          .then(function () {
            if (location != undefined) {
              var myLatLng = {
                lat: location.latitude,
                lng: location.longitude
              };
              $timeout(function () {
                vm.map = new google
                  .maps
                  .Map(document.getElementById('google_map'), {
                    zoom: 15,
                    center: myLatLng,
                    styles: [
                      {
                        "featureType": "water",
                        "stylers": [
                          {
                            "color": "#3ab4e6"
                          }
                        ]
                      }
                    ]
                  });

                var controlString = '<div class="row"><div class="col-sm-12" style="margin-left: 10px"><div class="bt' +
                  'n-group"><label class="btn btn-primary" ng-model="vm.mapType" uib-btn-radio="\'m' +
                  'aritime\'">Maritime map</label><label class="btn btn-primary" ng-model="vm.mapTy' +
                  'pe" uib-btn-radio="\'google\'">Google map</label></div></div></div>';
                var centerControlDiv = $compile(controlString)($scope);
                centerControlDiv.index = 1;
                vm
                  .map
                  .controls[google.maps.ControlPosition.LEFT_TOP]
                  .push(centerControlDiv[0]);

                var contentString = '<div class="co-box" ng-non-bindable><label>Latitude</label><p>' + $filter('number')(location.latitude, 4) + '</p><label>Longitude</label><p>' + $filter('number')(location.longitude, 4) + '</p></div>';
                var infowindow = new google
                  .maps
                  .InfoWindow({ content: contentString });
                google
                  .maps
                  .event
                  .addListener(infowindow, 'domready', function () {
                    var iwOuter = $('.gm-style-iw');
                    iwOuter.css({ "top": "20p" });

                    /* The DIV we want to change is above the .gm-style-iw DIV.
                 * So, we use jQuery and create a iwBackground variable,
                 * and took advantage of the existing reference to .gm-style-iw for the previous DIV with .prev().
                 */
                    var iwBackground = iwOuter.prev();

                    // Remove the background shadow DIV
                    iwBackground
                      .children(':nth-child(2)')
                      .css({ 'display': 'none' });

                    // Remove the white background DIV
                    iwBackground
                      .children(':nth-child(4)')
                      .css({ 'display': 'none' });

                    // Moves the infowindow 115px to the right.
                    iwOuter
                      .parent()
                      .parent()
                      .css({ left: '12px' });

                    // /hide arrow
                    iwBackground
                      .children(':nth-child(1)')
                      .css({ 'display': 'none' });
                    iwBackground
                      .children(':nth-child(3)')
                      .css({ 'left': '70px' });
                    var closeDiv = iwOuter.next();
                    closeDiv.css({ 'top': '22px', 'left': '113px', 'border-radius': '5px' });

                  });
                var marker = new google
                  .maps
                  .Marker({
                    position: {
                      lat: location.latitude,
                      lng: location.longitude
                    },
                    map: vm.map,
                    icon: {
                      url: 'assets/images/boat-location.png'
                    }
                  });
                marker.addListener('click', function () {
                  infowindow.open(vm.map, marker);
                });
                vm.getNearByMarines();
                vm.getDistributorMapData();
              });
            }
          });
      };
      vm.getAllSentinelsLatestLocations = function () {
        sentinelService
          .getAllSentinelsLocation(function (response) {
            if (response.length > 0) {
              angular.forEach(response, function (location) {
                var contentString = '<div class="co-box" ng-non-bindable><label>Latitude</label><p>' + $filter('number')(location.latitude, 4) + '</p><label>Longitude</label><p>' + $filter('number')(location.longitude, 4) + '</p></div>';
                var infowindow = new google
                  .maps
                  .InfoWindow({ content: contentString });
                google
                  .maps
                  .event
                  .addListener(infowindow, 'domready', function () {
                    var iwOuter = $('.gm-style-iw');
                    iwOuter.css({ "top": "20p" });

                    /* The DIV we want to change is above the .gm-style-iw DIV.
               * So, we use jQuery and create a iwBackground variable,
               * and took advantage of the existing reference to .gm-style-iw for the previous DIV with .prev().
               */
                    var iwBackground = iwOuter.prev();

                    // Remove the background shadow DIV
                    iwBackground
                      .children(':nth-child(2)')
                      .css({ 'display': 'none' });

                    // Remove the white background DIV
                    iwBackground
                      .children(':nth-child(4)')
                      .css({ 'display': 'none' });

                    // Moves the infowindow 115px to the right.
                    iwOuter
                      .parent()
                      .parent()
                      .css({ left: '12px' });

                    // /hide arrow
                    iwBackground
                      .children(':nth-child(1)')
                      .css({ 'display': 'none' });
                    iwBackground
                      .children(':nth-child(3)')
                      .css({ 'left': '70px' });
                    var closeDiv = iwOuter.next();
                    closeDiv.css({ 'top': '22px', 'left': '113px', 'border-radius': '5px' });

                  });
                var iconUrl = 'assets/images/boat-location.png';
                if (boatLocation.userSentinelId != location.userSentinelId) {
                  iconUrl = 'assets/images/boat-location2.png'
                }
                var marker = new google
                  .maps
                  .Marker({
                    position: {
                      lat: location.latitude,
                      lng: location.longitude
                    },
                    map: vm.map,
                    icon: {
                      url: iconUrl
                    }
                  });
                marker.addListener('click', function () {
                  infowindow.open(vm.map, marker);
                });
              });
            }
          });
      }
      //vm.initMap();
      /*Get Near By Marines */
      vm.markers = [];
      vm.getNearByMarines = function () {
        sentinelService
          .getNearByMarines($stateParams.sentinelId, function (response) {
            if (response.length > 0) {
              uiGmapGoogleMapApi
                .then(function () {
                  var service = new google
                    .maps
                    .places
                    .PlacesService(vm.map);
                  angular.forEach(response, function (l) {
                    service
                      .getDetails({
                        placeId: l.placeId
                      }, function (place, status) {
                        if (status === google.maps.places.PlacesServiceStatus.OK) {
                          var marker = new google
                            .maps
                            .Marker({
                              position: {
                                lat: parseFloat(l.latitude),
                                lng: parseFloat(l.longitude)
                              },
                              map: vm.map,
                              title: l.name
                            });
                          var imageUrl = '';
                          if (place.photos != undefined && place.photos.length > 0) {
                            var imageUrl = place
                              .photos[0]
                              .getUrl({ 'maxWidth': 500, 'maxHeight': 200 });
                          }
                          hoursText = "Not Found <br/><br/>";
                          if (place.opening_hours != undefined && place.opening_hours.weekday_text.length > 0) {
                            hoursText = "<p> <ul>";
                            for (var i = 0; i < place.opening_hours.weekday_text.length; i++) {
                              var weekday = "<li>" + place.opening_hours.weekday_text[i] + "</li>";
                              hoursText = hoursText + weekday;
                            }
                            hoursText = hoursText + "</ul></p>"
                          }
                          var phoneNumber;
                          if (place.international_phone_number) {
                            phoneNumber = place
                              .international_phone_number
                              .replace(/\s/g, '');
                          }
                          var infowindow = new google
                            .maps
                            .InfoWindow({
                              content: "<div id='content'><p> <img style='width:auto' src=" + imageUrl + "></p><p> <b>Name</b></p><p> " + l.name + " </p><p> <b>Address</b></p><p> " + place.formatted_address + " </p><p> <b> <a href=callto:" + phoneNumber + ">" + place.international_phone_number + "</a></b></p><p> <b>Opening Hours</b></p>" + hoursText + "</div>"
                            });
                          marker.addListener('click', function () {
                            infowindow.open(vm.map, marker);
                          });
                        }
                      });
                  })
                });
            }
          });
      };

      // vm.sentinelLocation = {
      //   center: {
      //     latitude: location.latitude,
      //     longitude: location.longitude
      //   },
      //   zoom: 15,
      //   fill: {
      //     color: '#00FFFFFF',
      //     opacity: 0.0
      //   },
      //   stroke: {
      //     color: '#000000',
      //     weight: 2,
      //     opacity: 0.5
      //   },
      //   windowControl: {},
      //   onMarkerClick: function () {
      //     $timeout(function () {
      //       var windows = vm
      //         .sentinelLocation
      //         .windowControl
      //         .getGWindows();
      //       google
      //         .maps
      //         .event
      //         .addListener(windows[0], 'domready', function () {
      //           // Reference to the DIV which receives the contents of the infowindow using
      //           // jQuery

      //         });
      //     }, 0);

      //   }
      // };

      vm.showNmeaMap = function () {
        sessionService.setMapSwitch(true);
        $state.go("boat.nmea_map", {
          sentinelId: $stateParams.sentinelId
        })
      }
      vm.getDistributorMapData = function () {
        if (location != null) {
          userService.getDistributorMapData(location.latitude, location.longitude, function (response) {
            if (response.length > 0) {
              //      console.log(response);
              response.forEach(function (data) {

                var marker = new google
                  .maps
                  .Marker({
                    position: {
                      lat: parseFloat(data.latitude),
                      lng: parseFloat(data.longitude)
                    },
                    map: vm.map,
                    title: data.name,
                    icon: {
                      url: 'assets/images/fp-dealer.png'
                    }

                  });
                var infowindow = new google
                  .maps
                  .InfoWindow({
                    content: "<div id='content'><p> <b>Name</b></p><p> " + data.name + " </p><p> <b>Address</b></p><p> " + data.address + " </p><p> <b>Email</b></p><p> " + data.email + " </p><p> <b>Country</b></p><p> " + data.country + " </p><p> <b>City</b></p><p> " + data.city + " </p><p> <b>Latitude</b></p><p> " + data.latitude + " </p><p> <b>Longitude</b></p><p> " + data.longitude + " </p><p> <b>Open Hours</b></p><p> " + data.openingHours + " </p><p> <b>Closed Days</b></p><p> " + data.closedDays + " </p><p> <b>Telephone</b></p><p> " + data.telephone + " </p><p> <b>Website</b></p><p><a style='text-transform: lowercase;' href=\"" + data.website + "\"" + "target=_blank>" + data.website + "</a> </p></div>"
                  });
                marker.addListener('click', function () {
                  infowindow.open(vm.map, marker);
                });

              });

            }
          });
        }
      }
    });

})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.documents', [
    'yatch-sentinel.services',
    'flow'
  ]).config(function ($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider
      .state('boat.documents', {
        url: '/documents/:sentinelId',
        views: {
          'header@boat': {
            templateUrl: 'app/main/manage-documents/header.html',
            controller: function(oemConfig){
              var vm = this;
              vm.oemConfig = angular.copy(oemConfig);
            },
            controllerAs: 'vm'
          },
          'content@boat': {
            templateUrl: 'app/main/manage-documents/manage-documents.html',
            controller: 'documentsController',
            controllerAs: 'vm',
            resolve: {
              FilesAndDirectories: function (userService, $stateParams) {
                return userService.getAllUserSentinelDirectoriesAndAttachments($stateParams.sentinelId,null);
              }
            }
          }
        },
        headerClass: 'half short',
        mobileHeader: {
          visible: true,
          title: 'Header.ManageDocuments'
        },
        data: {
          pageTitle: 'Manage Documents'
        }
      });
    $translatePartialLoaderProvider.addPart('app/main/manage-documents');
  });
})();

(function () {
  "use strict;";
  angular
    .module("yatch-sentinel.documents")
    .controller(
      "documentsController",
      function (
        navigationService,
        contactsListService,
        userService,
        toastr,
        config,
        sessionService,
        cfpLoadingBar,
        $rootScope,
        $stateParams,
        oemConfig,
        FilesAndDirectories,
        $uibModal
      ) {
        var vm = this;
        vm.id = null;

        vm.isReadOnlyDirectory = false;
        vm.oemConfig = angular.copy(oemConfig);
        vm.newDirectoryDialog = function () {
          $uibModal
            .open({
              templateUrl:
                "app/main/manage-documents/new-directory-dialog.html",
              controller: "newDirectoryDialogController",
              controllerAs: "vm",
              windowClass: "contact-modal",
              resolve: {
                sentinelId: function () {
                  return $stateParams.sentinelId;
                },
                currentDirectory: function () {
                  return vm.currentDirectory;
                },
              },
            })
            .result.then(function (response) {
              if (response != null) {
                vm.id = response.id;
                vm.child = true;
              }
              userService.getAllUserSentinelDirectoriesAndAttachments(
                $stateParams.sentinelId,
                vm.id,
                function (response) {
                  cfpLoadingBar.complete();
                  vm.uploadedFiles = response.attachments;
                  vm.directories = response.attachmentDirectories;
                  vm.currentDirectory = response.currentDirectory;
                  vm.uploadedFiles.forEach(function (file) {
                    file.isEditAble = false;
                  });
                  vm.directories.forEach(function (file) {
                    file.isEditAble = false;
                  });
                }
              );
            });
        };
        vm.uploadedFiles = FilesAndDirectories.attachments;
        vm.directories = FilesAndDirectories.attachmentDirectories;
        vm.currentDirectory = FilesAndDirectories.currentDirectory;
        vm.parentDirectories = FilesAndDirectories.parentDirectories;
        vm.filesanddir = FilesAndDirectories;
        vm.folderLink = null;
        vm.uploadedFiles.forEach(function (file) {
          file.isEditAble = false;
        });
        vm.directories.forEach(function (file) {
          file.isEditAble = false;
          vm.child = false;
        });
        vm.flowProgressValue = 0;
        vm.showProgressBar = false;
        vm.editable = false;
        navigationService.navigation = {
          backState: "boat.home",
          backStateParams: {},
        };
        vm.uploadApi = {
          target:
            config.apiUrl +
            "api/user/usersentinel/" +
            $stateParams.sentinelId +
            "/file?attachmentDirectoryId=" +
            vm.id,
          headers: {
            Authorization:
              "Bearer " + sessionService.getAuthToken().access_token,
          },
          method: "POST",
          permanentErrors: [500, 501],
          singleFile: true,
          chunkSize: Number.MAX_VALUE,
        };

        vm.onUploadStarted = function (file, flow) {
          flow.opts.target =
            config.apiUrl +
            "api/user/usersentinel/" +
            $stateParams.sentinelId +
            "/file?attachmentDirectoryId=" +
            vm.id;
          vm.showProgressBar = true;
        };

        vm.flowProgress = function (flow) {
          vm.flowProgressValue = flow.progress() * 100;
        };

        vm.onUploadComplete = function () {
          vm.showProgressBar = false;
        };

        vm.deleteUploadedFile = function (file) {
          if (confirm("Are you sure you want to Delete this File?")) {
            userService.deleteUserSentinelAttachment(
              $stateParams.sentinelId,
              file.id,
              function (response) {
                const fileIndexToDelete = vm.uploadedFiles.indexOf(file);
                vm.uploadedFiles.splice(fileIndexToDelete, 1);
                toastr.success("File Deleted Successfully.");
              }
            );
          }
        };
        vm.deleteDirectoryById = function (file) {
          if (confirm("Are you sure you want to Delete this Directory?")) {
            userService.deleteDirectoryById(
              file.id,
              $stateParams.sentinelId,
              function (response) {
                const fileIndexToDelete = vm.directories.indexOf(file);
                vm.directories.splice(fileIndexToDelete, 1);
                toastr.success("Directory Deleted Successfully.");
              }
            );
          }
        };
        vm.saveUploadedFile = function (file) {
          var fileExtension = file.name.split(".");
          if (fileExtension.length > 1) {
            file.name = file.dummyName + "." + fileExtension[1];
          }
          userService.updateUserSentinelAttachment(
            $stateParams.sentinelId,
            file.id,
            file.name,
            function (response) {
              toastr.success("File Updated Successfully.");
              file.isEditAble = false;
            }
          );
        };
        vm.updateDirectoryName = function (file) {
          userService.updateDirectoryName(
            file.id,
            $stateParams.sentinelId,
            file.name,
            function (response) {
              toastr.success("File Updated Successfully.");
              file.isEditAble = false;
            }
          );
        };

        vm.editUploadedFile = function (file) {
          file.isEditAble = true;
        };

        vm.onUploadSuccess = function (file, $message) {
          userService.getAllUserSentinelDirectoriesAndAttachments(
            $stateParams.sentinelId,
            vm.id,
            function (response) {
              cfpLoadingBar.complete();
              toastr.success("File Uploaded successfully");
              vm.uploadedFiles = response.attachments;
              vm.directories = response.attachmentDirectories;
              vm.currentDirectory = response.currentDirectory;
              if (vm.currentDirectory != null) {
                vm.id = vm.currentDirectory.id;
                vm.child = true;
              }

              vm.uploadedFiles.forEach(function (file) {
                file.isEditAble = false;
              });
              vm.directories.forEach(function (file) {
                file.isEditAble = false;
              });
            }
          );
        };

        // vm.downloadFile = function (file) {
        //   userService
        //     .downloadUserSentinelAttachment($stateParams.sentinelId, file.attachment.id, function (response) {
        //       window.open(response);
        //     });
        // }
        vm.getChildDirectoriesAndAttachments = function (file) {
          userService.getAllUserSentinelDirectoriesAndAttachments(
            $stateParams.sentinelId,
            file.id,
            function (response) {
              cfpLoadingBar.complete();
              // toastr.success('get inside');
              vm.uploadedFiles = response.attachments;
              vm.directories = response.attachmentDirectories;
              vm.currentDirectory = response.currentDirectory;
              vm.parentDirectories = response.parentDirectories;

              if (vm.currentDirectory == null) {
                vm.isReadOnlyDirectory = false;
              } else {
                if (vm.currentDirectory.isReadOnly == null) {
                  vm.isReadOnlyDirectory = false;
                } else {
                  vm.isReadOnlyDirectory = vm.currentDirectory.isReadOnly;
                }
              }

              if (vm.parentDirectories == null) {
                if(vm.currentDirectory!=null){
                  vm.folderLink = vm.currentDirectory;
                }
              } else {
                vm.folderLink = vm.parentDirectories;
              }

              if (vm.currentDirectory != null) {
                vm.id = vm.currentDirectory.id;
              }
              vm.child = true;
              vm.uploadedFiles.forEach(function (file) {
                file.isEditAble = false;
              });
              vm.directories.forEach(function (file) {
                file.isEditAble = false;
              });
            }
          );
        };
        vm.getChildDirectoriesAndAttachmentsBack = function (id) {
          userService.getAllUserSentinelDirectoriesAndAttachments(
            $stateParams.sentinelId,
            id,
            function (response) {
              cfpLoadingBar.complete();
              //    toastr.success('come out');
              vm.uploadedFiles = response.attachments;
              vm.directories = response.attachmentDirectories;
              vm.currentDirectory = response.currentDirectory;
              vm.parentDirectories = response.parentDirectories;


              if (vm.currentDirectory == null) {
                vm.isReadOnlyDirectory = false;
              } else {
                if (vm.currentDirectory.isReadOnly == null) {
                  vm.isReadOnlyDirectory = false;
                } else {
                  vm.isReadOnlyDirectory = vm.currentDirectory.isReadOnly;
                }
              }

              vm.folderLink=null
              if (vm.parentDirectories == null) {
                if(vm.currentDirectory!=null){
                  vm.folderLink = vm.currentDirectory;
                }
              } else {
                vm.folderLink = vm.parentDirectories;
              }


              if (vm.currentDirectory == null) {
                vm.child = false;
              } else {
                vm.child = true;
                vm.id = vm.currentDirectory.id;
              }

              vm.uploadedFiles.forEach(function (file) {
                file.isEditAble = false;
              });
              vm.directories.forEach(function (file) {
                file.isEditAble = false;
              });
            }
          );
        };
        vm.downloadFile = function (file) {
          var url =
            config.apiUrl +
            "api/user/userSentinel/" +
            $stateParams.sentinelId +
            "/document/" +
            file.id +
            "/download";
          var token = sessionService.getAuthToken();
          if (token) {
            url += "?access_token=" + token.access_token;
          }
          window.location.href = url;
        };
      }
    );
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.documents')
    .controller('newDirectoryDialogController', function (userService, toastr, $uibModalInstance, sentinelId,currentDirectory) {
      var vm = this;
      vm.userSentinelId=sentinelId;
      vm.currentDirectory=currentDirectory;
      if(vm.currentDirectory!=null)
      {
        vm.directory = {
          parentId:vm.currentDirectory.id,
          userSentinelId : vm.userSentinelId};
      }
      else
      {
      vm.directory = {
        userSentinelId : vm.userSentinelId};
      }
      vm.saveDirectory = function () {
        userService.saveDirectory(vm.directory,vm.userSentinelId, function (response) {
          toastr.success('Directory added successfully');
          $uibModalInstance.close(vm.currentDirectory);
        });
      };

    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.login',
    [
      'yatch-sentinel.services',
      'yatch-sentinel.register',
      'yatch-sentinel.home',
      'yatch-sentinel.forget_password',
      'yatch-sentinel.accountDetails'
    ])
    .config(function ($stateProvider, $translatePartialLoaderProvider) {
      $stateProvider
        .state('login', {
          url: '/login?mimickTokenId',
          templateUrl: 'app/main/login/login.html',
          controller: 'loginController',
          controllerAs: 'vm'
        });
      $translatePartialLoaderProvider.addPart('app/main/login');
    });
})();

(function () {
  "use strict;";
  angular
    .module("yatch-sentinel.login")
    .controller(
      "loginController",
      function (
        sessionService,
        config,
        accountService,
        toastr,
        $state,
        $location,
        userService,
        $scope,
        $timeout,
        $localStorage,
        moment,
        oemConfig,
        $uibModal
      ) {
        var vm = this;
        vm.oemConfig = angular.copy(oemConfig);
        vm.rememberMe = false;
        vm.agreed = false;
        vm.queryString= $location.search();
        vm.checkProtocol = function () {
          if (location.protocol !== "https:") {
            var url = location.href.substring(location.protocol.length);
            location.replace("https:" + url);
          }
        };
        if (
          config.environment == "Production" ||
          config.environment == "Test"
        ) {
          vm.checkProtocol();
        }
        vm.login = function () {
          accountService.login(
            vm.user,
            function (response) {
              toastr.success("Logged in");
              sessionService.setAuthToken(response, vm.rememberMe);
              accountService.me(function (user) {
                vm.agreed = user.agreed;
                sessionService.setUser(user);
                sessionService.setLoginState("web");

                userService.getUserSentinels(function (sentinels) {
                  userService.getSettings(function (response) {
                    sessionService.setUserSettings(response);
                  });

                  userService.getSharedSentinels(function (sharedSentinels) {
                    sharedSentinels.forEach(function (element) {
                      sentinels.push(element);
                    });
                    var isAdmin = false;
                    for (var i = 0; i < user.userRoles.length; i++) {
                      if (user.userRoles[i].roleId == 1) {
                        isAdmin = true;
                      }
                      if (isAdmin) {
                        break;
                      }
                    }
                    if (vm.agreed == true) {
                      if (!isAdmin) {
                        $scope.$broadcast("loggedIn");
                        if(!user.isPasswordPolicySatisfied && !user.isPasswordUpdateSkipped){
                           $state.go("update-password");
                           return;
                        }
                        if (sentinels.length == 0) {
                          $state.go("boat.home", {
                            sentinelId: ""
                          });
                        } else {
                          $state.go("boat.home", {
                            sentinelId: sentinels[0].id
                          });
                        }
                      } else {
                        if(!user.isPasswordPolicySatisfied && !user.isPasswordUpdateSkipped){
                           $state.go("update-password");
                           return;
                        }
                        $state.go("admin.home");
                      }
                    } else {
                      vm.acceptTermsAndConditions(user);
                    }
                  });
                });
              });
            },
            function (err) {
              toastr.error(err.error);
            }
          );
        };

        vm.acceptTermsAndConditions = function (user) {
          $uibModal
            .open({
              templateUrl:
                "app/main/account-settings/termsAndconditions/accept-terms.html",
              controller: "acceptTermsDialogController",
              controllerAs: "vm",
              windowClass: "contact-modal",
              resolve: {
                user: function () {
                  return angular.copy(user);
                },
                login: function () {
                  return true;
                }
              }
            })
            .result.then(
              function () {
                if(vm.queryString.isEmailChanged){
                  $location.url('accountDetails?isEmailChanged=true');
                }else{
                  $state.go('accountDetails');
                }
              },
              function () {
                sessionService.deleteAuthToken();
              }
            );
        };
        vm.mimickUser = function () {
          accountService.mimickUser(
            $state.params.mimickTokenId,
            function (response) {
              toastr.success("Logged in");
              sessionService.setAuthToken(response, vm.rememberMe);
              accountService.me(function (user) {
                sessionService.setUser(user);
                sessionService.setLoginState("web");
                userService.getSettings(function (settings) {
                  sessionService.setUserSettings(settings);
                  var isAdmin = false;
                  for (var i = 0; i < user.userRoles.length; i++) {
                    if (user.userRoles[i].roleId == 1) {
                      isAdmin = true;
                    }
                    if (isAdmin) {
                      break;
                    }
                  }
                  if (!isAdmin) {
                    $scope.$broadcast("loggedIn");
                    $state.go("boat.home", {
                      sentinelId: Number(response.sentinelId)
                    });
                  } else {
                    $state.go("admin.home");
                  }
                });
              });
            },
            function (err) {
              toastr.error(err.error);
            }
          );
        };

        function refresh_auth_tokens() {
          var accessToken = sessionService.getAuthToken();
          if (accessToken == undefined || accessToken == null) {
            return;
          }
          var expiryTime = moment(accessToken[".expires"]).subtract(
            5,
            "minutes"
          );
          var diff = expiryTime.diff(moment());
          if (diff <= 0 && $localStorage.rememberMe) {
            $timeout(function () {
              accountService.refreshToken(
                accessToken.refresh_token,
                function (response) {
                  sessionService.setAuthToken(
                    response,
                    $localStorage.rememberMe
                  );
                  userService.getUserSentinels(function (sentinels) {
                    userService.getSettings(function (response) {
                      sessionService.setUserSettings(response);
                    });
                    userService.getSharedSentinels(function (sharedSentinels) {
                      sharedSentinels.forEach(function (element) {
                        sentinels.push(element);
                      });
                      accountService.me(function (user) {
                        vm.agreed = user.agreed;
                        sessionService.setUser(user);
                        sessionService.setLoginState("web");
                        if (vm.agreed == true) {
                          if (sentinels.length == 0) {
                            $state.go("boat.home", {
                              sentinelId: "",
                            });
                          } else {
                            $state.go("boat.home", {
                              sentinelId: sentinels[0].id
                            });
                          }
                        } else {
                          vm.acceptTermsAndConditions(user);
                        }
                      });
                    });
                  });
                },
                function () {
                  //toastr.error(err.error)
                }
              );
            });
          } else if (diff > 0) {
            userService.getUserSentinels(function (sentinels) {
              userService.getSettings(function (response) {
                sessionService.setUserSettings(response);
              });
              userService.getSharedSentinels(function (sharedSentinels) {
                sharedSentinels.forEach(function (element) {
                  sentinels.push(element);
                });
                accountService.me(function (user) {
                  vm.agreed = user.agreed;
                  sessionService.setUser(user);
                  sessionService.setLoginState("web");
                  if (vm.agreed == true) {
                    if (sentinels.length == 0) {
                      $state.go("boat.home", {
                        sentinelId: "",
                      });
                    } else {
                      $state.go("boat.home", {
                        sentinelId: sentinels[0].id,
                      });
                    }
                  } else {
                    vm.acceptTermsAndConditions(user);
                  }
                });
              });
            });
          }
        }
        refresh_auth_tokens();

        if ($state.params.mimickTokenId != undefined) {
          vm.mimickUser();
        }
      }
    );
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.landing_page', [])
    .config(function ($stateProvider, $translatePartialLoaderProvider) {
      $stateProvider
        .state('landing_page', {
          url: '/',
          templateUrl: 'app/main/landing-page/main.html',
          controller: 'landingPageController',
          controllerAs: 'vm'
        });
      $translatePartialLoaderProvider.addPart('app/main/landing-page');
    })
    .controller('landingPageController', function (config, $window, $state, sessionService, $timeout, $localStorage, toastr, accountService, userService,
      moment, $stateParams, cameraService, oemConfig, $translate, $uibModal) {
      var vm = this;
      vm.oemConfig = angular.copy(oemConfig);
      vm.checkProtocol = function () {
        if (location.protocol !== 'https:') {
          var url = location.href.substring(location.protocol.length);
          location.replace('https:' + url);
        }
      }
      if (config.environment == 'Production' || config.environment == 'Test') {
        vm.checkProtocol();
      }
      $translate(vm.oemConfig.landing.tagLine).then(function (translation) {
        vm.tagLine = translation;
      });
      // vm.$onInit = function () {
      //   var url = $location.absUrl();
      //   var codeExist = url.includes('code=');
      //   if (codeExist) {
      //     var codeIndex = url.indexOf('code=');
      //     var start = codeIndex + 5;
      //     var end = url.indexOf('#/');
      //     var code = url.slice(start, end)
      //     var userSentinelId = sessionService.getUserSentinel();
      //     cameraService.getAccessToken(code, userSentinelId, function (onSuccess) {
      //       toastr.success("Cameras Linked Successfully!");
      //       $window.open(config.webUrl + "#/", "_self")
      //     });
      //   }
      //   else {
      //     refresh_auth_tokens();
      //   }
      // };
      // vm.$onInit();
      vm.login = function () {
        $state.go('login');
      };

      function refresh_auth_tokens() {
        var accessToken = sessionService.getAuthToken();
        if (accessToken == undefined || accessToken == null) {
          return;
        };
        var expiryTime = moment(accessToken[".expires"]).subtract(5, 'minutes');
        var diff = expiryTime.diff(moment());
        if (diff <= 0 && $localStorage.rememberMe) {
          $timeout(function () {
            accountService.refreshToken(accessToken.refresh_token, function (response) {
              sessionService.setAuthToken(response, $localStorage.rememberMe);
              userService.getUserSentinels(function (sentinels) {
                userService.getSettings(function (response) {
                  sessionService.setUserSettings(response);
                });
                userService.getSharedSentinels(function (sharedSentinels) {
                  sharedSentinels.forEach(function (element) {
                    sentinels.push(element);
                  });
                  accountService.me(function (user) {
                    vm.agreed = user.agreed;
                    sessionService.setUser(user);
                    sessionService.setLoginState("web");
                    if (vm.agreed == true) {
                      if (sentinels.length == 0) {
                        $state.go('boat.home', {
                          sentinelId: ''
                        });
                      }
                      else {
                        $state.go('boat.home', {
                          sentinelId: sentinels[0].id
                        });
                      }
                    }
                    else {
                      vm.acceptTermsAndConditions(user);
                    }
                  });
                });
              });
            }, function (err) {
              //toastr.error(err.error)
            });
          });
        } else if (diff > 0) {
          userService.getUserSentinels(function (sentinels) {
            userService.getSettings(function (response) {
              sessionService.setUserSettings(response);
            });
            userService.getSharedSentinels(function (sharedSentinels) {
              sharedSentinels.forEach(function (element) {
                sentinels.push(element);
              });
              accountService.me(function (user) {
                vm.agreed = user.agreed;
                sessionService.setUser(user);
                sessionService.setLoginState("web");
                if (vm.agreed == true) {
                  if (sentinels.length == 0) {
                    $state.go('boat.home', {
                      sentinelId: ''
                    });
                  }
                  else {
                    $state.go('boat.home', {
                      sentinelId: sentinels[0].id
                    });
                  }
                }
                else {
                 vm.acceptTermsAndConditions(user);
                }
              });
            });
          });
        }
      }
      refresh_auth_tokens();
      vm.acceptTermsAndConditions = function (user) {
        $uibModal.open({
            templateUrl: 'app/main/account-settings/termsAndconditions/accept-terms.html',
            controller: 'acceptTermsDialogController',
            controllerAs: 'vm',
            windowClass: 'contact-modal',
            resolve: {
                user: function () {
                    return angular.copy(user);
                },
                login : function() {
                  return true;
                }
            }
        }).result.then(function(){
          $state.go('accountDetails');
        },
        function (error) {
         sessionService.deleteAuthToken();
        });
      };
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.nmea_journey', [
      'yatch-sentinel.services',
      'uiGmapgoogle-maps'
    ])
    .config(function ($stateProvider,$translatePartialLoaderProvider) {
      $stateProvider
        .state('boat.nmea_journey', {
          url: '/nmea/journey/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/journey-nmea/header.html',
              controller: function (oemConfig) {
                var vm = this;
                vm.oemConfig = angular.copy(oemConfig);
              },
              controllerAs: 'vm'
            },
            'extra_header@boat': {
              templateUrl: 'app/main/journey-nmea/journey-nmea.html',
              controller: 'nmeaJourneyMapController',
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/journey-nmea/journey-nmea-summary.html',
              controller: 'nmeaJourneyController',
              controllerAs: 'vm',
              resolve: {
                summary: function (nmeaService, $stateParams) {
                  return nmeaService.getSentinelRouteSummary($stateParams.sentinelId, 'day',null,true);
                },
                routes: function (nmeaService, $stateParams) {
                  return nmeaService.getSentinelRoute($stateParams.sentinelId, 'day',null,true);
                }
              }
            }
          },
          headerClass: 'half',
          data: {
            pageTitle: 'NMEA Journey log'
          },
          mobileHeader: {
            visible: true,
            title: 'Header.NmeaJourneylog'
          }
        });
        $translatePartialLoaderProvider.addPart('app/main/journey-nmea');
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.nmea_journey')
    .controller('nmeaJourneyController', function (RecenterMap, $timeout, navigationService, summary, $stateParams, $state, nmeaService, routes, $filter, config) {
      var vm = this;
      vm.duration = 'day';
      vm.summary = summary;
      navigationService.navigation = {
        backState: 'boat.home',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };

      vm.markers = [];
      function makeSmooth(path, numIterations) {
        numIterations = Math.min(Math.max(numIterations, 1), 10);
        while (numIterations > 0) {
          path = smooth(path);
          numIterations--;
        }
        return path;
      }
      var recenterMapControl = new RecenterMap(ol.proj.fromLonLat([0,0]));
      vm.initMap = function () {
        vm.map = new ol.Map({
          controls: ol.control.defaults().extend([recenterMapControl]),
          target: "journey_map",
          layers: [
            new ol.layer.Tile({
              source: new ol.source.OSM({
                attributions: []
              }),
            }),
            new ol.layer.Tile({
              source: new ol.source.XYZ({
                url: "https://t1.openseamap.org/seamark/{z}/{x}/{y}.png",
              }),
            })
          ],
          view: new ol.View({
            center: ol.proj.fromLonLat([0, 0]),
            zoom: 16,
          }),
        });
        if (routes.length > 0) {
          plotJourney();
        }
      };
      vm.initMap();
      function plotJourney() {
        vm.map.removeControl(recenterMapControl);
        recenterMapControl = new RecenterMap(ol.proj.fromLonLat([routes[routes.length - 1].longitude, routes[routes.length - 1].latitude]));
        vm.map.addControl(recenterMapControl);
        vm.map.getView().setCenter(ol.proj.fromLonLat([routes[routes.length - 1].longitude, routes[routes.length - 1].latitude]));
        var locations = routes.map(function (j) {
          return ol.proj.fromLonLat(
            [j.longitude, j.latitude]
          );
        });
        var smoothened = makeSmooth(locations, 3);
        var route = new ol.geom.LineString(smoothened);
        var routeCoords = route.getCoordinates();
        var routeLength = routeCoords.length;
        var routeFeature = new ol.Feature({
          type: "route",
          geometry: route,
        });
        var geoMarkers = [];
        geoMarkers.push(routeFeature);
        var startMarker = new ol.Feature({
          type: "startMarker",
          geometry: new ol.geom.Point(routeCoords[0]),
        });
        geoMarkers.push(startMarker);
        var endMarker = new ol.Feature({
          type: "endMarker",
          geometry: new ol.geom.Point(routeCoords[routeLength - 1]),
        });
        geoMarkers.push(endMarker);
        var styles = {
          route: new ol.style.Style({
            stroke: new ol.style.Stroke({
              width: 3,
              color: '#003055',
            }),
          }),
          endMarker: new ol.style.Style({
            image: new ol.style.Icon({
              src: "assets/images/boat-image-png.png",
              scale: 0.30,
              rotation: routes[routes.length - 1].course
            }),
          }),
          startMarker: new ol.style.Style({
            image: new ol.style.Circle({
              radius: 8,
              snapToPixel: false,
              fill: new ol.style.Fill({
                color: "#003055",
              }),
              stroke: new ol.style.Stroke({
                color: "white",
                width: 1,
              }),
            }),
          }),
        };
        var vectorLayer = new ol.layer.Vector({
          name: 'journey',
          source: new ol.source.Vector({
            features: geoMarkers,
          }),
          style: function (feature) {
            return styles[feature.get("type")];
          },
        });
        vm.map.addLayer(vectorLayer);
      }
      vm.getSummary = function (duration) {
        vm.duration = duration;
        nmeaService.getSentinelRouteSummary($stateParams.sentinelId, duration, function (response) {
          vm.summary = response;
        },true);
        nmeaService.getSentinelRoute($stateParams.sentinelId, duration, function (response) {
          routes = response;
          var layers = vm.map.getLayers();
          layers.forEach(function (layer) {
            if (layer && layer.get('name') == 'journey') {
              vm.map.removeLayer(layer);
            }
          });
          if (routes.length > 0) {
            plotJourney();
          }
        },true);
      };

      vm.CenterControl = function (controlDiv) {
        var elementExists = document.getElementById("re-center");
        if (!elementExists) {
          // Set CSS for the control border.
          var controlUI = document.createElement("div");
          controlUI.id = "re-center";
          controlUI.style.backgroundColor = "#fff";
          controlUI.style.border = "2px solid #fff";
          controlUI.style.borderRadius = "3px";
          controlUI.style.backgroundImage = "url(../assets/images/mylocation-icon.png)";
          controlUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
          controlUI.style.cursor = "pointer";
          controlUI.style.marginRight = "10px";
          controlUI.style.textAlign = "center";
          controlUI.style.width = "40px";
          controlUI.style.height = "40px";
          controlUI.title = "Click to recenter the map";
          controlDiv.appendChild(controlUI);
          // Set CSS for the control interior.
          // var controlText = document.createElement("div");
          // controlText.style.color = "rgb(25,25,25)";
          // controlText.style.fontFamily = "Roboto,Arial,sans-serif";
          // controlText.style.fontSize = "16px";
          // controlText.style.lineHeight = "38px";
          // controlText.style.paddingLeft = "5px";
          // controlText.style.paddingRight = "5px";
          //   controlText.innerHTML = "Center Map";
          //    controlUI.appendChild(controlText);
          // Setup the click event listeners: simply set the map to location.
          controlUI.addEventListener("click", function () {
            vm.map.setCenter(vm.boatLastLocation);
          });
        }
      };

    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.nmea_journey')
    .service('nmeaJourneyService', function () {
      return {
        data: {
          map: {
            center: {
              latitude: 0,
              longitude: 0
            },
            zoom: 16,
            markers: []
          }
        }
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.nmea_journey')
    .controller('nmeaJourneyMapController', function (sessionService,$state, $stateParams, nmeaJourneyService, $scope, config) {
      var vm = this;
      vm.journeyData = nmeaJourneyService.data;

      vm.enabled = true;
      vm.showYS6JourneyLog = function () {
        sessionService.setJournySwitch(false);
        $state.go("boat.journey", {
          sentinelId: $stateParams.sentinelId
        })
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.journey', [
      'yatch-sentinel.services',
      'uiGmapgoogle-maps'
    ])
    .config(function ($stateProvider,$translatePartialLoaderProvider) {
      $stateProvider
        .state('boat.journey', {
          url: '/journey/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/journey/header.html',
              controller: function(oemConfig){
                var vm = this;
                vm.oemConfig = angular.copy(oemConfig);
              },
              controllerAs: 'vm'
            },
            'extra_header@boat': {
              templateUrl: 'app/main/journey/journey.html',
              controller: 'journeyMapController',
              controllerAs: 'vm',
              resolve: {
                currentSentinel: function (userService, $stateParams) {
                  return userService.getUserSentinelById($stateParams.sentinelId);
                }
              }
            },
            'content@boat': {
              templateUrl: 'app/main/journey/journey-summary.html',
              controller: 'boatJourneyController',
              controllerAs: 'vm',
              resolve: {
                summary: function (sentinelService, $stateParams) {
                  return sentinelService.getSentinelRouteSummary($stateParams.sentinelId, 'day');
                },
                routes: function (sentinelService, $stateParams) {
                  return sentinelService.getSentinelRoute($stateParams.sentinelId, 'day');
                },
                currentSentinel: function (userService, $stateParams) {
                  return userService.getUserSentinelById($stateParams.sentinelId);
                }
              }
            }
          },
          headerClass: 'half',
          data: {
            pageTitle: 'YS6 Journey log'
          },
          mobileHeader: {
            visible: true,
            title: 'Header.JourneyLog'
          }
        });
        $translatePartialLoaderProvider.addPart('app/main/journey');
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.journey')
    .service('journeyService', function () {
      return {
        data: {
          map: {
            center: {
              latitude: 0,
              longitude: 0
            },
            zoom: 16,
            markers: []
          }
        }
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.journey')
    .controller('journeyMapController', function (oemConfig,sessionService,$state,$stateParams,currentSentinel, journeyService, $scope, config) {
      var vm = this;
      vm.journeyData = journeyService.data;
      vm.oemConfig = angular.copy(oemConfig);
      vm.currentSentinel = currentSentinel;
      vm.showNmeaJourneyLog = function () {
        sessionService.setJournySwitch(true);
        $state.go("boat.nmea_journey", {
          sentinelId: $stateParams.sentinelId
        })
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.journey')
    .controller('boatJourneyController', function (oemConfig, RecenterMap, navigationService, summary, $stateParams, $state, sentinelService, routes, journeyService, $filter, config) {
      var vm = this;
      vm.oemConfig = angular.copy(oemConfig);
      vm.duration = 'day';
      vm.summary = summary;
      navigationService.navigation = {
        backState: 'boat.home',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      function makeSmooth(path, numIterations) {
        numIterations = Math.min(Math.max(numIterations, 1), 10);
        while (numIterations > 0) {
          path = smooth(path);
          numIterations--;
        }
        return path;
      }
      vm.markers = [];
      var recenterMapControl = new RecenterMap(ol.proj.fromLonLat([0,0]));
      vm.initMap = function () {
        vm.map = new ol.Map({
          controls: ol.control.defaults().extend([recenterMapControl]),
          target: "journey_map",
          layers: [
            new ol.layer.Tile({
              source: new ol.source.OSM({
                attributions: []
              }),
            }),
            new ol.layer.Tile({
              source: new ol.source.XYZ({
                url: "https://t1.openseamap.org/seamark/{z}/{x}/{y}.png",
              }),
            })
          ],
          view: new ol.View({
            center: ol.proj.fromLonLat([0, 0]),
            zoom: 16,
          }),
        });
        if (routes.length > 0) {
          plotJourney();
        }
      };
      vm.initMap();
      function plotJourney() {
        vm.map.removeControl(recenterMapControl);
        recenterMapControl = new RecenterMap(ol.proj.fromLonLat([routes[routes.length - 1].longitude, routes[routes.length - 1].latitude]));
        vm.map.addControl(recenterMapControl);
        vm.map.getView().setCenter(ol.proj.fromLonLat([routes[routes.length - 1].longitude, routes[routes.length - 1].latitude]));
        var locations = routes.map(function (j) {
          return ol.proj.fromLonLat(
            [j.longitude, j.latitude]
          );
        });
        var smoothened = makeSmooth(locations, 3);
        var route = new ol.geom.LineString(smoothened);
        var routeCoords = route.getCoordinates();
        var routeLength = routeCoords.length;
        var routeFeature = new ol.Feature({
          type: "route",
          geometry: route,
        });
        var geoMarkers = [];
        geoMarkers.push(routeFeature);
        var startMarker = new ol.Feature({
          type: "startMarker",
          geometry: new ol.geom.Point(routeCoords[0]),
        });
        geoMarkers.push(startMarker);
        var endMarker = new ol.Feature({
          type: "endMarker",
          geometry: new ol.geom.Point(routeCoords[routeLength - 1]),
        });
        geoMarkers.push(endMarker);
        var styles = {
          route: new ol.style.Style({
            stroke: new ol.style.Stroke({
              width: 3,
              color: '#003055',
            }),
          }),
          endMarker: new ol.style.Style({
            image: new ol.style.Icon({
              src: "assets/images/boat-image-png.png",
              scale: 0.30,
              rotation: routes[routes.length - 1].course
            }),
          }),
          startMarker: new ol.style.Style({
            image: new ol.style.Circle({
              radius: 8,
              snapToPixel: false,
              fill: new ol.style.Fill({
                color: "#003055",
              }),
              stroke: new ol.style.Stroke({
                color: "white",
                width: 1,
              }),
            }),
          }),
        };
        var vectorLayer = new ol.layer.Vector({
          name: 'journey',
          source: new ol.source.Vector({
            features: geoMarkers,
          }),
          style: function (feature) {
            return styles[feature.get("type")];
          },
        });
        vm.map.addLayer(vectorLayer);
      }


      vm.getSummary = function (duration) {
        vm.duration = duration;
        sentinelService.getSentinelRouteSummary($stateParams.sentinelId, duration, function (response) {
          vm.summary = response;
        });
        sentinelService.getSentinelRoute($stateParams.sentinelId, duration, function (response) {
          routes = response;
          var layers = vm.map.getLayers();
          layers.forEach(function (layer) {
            if (layer && layer.get('name') == 'journey') {
              vm.map.removeLayer(layer);
            }
          });
          if (routes.length > 0) {
            plotJourney();
          }
        });
      };

      vm.CenterControl = function (controlDiv) {
        var elementExists = document.getElementById("re-center");
        if (!elementExists) {
          // Set CSS for the control border.
          var controlUI = document.createElement("div");
          controlUI.id = "re-center";
          controlUI.style.backgroundColor = "#fff";
          controlUI.style.border = "2px solid #fff";
          controlUI.style.borderRadius = "3px";
          controlUI.style.backgroundImage = "url(../assets/images/mylocation-icon.png)";
          controlUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
          controlUI.style.cursor = "pointer";
          controlUI.style.marginRight = "10px";
          controlUI.style.textAlign = "center";
          controlUI.style.width = "40px";
          controlUI.style.height = "40px";
          controlUI.title = "Click to recenter the map";
          controlDiv.appendChild(controlUI);
          // Set CSS for the control interior.
          // var controlText = document.createElement("div");
          // controlText.style.color = "rgb(25,25,25)";
          // controlText.style.fontFamily = "Roboto,Arial,sans-serif";
          // controlText.style.fontSize = "16px";
          // controlText.style.lineHeight = "38px";
          // controlText.style.paddingLeft = "5px";
          // controlText.style.paddingRight = "5px";

          // controlText.innerHTML = "Center Map";
          // controlUI.appendChild(controlText);
          // Setup the click event listeners: simply set the map to location.
          controlUI.addEventListener("click", function () {
            vm.map.setCenter(vm.boatLastLocation);
          });
        }
      };

    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.home',
    [
      'yatch-sentinel.common',
      'yatch-sentinel.services',
      'yatch-sentinel.status',
      'yatch-sentinel.alarms',
      'yatch-sentinel.map',
      'yatch-sentinel.journey',
      'yatch-sentinel.sos',
      'yatch-sentnel.contacts',
      'yatch-sentinel.sensors',
      'yatch-sentinel.boats',
      'yatch-sentinel.metrics',
      'yatch-sentinel.accountSettings',
      'yatch-sentinel.contactUs',
      'yatch-sentinel.weather',
      'yatch-sentinel.notifications',
      'yatch-sentinel.sharedUsers',
      'yatch-sentinel.reset_password',
      'yatch-sentinel.change_email',
      'yatch-sentinel.disArm',
      'yatch-sentinel.documents'
    ])
    .config(function ($stateProvider, $translatePartialLoaderProvider) {
      $stateProvider
        .state('boat.home', {
          url: '/home/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/home/header.html',
              controller: 'homeHeaderController',
              controllerAs: 'vm',
              resolve :{
                userSentinel: function(userService, $stateParams){
                  return userService.getUserSentinelById($stateParams.sentinelId);
                }
              }
            },
            'content@boat': {
              templateUrl: 'app/main/home/home.html',
              controller: 'homeController',
              controllerAs: 'vm'
            }
          },
          data: {
            pageTitle: 'Home'
          },
          bodyClass: 'home',
          headerClass: 'half short'
        });
      $translatePartialLoaderProvider.addPart('app/main/home');
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.home')
    .controller('homeHeaderController', function (userService, sessionService, notificationHub, $rootScope, $scope, config,userSentinel, oemConfig) {
      var vm = this;
      vm.oemConfig = angular.copy(oemConfig);
      vm.user = sessionService.getUser();
      userService.getNotificationCount(function (response) {
        vm.notificationCount = response;
      });
      var hub = new notificationHub();
      hub.on('pushNotification', function (msg) {
        vm.notificationCount += 1;
        $rootScope.$apply();
      });
      $scope.$on("$destroy", function () {
        hub.off('pushNotification');
      });
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.home')
    .controller('homeController', function (cameraService, $stateParams, notificationHub, userService, $state, $scope, $rootScope,
      $uibModal, sentinelService, toastr, config, sessionService, oemConfig) {
      var vm = this;
      vm.dashboardUrl = {};
      vm.alarmsUrl = {};
      vm.mapUrl = {};
      vm.journeyLogUrl = {};
      vm.oemConfig = angular.copy(oemConfig);
      var statusType = {
        disArm: 1,
        arm: 2,
        off: 0
      }
      vm.sentinelId = $stateParams.sentinelId;
      vm.statusClass = "service-item small green";
      vm.statusLabel = "DISARM";
      if (vm.sentinelId == null || vm.sentinelId == undefined || vm.sentinelId == '') {
        userService.getUserSentinels(function (sentinels) {
          if (sentinels.length > 0) {
            $state.go('boat.home', {
              sentinelId: sentinels[0].id
            });
            $scope.$emit('sentinelSelected', sentinels[0]);
          } else {
            userService.getSharedSentinels(function (sharedSentinles) {
              if (sharedSentinles.length > 0) {
                $state.go('boat.home', {
                  sentinelId: sharedSentinles[0].id
                });
                $scope.$emit('sentinelSelected', sharedSentinles[0]);
              } else {
                toastr.info('Please enter product code in <b><a href="/#/boat/manage-boats/">manage boats</a></b>');
              }

            });
          }
        });
      } else {
        userService.getUserSentinelById(vm.sentinelId, function (currentSentinel) {
          vm.currentSentinel = currentSentinel;
          if (currentSentinel.status == statusType.disArm) {
            vm.statusClass = "service-item small red";
            vm.statusLabel = "ARM";
          } else if (currentSentinel.status == statusType.arm) {
            vm.statusClass = "service-item small green";
            vm.statusLabel = "DISARM";
          }

          var dashboardSwitch = sessionService.getDashboardSwitch();
          var alarmSwitch = sessionService.getAlarmSwitch();
          var mapSwitch = sessionService.getMapSwitch();
          var journeySwitch = sessionService.getJournySwitch();
          vm.dashboardUrl = getUrlYs6OrNmea({ name: 'boat.status', params: { sentinelId: vm.sentinelId } }, { name: 'boat.nmea', params: { sentinelId: vm.sentinelId } }, dashboardSwitch);
          vm.alarmsUrl = getUrlYs6OrNmea({ name: 'boat.alarms', params: { sentinelId: vm.sentinelId } }, { name: 'boat.nmea_alarms', params: { sentinelId: vm.sentinelId } }, alarmSwitch);
          vm.mapUrl = getUrlYs6OrNmea({ name: 'boat.map', params: { sentinelId: vm.sentinelId } }, { name: 'boat.nmea_map', params: { sentinelId: vm.sentinelId } }, mapSwitch);
          vm.journeyLogUrl = getUrlYs6OrNmea({ name: 'boat.journey', params: { sentinelId: vm.sentinelId } }, { name: 'boat.nmea_journey', params: { sentinelId: vm.sentinelId } }, journeySwitch);


        }, function () {
          $state.go('boat.home');
        });
      }
      function getUrlYs6OrNmea(ys6State, nmeaState, switchIndicator) {
        var model = {};
        if (vm.currentSentinel.w2K1SerialKeyId && (switchIndicator == null || switchIndicator == undefined)) {
          model = {
            state: nmeaState.name,
            params: nmeaState.params
          }
        }
        else if (vm.currentSentinel.w2K1SerialKeyId && switchIndicator == false) {
          model = {
            state: ys6State.name,
            params: ys6State.params
          }
        }
        else if (vm.currentSentinel.w2K1SerialKeyId && switchIndicator) {
          model = {
            state: nmeaState.name,
            params: nmeaState.params
          }
        }
        else {
          model = {
            state: ys6State.name,
            params: ys6State.params
          }
        }
        return model
      }
      vm.chooseContactsPage = function () {
        $uibModal.open({
          templateUrl: 'app/main/home/choose-contact.html',
          resolve: {
            sentinelId: function () {
              return vm.sentinelId;
            }
          },
          controllerAs: 'vm',
          controller: function (sentinelId) {
            var vm = this;
            vm.sentinelId = sentinelId;
          }
        })
      };
      vm.chooseManageDocumentPage = function () {
        $uibModal.open({
          templateUrl: 'app/main/home/choose-contact.html',
          resolve: {
            sentinelId: function () {
              return vm.sentinelId;
            }
          },
          controllerAs: 'vm',
          controller: function (sentinelId) {
            var vm = this;
            vm.sentinelId = sentinelId;
          }
        })
      };

      vm.chooseDashboardPage = function () {
        $uibModal.open({
          templateUrl: 'app/main/home/choose-dashboard.html',
          resolve: {
            sentinelId: function () {
              return vm.sentinelId;
            }
          },
          controllerAs: 'vm',
          controller: function (sentinelId) {
            var vm = this;
            vm.sentinelId = sentinelId;
          }
        })
      };

      vm.chooseJourneyLogPage = function () {
        $uibModal.open({
          templateUrl: 'app/main/home/choose-journey-log.html',
          resolve: {
            sentinelId: function () {
              return vm.sentinelId;
            }
          },
          controllerAs: 'vm',
          controller: function (sentinelId) {
            var vm = this;
            vm.sentinelId = sentinelId;
          }
        })
      };

      vm.chooseMapPage = function () {
        $uibModal.open({
          templateUrl: 'app/main/home/choose-map.html',
          resolve: {
            sentinelId: function () {
              return vm.sentinelId;
            }
          },
          controllerAs: 'vm',
          controller: function (sentinelId) {
            var vm = this;
            vm.sentinelId = sentinelId;
          }
        })
      };

      vm.chooseAlarmsPage = function () {
        $uibModal.open({
          templateUrl: 'app/main/home/choose-alarms.html',
          resolve: {
            sentinelId: function () {
              return vm.sentinelId;
            }
          },
          controllerAs: 'vm',
          controller: function (sentinelId) {
            var vm = this;
            vm.sentinelId = sentinelId;
          }
        })
      };

      $rootScope.$on("updateUserSentinelStatus", function (event, object) {
        if (object.data == statusType.disArm) {
          vm.statusClass = "service-item small red";
          vm.statusLabel = "ARM";
        } else if (object.data == statusType.arm) {
          vm.statusClass = "service-item small green";
          vm.statusLabel = "DISARM";
        }
      });
      var hub = new notificationHub();
      hub.on('pushNotification', function (msg) {
        if(msg.indexOf('armed')){
          userService.getUserSentinelById(vm.sentinelId, function (currentSentinel) {
            vm.currentSentinel = currentSentinel;
            if (currentSentinel.status == statusType.disArm) {
              vm.statusClass = "service-item small red";
              vm.statusLabel = "ARM";
            } else if (currentSentinel.status == statusType.arm) {
              vm.statusClass = "service-item small green";
              vm.statusLabel = "DISARM";
            }
          });
        }
      });
      $scope.$on("$destroy", function () {
        hub.off('pushNotification');
      });
      vm.disarmAlarms = function () {
        if (vm.currentSentinel != null && vm.currentSentinel.isCameraOnly) {
          toastr.success("Disarm message has been sent. You will be notified shortly.");
          cameraService.updateCamerasModeByUserSentinelId($stateParams.sentinelId, {
            CameraModeValue: 'disarmed'
          })
            .then(function (response) {
              if (response.exceptionMessage == undefined) {
                vm.statusClass = "service-item small red";
                vm.statusLabel = "ARM";
                toastr.success("Disarmed Successfully!");
              }
            });
        } else {
          $state.go('boat.disArm', {
            sentinelId: $stateParams.sentinelId
          });
        }
      }

      vm.armAlarms = function () {
        if (vm.currentSentinel != null && vm.currentSentinel.isCameraOnly) {
          toastr.success("Arm message has been sent. You will be notified shortly.");
          cameraService.updateCamerasModeByUserSentinelId($stateParams.sentinelId, {
            CameraModeValue: 'armed'
          })
            .then(function (response) {
              if (response.exceptionMessage == undefined) {
                vm.statusClass = "service-item small green";
                vm.statusLabel = "DISARM";
                toastr.success("Armed Successfully!");
              }
            });
        } else {
          sentinelService.arm(vm.sentinelId, function (response) {
            toastr.success("Arm message has been sent. You will be notified shortly.");
          });
        }
      };

      vm.nmeaDemo = function () {
        toastr.success('Coming soon');
      }

    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.forget_password', [])
    .config(function ($stateProvider) {
      $stateProvider
        .state('forgot_password', {
          url: '/forgot-password',
          templateUrl: 'app/main/forgot-password/forget-password.html',
          controller: 'forgetPasswordController',
          controllerAs: 'vm'
        });
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.forget_password')
    .controller('forgetPasswordController', function (accountService, $state, toastr, oemConfig,config) {
      var vm = this;
      vm.config=angular.copy(config);
      vm.oemConfig = angular.copy(oemConfig);
      vm.resetPassword = function () {
        accountService.resetPassword(vm.account.emailAddress,vm.config.tenant, function () {
          toastr.success('An email has been sent to your email address to reset password.');
          $state.go('login');
        }, function (err) {
          toastr.error(err.exceptionMessage);
        });
      };
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.map')
    .service('boatMapService', function () {
      return {
        data: {}
      };
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.distributor_map', [
    'yatch-sentinel.services',
    'flow'
  ]).config(function ($stateProvider,$translatePartialLoaderProvider) {
    $stateProvider
      .state('boat.distributor_map', {
        url: '/distributor-map/:sentinelId',
        views: {
          'header@boat': {
            templateUrl: 'app/main/distributor-map/header.html',
            controller: 'distributorMapHeaderController',
            controllerAs: 'vm'
          },
          'extra_header@boat': {
            templateUrl: 'app/main/distributor-map/distributor-map.html',
            controller: 'distributorMapController',
            controllerAs: 'vm',
            resolve: {
              data: function (userService) {
                return userService.getDistributorMapDataAll('');
              }
            }
          }
        },
        headerClass: 'half blank',
        mobileHeader: {
          visible: true,
          title: 'Header.DistributorMap'
        },
        data: {
          pageTitle: 'Yacht Sentinel | Distributor Map'
        }
      });
      $translatePartialLoaderProvider.addPart('app/main/distributor-map');
  });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.distributor_map')
    .controller('distributorMapHeaderController', function (boatMapService, oemConfig) {
        var vm = this;
        vm.oemConfig = angular.copy(oemConfig);
        vm.location = boatMapService.data;
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.distributor_map')
  .controller('distributorMapController', function (data, navigationService, $stateParams, $, uiGmapGoogleMapApi, $timeout) {
    var vm = this;
    vm.list=data;
    vm.mapType = "google";
    navigationService.navigation = {
      backState: 'boat.home',
      backStateParams: {
        sentinelId: $stateParams.sentinelId
      }
    };
    vm.distributorMapData=angular.copy(data);
    var mapData=data;
    vm.initMap = function () {
      uiGmapGoogleMapApi
        .then(function () {
          if (data.length>0) {
            var myLatLng = {
              lat: data[0].latitude,
              lng: data[0].longitude
            };
            $timeout(function () {
              vm.map = new google
                .maps
                .Map(document.getElementById('google_map'), {
                  zoom: 3,
                  center: myLatLng,
                  styles: [
                    {
                      "featureType": "water",
                      "stylers": [
                        {
                          "color": "#3ab4e6"
                        }
                      ]
                    }
                  ]
                });
              vm.getDistributorMapData();
            });

          }

        });

    };

    vm.zoomToAddress=function(latitude,longitude)
    {

      var myLatLng = {
        lat: latitude,
        lng: longitude
      };
      $timeout(function () {
        vm.map = new google
          .maps
          .Map(document.getElementById('google_map'), {
            zoom: 15,
            center: myLatLng,
            styles: [
              {
                "featureType": "water",
                "stylers": [
                  {
                    "color": "#3ab4e6"
                  }
                ]
              }
            ]
          });
        vm.getDistributorMapData();
      });

    }
    vm.getDistributorMapData=function()
    {
      var markers = [];
      if(mapData!=null)
      {
        mapData.forEach(function(data) {

              var marker = new google
              .maps
              .Marker({
                position: {
                  lat: parseFloat(data.latitude),
                  lng: parseFloat(data.longitude)
                },
                map: vm.map,
                title: data.name,
                icon: {
                  url: 'assets/images/fp-dealer.png'
                }

              });

              var infowindow = new google
              .maps
              .InfoWindow({
                content: "<div id='content'><p> <b>Name</b></p><p> " + data.name + " </p><p> <b>Address</b></p><p> " + data.address + " </p><p> <b>Email</b></p><p> " + data.email + " </p><p> <b>Country</b></p><p> " + data.country + " </p><p> <b>City</b></p><p> " + data.city + " </p><p> <b>Latitude</b></p><p> " + data.latitude + " </p><p> <b>Longitude</b></p><p> " + data.longitude + " </p><p> <b>Open Hours</b></p><p> " + data.openingHours + " </p><p> <b>Closed Days</b></p><p> " + data.closedDays + " </p><p> <b>Telephone</b></p><p> " + data.telephone + " </p><p> <b>Website</b></p><p><a style='text-transform: lowercase;' href=\"" + data.website +"\"" + "target=_blank>"+data.website+"</a> </p></div>"
              });

            marker.addListener('click', function () {
              infowindow.open(vm.map, marker);
            });
          markers.push(marker);
        });
        var markerCluster = new MarkerClusterer(vm.map, markers,
          {imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'});
    }
  }
  });

})();


(function () {
  'use strict;'
  angular.module('yatch-sentinel.disArm', [])
    .config(function ($stateProvider,$translatePartialLoaderProvider) {
      $stateProvider
        .state('boat.disArm', {
          url: '/disarm/:sentinelId',
          views: {
            'header@boat': {
                templateUrl: 'app/main/disArm/header.html',
                controller: 'disArmHeaderController',
                controllerAs: 'vm'
            }
          },
          data: {
            pageTitle: 'Disarm',
            hideMainContent: true
          },
          headerClass: 'sos'
        });
        $translatePartialLoaderProvider.addPart('app/main/disArm');
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.disArm')
    .controller('disArmHeaderController', function (navigationService, sentinelService, $stateParams, toastr, $rootScope, $state, oemConfig) {
      var vm = this;
      vm.oemConfig = angular.copy(oemConfig);
      navigationService.navigation = {
        backState: 'boat.home',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      vm.sendArmOrDisAlarmSmS = function () {
        sentinelService.disarm($stateParams.sentinelId, function () {
          toastr.success('Disarm message has been sent. You will be notified shortly');
          $state.go('boat.home',{sentinelId: $stateParams.sentinelId});
        });
      };
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentnel.contacts', [
      'yatch-sentinel.services'
    ])
    .config(function ($stateProvider,$translatePartialLoaderProvider) {
      $stateProvider
        .state('boat.contacts', {
          url: '/contacts/:sentinelId',
          views: {
            'header@boat': {
              templateUrl: 'app/main/contacts/header.html',
              controller: 'contactsHeaderController',
              controllerAs: 'vm'
            },
            'content@boat': {
              templateUrl: 'app/main/contacts/contacts.html',
              controller: 'contactsController',
              controllerAs: 'vm',
              resolve: {
                contacts: function (userService) {
                  return userService.getUserContacts();
                },
                countries: function(http){
                  return http.get("assets/countries.json");
                }
              }
            }
          },
          data: {
            pageTitle: 'Contacts'
          },
          headerClass: 'h75',
          bodyClass: 'contacts',
          mobileHeader: {
            visible: true,
            title: 'Header.Contacts'
          }
        });
        $translatePartialLoaderProvider.addPart('app/main/contacts');
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentnel.contacts')
    .service('contactsListService', function () {
      return {
        contacts: {
          list: []
        }
      };
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentnel.contacts')
    .controller('contactsHeaderController', function ($uibModal, contactsListService, userService, oemConfig) {
      var vm = this;
      vm.oemConfig = angular.copy(oemConfig);
      vm.newContactDialog = function () {
        $uibModal.open({
          templateUrl: 'app/main/contacts/new-contact-dialog.html',
          controller: 'newContactDialogController',
          controllerAs: 'vm',
          windowClass : 'contact-modal',
          resolve:{
            countries:function(){
              return contactsListService.contacts.countries;
            }
          }
        }).result.then(function () {
          userService.getUserContacts(function (contacts) {
            contactsListService.contacts.list = contacts;
          });
        });
      };
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentnel.contacts')
    .controller('contactsController', function (navigationService, contacts, contactsListService, $uibModal,userService,countries) {
      var vm = this;
      contactsListService.contacts.list = contacts;
      contactsListService.contacts.countries = angular.copy(countries);
      vm.contacts = contactsListService.contacts;
      navigationService.navigation = {
        backState: 'boat.home',
        backStateParams: {}
      };
      vm.editContactDialog = function (contact) {
        $uibModal.open({
          templateUrl: 'app/main/contacts/edit-contact-dialog.html',
          controller: 'editContactDialogController',
          controllerAs: 'vm',
          windowClass: 'contact-modal',
          resolve: {
            contact: function () {
              return angular.copy(contact);
            },
            countries: function(){
              return angular.copy(countries);
            }
          }
        }).result.then(function () {
          userService.getUserContacts(function (response) {
            contactsListService.contacts.list = response;
          });
        });
      };

    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentnel.contacts')
    .controller('editContactDialogController', function ($uibModal, contactsListService, contact, $uibModalInstance, toastr, userService, countries) {
      var vm = this;
      vm.contact = contact;
      vm.countries = countries;
      if(vm.contact.country){
        vm.contact.selectedCountry = countries.filter(function(c){
          return c.name == vm.contact.country;
        });
        angular.forEach(vm.contact.selectedCountry, function(c){
          c.selected = true;
        });
      }
      vm.editContact = function () {
        if (vm.contact.selectedCountry.length > 0) {
          vm.contact.country = vm.contact.selectedCountry[0].name;
          vm.contact.countryCode = vm.contact.selectedCountry[0].dial_code;
        }
        userService.editContact(vm.contact, function (response) {
          toastr.success('Contact edited successfully');
          $uibModalInstance.close(response);
        });
      }
      vm.deleteContact = function (contact) {
        userService.deleteUserContact(contact.id, function (response) {
          toastr.success('Contact deleted successfully');
          $uibModalInstance.close(response);
        });
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentnel.contacts')
    .controller('newContactDialogController', function (userService, toastr, $uibModalInstance, countries) {
      var vm = this;
      vm.countries = countries;
      vm.saveContact = function () {
        if (vm.contact.selectedCountry.length > 0) {
          vm.contact.country = vm.contact.selectedCountry[0].name;
          vm.contact.countryCode = vm.contact.selectedCountry[0].dial_code;
        }
        userService.saveUserContact(vm.contact, function (response) {
          toastr.success('Contact added successfully');
          $uibModalInstance.close(vm.contact);
        });
      };

    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.contactUs', [
    'yatch-sentinel.services'
  ]).config(function ($stateProvider) {
    $stateProvider
      .state('boat.contactUs', {
        url: '/contactUs',
        views: {
          'header@boat': {
            templateUrl: 'app/main/contact-us/header.html',
            controller: function (oemConfig) {
              var vm = this;
              vm.oemConfig = angular.copy(oemConfig);
            },
            controllerAs: 'vm'
          },
          'content@boat': {
            templateUrl: 'app/main/contact-us/contactUs.html',
            controller: 'contactUsController',
            controllerAs: 'vm'
          }
        },
        headerClass: 'half',
        mobileHeader: {
          visible: true,
          title: 'Header.ContactUs'
        },
        data: {
          pageTitle: 'Contact us'
        }
      });
  });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.contactUs')
    .controller('contactUsController', function (navigationService, oemConfig) {
      var vm = this;
      vm.oemConfig = angular.copy(oemConfig);
      navigationService.navigation = {
        backState: 'boat.home',
        backStateParams: {}
      };
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.common', [
    'yatch-sentinel.services',
    'uiGmapgoogle-maps'
  ])
    .config(function ($stateProvider,uiGmapGoogleMapApiProvider,$translatePartialLoaderProvider) {
      uiGmapGoogleMapApiProvider.configure({
        key: 'AIzaSyAD-9bv02twT6PulUr320a61oELvrJmO7k',
        v: '3.23',
        libraries: 'visualization,drawing,places,geometry'
      });
      $stateProvider
        .state('boat', {
          url: '/boat',
          templateUrl: 'app/main/common/app.html',
          'abstract': true,
          controller: 'commonController',
          controllerAs: 'vm',
          resolve: {
            sentinels: function (userService) {
              return userService.getUserSentinels();
            },
            sharedSentinels: function(userService){
              return userService.getSharedSentinels();
            } ,
            distributorStatus: function (userService) {
              return userService.getDistributorMapDataStatus();
              },
            isForumEnable: function (tenantService) {
                return tenantService.isForumEnable();
            },
            user : function(accountService){
              return accountService.me();
            }
          }
        });
        $translatePartialLoaderProvider.addPart('app/main/common');
    });
})();

(function () {
  'use strict';
  angular.module('yatch-sentinel.common').directive('pageTitle',
    function ($rootScope, $timeout, oemConfig) {
      return {
        link: function (scope, element) {

          var listener = function (event, toState) {

            var title = oemConfig.title;
            if (toState.data && toState.data.pageTitle) title = title + ' | ' + toState.data.pageTitle;

            $timeout(function () {
              element.text(title);
            }, 0, false);
          };

          $rootScope.$on('$stateChangeSuccess', listener);
        }
      };
    });
})();

(function () {
  'use strict';
  angular.module('yatch-sentinel.common')
    .directive('hideMainContent',
      function ($rootScope, $timeout, $state) {
        return {
          link: function (scope, element) {
            if ($state.current.name == 'boat.sos') {
              element.css('display', 'none');
            } else {
              element.css('display', 'block');
            }
            var listener = function (event, toState) {

              var hideMainContent = false;
              if (toState.data && toState.data.hideMainContent) {
                hideMainContent = toState.data.hideMainContent;
              }

              $timeout(function () {
                if (hideMainContent) {
                  element.css('display', 'none');
                } else {
                  element.css('display', 'block');
                }
              }, 0, false);
            };

            $rootScope.$on('$stateChangeSuccess', listener);
            $timeout(function () {
              if ($state.current.data && $state.current.data.hideMainContent) {
                element.css('display', 'none');
              } else {
                element.css('display', 'block');
              }
            }, 0, false);
          }
        };
      });
})();

(function () {
  'use strict';
  angular.module('yatch-sentinel.common')
    .directive('headerClass',
      function ($rootScope, $timeout, $state) {
        return {
          link: function (scope, element) {
            var headerClass = 'col-sm-12 header';
            if ($state.current.headerClass) {
              headerClass = headerClass + " " + $state.current.headerClass;
            }
            element.attr('class', headerClass);
            var listener = function (event, toState) {

              headerClass = 'col-sm-12 header';
              if (toState.headerClass) {
                headerClass = headerClass + ' ' + toState.headerClass;
              }

              $timeout(function () {
                element.attr('class', headerClass);
              }, 0, false);
            };

            $rootScope.$on('$stateChangeSuccess', listener);
          }
        };
      });
})();

(function () {
  "use strict;";
  angular
    .module("yatch-sentinel.common")
    .controller(
      "commonController",
      function (
        distributorStatus,
        $scope,
        chatHub,
        chatService,
        $localStorage,
        accountService,
        sentinels,
        sharedSentinels,
        sessionService,
        $state,
        $rootScope,
        notificationHub,
        userService,
        toastr,
        $log,
        config,
        $window,
        $timeout,
        sentinelService,
        moment,
        $filter,
        navigationService,
        oemConfig,
        isForumEnable,
        $uibModal,
        user
      ) {
        var vm = this;
        vm.forumEnabled = isForumEnable;
        vm.oemConfig = angular.copy(oemConfig);
        vm.status = distributorStatus;
        vm.hub = new chatHub();
        vm.user=user;
        vm.hub.on("NewMessage", function (data) {
          if ($state.current.name != "boat.chat") {
            toastr.success("New Message Received!!");
          }
        });
        vm.checkProtocol = function () {
          if (location.protocol !== 'https:') {
            var url = location.href.substring(location.protocol.length);
            location.replace('https:' + url);
          }
        }
        if (config.environment == 'Production' || config.environment == 'Test') {
          vm.checkProtocol();
        }

        vm.isCollapsed = true;
        // vm.user = sessionService.getUser();
        $timeout(function () {
          vm.sentinelId = $state.params.sentinelId;
        }, 0);

        function refresh_auth_tokens() {
          var accessToken = sessionService.getAuthToken();
          var expiryTime = moment(accessToken[".expires"]).subtract(
            5,
            "minutes"
          );
          var diff = expiryTime.diff(moment());
          $timeout(function () {
            accountService.refreshToken(
              accessToken.refresh_token,
              function (response) {
                sessionService.setAuthToken(response, $localStorage.rememberMe);
                hub.disconnect("pushNotification");
                hub.setAccessToken(sessionService.getAuthToken().access_token);
                hub.connect();
                refresh_auth_tokens();
              },
              function (err) {
                toastr.error(err.error);
              }
            );
          }, diff);
        }
        refresh_auth_tokens();

        vm.sentinels = [];
        if (sharedSentinels) {
          sharedSentinels.forEach(function (s) {
            sentinels.push(s);
          });
        }

        function sentinelWeather() {
          var sentinelWeatherDate = moment();
          vm.sentinelWeather = null;
          vm.weatherDetails = null;
          vm.sentinelWeather = null;
          var sentinelId =
            $state.params.sentinelId == undefined
              ? sentinels[0].id
              : $state.params.sentinelId;
          return sentinelService.getSentinelWeather(
            sentinelWeatherDate.format("YYYY/MM/DD"),
            vm.currentSentinel.id,
            function (response) {
              if (response != null) {
                vm.weatherDetails = response.sentinelWeatherDetail.filter(
                  function (w) {
                    return w.time == 1200;
                  }
                )[0];
                vm.sentinelWeather = response;
              }
            },
            function (err) {
              vm.weatherDetails = {
                feelsLike: 0,
              };
              vm.sentinelWeather = {
                minTemperature: 0,
              };
            }
          );
        }

        function setBackgroundImage() {
          var url = config.apiUrl + vm.currentSentinel.boatImageUrl;
          var token = sessionService.getAuthToken();
          if (token) {
            url += "?access_token=" + token.access_token;
          }
          var style = document.createElement("style");
          style.type = "text/css";
          style.innerHTML =
            '.content-area .header { background: url("' +
            url +
            '");  background-size: cover;background-position: center;background-repeat: no-repeat;padding-top: 0.625rem;height: 90vh;min-height: 35.625rem;margin: 0;margin-bottom: 3.125rem; }';
          document.getElementsByTagName("head")[0].appendChild(style);

          style = document.createElement("style");
          style.type = "text/css";
          style.innerHTML =
            "@media (max-width: 641px) {" +
            ".content-area .header.half.short {" +
            "min-height: 28.125rem;" +
            "background: url('" +
            url +
            "');" +
            "background-size: cover;        background-position: center;        background-repeat: no-repeat;" +
            "}" +
            "};";
          document.getElementsByTagName("head")[0].appendChild(style);
        }
        vm.config = {
          autoHideScrollbar: false,
          theme: "light",
          advanced: {
            updateOnContentResize: true,
          },
          setHeight: 300,
          scrollInertia: 5,
        };
        function initSentinels() {
          vm.currentSentinel = {};
          vm.sentinels = [];
          if (sentinels) {
            vm.sentinels = sentinels;
            for (var i = 0, j = -1; i < sentinels.length; i++) {
              if ($state.params.sentinelId == sentinels[i].id) {
                vm.currentSentinel = sentinels[i];
                if (
                  vm.currentSentinel != null &&
                  vm.currentSentinel.isCameraOnly
                ) {
                  vm.isCameraOnly = true;
                } else {
                  vm.isCameraOnly = false;
                }
                var dashboardSwitch = sessionService.getDashboardSwitch();
                var alarmSwitch = sessionService.getAlarmSwitch();
                var mapSwitch = sessionService.getMapSwitch();
                var journeySwitch = sessionService.getJournySwitch();
                vm.dashboardUrl = getUrlYs6OrNmea({ name: 'boat.status', params: { sentinelId: vm.currentSentinel.id } }, { name: 'boat.nmea', params: { sentinelId: vm.currentSentinel.id } }, dashboardSwitch);
                vm.alarmsUrl = getUrlYs6OrNmea({ name: 'boat.alarms', params: { sentinelId: vm.currentSentinel.id } }, { name: 'boat.nmea_alarms', params: { sentinelId: vm.currentSentinel.id } }, alarmSwitch);
                vm.mapUrl = getUrlYs6OrNmea({ name: 'boat.map', params: { sentinelId: vm.currentSentinel.id } }, { name: 'boat.nmea_map', params: { sentinelId: vm.currentSentinel.id } }, mapSwitch);
                vm.journeyLogUrl = getUrlYs6OrNmea({ name: 'boat.journey', params: { sentinelId: vm.currentSentinel.id } }, { name: 'boat.nmea_journey', params: { sentinelId: vm.currentSentinel.id } }, journeySwitch);
                break;
              }
            }
          }
        }
        initSentinels();
        setBackgroundImage();
        $timeout(function () {
          sentinelWeather();
        }, 0);

        var hub = new notificationHub();
        vm.logout = function () {
          sessionService.deleteAuthToken();
          hub.disconnect("pushNotification");
          $state.go("login");
        };

        userService.getNotificationCount(function (response) {
          vm.notificationCount = response;
        });

        $rootScope.$on("update_notification", function (args, data) {
          if (vm.notificationCount - data.unreadNotificationCount >= 0) {
            vm.notificationCount =
              vm.notificationCount - data.unreadNotificationCount;
          } else {
            vm.notificationCount = 0;
          }
        });
        $rootScope.$on("update_notification_to_zero", function (args, data) {
          vm.notificationCount = 0;
        });
        $rootScope.$on("sentinelUpdated", function (args, data) {
          sentinels = data;
          vm.sentinels = [];
          initSentinels();
        });
        $rootScope.$on("sentinelSelected", function (args, data) {
          vm.currentSentinel = data;
          var dashboardSwitch = sessionService.getDashboardSwitch();
          var alarmSwitch = sessionService.getAlarmSwitch();
          var mapSwitch = sessionService.getMapSwitch();
          var journeySwitch = sessionService.getJournySwitch();
          vm.dashboardUrl = getUrlYs6OrNmea({ name: 'boat.status', params: { sentinelId: vm.currentSentinel.id } }, { name: 'boat.nmea', params: { sentinelId: vm.currentSentinel.id } }, dashboardSwitch);
          vm.alarmsUrl = getUrlYs6OrNmea({ name: 'boat.alarms', params: { sentinelId: vm.currentSentinel.id } }, { name: 'boat.nmea_alarms', params: { sentinelId: vm.currentSentinel.id } }, alarmSwitch);
          vm.mapUrl = getUrlYs6OrNmea({ name: 'boat.map', params: { sentinelId: vm.currentSentinel.id } }, { name: 'boat.nmea_map', params: { sentinelId: vm.currentSentinel.id } }, mapSwitch);
          vm.journeyLogUrl = getUrlYs6OrNmea({ name: 'boat.journey', params: { sentinelId: vm.currentSentinel.id } }, { name: 'boat.nmea_journey', params: { sentinelId: vm.currentSentinel.id } }, journeySwitch);
        });
        $rootScope.$on("boatImageUpdated", function (args, data) {
          vm.getSentinels();
        });

        vm.getSentinels = function () {
          userService.getUserSentinelById(vm.currentSentinel.id, function (response) {
            vm.currentSentinel.boatImageUrl = response.boatImageUrl;
            setBackgroundImage();
          });
        };

        vm.sentinelSeleted = function (s) {
          $timeout(function () {
            sentinelWeather();
          }, 0);
        };

        userService.getNotificationCount(function (response) {
          vm.notificationCount = response;
        });

        var stateHistory = [];
        var visitedStates = [];

        function addToStateHistory(hist) {
          if (hist.fromState == undefined) return;
          var existingState = stateHistory.filter(function (state) {
            return (
              state.fromState.name == hist.fromState.name &&
              state.toState.name == hist.toState.name
            );
          });
          if (existingState.length > 0) return;

          existingState = visitedStates.filter(function (state) {
            return (
              state.fromState.name == hist.fromState.name &&
              state.toState.name == hist.toState.name
            );
          });
          if (existingState.length > 0) return;
          stateHistory.push(hist);
        }

        function removeFromStateHistory(hist) { }

        vm.goBack = function () {
          $rootScope.goBack();
        };

        $rootScope.goBack = function () {
          $state.go(
            navigationService.navigation.backState,
            navigationService.navigation.backStateParams
          );
        };

        function handleStateChanged(
          event,
          toState,
          toParams,
          fromState,
          fromParams
        ) {
          var currentState = $state.current.name;
          if (vm.currentSentinel != null && vm.currentSentinel.isCameraOnly) {
            vm.isCameraOnly = true;
          } else {
            vm.isCameraOnly = false;
          }
          if (
            currentState != "boat.status" &&
            currentState != "boat.alarms" &&
            currentState != "boat.position_alarm" &&
            currentState != "boat.safe_return_alarm" &&
            currentState != "boat.battery_alarm" &&
            currentState != "boat.shorepower_alarm" &&
            currentState != "boat.temperature_alarm" &&
            currentState != "boat.high_water_alarm" &&
            currentState != "boat.motion_detector_alarm" &&
            currentState != "boat.door_alarm" &&
            currentState != "boat.shock_alarm" &&
            currentState != "boat.tilt_alarm" &&
            currentState != "boat.item_security_alarm" &&
            currentState != "boat.map" &&
            currentState != "boat.journey"
          ) {
            vm.isHomeOrCameraState = true;
          } else {
            vm.isHomeOrCameraState = false;
          }
          if (toState.mobileHeader && toState.mobileHeader.visible == true) {
            vm.showMobileHeader = true;
            vm.title = toState.mobileHeader.title;
          } else {
            vm.showMobileHeader = false;
          }
          addToStateHistory({
            fromState: fromState,
            fromParams: fromParams,
            toState: toState,
            toParams: toParams,
          });
        }

        $rootScope.$on(
          "$stateChangeSuccess",
          function (event, toState, toParams, fromState, fromParams) {
            handleStateChanged(event, toState, toParams, fromState, fromParams);
            if ($state.params.sentinelId == "") {
              vm.currentSentinel = {};
            }
            initSentinels();
            $timeout(function () {
              vm.sentinelId = $state.params.sentinelId;
            }, 0);
          }
        );

        $rootScope.$on("$stateChangeStart", function (event, toState) {
          var token = sessionService.getAuthToken();
          if (
            (token == null || token == undefined) &&
            toState.name != "login" &&
            toState.name != "register" &&
            toState.name != "forgot_password" &&
            toState.name != "change_language"
          ) {
            event.preventDefault();
            $state.go("login");
          }
        });

        handleStateChanged(null, $state.current);
        hub.on("pushNotification", function (msg) {
          toastr.success(msg);
          vm.notificationCount += 1;
          $rootScope.$apply();
        });
        hub.on("pushStatusNotification", function (object) {
          toastr.success(object.message);
          vm.notificationCount += 1;
          $rootScope.$emit("updateUserSentinelStatus", object);
          $rootScope.$apply();
        });
        if (sessionService.getAuthToken()) {
          hub.setAccessToken(sessionService.getAuthToken().access_token);
          hub.connect();
        } else {
          $rootScope.$on("loggedIn", function () {
            hub.setAccessToken(sessionService.getAuthToken().access_token);
            hub.connect();
          });
        }

        function isChatSupported() {
          chatService.isChatSupported().then(function (response) {
            vm.isChatSupported = response;
          });
        }

        isChatSupported();
        vm.goToHelpCenter = function () {
          chatService.isChatInitiated().then(function (isChatInit) {
            vm.isChatInitiated = isChatInit;
            if (vm.isChatInitiated != false) {
              $state.go("boat.chat", {
                sentinelId: $state.params.sentinelId,
                groupId: vm.isChatInitiated,
              });
            } else {
              chatService.startChart().then(function (response) {
                vm.group = response;
                $state.go("boat.chat", {
                  sentinelId: $state.params.sentinelId,
                  groupId: vm.group.id,
                });
              });
            }
          });
        };

        vm.openNav = function () {
          document.getElementById("mySidenav").style.width = "250px";
          isOpen = true;
          // document.getElementById("mySidenav").style.width = "250px";
          // document.getElementById("main").style.marginLeft = "250px";
        }

        /* Set the width of the side navigation to 0 */
        vm.closeNav = function () {
          document.getElementById("mySidenav").style.width = "0";
          isOpen = false;
          // document.getElementById("mySidenav").style.width = "0";
          // document.getElementById("main").style.marginLeft = "0";
        }
        var isOpen = false;
        vm.toggleSideNav = function () {
          if (isOpen) {
            vm.closeNav();
          }
          else {
            vm.openNav();
          }
        };
        function getUrlYs6OrNmea(ys6State, nmeaState, switchIndicator) {
          var model = {};
          if (vm.currentSentinel.w2K1SerialKeyId && (switchIndicator == null || switchIndicator == undefined)) {
            model = {
              state: nmeaState.name,
              params: nmeaState.params
            }
          }
          else if (vm.currentSentinel.w2K1SerialKeyId && switchIndicator == false) {
            model = {
              state: ys6State.name,
              params: ys6State.params
            }
          }
          else if (vm.currentSentinel.w2K1SerialKeyId && switchIndicator) {
            model = {
              state: nmeaState.name,
              params: nmeaState.params
            }
          }
          else {
            model = {
              state: ys6State.name,
              params: ys6State.params
            }
          }
          return model
        }

        vm.chooseContactsPage = function () {
          $uibModal.open({
            templateUrl: 'app/main/home/choose-contact.html',
            resolve: {
              sentinelId: function () {
                return vm.sentinelId;
              }
            },
            controllerAs: 'vm',
            controller: function (sentinelId, $state, $timeout, $uibModalInstance) {
              var vm = this;
              vm.sentinelId = sentinelId;
              function closeDialog() {
                $timeout(function () {
                  $uibModalInstance.close();
                }, 0);
              }
              vm.gotoContacts = function () {
                $state.go('boat.contacts', { sentinelId: vm.sentinelId });
                closeDialog();
              };

              vm.gotoSharedUsers = function () {
                $state.go('boat.sharedUsers', { sentinelId: vm.sentinelId });
                closeDialog();
              };
            }
          }).result.then(function () {
            vm.closeNav();
          }, function () {
            vm.closeNav();
          })
        }
      }
    );
})();

(function () {
  'use strict';
  angular.module('yatch-sentinel.common')
    .directive('bodyClass',
      function ($rootScope, $timeout, $state) {
        return {
          link: function (scope, element) {
            var bodyClass = '';
            if ($state.current.bodyClass) {
              bodyClass = $state.current.bodyClass;
            }
            element.attr('class', bodyClass);
            var listener = function (event, toState) {

              bodyClass = '';
              if (toState.bodyClass) {
                bodyClass = toState.bodyClass;
              }

              $timeout(function () {
                element.attr('class', bodyClass);
              }, 0, false);
            };

            $rootScope.$on('$stateChangeSuccess', listener);
          }
        };
      });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.change_email', [
      'yatch-sentinel.services'
    ])
    .config(function ($stateProvider) {
      $stateProvider
        .state('change-email', {
          url: '/change-email',
          templateUrl: 'app/main/change-email/change-email.html',
          controller: 'changeEmailController',
          controllerAs: 'vm'
        });
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.change_email')
    .controller('changeEmailController',
      function (accountService, sessionService, $location, toastr) {
        var vm = this;
        vm.queryString = $location.search();
        vm.changeEmail = function () {
          accountService.changeEmail({
            oldEmailAddress: vm.queryString.oldEmailAddress,
            newEmailAddress: vm.queryString.newEmailAddress,
            token: vm.queryString.token,
            password: vm.account.password
          }, function () {
            toastr.success('Email changed successfully');
            accountService.login({
              emailAddress: vm.queryString.newEmailAddress,
              password: vm.account.password
            }, function (response) {
              toastr.success("Logged in");
              sessionService.setAuthToken(response, vm.rememberMe);
              accountService.me(function (user) {
                sessionService.setUser(user);
                $location.url("/login?isEmailChanged=true");
              });
            })
          }, function (error) {
            toastr.error(error.exceptionMessage);
          });
        };
      });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .service('alarmService', function () {
      return {
        data: []
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('alarmIndexController', function (sessionService, $state, alarms, oemConfig,
      alarmTypes, $stateParams, alarmService, sensors, sensorTypes, navigationService, currentSentinel, connectivity, $rootScope) {
      var vm = this;
      vm.oemConfig = angular.copy(oemConfig);
      var statusType = {
        disArm: 1,
        arm: 2,
        off: 0
      }
      vm.goBack = function () {
        $rootScope.goBack();
      };
      vm.connectivity = connectivity;
      alarmService.data = alarms;
      vm.currentSentinelId = $stateParams.sentinelId;
      vm.currentSentinel = currentSentinel;
      vm.turnedOff = false;
      if (vm.currentSentinel.status == statusType.disArm) {
        vm.isDisArmed = true
      }
      else if (vm.currentSentinel.status == statusType.off) {
        vm.turnedOff = true;
      }
      navigationService.navigation = {
        backState: 'boat.home',
        backStateParams: {
          sentinelId: $stateParams.sentinelId
        }
      };
      var setSensorStatus = function (sensorId) {
        var initialStatus = {
          lowBattery: false,
          missingBattery: false
        };
        var sensorType = sensors.filter(function (s) {
          return s.id == sensorId;
        })[0];
        if (sensorType) {
          angular.forEach(sensorType.sensors, function (s) {
            initialStatus.lowBattery = initialStatus.lowBattery || s.lowBattery;
            initialStatus.missingBattery = initialStatus.missingBattery || s.missingBattery;
          });
        }
        return initialStatus;
      };
      /**
       * Battery alarm status
       */
      var batteryAlarms = alarms.filter(function (alarm) {
        return alarm.alarmTypeId == alarmTypes.sentinelBatteryAlarm.id ||
          alarm.alarmTypeId == alarmTypes.boatBatteryAlarm.id
      });
      if (batteryAlarms && batteryAlarms.length > 0) {
        vm.batteryAlarm = false;
        var activeBatteryAlarm = batteryAlarms.find(function (ba) {
          return ba.enabled;
        });
        if (activeBatteryAlarm) {
          vm.batteryAlarm = true;
        }
      } else {
        vm.batteryAlarm = false;
      }


      /**
       * Geo fence alarm status
       */
      var geoFenceAlarm = alarms.filter(function (alarm) {
        return alarm.alarmTypeId == alarmTypes.geofenceAlarm.id;
      })[0];
      if (geoFenceAlarm) {
        if (!geoFenceAlarm.enabled) {
          var geoFenceMoveOutAlarm = alarms.filter(function (alarm) {
            return alarm.alarmTypeId == alarmTypes.geoFenceAlarmMoveIn.id;
          })[0];
          if (geoFenceMoveOutAlarm) {
            vm.positionAlarm = geoFenceMoveOutAlarm.enabled;
          }
          else {
            vm.positionAlarm = false;// && connectivity.satellite == false;
          }
        }
        else {

          vm.positionAlarm = geoFenceAlarm.enabled;// && connectivity.satellite == false;
        }
      } else {
        vm.positionAlarm = false;
      }


      /**
       * Shorepower/ Main supply alarm status
       */
      var shorepowerAlarms = alarms.filter(function (alarm) {
        return alarm.alarmTypeId == alarmTypes.mainSupplyAlarm.id;
      });
      if (shorepowerAlarms && shorepowerAlarms.length > 0) {
        vm.shorepowerAlarm = false;
        shorepowerAlarms.forEach(function (a) {
          vm.shorepowerAlarm = vm.shorepowerAlarm || a.enabled;
        });
      } else {
        vm.shorepowerAlarm = false;
      }
      vm.shorePowerSensorStatus = setSensorStatus(sensorTypes.mainSupplySensor.id);


      /**
       * Temperature alarm status
       */
      var temperatureAlarms = alarms.filter(function (alarm) {
        return alarm.alarmTypeId == alarmTypes.temperatureAlarm.id;
      });
      if (temperatureAlarms && temperatureAlarms.length > 0) {
        vm.temperatureAlarm = false;
        temperatureAlarms.forEach(function (a) {
          vm.temperatureAlarm = vm.temperatureAlarm || a.enabled;// && connectivity.satellite == false;
        });
      } else {
        vm.temperatureAlarm = false;
      }
      vm.temperaturSensorStatus = setSensorStatus(sensorTypes.temperatureSensor.id);

      /**
       * Bilge/High water alarm status
       */
      var highWaterAlarms = alarms.filter(function (alarm) {
        return alarm.alarmTypeId == alarmTypes.bilgeAlarm.id;
      });
      if (highWaterAlarms && highWaterAlarms.length > 0) {
        vm.highWaterAlarm = false;
        highWaterAlarms.forEach(function (a) {
          vm.highWaterAlarm = vm.highWaterAlarm || a.enabled;
        });
      } else {
        vm.highWaterAlarm = false;
      }
      vm.highWaterSensorStatus = setSensorStatus(sensorTypes.bilgeSensor.id);


      /**
       * PIR/Motion detection alarm status
       */
      var motionDetectionAlarms = alarms.filter(function (alarm) {
        return alarm.alarmTypeId == alarmTypes.pirAlarm.id;
      });
      if (motionDetectionAlarms && motionDetectionAlarms.length > 0) {
        vm.motionDetectionAlarm = false;
        motionDetectionAlarms.forEach(function (a) {
          vm.motionDetectionAlarm = vm.motionDetectionAlarm || a.enabled;
        });
      } else {
        vm.motionDetectionAlarm = false;
      }
      vm.pirSensorStatus = setSensorStatus(sensorTypes.pirSensor.id);

      /**
       * Door alarm status
       */
      var doorAlarms = alarms.filter(function (alarm) {
        return alarm.alarmTypeId == alarmTypes.doorAlarm.id;
      });
      if (doorAlarms && doorAlarms.length > 0) {
        vm.doorAlarm = false;
        doorAlarms.forEach(function (a) {
          vm.doorAlarm = vm.doorAlarm || a.enabled;// && connectivity.satellite == false;
        });
      } else {
        vm.doorAlarm = false;
      }


      /**
       * Shock alarm status
       */
      var shockAlarms = alarms.filter(function (alarm) {
        return alarm.alarmTypeId == alarmTypes.mildShockAlarm.id ||
          alarm.alarmTypeId == alarmTypes.severeShockAlarm.id;
      });
      if (shockAlarms && shockAlarms.length > 0) {
        vm.shockAlarm = false;
        shockAlarms.forEach(function (a) {
          vm.shockAlarm = vm.shockAlarm || a.enabled;// && connectivity.satellite == false;;
        });
      } else {
        vm.shockAlarm = false;
      }
      vm.vibrationSensorStatus = setSensorStatus(sensorTypes.vibrationSensor.id);

      /**
       * Tilt alarm status
       */
      var tiltAlarms = alarms.filter(function (alarm) {
        return alarm.alarmTypeId == alarmTypes.tiltAlarm.id;
      });
      if (tiltAlarms && tiltAlarms.length > 0) {
        vm.tiltAlarm = false;
        tiltAlarms.forEach(function (a) {
          vm.tiltAlarm = vm.tiltAlarm || a.enabled;// && connectivity.satellite == false;
        });
      } else {
        vm.tiltAlarm = false;
      }
      vm.tiltSensorStatus = setSensorStatus(sensorTypes.tiltSensor.id);


      /**
       * Item security alarm status
       */
      var itemSecurityAlarms = alarms.filter(function (alarm) {
        return alarm.alarmTypeId == alarmTypes.beaconAlarm.id;
      });
      if (itemSecurityAlarms && itemSecurityAlarms.length > 0) {
        vm.itemSecurityAlarm = false;
        itemSecurityAlarms.forEach(function (a) {
          vm.itemSecurityAlarm = vm.itemSecurityAlarm || a.enabled;// && connectivity.satellite == false;
        });
      } else {
        vm.itemSecurityAlarm = false;
      }
      vm.beaconSensorStatus = setSensorStatus(sensorTypes.beaconSensor.id);
      /**
       * Voltage alarm status
       */

      var voltageAlarms = alarms.filter(function (alarm) {
        return alarm.alarmTypeId == alarmTypes.voltageAlarm.id;
      });
      if (voltageAlarms && voltageAlarms.length > 0) {
        vm.voltageAlarm = false;
        voltageAlarms.forEach(function (a) {
          vm.voltageAlarm = vm.voltageAlarm || a.enabled;//
        });
      } else {
        vm.voltageAlarm = false;
      }
      vm.voltageSensorStatus = setSensorStatus(sensorTypes.voltageSensor.id);

      /**
       * Safe return alarm status
       */
      var safeReturnAlarms = alarms.filter(function (alarm) {
        return alarm.alarmTypeId == alarmTypes.safeReturnAlarm.id;
      });
      if (safeReturnAlarms && safeReturnAlarms.length > 0) {
        vm.safeReturnAlarm = false;
        safeReturnAlarms.forEach(function (a) {
          vm.safeReturnAlarm = vm.safeReturnAlarm || a.enabled;// && connectivity.satellite == false;
        });
      } else {
        vm.safeReturnAlarm = false;
      }

      vm.showNmeaAlarms = function () {
        sessionService.setAlarmSwitch(true);
        $state.go("boat.nmea_alarms", {
          sentinelId: $stateParams.sentinelId
        })
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.alarms')
    .controller('alarmHeaderController', function (alarmService, $filter, moment, oemConfig) {
      var vm = this;
      vm.oemConfig = angular.copy(oemConfig);
      vm.alarms = alarmService.data;

      var latest = $filter('orderBy')(vm.alarms.filter(function (a) {
        return a.dateUpdated != null
      }), 'dateUpdated', true);
      if (latest && latest.length > 0) {
        vm.lastUpdated = $filter('utcDate')(latest[0].dateUpdated);
      } else {
        vm.lastUpdated = 'None'
      }

      latest = $filter('orderBy')(vm.alarms, 'dateAdded', true);
      if (latest && latest.length > 0) {
        vm.lastAdded = $filter('utcDate')(latest[0].dateAdded);
      } else {
        vm.lastAdded = 'None';
      }

      if (vm.lastUpdated != null) {
        if (moment(vm.lastUpdated) > moment(vm.lastAdded)) {
          vm.timeStamp = vm.lastUpdated;
        } else {
          vm.timeStamp = vm.lastAdded;
        }
      } else {
        vm.timeStamp = vm.lastAdded;
      }

    });
})();

(function () {
    'use strict;'
    angular.module('yatch-sentinel.accountSettings')
        .controller('accountSettingsController', function ($translate, accountService, toastr, sessionService, navigationService, config,
            cfpLoadingBar, $rootScope, $stateParams, $uibModal,$scope, oemConfig, countries) {
            var vm = this;
            vm.passwordValidationStatus = {
              minLength: false,
              upperCase: false,
              lowerCase: false,
              number: false
            };
            vm.oemConfig = angular.copy(oemConfig);
            vm.countries = countries;
            vm.lang = sessionService.getLang();
            var token = sessionService.getAuthToken();
            vm.access_token = token.access_token;
            vm.url = config.apiUrl;
            navigationService.navigation = {
                backState: 'boat.home',
                backStateParams: {}
            };
            function guid() {
                function s4() {
                    return Math.floor((1 + Math.random()) * 0x10000)
                        .toString(16)
                        .substring(1);
                }
                return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
            }
            vm.user = angular.copy(sessionService.getUser());
            vm.oldEmailAddress = vm.user.emailAddress;
            vm.user.repeatEmail = vm.user.emailAddress;
            if (oemConfig.oem === "fp" || oemConfig.oem === "") {
                vm.user.selectedCountry = [];
                var selectedCountry = vm.countries.find(function (country) {
                    return country.name === vm.user.country && country.dial_code === vm.user.countryCode;
                });
                if(selectedCountry){
                  selectedCountry.ticked = true;
                  vm.user.selectedCountry.push(selectedCountry);
                }
            }
            vm.updateAccount = function (form) {
                if (vm.user.selectedCountry != undefined && vm.user.selectedCountry != null && vm.user.selectedCountry.length > 0) {
                    vm.user.country = vm.user.selectedCountry[0].name;
                    vm.user.countryCode = vm.user.selectedCountry[0].dial_code;
                }
                if (vm.oldEmailAddress == vm.user.emailAddress) {
                    accountService.update(vm.user, function (response) {
                        sessionService.setUser(response);
                        toastr.success('Account information updated');
                        vm.user = angular.copy(sessionService.getUser());
                        vm.user.repeatEmail = vm.user.emailAddress;
                        $translate.use(vm.lang);
                        sessionService.setLang(vm.lang);
                        form.$setPristine();
                    });
                }
                else
                {
                    vm.acceptTermsAndConditions();
                }
            };
            vm.updateProfile = function (attachmentId) {
                vm.userProfile.attachmentId = vm.attachmentId;
                vm.userProfile.fullName = vm.form.value.name;
                vm.userProfile.emailAddress = vm.form.value.emailAddress;

            };
            vm.flow = {
                target: config.apiUrl + "api/sentinel/" + $stateParams.sentinelId + "/image",
                headers: {
                    Authorization: 'Bearer ' + sessionService.getAuthToken().access_token
                },
                method: 'POST',
                permanentErrors: [500, 501],
                singleFile: true,
                chunkSize: Number.MAX_VALUE
            };

            vm.flowProfile = {
                target: config.apiUrl + "api/attachment/",
                headers: {
                    Authorization: 'Bearer ' + sessionService.getAuthToken().access_token
                },
                method: 'POST',
                permanentErrors: [500, 501],
                singleFile: true,
                chunkSize: Number.MAX_VALUE
            };
            vm.acceptTermsAndConditions = function () {
                $uibModal.open({
                    templateUrl: 'app/main/account-settings/termsAndconditions/accept-terms.html',
                    controller: 'acceptTermsDialogController',
                    controllerAs: 'vm',
                    windowClass: 'contact-modal',
                    resolve: {
                        user: function () {
                            return angular.copy(vm.user);
                        },
                        login: function(){
                          return false;
                        }
                    }
                }).result.then(function (response) {
                    sessionService.setUser(response);
                    toastr.success('Account information updated');
                    toastr.info("Verification Email has been send to your new email. Please follow the instructions to activate your new email");
                    vm.user = angular.copy(sessionService.getUser());
                    vm.user.repeatEmail = vm.user.emailAddress;
                    vm.oldEmailAddress = vm.user.emailAddress;
                    $translate.use(vm.lang);
                    sessionService.setLang(vm.lang);
                });
            };
            vm.boatImageSuccess = function ($file, $message) {
                cfpLoadingBar.complete();
                toastr.success('Boat updated successfully');
                $rootScope.uuid = guid();
                $scope.$emit('boatImageUpdated', "success");
            };
            vm.profileImageSuccess = function ($file, $message, $flow) {
                vm.user.attachmentId = angular.fromJson($message);
                accountService.updateProfile(vm.user.id, vm.user, function (response) {
                    if (response != null) {
                        accountService.me(function (response) {
                            sessionService.setUser(response);
                            vm.user = angular.copy(sessionService.getUser());
                        });
                    }
                });

                cfpLoadingBar.complete();
                toastr.success('Profile updated successfully');
                $rootScope.uuid = guid();

            };

            vm.onUploadStarted = function () {
                cfpLoadingBar.start();
            };

            vm.onUploadComplete = function () {
                cfpLoadingBar.complete();
            };

            vm.onPasswordChange = function ($event) {
              var value = $event.target.value;
              if (value.length >= 8) {
                vm.passwordValidationStatus.minLength = true;
              } else {
                vm.passwordValidationStatus.minLength = false;
              }

              const lowerCaseRegex = /^(.*[a-z]).*$/gm
              var foundLower = value.match(lowerCaseRegex);
              if (foundLower && foundLower.length > 0) {
                vm.passwordValidationStatus.lowerCase = true
              }
              else {
                vm.passwordValidationStatus.lowerCase = false
              }

              const upperCaseRegex = /^(.*[A-Z]).*$/gm
              var foundUpper = value.match(upperCaseRegex);
              if (foundUpper && foundUpper.length > 0) {
                vm.passwordValidationStatus.upperCase = true
              }
              else {
                vm.passwordValidationStatus.upperCase = false
              }

              const numberRegex = /^(?=.*\d).*$/gm
              var foundNumber = value.match(numberRegex);
              if (foundNumber && foundNumber.length > 0) {
                vm.passwordValidationStatus.number = true
              }
              else {
                vm.passwordValidationStatus.number = false
              }
            }
        });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.accountDetails',[])
    .config(function ($stateProvider, $translatePartialLoaderProvider) {
      $stateProvider
        .state('accountDetails', {
          url: '/accountDetails',
          templateUrl: 'app/main/account-details/account-form.html',
          controller: 'accountFormController',
          controllerAs: 'vm',
          resolve: {
            countries: function (http) {
              return http.get("assets/countries.json");
            },
            boats: function (userService) {
              return userService.getUserSentinels();
            }
          }
        });
        $translatePartialLoaderProvider.addPart('app/main/account-details');
    });
})();

(function () {
  "use strict;";
  angular
    .module("yatch-sentinel.accountDetails")
    .controller("accountFormController", function (toastr, $state, sentinelService, sessionService, boats, accountService, oemConfig, countries, $location) {
      var vm = this;
      vm.queryString = $location.search();
      vm.user = sessionService.getUser();
      vm.boats = boats;
      vm.newUser = {};
      vm.countries = countries;
      vm.countryMessage = "";
      vm.oemConfig = angular.copy(oemConfig);
      vm.checkCountry = function () {
        if (vm.newUser.selectedCountry == undefined || vm.newUser.selectedCountry == null || vm.newUser.selectedCountry.length == 0) {
          vm.countryMessage = "country is required"
          return true;
        }
        else {
          vm.countryMessage = "";
          return false;
        }
      }

      vm.updateAccount = function (form) {
        if (vm.newUser.selectedCountry == undefined || vm.newUser.selectedCountry == null || vm.newUser.selectedCountry.length == 0) {
          return;
        }
        vm.user.fullName = vm.newUser.firstName + " " + vm.newUser.lastName;
        // vm.user.emailAddress = vm.newUser.emailAddress;
        vm.user.mobileNumber = vm.newUser.mobileNumber;
        vm.user.address = vm.newUser.address;
        vm.user.zipCode = vm.newUser.zipCode;
        vm.user.city = vm.newUser.city;
        vm.user.homePort = vm.newUser.homePort;
        vm.user.country = vm.newUser.selectedCountry[0].name;
        vm.user.countryCode = vm.newUser.selectedCountry[0].dial_code;
        accountService.update(vm.user, function (response) { });
        sentinelService.UpdateAllUserSentinelsOfATenant(vm.boats);
        accountService.updateAgreedStatus(
          true,
          function () {
            vm.account = {};
          }
        );
        accountService.me(function (user) {
          sessionService.setUser(user);
        });
        if (!vm.user.isPasswordPolicySatisfied && !vm.user.isPasswordUpdateSkipped) {
          $state.go("update-password");
        } else {
          toastr.success('Logged In');
          $state.go('boat.home');
        }
      }
    });
})();

(function () {
    'use strict;'
    angular.module('yatch-sentinel.common')
        .directive('ngSrcAuthorized', function (sessionService, config) {
            return {
                restrict: 'A',
                link: function (scope, elem, attrs) {
                    var token = sessionService.getAuthToken();
                    var url = config.apiUrl + attrs.ngSrcAuthorized
                    if (token) {
                        url += "?access_token=" + token.access_token;
                        elem.prop('src', url);
                        elem.css({
                            'background-image': 'url(' + url + ')'
                        });
                    } else {
                        elem.prop('src', url);
                        elem.css({
                            'background-image': 'url(' + url + ')'
                        });
                    }

                    scope.$watch(function () {
                        return attrs.ngSrcAuthorized;
                    }, function () {
                        var token = sessionService.getAuthToken();
                         var url = config.apiUrl + attrs.ngSrcAuthorized
                        if (token) {
                                 url += "?access_token=" + token.access_token;
                            elem.prop('src', url);
                            elem.css({
                                'background-image': 'url(' + url + ')'
                            });
                        } else {
                            elem.prop('src', url);
                            elem.css({
                                'background-image': 'url(' + url + ')'
                            });
                        }
                    });
                }
            }
        });
})();
(function () {
  angular.module('yatch-sentinel.forum')
    .directive('showNewPostDialog', function () {
      return {
        restrict: 'A',
        templateUrl: 'app/main/forum/new/new-post.html',
        scope: {
          showHidden: '=?',
          hideCategory: '=?',
          callback: '=',
          categories: "="
        },
        transclude: true,
        controllerAs: "vm",
        link: function (scope, elem, attrs) {

        },
        controller: function ($scope, $timeout, $stateParams, sessionService, config, toastr, cfpLoadingBar, userService) {
          var vm = this;
          vm.disableButton = false;
          vm.showProgressBar = false;
          vm.flowProgressValue = 0;
          vm.forum = {
            forumAttachmentIds: []
          };
          vm.tinymceModel = 'Initial content';

          vm.getContent = function () {
            console.log('Editor content:', vm.tinymceModel);
          };

          vm.setContent = function () {
            vm.tinymceModel = 'Time: ' + (new Date());
          };

          vm.tinymceOptions = {
            plugins: 'link image code media',
            toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | code',
            height: 300,
          };
          vm.uploadedFiles = [];
          vm.uploadApi = {
            target: config.apiUrl + "api/attachment/",
            headers: {
              Authorization: 'Bearer ' + sessionService.getAuthToken().access_token
            },
            method: 'POST',
            permanentErrors: [500, 501],
            singleFile: true,
            chunkSize: Number.MAX_VALUE
          };
          vm.onUploadStarted = function (file, flow) {
            vm.showProgressBar = true;
            vm.disableButton = true;
          };

          vm.flowProgress = function (flow) {
            vm.flowProgressValue = flow.progress() * 100;
          }

          vm.onUploadComplete = function () {
            vm.showProgressBar = false;
            vm.disableButton = false;
          };
          vm.onUploadSuccess = function (file, $attachmentId) {

            cfpLoadingBar.complete();
            var attachmentId = Number($attachmentId);
            vm.forum.forumAttachmentIds.push(attachmentId);
            file.attachmentId = $attachmentId;
            vm.uploadedFiles.push(file);
            toastr.success('File Uploaded successfully');
          };

          vm.deleteUploadedFile = function (file) {
            if (confirm("Are you sure you want to Delete this File?")) {
              const fileIndexToDelete = vm.uploadedFiles.indexOf(file);
              vm.uploadedFiles.splice(fileIndexToDelete, 1);
              const attachmentIndexToDelete = vm.forum.forumAttachmentIds.filter(function (index) {
                return index == file.attachmentId;
              });
              const removedAttachmentId = vm.forum.forumAttachmentIds.indexOf(attachmentIndexToDelete[0]);
              vm.forum.forumAttachmentIds.splice(removedAttachmentId, 1);
              toastr.success("File Deleted Successfully.");
            }
          };
          vm.createPost = function (form) {
            var categoryId = 0;
            if (!$scope.hideCategory) {
              categoryId = vm.forum.category;
            }
            else {
              categoryId = $stateParams.categoryId;
            }
            userService.createForumPost(categoryId, vm.forum, function (response) {
              toastr.success("Post Submitted Successfully.");
              vm.forum = {
                forumAttachmentIds: []
              };
              vm.uploadedFiles = [];
              $timeout(function () {
                form.$setPristine();
                form.$setUntouched();
                form.$submitted = false;
              });
              $scope.callback(true);
            });
          }
        }
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('yatch-sentinel', [
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ui.router',
      'ui.bootstrap',
      'toastr',
      'ngStorage',
      'SignalR',
      'ngScrollbars',
      'pascalprecht.translate',
      'yatch-sentinel.services',
      'yatch-sentinel.landing_page',
      'yatch-sentinel.tutorial',
      'yatch-sentinel.forum',
      'angular-loading-bar',
      'yatch-sentinel.login',
      'yatch-sentinel.home',
      'yatch-sentinel.privacy',
      'yatch-sentinel.cameras',
      'yatch-sentinel.spinner',
      'flow',
      'angular-timeline',
      'angular-scroll-animate',
      'angularjs-datetime-picker',
      'yatch-sentinel.nmea',
      'yatch-sentinel.nmea_journey',
      'yatch-sentinel.nmea_map',
      'chart.js',
      'oitozero.ngSweetAlert',
      'yatch-sentinel.helpCenter',
      'yatch-sentinel.distributor_map',
      'yatch-sentinel.redirect',
      'yatch-sentinel.update_password',
      'ui.tinymce'
    ]);

})();

(function () {
  angular.module('yatch-sentinel')
    .service('maritimeMapService', function () {
      return {
        instanceCount: 0
      }
    })
    .directive('maritimeMap', function (RecenterMap, maritimeMapService) {
      return {
        restrict: 'E',
        templateUrl: 'app/directives/maritime/maritime.html',
        scope: {
          location: '=location'
        },
        transclude: true,
        link: function (scope, elem, attrs) {
          maritimeMapService.instanceCount++;
          scope.instanceCount = maritimeMapService.instanceCount;

          var iconFeature = new ol.Feature({
            geometry: new ol.geom.Point(ol.proj.fromLonLat([scope.location.longitude, scope.location.latitude]))
          });

          var iconStyle = new ol.style.Style({
            image: new ol.style.Icon({
              src: 'assets/images/boat-location.png',
              scale: 1,
            }),
          });

          iconFeature.setStyle(iconStyle);

          var vectorSource = new ol.source.Vector({
            features: [iconFeature],
          });

          var vectorLayer = new ol.layer.Vector({
            source: vectorSource,
          });

          setTimeout(function () {
            scope.map = new ol.Map({
              controls: ol.control.defaults().extend([new RecenterMap(ol.proj.fromLonLat([scope.location.longitude, scope.location.latitude]))]),
              target: 'map' + scope.instanceCount,
              layers: [
                new ol.layer.Tile({
                  source: new ol.source.OSM({
                    attributions: []
                  }),
                }),
                new ol.layer.Tile({
                  source: new ol.source.XYZ({
                    url: "https://t1.openseamap.org/seamark/{z}/{x}/{y}.png",
                  })
                }),
                vectorLayer
              ],
              view: new ol.View({
                center: ol.proj.fromLonLat([scope.location.longitude, scope.location.latitude]),
                zoom: 16,
              }),
            });
            // Popup showing the position the user clicked
            var popupElem = document.getElementById('popup');

            var popup = new ol.Overlay({
              element: popupElem,
              positioning: 'bottom-center',
              stopEvent: false,
              offset: [0, -25]
            });
            scope.map.addOverlay(popup);
            // display popup on click
            scope.map.on('click', function (evt) {
              var feature = scope.map.forEachFeatureAtPixel(evt.pixel, function (feature) {
                return feature;
              });
              if (feature) {
                var coordinates = feature.getGeometry().getCoordinates();
                popup.setPosition(coordinates);
                popupElem.click();
              }
            });
          });
        },
        controller: function ($scope, $localStorage, $timeout) {

        }
      }
    });
})();

(function () {
    angular.module('yatch-sentinel.register')
        .directive('confirmPwd', function ($interpolate, $parse) {
            return {
                require: 'ngModel',
                link: function (scope, elem, attr, ngModelCtrl) {

                    var pwdToMatch = $parse(attr.confirmPwd);
                    var pwdFn = $interpolate(attr.confirmPwd)(scope);

                    scope.$watch(pwdFn, function (newVal) {
                        ngModelCtrl.$setValidity('password', ngModelCtrl.$viewValue == newVal);
                    })

                    ngModelCtrl.$validators.password = function (modelValue, viewValue) {
                        var value = modelValue || viewValue;
                        return value == pwdToMatch(scope);
                    };

                }
            }
        });
})();

(function () {
  'use strict';
  angular.module('yatch-sentinel.services')
    .service('userService',
      function (http, config, $q) {
        return {
          getUserSentinels: function (onSuccess) {
            return http.get(config.apiUrl + "api/user/sentinels", {}, onSuccess);
          },
          getUserSentinelById: function (userSentinelId, onSuccess, onError) {
            return http.get(config.apiUrl + "api/user/sentinel/" + userSentinelId, {}, onSuccess, onError);
          },
          getDistributorMapData: function (latitude,longitude, onSuccess, onError) {
            return http.get(config.apiUrl + "api/tenant/mapData/" +latitude+"/"+longitude, {}, onSuccess, onError);
          },
          getDistributorMapDataAll: function (searchTerm) {

            return http.get(config.apiUrl + "api/tenant/mapDataAll" , {searchTerm:searchTerm});
          },
          getDistributorMapDataStatus: function () {

            return http.get(config.apiUrl + "api/tenant/distributorMap/status" , {});
          },
          getSharedSentinels: function (onSuccess) {
            return http.get(config.apiUrl + "api/user/sentinels/shared/", {}, onSuccess);
          },
          updateSonoffStatus: function (userSentinelId, onSuccess) {
            return http.post(config.apiUrl + "api/user/userSentinel/"+userSentinelId+"/deviceStatus", onSuccess);
          },
          addUserSeninel: function (model, onSuccess) {
            return http.post(config.apiUrl + "api/user/sentinels/add", model, onSuccess);
          },
          addNmeaOnlyUserSeninel: function (model, onSuccess) {
            return http.post(config.apiUrl + "api/user/sentinels/add/nmea-only", model, onSuccess);
          },
          saveUserContacts: function (model, onSuccess) {
            return http.post(config.apiUrl + "api/user/contacts", model, onSuccess);
          },
          saveDirectory: function (model,userSentinelId, onSuccess) {
            return http.post(config.apiUrl + "api/user/userSentinel/"+userSentinelId+"/attachmentDirectory/add", model, onSuccess);
          },
          saveUserContact: function (model, onSuccess) {
            return http.post(config.apiUrl + "api/user/contact", model, onSuccess);
          },
          editContact: function (model, onSuccess) {
            return http.put(config.apiUrl + "api/user/contact", model, onSuccess);
          },
          getUserContacts: function (onSuccess) {
            return http.get(config.apiUrl + "api/user/contacts", {}, onSuccess);
          },
          deleteUserContact: function (userContactId, success, error) {
            http.delete(config.apiUrl + "api/user/contact/" + userContactId, {}, success, error);
          },
          getContactById: function (userContactId, onSuccess) {
            return http.get(config.apiUrl + "api/user/contacts/" + userContactId, {}, onSuccess);
          },
          saveSettings: function (model, onSuccess) {
            return http.post(config.apiUrl + "api/user/insertsettings", model, onSuccess);
          },
          sendSosMessage: function (userSentinelId, extraMessage, onSuccess) {
            return http.post(config.apiUrl + "api/user/sendSosMessage/" + userSentinelId, "\"" + extraMessage + "\"", onSuccess);
          },
          getNotificationCount: function (onSuccess) {
            return http.get(config.apiUrl + "api/user/notifications/count", {}, onSuccess);
          },
          getSettings: function (onSuccess) {
            return http.get(config.apiUrl + "api/setting/all", {}, onSuccess);
          },
          getSharedUsers: function (onSuccess, onError) {
            return http.get(config.apiUrl + "api/user/shared", {}, onSuccess, onError);
          },
          createSharedUsers: function (model, success, error) {
            return http.post(config.apiUrl + "api/user/shared/", model, success, error);
          },
          createForumPost:function(forumCategoryId,model,success,error)
          {
            return http.post(config.apiUrl + "api/user/forumCategory/"+forumCategoryId+"/forumPost/", model, success, error);
          },
          createForumPostMessage:function(forumCategoryId,forumPostId,model,success,error)
          {
            return http.post(config.apiUrl + "api/user/forumCategory/"+forumCategoryId+"/forumPost/"+forumPostId+"/message", model, success, error);
          },
          setUserEditPermission: function (userId, canEdit, success, error) {
            return http.put(config.apiUrl + "api/user/shared/" + userId + "/permission/edit/" + canEdit, {}, success, error);
          },
          setUserViewLivePermission: function (userId, canViewLive, success, error) {
            return http.put(config.apiUrl + "api/user/shared/" + userId + "/permission/live/" + canViewLive, {}, success, error);
          },
          setUserViewAlertsPermission: function (userId, canViewAlerts, success, error) {
            return http.put(config.apiUrl + "api/user/shared/" + userId + "/permission/alert/" + canViewAlerts, {}, success, error);
          },
          getSharedUserPermissions: function (userSentinelId, success, error) {
            return http.get(config.apiUrl + "api/user/sentinel/" + userSentinelId + "/shared/permissions", {}, success, error);
          },
          deleteSharedUser: function (userId, success, error) {
            return http.delete(config.apiUrl + "api/user/shared/" + userId, {}, success, error);
          },
          deleteUserSentinel: function (userSentinelId) {
            return http.delete(config.apiUrl + "api/user/sentinels/" + userSentinelId);
          },

          sellUserSentinel: function (userSentinelId,email,password,sellTo) {
            return http.post(config.apiUrl + "api/user/sell/sentinels/" + userSentinelId,{EmailAddress:email,Password:password,SellTo:sellTo});
          },


          deleteSharedBoat: function (userSentinelId) {
            return http.delete(config.apiUrl + "api/user/Sentinels/Shared/" + userSentinelId);
          },
          getAllUserSentinelAttachments: function (userSentinelId, success) {
            return http.get(config.apiUrl + "api/user/userSentinel/" + userSentinelId + "/files", {}, success);
          },
          getAllUserSentinelDirectoriesAndAttachments: function (userSentinelId,attachmentDirectoryId, success) {
            return http.get(config.apiUrl + "api/user/userSentinel/" + userSentinelId + "/attachmentDirectory/all?attachmentDirectoryId="+attachmentDirectoryId, {}, success);
          },
          deleteUserSentinelAttachment: function (userSentinelId, attachmentId, success) {
            return http.delete(
              config.apiUrl +
              "api/user/userSentinel/" +
              userSentinelId +
              "/file/" +
              attachmentId, {}, success);
          },
          deleteDirectoryById: function (attachmentDirectoryId,userSentinelId, success) {
            return http.delete(
              config.apiUrl +
              "api/user/userSentinel/" + userSentinelId + "/attachmentDirectory/"+
              attachmentDirectoryId, {}, success);
          },
          updateUserSentinelAttachment: function (userSentinelId, attachmentId,name, success) {
            return http.put(
              config.apiUrl +
              "api/user/userSentinel/" +
              userSentinelId +
              "/file/" +
              attachmentId+"?name="+name, {}, success);
          },
          updateDirectoryName: function (attachmentDirectoryId,userSentinelId,name, success) {
            return http.put(
              config.apiUrl +
              "api/user/userSentinel/" + userSentinelId + "/attachmentDirectory/"+
              attachmentDirectoryId +"?name="+name, {}, success);
          },
          downloadUserSentinelAttachment: function (userSentinelId, attachmentId, success) {
            return http.get(
              config.apiUrl +
              "api/user/userSentinel/" +
              userSentinelId +
              "/file/" +
              attachmentId +
              "/download", {}, success);
          },
          downloadForumAttachment: function (attachmentId, success) {
            return http.get(
              config.apiUrl +
              "api/user/forumCategory/forumPost/file/" +
              attachmentId +
              "/download", {}, success);
          }
        }
      });
})();

(function () {
  "use strict";
  angular
    .module("yatch-sentinel.services")
    .service("tuyaCameraService", function (http, config) {
      var vm = this;
      vm.tuya = {
        ssid: "",
        token: "",
        password: "",
        qrcodeImage: "",
        tuyaUserDbId: "",
        userSentinelId: "",
      };
      return {
        account_info: function (sentinelId) {
          return http.get(
            config.apiUrl +
            "api/tuya/userSentinel/" +
            sentinelId +
            "/account_info"
          );
        },

        getQrCode: function (ssid, password, token) {
          return http.post(config.apiUrl + "api/tuya/qrcode", {
            p: password,
            s: ssid,
            t: token,
          });
        },

        assignDeviceToSentinel: function (deviceId, sentinelId, tuyaUserDbId, name) {
          return http.post(
            config.apiUrl +
            "api/tuya/add/device/" +
            deviceId +
            "/userSentinel/" +
            sentinelId +
            "/user/" +
            tuyaUserDbId + "/camera/" + name,
            {
              userSentinel: sentinelId,
              deviceId: deviceId,
              tuyaUserId: tuyaUserDbId,
              name: name
            }
          );
        },
        allUserSentinelDevices: function (userSentinelId) {
          return http.get(
            config.apiUrl + "api/tuya/device/userSentinel/" + userSentinelId
          );
        },

        getLiveStream: function (deviceId) {
          return http.get(
            config.apiUrl + "api/tuya/device/" + deviceId + "/live"
          );
        },
        deleteCamera: function (deviceId, usersentinelid) {
          return http.delete(
            config.apiUrl + "api/tuya/device/" + deviceId + "/userSentinel/" + usersentinelid
          );
        },
        nightVision: function (deviceId, value) {
          return http.get(
            config.apiUrl + "api/tuya/device/" + deviceId + "/nightvision/" + value
          );
        },

        armed: function (deviceId, value) {
          return http.get(
            config.apiUrl + "api/tuya/device/" + deviceId + "/armed/" + value
          );
        },

        getSettings: function (deviceId) {
          return http.get(
            config.apiUrl + "api/tuya/device/" + deviceId + "/settings"
          );
        },

        getCameraName: function (deviceId) {
          return http.get(
            config.apiUrl + "api/tuya/device/" + deviceId + "/name"
          );
        },

        getCameraEvents: function (tuyaDeviceId, userSentinelId, pageNumber) {
          return http.get(
            config.apiUrl + "api/tuya/devices/" + tuyaDeviceId + "/" + userSentinelId + "/events",{
              pageNumber: pageNumber
            }
          );
        },

        getSnapshotUrl: function(tuyaDeviceId, userSentinelId, attachmentId){
          return http.get(
            config.apiUrl + "api/tuya/devices/" + tuyaDeviceId + "/" + userSentinelId + "/snapshot/" + attachmentId + "/url"
          );
        }
      };
    });
})();

(function () {
  'use strict';
  angular.module('yatch-sentinel.services')
    .service('tenantService',
      function (http, config, $q) {
        return {
          getAllTenantCategories: function (onSuccess) {
            return http.get(config.apiUrl + "api/tenant/forumCategory/all", {}, onSuccess);
          },
          updateNumberOfViews: function (forumCategoryId, onSuccess) {
            return http.put(config.apiUrl + "api/tenant/forumCategory/" + forumCategoryId, {}, onSuccess);
          },
          getNumberOfThreads: function (onSuccess) {
            return http.get(config.apiUrl + "api/tenant/forumCategory/forumPost/count", {}, onSuccess);
          },
          getCategoriesHierarchy: function (onSuccess) {
            return http.get(config.apiUrl + "api/tenant/forumCategory/hierarchy", {}, onSuccess);
          },
          getTenantCategory: function (forumCategoryId, onSuccess) {
            return http.get(config.apiUrl + "api/tenant/forumCategory/" + forumCategoryId, {}, onSuccess);
          },
          getForumCategoryPosts: function (forumCategoryId, onSuccess) {
            return http.get(config.apiUrl + "api/tenant/forumCategory/" + forumCategoryId+"/forumPost/all", {}, onSuccess);
          },
          getForumPosts: function (forumCategoryId,forumPostId, onSuccess) {
            return http.get(config.apiUrl + "api/tenant/forumCategory/" + forumCategoryId+"/forumPost/"+forumPostId, {}, onSuccess);
          },
          getLatestPosts: function (onSuccess) {
            return http.get(config.apiUrl + "api/tenant/forumCategory/forumPost/latest", {}, onSuccess);
          },
          isForumEnable: function () {
            return http.get(config.apiUrl + "api/tenant/forumCheck");
          }
        }
      });
})();

(function () {
    'use strict;'
    angular.module('yatch-sentinel.services')
        .factory('speedWaterReferencedTypeEnum', function () {
            return {
                PaddleWheel:1,
                PitotTube:2,
                DopplerLog:3,
                CorrelationLog:4,
                EMLog:5
            };
        });
})();
(function () {
  'use strict;'
  angular.module('yatch-sentinel.services')
    .factory('settingEnum', function () {
      return {
        Temperature: {
          id: 1,
          description: 'Temperature'
        },
        Speed: {
          id: 2,
          description: 'Speed'
        },
        Weight: {
          id: 3,
          description: 'Weight'
        },
        Height: {
          id: 4,
          description: 'Height'
        },
        Distance: {
          id: 5,
          description: 'Distance'
        },
        Volume: {
          id: 6,
          description: 'Volume'
        }
      };
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.services')
    .service('sessionService', function ($localStorage, $cookies, moment) {
      $localStorage.cache = {};
      return {
        getAuthToken: function () {
          return $cookies.getObject('token');
          //return $localStorage.token
        },
        deleteAuthToken: function () {
          $cookies.remove('token');
          //delete $localStorage.token;
        },
        setAuthToken: function (token, rememberMe) {
          var cookieExpiry = moment().add('year', 1).format();
          if (rememberMe) {
            $cookies.putObject('token', token, {
              expires: cookieExpiry
            });
          } else {
            $cookies.putObject('token', token);
          }
          $localStorage.rememberMe = rememberMe;
        },
        setUser: function (user) {
          $localStorage.user = user;
        },
        getUser: function () {
          return $localStorage.user;
        },
        setSonoffRememberMe: function (sonoff) {
          $localStorage.sonoffRememberMe = sonoff;
        },
        getSonoffRememberMe: function () {
          return $localStorage.sonoffRememberMe;
        },
        setLoginState: function (platform) {
          $localStorage.platform = platform;
        },
        getLoginState: function () {
          return $localStorage.platform;
        },
        setUserSettings: function (settings) {
          $localStorage.userSettings = settings;
        },
        getUserSettings: function () {
          return $localStorage.userSettings;
        },
        setETag: function (key, tag) {
          $localStorage.cache[key] = tag;
        },
        getETag: function (key) {
          return $localStorage.cache[key];
        },
        getLang: function () {
          return $localStorage.lang || 'en';
        },
        setLang: function (lng) {
          $localStorage.lang = lng;
        },
        setUserSentinel: function (userSentinelId) {
          $localStorage.userSentinelId = userSentinelId;
        },
        getUserSentinel: function () {
          return $localStorage.userSentinelId;
        },
        setDashboardSwitch: function (switchBool) {
          $localStorage.switchBool = switchBool;
          $cookies.putObject('dashboardSwitch', switchBool);
        },
        getDashboardSwitch: function () {
          return $localStorage.switchBool;
        },
        setAlarmSwitch: function (nmeaSwitch) {
          $localStorage.nmeaSwitch = nmeaSwitch;
          $cookies.putObject('nmeaSwitch', nmeaSwitch);
        },
        getAlarmSwitch: function () {
          return $localStorage.nmeaSwitch;
        },
        setMapSwitch: function (mapSwitch) {
          $localStorage.mapSwitch = mapSwitch;
          $cookies.putObject('mapSwitch', mapSwitch);
        },
        getMapSwitch: function () {
          return $localStorage.mapSwitch;
        },
        setJournySwitch: function (journySwitch) {
          $localStorage.journySwitch = journySwitch;
          $cookies.putObject('journySwitch', journySwitch);
        },
        getJournySwitch: function () {
          return $localStorage.journySwitch;
        }
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.services')
    .service('sentinelService', function (http, config) {
      return {
        getSentinelSensorStatuses: function (sentinelId, onSuccess) {
          return http.get(config.apiUrl + "api/sentinel/latest/status/" + sentinelId, {}, onSuccess);
        },
        getSentinelLocation: function (sentinelId, onSuccess) {
          return http.get(config.apiUrl + "api/sentinel/location/latest/" + sentinelId, {}, onSuccess);
        },
        getAllSentinelsLocation: function (onSuccess) {
          return http.get(config.apiUrl + "api/sentinel/location/latest/allSentinels/", {}, onSuccess);
        },
        deleteSentinelLocations: function (sentinelId) {
          return http.delete(config.apiUrl + "api/sentinel/" + sentinelId + "/locations");
        },
        getNearByMarines: function (sentinelId, onSuccess) {
          return http.get(config.apiUrl + "api/sentinel/location/nearBy/" + sentinelId, {}, onSuccess);
        },
        getSentinelRoute: function (sentinelId, duration, onSuccess) {
          return http.get(config.apiUrl + "api/sentinel/route/" + sentinelId + "/" + duration, {}, onSuccess);
        },
        getSentinelRouteSummary: function (sentinelId, duration, onSuccess) {
          return http.get(config.apiUrl + "api/sentinel/route/summary/" + sentinelId + "/" + duration, {}, onSuccess);
        },
        getSentinel: function (id, onSuccess) {
          return http.get(config.apiUrl + "api/sentinel/" + id, {}, onSuccess);
        },
        getSentinelWeather: function (date, userSentinelId, onSuccess, onError) {
          return http.get(config.apiUrl + "api/sentinel/weather/getSentinelWeather/" + userSentinelId, {
            date: date
          }, onSuccess, onError);
        },
        getForeCast: function (date, userSentinelId, onSuccess, onError) {
          return http.get(config.apiUrl + "api/sentinel/weather/getSentinelForeCast/" + userSentinelId, {
            date: date
          }, onSuccess, onError);
        },
        getSentinelAlarms: function (sentinelId, onSuccess) {
          return http.get(config.apiUrl + "api/sentinel/alarms/" + sentinelId, {}, onSuccess)
            .then(function (response) {
              response.forEach(function (r) {
                if (r.alarmValue) {
                  r.alarmValue = angular.fromJson(r.alarmValue);
                }
              });
              return response;
            });
        },
        saveBoatSettings: function (model, onSuccess) {
          return http.post(config.apiUrl + "api/sentinel/boatSettings", model, onSuccess);
        },
        updateCameraOnlyBoat: function (model, onSuccess) {
          return http.post(config.apiUrl + "api/sentinel/cameraOnly", model, onSuccess);
        },
        UpdateAllUserSentinelsOfATenant: function (model, onSuccess){
          return http.put(config.apiUrl + "api/sentinel/updateAllUserSentinels",model, onSuccess);
        },
        saveSentinelBatteryAlarm: function (alarm, onSuccess) {
          return http.post(config.apiUrl + "api/sentinel/alarm", alarm, onSuccess);
        },
        saveShockAlarm: function (userSentinelId, alarms, success, error) {
          return http.post(config.apiUrl + "api/sentinel/alarm/shock/" + userSentinelId, alarms, success, error);
        },
        updateSentinelSensor: function (sentinelSensor, onSuccess) {
          return http.post(config.apiUrl + "api/sentinel/sentinelSensor/update", sentinelSensor, onSuccess);
        },
        checkShorePowerStatus: function (userSentinelId, onSuccess) {
          return http.get(config.apiUrl + "api/sentinel/sentinelSensor/shorePowerStatus/" + userSentinelId, {}, onSuccess);
        },
        getBatteryAlarm: function (userSentinelId, onSuccess, onError) {
          return http.get(config.apiUrl + "api/sentinel/alarm/BatteryAlarm/" + userSentinelId, {}, onSuccess, onError)
            .then(function (alarms) {
              if (alarms && alarms.boatBatteryAlarm && alarms.boatBatteryAlarm.alarmValue) {
                alarms.boatBatteryAlarm.alarmValue = angular.fromJson(alarms.boatBatteryAlarm.alarmValue);
              }
              if (alarms && alarms.sentinelBatteryAlarm && alarms.sentinelBatteryAlarm.alarmValue) {
                alarms.sentinelBatteryAlarm.alarmValue = angular.fromJson(alarms.sentinelBatteryAlarm.alarmValue);
              }
              if (alarms && alarms.voltageBatteryAlarm && alarms.voltageBatteryAlarm.alarmValue) {
                alarms.voltageBatteryAlarm.alarmValue = angular.fromJson(alarms.voltageBatteryAlarm.alarmValue);
              }
              return alarms;
            });
        },
        updateBatteryAlarm: function (userSentinelId, model, success, error) {
          model.boatBatteryAlarm.alarmValue = angular.toJson(model.boatBatteryAlarm.alarmValue);
          model.sentinelBatteryAlarm.alarmValue = angular.toJson(model.sentinelBatteryAlarm.alarmValue);
          model.voltageBatteryAlarms.forEach(function (element) {
            if(!element) return;
            element.alarmValue = angular.toJson(element.alarm.alarmValue);
          });
          return http.post(config.apiUrl + "api/sentinel/alarm/battery/" + userSentinelId, model, success, error);
        },
        getGeofenceAlarm: function (userSentinelId, onSuccess, onError) {
          return http.get(config.apiUrl + "api/sentinel/alarm/geofenceAlarm/" + userSentinelId, {}, onSuccess, onError)
            .then(function (response) {
              if (response.geoFenceMoveOut != null && response.geoFenceMoveOut.alarmValue != null) {
                response.geoFenceMoveOut.alarmValue = angular.fromJson(response.geoFenceMoveOut.alarmValue);
              }
              if (response.geoFenceMoveIn != null && response.geoFenceMoveIn.alarmValue != null) {
                response.geoFenceMoveIn.alarmValue = angular.fromJson(response.geoFenceMoveIn.alarmValue);
              }
              return response;
            });
        },
        getSafeReturnAlarm: function (userSentinelId, onSuccess, onError) {
          return http.get(config.apiUrl + "api/sentinel/alarm/safeReturn/" + userSentinelId, {}, onSuccess, onError)
            .then(function (response) {
              if (response != null && response.alarmValue != null && response.alarmValue != "") {
                response.alarmValue = angular.fromJson(response.alarmValue);
              }
              return response;
            });
        },
        updateSafeReturnAlarm: function (userSentinelId, model, success, error) {
          return http.post(config.apiUrl + "api/sentinel/alarm/safeReturn/" + userSentinelId, model, success, error);
        },
        updateGeoFenceAlarm: function (userSentinelId, model, success, error) {
          return http.post(config.apiUrl + "api/sentinel/alarm/Geofence/" + userSentinelId, model, success, error);
        },
        getSentinelSensorsBySensorType: function (userSentinelId, sensorTypeId, onSuccess) {
          return http.get(config.apiUrl + "api/sentinel/sensors/" + userSentinelId + "/" + sensorTypeId, {}, onSuccess);
        },
        canUserAccessTheSentinel: function (userSentinelId, onSuccess) {
          return http.get(config.apiUrl + "api/sentinel/sentineAccess/" + userSentinelId, {}, onSuccess);
        },
        getSentinelSensors: function (userSentinelId, success, error) {
          return http.get(config.apiUrl + "api/sentinel/sensors/" + userSentinelId, {}, success, error);
        },
        getSentinelSensor: function (userSentinelId, sentinelSensorId, success, error) {
          return http.get(config.apiUrl + "api/sentinel/" + userSentinelId + "/sensor/" + sentinelSensorId, {}, success, error);
        },
        getTemperatureAlarms: function (userSentinelId, onSuccess, onError) {
          return http.get(config.apiUrl + "api/sentinel/alarm/temperature/" + userSentinelId, {}, onSuccess, onError)
            .then(function (response) {
              if (response == null || response.length == 0) return response;
              response.forEach(function (r) {
                if (r.alarmValue) {
                  r.alarmValue = angular.fromJson(r.alarmValue);
                }
              });
              return response;
            });
        },
        updateTemperatureAlarms: function (userSentinelId, model, success, error) {
          var copy = angular.copy(model);
          copy.forEach(function (c) {
            c.alarmValue = angular.toJson(c.alarmValue);
          });
          return http.post(config.apiUrl + "api/sentinel/alarm/temperature/" + userSentinelId, copy, success, error);
        },
        getVibrationAlarms: function (userSentinelId, onSuccess, onError) {
          return http.get(config.apiUrl + "api/sentinel/alarm/vibration/" + userSentinelId, {}, onSuccess, onError);
        },
        getTiltAlarm: function (userSentinelId, onSuccess, onError) {
          return http.get(config.apiUrl + "api/sentinel/alarm/tilt/" + userSentinelId, {}, onSuccess, onError)
            .then(function (response) {
              if (response && response.alarmValue) {
                response.alarmValue = angular.fromJson(response.alarmValue);
              }
              return response;
            });

        },
        getBeaconAlarm: function (userSentinelId, onSuccess, onError) {
          return http.get(config.apiUrl + "api/sentinel/alarm/beacon/" + userSentinelId, {}, onSuccess, onError)
            .then(function (response) {
              if (response && response.alarmValue) {
                response.alarmValue = angular.fromJson(response.alarmValue);
              }
              return response;
            });
        },
        updateBeaconAlarm: function (userSentinelId, model, success, error) {
          return http.post(config.apiUrl + "api/sentinel/alarm/beacon/" + userSentinelId, model, success, error);
        },
        getSensorTypes: function (onSuccess) {
          return http.get(config.apiUrl + "api/sentinel/sensorTypes/all", {}, onSuccess);
        },
        getSensorTypeById: function (sensorTypeId, onSuccess) {
          return http.get(config.apiUrl + "api/sentinel/sensorTypes/" + sensorTypeId, {}, onSuccess);
        },
        getBilgeAlarms: function (userSentinelId, onSuccess, onError) {
          return http.get(config.apiUrl + "api/sentinel/alarm/bilge/" + userSentinelId, {}, onSuccess, onError);
        },
        getAllBoatsWithInRange: function (latitude, longitude, onSuccess, onError) {
          return http.get(config.apiUrl + "api/sentinel/latestLocations/" + latitude + "/" + longitude, {}, onSuccess, onError);
        },
        updateBilgeAlarms: function (userSentinelId, model, success, error) {
          return http.post(config.apiUrl + "api/sentinel/alarm/bilge/" + userSentinelId, model, success, error);
        },
        getPirAlarms: function (userSentinelId, onSuccess, onError) {
          return http.get(config.apiUrl + "api/sentinel/alarm/pir/" + userSentinelId, {}, onSuccess, onError);
        },
        getMainSupplyAlarms: function (userSentinelId, onSuccess, onError) {
          return http.get(config.apiUrl + "api/sentinel/alarm/mainsupply/" + userSentinelId, {}, onSuccess, onError);
        },
        updateMainSupplyAlarm: function (userSentinelId, model, success, error) {
          return http.post(config.apiUrl + "api/sentinel/alarm/mainsupply/" + userSentinelId, model, success, error);
        },
        updateShockAlarm: function (userSentinelId, model, success, error) {
          var copy = angular.copy(model);
          copy.mildShockAlarm.alarmValue = angular.toJson(copy.mildShockAlarm.alarmValue);
          copy.severeShockAlarm.alarmValue = angular.toJson(copy.severeShockAlarm.alarmValue);
          return http.post(config.apiUrl + "api/sentinel/alarm/shock/" + userSentinelId, copy, success, error);
        },
        updateMotionDetectorAlarm: function (userSentinelId, model, success, error) {
          return http.post(config.apiUrl + "api/sentinel/alarm/PIR/" + userSentinelId, model, success, error);
        },
        updateDoorAlarm: function (userSentinelId, model, success, error) {
          return http.post(config.apiUrl + "api/sentinel/alarm/door/" + userSentinelId, model, success, error);
        },
        getNotifications: function (userSentinelId, alarmTypeId, pageNumber, pageSize, onSuccess) {
          return http.get(config.apiUrl + "api/sentinel/notifications/" + userSentinelId + "/" + alarmTypeId, {
            pageNumber: pageNumber,
            pageSize: pageSize
          }, onSuccess);
        },
        getSentinelNotifications: function (pageNumber, pageSize, onSuccess) {
          return http.get(config.apiUrl + "api/sentinel/notifications/", {
            pageNumber: pageNumber,
            pageSize: pageSize
          }, onSuccess);
        },
        getReadNotifications: function (pageNumber, pageSize, orderBy, onSuccess) {
          return http.get(config.apiUrl + "api/sentinel/notifications/read", {
            pageNumber: pageNumber,
            pageSize: pageSize,
            orderBy: orderBy
          }, onSuccess);
        },
        getUnReadNotifications: function (pageNumber, pageSize, onSuccess) {
          return http.get(config.apiUrl + "api/sentinel/notifications/unread", {
            pageNumber: pageNumber,
            pageSize: pageSize
          }, onSuccess);
        },
        getJournalLog: function (pageNumber, pageSize, onSuccess) {
          return http.get(config.apiUrl + "api/sentinel/notifications/journal", {
            pageNumber: pageNumber,
            pageSize: pageSize
          }, onSuccess);
        },
        getAlarmTypeNotificationCounts: function (sentinelId, onSuccess) {
          return http.get(config.apiUrl + "api/sentinel/notifications/alarmType/count/" + sentinelId, {}, onSuccess);
        },
        getAllSetntinelNotificationCount: function (onSuccess) {
          return http.get(config.apiUrl + "api/sentinel/notifications/count/", {}, onSuccess);
        },
        getSentinelNotificationCount: function (userSentinelId, onSuccess) {
          return http.get(config.apiUrl + "api/sentinel/notifications/count/" + userSentinelId, {}, onSuccess);
        },
        getSentinelAlarmNotificationCount: function (userSentinelId, alarmTypeId, onSuccess) {
          return http.get(config.apiUrl + "api/sentinel/notifications/alarmType/count/" + userSentinelId + "/" + alarmTypeId, {}, onSuccess);
        },
        markNotificationsAsSeen: function (userSentinelId, alarmTypeId, onSuccess) {
          return http.get(config.apiUrl + "api/sentinel/notifications/seen/" + userSentinelId + "/" + alarmTypeId, {}, onSuccess);
        },
        markAllNotificationsSeen: function (onSuccess) {
          return http.get(config.apiUrl + "api/sentinel/notifications/markAsRead", {}, onSuccess);
        },
        getAllNotificationsCount: function (success, error) {
          return http.get(config.apiUrl + "api/sentinel/notifications/alarmType/count", {}, success, error);
        },
        getSentinelNotificationCountByAlarm: function (alarmTypeId, success) {
          return http.get(config.apiUrl + "api/sentinel/notifications/alarmType/" + alarmTypeId + "/count", {}, success);
        },
        getShockAlarm: function (userSentinelId, success, error) {
          return http.get(config.apiUrl + "api/sentinel/alarm/shock/" + userSentinelId, {}, success, error);
        },
        saveDoorAlarm: function (userSentinelId, model, success, error) {
          return http.post(config.apiUrl + "api/sentinel/alarm/door/" + userSentinelId, model, success, error);
        },
        getDoorAlarm: function (userSentinelId, success, error) {
          return http.get(config.apiUrl + "api/sentinel/alarm/door/" + userSentinelId, {}, success, error);
        },
        saveTiltAlarm: function (userSentinelId, model, success, error) {
          return http.post(config.apiUrl + "api/sentinel/alarm/tilt/" + userSentinelId, model, success, error);
        },
        disarm: function (userSentinelId, success, error) {
          return http.put(config.apiUrl + "api/sentinel/disarm/" + userSentinelId, {}, success, error);
        },
        arm: function (userSentinelId, success, error) {
          return http.put(config.apiUrl + "api/sentinel/arm/" + userSentinelId, {}, success, error);
        },
        getLatestConnectivityStatus: function (sentinelId) {
          return http.get(config.apiUrl + "api/sentinel/connectivity/latest/" + sentinelId);
        },
        deleteSensor: function (userSentinelId, sensorId) {
          return http.delete(config.apiUrl + "api/sentinel/" + userSentinelId + "/sensors/" + sensorId);
        }
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.services')
    .factory('sensorTypes', function () {
      return {
        temperatureSensor: {
          id: 1,
          description: 'Temperature sensor'
        },
        vibrationSensor: {
          id: 2,
          description: 'Door sensor'
        },
        tiltSensor: {
          id: 3,
          description: 'Tilt sensor'
        },
        beaconSensor: {
          id: 4,
          description: 'Item security sensor'
        },
        bilgeSensor: {
          id: 5,
          description: 'Bilge sensor'
        },
        pirSensor: {
          id: 6,
          description: 'Motion detection sensor'
        },
        mainSupplySensor: {
          id: 7,
          description: 'Shorepower sensor'
        },
        locationSensor: {
          id: 8,
          description: 'Location sensor'
        },
        doorSensor: {
          id: 9,
          description: 'Door sensor'
        },
        voltageSensor: {
          id: 10,
          description: 'Voltage sensor'
        }
      }
    })
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.services')
    .factory('roles', function () {
      return {
        viewer: {
          id: 4,
          name: 'viewer'
        },
        editor: {
          id: 5,
          name: 'editor'
        }
      }
    })
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.services')
    .factory('nmeaTemperatureSourceEnum', function () {
      return {
        SeaTemperature: 0,
        OutsideTemperature: 1,
        InsideTemperature: 2,
        EngineRoomTemperature: 3,
        MainCabinTemperature: 4,
        LiveWellTemperature: 5,
        BailWellTemperature: 6,
        RefrigerationTemperature: 7,
        HeatingSystemTemperature: 8,
        DewPointTemperature: 9,
        WindChillTemperatureAndApparent: 10,
        WindChillTemperatureAndTheoretical: 11,
        HeatIndexTemperature: 12,
        FreezerTemperature: 13,
        ExhaustGasTemperature: 14
      };
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.services')
    .factory('nmeaGraphIntervalEnum', function () {
      return {
        Daily: 1,
        Weekly: 2,
        Monthly: 3,
      };
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.services')
    .factory('nmeaFluidTypesEnum', function () {
      return {
        Fuel: 0,
        FreshWater: 1,
        WasteWater: 2,
        LiveWell: 3,
        Oil: 4,
        BlackWater: 5,
        FuelGasoline: 6
      };
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.services')
    .factory('nmeaEngineAlertsEnum', function () {
      return {
        CheckEngine: 1,
        OverTemperature: 2,
        LowOilPressure: 3,
        LowOilLevel: 4,
        LowFuelPressure: 5,
        LowSystemVoltage: 6,
        LowCoolantLevel: 7,
        WaterFlow: 8,
        WaterInFuel: 9,
        ChargeIndicator: 10,
        PreheatIndicator: 11,
        HighBoostPressure: 12,
        RevLimitExceeded: 13,
        EGRSystem: 14,
        ThrottlePositionSensor: 15,
        EngineEmergencyStop: 16
      };
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.services')
    .factory('nmeaDcTypesEnum', function () {
      return {
        Battery: 0,
        Alternator: 1,
        Convertor: 2,
        SolarCell: 3,
        WindPower: 4
      };
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.services')
    .factory('nmeaDataFieldEnum', function () {
      return {
        Pgn127488Speed: 1,
        Pgn127488BoostPressure: 2,
        Pgn127488TiltTrim: 3,
        Pgn127493TransmissionGear: 4,
        Pgn127493OilPressure: 5,
        Pgn127493OilTemperature: 6,
        Pgn127493DiscreteStatus1: 7,
        Pgn127505Type: 8,
        Pgn127505Level: 9,
        Pgn127505Capacity: 10,
        Pgn127506SId: 11,
        Pgn127506DcType: 12,
        Pgn127506StateOfCharge: 13,
        Pgn127506StateOfHealth: 14,
        Pgn127506TimeRemaining: 15,
        Pgn127506RippleVoltage: 16,
        Pgn127508Voltage: 17,
        Pgn127508Current: 18,
        Pgn127508Temperature: 19,
        Pgn127508SId: 20,
        Pgn129026SId: 21,
        Pgn129026CogReference: 22,
        Pgn129026Cog: 23,
        Pgn129026Sog: 24,
        Pgn127496TimeToEmpty: 25,
        Pgn127496DistanceToEmpty: 26,
        Pgn127496EstimatedFuelRemaining: 27,
        Pgn127496TripRunTime: 28,
        Pgn127233SId: 29,
        Pgn127233MobEmitterId: 30,
        Pgn127233MobStatus: 31,
        Pgn127233ActivationTime: 32,
        Pgn127233PositionSource: 33,
        Pgn127233PositionDate: 34,
        Pgn127233PositionTime: 35,
        Pgn127233Latitude: 36,
        Pgn127233Longitude: 37,
        Pgn127233CogReference: 38,
        Pgn127233Cog: 39,
        Pgn127233Sog: 40,
        Pgn127233MmsiOfVessel: 41,
        Pgn127233MobEmitterBatteryStatus: 42,
        Pgn127489OilPressure: 43,
        Pgn127489OilTemperature: 44,
        Pgn127489Temperature: 45,
        Pgn127489AlternatorPotential: 46,
        Pgn127489FuelRate: 47,
        Pgn127489TotalEngineHours: 48,
        Pgn127489CoolantPressure: 49,
        Pgn127489FuelPressure: 50,
        Pgn127489DiscreteStatus1: 51,
        Pgn127489DiscreteStatus2: 52,
        Pgn127489PercentEngineLoad: 53,
        Pgn127489PercentEngineTorque: 54,
        Pgn128267SId: 55,
        Pgn128267Depth: 56,
        Pgn128267Offset: 57,
        Pgn128267Range: 58,
        Pgn129025Latitude: 59,
        Pgn129025Longitude: 60,
        Pgn130316SId: 61,
        Pgn130316Source: 62,
        Pgn130316Temperature: 63,
        Pgn130316SetTemperature: 64,
        Pgn130306SId: 65,
        Pgn130306WindSpeed: 66,
        Pgn130306WindAngle: 67,
        Pgn130306Reference: 68,
        Pgn130313SId: 69,
        Pgn130313Source: 70,
        Pgn130313ActualHumidity: 71,
        Pgn130313SetHumidity: 72,
        Pgn127506AmpHours: 73,
        Pgn128275MeasurementDate : 74,
        Pgn128275MeasurementTime : 75,
        Pgn128275TotalCumulativeDistance : 76,
        Pgn128275DistanceSinceLastReset : 77,
        Pgn128259SequenceID : 78,
        Pgn128259SpeedWaterReferenced : 79,
        Pgn128259SpeedGroundReferenced : 80,
        Pgn128259SpeedWaterReferencedType : 81,
        Pgn128259SpeedDirection : 82,
        Pgn128259NMEAReserved : 83
      };
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.services')
    .service('nmeaService', function (http, config) {
      return {
        getOilPressureData: function () {
          return http.get(config.apiUrl + "api/nmea/data", '', null, null, true);
        },
        getLatestDashboardAlertsData: function (userSentinelId,getByDate) {
          return http.get(config.apiUrl + "api/nmea/" + userSentinelId + "/dashboard/alerts",{getByDate:getByDate}, null, null, false);
        },
        getLastUpdatedOnNmeaData: function (userSentinelId,getByDate) {
          return http.get(config.apiUrl + "api/nmea/" + userSentinelId + "/dashboard/lastUpdatedOn", {getByDate:getByDate}, null, null, true);
        },
        getLatestCurrentTripNmeaData: function (userSentinelId,getByDate) {
          return http.get(config.apiUrl + "api/nmea/" + userSentinelId + "/dashboard/currentTripData", {getByDate:getByDate}, null, null, true);
        },
        getLatestEngineWidgetNmeaData: function (userSentinelId,getByDate) {
          return http.get(config.apiUrl + "api/nmea/" + userSentinelId + "/dashboard/engineData", {getByDate:getByDate}, null, null, false);
        },
        getLatestCourseNmeaData: function (userSentinelId,getByDate) {
          return http.get(config.apiUrl + "api/nmea/" + userSentinelId + "/dashboard/courseData",{getByDate:getByDate}, null, null, true);
        },
        getLatestPowerNmeaData: function (userSentinelId,getByDate) {
          return http.get(config.apiUrl + "api/nmea/" + userSentinelId + "/dashboard/powerData", {getByDate:getByDate}, null, null, true);
        },
        getLatestFluidLevelNmeaData: function (userSentinelId,getByDate) {
          return http.get(config.apiUrl + "api/nmea/" + userSentinelId + "/dashboard/fluidLevelsData", {getByDate:getByDate}, null, null, true);
        },
        getLatestTemperatureNmeaData: function (userSentinelId,getByDate) {
          return http.get(config.apiUrl + "api/nmea/" + userSentinelId + "/dashboard/temperatureData", {getByDate:getByDate}, null, null, true);
        },
        getLatestHumidityNmeaData: function (userSentinelId,getByDate) {
          return http.get(config.apiUrl + "api/nmea/" + userSentinelId + "/dashboard/humidityData",  {getByDate:getByDate}, null, null, true);
        },
        getLatestEngineDataByEngineId: function (userSentinelId, engineId,getByDate) {
          return http.get(config.apiUrl + "api/nmea/" + userSentinelId + "/engine-details/" + engineId + "/data",  {getByDate:getByDate}, null, null, true);
        },
        getLatestEngineDataByAllEngineInstances: function (userSentinelId,getByDate) {
          return http.get(config.apiUrl + "api/nmea/" + userSentinelId + "/engine-details/data",  {getByDate:getByDate}, null, null, false);
        },
        getAllPowerDetailsNmeaData: function (userSentinelId,getByDate) {
          return http.get(config.apiUrl + "api/nmea/" + userSentinelId + "/power-details/data", {getByDate:getByDate}, null, null, false);
        },
        getEngineDetailsNmeaGraphData: function (interval, userSentinelId, nmeaInstanceId, nmeaDataFieldEnumId,getByDate) {
          return http.get(config.apiUrl + "api/nmea/" + userSentinelId + "/engine/" + nmeaInstanceId + "/data/" + nmeaDataFieldEnumId + "/interval/" + interval,  {getByDate:getByDate}, null, null, true);
        },
        getPowerDetailsNmeaGraphData: function (interval, userSentinelId, instanceNumber, sourceId, nmeaDataFieldEnumId,getByDate) {
          return http.get(config.apiUrl + "api/nmea/" + userSentinelId + "/power/" + instanceNumber + "/source/" + sourceId + "/data/" + nmeaDataFieldEnumId + "/interval/" + interval, {getByDate:getByDate}, null, null, true);
        },
        getNmeaGraphData: function (model) {
          return http.get(config.apiUrl + "api/nmea/graph/data", model, '', null, null, false);
        },
        getSentinelRoute: function (sentinelId, duration, onSuccess,getByDate) {
          return http.get(config.apiUrl + "api/nmea/route/" + sentinelId + "/" + duration, {getByDate:getByDate}, onSuccess);
        },
        getSentinelRouteSummary: function (sentinelId, duration, onSuccess,getByDate) {
          return http.get(config.apiUrl + "api/nmea/route/summary/" + sentinelId + "/" + duration, {getByDate:getByDate}, onSuccess);
        },
        getAllEnginesDataByUserSentinelId: function (userSentinelId) {
          return http.get(config.apiUrl + "api/nmea/" + userSentinelId + "/engines/data", '', null, null, true);
        },
        getSentinelLocation: function (sentinelId, onSuccess,getByDate) {
          return http.get(config.apiUrl + "api/nmea/location/latest/" + sentinelId, {getByDate:getByDate}, onSuccess);
        },
        getAllSentinelsLocation: function (onSuccess) {
          return http.get(config.apiUrl + "api/nmea/location/latest/allSentinels/", {}, onSuccess);
        },
        getNearByMarines: function (sentinelId, onSuccess) {
          return http.get(config.apiUrl + "api/nmea/location/nearBy/" + sentinelId, {}, onSuccess);
        },
        getNmeaAlarmsStatus: function (userSentinelId, onSuccess, onError) {
          return http.get(config.apiUrl + "api/nmea/alarms/" + userSentinelId + "/status", {}, onSuccess, onError);
        },
        getCurrentTripAlarm: function (userSentinelId, onSuccess, onError) {
          return http.get(config.apiUrl + "api/nmea/alarm/current-trip/" + userSentinelId, {}, onSuccess, onError)
            .then(function (response) {
              if (response.timeToEmptyAlarm && response.timeToEmptyAlarm.alarmValue) {
                response.timeToEmptyAlarm.alarmValue = angular.fromJson(response.timeToEmptyAlarm.alarmValue);
              }
              if (response.distanceToEmptyAlarm && response.distanceToEmptyAlarm.alarmValue) {
                response.distanceToEmptyAlarm.alarmValue = angular.fromJson(response.distanceToEmptyAlarm.alarmValue);
              }
              if (response.tripDistanceAlarm && response.tripDistanceAlarm.alarmValue) {
                response.tripDistanceAlarm.alarmValue = angular.fromJson(response.tripDistanceAlarm.alarmValue);
              }
              if (response.tripRunTimeAlarm && response.tripRunTimeAlarm.alarmValue) {
                response.tripRunTimeAlarm.alarmValue = angular.fromJson(response.tripRunTimeAlarm.alarmValue);
              }
              return response;
            });
        },
        getSpeedLimitAlarm: function (userSentinelId, onSuccess, onError) {
          return http.get(config.apiUrl + "api/nmea/alarm/speed-limit/" + userSentinelId, {}, onSuccess, onError)
            .then(function (response) {
              if (response.speedOverGroundAlarm && response.speedOverGroundAlarm.alarmValue) {
                response.speedOverGroundAlarm.alarmValue = angular.fromJson(response.speedOverGroundAlarm.alarmValue);
              }
              if (response.speedOverWaterAlarm && response.speedOverWaterAlarm.alarmValue) {
                response.speedOverWaterAlarm.alarmValue = angular.fromJson(response.speedOverWaterAlarm.alarmValue);
              }
              return response;
            });
        },

        updateCurrentTripAlarm: function (userSentinelId, model, success, error) {
          model.timeToEmptyAlarm.alarmValue = angular.toJson(model.timeToEmptyAlarm.alarm);
          model.distanceToEmptyAlarm.alarmValue = angular.toJson(model.distanceToEmptyAlarm.alarm);
          model.tripDistanceAlarm.alarmValue = angular.toJson(model.tripDistanceAlarm.alarm);
          model.tripRunTimeAlarm.alarmValue = angular.toJson(model.tripRunTimeAlarm.alarm);
          return http.post(config.apiUrl + "api/nmea/alarm/current-trip/" + userSentinelId, model, success, error);
        },
        updateSpeedLimitAlarm: function (userSentinelId, model, success, error) {
          model.speedOverGroundAlarm.alarmValue = angular.toJson(model.speedOverGroundAlarm.alarm);
          model.speedOverWaterAlarm.alarmValue = angular.toJson(model.speedOverWaterAlarm.alarm);

          return http.post(config.apiUrl + "api/nmea/alarm/speed-limit/" + userSentinelId, model, success, error);
        },


        getWaterDepthAlarm: function (userSentinelId, onSuccess, onError) {
          return http.get(config.apiUrl + "api/nmea/alarm/waterDepth/" + userSentinelId, {}, onSuccess, onError)
            .then(function (response) {
              if (response && response.alarmValue) {
                response.alarmValue = angular.fromJson(response.alarmValue);
              }
              return response;
            });
        },
        updateWaterDepthAlarm: function (userSentinelId, model, success, error) {
          model.alarmValue = angular.toJson(model.alarm);
          return http.post(config.apiUrl + "api/nmea/alarm/waterDepth/" + userSentinelId, model, success, error);
        },
        getWindSpeedAlarm: function (userSentinelId, onSuccess, onError) {
          return http.get(config.apiUrl + "api/nmea/alarm/windspeed/" + userSentinelId, {}, onSuccess, onError)
            .then(function (response) {
              if (response && response.alarmValue) {
                response.alarmValue = angular.fromJson(response.alarmValue);
              }
              return response;
            });
        },
        updateWindSpeedAlarm: function (userSentinelId, model, success, error) {
          model.alarmValue = angular.toJson(model.alarm);
          return http.post(config.apiUrl + "api/nmea/alarm/windspeed/" + userSentinelId, model, success, error);
        },
        getFluidLevelsAlarm: function (userSentinelId, onSuccess, onError) {
          return http.get(config.apiUrl + "api/nmea/alarm/fluid-Levels/" + userSentinelId, {}, onSuccess, onError)
            .then(function (response) {
              response.forEach(function (fluidAlarm) {
                if (fluidAlarm.sentinelAlarm && fluidAlarm.sentinelAlarm.alarmValue) {
                  fluidAlarm.sentinelAlarm.alarmValue = angular.fromJson(fluidAlarm.sentinelAlarm.alarmValue);
                }
              });
              return response;
            });
        },
        updateFluidLevelsAlarm: function (userSentinelId, models, success, error) {
          models.forEach(function (fluidAlarm) {
            if (fluidAlarm.sentinelAlarm && fluidAlarm.sentinelAlarm.alarm) {
              fluidAlarm.sentinelAlarm.alarmValue = angular.toJson(fluidAlarm.sentinelAlarm.alarm);
            }
          });
          return http.post(config.apiUrl + "api/nmea/alarm/fluid-Levels/" + userSentinelId, models, success, error);
        },
        getBilgePumpsAlarm: function (userSentinelId, onSuccess, onError) {
          return http.get(config.apiUrl + "api/nmea/alarm/bilge-pumps/" + userSentinelId, {}, onSuccess, onError)
            .then(function (response) {
              if (response.bilgePump1Alarm && response.bilgePump1Alarm.alarmValue) {
                response.bilgePump1Alarm.alarmValue = angular.fromJson(response.bilgePump1Alarm.alarmValue);
              }
              if (response.bilgePump2Alarm && response.bilgePump2Alarm.alarmValue) {
                response.bilgePump2Alarm.alarmValue = angular.fromJson(response.bilgePump2Alarm.alarmValue);
              }
              if (response.bilgePump3Alarm && response.bilgePump3Alarm.alarmValue) {
                response.bilgePump3Alarm.alarmValue = angular.fromJson(response.bilgePump3Alarm.alarmValue);
              }
              if (response.bilgePump4Alarm && response.bilgePump4Alarm.alarmValue) {
                response.bilgePump4Alarm.alarmValue = angular.fromJson(response.bilgePump4Alarm.alarmValue);
              }
              if (response.bilgePump5Alarm && response.bilgePump5Alarm.alarmValue) {
                response.bilgePump5Alarm.alarmValue = angular.fromJson(response.bilgePump5Alarm.alarmValue);
              }
              return response;
            });
        },
        updateBilgePumpsAlarm: function (userSentinelId, model, success, error) {
          model.bilgePump1Alarm.alarmValue = angular.toJson(model.bilgePump1Alarm.alarm);
          model.bilgePump2Alarm.alarmValue = angular.toJson(model.bilgePump2Alarm.alarm);
          model.bilgePump3Alarm.alarmValue = angular.toJson(model.bilgePump3Alarm.alarm);
          model.bilgePump4Alarm.alarmValue = angular.toJson(model.bilgePump4Alarm.alarm);
          model.bilgePump5Alarm.alarmValue = angular.toJson(model.bilgePump5Alarm.alarm);
          return http.post(config.apiUrl + "api/nmea/alarm/bilge-pumps/" + userSentinelId, model, success, error);
        },
        getPowerAlarm: function (userSentinelId, instanceNumber, sourceId, onSuccess, onError) {
          return http.get(config.apiUrl + "api/nmea/alarm/" + userSentinelId + "/power/" + instanceNumber + "?sourceId=" + sourceId, {}, onSuccess, onError)
            .then(function (response) {
              if (response.stateOfChargeAlarm && response.stateOfChargeAlarm.alarmValue) {
                response.stateOfChargeAlarm.alarmValue = angular.fromJson(response.stateOfChargeAlarm.alarmValue);
              }
              if (response.timeRemainingAlarm && response.timeRemainingAlarm.alarmValue) {
                response.timeRemainingAlarm.alarmValue = angular.fromJson(response.timeRemainingAlarm.alarmValue);
              }
              if (response.currentAlarm && response.currentAlarm.alarmValue) {
                response.currentAlarm.alarmValue = angular.fromJson(response.currentAlarm.alarmValue);
              }
              if (response.batteryCaseTempAlarm && response.batteryCaseTempAlarm.alarmValue) {
                response.batteryCaseTempAlarm.alarmValue = angular.fromJson(response.batteryCaseTempAlarm.alarmValue);
              }
              if (response.stateOfHealthAlarm && response.stateOfHealthAlarm.alarmValue) {
                response.stateOfHealthAlarm.alarmValue = angular.fromJson(response.stateOfHealthAlarm.alarmValue);
              }
              if (response.voltageAlarm && response.voltageAlarm.alarmValue) {
                response.voltageAlarm.alarmValue = angular.fromJson(response.voltageAlarm.alarmValue);
              }
              if (response.ampHoursAlarm && response.ampHoursAlarm.alarmValue) {
                response.ampHoursAlarm.alarmValue = angular.fromJson(response.ampHoursAlarm.alarmValue);
              }
              return response;
            });
        },
        updatePowerAlarm: function (userSentinelId, model, success, error) {
          model.stateOfChargeAlarm.alarmValue = angular.toJson(model.stateOfChargeAlarm.alarm);
          model.timeRemainingAlarm.alarmValue = angular.toJson(model.timeRemainingAlarm.alarm);
          model.currentAlarm.alarmValue = angular.toJson(model.currentAlarm.alarm);
          model.batteryCaseTempAlarm.alarmValue = angular.toJson(model.batteryCaseTempAlarm.alarm);
          model.stateOfHealthAlarm.alarmValue = angular.toJson(model.stateOfHealthAlarm.alarm);
          model.voltageAlarm.alarmValue = angular.toJson(model.voltageAlarm.alarm);
          model.ampHoursAlarm.alarmValue = angular.toJson(model.ampHoursAlarm.alarm);
          return http.post(config.apiUrl + "api/nmea/alarm/power/" + userSentinelId, model, success, error);
        },
        getEngineAlarm: function (userSentinelId, instanceNumber, onSuccess, onError) {
          return http.get(config.apiUrl + "api/nmea/alarm/" + userSentinelId + "/engine/" + instanceNumber, {}, onSuccess, onError)
            .then(function (response) {
              if (response.rpmAlarm && response.rpmAlarm.alarmValue) {
                response.rpmAlarm.alarmValue = angular.fromJson(response.rpmAlarm.alarmValue);
              }
              if (response.fuelPressureAlarm && response.fuelPressureAlarm.alarmValue) {
                response.fuelPressureAlarm.alarmValue = angular.fromJson(response.fuelPressureAlarm.alarmValue);
              }
              if (response.fuelRateAlarm && response.fuelRateAlarm.alarmValue) {
                response.fuelRateAlarm.alarmValue = angular.fromJson(response.fuelRateAlarm.alarmValue);
              }
              if (response.transmissionOilPressureAlarm && response.transmissionOilPressureAlarm.alarmValue) {
                response.transmissionOilPressureAlarm.alarmValue = angular.fromJson(response.transmissionOilPressureAlarm.alarmValue);
              }
              if (response.engineTemperatureAlarm && response.engineTemperatureAlarm.alarmValue) {
                response.engineTemperatureAlarm.alarmValue = angular.fromJson(response.engineTemperatureAlarm.alarmValue);
              }
              if (response.oilTemperatureAlarm && response.oilTemperatureAlarm.alarmValue) {
                response.oilTemperatureAlarm.alarmValue = angular.fromJson(response.oilTemperatureAlarm.alarmValue);
              }
              if (response.engineLoadAlarm && response.engineLoadAlarm.alarmValue) {
                response.engineLoadAlarm.alarmValue = angular.fromJson(response.engineLoadAlarm.alarmValue);
              }
              if (response.engineTorqueAlarm && response.engineTorqueAlarm.alarmValue) {
                response.engineTorqueAlarm.alarmValue = angular.fromJson(response.engineTorqueAlarm.alarmValue);
              }
              if (response.alternatorPotentialAlarm && response.alternatorPotentialAlarm.alarmValue) {
                response.alternatorPotentialAlarm.alarmValue = angular.fromJson(response.alternatorPotentialAlarm.alarmValue);
              }
              if (response.boostAlarm && response.boostAlarm.alarmValue) {
                response.boostAlarm.alarmValue = angular.fromJson(response.boostAlarm.alarmValue);
              }
              if (response.transmissionOilTemperatureAlarm && response.transmissionOilTemperatureAlarm.alarmValue) {
                response.transmissionOilTemperatureAlarm.alarmValue = angular.fromJson(response.transmissionOilTemperatureAlarm.alarmValue);
              }
              if (response.engineHoursAlarm && response.engineHoursAlarm.alarmValue) {
                response.engineHoursAlarm.alarmValue = angular.fromJson(response.engineHoursAlarm.alarmValue);
              }
              if (response.engineOilPressureAlarm && response.engineOilPressureAlarm.alarmValue) {
                response.engineOilPressureAlarm.alarmValue = angular.fromJson(response.engineOilPressureAlarm.alarmValue);
              }
              return response;
            });
        },
        updateEngineAlarm: function (userSentinelId, model, success, error) {
          model.rpmAlarm.alarm.triggerValue = model.rpmAlarm.alarm.triggerValue*100;
          model.rpmAlarm.alarmValue = angular.toJson(model.rpmAlarm.alarm);
          model.fuelPressureAlarm.alarmValue = angular.toJson(model.fuelPressureAlarm.alarm);
          model.fuelRateAlarm.alarmValue = angular.toJson(model.fuelRateAlarm.alarm);
          model.transmissionOilPressureAlarm.alarmValue = angular.toJson(model.transmissionOilPressureAlarm.alarm);
          model.engineTemperatureAlarm.alarmValue = angular.toJson(model.engineTemperatureAlarm.alarm);
          model.oilTemperatureAlarm.alarmValue = angular.toJson(model.oilTemperatureAlarm.alarm);
          model.engineLoadAlarm.alarmValue = angular.toJson(model.engineLoadAlarm.alarm);
          model.engineTorqueAlarm.alarmValue = angular.toJson(model.engineTorqueAlarm.alarm);
          model.alternatorPotentialAlarm.alarmValue = angular.toJson(model.alternatorPotentialAlarm.alarm);
          model.boostAlarm.alarmValue = angular.toJson(model.boostAlarm.alarm);
          model.transmissionOilTemperatureAlarm.alarmValue = angular.toJson(model.transmissionOilTemperatureAlarm.alarm);
          model.engineHoursAlarm.alarmValue = angular.toJson(model.engineHoursAlarm.alarm);
          model.engineOilPressureAlarm.alarmValue=angular.toJson(model.engineOilPressureAlarm.alarm);
          return http.post(config.apiUrl + "api/nmea/alarm/engine/" + userSentinelId, model, success, error);
        },
        getTempHumidityAlarm: function (userSentinelId, onSuccess, onError) {
          return http.get(config.apiUrl + "api/nmea/alarm/temp-humidity/" + userSentinelId, {}, onSuccess, onError)
            .then(function (response) {
              if (response.seaTempAlarm && response.seaTempAlarm.alarmValue) {
                response.seaTempAlarm.alarmValue = angular.fromJson(response.seaTempAlarm.alarmValue);
              }
              if (response.outsideTempAlarm && response.outsideTempAlarm.alarmValue) {
                response.outsideTempAlarm.alarmValue = angular.fromJson(response.outsideTempAlarm.alarmValue);
              }
              if (response.insideTempAlarm && response.insideTempAlarm.alarmValue) {
                response.insideTempAlarm.alarmValue = angular.fromJson(response.insideTempAlarm.alarmValue);
              }
              if (response.engineRoomTempAlarm && response.engineRoomTempAlarm.alarmValue) {
                response.engineRoomTempAlarm.alarmValue = angular.fromJson(response.engineRoomTempAlarm.alarmValue);
              }
              if (response.mainCabinTempAlarm && response.mainCabinTempAlarm.alarmValue) {
                response.mainCabinTempAlarm.alarmValue = angular.fromJson(response.mainCabinTempAlarm.alarmValue);
              }
              if (response.liveWellTempAlarm && response.liveWellTempAlarm.alarmValue) {
                response.liveWellTempAlarm.alarmValue = angular.fromJson(response.liveWellTempAlarm.alarmValue);
              }
              if (response.bailWellTempAlarm && response.bailWellTempAlarm.alarmValue) {
                response.bailWellTempAlarm.alarmValue = angular.fromJson(response.bailWellTempAlarm.alarmValue);
              }
              if (response.referigerationTempAlarm && response.referigerationTempAlarm.alarmValue) {
                response.referigerationTempAlarm.alarmValue = angular.fromJson(response.referigerationTempAlarm.alarmValue);
              }
              if (response.insideHumidityAlarm && response.insideHumidityAlarm.alarmValue) {
                response.insideHumidityAlarm.alarmValue = angular.fromJson(response.insideHumidityAlarm.alarmValue);
              }
              if (response.outsideHumidityAlarm && response.outsideHumidityAlarm.alarmValue) {
                response.outsideHumidityAlarm.alarmValue = angular.fromJson(response.outsideHumidityAlarm.alarmValue);
              }
              if (response.heatingSystemTempAlarm && response.heatingSystemTempAlarm.alarmValue) {
                response.heatingSystemTempAlarm.alarmValue = angular.fromJson(response.heatingSystemTempAlarm.alarmValue);
              }
              if (response.dewPointTempAlarm && response.dewPointTempAlarm.alarmValue) {
                response.dewPointTempAlarm.alarmValue = angular.fromJson(response.dewPointTempAlarm.alarmValue);
              }
              if (response.windChillTempAlarm && response.windChillTempAlarm.alarmValue) {
                response.windChillTempAlarm.alarmValue = angular.fromJson(response.windChillTempAlarm.alarmValue);
              }
              if (response.freezerTempAlarm && response.freezerTempAlarm.alarmValue) {
                response.freezerTempAlarm.alarmValue = angular.fromJson(response.freezerTempAlarm.alarmValue);
              }
              if (response.exhaustGasTempAlarm && response.exhaustGasTempAlarm.alarmValue) {
                response.exhaustGasTempAlarm.alarmValue = angular.fromJson(response.exhaustGasTempAlarm.alarmValue);
              }
              return response;
            });
        },
        updateTempHumidityAlarm: function (userSentinelId, model, success, error) {
          model.seaTempAlarm.alarmValue = angular.toJson(model.seaTempAlarm.alarm);
          model.outsideTempAlarm.alarmValue = angular.toJson(model.outsideTempAlarm.alarm);
          model.insideTempAlarm.alarmValue = angular.toJson(model.insideTempAlarm.alarm);
          model.engineRoomTempAlarm.alarmValue = angular.toJson(model.engineRoomTempAlarm.alarm);
          model.mainCabinTempAlarm.alarmValue = angular.toJson(model.mainCabinTempAlarm.alarm);
          model.liveWellTempAlarm.alarmValue = angular.toJson(model.liveWellTempAlarm.alarm);
          model.bailWellTempAlarm.alarmValue = angular.toJson(model.bailWellTempAlarm.alarm);
          model.referigerationTempAlarm.alarmValue = angular.toJson(model.referigerationTempAlarm.alarm);
          model.insideHumidityAlarm.alarmValue = angular.toJson(model.insideHumidityAlarm.alarm);
          model.outsideHumidityAlarm.alarmValue = angular.toJson(model.outsideHumidityAlarm.alarm);
          model.heatingSystemTempAlarm.alarmValue = angular.toJson(model.heatingSystemTempAlarm.alarm);
          model.dewPointTempAlarm.alarmValue = angular.toJson(model.dewPointTempAlarm.alarm);
          model.windChillTempAlarm.alarmValue = angular.toJson(model.windChillTempAlarm.alarm);
          model.freezerTempAlarm.alarmValue = angular.toJson(model.freezerTempAlarm.alarm);
          model.exhaustGasTempAlarm.alarmValue = angular.toJson(model.exhaustGasTempAlarm.alarm);
          return http.post(config.apiUrl + "api/nmea/alarm/temp-humidity/" + userSentinelId, model, success, error);
        },
        getGeofenceAlarm: function (userSentinelId, onSuccess, onError) {
          return http.get(config.apiUrl + "api/nmea/alarm/geofenceAlarm/" + userSentinelId, {}, onSuccess, onError)
            .then(function (response) {
              if (response.geoFenceMoveOut != null && response.geoFenceMoveOut.alarmValue != null) {
                response.geoFenceMoveOut.alarmValue = angular.fromJson(response.geoFenceMoveOut.alarmValue);
              }
              if (response.geoFenceMoveIn != null && response.geoFenceMoveIn.alarmValue != null) {
                response.geoFenceMoveIn.alarmValue = angular.fromJson(response.geoFenceMoveIn.alarmValue);
              }
              if (response.speedLimit && response.speedLimit.alarmValue) {
                response.speedLimit.alarmValue = angular.fromJson(response.speedLimit.alarmValue);
              }
              return response;
            });
        },
        updateGeoFenceAlarm: function (userSentinelId, model, success, error) {
          model.speedLimit.alarmValue = angular.toJson(model.speedLimit.alarm);
          return http.post(config.apiUrl + "api/nmea/alarm/geofence/" + userSentinelId, model, success, error);
        },
        getAllEnginesInstancesToRename: function (userSentinelId) {
          return http.get(config.apiUrl + "api/nmea/" + userSentinelId + "/rename/engines", '', null, null, true);
        },
        getAllPowerInstancesToRename: function (userSentinelId) {
          return http.get(config.apiUrl + "api/nmea/" + userSentinelId + "/rename/power", '', null, null, true);
        },
        updateNmeaInstanceName: function (userSentinelId, instanceNumber,sourceId, instanceType, newName) {
          return http.put(config.apiUrl + "api/nmea/" + userSentinelId + "/instance/" + instanceNumber + "/type/" + instanceType + "/rename/" + newName + "?sourceId=" + sourceId, '', null, null, true);
        },
        addPowerSourceNameAndType: function (userSentinelId, model) {
          return http.put(config.apiUrl + "api/nmea/" + userSentinelId + "/dashboard/powerData/instance/", model);
        },
        getNmeaDbDataStatusForAlarm: function (userSentinelId, nmeaDataFieldEnumId) {
          return http.get(config.apiUrl + "api/nmea/alarms/" + userSentinelId + "/nmeaDataFieldEnum/" + nmeaDataFieldEnumId + "/hasData");
        }
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('yatch-sentinel.services')
    .service('navigationService', function (){
      this.navigation = {
        backState: 'boat.home'
      };

    });

})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.services')
    .service('logService', function (http, config) {
      return {
        getAllLogData: function (model, startDateTime, endDateTime, onSuccess) {
          return http.get(config.apiUrl + "api/log/all", model, onSuccess);
        }
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.services')
    .service('imeiService', function (http, config, $q) {
      return {
        validate: function (imei, onSuccess) {
          return $q(function (resolve, reject) {
            return http.get(config.apiUrl + "api/imei/validate/" + imei, {}, onSuccess, null, true)
              .then(function (response) {
                if (response.isUsed === false && response.isValid) {
                  resolve(true);
                  return true;
                }
                reject(false);
                return false;
              });
          });
        }
      };
    });
})();

'use strict';
angular.module('yatch-sentinel.services')
  .factory('httpInterceptorService',
    function ($q, $injector, $location, sessionService) {

      var authInterceptorServiceFactory = {};

      var request = function (config) {

        config.headers = config.headers || {};
        // if (config.url.indexOf('.html') == -1 && config.method == 'GET') {
        //   var tag = sessionService.getETag(config.url);
        //   if (tag) {
        //     config.headers['If-None-Match'] = tag;
        //   }
        // }
        var authData = sessionService.getAuthToken();
        if (authData) {
          config.headers.Authorization = 'Bearer ' + authData.access_token;
        }
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        return config;
      }

      var responseError = function (rejection) {
        if (rejection.status === 401) {
          $location.path('/login');
        }
        return $q.reject(rejection);
      }

      // var response = function (res) {
      //   if (res.config.url.indexOf('.html') == -1 && res.config.method == 'GET') {
      //     console.log(res.headers());
      //     var tag = res.headers('ETag');
      //     if (tag) {
      //       sessionService.setETag(res.config.url, tag);
      //     }
      //   }
      //   return res;
      // };

      authInterceptorServiceFactory.request = request;
      authInterceptorServiceFactory.responseError = responseError;
      //authInterceptorServiceFactory.response = response;

      return authInterceptorServiceFactory;
    })
  .config(
    function ($httpProvider) {
      $httpProvider.interceptors.push('httpInterceptorService');
    });

angular.module('yatch-sentinel.services')
  .service('http', function ($http, toastr, $q) {
    function handleError(errorHandler, err) {
      if (errorHandler) {
        errorHandler(err);
        return;
      }
      var msg = 'An unknown error occured';
      if (err && err.exceptionMessage) {
        msg = err.exceptionMessage;
      } else if (err && err.error_description) {
        msg = err.error_description;
      } else if (err && err.message) {
        msg = err.message;
      }
      //toastr.error(msg);
      return err;
    }
    return {
      get: function (url, data, success, error, ignoreLoadingBar) {
        if(ignoreLoadingBar == undefined){
          ignoreLoadingBar = false
        }
        return $http.get(url, {
            params: data,
            ignoreLoadingBar: ignoreLoadingBar
          })
          .then(function (response) {
            if (success) {
              success(response.data);
            }
            return response.data;
          }, function (err) {
            return handleError(error, err.data);
          });
      },
      post: function (url, data, success, error, header) {
        return $q(function(resolve, reject){
          $http.post(url, data, header || {})
          .then(function (response) {
            if (success) {
              success(response.data);
            }
            resolve(response.data);
            return response.data;
          }, function (err) {
            reject(err.data);
            return handleError(error, err.data);
          });
        });
      },
      put: function (url, data, success, error) {
        return $http.put(url, data)
          .then(function (response) {
            if (success) {
              success(response.data);
            }
            return response.data;
          }, function (err) {
            return handleError(error, err.data);
          });
      },
      delete: function (url, data, success, error) {
        return $http.delete(url, {
            params: data
          })
          .then(function (response) {
            if (success) {
              success(response.data);
            }
            return response.data;
          }, function (err) {
            return handleError(error, err.data);
          });
      }
    };

  });

(function () {
  'use strict';
  angular.module('yatch-sentinel.services')
    .service('chatService', function (http, config) {
      return {
        isChatSupported: function () {
          return http.get(config.apiUrl + "api/chat/status");
        },
        isChatInitiated: function () {
          return http.get(config.apiUrl + "api/chat/init");
        },
        startChart: function () {
          return http.post(config.apiUrl + "api/chat/init", {});
        },
        getGroupMessages: function (groupId) {
          return http.get(config.apiUrl + "api/chat/" + groupId + "/message");
        },
        sendMessage: function (groupId, model) {
          return http.post(config.apiUrl + "api/chat/" + groupId + "/message", model, null, null, {
            ignoreLoadingBar: true
          });
        },
        getChatGroupRecipientByGroupId: function (groupId) {
          return http.get(config.apiUrl + "api/chat/group/" + groupId);
        }
      };
    });
})();

(function () {
  'use strict';
  angular.module('yatch-sentinel.services')
    .service('cameraService',
      function (http, config, $q) {
        return {
          getAccessToken: function (userSentinelId, onSuccess) {
            return http.get(config.apiUrl + "api/camera/oauth/" + userSentinelId, {}, onSuccess);
          },
          getAllCamerasByUserSentinelId: function (userSentinelId, onSuccess) {
            return http.get(config.apiUrl + "api/camera/userSentinel/" + userSentinelId, {}, onSuccess);
          },
          getCameraStream: function (cameraId, onSuccess) {
            return http.get(config.apiUrl + "api/camera/" + cameraId + "/streams", {}, onSuccess);
          },
          getUserSentinelCamera: function (cameraId, onSuccess) {
            return http.get(config.apiUrl + "api/camera/" + cameraId + "/userSentinelCamera", {}, onSuccess);
          },
          userSentinelCameraEvents: function (userSentinelId, cameraId, pageNumber, pageSize, onSuccess) {
            return http.get(config.apiUrl + "api/camera/userSentinel/" + userSentinelId + "/camera/" + cameraId + "/events", {
              pageNumber: pageNumber,
              pageSize: pageSize
            }, onSuccess);
          },
          getAttachmentBlobUri: function (userSentinelId, attachmentId, onSuccess) {
            return http.get(config.apiUrl + "api/camera/userSentinel/" + userSentinelId + "/attachment/" + attachmentId, {}, onSuccess);
          },
          getCamera: function (cameraId, onSuccess) {
            return http.get(config.apiUrl + "api/camera/" + cameraId, {}, onSuccess);
          },
          getCameraFirmwareStatus: function (cameraId, onSuccess) {
            return http.get(config.apiUrl + "api/camera/" + cameraId + "/firmware", {}, onSuccess);
          },
          getCameraMode: function (cameraId, onSuccess) {
            return http.get(config.apiUrl + "api/camera/" + cameraId + "/mode", {}, onSuccess);
          },
          updateCamerasModeByUserSentinelId: function (userSentinelId, model) {
            return http.put(config.apiUrl + "api/camera/userSentinel/" + userSentinelId + "/mode", model);
          },
          deleteCamera: function (cameraId, onSuccess) {
            return http.delete(config.apiUrl + "api/camera/" + cameraId, {}, onSuccess);
          },
          updateCameraFirmwareStatus: function (cameraId, targetVersion, onSuccess) {
            return http.post(config.apiUrl + "api/camera/" + cameraId + "/firmware", JSON.stringify(targetVersion), onSuccess);
          },
          updateCameraByCameraId: function (cameraId, newName, onSuccess) {
            return http.put(config.apiUrl + "api/camera/" + cameraId, JSON.stringify(newName), onSuccess);
          },
          getCameraStatus: function (cameraId) {
            return http.get(config.apiUrl + "api/camera/" + cameraId + "/status");
          },
          getCameraWifiStatus: function (cameraId) {
            return http.get(config.apiUrl + "api/camera/" + cameraId + "/wifi/status");
          },
          getCameraSimStatus: function (cameraId, onSuccess) {
            return http.get(config.apiUrl + "api/camera/" + cameraId + "/sim/status", onSuccess);
          },
        }
      });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.services')
    .factory('allowedUnitsEnum', function () {
      return {
        Celcius: 1,
        Farenheit: 2,
        MilesPerHour: 3,
        KilometersPerHour: 4,
        Milimeters: 5,
        Meter: 6,
        Kilometers: 7,
        Miles: 8,
        Knots: 9,
        Feet: 10,
        NauticalMiles: 11,
        Liters: 12,
        Gallons: 13,
        MetersPerSecond: 14,
        Radians: 15,
        Degrees: 16,
        Pascals: 17,
        Psi: 18,
        Kelvins: 19,
        Seconds: 20,
        Hours: 21,
        CubicMeters: 22,
        Minutes: 23
      };
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.services')
    .factory('alarmTypes', function () {
      return {
        sentinelBatteryAlarm: {
          id: 1,
          description: 'Sentinel battery alarm',
          unreadMessageCount: 2
        },
        boatBatteryAlarm: {
          id: 2,
          description: 'Boat battery alarm'
        },
        geofenceAlarm: {
          id: 3,
          description: 'Geofence alarm'
        },
        temperatureAlarm: {
          id: 4,
          description: 'Temperature alarm'
        },
        beaconAlarm: {
          id: 7,
          description: 'Beacon/item security alarm'
        },
        bilgeAlarm: {
          id: 8,
          description: 'Bilge/high water alarm'
        },
        pirAlarm: {
          id: 9,
          description: 'PIR/Motion alarm'
        },
        mainSupplyAlarm: {
          id: 10,
          description: 'Main supply/Shorepower alarm'
        },
        mildShockAlarm: {
          id: 11,
          description: 'Mild shock alarm'
        },
        severeShockAlarm: {
          id: 12,
          description: 'Server shock alarm'
        },
        doorAlarm: {
          id: 13,
          description: 'Door alarm'
        },
        roughSeaAlarm: {
          id: 14,
          description: 'Rough sea alarm'
        },
        stormAlarm: {
          id: 15,
          description: 'Storm alarm'
        },
        tiltAlarm:{
          id:20,
          description: 'Tilt alarm'
        },
        geoFenceAlarmMoveIn: {
          id: 21,
          description: 'Geofence alarm move in'
        },
        safeReturnAlarm: {
          id: 22,
          description: 'Safe return alarm'
        },
        voltageAlarm: {
          id: 23,
          description: 'Voltage alarm'
        }
      }
    })
})();

(function () {
  'use strict';
  angular.module('yatch-sentinel.services')
    .service('accountService', function (http, config) {
      return {
        createAccount: function (model, onSuccess, onError) {
          return http.post(config.apiUrl + "api/account/create", model, onSuccess, onError);
        },
        createCameraOnlyAccount: function (model, onSuccess, onError) {
          return http.post(config.apiUrl + "api/account/create/cameraOnly", model, onSuccess, onError);
        },
        createNmeaOnlyAccount: function (model, onSuccess, onError) {
          return http.post(config.apiUrl + "api/account/create/nmeaOnly", model, onSuccess, onError);
        },
        login: function (model, onSuccess, onError) {
          var data = "grant_type=password&username=" + model.emailAddress + "&password=" + model.password + "&roles="+ "[2]"  + "&captchaResponse=" + model.captcha;
          return http.post(config.apiUrl + "token", data, onSuccess, onError, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          });
        },
        mimickUser: function (mimicKTokenId, onSuccess, onError) {
          var data = "grant_type=password&mimickTokenId=" + mimicKTokenId;
          return http.post(config.apiUrl + "token", data, onSuccess, onError, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          });
        },
        refreshToken: function (refreshToken, onSuccess, onError) {
          var data = "grant_type=refresh_token&refresh_token=" + refreshToken;
          return http.post(config.apiUrl + "token", data, onSuccess, onError);
        },
        resetPassword: function (email, tenantId, onSuccess, onError) {
          return http.get(config.apiUrl + "api/account/resetPassword", {
            emailAddress: email,
            tenant: tenantId
          }, onSuccess, onError);
        },
        changeEmail: function(model, onSuccess, onError){
          return http.post(config.apiUrl + "api/account/changeEmail", model, onSuccess, onError);
        },
        changePassword: function (model, onSuccess) {
          return http.post(config.apiUrl + "api/account/changePassword", model, onSuccess);
        },
        me: function (onSuccess) {
          return http.get(config.apiUrl + "api/account/me", {}, onSuccess);
        },
        update: function (model, onSuccess, onError) {
          return http.post(config.apiUrl + "api/account/update", model, onSuccess, onError);
        },
        updateAgreedStatus: function (status,onSuccess) {
          return http.post(config.apiUrl + "api/account/UpdateAgreedStatus?status="+status, {}, onSuccess);
        },
        updateProfile: function(userId,model,onSuccess) {
          return http.put(config.apiUrl + "api/user/"+userId+"/profile",model,onSuccess);
        },
        validateW2K1SerialKey: function (w2K1SerialKey, onSuccess) {
          return http.get(config.apiUrl + "api/account/validate/w2K1SerialKey/" + w2K1SerialKey, {}, onSuccess, null, true);
        },
        updatePassword: function(model){
          return http.post(config.apiUrl+ "api/account/updatePassword",model);
        },
        skipPasswordUpdate: function(userId){
          return http.get(config.apiUrl+ "api/account/skipPasswordPolicyUpdate/"+ userId,{});
        }
      };
    });

})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.filters', ['yatch-sentinel.services']);
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.filters')
    .filter('volume', function (sessionService, settingEnum) {
      return function (label) {
        var settings = sessionService.getUserSettings();
        var toReturn = settings.filter(function (setting) {
          return setting.description === settingEnum.Volume.description;
        });
        if (toReturn !== null && toReturn.length > 0) {
          if (toReturn[0].userSettingViewModel != null) {
            return label + ' ' + toReturn[0].userSettingViewModel.allowed_Setting_Value.unit;
          } else {
            return label + ' ' + toReturn[0].allowedSettingValues.filter(function (s) {
              return s.isPrimary;
            })[0].unit;
          }
        }
        return label;
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.filters')
    .filter('utcDate', function ($filter) {
      return function (input) {
        if(input == null || input == undefined) return '';
        return $filter('date')(input + "Z", 'dd MMM yyyy hh:mm a');
      };
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.filters')
    .filter('temperature', function (sessionService, settingEnum) {
      return function (label) {
        var settings = sessionService.getUserSettings();
        var toReturn = settings.filter(function (setting) {
          return setting.description === settingEnum.Temperature.description;
        });
        if (toReturn !== null && toReturn.length > 0) {
          if (toReturn[0].userSettingViewModel != null) {
            return label + ' ' + toReturn[0].userSettingViewModel.allowed_Setting_Value.unit;

          } else {
            return label + ' ' + toReturn[0].allowedSettingValues.filter(function (s) {
              return s.isPrimary;
            })[0].unit;
          }
        }
        return label;
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.filters')
    .filter('speed', function (sessionService, settingEnum) {
      return function (label) {
        if(label == undefined) return "N/A";
        var settings = sessionService.getUserSettings();
        var toReturn = settings.filter(function (setting) {
          return setting.description === settingEnum.Speed.description;
        });
        if (toReturn !== null && toReturn.length > 0) {
          if (toReturn[0].userSettingViewModel != null) {
            return label +" "+ toReturn[0].userSettingViewModel.allowed_Setting_Value.unit;

          } else {
            return label +" "+ toReturn[0].allowedSettingValues.filter(function (s) {
              return s.isPrimary;
            })[0].unit;
          }
        }
        return label;
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.filters')
    .filter('militaryTime', function (moment) {
      return function (input) {
        var inputStr = input.toString();
        if (inputStr.length < 4) {
          var prefix = "";
          var diff = 4 - inputStr.length;
          for (var i = 0; i < diff; i++) {
            prefix += "0";
          }
          prefix += inputStr;
          return moment(prefix, "hh").format('hA')

        } else {
          return moment(inputStr, "hh").format('hA')
        }
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.filters')
    .filter('hms', function (moment) {
      return function (input) {
        var duration = moment.duration(input, 'seconds');
        var days = duration.days() * 24;
        var hours = duration.hours() + days;
        var minutes = duration.minutes();
        var seconds = duration.seconds();

        return hours.toString().padStart(2,'0') + ":" + minutes.toString().padStart(2,'0') + ":" + seconds.toString().padStart(2,'0')
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.filters')
    .filter('height', function (sessionService, settingEnum) {
      return function (label) {
        var settings = sessionService.getUserSettings();
        var toReturn = settings.filter(function (setting) {
          return setting.description === settingEnum.Height.description;
        });
        if (toReturn !== null && toReturn.length > 0) {
          if (toReturn[0].userSettingViewModel != null) {
            return label + " (" + toReturn[0].userSettingViewModel.allowed_Setting_Value.unit + ")";

          } else {
            return label + " (" + toReturn[0].allowedSettingValues.filter(function (s) {
              return s.isPrimary;
            })[0].unit + ")";
          }
        }
        return label;
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.filters')
    .filter('distance', function (sessionService, settingEnum) {
      return function (label) {
        var settings = sessionService.getUserSettings();
        var toReturn = settings.filter(function (setting) {
          return setting.description === settingEnum.Distance.description;
        });
        if (toReturn !== null && toReturn.length > 0) {
          if (toReturn[0].userSettingViewModel != null) {
            return label + " (" + toReturn[0].userSettingViewModel.allowed_Setting_Value.unit + ")";

          } else {
            return label + " (" + toReturn[0].allowedSettingValues.filter(function (s) {
              return s.isPrimary;
            })[0].unit + ")";
          }
        }
        return label;
      }
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.filters')
    .filter('courseDirection', function () {
      return function (course) {
        if (course >= -354.37 && course <= 39.37) {
          return course + " °" + " N";
        } else if (course >= -39.38 && course <= 84.37) {
          return course + " °" + " NE";
        } else if (course >= -84.38 && course <= 129.37) {
          return course + " °" + " E";
        } else if (course >= 129.38 && course <= 174.37) {
          return course + " °" + " SE";
        } else if (course >= 174.38 && course <= 219.37) {
          return course + " °" + " S";
        } else if (course >= 219.38 && course <= 264.37) {
          return course + " °" + " SW";
        } else if (course >= 264.38 && course <= 309.37) {
          return course + " °" + " W";
        } else if (course >= 309.38 && course <= 359.99) {
          return course + " °" + " NW";
        }
        else {
          return course + " °"
        }
      }
    });
})();

(function () {
  "use strict;";
  angular.module("yatch-sentinel").service("oemConfig", function ($document) {
    // Empty for YAcht Sentinel
    // Supported OEM's = fp/ , sp2/
    var oem = "sp2/";
    if (oem != "") {
      var head = $document.find("head")[0];

      // Create new link Element
      var link = $document.context.createElement("link");

      // set the attributes for link element
      link.rel = "stylesheet";

      link.type = "text/css";

      link.href =
        "assets/css/oem/" +
        oem.replace("/", "") +
        "/" +
        oem.replace("/", "") +
        ".css";
      // Append link element to HTML head
      head.appendChild(link);
    }
    var addresses = {
      "": [
        "London, UK - Head office",
        "Yacht Sentinel Limited",
        "Elmbridge House, <br />" +
          "Elmbridge Lane,<br />" +
          "Kingfield, Woking,<br />" +
          "GU22 9AF,<br />" +
          "United Kingdom<br />",
      ],
      "fp/": [],
      "sp2/": [
        "London, UK - Head office",
        "Yacht Sentinel Limited",
        "Elmbridge House, <br />" +
          "Elmbridge Lane,<br />" +
          "Kingfield, Woking,<br />" +
          "GU22 9AF,<br />" +
          "United Kingdom<br />",
      ],
    };
    var emails = {
      "": "sales@yacht-sentinel.com",
      "fp/": "",
      "sp2/": "sales@yacht-sentinel.com",
    };
    var phones = {
      "": "+44 (0)1932 506 173",
      "fp/": "",
      "sp2/": "+44 (0)1932 506 173",
    };
    var titles = {
      "": "Yacht Sentinel",
      "fp/": "Fountaine Pajot",
      "sp2/": "Sentinel Point 2",
    };
    var tagLines = {
      "": "VirtualCrew.Text",
      "fp/": "VirtualCrewFp.Text",
      "sp2/": "VirtualCrew.Text",
    };
    return {
      oem: oem.replace("/", ""),
      title: titles[oem],
      header: {
        logo: "assets/images/" + oem + "logo-small.png",
        weather: "assets/images/" + oem + "weather.png",
        notification: "assets/images/" + oem + "notifications.png",
        manageBoats: function () {
          if (oem == "") return "ManageBoats.Text";
          if (oem == "fp/") return "ManageBoats.Text";
          if (oem == "sp2/") return "ManageAssets.Text";
        },
      },
      footer: {
        logo: "assets/images/" + oem + "symbol-small.png",
        help: "assets/images/" + oem + "help.png",
        settings: "assets/images/" + oem + "settings.png",
        menu: {
          manageBoats: function () {
            if (oem == "") return "Footer.ManageBoats";
            if (oem == "fp/") return "Footer.ManageBoats";
            if (oem == "sp2/") return "Footer.ManageAssets";
          },
        },
      },
      landing: {
        logo: "assets/images/" + oem + "logo.png",
        activateAccount: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return false;
            if (oem == "sp2/") return true;
          },
        },
        tagLine: tagLines[oem],
      },
      login: {
        logo: "assets/images/" + oem + "logo-blue.png",
        activateAccount: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return false;
            if (oem == "sp2/") return true;
          },
        },
      },
      forgotPassword: {
        logo: "assets/images/" + oem + "logo-blue.png",
      },
      register: {
        logo: "assets/images/" + oem + "logo-blue.png",
        showOptions: function () {
          if (oem == "") return true;
          if (oem == "fp/") return true;
          if (oem == "sp2/") return false;
        },
      },
      changeLanguage: {
        logo: "assets/images/" + oem + "logo-blue.png",
      },
      home: {
        header: {
          showIcon: function () {
            if (oem == "") return true;
            if (oem == "fp/") return true;
            if (oem == "sp2/") return true;
          },
          notificationGreen: "assets/images/" + oem + "icon-green.png",
          notificationRed: "assets/images/" + oem + "icon-red.png",
        },
        main: {
          yacht: "assets/images/" + oem + "yacht.png",
          alarm: "assets/images/" + oem + "alarm.png",
          map: "assets/images/" + oem + "map.png",
          routes: "assets/images/" + oem + "routes.png",
          camera: "assets/images/" + oem + "cctv.png",
          contact: "assets/images/" + oem + "user-contact.png",
        },
      },
      ys6Dashboard: {
        logo: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return false;
            if (oem == "sp2/") return true;
          },
          image: "assets/images/" + oem + "icon-blue.png",
        },
        statuses: {
          showIcons: function () {
            if (oem == "") return true;
            if (oem == "fp/") return false;
            if (oem == "sp2/") return true;
          },
        },
        switch: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return true;
            if (oem == "sp2/") return false;
          },
        },
        heading: function () {
          if (oem == "") return "Ys6Dashboard.Text";
          if (oem == "fp/") return "Ys6Dashboard.Text";
          if (oem == "sp2/") return "Sp2Dashboard.Text";
        },
      },
      ys6Alarms: {
        logo: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return false;
            if (oem == "sp2/") return true;
          },
          image: "assets/images/" + oem + "icon-blue.png",
        },
        battery: {
          batteryOptions: function () {
            if (oem == "") return 2;
            if (oem == "fp/") return 2;
            if (oem == "sp2/") return 3;
          },
        },
        heading: function () {
          if (oem == "") return "Ys6Alarms.Text";
          if (oem == "fp/") return "Ys6Alarms.Text";
          if (oem == "sp2/") return "Alarms.Text";
        },
      },
      ys6Map: {
        logo: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return false;
            if (oem == "sp2/") return true;
          },
          image: "assets/images/" + oem + "icon-blue.png",
        },
        switch: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return true;
            if (oem == "sp2/") return false;
          },
        },
        heading: function () {
          if (oem == "") return "Ys6Map.Text";
          if (oem == "fp/") return "Ys6Map.Text";
          if (oem == "sp2/") return "Map.Text";
        },
      },
      ys6Journey: {
        logo: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return false;
            if (oem == "sp2/") return true;
          },
          image: "assets/images/" + oem + "icon-blue.png",
        },
        switch: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return true;
            if (oem == "sp2/") return false;
          },
        },
        heading: function () {
          if (oem == "") return "Ys6JourneyLog.Text";
          if (oem == "fp/") return "Ys6JourneyLog.Text";
          if (oem == "sp2/") return "JourneyLog.Text";
        },
      },
      camera: {
        logo: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return false;
            if (oem == "sp2/") return false;
          },
          image: "assets/images/" + oem + "symbol.png",
        },
        content: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return true;
            if (oem == "sp2/") return false;
          },
        },
      },
      contacts: {
        logo: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return false;
            if (oem == "sp2/") return true;
          },
          image: "assets/images/" + oem + "symbol.png",
        },
        content: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return true;
            if (oem == "sp2/") return false;
          },
        },
      },
      sp2Contacts: {
        logo: {
          show: function () {
            if (oem == "") return false;
            if (oem == "fp/") return false;
            if (oem == "sp2/") return true;
          },
          image: "assets/images/" + oem + "symbol.png",
        },
      },
      sharedUser: {
        logo: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return false;
            if (oem == "sp2/") return true;
          },
          image: "assets/images/" + oem + "symbol.png",
        },
        allowedBoat: function () {
          if (oem == "") return "AllowedBoat.Text";
          if (oem == "fp/") return "AllowedBoat.Text";
          if (oem == "sp2/") return "AllowedAsset.Text";
        },
        boatRequired: function () {
          if (oem == "") return "BoatRequired.Text";
          if (oem == "fp/") return "BoatRequired.Text";
          if (oem == "sp2/") return "AssetRequired.Text";
        },
        showCameraPermissions: function () {
          if (oem == "") return true;
          if (oem == "fp/") return true;
          if (oem == "sp2/") return false;
        },
      },
      documents: {
        logo: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return false;
            if (oem == "sp2/") return false;
          },
          image: "assets/images/" + oem + "symbol.png",
        },
        folder: "assets/images/" + oem + "folder-icon.png",
        file: "assets/images/" + oem + "file-icon.png",
        content: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return true;
            if (oem == "sp2/") return false;
          },
        },
      },
      sensors: {
        logo: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return false;
            if (oem == "sp2/") return true;
          },
          image: "assets/images/" + oem + "symbol.png",
        },
        content: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return true;
            if (oem == "sp2/") return false;
          },
        },
      },
      weather: {
        logo: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return false;
            if (oem == "sp2/") return true;
          },
          image: "assets/images/" + oem + "symbol.png",
        },
      },
      notifications: {
        logo: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return false;
            if (oem == "sp2/") return true;
          },
          image: "assets/images/" + oem + "symbol.png",
        },
      },
      tutorial: {
        logo: "assets/images/" + oem + "logo.png",
        screen2: "assets/images/" + oem + "screen2.png",
        screen3: "assets/images/" + oem + "screen3.png",
        screen4: "assets/images/" + oem + "screen4.png",
        screen5: "assets/images/" + oem + "screen5.png",
        screen6: "assets/images/" + oem + "screen6.png",
        screen7: "assets/images/" + oem + "screen7.png",
        screen8: "assets/images/" + oem + "screen8.png",
        screen9: "assets/images/" + oem + "screen9.png",
      },
      forum: {
        logo: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return false;
            if (oem == "sp2/") return true;
          },
          image: "assets/images/" + oem + "symbol.png",
        },
      },
      contactUs: {
        footer: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return false;
            if (oem == "sp2/") return true;
          },
        },
        logo: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return false;
            if (oem == "sp2/") return true;
          },
          image: "assets/images/" + oem + "symbol.png",
        },
        address: addresses[oem],
        email: emails[oem],
        phone: phones[oem],
      },
      accountSettings: {
        logo: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return false;
            if (oem == "sp2/") return true;
          },
          image: "assets/images/" + oem + "symbol.png",
        },
        phone: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return true;
            if (oem == "sp2/") return false;
          },
        },
        port: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return true;
            if (oem == "sp2/") return false;
          },
        },
        address: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return true;
            if (oem == "sp2/") return false;
          },
        },
        city: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return true;
            if (oem == "sp2/") return false;
          },
        },
        country: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return true;
            if (oem == "sp2/") return false;
          },
        },
        zip: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return true;
            if (oem == "sp2/") return false;
          },
        },
      },
      manageBoats: {
        sellButton: {
          show: function () {
            if (oem == "") return false;
            if (oem == "fp/") return true;
            if (oem == "sp2/") return false;
          },
        },
        logo: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return false;
            if (oem == "sp2/") return true;
          },
          image: "assets/images/" + oem + "symbol.png",
        },
        label: {
          add: function () {
            if (oem == "") return "AddBoat.Text";
            if (oem == "fp/") return "AddBoat.Text";
            if (oem == "sp2/") return "AddAsset.Text";
          },
          name: function () {
            if (oem == "") return "BoatName.Text";
            if (oem == "fp/") return "BoatName.Text";
            if (oem == "sp2/") return "AssetName.Text";
          },
          nameRequired: function () {
            if (oem == "") return "BoatNameRequired.Text";
            if (oem == "fp/") return "BoatNameRequired.Text";
            if (oem == "sp2/") return "AssetNameRequired.Text";
          },
          addNew: function () {
            if (oem == "") return "AddNewBoat.Text";
            if (oem == "fp/") return "AddNewBoat.Text";
            if (oem == "sp2/") return "AddNewAsset.Text";
          },
          myList: function () {
            if (oem == "") return "MyBoats.Text";
            if (oem == "fp/") return "MyBoats.Text";
            if (oem == "sp2/") return "MyAssets.Text";
          },
          edit: function () {
            if (oem == "") return "EditBoat.Text";
            if (oem == "fp/") return "EditBoat.Text";
            if (oem == "sp2/") return "EditAsset.Text";
          },
        },
      },
      metrics: {
        logo: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return false;
            if (oem == "sp2/") return true;
          },
          image: "assets/images/" + oem + "symbol.png",
        },
      },
      nmeaDashboard: {
        refreshStatus: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return true;
            if (oem == "sp2/") return false;
          },
        },
        logo: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return false;
            if (oem == "sp2/") return false;
          },
          image: "assets/images/" + oem + "symbol.png",
        },
      },
      nmeaDashboardDeatails: {
        logo: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return false;
            if (oem == "sp2/") return false;
          },
          image: "assets/images/" + oem + "symbol.png",
        },
      },
      nmeaAlarms: {
        logo: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return false;
            if (oem == "sp2/") return true;
          },
          image: "assets/images/" + oem + "icon-blue.png",
        },
        showSwitch: function () {
          if (oem == "") return true;
          if (oem == "fp/") return true;
          if (oem == "sp2/") return true;
        },
      },
      nmeaMap: {
        logo: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return false;
            if (oem == "sp2/") return true;
          },
          image: "assets/images/" + oem + "icon-blue.png",
        },
      },
      nmeaJourney: {
        logo: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return false;
            if (oem == "sp2/") return true;
          },
          image: "assets/images/" + oem + "icon-blue.png",
        },
        content: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return true;
            if (oem == "sp2/") return false;
          },
        },
      },
      helpCenter: {
        logo: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return false;
            if (oem == "sp2/") return true;
          },
          image: "assets/images/" + oem + "symbol.png",
        },
      },
      disarm: {
        logo: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return false;
            if (oem == "sp2/") return true;
          },
          image: "assets/images/" + oem + "sos.png",
        },
        text: function () {
          if (oem == "") return "Disarm.Text";
          if (oem == "fp/") return "Disarm.Text";
          if (oem == "sp2/") return "DisarmSp2.Text";
        },
      },
      sos: {
        header: {
          logo: {
            show: function () {
              if (oem == "") return true;
              if (oem == "fp/") return false;
              if (oem == "sp2/") return true;
            },
            image: "assets/images/" + oem + "sos.png",
          },
        },
        dialog: {
          logo: {
            show: function () {
              if (oem == "") return true;
              if (oem == "fp/") return false;
              if (oem == "sp2/") return true;
            },
            image: "assets/images/" + oem + "sos2.png",
          },
        },
        content: {
          show: function () {
            if (oem == "") return true;
            if (oem == "fp/") return true;
            if (oem == "sp2/") return false;
          },
        },
      },
      faq: {
        show: function () {
          if (oem == "") return true;
          if (oem == "fp/") return false;
          if (oem == "sp2/") return true;
        },
      },

      tutorialVideo: {
        show: function () {
          if (oem == "") return true;
          if (oem == "fp/") return false;
          if (oem == "sp2/") return true;
        },
      },
      SentinelProductCodeInput: {
        show: function () {
          if (oem == "") return true;
          if (oem == "fp/") return true;
          if (oem == "sp2/") return false;
        },
      },
    };
  });
})();

(function () {
  'use strict';

  angular
    .module('yatch-sentinel')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $document) {
    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('yatch-sentinel')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise('/');
  }

})();

/* global malarkey:false, moment:false */
(function () {
  'use strict';
  var RecenterMapControl = /*@__PURE__*/(function (Control) {
    function RecenterMapControl(opt_options) {
      var options = opt_options || {};

      var button = document.createElement('button');
      button.innerHTML = 'C';

      var element = document.createElement('div');
      element.className = 'rotate-north ol-unselectable ol-control';
      element.appendChild(button);

      Control.call(this, {
        element: element,
        target: options.target,
      });

      button.addEventListener('click', this.handleRotateNorth.bind(this, options), false);
    }

    if (Control) RecenterMapControl.__proto__ = Control;
    RecenterMapControl.prototype = Object.create(Control && Control.prototype);
    RecenterMapControl.prototype.constructor = RecenterMapControl;
    RecenterMapControl.prototype.handleRotateNorth = function handleRotateNorth(location) {
      this.getMap().getView().setCenter(location)
    };
    return RecenterMapControl;
  }(ol.control.Control));
  angular
    .module('yatch-sentinel')
    .constant('malarkey', malarkey)
    .constant('swiper', Swiper)
    .constant('moment', moment)
    .constant('am4core', am4core)
    .constant('am4charts', am4charts)
    .constant('am4themes_animated', am4themes_animated)
    .constant('RecenterMap', RecenterMapControl)

})();

(function () {
  'use strict';

  angular
    .module('yatch-sentinel')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, cfpLoadingBarProvider, flowFactoryProvider,$translateProvider) {
    // Enable log
    $logProvider.debugEnabled(true);
    cfpLoadingBarProvider.spinnerTemplate =
      '<div id="loading-bar-spinner">' +
      '<img class="img-responsive" src="assets/images/loading-1.gif" />' +
      '</div>'
      ;
    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = false;
    toastrConfig.progressBar = true;
    flowFactoryProvider.defaults = {
      chunkSize: Number.MAX_VALUE,
      testChunks: false
    };

    $translateProvider.useLoader('$translatePartialLoader', {
      urlTemplate: '{part}/i18n/{lang}.json'
    });

    $translateProvider
    .preferredLanguage('en');
    
    $translateProvider.useSanitizeValueStrategy(null);

    $translateProvider.useLocalStorage();
  }

})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.spinner', [])
    .config(function ($stateProvider) {
      $stateProvider
        .state('spinner', {
          url: '/spinner',
          templateUrl: 'app/main/spinner/spinner.html',
          controller: 'spinnerController',
          controllerAs: 'vm'
        });
    })
    .controller('spinnerController', function (cfpLoadingBar) {
      var vm = this;
      vm.start = function () {
        cfpLoadingBar.start();
      };

      vm.stop = function () {
        cfpLoadingBar.complete();
      };
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.privacy', ['vcRecaptcha','flow','ui.validate'])
    .config(function ($stateProvider, vcRecaptchaServiceProvider,$translatePartialLoaderProvider) {
      vcRecaptchaServiceProvider.setSiteKey("6Lf2QTMUAAAAAJF1e1NSMDXJul7ZulweKJyXTKpm");
      $stateProvider
        .state('privacy', {
            url : '/privacy?isPrivacy',
            templateUrl : 'app/main/privacy/privacy.html',
            controller: 'privacyController',
            controllerAs : 'vm'
        });
        $translatePartialLoaderProvider.addPart('app/main/privacy');
    });
})();

(function () {
  'use strict;'
  angular.module('yatch-sentinel.helpCenter', [
    'yatch-sentinel.services',
    'flow'
  ]).config(function ($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider
      .state('boat.helpCenter', {
        url: '/:sentinelId/helpCenter',
        views: {
          'header@boat': {
            templateUrl: 'app/main/help-center/chatCredentials/header.html',
            controller: function (oemConfig) {
              var vm = this;
              vm.oemConfig = angular.copy(oemConfig);
            },
            controllerAs: 'vm'
          },
          'content@boat': {
            templateUrl: 'app/main/help-center/chatCredentials/chatCredentials.html',
            controller: 'helpCenterController',
            controllerAs: 'vm'
          }
        },
        headerClass: 'half',
        mobileHeader: {
          visible: true,
          title: 'Header.HelpCenter'
        },
        data: {
          pageTitle: 'Help Center'
        }
      })
      .state('boat.chat', {
        url: '/:sentinelId/chat/:groupId',
        views: {
          'header@boat': {
            templateUrl: 'app/main/help-center/groupChat/header.html',
            controller: function (oemConfig) {
              var vm = this;
              vm.oemConfig = angular.copy(oemConfig);
            },
            controllerAs: 'vm'
          },
          'content@boat': {
            templateUrl: 'app/main/help-center/groupChat/groupChat.html',
            controller: 'chatController',
            controllerAs: 'vm',
            resolve: {
              groupMessages: function (chatService, $stateParams) {
                return chatService.getGroupMessages($stateParams.groupId);
              },
              chatGroupRecipient: function (chatService, $stateParams) {
                return chatService.getChatGroupRecipientByGroupId($stateParams.groupId);
              }
            }
          }
        },
        headerClass: 'half',
        mobileHeader: {
          visible: true,
          title: 'Header.HelpCenter'
        },
        data: {
          pageTitle: 'Help Center'
        }
      });
    $translatePartialLoaderProvider.addPart('app/main/help-center/chatCredentials');
    $translatePartialLoaderProvider.addPart('app/main/help-center/groupChat');
  });
})();

angular.module('yatch-sentinel')
.config(function($stateProvider, $translatePartialLoaderProvider){
    $stateProvider
    .state('change_language', {
      url: '/change-language',
      templateUrl: 'app/main/change-language/index.html',
      controller: 'changeLanguageController',
      controllerAs: 'vm'
    });
    $translatePartialLoaderProvider.addPart('app/main/change-language');
})
.service('changeLanguageHelper', function(){
    return {
        backLink:{
            state: '',
            stateParams: {}
        }
    }
})
.directive('changeLanguage', function(changeLanguageHelper, $parse, $state){
    return {
        restrict: 'A',
        link: function(scope, elem, attrs){
            elem.on('click',(function(){
                changeLanguageHelper.backLink.state = attrs.changeLanguage;
                $state.go('change_language');
            }));
        }
    }
})
.controller('changeLanguageController', function($translate,sessionService, $state, changeLanguageHelper, oemConfig){
    var vm = this;
    vm.oemConfig = angular.copy(oemConfig);
    vm.lang = sessionService.getLang();
    vm.changeLanguage = function(){
        $translate.use(vm.lang);
        sessionService.setLang(vm.lang);
        if(changeLanguageHelper.backLink.state != ''){
            $state.go(changeLanguageHelper.backLink.state,changeLanguageHelper.backLink.stateParams);
        }
    };

    vm.goBack = function(){
        if(changeLanguageHelper.backLink.state != ''){
            $state.go(changeLanguageHelper.backLink.state,changeLanguageHelper.backLink.stateParams);
        }
        else{
            $state.go('landing_page');
        }
    }
});
angular.module("yatch-sentinel").run(["$templateCache", function($templateCache) {$templateCache.put("app/directives/maritime/maritime.html","<ng-transclude></ng-transclude><style>.map {\r\n    height: 600px;\r\n    width: 100%;\r\n  }</style><div id=map{{instanceCount}} class=map><!-- Popup --><div id=popup popover-class=popover-full-width uib-popover=\"Latitude: {{location.latitude}} Longitude: {{location.longitude}}\"></div></div>");
$templateCache.put("app/main/account-details/account-form.html","<div class=col-sm-12><h3>Account Details</h3></div><div class=full-width><form novalidate name=form ng-submit=\"form.$valid && vm.updateAccount(form)\" class=h-880px><!--  --><div class=col-sm-12><div class=bound-box><div class=col-sm-6><label class=\"card-label fp\">{{\'FirstName.Text\'| translate}}*</label><input class=active type=text name=FirstName required=true ng-model=vm.newUser.firstName><div ng-messages=form.FirstName.$error ng-if=form.$submitted class=error><div ng-message=required>{{ \"FirstName.Required\" | translate }}</div></div></div><div class=col-sm-6><label class=\"card-label fp\">{{\'LastName.Text\'| translate}}*</label><input type=text name=LastName required=true style=\"width: 100%\" ng-model=vm.newUser.lastName><div ng-messages=form.LastName.$error ng-if=form.$submitted class=error><div ng-message=required>{{ \"LastName.Required\" | translate }}</div></div></div></div></div><div class=col-sm-12><div class=bound-box><div class=col-sm-6 style=\"z-index: 2\"><label class=\"card-label fp\">{{\'EmailAddress.Text\'| translate}}*</label><label class=active ng-if=vm.queryString.isEmailChanged>{{vm.user.emailAddress}}</label><input ng-if=!vm.queryString.isEmailChanged class=active type=email ng-model=vm.user.emailAddress , name=emailAddress required=true><div ng-messages=form.email.$error ng-if=form.$submitted class=error><div ng-message=required>{{ \"EmailAddress.Required\" | translate }}</div></div></div><div class=col-sm-6><label class=\"card-label fp\">{{\'Telephone.Text\'| translate}}*</label><input class=active type=text name=telephone ng-model=vm.newUser.mobileNumber required=true><div ng-messages=form.telephone.$error ng-if=form.$submitted class=error><div ng-message=required>{{ \"Telephone.Required\" | translate }}</div></div></div></div></div><div class=col-sm-12><div class=bound-box><div class=col-sm-6><label class=\"card-label fp\">{{\'Address.Text\'| translate}}*</label><textarea class=active rows=2 type=text name=address ng-model=vm.newUser.address required=true>\r\n          </textarea><div ng-messages=form.address.$error ng-if=form.$submitted class=error><div ng-message=required>{{ \"Address.Required\" | translate }}</div></div></div><div class=col-sm-6><label class=\"card-label fp\">{{\'ZipCode.Text\'| translate}}*</label><input class=active type=text name=zip ng-model=vm.newUser.zipCode required=true><div ng-messages=form.zip.$error ng-if=form.$submitted class=error><div ng-message=required>{{ \"ZipCode.Required\" | translate }}</div></div></div></div></div><div class=col-sm-12><div class=bound-box><div class=col-sm-6><label class=\"card-label fp\">{{\'City.Text\'| translate}}*</label><input class=active type=text name=city ng-model=vm.newUser.city required=true><div ng-messages=form.city.$error ng-if=form.$submitted class=error><div ng-message=required>{{ \"City.Required\" | translate }}</div></div></div><div class=col-sm-6><label class=\"card-label fp\">{{\'Country.Text\'| translate}}*</label><div isteven-multi-select input-model=vm.countries button-label=name item-label=name tick-property=ticked selection-mode=single output-model=vm.newUser.selectedCountry name=country required=true></div><div ng-if=\"form.$submitted && vm.checkCountry()\" class=error><div>{{ vm.countryMessage }}</div></div></div></div></div><div class=col-sm-12><div class=bound-box><div class=col-sm-12><label class=\"card-label fp\">{{\'HomePort.Text\'| translate}}</label><input class=active type=text name=homePort ng-model=vm.newUser.homePort style=\"width: 50%\"></div></div></div><!-- userSentinel --><div class=col-sm-12><h3>Boats</h3></div><div class=col-sm-12><div class=bound-box><div class=col-sm-6 ng-repeat=\"boat in vm.boats\"><label class=card-label>IMEI: {{boat.imei}}</label><label class=card-label ng-if=\"boat.validW2K1SerialKey!=null\">SDKey: {{boat.validW2K1SerialKey.w2K1SerialKey}}</label><input class=active type=text name=city value={{boat.name}} ng-model=boat.name></div></div></div><div class=\"col-sm-12 mid h-0\"><button type=\"submit \" class=\"oval-btn blue\">{{\'SaveChanges.Text\'| translate}}</button></div></form></div>");
$templateCache.put("app/main/alarm/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.ys6Alarms.logo.show() ng-src={{vm.oemConfig.ys6Alarms.logo.image}} class=symbol><h2 class=red-border-bottom>{{vm.oemConfig.ys6Alarms.heading() | translate}}</h2><div class=status>{{\'LastAmendedOn.Text\'| translate}} {{vm.timeStamp}}</div></div>");
$templateCache.put("app/main/alarm/index.html","<div class=alarm-box><!--  --><div class=col-sm-12 style=margin-left:-5px><a href ng-click=vm.goBack() style=\"float: left\"><img src=assets/images/back.png class=back-btn2></a></div><div class=row ng-if=\"vm.currentSentinel.w2K1SerialKeyId!=null && vm.oemConfig.nmeaAlarms.showSwitch()\"><div class=col-sm-12><div class=\"col-sm-6 p-0\"><div class=bound-box><div class=\"col-md-6 col-sm-6 card small flex-card\"><label class=card-label>YS6</label><switch ng-click=vm.showNmeaAlarms(); class=green></switch><label class=\"card-label text-right\">NMEA</label></div></div></div></div></div><div class=row><div class=col-sm-6><div class=bound-box><div class=\"col-sm-12 card small flex-card blank\"><label class=field>{{ \"Alarm.Text\" | translate }}</label><label class=field>{{ \"Status2.Text\" | translate }}</label></div><div class=\"col-sm-12 card small flex-card\" ui-sref=\"boat.position_alarm({sentinelId: vm.currentSentinelId})\"><label class=card-label>{{ \"Position.Text\" | translate }}</label><div ng-if=\"!vm.isDisArmed && vm.turnedOff == false\"><div class=\"round-bagde green\" uib-tooltip=\"{{ \'AlarmActivated.Text\' | translate }}\" ng-if=\"vm.positionAlarm == true\"></div><div class=\"round-bagde red\" uib-tooltip=\"{{ \'AlarmInactive.Text\' | translate }}\" ng-if=\"vm.positionAlarm == false\"></div></div><div ng-if=\"vm.isDisArmed || vm.turnedOff\" class=\"round-bagde blue\" uib-tooltip=\"{{ \'Disarmed.Text\' | translate }}\"></div><a ui-sref=\"boat.position_alarm({sentinelId: vm.currentSentinelId})\"><img src=assets/images/arrow.png class=\"card-icon pull-right\"></a></div><div class=\"col-sm-12 card small flex-card\" ui-sref=\"boat.safe_return_alarm({sentinelId: vm.currentSentinelId})\"><label class=card-label>{{ \"SafeReturn.Text\" | translate }}</label><div ng-if=\"!vm.isDisArmed && vm.turnedOff == false\"><div class=\"round-bagde green\" uib-tooltip=\"{{ \'AlarmActivated.Text\' | translate }}\" ng-if=\"vm.safeReturnAlarm == true\"></div><div class=\"round-bagde red\" uib-tooltip=\"{{ \'AlarmInactive.Text\' | translate }}\" ng-if=\"vm.safeReturnAlarm == false\"></div></div><div ng-if=\"vm.isDisArmed || vm.turnedOff\" class=\"round-bagde blue\" uib-tooltip=\"{{ \'Disarmed.Text\' | translate }}\"></div><a ui-sref=\"boat.safe_return_alarm({sentinelId: vm.currentSentinelId})\"><img src=assets/images/arrow.png class=\"card-icon pull-right\"></a></div><div class=\"col-sm-12 card small flex-card\" ui-sref=\"boat.battery_alarm({sentinelId: vm.currentSentinelId})\"><label class=card-label>{{ \"Battery.Text\" | translate }}</label><div ng-if=\"vm.turnedOff == false\"><div class=\"round-bagde green\" uib-tooltip=\"{{ \'AlarmActivated.Text\' | translate }}\" ng-if=\"vm.batteryAlarm == true\"></div><div class=\"round-bagde red\" uib-tooltip=\"{{ \'AlarmInactive.Text\' | translate }}\" ng-if=\"vm.batteryAlarm == false\"></div></div><div ng-if=vm.turnedOff class=\"round-bagde blue\" uib-tooltip=\"{{ \'Disarmed.Text\' | translate }}\"></div><a ui-sref=\"boat.battery_alarm({sentinelId: vm.currentSentinelId})\"><img src=assets/images/arrow.png class=\"card-icon pull-right\"></a></div><div ng-if=!vm.oemConfig.sp2Contacts.logo.show() class=\"col-sm-12 card small flex-card\" ui-sref=\"boat.shorepower_alarm({sentinelId: vm.currentSentinelId})\"><label class=card-label>{{ \"ShorePower.Text\" | translate }}</label><div ng-if=\"!vm.isDisArmed && vm.turnedOff == false\"><div class=\"round-bagde green\" uib-tooltip=\"{{ \'AlarmActivated.Text\' | translate }}\" ng-if=\"vm.shorepowerAlarm  == true && (vm.shorePowerSensorStatus.lowBattery == false && vm.shorePowerSensorStatus.missingBattery == false)\"></div><div class=\"round-bagde red\" uib-tooltip=\"{{ \'AlarmInactive.Text\' | translate }}e\" ng-if=\"vm.shorepowerAlarm  == false && (vm.shorePowerSensorStatus.lowBattery == false && vm.shorePowerSensorStatus.missingBattery == false)\"></div><div class=\"round-bagde gold\" uib-tooltip=\"{{ \'LowBattery.Text\' | translate }}\" ng-if=\"vm.shorePowerSensorStatus.lowBattery == true && vm.shorePowerSensorStatus.missingBattery == false\"></div><div class=\"round-bagde orange\" uib-tooltip=\"{{ \'MissingSensor.Text\' | translate }}\" ng-if=\"vm.shorePowerSensorStatus.missingBattery == true\"></div></div><div ng-if=\"vm.isDisArmed || vm.turnedOff\" class=\"round-bagde blue\" uib-tooltip=\"{{ \'Disarmed.Text\' | translate }}\"></div><a ui-sref=\"boat.shorepower_alarm({sentinelId: vm.currentSentinelId})\"><img src=assets/images/arrow.png class=\"card-icon pull-right\"></a></div><div ng-if=!vm.oemConfig.sp2Contacts.logo.show() class=\"col-sm-12 card small flex-card\" ui-sref=\"boat.temperature_alarm({sentinelId: vm.currentSentinelId})\"><label class=card-label>{{ \"Temperature.Text\" | translate }}</label><div ng-if=\"vm.turnedOff == false\"><div class=\"round-bagde green\" uib-tooltip=\"{{ \'AlarmActivated.Text\' | translate }}\" ng-if=\"vm.temperatureAlarm == true && (vm.temperaturSensorStatus.lowBattery == false && vm.temperaturSensorStatus.missingBattery == false)\"></div><div class=\"round-bagde red\" uib-tooltip=\"{{ \'AlarmInactive.Text\' | translate }}\" ng-if=\"vm.temperatureAlarm == false && (vm.temperaturSensorStatus.lowBattery == false && vm.temperaturSensorStatus.missingBattery == false)\"></div><div class=\"round-bagde gold\" uib-tooltip=\"{{ \'LowBattery.Text\' | translate }}\" ng-if=\"vm.temperaturSensorStatus.lowBattery == true && vm.temperaturSensorStatus.missingBattery == false\"></div><div class=\"round-bagde orange\" uib-tooltip=\"{{ \'MissingSensor.Text\' | translate }}\" ng-if=\"vm.temperaturSensorStatus.missingBattery == true\"></div></div><div ng-if=vm.turnedOff class=\"round-bagde blue\" uib-tooltip=\"{{ \'Disarmed.Text\' | translate }}\"></div><a ui-sref=\"boat.temperature_alarm({sentinelId: vm.currentSentinelId})\"><img src=assets/images/arrow.png class=\"card-icon pull-right\"></a></div><div ng-if=!vm.oemConfig.sp2Contacts.logo.show() class=\"col-sm-12 card small flex-card\" ui-sref=\"boat.high_water_alarm({sentinelId: vm.currentSentinelId})\"><label class=card-label>{{ \"HighWater.Text\" | translate }}</label><div ng-if=\"vm.turnedOff == false\"><div class=\"round-bagde green\" uib-tooltip=\"{{ \'AlarmActivated.Text\' | translate }}\" ng-if=\"vm.highWaterAlarm == true && (vm.highWaterSensorStatus.lowBattery == false && vm.highWaterSensorStatus.missingBattery == false)\"></div><div class=\"round-bagde red\" uib-tooltip=\"{{ \'AlarmInactive.Text\' | translate }}\" ng-if=\"vm.highWaterAlarm == false && (vm.highWaterSensorStatus.lowBattery == false && vm.highWaterSensorStatus.missingBattery == false)\"></div><div class=\"round-bagde gold\" uib-tooltip=\"{{ \'LowBattery.Text\' | translate }}\" ng-if=\"vm.highWaterSensorStatus.lowBattery == true && vm.highWaterSensorStatus.missingBattery == false\"></div><div class=\"round-bagde orange\" uib-tooltip=\"{{ \'MissingSensor.Text\' | translate }}\" ng-if=\"vm.highWaterSensorStatus.missingBattery == true\"></div></div><div ng-if=vm.turnedOff class=\"round-bagde blue\" uib-tooltip=\"{{ \'Disarmed.Text\' | translate }}\"></div><a ui-sref=\"boat.high_water_alarm({sentinelId: vm.currentSentinelId})\"><img src=assets/images/arrow.png class=\"card-icon pull-right\"></a></div></div></div><!--  --><!--  --><div class=col-sm-6><div class=bound-box><div class=\"col-sm-12 card small flex-card blank hidden-xs\"><label class=field>{{ \"Alarm.Text\" | translate }}</label><label class=field>{{ \"Status2.Text\" | translate }}</label></div><div ng-if=!vm.oemConfig.sp2Contacts.logo.show() class=\"col-sm-12 card small flex-card\" ui-sref=\"boat.motion_detector_alarm({sentinelId: vm.currentSentinelId})\"><label class=card-label>{{ \"MotionDetection.Text\" | translate }}</label><div ng-if=\"!vm.isDisArmed && vm.turnedOff == false\"><div class=\"round-bagde green\" uib-tooltip=\"{{ \'AlarmActivated.Text\' | translate }}\" ng-if=\"vm.motionDetectionAlarm == true && (vm.pirSensorStatus.lowBattery == false && vm.pirSensorStatus.missingBattery == false)\"></div><div class=\"round-bagde red\" uib-tooltip=\"{{ \'AlarmInactive.Text\' | translate }}\" ng-if=\"vm.motionDetectionAlarm == false && (vm.pirSensorStatus.lowBattery == false && vm.pirSensorStatus.missingBattery == false)\"></div><div class=\"round-bagde gold\" uib-tooltip=\"{{ \'LowBattery.Text\' | translate }}\" ng-if=\"vm.pirSensorStatus.lowBattery == true && vm.pirSensorStatus.missingBattery == false\"></div><div class=\"round-bagde orange\" uib-tooltip=\"{{ \'MissingSensor.Text\' | translate }}\" ng-if=\"vm.pirSensorStatus.missingBattery == true\"></div></div><div ng-if=\"vm.isDisArmed || vm.turnedOff\" class=\"round-bagde blue\" uib-tooltip=\"{{ \'Disarmed.Text\' | translate }}\"></div><a ui-sref=\"boat.motion_detector_alarm({sentinelId: vm.currentSentinelId})\"><img src=assets/images/arrow.png class=\"card-icon pull-right\"></a></div><div ng-if=!vm.oemConfig.sp2Contacts.logo.show() class=\"col-sm-12 card small flex-card\" ui-sref=\"boat.door_alarm({sentinelId: vm.currentSentinelId})\"><label class=card-label>{{ \"Door.Text\" | translate }}</label><div ng-if=\"!vm.isDisArmed && vm.turnedOff == false\"><div class=\"round-bagde red\" uib-tooltip=\"{{ \'AlarmInactive.Text\' | translate }}\" ng-if=\"vm.doorAlarm == false && (vm.vibrationSensorStatus.lowBattery == false && vm.vibrationSensorStatus.missingBattery == false)\"></div><div class=\"round-bagde green\" uib-tooltip=\"{{ \'AlarmActivated.Text\' | translate }}\" ng-if=\"vm.doorAlarm == true && (vm.vibrationSensorStatus.lowBattery == false && vm.vibrationSensorStatus.missingBattery == false)\"></div><div class=\"round-bagde gold\" uib-tooltip=\"{{ \'LowBattery.Text\' | translate }}\" ng-if=\"(vm.vibrationSensorStatus.lowBattery == true && vm.vibrationSensorStatus.missingBattery == false)\"></div><div class=\"round-bagde orange\" uib-tooltip=\"{{ \'MissingSensor.Text\' | translate }}\" ng-if=\"vm.vibrationSensorStatus.missingBattery == true\"></div></div><div ng-if=\"vm.isDisArmed || vm.turnedOff\" class=\"round-bagde blue\" uib-tooltip=\"{{ \'Disarmed.Text\' | translate }}\"></div><a ui-sref=\"boat.door_alarm({sentinelId: vm.currentSentinelId})\"><img src=assets/images/arrow.png class=\"card-icon pull-right\"></a></div><div class=\"col-sm-12 card small flex-card\" ui-sref=\"boat.shock_alarm({sentinelId: vm.currentSentinelId})\"><label class=card-label>{{ \"Shock.Text\" | translate }}</label><div ng-if=\"vm.turnedOff == false\"><div class=\"round-bagde green\" uib-tooltip=\"{{ \'AlarmActivated.Text\' | translate }}\" ng-if=\"vm.shockAlarm == true && (vm.vibrationSensorStatus.lowBattery == false && vm.vibrationSensorStatus.missingBattery == false)\"></div><div class=\"round-bagde red\" uib-tooltip=\"{{ \'AlarmInactive.Text\' | translate }}\" ng-if=\"vm.shockAlarm == false && (vm.vibrationSensorStatus.lowBattery == false && vm.vibrationSensorStatus.missingBattery == false)\"></div><div class=\"round-bagde gold\" uib-tooltip=\"{{ \'LowBattery.Text\' | translate }}\" ng-if=\"(vm.vibrationSensorStatus.lowBattery == true && vm.vibrationSensorStatus.missingBattery == false)\"></div><div class=\"round-bagde orange\" uib-tooltip=\"{{ \'MissingSensor.Text\' | translate }}\" ng-if=\"vm.vibrationSensorStatus.missingBattery == true\"></div></div><div ng-if=vm.turnedOff class=\"round-bagde blue\" uib-tooltip=\"{{ \'Disarmed.Text\' | translate }}\"></div><a ui-sref=\"boat.shock_alarm({sentinelId: vm.currentSentinelId})\"><img src=assets/images/arrow.png class=\"card-icon pull-right\"></a></div><div class=\"col-sm-12 card small flex-card\" ui-sref=\"boat.tilt_alarm({sentinelId: vm.currentSentinelId})\"><label class=card-label>{{ \"Tilt.Text\" | translate }}</label><div ng-if=\"!vm.isDisArmed && vm.turnedOff == false\"><div class=\"round-bagde green\" uib-tooltip=\"{{ \'AlarmActivated.Text\' | translate }}\" ng-if=\"vm.tiltAlarm == true && (vm.tiltSensorStatus.lowBattery == false && vm.tiltSensorStatus.missingBattery == false)\"></div><div class=\"round-bagde red\" uib-tooltip=\"{{ \'AlarmInactive.Text\' | translate }}\" ng-if=\"vm.tiltAlarm == false && (vm.tiltSensorStatus.lowBattery == false && vm.tiltSensorStatus.missingBattery == false)\"></div><div class=\"round-bagde gold\" uib-tooltip=\"{{ \'LowBattery.Text\' | translate }}\" ng-if=\"(vm.tiltSensorStatus.lowBattery == true && vm.tiltSensorStatus.missingBattery == false)\"></div><div class=\"round-bagde orange\" uib-tooltip=\"{{ \'MissingSensor.Text\' | translate }}\" ng-if=\"vm.tiltSensorStatus.missingBattery == true\"></div></div><div ng-if=\"vm.isDisArmed || vm.turnedOff\" class=\"round-bagde blue\" uib-tooltip=\"{{ \'Disarmed.Text\' | translate }}\"></div><a ui-sref=\"boat.tilt_alarm({sentinelId: vm.currentSentinelId})\"><img src=assets/images/arrow.png class=\"card-icon pull-right\"></a></div><div ng-if=vm.oemConfig.sp2Contacts.logo.show() class=\"col-sm-12 card small flex-card\" ui-sref=\"boat.temperature_alarm({sentinelId: vm.currentSentinelId})\"><label class=card-label>{{ \"Temperature.Text\" | translate }}</label><div ng-if=\"vm.turnedOff == false\"><div class=\"round-bagde green\" uib-tooltip=\"{{ \'AlarmActivated.Text\' | translate }}\" ng-if=\"vm.temperatureAlarm == true && (vm.temperaturSensorStatus.lowBattery == false && vm.temperaturSensorStatus.missingBattery == false)\"></div><div class=\"round-bagde red\" uib-tooltip=\"{{ \'AlarmInactive.Text\' | translate }}\" ng-if=\"vm.temperatureAlarm == false && (vm.temperaturSensorStatus.lowBattery == false && vm.temperaturSensorStatus.missingBattery == false)\"></div><div class=\"round-bagde gold\" uib-tooltip=\"{{ \'LowBattery.Text\' | translate }}\" ng-if=\"vm.temperaturSensorStatus.lowBattery == true && vm.temperaturSensorStatus.missingBattery == false\"></div><div class=\"round-bagde orange\" uib-tooltip=\"{{ \'MissingSensor.Text\' | translate }}\" ng-if=\"vm.temperaturSensorStatus.missingBattery == true\"></div></div><div ng-if=vm.turnedOff class=\"round-bagde blue\" uib-tooltip=\"{{ \'Disarmed.Text\' | translate }}\"></div><a ui-sref=\"boat.temperature_alarm({sentinelId: vm.currentSentinelId})\"><img src=assets/images/arrow.png class=\"card-icon pull-right\"></a></div><!-- <div ng-if=\"!vm.oemConfig.sp2Contacts.logo.show()\" class=\"col-sm-12 card small flex-card\"\r\n          ui-sref=\"boat.item_security_alarm({sentinelId: vm.currentSentinelId})\">\r\n          <label class=\"card-label\">{{\r\n            \"ItemSecurity.Text\" | translate\r\n          }}</label>\r\n          <div ng-if=\"!vm.isDisArmed && vm.turnedOff == false\">\r\n            <div class=\"round-bagde green\" uib-tooltip=\"{{ \'AlarmActivated.Text\' | translate }}\"\r\n              ng-if=\"vm.itemSecurityAlarm == true && (vm.beaconSensorStatus.lowBattery == false && vm.beaconSensorStatus.missingBattery == false)\">\r\n            </div>\r\n            <div class=\"round-bagde red\" uib-tooltip=\"{{ \'AlarmInactive.Text\' | translate }}\"\r\n              ng-if=\"vm.itemSecurityAlarm == false && (vm.beaconSensorStatus.lowBattery == false && vm.beaconSensorStatus.missingBattery == false)\">\r\n            </div>\r\n            <div class=\"round-bagde gold\" uib-tooltip=\"{{ \'LowBattery.Text\' | translate }}\"\r\n              ng-if=\"(vm.beaconSensorStatus.lowBattery == true && vm.beaconSensorStatus.missingBattery == false)\"></div>\r\n            <div class=\"round-bagde orange\" uib-tooltip=\"{{ \'MissingSensor.Text\' | translate }}\"\r\n              ng-if=\"vm.beaconSensorStatus.missingBattery == true\"></div>\r\n          </div>\r\n          <div ng-if=\"vm.isDisArmed || vm.turnedOff\" class=\"round-bagde blue\"\r\n            uib-tooltip=\"{{ \'Disarmed.Text\' | translate }}\"></div>\r\n          <a ui-sref=\"boat.item_security_alarm({sentinelId: vm.currentSentinelId})\">\r\n            <img src=\"assets/images/arrow.png\" class=\"card-icon pull-right\" />\r\n          </a>\r\n        </div> --></div></div></div><!--  --><div class=row><div class=col-sm-6><div class=bound-box><div class=\"col-sm-12 card small flex-card\"><div class=my-legend><div class=legend-scale><ul class=legend-labels><li><span class=\"badge green\"></span> <b>{{ \"Active.Text\" | translate }}</b></li><li><span class=\"badge red\"></span> <b>{{ \"Inactive.Text\" | translate }}</b></li><li><span class=\"badge blue\"></span> <b>{{ \"Disarmed.Text\" | translate }}</b></li><li><span class=\"badge gold\"></span> <b>{{ \"LowBattery.Text\" | translate }}</b></li><li><span class=\"badge orange\"></span> <b>{{ \"MissingSensor.Text\" | translate }}</b></li></ul></div></div></div></div></div></div></div>");
$templateCache.put("app/main/account-settings/accountSettings.html","<form name=form novalidate=\"\" ng-submit=\"form.$valid && vm.updateAccount(form)\"><div class=col-sm-6><div class=bound-box><div class=\"col-sm-12 card small\"><label class=field>{{\'ChangeLanguage.Text\'| translate}}</label><select ng-model=vm.lang><option value=en>English</option><option value=fr>Français</option><option value=sp>Español</option></select></div></div><div class=bound-box><div class=\"col-sm-12 card small\"><label class=field>{{\'Notifications.Text\'| translate}}</label><div class=round><input style=\"visibility: hidden !important\" type=checkbox id=round ng-model=vm.user.recieveEmails><label for=round></label></div><label for=round class=\"card-label fp\" style=\"width: 80%;padding-top: 5px\">{{\'ReceiveEmailNotifications.Text\'| translate}}</label></div></div><div class=bound-box><label class=field>{{\'ChangeAccountDetails.Text\'| translate}}</label><div class=\"col-sm-12 card small\"><label class=\"card-label fp\">{{\'NameFull.Text\'| translate}}</label><input class=active type=text name=full_name ng-model=vm.user.fullName><div ng-messages=form.full_name.$error ng-if=form.$submitted class=error><div ng-message=required>{{ \"FullName.Required\" | translate }}</div></div></div><div class=\"col-sm-12 card small\"><label class=\"card-label fp\">{{\'Email.Text\'| translate}}</label><input class=active type=email name=email_address ng-model=vm.user.emailAddress><div ng-messages=form.email.$error ng-if=form.$submitted class=error><div ng-message=email>{{\'ValidEmail.Text\'| translate}}.</div></div></div><div class=\"col-sm-12 card small\"><label class=\"card-label fp\">{{\'RepeatEmail.Text\'| translate}}</label><input class=active type=email ui-validate=\"{match: \'$value === vm.user.emailAddress\'}\" name=repeatEmail ng-required=\"(vm.user.emailAddress && vm.user.emailAddress != \'\')\" ng-model=vm.user.repeatEmail><div ng-messages=form.repeatEmail.$error ng-if=form.$submitted class=error><div ng-message=required>{{\'RepeatEmailRequired.Text\'| translate}}.</div><div ng-message=email>{{\'ValidEmail.Text\'| translate}}.</div><div ng-message=match>{{\'RepeatEmailDoesntMatch.Text\'| translate}}.</div></div></div><div class=\"col-sm-12 card small\" style=\"z-index: 2\" ng-if=vm.oemConfig.accountSettings.country.show()><label class=\"card-label fp\">{{\'Country.Text\'| translate}}</label><div isteven-multi-select input-model=vm.countries output-model=vm.user.selectedCountry button-label=name item-label=name tick-property=ticked selection-mode=single></div></div><div class=\"col-sm-12 card small\" ng-if=vm.oemConfig.accountSettings.address.show()><label class=\"card-label fp\">{{\'Address.Text\'| translate}}</label><textarea class=active rows=4 type=text name=address ng-model=vm.user.address></textarea></div><div class=\"col-sm-12 card small\" ng-if=vm.oemConfig.accountSettings.city.show()><label class=\"card-label fp\">{{\'City.Text\'| translate}}</label><input class=active type=text name=city ng-model=vm.user.city></div></div></div><!--  --><!--  --><div class=col-sm-6><div class=bound-box><label class=field>{{\'ChangePassword.Text\'| translate}}</label><div class=\"col-sm-12 card small\"><label class=\"card-label fp\">{{\'OldPassword.Text\'| translate}}</label><input class=active type=password name=old_password ng-model=vm.user.oldPassword></div><div class=\"col-sm-12 card small\"><label class=\"card-label fp\">{{\'NewPassword.Text\'| translate}}</label><input class=active type=password ng-pattern=\"/^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/\" ng-class=\"{error: form.$submitted && form.new_password.$invalid}\" name=new_password ng-required=\"(vm.user.oldPassword && vm.user.oldPassword != \'\')\" ng-model=vm.user.newPassword ng-maxlength=16 ng-keyup=vm.onPasswordChange($event)><div ng-messages=form.new_password.$error ng-if=form.$submitted class=error><div ng-message=required>{{\'NewPasswordRequired.Text\'| translate}}.</div><div ng-message=maxlength>{{\'PasswordLess.Text\'| translate}}</div></div><div><ul class=password__validation__status><li ng-class=\"{\'ok\': vm.passwordValidationStatus.minLength == true}\"><i class=\"fa fa-times-circle\" ng-if=!vm.passwordValidationStatus.minLength aria-hidden=true></i> <i class=\"fa fa-check-circle-o\" ng-if=vm.passwordValidationStatus.minLength aria-hidden=true></i> <span>{{\'PasswordValidation.MinLength\' | translate}}</span></li><li ng-class=\"{\'ok\': vm.passwordValidationStatus.lowerCase == true}\"><i class=\"fa fa-times-circle\" ng-if=!vm.passwordValidationStatus.lowerCase aria-hidden=true></i> <i class=\"fa fa-check-circle-o\" ng-if=vm.passwordValidationStatus.lowerCase aria-hidden=true></i> <span>{{\'PasswordValidation.LowerCase\' | translate}}</span></li><li ng-class=\"{\'ok\': vm.passwordValidationStatus.upperCase == true}\"><i class=\"fa fa-times-circle\" ng-if=!vm.passwordValidationStatus.upperCase aria-hidden=true></i> <i class=\"fa fa-check-circle-o\" ng-if=vm.passwordValidationStatus.upperCase aria-hidden=true></i> <span>{{\'PasswordValidation.UpperCase\' | translate}}</span></li><li ng-class=\"{\'ok\': vm.passwordValidationStatus.number == true}\"><i class=\"fa fa-times-circle\" ng-if=!vm.passwordValidationStatus.number aria-hidden=true></i> <i class=\"fa fa-check-circle-o\" ng-if=vm.passwordValidationStatus.number aria-hidden=true></i> <span>{{\'PasswordValidation.Number\' | translate}}</span></li></ul></div></div><div class=\"col-sm-12 card small\"><label class=\"card-label fp\">{{\'RepeatNewPassword.Text\'| translate}}</label><input class=active type=password name=repeatPassword confirm-pwd=vm.user.newPassword ng-required=\"(vm.user.newPassword && vm.newPassword != \'\')\" ng-model=vm.user.confirmPassword ng-required=vm.user.changePassword ng-class=\"{error: form.$valid && form.repeatPassword.$invalid}\" ng-maxlength=16 ng-minlength=6><div ng-messages=form.repeatPassword.$error ng-if=\"form.$submitted && form.repeatPassword.$touched\" class=error><div ng-message=\"required \">{{\'RepeatPasswordRequired.Text\'| translate}}</div><div ng-message=\"minlength \">{{\'PasswordMore.Text\'| translate}}</div><div ng-message=\"maxlength \">{{\'PasswordLess.Text\'| translate}}</div><div ng-message=\"password \">{{\'PasswordDoesntMatch.Text\'| translate}}</div></div></div><div class=\"col-sm-12 card small\" flow-init=vm.flow flow-files-submitted=$flow.upload() flow-complete=vm.onUploadComplete() flow-upload-started=vm.onUploadStarted() flow-file-success=\"vm.boatImageSuccess($file, $message, $flow)\"><div pg-form-group class=\"form-group form-group-default\"><input type=file id=boat_image flow-btn><label for=boat_image flow-btn>{{\'ChangeHomeBoatImage.Text\'| translate}}</label></div></div><div class=\"col-sm-12 card small\" flow-init=vm.flowProfile flow-files-submitted=$flow.upload() flow-complete=vm.onUploadComplete() flow-upload-started=vm.onUploadStarted() flow-file-success=\"vm.profileImageSuccess($file, $message, $flow)\"><div pg-form-group class=\"form-group form-group-default\"><img class=pic style=\"width: 80px;height: 80px\" ng-src=\"{{vm.url}}{{vm.user.profilePicture}}?access_token={{vm.access_token}}\"> <input type=file id=boat_image flow-btn><label for=boat_image flow-btn>{{\'ChangeProfileImage.Text\'| translate}}</label></div></div><div class=\"col-sm-12 card small\" ng-if=vm.oemConfig.accountSettings.phone.show()><label class=\"card-label fp\">{{\'MobileNumber.Text\'| translate}}</label><input type=text maxlength=50 name=mobile_number ng-model=vm.user.mobileNumber><div ng-messages=form.mobile_number.$error ng-if=form.$submitted class=error><div ng-message=required>{{ \"MobileNumber.Required\" | translate }}</div></div></div><div class=\"col-sm-12 card small\" ng-if=vm.oemConfig.accountSettings.port.show()><label class=\"card-label fp\">{{\'HomePort.Text\'| translate}}</label><input class=active type=text name=homePort ng-model=vm.user.homePort></div><div class=\"col-sm-12 card small\" ng-if=vm.oemConfig.accountSettings.zip.show()><label class=\"card-label fp\">{{\'ZipCode.Text\'| translate}}</label><input class=active type=text name=zip ng-model=vm.user.zipCode></div></div></div><!--  --><div class=\"col-sm-12 mid\"><button type=\"submit \" class=\"oval-btn blue\">{{\'SaveChanges.Text\'| translate}}</button></div></form>");
$templateCache.put("app/main/account-settings/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.accountSettings.logo.show() ng-src={{vm.oemConfig.accountSettings.logo.image}} class=symbol><h2 class=red-border-bottom>{{\'AccountSettings.Text\'| translate}}</h2></div>");
$templateCache.put("app/main/change-email/change-email.html","<form name=form novalidate ng-submit=\"form.$valid && vm.changeEmail()\"><div class=login-form><div class=main><div class=\"col-sm-12 center-align\"><h1>Change Email</h1></div><div class=\"col-sm-6 col-xs-12 card-slim content-box\"><label class=field>New Email</label><label class=field>{{vm.queryString.newEmailAddress}}</label></div><div class=\"col-sm-6 col-xs-12 card-slim content-box\"><label class=field>Password</label><input placeholder=\"Enter password\" type=password required type=password name=password ng-model=vm.account.password ng-class=\"{\'error\': form.$submitted && form.password.$invalid}\"><div ng-messages=\"form.password.$error && form.password.$touched\" ng-if=\"form.$submitted \" class=error><div ng-message=\"required \">Password is required</div></div></div><div class=\"col-sm-12 card-slim\"><button type=\"submit \" class=\"oval-btn full red\">Login</button></div></div></div></form>");
$templateCache.put("app/main/change-language/index.html","<form name=form novalidate ng-submit=\"form.$valid && vm.changeLanguage()\"><div class=login-form><div class=\"col-sm-12 header\"><div class=col-sm-6><a ui-sref=landing_page><img ng-src={{vm.oemConfig.changeLanguage.logo}} class=logo-icon></a><a ng-click=vm.goBack()><img src=assets/images/back.png class=back-btn></a></div></div><div class=main><div class=\"col-sm-12 single-column\"><div class=center><h1>{{\'ChangeLanguage.Text\' | translate}}</h1><div class=\"card-slim col-xs-12\"><label class=field>{{\'SelectLanguage.Text\' | translate}}</label><select ng-model=vm.lang><option value=en>English</option><option value=fr>Français</option><option value=sp>Español</option></select></div><div class=\"card-slim col-xs-12\"><button class=\"oval-btn full red\" type=submit>{{\'Ok.Text\' | translate}}</button></div></div></div></div></div></form>");
$templateCache.put("app/main/common/app.html","<div ng-include=\"\'app/main/common/side-menu.html\'\"></div><div class=content-area id=main><div ng-include=\"\'app/main/common/header.html\'\" ng-click=\"vm.isCollapsed = true\"></div><div ui-view=extra_header></div><div class=main hide-main-content><div class=main-box><div ui-view=content></div></div></div><div ng-include=\"\'app/main/common/footer.html\'\"></div></div>");
$templateCache.put("app/main/common/error-box-dialog.html","<div class=modal-content><div class=modal-body><img src=assets/images/sos2.png><h3>{{\'NoSensors.Text\'| translate}}</h3><a target=_blank ng-if=\"vm.buyNowLink!=null\" ng-href={{vm.buyNowLink}}>{{\'BuyNow.Text\'| translate}}</a> <a href=\"\" ng-click=$dismiss()>{{\'Cancel.Text\'| translate}}</a></div></div><!-- modal-content -->");
$templateCache.put("app/main/common/footer.html","<div class=\"content-section footer\" id=buttons><div class=col-md-12><div style=\"position: fixed;bottom: 65px;margin-left: -15px;z-index: 99999;width: 100%;background: #003055;text-align: center\" ng-if=\"vm.isCameraOnly && !vm.isHomeOrCameraState\"><span style=\"color:red;font-size: 20px;font-weight: 500\">{{ \"Footer.SampleDataMessage\" | translate }}</span></div><div style=\"position: fixed;bottom: 65px;margin-left: -15px;z-index: 99999;width: 100%;background: red;text-align: center\" ng-if=!vm.user.agreed><span style=\"color:#fff;font-size: 20px;font-weight: 500;background-color:red\" translate=\"{{ \'Footer.FillUserDetailsFormMessage\' }}\"></span></div><div id=accordion><div class=\"panel panel-default\"><div class=panel-heading><a ui-sref=\"boat.home({sentinelId: vm.currentSentinel.id})\"><img ng-src={{vm.oemConfig.footer.logo}}></a><h4 class=panel-title><a href=\"\" ng-click=\"vm.isCollapsed = !vm.isCollapsed\">{{ vm.currentSentinel.name }} <img src=assets/images/caret-down.png></a></h4><!-- drop up --><div><div class=\"btn-group navbar-right footer-setting\" uib-dropdown><img ng-src={{vm.oemConfig.footer.settings}} class=dropdown-toggle uib-dropdown-toggle ng-click=\"vm.isCollapsed = true\"><ul class=\"dropdown-menu drop-up\" role=menu uib-dropdown-menu><li><a ui-sref=\"boat.accountSettings({sentinelId: vm.sentinelId})\">{{ \"Footer.AccountSettings\" | translate }}</a></li><li><a ui-sref=\"boat.manage_boats({sentinelId: vm.sentinelId})\">{{ vm.oemConfig.footer.menu.manageBoats() | translate }}</a></li><li><a ui-sref=\"boat.metrics({sentinelId: vm.sentinelId})\">{{ \"Footer.Metrics\" | translate }}</a></li><!-- <li>\r\n                  <a ui-sref=\"boat.documents({sentinelId: vm.sentinelId})\">{{\r\n                    \"Footer.ManageDocuments\" | translate\r\n                  }}</a>\r\n                </li> --><!--<li><a ui-sref=\"boat.sharedUsers\">manage shared users</a></li>--><li><a style=\"cursor: pointer\" ng-click=vm.logout()>{{ \"Footer.Logout\" | translate }}</a></li></ul></div><div class=\"btn-group navbar-right\" uib-dropdown><img ng-src={{vm.oemConfig.footer.help}} class=dropdown-toggle uib-dropdown-toggle ng-click=\"vm.isCollapsed = true\"><ul class=\"dropdown-menu drop-up\" role=menu uib-dropdown-menu><li ng-if=vm.forumEnabled><a ui-sref=\"forum({sentinelId: vm.sentinelId})\">{{ \"Footer.Forum\" | translate }}</a></li><li><a ui-sref=tutorial>{{ \"Footer.Tutorial\" | translate }}</a></li><li ng-if=vm.oemConfig.faq.show()><a target=_blank href=https://yacht-sentinel.freshdesk.com/support/solutions>FAQ</a></li><li ng-if=vm.oemConfig.tutorialVideo.show()><a target=_blank href=https://yacht-sentinel.freshdesk.com/support/solutions/folders/44000849691>{{ \"Footer.TutorialVideos\" | translate }}</a></li><!-- Distributor Link Added --><li ng-if=vm.status><a ui-sref=\"boat.distributor_map({sentinelId: vm.sentinelId})\">{{ \"Footer.DistributorMap\" | translate }}</a></li><li ng-if=vm.oemConfig.contactUs.footer.show()><a ui-sref=boat.contactUs>{{ \"Footer.ContactUs\" | translate }}</a></li><li ng-if=vm.isChatSupported><a ng-click=vm.goToHelpCenter()>{{ \"Footer.HelpCenter\" | translate }}</a></li></ul></div></div><!-- drop up --></div><div uib-collapse=vm.isCollapsed class=\"panel-collapse collapse\"><div class=panel-body ng-scrollbars ng-scrollbars-config=vm.config><!-- change yacht --><div class=container><div class=row><div class=col-md-4 ng-repeat=\"s in vm.sentinels track by $index\"><span class=action-tab ng-class=\"{\'filled\' : s.id == vm.currentSentinel.id}\"><a ui-sref=\"boat.home({sentinelId: s.id})\" ng-click=\"vm.isCollapsed = true; vm.currentSentinel = s; vm.sentinelSeleted(s)\"><span>{{ $index + 1 }}</span><p class=boat-name-trimmed style=\"overflow: hidden;\r\n                      white-space: nowrap;\r\n                      text-overflow: ellipsis;\r\n                      width: 180px\">{{ s.name }}</p><img ng-if=\"s.id != vm.currentSentinel.id\" src=assets/images/empty-radio.png> <img ng-if=\"s.id == vm.currentSentinel.id\" src=assets/images/radio.png></a></span></div></div></div><!-- change yacht --></div></div></div></div></div></div>");
$templateCache.put("app/main/common/header.html","<div header-class><div class=\"col-sm-6 mobile-header\"><a ui-sref=\"boat.home({sentinelId: vm.sentinelId})\"><img ng-src={{vm.oemConfig.header.logo}} class=logo-icon></a><a ng-if=\"vm.showMobileHeader == true\" ng-click=vm.goBack()><img src=assets/images/back.png class=back-btn></a><h3 ng-if=\"vm.showMobileHeader == true\" class=header-text>{{vm.title| translate}} {{vm.navigation.backState}}</h3><a ng-if=\"vm.showMobileHeader == true\" ng-click=vm.toggleSideNav() class=header-nav-menu-icon><i class=\"fa fa-bars\" style=\"font-size: 30px;\r\n      padding: 5px\"></i></a></div><div class=col-sm-6 style=z-index:99><div class=\"pull-right top-menu\"><a ng-click=vm.toggleSideNav() style=\"color: white;text-decoration: none;padding: 10px\"><i class=\"fa fa-bars\" style=\"font-size: 30px;\r\n        padding: 5px\"></i> </a><a ui-sref=\"boat.weather({sentinelId: vm.sentinelId})\" style=\"display: inline-block\"><img ng-src={{vm.oemConfig.header.weather}} class=weather-icon><div class=weather-details>{{vm.weatherDetails.feelsLike |number:0}}&deg;</div></a><a ui-sref=\"boat.notifications({sentinelId: vm.sentinelId})\" style=\"display: inline-block\"><img ng-src={{vm.oemConfig.header.notification}} class=notifiation-icon> <span ng-if=\"vm.notificationCount <= 10\" class=notification-details>{{vm.notificationCount}}</span> <span ng-if=\"vm.notificationCount > 10\" class=notification-details style=\"font-size: 12px;height:20px;width: 30px\">10+</span></a></div></div><div ui-view=header></div></div>");
$templateCache.put("app/main/common/side-menu.html","<div id=mySidenav class=sidenav><a href=javascript:void(0) class=closebtn ng-click=vm.closeNav()>&times;</a> <a ui-state=vm.dashboardUrl.state ui-state-params=vm.dashboardUrl.params ng-click=vm.closeNav()><p ng-if=!vm.oemConfig.sp2Contacts.logo.show()>{{ \"Dashboard.Text\" | translate }}</p><p ng-if=vm.oemConfig.sp2Contacts.logo.show()>{{ \"BoatStatus.Text\" | translate }}</p></a><a ui-state=vm.alarmsUrl.state ui-state-params=vm.alarmsUrl.params ng-click=vm.closeNav()><p>{{ \"Alarms.Text\" | translate }}</p></a><a ui-state=vm.mapUrl.state ui-state-params=vm.mapUrl.params ng-click=vm.closeNav()><p>{{ \"Map.Text\" | translate }}</p></a><a ui-state=vm.journeyLogUrl.state ui-state-params=vm.journeyLogUrl.params ng-click=vm.closeNav()><p>{{ \"JourneyLog.Text\" | translate }}</p></a><a ng-if=vm.oemConfig.camera.content.show() ui-sref=\"boat.cameras({sentinelId: vm.sentinelId})\" ng-click=vm.closeNav()><p>{{ \"Cameras.Text\" | translate }}</p></a><a ng-if=vm.oemConfig.contacts.content.show() ng-click=vm.chooseContactsPage()><p>{{ \"Contacts.Text\" | translate }}</p></a></div>");
$templateCache.put("app/main/contact-us/contactUs.html","<!--  --><div class=col-sm-6><div class=bound-box><label class=field>Address</label><div class=\"col-sm-12 card small\"><label class=\"details red\">{{vm.oemConfig.contactUs.address[0]}}</label><label class=details>{{vm.oemConfig.contactUs.address[1]}}</label><p ng-bind-html=vm.oemConfig.contactUs.address[2]></p></div></div></div><!--  --><!--  --><div class=col-sm-6><div class=bound-box><label class=field>Email</label><div class=\"col-sm-12 card small\"><label class=details><a href=mailto:{{vm.oemConfig.contactUs.email}}>{{vm.oemConfig.contactUs.email}}</a></label></div></div><div class=bound-box><label class=field>Phone</label><div class=\"col-sm-12 card small\"><label class=details><a href=callto:{{vm.oemConfig.contactUs.phone}}>{{vm.oemConfig.contactUs.phone}}</a></label></div></div></div><!--  -->");
$templateCache.put("app/main/contact-us/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.contactUs.logo.show() ng-src={{vm.oemConfig.contactUs.logo.image}} class=symbol><h2>Contact us</h2></div>");
$templateCache.put("app/main/contacts/contacts.html","<div class=\"col-sm-6 col-xs-12\" ng-repeat=\"c in vm.contacts.list\" ng-click=vm.editContactDialog(c)><div class=bound-box><div class=\"col-sm-12 card contact-card\"><label class=field>{{\'Name.Text\'| translate}}</label><label class=card-label>{{c.name}}</label><label class=field>{{\'Email.Text\'| translate}}</label><label class=card-label>{{c.emailAddress}}</label><label class=field>{{\'Phone.Text\'| translate}}</label><label class=card-label>({{c.countryCode}}) {{c.phoneNumber}}</label></div></div></div>");
$templateCache.put("app/main/contacts/edit-contact-dialog.html","<form novalidate=\"\" ng-submit=\"form.$valid && vm.editContact()\" name=form><div class=modal-content><div class=modal-header><button class=close type=button ng-click=$dismiss()>x</button><h3 class=modal-title>{{\'EditContact.Text\'| translate}}</h3></div><div class=modal-body><div class=full-width><div class=content-box style=\"width: 75%\"><label class=field>{{\'Name.Text\'| translate}}</label><input placeholder=\"Enter name\" type=text required name=name maxlength=50 ng-model=vm.contact.name ng-class=\"{\'error\': form.$submitted && form.name.$invalid}\"><div ng-messages=form.name.$error ng-if=form.$submitted class=error><div ng-message=required>{{\'NameRequired.Text\'| translate}}.</div></div><label class=field>{{\'Email.Text\'| translate}}</label><input placeholder=\"Enter email\" type=email required name=email maxlength=50 ng-model=vm.contact.emailAddress ng-class=\"{\'error\': form.$submitted && form.email.$invalid}\"><div ng-messages=form.email.$error ng-if=form.$submitted class=error><div ng-message=required>{{\'EmailRequired.Text\'| translate}}.</div><div ng-message=email>{{\'ValidEmail.Text\'| translate}}.</div></div><label class=field>{{\'Country.Text\'| translate}}</label><div isteven-multi-select input-model=vm.countries output-model=vm.contact.selectedCountry button-label=\"name dial_code\" item-label=\"name dial_code\" tick-property=selected selection-mode=single></div><label class=field>{{\'Phone.Text\'| translate}}</label><input placeholder=\"Enter phone number\" type=text required name=phone_number ng-maxlength=15 ng-minlength=7 ng-model=vm.contact.phoneNumber ng-class=\"{\'error\': form.$submitted && form.phone_number.$invalid}\"><div ng-messages=form.phone_number.$error ng-if=form.$submitted class=error><div ng-message=required>{{\'PhoneRequired.Text\'| translate}}.</div><div ng-message=minlength>{{\'PhoneMore.Text\'| translate}}</div><div ng-message=maxlength>{{\'PhoneLess.Text\'| translate}}</div></div><button type=submit class=\"oval-btn red text-center\">{{\'UpdateContact.Text\'| translate}}</button> <button type=button ng-click=vm.deleteContact(vm.contact) class=\"oval-btn red text-center\">{{\'DeleteContact.Text\'| translate}}</button> <a class=link ng-click=$dismiss() type=button>{{\'Cancel.Text\'| translate}}</a></div></div></div></div></form>");
$templateCache.put("app/main/contacts/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.contacts.logo.show() ng-src={{vm.oemConfig.contacts.logo.image}} class=symbol><h2>{{\'Contacts.Text\'| translate}}</h2><button ng-click=vm.newContactDialog() class=\"oval-btn red\">+ {{\'AddContact.Text\'| translate}}</button></div>");
$templateCache.put("app/main/contacts/new-contact-dialog.html","<form novalidate=\"\" ng-submit=\"form.$valid && vm.saveContact()\" name=form><div class=modal-content><div class=modal-header><button class=close type=button ng-click=$dismiss()>x</button><h3 class=modal-title>{{\'AddContact.Text\'| translate}}</h3></div><div class=modal-body><div class=full-width><div class=content-box style=\"width: 75%\"><label class=field>{{\'Name.Text\'| translate}}</label><input placeholder=\"{{\'Name.Text\'| translate}}\" type=text required name=name maxlength=50 ng-model=vm.contact.name ng-class=\"{\'error\': form.$submitted && form.name.$invalid}\"><div ng-messages=form.name.$error ng-if=form.$submitted class=error><div ng-message=required>{{\'NameRequired.Text\'| translate}}.</div></div><label class=field>{{\'Email.Text\'| translate}}</label><input placeholder=\"{{\'Email.Text\'| translate}}\" type=email required name=email maxlength=50 ng-model=vm.contact.emailAddress ng-class=\"{\'error\': form.$submitted && form.email.$invalid}\"><div ng-messages=form.email.$error ng-if=form.$submitted class=error><div ng-message=required>{{\'EmailRequired.Text\'| translate}}.</div><div ng-message=email>{{\'ValidEmail.Text\'| translate}}.</div></div><label class=field>{{\'Country.Text\'| translate}}</label><div isteven-multi-select input-model=vm.countries output-model=vm.contact.selectedCountry button-label=\"name dial_code\" item-label=\"name dial_code\" tick-property=ticked selection-mode=single></div><label class=field>{{\'Phone.Text\'| translate}}</label><input placeholder=\"Enter phone number\" type=text name=phone_number ng-maxlength=15 ng-minlength=7 ng-model=vm.contact.phoneNumber ng-class=\"{\'error\': form.$submitted && form.phone_number.$invalid}\"><div ng-messages=form.phone_number.$error ng-if=form.$submitted class=error><div ng-message=required>{{\'PhoneRequired.Text\'| translate}}.</div><div ng-message=minlength>{{\'PhoneMore.Text\'| translate}}</div><div ng-message=maxlength>{{\'PhoneLess.Text\'| translate}}</div></div><button type=submit class=\"oval-btn red text-center\">{{\'AddContact.Text\'| translate}}</button> <a class=link ng-click=$dismiss() type=button>{{\'Cancel.Text\'| translate}}</a></div></div></div></div></form>");
$templateCache.put("app/main/disArm/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.disarm.logo.show() ng-src={{vm.oemConfig.disarm.logo.image}} class=symbol><h2 style=\"text-transform: initial\">{{\'DoYouReally.Text\'| translate}}</h2><div class=white-hr></div><button class=\"oval-btn blue full\" ng-click=vm.sendArmOrDisAlarmSmS()>{{ vm.oemConfig.disarm.text() | translate }}</button></div>");
$templateCache.put("app/main/distributor-map/distributor-map.html","<div class=row><div class=col-md-12><div id=google_map style=\"height: 50rem; margin: 0 50px\" class=adjust_height ng-init=vm.initMap()></div></div></div><div class=row style=\"padding: 30px 50px\"><div class=\"col-sm-12 card small\"><label class=card-label>{{\'Search.Text\'| translate}}</label><input class=active type=text placeholder=Search name=search ng-model=searchText></div></div><div class=row style=\"padding: 30px 50px\"><div class=\"col-sm-6 col-xs-12\" ng-repeat=\"c in vm.list | filter:searchText\"><div class=bound-box><div class=\"col-sm-12 card contact-card\"><label class=field>{{\'Name.Text\'| translate}}</label><label class=card-label ng-click=vm.zoomToAddress(c.latitude,c.longitude)>{{c.name}}</label><label class=field>{{\'Email.Text\'| translate}}</label><label class=card-label><a style=\"font-size: 1.25rem\" ng-href=mailto://{{c.email}}>{{c.email}}</a></label><label class=field>{{\'Address.Text\'| translate}}</label><label class=card-label>{{c.address}}</label><label class=field>{{\'Country.Text\'| translate}}</label><label class=card-label>{{c.country}}</label><label class=field>{{\'City.Text\'| translate}}</label><label class=card-label>{{c.city}}</label><label class=field>{{\'OpeningHours.Text\'| translate}}</label><label class=card-label>{{c.openingHours}}</label><label class=field>{{\'ClosedDays.Text\'| translate}}</label><label class=card-label>{{c.closedDays}}</label><label class=field>{{\'Telephone.Text\'| translate}}</label><label class=card-label><a style=\"font-size: 1.25rem\" href=callto://{{c.telephone}}>{{c.telephone}}</a></label><label class=field>{{\'Website.Text\'| translate}}</label><label class=card-label><a style=\"text-transform: lowercase\" ng-href={{c.website}} target=_blank>{{c.website}}</a></label></div></div></div></div>");
$templateCache.put("app/main/distributor-map/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.ys6Map.logo.show() ng-src={{vm.oemConfig.ys6Map.logo.image}} class=symbol><h2 class=red-border-bottom>{{\'DistributorMap.Text\'| translate}}</h2></div>");
$templateCache.put("app/main/forgot-password/forget-password.html","<form name=form novalidate ng-submit=\"form.$valid && vm.resetPassword()\"><div class=login-form><div class=\"col-sm-12 header\"><div class=col-sm-6><a ui-sref=landing_page><img ng-src={{vm.oemConfig.forgotPassword.logo}} class=logo-icon></a><a ui-sref=login><img src=assets/images/back.png class=back-btn></a></div></div><div class=main><div class=\"col-sm-12 single-column\"><div class=center><h1>Reset your<br>password</h1><div class=\"card-slim last\"><label class=field>Email</label><input type=email name=email required ng-model=vm.account.emailAddress><div ng-messages=form.email.$error ng-if=form.$submitted class=text-danger><div ng-message=required>Email address is required</div><div ng-message=email>Please enter a valid email address</div></div></div><div class=\"card-slim last\"><button class=\"oval-btn full red\" type=submit>Reset password</button></div></div></div></div></div></form>");
$templateCache.put("app/main/home/choose-contact.html","<div class=modal-body id=choose_contacts_dialog><div class=row style=\"margin-left: 15px;margin-right: 15px\"><div class=col-sm-6><a ui-sref=\"boat.contacts({sentinelId: vm.sentinelId})\" ng-click=$dismiss() class=\"btn oval-btn red text-center\">{{\'Contacts.Text\'| translate}}</a></div><div class=col-sm-6><a ui-sref=\"boat.sharedUsers({sentinelId: vm.sentinelId})\" ng-click=$dismiss() class=\"btn oval-btn red text-center\">{{\'SharedUsers.Text\'| translate}}</a></div></div></div>");
$templateCache.put("app/main/home/header.html","<div class=slider-caption><div class=\"col-sm-12 boat-status\"><div class=status-icon><img ng-if=\"vm.notificationCount == 0 && vm.oemConfig.home.header.showIcon()\" uib-tooltip=\"All boat stats are OK\" ng-src={{vm.oemConfig.home.header.notificationGreen}}> <img ng-if=\"vm.notificationCount > 0 && vm.oemConfig.home.header.showIcon()\" uib-tooltip=\"Please check notifications\" ng-src={{vm.oemConfig.home.header.notificationRed}}></div></div></div>");
$templateCache.put("app/main/home/home.html","<div class=col-sm-12><div class=bound-box><label class=field>{{ \"ControlPanel.Text\" | translate }}</label><div class=fade-blue-hr></div><div class=row><div class=col-xs-6 ng-class=\"{\'col-md-3\': vm.oemConfig.sp2Contacts.logo.show(),\'col-md-2\': !vm.oemConfig.sp2Contacts.logo.show()}\" ui-state=vm.dashboardUrl.state ui-state-params=vm.dashboardUrl.params><div class=service-item><div class=service-icon><div><img ng-src={{vm.oemConfig.home.main.yacht}}></div><p ng-if=!vm.oemConfig.sp2Contacts.logo.show()>{{ \"Dashboard.Text\" | translate }}</p><p ng-if=vm.oemConfig.sp2Contacts.logo.show()>{{ \"BoatStatus.Text\" | translate }}</p></div></div></div><div class=col-xs-6 ng-class=\"{\'col-md-3\': vm.oemConfig.sp2Contacts.logo.show(),\'col-md-2\': !vm.oemConfig.sp2Contacts.logo.show()}\" ui-state=vm.alarmsUrl.state ui-state-params=vm.alarmsUrl.params><div class=service-item><div class=service-icon id=alarmTestId><div><img ng-src={{vm.oemConfig.home.main.alarm}}></div><p>{{ \"Alarms.Text\" | translate }}</p></div></div></div><div class=col-xs-6 ng-class=\"{\'col-md-3\': vm.oemConfig.sp2Contacts.logo.show(),\'col-md-2\': !vm.oemConfig.sp2Contacts.logo.show()}\" ui-state=vm.mapUrl.state ui-state-params=vm.mapUrl.params><div class=service-item><div class=service-icon><div><img ng-src={{vm.oemConfig.home.main.map}}></div><p>{{ \"Map.Text\" | translate }}</p></div></div></div><div class=col-xs-6 ng-class=\"{\'col-md-3\': vm.oemConfig.sp2Contacts.logo.show(),\'col-md-2\': !vm.oemConfig.sp2Contacts.logo.show()}\" ui-state=vm.journeyLogUrl.state ui-state-params=vm.journeyLogUrl.params><div class=service-item><div class=service-icon><div><img ng-src={{vm.oemConfig.home.main.routes}}></div><p>{{ \"JourneyLog.Text\" | translate }}</p></div></div></div><div ng-if=vm.oemConfig.camera.content.show() class=\"col-md-2 col-xs-6\" ui-sref=\"boat.cameras({sentinelId: vm.sentinelId})\"><div class=service-item><div class=service-icon><div><img ng-src={{vm.oemConfig.home.main.camera}}></div><p>{{ \"Cameras.Text\" | translate }}</p></div></div></div><div ng-if=vm.oemConfig.contacts.content.show() class=\"col-md-2 col-xs-6\" ng-click=vm.chooseContactsPage()><div class=service-item><div class=service-icon><div><img ng-src={{vm.oemConfig.home.main.contact}}></div><p>{{ \"Contacts.Text\" | translate }}</p></div></div></div></div><div class=row><div ng-if=\"vm.statusLabel==\'DISARM\'\" ng-class=\"{\'col-md-6\': vm.oemConfig.sp2Contacts.logo.show(),\'col-md-3\': !vm.oemConfig.sp2Contacts.logo.show()}\" class=\"col-xs-12 col-sm-6\" ng-click=vm.disarmAlarms()><div ng-class=vm.statusClass style=\"text-align: center\" id=service-red><div class=service-icon><p>{{ vm.oemConfig.disarm.text() | translate }}</p></div></div></div><div ng-if=\"vm.statusLabel==\'ARM\'\" ng-class=\"{\'col-md-6\': vm.oemConfig.sp2Contacts.logo.show(),\'col-md-3\': !vm.oemConfig.sp2Contacts.logo.show()}\" class=\"col-md-3 col-xs-12 col-sm-6\" ng-click=vm.armAlarms()><div ng-class=vm.statusClass style=\"text-align: center\" id=service-red><div class=service-icon><p ng-if=!vm.oemConfig.sp2Contacts.logo.show()>{{ \"Arm.Text\" | translate }}</p><p ng-if=vm.oemConfig.sp2Contacts.logo.show()>{{ \"ArmSp2.Text\" | translate }}</p><!--<a  class=\"pull-right arrow\"><img src=\"assets/images/arrow.png\" ui-sref=\"boat.sos({sentinelId: vm.sentinelId})\"></a>--></div></div></div><div ng-if=vm.oemConfig.sp2Contacts.logo.show() class=\"col-md-6 col-xs-12 col-sm-6\" ng-click=vm.chooseContactsPage()><div class=\"service-item small\" style=\"text-align: center\"><div class=service-icon><p>{{\'Contacts.Text\'| translate}}</p><!--<a  class=\"pull-right arrow\"><img src=\"assets/images/arrow.png\" ui-sref=\"boat.contacts({sentinelId: vm.sentinelId})\"></a>--></div></div></div><div ng-if=vm.oemConfig.documents.content.show() class=\"col-md-3 col-xs-12 col-sm-6\" ui-sref=\"boat.documents({sentinelId: vm.sentinelId})\"><div class=\"service-item small\" style=\"text-align: center\"><div class=service-icon><p>{{ \"ManageDocuments.Text\" | translate }}</p><!--<a  class=\"pull-right arrow\"><img src=\"assets/images/arrow.png\" ui-sref=\"boat.sos({sentinelId: vm.sentinelId})\"></a>--></div></div></div><div ng-if=vm.oemConfig.sensors.content.show() class=\"col-md-3 col-xs-12 col-sm-6\" ui-sref=\"boat.sensors({sentinelId: vm.sentinelId})\"><div class=\"service-item small\" style=\"text-align: center\"><div class=service-icon><p>{{ \"RenameSensors.Text\" | translate }}</p><!--<a  class=\"pull-right arrow\"><img src=\"assets/images/arrow.png\" ui-sref=\"boat.sensors({sentinelId: vm.sentinelId})\"></a>--></div></div></div><!-- <div\r\n        class=\"col-md-3 col-xs-12 col-sm-6\"\r\n        ng-click=\"vm.chooseContactsPage()\"\r\n      >\r\n        <div class=\"service-item small\" style=\"text-align: center\">\r\n          <div class=\"service-icon\">\r\n            <p>{{ \"Contacts.Text\" | translate }}</p>\r\n          </div>\r\n        </div>\r\n      </div> --><div ng-if=vm.oemConfig.sos.content.show() class=\"col-md-3 col-xs-12 col-sm-6\" ui-sref=\"boat.sos({sentinelId: vm.sentinelId})\"><div class=\"service-item small\" style=\"text-align: center\"><div class=service-icon><p>{{ \"SOS.Text\" | translate }}</p><!--<a  class=\"pull-right arrow\"><img src=\"assets/images/arrow.png\" ui-sref=\"boat.sos({sentinelId: vm.sentinelId})\"></a>--></div></div></div></div></div></div>");
$templateCache.put("app/main/journey/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.ys6Journey.logo.show() ng-src={{vm.oemConfig.ys6Journey.logo.image}} class=symbol><h2 class=red-border-bottom>{{vm.oemConfig.ys6Journey.heading()| translate}}</h2></div>");
$templateCache.put("app/main/journey/journey-summary.html","<div class=\"col-sm-12 mid button-bar journey\"><button ng-class=\"{active: vm.duration == \'day\'}\" class=\"oval-btn small\" ng-click=\"vm.getSummary(\'day\')\">{{\'24h.Text\'| translate}}</button> <button ng-class=\"{active: vm.duration == \'week\'}\" class=\"oval-btn small\" ng-click=\"vm.getSummary(\'week\')\">{{\'7Days.Text\'| translate}}</button> <button ng-class=\"{active: vm.duration == \'month\'}\" class=\"oval-btn small\" ng-click=\"vm.getSummary(\'month\')\">{{\'Month.Text\'| translate}}</button></div><!--  --><div class=col-sm-12><div class=\"col-md-3 col-xs-6 hidden-sm hidden-xs\"><div class=\"service-item blank\"><div class=service-icon><h1>{{\'YourJourney.Text\'| translate}}</h1><div class=red-hr></div></div></div></div><div class=\"col-md-3 col-xs-6\"><div class=\"service-item log-item\"><div class=service-icon uib-tooltip=\"{{\'NauticalMile.Text\'| translate}}\" tooltip-placement=bottom><span class=value>{{vm.summary.totalDistanceCovered | number:1}}<span>nm</span></span> <span class=label>{{\'Distance.Text\'| translate}}</span></div></div></div><div class=\"col-md-3 col-xs-6\"><div class=\"service-item log-item\"><div class=service-icon><span class=value>{{vm.summary.time | number:1}}<span>h</span></span> <span class=label>{{\'Time.Text\'| translate}}</span></div></div></div><div class=\"col-md-3 col-xs-6\"><div class=\"service-item log-item\"><div class=service-icon><span class=value>{{vm.summary.maxSpeed | number:1}}<span>{{\'\' | speed}}</span></span> <span class=label>{{\'MaxSpeed.Text\'| translate}}</span></div></div></div><!--  --><div class=\"col-md-3 col-xs-6 hidden-sm hidden-xs\"><div class=\"service-item blank\"><div class=service-icon><h1>{{\'Average.Text\'| translate}}</h1><div class=red-hr></div></div></div></div><div class=\"col-md-3 col-xs-6\"><div class=\"service-item log-item\"><div class=service-icon uib-tooltip=\"Nautical mile\" tooltip-placement=bottom><span class=value>{{vm.summary.averageDistanceCoveredPerDay | number:1}}<span>nm</span></span> <span class=label>{{\'AvgDistanceByDay.Text\'| translate}}</span></div></div></div><div class=\"col-md-3 col-xs-6\"><div class=\"service-item log-item\"><div class=service-icon><span class=value>{{vm.summary.averageTimePerDay | hms}}</span> <span class=label>{{\'AvgTimeByDay.Text\'| translate}}</span></div></div></div><div class=\"col-md-3 col-xs-6\"><div class=\"service-item log-item\"><div class=service-icon><span class=value>{{vm.summary.averageSpeed | number:1}}<span>{{\'\' | speed}}</span></span> <span class=label>{{\'AvgSpeed.Text\'| translate}}</span></div></div></div></div><!--  -->");
$templateCache.put("app/main/journey/journey.html","<style>.journey_map {\r\n    width: 100%;\r\n    height: 600px;\r\n  }</style><div class=\"col-sm-12 map-area\"><div id=journey_map class=journey_map></div></div><div class=col-sm-12 ng-if=\"vm.currentSentinel.w2K1SerialKeyId!=null && vm.oemConfig.ys6Journey.switch.show()\"><div class=\"col-sm-4 p-0\"><div class=bound-box><div class=\"col-md-6 col-sm-6 card small flex-card\"><label class=card-label>YS6</label><switch ng-click=vm.showNmeaJourneyLog(); class=green></switch><label class=\"card-label text-right\">NMEA</label></div></div></div></div>");
$templateCache.put("app/main/journey-nmea/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.nmeaJourney.logo.show() ng-src={{vm.oemConfig.nmeaJourney.logo.image}} class=symbol><h2 class=red-border-bottom>{{\'NmeaJourneyLog.Text\'| translate}}</h2></div>");
$templateCache.put("app/main/journey-nmea/journey-nmea-summary.html","<div class=\"col-sm-12 mid button-bar journey\"><button ng-class=\"{active: vm.duration == \'day\'}\" class=\"oval-btn small\" ng-click=\"vm.getSummary(\'day\')\">{{ \"24h.Text\" | translate }}</button> <button ng-class=\"{active: vm.duration == \'week\'}\" class=\"oval-btn small\" ng-click=\"vm.getSummary(\'week\')\">{{ \"7Days.Text\" | translate }}</button> <button ng-class=\"{active: vm.duration == \'month\'}\" class=\"oval-btn small\" ng-click=\"vm.getSummary(\'month\')\">{{ \"Month.Text\" | translate }}</button></div><!--  --><div class=col-sm-12><div class=\"col-md-3 col-xs-6 hidden-sm hidden-xs\"><div class=\"service-item blank\"><div class=service-icon><h1>{{ \"YourJourney.Text\" | translate }}</h1><div class=red-hr></div></div></div></div><div class=\"col-md-3 col-xs-6\"><div class=\"service-item log-item\"><div class=service-icon uib-tooltip=\"{{ \'Tooltips.Distance\' | translate }}\" tooltip-placement=bottom><span class=value>{{ vm.summary.totalDistanceCovered | number: 1 }}<span>{{\'\' | distance}}</span></span> <span class=label>{{ \"Distance.Text\" | translate }}</span></div></div></div><div class=\"col-md-3 col-xs-6\"><div class=\"service-item log-item\"><div class=service-icon uib-tooltip=\"{{ \'Tooltips.Time\' | translate }}\" tooltip-placement=bottom><span class=value>{{ vm.summary.time | number: 1 }}<span>h</span></span> <span class=label>{{ \"Time.Text\" | translate }}</span></div></div></div><div class=\"col-md-3 col-xs-6\"><div class=\"service-item log-item\"><div class=service-icon><span class=value>{{ vm.summary.maxSpeed | number: 1 }}<span>{{ \"\" | speed }}</span></span> <span class=label>{{ \"MaxSpeed.Text\" | translate }}</span></div></div></div><!--  --><div class=\"col-md-3 col-xs-6 hidden-sm hidden-xs\"><div class=\"service-item blank\"><div class=service-icon><h1>{{ \"Average.Text\" | translate }}</h1><div class=red-hr></div></div></div></div><div class=\"col-md-3 col-xs-6\"><div class=\"service-item log-item\"><div class=service-icon uib-tooltip=\"{{ \'NauticalMile.Text\' | translate }}\" tooltip-placement=bottom><span class=value>{{ vm.summary.averageDistanceCoveredPerDay | number: 1 }}<span>{{\'\' | distance}}</span></span> <span class=label>{{ \"AvgDistanceByDay.Text\" | translate }}</span></div></div></div><div class=\"col-md-3 col-xs-6\"><div class=\"service-item log-item\"><div class=service-icon><span class=value>{{ vm.summary.averageTimePerDay | hms }}</span> <span class=label>{{ \"AvgTimeByDay.Text\" | translate }}</span></div></div></div><div class=\"col-md-3 col-xs-6\"><div class=\"service-item log-item\"><div class=service-icon><span class=value>{{ vm.summary.averageSpeed | number: 1 }}<span>{{ \"\" | speed }}</span></span> <span class=label>{{ \"AvgSpeed.Text\" | translate }}</span></div></div></div></div><!--  -->");
$templateCache.put("app/main/journey-nmea/journey-nmea.html","<style>.journey_map {\r\n    width: 100%;\r\n    height: 600px;\r\n  }</style><div class=\"col-sm-12 map-area\"><div id=journey_map class=journey_map></div></div><div class=col-sm-12><div class=\"col-sm-4 p-0\"><div class=bound-box><div class=\"col-md-6 col-sm-6 card small flex-card\"><label class=card-label>YS6</label><switch ng-click=vm.showYS6JourneyLog(); ng-model=vm.enabled class=green></switch><label class=\"card-label text-right\">NMEA</label></div></div></div></div>");
$templateCache.put("app/main/landing-page/main.html","<div class=\"login fullbg\"><img ng-src={{vm.oemConfig.landing.logo}}><div class=center-tag>{{vm.tagLine}}</div><button class=\"oval-btn full\" ng-click=vm.login();>{{\'Login.Text\' | translate}}</button> <a ui-sref=register ng-if=vm.oemConfig.landing.activateAccount.show(); class=link>{{\'ActivateAccount.Text\' | translate}}</a> <a change-language=login class=link>{{\'ChangeLanguage.Text\' | translate}}</a></div>");
$templateCache.put("app/main/login/login.html","<form name=form novalidate ng-submit=\"form.$valid && vm.login()\"><div class=login-form><div class=\"col-sm-12 header\"><div class=\"col-sm-4 col-xs-4\"><a href=\"\"><img ng-src={{vm.oemConfig.login.logo}} class=logo-icon></a><!--<a href=\"\"><img src=\"assets/images/back.png\" class=\"back-btn\"></a>--></div><div class=\"col-sm-8 col-xs-8\"><a ui-sref=forgot_password class=\"pull-right forgot-link\">{{\'ForgotPassword.Text\' | translate}}</a></div></div><div class=main><div class=\"col-sm-12 center-align\"><h1>{{\'Login.Text\'| translate}}</h1></div><div class=\"col-sm-6 col-xs-12 card-slim content-box\"><label class=field>{{\'Email.Text\' | translate}}</label><input placeholder=\"Enter email address\" type=text type=email required name=email ng-model=vm.user.emailAddress><div ng-messages=form.email.$error class=text-danger ng-if=form.$submitted><div ng-message=required>{{\'Email.Required\' | translate}}</div></div></div><div class=\"col-sm-6 col-xs-12 card-slim content-box\"><label class=field>{{\'Password.Text\' | translate}}</label><input placeholder=\"{{\'Password.Placeholder\' | translate}}\" type=password name=password type=password required ng-model=vm.user.password><div ng-messages=form.password.$error class=text-danger ng-if=form.$submitted><div ng-message=required>{{\'Password.Required\' | translate}}</div></div></div><div class=\"col-sm-6 col-xs-12 card-slim content-box\"><div class=round><input style=\"visibility: hidden !important\" type=checkbox id=round ng-model=vm.rememberMe><label for=round></label></div><label for=round class=action-label>{{\'RememberMe.Text\' | translate}}</label></div><div class=\"col-sm-12 card-slim last\"><button type=submit class=\"oval-btn full red\">{{\'Login.Text\' | translate}}</button> <a ui-sref=register ng-if=vm.oemConfig.login.activateAccount.show(); class=link>{{\'ActivateAccount.Text\' | translate}}</a> <a ui-sref=change_language style=\"cursor: pointer;display: inline-block\" change-language=login class=link>{{\'ChangeLanguage.Text\' | translate}}</a></div></div></div></form>");
$templateCache.put("app/main/manage-documents/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.documents.logo.show() ng-src={{vm.oemConfig.documents.logo.image}} class=symbol><h2 class=red-border-bottom>{{\'ManageDocuments.Text\' | translate}}</h2></div>");
$templateCache.put("app/main/manage-documents/manage-documents.html","<form novalidate=\"\" name=form ng-submit=form.$valid><div class=col-sm-12><div class=bound-box><div class=\"col-sm-12 card\"><div class=\"col-sm-12 card small\" flow-init=vm.uploadApi flow-files-submitted=$flow.upload() flow-complete=vm.onUploadComplete() flow-upload-started=vm.onUploadStarted($file,$flow) flow-file-success=\"vm.onUploadSuccess($file, $message, $flow)\" flow-progress=vm.flowProgress($flow)><div style=\"margin: 10px 0; font-size: 16px; font-weight: bold\"><span ng-if=!vm.folderLink.length>{{ vm.folderLink.name| uppercase}}</span> <span ng-repeat=\"link in vm.folderLink\" ng-if=\"vm.folderLink.length>0\"><span ng-if=\"$index!=0\">/ </span><span>{{link.name | uppercase}}</span></span></div><div ng-if=!vm.isReadOnlyDirectory><div flow-drag-enter=\"style={border:\'2px dashed green\'}\" flow-drag-leave=\"style={border: \'1px dashed\'}\" ng-style=style flow-drop style=\"height: 100px; border: 1px dashed\"><label style=\"padding: 40px; width: 100%; text-align: center\" for=boat_image flow-btn>{{ \"DragDropFiles.Text\" | translate }}</label></div><div pg-form-group class=\"form-group form-group-default m-t-15\"><input type=file id=boat_image flow-btn><label class=m-t-5 for=boat_image flow-btn>{{ \"UploadFile.Text\" | translate }}</label></div></div><a href back-button ng-if=vm.child ng-click=vm.getChildDirectoriesAndAttachmentsBack(vm.currentDirectory.parentId)>Go Back</a><div class=\"row m-t-10\" ng-if=vm.showProgressBar><div class=col-12><uib-progressbar class=\"progress-striped active\" value=vm.flowProgressValue type=success></uib-progressbar></div></div><hr><button ng-click=vm.newDirectoryDialog() ng-if=!vm.isReadOnlyDirectory class=\"oval-btn red\">+ {{\'AddNewDirectory.Text\'| translate}}</button><div class=m-t-15 ng-if=\"vm.directories.length>0\"><label for=boat_image flow-btn>{{ \"Folders.Text\" | translate }}</label><table class=\"m-t-5 table table-condensed table-hover table-bordered table-striped m-table\"><thead><tr class=text-center><td>#</td><td>{{ \"Directories.Text\" | translate }}</td><td>{{ \"Action.Text\" | translate }}</td></tr></thead><tbody><tr class=text-center ng-repeat=\"file in vm.directories\"><td>{{ $index + 1 }}</td><td style=\"cursor: pointer\"><a><img class=custom style=\"width: 40px; height: 40px\" ng-click=vm.getChildDirectoriesAndAttachments(file) ng-src={{vm.oemConfig.documents.folder}}> <input ng-if=!file.isEditAble class=custom disabled=true type=text ng-model=file.name> <input ng-if=file.isEditAble class=custom type=text ng-model=file.name></a></td><td><a ng-if=!file.isReadOnly><i class=\"fa fa-times\" uib-tooltip=\"{{ \'DeleteFile.Text\' | translate }}\" ng-click=vm.deleteDirectoryById(file)></i> </a><a ng-if=!file.isReadOnly><i ng-if=!file.isEditAble class=\"fa fa-pencil\" uib-tooltip=\"{{ \'EditFile.Text\' | translate }}\" ng-click=vm.editUploadedFile(file)></i> <i ng-if=file.isEditAble class=\"fa fa-save\" uib-tooltip=\"{{ \'SaveFile.Text\' | translate }}\" ng-click=vm.updateDirectoryName(file)></i></a></td></tr></tbody></table></div><div class=m-t-15 ng-if=\"vm.uploadedFiles.length>0\"><label for=boat_image flow-btn>{{ \"Files.Text\" | translate }}</label><table class=\"m-t-5 table table-condensed table-hover table-bordered table-striped m-table\"><thead><tr class=text-center><td>#</td><td>{{ \"Files.Text\" | translate }}</td><td>{{ \"Action.Text\" | translate }}</td></tr></thead><tbody><tr class=text-center ng-repeat=\"file in vm.uploadedFiles\"><td>{{ $index + 1 }}</td><td><img class=custom style=\"width: 40px; height: 40px\" ng-src={{vm.oemConfig.documents.file}}> <input ng-if=!file.isEditAble class=custom disabled=true type=text ng-model=file.dummyName> <input ng-if=file.isEditAble class=custom type=text ng-model=file.dummyName></td><td><a><i class=\"fa fa-download m-r-5\" uib-tooltip=\"{{ \'DownloadFile.Text\' | translate }}\" ng-click=vm.downloadFile(file)></i> </a><a ng-if=!vm.isReadOnlyDirectory><i class=\"fa fa-times\" uib-tooltip=\"{{ \'DeleteFile.Text\' | translate }}\" ng-click=vm.deleteUploadedFile(file)></i> </a><a ng-if=!vm.isReadOnlyDirectory><i ng-if=!file.isEditAble class=\"fa fa-pencil\" uib-tooltip=\"{{ \'EditFile.Text\' | translate }}\" ng-click=vm.editUploadedFile(file)></i> <i ng-if=file.isEditAble class=\"fa fa-save\" uib-tooltip=\"{{ \'SaveFile.Text\' | translate }}\" ng-click=vm.saveUploadedFile(file)></i></a></td></tr></tbody></table></div></div></div></div></div></form>");
$templateCache.put("app/main/manage-documents/new-directory-dialog.html","<form novalidate=\"\" ng-submit=\"form.$valid && vm.saveDirectory()\" name=form><div class=modal-content><div class=modal-header><button class=close type=button ng-click=$dismiss()>x</button><h3 class=modal-title>{{\'AddNew.Text\'| translate}}</h3></div><div class=modal-body><div class=full-width><div class=content-box style=\"width: 75%\"><label class=field>{{\'Name.Text\'| translate}}</label><input placeholder=\"{{\'Name.Text\'| translate}}\" type=text required name=name maxlength=50 ng-model=vm.directory.name ng-class=\"{\'error\': form.$submitted && form.name.$invalid}\"><div ng-messages=form.name.$error ng-if=form.$submitted class=error><div ng-message=required>{{\'NameRequired.Text\'| translate}}.</div></div><button type=submit class=\"oval-btn red text-center\">{{\'AddNew.Text\'| translate}}</button> <a class=link ng-click=$dismiss() type=button>{{\'Cancel.Text\'| translate}}</a></div></div></div></div></form>");
$templateCache.put("app/main/map/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.ys6Map.logo.show() ng-src={{vm.oemConfig.ys6Map.logo.image}} class=symbol><h2 class=red-border-bottom>{{vm.oemConfig.ys6Map.heading()| translate}}</h2><div class=status>{{\'LastUpdatedOn.Text\'| translate}} {{vm.location.createdDate | utcDate}}</div></div>");
$templateCache.put("app/main/map/map-content.html","");
$templateCache.put("app/main/map/map.html","<div class=col-sm-12 ng-if=\"vm.currentSentinel.w2K1SerialKeyId!=null && vm.oemConfig.ys6Map.switch.show()\"><div class=\"col-sm-4 p-0\"><div class=bound-box><div class=\"col-md-6 col-sm-6 nmea-card card small flex-card\"><label class=\"card-label auto white\">YS6</label><switch ng-click=vm.showNmeaMap(); class=\"green pull-right\" style=background:#033154></switch><label class=\"card-label auto white text-right\">NMEA</label></div></div></div></div><div ng-if=!vm.hideMap><div class=\"col-sm-12 map-area\" ng-if=\"vm.mapType == \'google\'\" id=boat-location><div id=google_map class=adjust_height ng-init=vm.initMap()></div><div style=width:350px;margin:auto><button type=submit ng-click=vm.getAllSentinelsLatestLocations() ng-if=\"vm.mapType == \'google\'\" class=\"oval-btn text-center\">{{ \"GetLocations.Text\" | translate }}</button></div></div><div class=\"col-sm-12 map-area\" ng-if=\"vm.mapType == \'maritime\'\"><maritime-map location=vm.maritimeLocation originalmap=true><!-- <div class=\"col-sm-12\">\r\n        <div class=\"btn-group maritime-toggle\">\r\n          <label class=\"btn btn-primary\" ng-model=\"vm.mapType\"\r\n            uib-btn-radio=\"\'maritime\'\">{{ \"MaritimeMap.Text\" | translate }}</label>\r\n          <label class=\"btn btn-primary\" ng-model=\"vm.mapType\"\r\n            uib-btn-radio=\"\'google\'\">{{ \"GoogleMap.Text\" | translate }}</label>\r\n        </div>\r\n      </div> --></maritime-map></div></div><!-- <div class=\"main\" ng-if=\"vm.mapType == \'google\'\">\r\n  <div class=\"main-box\">\r\n    <button type=\"submit\" ng-click=\"vm.getAllSentinelsLatestLocations()\" ng-if=\"vm.mapType == \'google\'\" class=\"oval-btn text-center\">Get other boats locations</button>\r\n\r\n  </div>\r\n</div> -->");
$templateCache.put("app/main/map-nmea/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.nmeaMap.logo.show() ng-src={{vm.oemConfig.nmeaMap.logo.image}} class=symbol><h2 class=red-border-bottom>{{\'NmeaMap.Text\'| translate}}</h2><div class=status>{{\'LastUpdatedOn.Text\'| translate}} {{vm.location.createdDate | utcDate}}</div></div>");
$templateCache.put("app/main/map-nmea/map-nmea-content.html","");
$templateCache.put("app/main/map-nmea/map-nmea.html","<div class=col-sm-12 style=\"background-color: #003055\"><div class=\"col-sm-4 p-0\"><div class=bound-box><div class=\"col-md-6 col-sm-6 nmea-card card small flex-card\"><label class=\"card-label auto white\">YS6</label><switch ng-click=vm.showYS6Map(); ng-model=vm.enabled class=\"green pull-right\"></switch><label class=\"card-label auto white text-right\">NMEA</label></div></div></div></div><div ng-if=!vm.hideMap><div class=\"col-sm-12 map-area\" style=\"background-color: #003055\" ng-if=\"vm.mapType == \'google\'\" id=boat-location><div id=google_map class=adjust_height ng-init=vm.initMap()></div><!-- <div style=\"width:350px;margin:auto;\">\r\n    <button\r\n      type=\"submit\"\r\n      ng-click=\"vm.getAllSentinelsLatestLocations()\"\r\n      ng-if=\"vm.mapType == \'google\'\"\r\n      class=\"oval-btn text-center\"\r\n    >\r\n      {{ \"GetLocations.Text\" | translate }}\r\n    </button>\r\n  </div> --></div><div class=\"col-sm-12 map-area\" style=\"background-color: #003055\" ng-if=\"vm.mapType == \'maritime\'\"><maritime-map location=vm.maritimeLocation originalmap=true><!-- <div class=\"col-sm-12\">\r\n        <div class=\"btn-group maritime-toggle\">\r\n          <label class=\"btn btn-primary\" ng-model=\"vm.mapType\"\r\n            uib-btn-radio=\"\'maritime\'\">{{ \"MaritimeMap.Text\" | translate }}</label>\r\n          <label class=\"btn btn-primary\" ng-model=\"vm.mapType\"\r\n            uib-btn-radio=\"\'google\'\">{{ \"GoogleMap.Text\" | translate }}</label>\r\n        </div>\r\n      </div> --></maritime-map></div></div><!-- <div class=\"main\" ng-if=\"vm.mapType == \'google\'\">\r\n  <div class=\"main-box\">\r\n    <button type=\"submit\" ng-click=\"vm.getAllSentinelsLatestLocations()\" ng-if=\"vm.mapType == \'google\'\" class=\"oval-btn text-center\">Get other boats locations</button>\r\n\r\n  </div>\r\n</div> -->");
$templateCache.put("app/main/metrics/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.metrics.logo.show() ng-src={{vm.oemConfig.metrics.logo.image}} class=symbol><h2 class=red-border-bottom>{{\'Metrics.Text\' | translate}}</h2></div>");
$templateCache.put("app/main/metrics/metrics.html","<!--  --><form novalidate=\"\" name=form ng-submit=\"form.$valid  && vm.saveSettings()\"><div class=\"col-sm-6 col-md-offset-3\"><div class=bound-box><div class=\"col-sm-12 card small\" ng-repeat=\"s in vm.settings\" ng-if=\"s.id == 1 || s.id==2 || s.id==4 || s.id == 5 || s.id == 6\"><label class=card-label>{{ s.description }}</label><select class=active required ng-model=s.userSettingViewModel.allow_Setting_Value name=allowedSettingValue id=allowedSettingValue ng-options=\"allowedSettingValue.id as allowedSettingValue.unit for allowedSettingValue in s.allowedSettingValues\"></select></div></div></div><!--  --><!--\r\n    <div class=\"col-sm-6\">\r\n        <div class=\"bound-box\">\r\n            <div class=\"col-sm-12 card small\" ng-repeat=\"s in vm.settings\" ng-if=\"$index >=2\">\r\n                <label class=\"card-label\">{{s.description}}</label>\r\n                <select class=\"active\" required ng-model=\"s.userSettingViewModel.allow_Setting_Value\" name=\"allowedSettingValue\" id=\"allowedSettingValue\"\r\n                    ng-options=\"allowedSettingValue.id as allowedSettingValue.unit for allowedSettingValue in s.allowedSettingValues\">\r\n			</select>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n     --><div class=\"col-sm-12 mid\"><button type=submit class=\"oval-btn blue\">{{ \"SaveChanges.Text\" | translate }}</button></div></form>");
$templateCache.put("app/main/notifications/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.notifications.logo.show() ng-src={{vm.oemConfig.notifications.logo.image}} class=symbol><h2 class=red-border-bottom>{{\'Notifications.Text\'| translate}}</h2></div>");
$templateCache.put("app/main/notifications/notifications.html","<div id=notifications><div class=col-sm-12><div class=bound-box><h2 class=field>{{\'NewMessages.Text\'| translate}}</h2><div class=pull-right><button class=\"btn btn-warning\" ng-click=vm.markAllNotificationsSeen()><i class=\"fa fa-trash\"></i> {{\'ClearNewMessages.Text\'| translate}}</button></div><div class=white-hr></div><div ng-if=\"vm.notifications.unread.length == 0\"><div class=\"col-sm-12 pre-card\"><div uib-alert=\"\" class=info>{{\'NoMessages.Text\'| translate}}</div></div></div><div ng-repeat=\"n in vm.notifications.unread\"><div class=\"col-sm-12 pre-card\"><div class=time><img src=assets/images/time.png> {{n.createdDate|utcDate}}</div><div class=\"boat-title pull-right\" ng-if=\"n.notificationTypeId == 1\">{{n.userSentinel.name}}</div><div class=\"boat-title pull-right\" ng-if=\"n.notificationTypeId == 2\">{{n.userSentinel.name}} | {{\'JournalLog.Text\'| translate}}</div></div><div class=\"col-sm-12 card\"><label class=card-label ng-bind-html=n.notificationMessage></label><div ng-if=\"n.userSentinelCameraEventId != null && n.showSnapshotBool==true\"><img ng-src=\"{{ n.snapshotAttachmentUri }}\"></div><div ng-if=\"n.userSentinelCameraEventId != null && n.showVideoBool==true\"><video style=width:100% controls><source ng-src=\"{{ n.videoAttachmentUri }}\" type=video/mp4></video></div><div ng-if=\"n.sentinelLocationId != null && n.showMapBool==true \"><div class=\"col-sm-12 map-area maritime-toggle\" style=\"margin-top: 5px\"><maritime-map location=n.sentinelLocation originalmap=false></maritime-map></div></div></div><div class=\"col-sm-12 post-card\"><a href=\"\" ng-if=\"n.sentinelLocationId != null && !n.showMapBool\" ng-click=vm.showMap(n) style=margin-right:10px class=active><img src=assets/images/pointer-active.png> {{\'Location.Text\'| translate}}: {{n.sentinelLocation.latitude | number:4}}, {{n.sentinelLocation.longitude | number:4}} </a><a ng-if=\"n.showMapBool==true\" href=\"\" ng-click=vm.hideMap(n) style=margin-right:10px><img src=assets/images/pointer.png> {{\'HideLocation.Text\'| translate}}: {{n.sentinelLocation.latitude | number:4}}, {{n.sentinelLocation.longitude | number:4}} </a><a href=\"\" ng-if=\"n.userSentinelCameraEventId != null && !n.showSnapshotBool\" ng-click=vm.showSnapshot(n) style=margin-right:10px><i class=\"fa fa-camera\"></i> {{\'Snapshot.Text\'| translate}} </a><a href=\"\" ng-if=\"n.showSnapshotBool==true\" ng-click=vm.hideSnapshot(n) style=margin-right:10px><i class=\"fa fa-camera\"></i> {{\'HideSnapshot.Text\'| translate}} </a><a href=\"\" ng-if=\"n.userSentinelCameraEventId != null && n.userSentinelCameraEvent.videoAttachmentId!=null && !n.showVideoBool\" ng-click=vm.showVideo(n)><i class=\"fa fa-video-camera\"></i> {{\'Video.Text\'| translate}} </a><a href=\"\" ng-if=\"n.showVideoBool == true\" ng-click=vm.hideVideo(n)><i class=\"fa fa-video-camera\"></i> {{\'HideVideo.Text\'| translate}}</a></div></div><div ng-if=\"vm.showLoadMore == false && vm.notifications.unread.length > 0\"><div class=\"col-sm-12 pre-card\"><div uib-alert=\"\" class=info>{{\'NoMoreMessages.Text\'| translate}}</div></div></div></div><div class=\"col-sm-12 mid\" ng-if=\"vm.notifications.unread.length > 0 && vm.showLoadMore == true\"><div class=bound-box><button class=\"oval-btn red\" ng-click=vm.getUnReadNotifications()><img src=assets/images/load.png> {{\'LoadMore.Text\'| translate}}</button></div></div></div><div class=col-sm-12><div class=bound-box><h2 class=field>{{\'PastMessages.Text\'| translate}}</h2><div class=btn-group uib-dropdown is-open=status.isopen style=float:right><button id=single-button type=button class=\"btn btn-primary\" uib-dropdown-toggle ng-disabled=disabled>{{\'OrderBy.Text\'| translate}} <span class=caret></span></button><ul id=notificaion-dropdown class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li role=menuitem><a href ng-click=\"vm.getReadNotifications(\'createdDate\')\">{{\'Time.Text\'| translate}}</a></li><li role=menuitem><a href ng-click=\"vm.getReadNotifications(\'userSentinel.name\')\">{{\'Boat.Text\'| translate}}</a></li><li role=menuitem><a href ng-click=\"vm.getReadNotifications(\'alarmType.alarmName\')\">{{\'Alarm.Text\'| translate}}</a></li></ul></div><div class=white-hr></div><div ng-if=\"vm.notifications.read.length == 0\"><div class=\"col-sm-12 pre-card\"><div uib-alert=\"\" class=info>{{\'NoPastMessages.Text\'| translate}}</div></div></div><div ng-repeat=\"n in vm.notifications.read\"><div class=\"col-sm-12 pre-card\"><div class=time><img src=assets/images/time.png> {{n.createdDate|utcDate}}</div><div class=\"boat-title pull-right\" ng-if=\"n.notificationTypeId == 1\">{{n.userSentinel.name}}</div><div class=\"boat-title pull-right\" ng-if=\"n.notificationTypeId == 2\">{{n.userSentinel.name}} | {{\'JournalLog.Text\'| translate}}</div></div><div class=\"col-sm-12 card\"><label class=card-label ng-bind-html=n.notificationMessage></label><div ng-if=\"n.userSentinelCameraEventId != null && n.showSnapshotBool==true\"><img ng-src=\"{{ n.snapshotAttachmentUri }}\"></div><div ng-if=\"n.userSentinelCameraEventId != null && n.showVideoBool==true\"><video style=width:100% controls><source ng-src=\"{{ n.videoAttachmentUri }}\" type=video/mp4></video></div><div ng-if=\"n.sentinelLocationId != null && n.showMapBool==true\"><div class=\"col-sm-12 map-area\" style=\"margin-top: 5px\"><maritime-map location=n.sentinelLocation originalmap=false></maritime-map></div></div></div><div class=\"col-sm-12 post-card\"><a ng-if=\"n.sentinelLocationId != null && !n.showMapBool\" href=\"\" ng-click=vm.showMap(n) style=margin-right:10px><img src=assets/images/pointer.png> {{\'Location.Text\'| translate}}: {{n.sentinelLocation.latitude | number:4}}, {{n.sentinelLocation.longitude | number:4}} </a><a ng-if=\"n.showMapBool==true\" href=\"\" ng-click=vm.hideMap(n) style=margin-right:10px><img src=assets/images/pointer.png> {{\'HideLocation.Text\'| translate}}: {{n.sentinelLocation.latitude | number:4}}, {{n.sentinelLocation.longitude | number:4}} </a><a href=\"\" ng-if=\"n.userSentinelCameraEventId != null && !n.showSnapshotBool\" ng-click=vm.showSnapshot(n) style=margin-right:10px><i class=\"fa fa-camera\"></i> {{\'Snapshot.Text\'| translate}} </a><a href=\"\" ng-if=\"n.showSnapshotBool==true\" ng-click=vm.hideSnapshot(n) style=margin-right:10px><i class=\"fa fa-camera\"></i> {{\'HideSnapshot.Text\'| translate}} </a><a href=\"\" ng-if=\"n.userSentinelCameraEventId != null && n.userSentinelCameraEvent.videoAttachmentId!=null  && !n.showVideoBool\" ng-click=vm.showVideo(n)><i class=\"fa fa-video-camera\"></i> {{\'Video.Text\'| translate}} </a><a href=\"\" ng-if=\"n.showVideoBool == true\" ng-click=vm.hideVideo(n)><i class=\"fa fa-video-camera\"></i> {{\'HideVideo.Text\'| translate}}</a></div></div></div><div class=\"col-sm-12 mid\"><div class=bound-box><button class=\"oval-btn red\" ng-click=vm.getReadNotificationsSimple()><img src=assets/images/load.png> {{\'LoadMore.Text\'| translate}}</button></div></div></div><div class=col-sm-12><div class=bound-box><h2 class=field>{{\'JournalLog.Text\'| translate}}</h2><div class=white-hr></div><div ng-if=\"vm.notifications.journalLog.length == 0\"><div class=\"col-sm-12 pre-card\"><div uib-alert=\"\" class=info>{{\'NoJournalLog.Text\'| translate}}</div></div></div><div ng-repeat=\"n in vm.notifications.journalLog\"><div class=\"col-sm-12 pre-card\"><div class=time><img src=assets/images/time.png> {{n.createdDate|utcDate}}</div><div class=\"boat-title pull-right\">{{n.userSentinel.name}}</div></div><div class=\"col-sm-12 card\"><label class=card-label ng-bind-html=n.notificationMessage></label><div ng-if=\"n.userSentinelCameraEventId != null && n.showSnapshotBool==true\"><img style=\"margin-left: 25px;margin-bottom: 10px\" ng-src=\"{{ n.snapshotAttachmentUri }}\"></div><div ng-if=\"n.userSentinelCameraEventId != null && n.showVideoBool==true\"><video style=\"margin-left: 25px\" width=320 height=240 controls><source src=\"{{ n.videoAttachmentUri }}\" type=video/mp4></video></div><div ng-if=\"n.sentinelLocationId != null && n.showMapBool==true\"><div class=\"col-sm-12 map-area maritime-toggle\" style=\"margin-top: 5px\"><maritime-map location=n.sentinelLocation originalmap=false></maritime-map></div></div></div><div class=\"col-sm-12 post-card\"><a ng-if=\"n.sentinelLocationId != null && !n.showMapBool\" href=\"\" ng-click=vm.showMap(n) style=margin-right:10px><img src=assets/images/pointer.png> {{\'Location.Text\'| translate}}: {{n.sentinelLocation.latitude | number:4}}, {{n.sentinelLocation.longitude | number:4}} </a><a ng-if=\"n.showMapBool==true\" href=\"\" ng-click=vm.hideMap(n) style=margin-right:10px><img src=assets/images/pointer.png> {{\'HideLocation.Text\'| translate}}: {{n.sentinelLocation.latitude | number:4}}, {{n.sentinelLocation.longitude | number:4}} </a><a href=\"\" ng-if=\"n.userSentinelCameraEventId != null && !n.showSnapshotBool\" ng-click=vm.showSnapshot(n) style=margin-right:10px><i class=\"fa fa-camera\"></i> {{\'Snapshot.Text\'| translate}} </a><a href=\"\" ng-if=\"n.showSnapshotBool==true\" ng-click=vm.hideSnapshot(n) style=margin-right:10px><i class=\"fa fa-camera\"></i> {{\'HideSnapshot.Text\'| translate}} </a><a href=\"\" ng-if=\"n.userSentinelCameraEventId != null && n.userSentinelCameraEvent.videoAttachmentId!=null  && !n.showVideoBool\" ng-click=vm.showVideo(n)><i class=\"fa fa-video-camera\"></i> {{\'Video.Text\'| translate}} </a><a href=\"\" ng-if=\"n.showVideoBool == true\" ng-click=vm.hideVideo(n)><i class=\"fa fa-video-camera\"></i> {{\'HideVideo.Text\'| translate}}</a></div></div></div><div class=\"col-sm-12 mid\"><div class=bound-box><button class=\"oval-btn red\" ng-click=vm.getJournalLog()><img src=assets/images/load.png> {{\'LoadMore.Text\'| translate}}</button></div></div></div></div>");
$templateCache.put("app/main/privacy/privacy.html","<div class=container><h1>{{\'TermsConditionsDocument.Title\'|translate}}</h1><br><strong><span style=\"text-decoration: underline;font-weight: bold\">{{\'TermsConditionsDocument.Line1\'|translate}}</span>{{\'TermsConditionsDocument.Line1Continue\'|translate}}</strong><br><p>{{\'TermsConditionsDocument.Line2\'|translate}}</p><br><strong>{{\'TermsConditionsDocument.DefinationsTitle\'|translate}}</strong><br><br><p>{{\'TermsConditionsDocument.Defination\'|translate}}</p><p>{{\'TermsConditionsDocument.Hardware\'|translate}}</p><p>{{\'TermsConditionsDocument.Intellectual\'|translate}}</p><p>{{\'TermsConditionsDocument.OpenSource\'|translate}}</p><p>{{\'TermsConditionsDocument.Product\'|translate}}</p><p>{{\'TermsConditionsDocument.Software\'|translate}}</p><strong>{{\'TermsConditionsDocument.LicenseTitle\'|translate}}</strong><br><br><p>{{\'TermsConditionsDocument.LicenseParagraph\'|translate}}</p><strong>{{\'TermsConditionsDocument.LimitationsTitle\'|translate}}</strong><br><br><p>{{\'TermsConditionsDocument.LimitationsParagraph\'|translate}}</p><strong>{{\'TermsConditionsDocument.TermTitle\'|translate}}</strong><br><br><p>{{\'TermsConditionsDocument.TermParagraph\'|translate}}</p><strong>{{\'TermsConditionsDocument.WarrantiesTitle\'|translate}}</strong><br><br><p>{{\'TermsConditionsDocument.WarrantiesParagraph\'|translate}} <strong>{{\'TermsConditionsDocument.WarrantiesParabold\'|translate}}</strong></p><strong>{{\'TermsConditionsDocument.LiabilityTitle\'|translate}}</strong><br><br><p><strong>{{\'TermsConditionsDocument.LiabilityParagraph\'|translate}}</strong></p><strong>{{\'TermsConditionsDocument.MaintenanceTitle\'|translate}}</strong><br><br><p>{{\'TermsConditionsDocument.MaintenanceParagraph\'|translate}}</p><strong>{{\'TermsConditionsDocument.ConfidentialityTitle\'|translate}}</strong><br><br><p>{{\'TermsConditionsDocument.ConfidentialityParagraph\'|translate}}</p><strong>{{\'TermsConditionsDocument.GeneralTitle\'|translate}}</strong><br><br><p>{{\'TermsConditionsDocument.GeneralParagraph\'|translate}}</p><p>{{\'TermsConditionsDocument.GenralParagraphContinued\'|translate}}</p><h1>{{\'PrivacyPolicyDocument.PrivacyPolicyHeading\'|translate}}</h1><strong>{{\'PrivacyPolicyDocument.IntroductionTitle\'|translate}}</strong><br><br><p id=privacyPolicyTitle>{{\'PrivacyPolicyDocument.IntroductionParagraph\'|translate}}</p><strong>{{\'PrivacyPolicyDocument.PersonalDataTitle\'|translate}}</strong><br><br><p>{{\'PrivacyPolicyDocument.PersonalDataParagraph\'|translate}}</p><strong>{{\'PrivacyPolicyDocument.WhoWeAreTitle\'|translate}}</strong><br><br><p>{{\'PrivacyPolicyDocument.WhoWeAreParagraph\'|translate}}</p><strong>{{\'PrivacyPolicyDocument.SortOfDataTitle\'|translate}}</strong><br><br><p>{{\'PrivacyPolicyDocument.SortOfDataParagraph\'|translate}}<br><ul style=\"list-style-type:disc;margin-left: 45px\"><li>{{\'PrivacyPolicyDocument.SortOfDataBullet1\'|translate}}</li><li>{{\'PrivacyPolicyDocument.SortOfDataBullet2\'|translate}}</li><li>{{\'PrivacyPolicyDocument.SortOfDataBullet3\'|translate}}</li><li>{{\'PrivacyPolicyDocument.SortOfDataBullet4\'|translate}}</li><li>{{\'PrivacyPolicyDocument.SortOfDataBullet5\'|translate}}</li><li>{{\'PrivacyPolicyDocument.SortOfDataBullet6\'|translate}}</li><li>{{\'PrivacyPolicyDocument.SortOfDataBullet7\'|translate}}</li></ul></p><p>{{\'PrivacyPolicyDocument.SorOfDataContinue1\'|translate}}<br><ul style=\"list-style-type:disc;margin-left: 45px\"><li>{{\'PrivacyPolicyDocument.SortOfDataAlphaBullet1\'|translate}}</li><li>{{\'PrivacyPolicyDocument.SortOfDataAlphaBullet2\'|translate}}</li><li>{{\'PrivacyPolicyDocument.SortOfDataAlphaBullet3\'|translate}}</li><li>{{\'PrivacyPolicyDocument.SortOfDataAlphaBullet4\'|translate}}</li><li>{{\'PrivacyPolicyDocument.SortOfDataAlphaBullet5\'|translate}}</li><li>{{\'PrivacyPolicyDocument.SortOfDataAlphaBullet6\'|translate}}</li></ul></p><strong>{{\'PrivacyPolicyDocument.ProcessPersonalDataTitle\'|translate}}</strong><br><br><p>{{\'PrivacyPolicyDocument.ProcessPersonalDataParagraph\'|translate}}<ul style=\"list-style-type:disc;margin-left: 45px\"><li>{{\'PrivacyPolicyDocument.ProcessPersonalDataBullet1\'|translate}}</li><li>{{\'PrivacyPolicyDocument.ProcessPersonalDataBullet2\'|translate}}</li><li>{{\'PrivacyPolicyDocument.ProcessPersonalDataBullet3\'|translate}}</li><li>{{\'PrivacyPolicyDocument.ProcessPersonalDataBullet4\'|translate}}</li></ul></p><strong>{{\'PrivacyPolicyDocument.PersonalDataUsedTitle\'|translate}}</strong><br><br><p>{{\'PrivacyPolicyDocument.PersonalDataUsedParagraph1\'|translate}}</p><p>{{\'PrivacyPolicyDocument.PersonalDataUsedParagraph2\'|translate}}</p><p>{{\'PrivacyPolicyDocument.PersonalDataUsedParagraph3\'|translate}}</p><strong>{{\'PrivacyPolicyDocument.StorePersonalDataTitle\'|translate}}</strong><br><br><p>{{\'PrivacyPolicyDocument.StorePersonalDataParagraph1\'|translate}}</p><p>{{\'PrivacyPolicyDocument.StorePersonalDataParagraph2\'|translate}}</p><p>{{\'PrivacyPolicyDocument.StorePersonalDataParagraph3\'|translate}}</p><strong>{{\'PrivacyPolicyDocument.RightsTitle\'|translate}}</strong><br><br><p>{{\'PrivacyPolicyDocument.RightsParagraph\'|translate}}<ul style=\"list-style-type:disc;margin-left: 45px\"><li>{{\'PrivacyPolicyDocument.RightsParaBullet1\'|translate}}</li><li>{{\'PrivacyPolicyDocument.RightsParaBullet2\'|translate}}</li><li>{{\'PrivacyPolicyDocument.RightsParaBullet3\'|translate}}</li><li>{{\'PrivacyPolicyDocument.RightsParaBullet4\'|translate}}</li><li>{{\'PrivacyPolicyDocument.RightsParaBullet5\'|translate}}</li><li>{{\'PrivacyPolicyDocument.RightsParaBullet6\'|translate}}</li><li>{{\'PrivacyPolicyDocument.RightsParaBullet7\'|translate}}</li><li>{{\'PrivacyPolicyDocument.RightsParaBullet8\'|translate}}</li></ul></p><strong>{{\'PrivacyPolicyDocument.SafeGuardTitle\'|translate}}</strong><br><br><p>{{\'PrivacyPolicyDocument.SafeGuardParagraph1\'|translate}}<ul style=\"list-style-type:disc;margin-left: 45px\"><li>{{\'PrivacyPolicyDocument.SafeGuardBullet1\'|translate}}</li><li>{{\'PrivacyPolicyDocument.SafeGuardBullet2\'|translate}}</li><li>{{\'PrivacyPolicyDocument.SafeGuardBullet3\'|translate}}</li></ul></p><p>{{\'PrivacyPolicyDocument.SafeGuardParagraph2\'|translate}}</p><p>{{\'PrivacyPolicyDocument.SafeGuardParagraph3\'|translate}}</p><p>{{\'PrivacyPolicyDocument.SafeGuardParagraph4\'|translate}}</p><strong>{{\'PrivacyPolicyDocument.OtherSitesTitle\'|translate}}</strong><br><br><p>{{\'PrivacyPolicyDocument.OtherSitesParagraph\'|translate}}</p><strong>{{\'PrivacyPolicyDocument.InformPolicyChangeTitle\'|translate}}</strong><br><br><p>{{\'PrivacyPolicyDocument.InformPolicyChangeParagraph\'|translate}}</p><strong>{{\'PrivacyPolicyDocument.ContactUsTitle\'|translate}}</strong><br><br><p>{{\'PrivacyPolicyDocument.ContactUsParagraph1\'|translate}}</p><p>{{\'PrivacyPolicyDocument.ContactUsParagraph2\'|translate}}</p><p>{{\'PrivacyPolicyDocument.ContactUsParagraph3\'|translate}}</p><form novalidate name=form ng-submit=\"form.$valid && vm.createAccount(form)\"><div ng-if=\"vm.hideCheckBox==false\" class=\"col-sm-12 no-gutter\" ng-init=\"vm.account.agreed = false\"><div class=round><input type=checkbox id=round ng-model=vm.account.agreed><label for=round></label></div><label for=round class=\"action-label privacy\" translate=\"{{ \'TermsAndConditionsStatment.Text\' }}\"></label></div><div ng-if=form.$submitted class=error><div ng-if=\"vm.account.agreed == false\">{{ \"LicenseAggrement.Text\" | translate }}</div></div><div class=\"col-sm-12 card-slim last\" ng-if=\"vm.hideCheckBox==false\"><button type=submit ng-disabled=!vm.account.agreed class=\"oval-btn red\">{{ \"ActivateAccount.Text\" | translate }}</button></div></form></div>");
$templateCache.put("app/main/redirect/redirect.html","<h2 style=\"text-align: center; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)\">checking....</h2>");
$templateCache.put("app/main/register/register.html","<form novalidate name=form ng-submit=\"form.$valid && vm.account.selectedCountry != null && vm.createAccount(form)\"><div class=login-form><div class=\"col-sm-12 header\"><div class=col-sm-6><a ui-sref=landing_page><img ng-src={{vm.oemConfig.register.logo}} class=logo-icon></a><a ui-sref=login><img src=assets/images/back.png class=back-btn></a></div></div><div class=main><div class=\"col-sm-12 center-align\"><h1>{{ \"ActivateAccount.Text\" | translate }}</h1></div><!--  --><div class=bound-box><label class=field>{{ \"PersonalInformation.Text\" | translate }}</label><div class=\"col-sm-12 card\" flow-init=vm.flow flow-files-submitted=$flow.upload() flow-file-success=\"vm.fileSuccess($file, $message, $flow)\"><div class=\"col-sm-6 col-xs-12 content-box\"><label class=field>{{ \"FullName.Text\" | translate }}</label><input type=text required name=full_name maxlength=100 ng-model=vm.account.fullName ng-class=\"{\'error\': form.$submitted && form.full_name.$invalid}\"><div ng-messages=form.full_name.$error ng-if=form.$submitted class=error><div ng-message=required>{{ \"FullName.Required\" | translate }}</div><div ng-message=maxlength>{{ \"FullName.MaxLength\" | translate }}</div></div></div><div class=\"col-sm-6 col-xs-12 content-box\"><label class=field>{{ \"Country.Text\" | translate }}</label><div isteven-multi-select input-model=vm.countries output-model=vm.account.selectedCountry button-label=\"name dial_code\" item-label=\"name dial_code\" tick-property=ticked selection-mode=single ng-class=\"{\'error\': form.$submitted && vm.account.selectedCountry.length == 0}\"></div><div class=error ng-if=\"form.$submitted && vm.account.selectedCountry.length == 0\">{{ \"Country.Required\" | translate }}</div></div><div class=\"col-sm-6 col-xs-12 content-box\"><label class=field>{{ \"MobileNumber.Text\" | translate }}</label><input type=text required maxlength=50 name=mobile_number ng-model=vm.account.mobileNumber ng-class=\"{\'error\': form.$submitted && form.mobile_number.$invalid}\"><div ng-messages=form.mobile_number.$error ng-if=form.$submitted class=error><div ng-message=required>{{ \"MobileNumber.Required\" | translate }}</div></div></div><div ng-if=vm.oemConfig.register.showOptions() class=\"col-sm-6 col-xs-12 content-box\"><label class=field>Select the Yacht sentinel device that you are trying to set up. (to set up a camera AND a YS6 select YS Hub)</label><div style=\"clear: both;margin-top: 20px\"><div class=round><input style=\"visibility: hidden !important\" type=checkbox id=isCameraOnly2 name=isCameraOnly2 ng-model=vm.ysHubOnly ng-change=vm.productionSelectionChange(1)><label for=isCameraOnly2></label></div><label for=isCameraOnly2 class=\"field m-t-5\" style=\"display: inline-block\" translate=\"{{ \'YS6Hub.Text\' }}\"></label></div><div><div class=round><input style=\"visibility: hidden !important\" type=checkbox id=isCameraOnly1 name=isCameraOnly1 ng-model=vm.isCameraOnly ng-change=vm.productionSelectionChange(0)><label for=isCameraOnly1></label></div><label for=isCameraOnly1 class=\"field m-t-5\" style=\"display: inline-block\" translate=\"{{ \'IsCameraOnly.Text\' }}\"></label></div><div><div class=round><input style=\"visibility: hidden !important\" type=checkbox id=isNmeaOnly name=isNmeaOnly ng-model=vm.isNmeaOnly ng-change=vm.productionSelectionChange(2)><label for=isNmeaOnly></label></div><label for=isNmeaOnly class=\"field m-t-5\" style=\"display: inline-block\" translate=\"{{ \'SentinelDomotics.Text\' }}\"></label></div></div><div class=\"col-sm-6 col-xs-12 content-box\" ng-if=vm.ysHubOnly><label class=field>{{ \"IMEI.Text\" | translate }}</label><input uib-tooltip=\"{{ \'IMEI.Tooltip\' | translate }}\" type=text name=imei required maxlength=18 ui-validate-async=\"{validImei: \'vm.validateImei($value)\'}\" autocomplete=off minlength=15 ng-model=vm.account.imei ng-class=\"{\'error\': form.$submitted && form.imei.$invalid}\"><div ng-messages=form.imei.$error class=error><div ng-message=required><p>{{ \"IMEI.Required\" | translate }}</p><p>{{ \"IMEI.Info\" | translate }}</p></div><div ng-message=minlength>{{ \"IMEI.MinLength\" | translate }}</div><div ng-message=validImei>{{ \"IMEI.Invalid\" | translate }}</div></div></div><div class=\"col-sm-6 col-xs-12 content-box\" ng-if=vm.ysHubOnly><button class=\"oval-btn blue\" type=button flow-btn>{{ \"ScanQR.Text\" | translate }}</button></div><div class=\"col-sm-6 col-xs-12 content-box\" ng-if=vm.isNmeaOnly><label class=field>{{ \"NmeaW2K1SerialKey.Text\" | translate }}</label><input type=text name=w2k1Key required ui-validate-async=\"{validW2k1Key: \'vm.validateW2k1Key($value)\'}\" autocomplete=off ng-model=vm.sentinel.w2K1Key><div ng-messages=form.w2K1Key.$error class=error><div ng-message=required><p>{{ \"NmeaW2K1SerialKey.Required\" | translate }}</p></div><div ng-message=validW2k1Key>{{ \"NmeaW2K1SerialKey.Invalid\" | translate }}</div></div></div></div></div><!--  --><div class=bound-box><label class=field>{{ \"AccountInformation.Text\" | translate }}</label><div class=\"col-sm-12 card\"><div class=\"col-sm-6 col-xs-12 content-box\"><label class=field>{{ \"Email.Text\" | translate }}</label><input type=text required type=email name=email maxlength=50 ng-model=vm.account.emailAddress ng-class=\"{\'error\': form.$submitted && form.email.$invalid}\"><div ng-messages=form.email.$error ng-if=form.$submitted class=error><div ng-message=required>{{ \"Email.Required\" | translate }}</div></div></div><div class=\"col-sm-6 col-xs-12 content-box\"><label class=field>{{ \"Password.Text\" | translate }}</label><input type=password ng-pattern=\"/^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/\" required type=password name=password ng-maxlength=16 ng-minlength=8 ng-model=vm.account.password ng-class=\"{\'error\': form.$submitted && form.password.$invalid}\" ng-keyup=vm.onPasswordChange($event)><div ng-messages=form.password.$error ng-if=form.$submitted class=error><div ng-message=required>{{ \"Password.Required\" | translate }}</div><!-- <div ng-message=\"minlength\">\r\n                {{ \"Password.MinLength\" | translate }}\r\n              </div> --><div ng-message=maxlength>{{ \"Password.MaxLength\" | translate }}</div></div><div><ul class=password__validation__status><li ng-class=\"{\'ok\': vm.passwordValidationStatus.minLength == true}\"><i class=\"fa fa-times-circle\" ng-if=!vm.passwordValidationStatus.minLength aria-hidden=true></i> <i class=\"fa fa-check-circle-o\" ng-if=vm.passwordValidationStatus.minLength aria-hidden=true></i> <span>{{\'PasswordValidation.MinLength\' | translate}}</span></li><li ng-class=\"{\'ok\': vm.passwordValidationStatus.lowerCase == true}\"><i class=\"fa fa-times-circle\" ng-if=!vm.passwordValidationStatus.lowerCase aria-hidden=true></i> <i class=\"fa fa-check-circle-o\" ng-if=vm.passwordValidationStatus.lowerCase aria-hidden=true></i> <span>{{\'PasswordValidation.LowerCase\' | translate}}</span></li><li ng-class=\"{\'ok\': vm.passwordValidationStatus.upperCase == true}\"><i class=\"fa fa-times-circle\" ng-if=!vm.passwordValidationStatus.upperCase aria-hidden=true></i> <i class=\"fa fa-check-circle-o\" ng-if=vm.passwordValidationStatus.upperCase aria-hidden=true></i> <span>{{\'PasswordValidation.UpperCase\' | translate}}</span></li><li ng-class=\"{\'ok\': vm.passwordValidationStatus.number == true}\"><i class=\"fa fa-times-circle\" ng-if=!vm.passwordValidationStatus.number aria-hidden=true></i> <i class=\"fa fa-check-circle-o\" ng-if=vm.passwordValidationStatus.number aria-hidden=true></i> <span>{{\'PasswordValidation.Number\' | translate}}</span></li></ul></div></div><div class=\"col-sm-6 col-xs-12 content-box\"><label class=field>{{ \"ConfirmPassword.Text\" | translate }}</label><input type=password name=confirm_password confirm-pwd=vm.account.password required type=password ng-maxlength=16 ng-minlength=6 ng-model=vm.account.confirmPassword ng-class=\"{\'error\': form.$submitted && form.confirm_password.$invalid}\"><div ng-messages=form.confirm_password.$error ng-if=\"form.$submitted && form.confirm_password.$touched\" class=error><div ng-message=required>{{ \"ConfirmPassword.Required\" | translate }}</div><div ng-message=minlength>{{ \"ConfirmPassword.MinLength\" | translate }}</div><div ng-message=maxlength>{{ \"ConfirmPassword.MaxLength\" | translate }}</div><div ng-message=password>{{ \"ConfirmPassword.MisMatch\" | translate }}</div></div></div><div class=\"col-sm-6 col-xs-12 content-box\"><div vc-recaptcha theme=\"\'light\'\" on-create=vm.setWidgetId(widgetId) on-success=vm.setResponse(response) on-expire=vm.cbExpiration() ng-model=vm.account.captcha></div></div></div></div><div class=\"col-sm-12 no-gutter\" ng-init=\"vm.account.agreed = false\"><div class=round><input style=\"visibility: hidden !important\" type=checkbox id=round ng-model=vm.account.agreed><label for=round></label></div><label for=round class=\"action-label privacy\" translate=\"{{ \'TermsAndConditionsStatment.Text\' }}\"></label></div><div ng-if=form.$submitted class=error><div ng-if=\"vm.account.agreed == false\">{{ \"LicenseAggrement.Text\" | translate }}</div></div><div class=\"col-sm-12 card-slim last\"><button type=submit class=\"oval-btn red\">{{ \"ActivateAccount.Text\" | translate }}</button></div><!--  --></div></div></form>");
$templateCache.put("app/main/reset-password/reset-password.html","<form name=form novalidate ng-submit=\"form.$valid && vm.changePassword()\"><div class=login-form><div class=main><div class=\"col-sm-12 center-align\"><h1>Change Password</h1></div><div class=\"col-sm-6 col-xs-12 card-slim content-box\"><label class=field>Password</label><input autocomplete=Off placeholder=\"Enter password\" type=password required name=new_password ng-maxlength=16 ng-pattern=\"/^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/\" ng-model=vm.account.password ng-class=\"{\'error\': form.$submitted && form.new_password.$invalid}\" ng-keyup=vm.onPasswordChange($event)><div ng-messages=form.new_password.$error ng-if=\"form.$submitted && form.new_password.$touched\" class=error><div ng-message=required>Password is required</div><div ng-message=maxlength>Password length should be less than 16 characters</div></div><div><ul class=password__validation__status><li ng-class=\"{\'ok\': vm.passwordValidationStatus.minLength == true}\"><i class=\"fa fa-times-circle\" ng-if=!vm.passwordValidationStatus.minLength aria-hidden=true></i> <i class=\"fa fa-check-circle-o\" ng-if=vm.passwordValidationStatus.minLength aria-hidden=true></i> <span>{{\'PasswordValidation.MinLength\' | translate}}</span></li><li ng-class=\"{\'ok\': vm.passwordValidationStatus.lowerCase == true}\"><i class=\"fa fa-times-circle\" ng-if=!vm.passwordValidationStatus.lowerCase aria-hidden=true></i> <i class=\"fa fa-check-circle-o\" ng-if=vm.passwordValidationStatus.lowerCase aria-hidden=true></i> <span>{{\'PasswordValidation.LowerCase\' | translate}}</span></li><li ng-class=\"{\'ok\': vm.passwordValidationStatus.upperCase == true}\"><i class=\"fa fa-times-circle\" ng-if=!vm.passwordValidationStatus.upperCase aria-hidden=true></i> <i class=\"fa fa-check-circle-o\" ng-if=vm.passwordValidationStatus.upperCase aria-hidden=true></i> <span>{{\'PasswordValidation.UpperCase\' | translate}}</span></li><li ng-class=\"{\'ok\': vm.passwordValidationStatus.number == true}\"><i class=\"fa fa-times-circle\" ng-if=!vm.passwordValidationStatus.number aria-hidden=true></i> <i class=\"fa fa-check-circle-o\" ng-if=vm.passwordValidationStatus.number aria-hidden=true></i> <span>{{\'PasswordValidation.Number\' | translate}}</span></li></ul></div></div><div class=\"col-sm-6 col-xs-12 card-slim content-box\"><label class=field>Confirm Password</label><input autocomplete=off type=password name=confirm_password required type=password confirm-pwd=vm.account.password ng-maxlength=16 ng-model=vm.account.confirmPassword ng-class=\"{ \'error\': form.$submitted && form.confirm_password.$invalid} \"><div ng-messages=form.confirm_password.$error ng-if=\"form.$submitted && form.confirm_password.$touched\" class=error><div ng-message=required>Confirm password is required</div><div ng-message=password>Password doest not match</div></div></div><div class=\"col-sm-12 card-slim\"><button type=\"submit \" class=\"oval-btn full red\">Reset</button></div></div></div></form>");
$templateCache.put("app/main/shared-users/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.sharedUser.logo.show() ng-src={{vm.oemConfig.sharedUser.logo.image}} class=symbol><h2 class=red-border-bottom>{{\'SharedUsers.Text\'| translate}}</h2><button class=\"oval-btn red\" ng-click=vm.showNewsSharedUserDialog()>+ {{\'AddNewUser.Text\'| translate}}</button></div>");
$templateCache.put("app/main/shared-users/new-shared-user-dialog.html","<form novalidate name=form ng-submit=\"form.$valid && vm.addNewUser(form)\"><div class=modal-content><div class=modal-header><button class=close type=button ng-click=$dismiss()>x</button><h3 class=modal-title>{{\'AddSharedUser.Text\'| translate}}</h3></div><div class=modal-body><div class=full-width><div class=content-box style=\"width: 75%\"><label class=field>{{\'Email.Text\'| translate}}</label><input placeholder=\"Enter email address\" type=text required type=email name=email maxlength=50 ng-model=vm.sharedUser.emailAddress ng-class=\"{\'error\': form.$submitted && form.email.$invalid}\"><div ng-messages=form.email.$error ng-if=form.$submitted class=error><div ng-message=required>{{\'EmailRequired.Text\'| translate}}</div></div><label class=card-label>{{vm.oemConfig.sharedUser.allowedBoat() | translate}}</label><div isteven-multi-select input-model=vm.sentinels output-model=vm.sharedUser.sentinels button-label=name item-label=name tick-property=selected orientation=horizontal></div><div ng-if=\"vm.sharedUser.sentinels.length == 0\" class=error><div>{{vm.oemConfig.sharedUser.boatRequired() | translate}}</div></div><button type=submit class=\"oval-btn red text-center\">{{\'AddSharedUser.Text\'| translate}}</button> <a class=link ng-click=$dismiss() type=button>{{\'Cancel.Text\'| translate}}</a></div></div></div></div></form>");
$templateCache.put("app/main/shared-users/shared-users.html","<!--  --><div class=col-sm-12><div class=bound-box><label class=field>{{ \"EditUser.Text\" | translate }}</label><div class=\"col-sm-12 card small\" ng-repeat=\"u in vm.userList.users\"><label class=card-label>{{ u.fullName }}</label><p>IMEI: {{ u.userSentinel.imei }}</p><p>{{ \"BoatName.Text\" | translate }}: {{ u.userSentinel.name }}</p><a href=\"\" ng-click=vm.deleteUser(u.id) class=\"pull-right remove-icon\"><img src=assets/images/remove.png></a><div class=row><switch on=\"{{ \'CanEdit.Text\' | translate }}\" off=\"{{ \'CanView.Text\' | translate }}\" ng-change=vm.setUserEditPermission(u.id,u.canEdit) ng-model=u.canEdit class=\"green wide\"></switch></div><div class=row ng-if=vm.oemConfig.sharedUser.showCameraPermissions()><div class=col-sm-12><label class=card-label>{{ \"CameraPermissions.Text\" | translate }}</label></div></div><div class=row ng-if=vm.oemConfig.sharedUser.showCameraPermissions()><div class=col-md-4 style=margin-top:10px><label class=field>{{ \"CanViewLive.Text\" | translate }}</label></div><div class=col-md-4><switch on=\"{{ \'On.Text\' | translate }}\" off=\"{{ \'Off.Text\' | translate }}\" ng-change=vm.setUserViewLivePermission(u.id,u.canViewLive) ng-model=u.canViewLive class=\"green wide\"></switch></div></div><div class=row ng-if=vm.oemConfig.sharedUser.showCameraPermissions()><div class=col-md-4 style=margin-top:10px><label class=field>{{ \"CanViewAlerts.Text\" | translate }}</label></div><div class=col-md-4><switch on=\"{{ \'On.Text\' | translate }}\" off=\"{{ \'Off.Text\' | translate }}\" ng-change=vm.setUserViewAlertsPermission(u.id,u.canViewAlerts) ng-model=u.canViewAlerts class=\"green wide\"></switch></div></div></div></div></div><!--  -->");
$templateCache.put("app/main/sos/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.sos.header.logo.show() ng-src={{vm.oemConfig.sos.header.logo.image}} class=symbol><h2 style=\"text-transform: initial\">{{\'DoYouReallySOS.Text\'| translate}}</h2><div class=white-hr></div><button class=\"oval-btn blue full\" ng-click=vm.showSosDialog()>{{\'SendSOS.Text\'| translate}}</button></div>");
$templateCache.put("app/main/sos/sos.html","<div class=modal-content><div class=modal-body><img ng-if=vm.oemConfig.sos.dialog.logo.show() ng-src={{vm.oemConfig.sos.dialog.logo.image}}><h3>{{\'ExtraInfo.Text\'| translate}}</h3><input type=text ng-model=vm.extraMessage> <button ng-click=vm.sendSos() class=\"oval-btn red\">{{\'SendSOS.Text\'| translate}}</button> <a href=\"\" ng-click=$dismiss()>{{\'Cancel.Text\'| translate}}</a></div></div><!-- modal-content -->");
$templateCache.put("app/main/spinner/spinner.html","<button class=\"btn btn-primary\" ng-click=vm.start()>Start</button> <button class=\"btn btn-warning\" ng-click=vm.stop()>Stop</button>");
$templateCache.put("app/main/status/header.html","<div class=slider-caption><img ng-src={{vm.oemConfig.ys6Dashboard.logo.image}} ng-hide=!vm.oemConfig.ys6Dashboard.logo.show() class=symbol><h2 class=red-border-bottom>{{ vm.oemConfig.ys6Dashboard.heading() | translate}}</h2><div class=status>{{\'LastUpdatedOn.Text\'| translate}} {{vm.status.sentinelBattery.createdDate | utcDate}}</div></div>");
$templateCache.put("app/main/status/status.html","<div class=boat-status-box><!--  --><div ng-if=\"vm.currentSentinel.w2K1SerialKeyId!=null && vm.oemConfig.ys6Dashboard.switch.show()\" class=col-sm-12><div class=\"col-sm-6 p-0\"><div class=bound-box><div class=\"col-md-6 col-sm-6 card small flex-card\"><label class=card-label>YS6</label><switch ng-click=vm.showNmeaDashboard(); class=\"green pull-right\"></switch><label class=\"card-label text-right\">NMEA</label></div></div></div></div><div class=col-sm-6><div class=bound-box><label class=field>{{ \"CentralUnit1.Text\" | translate }}</label><span class=field-underline></span><div class=\"col-sm-12 card small\"><i ng-show=vm.oemConfig.ys6Dashboard.statuses.showIcons() class=\"card-icon fa fa-power-off fa-2x\"></i><label class=card-label>{{ \"Status1.Text\" | translate }}</label><div ng-if=\"vm.isDisArmed == false && vm.isOff == false &&  vm.isOnline \" class=\"badge green pull-right\">{{ \"Armed.Text\" | translate }}</div><div ng-if=\"vm.isDisArmed == true && vm.isOff == false &&  vm.isOnline\" class=\"badge green pull-right\">{{ \"DisArmed.Text\" | translate }}</div><div ng-if=\"vm.isDisArmed == false && vm.isOff == true && vm.isOnline\" class=\"badge red pull-right\">{{ \"Off.Text\" | translate }}</div><div ng-if=\" vm.isOnline == false\" class=\"badge red pull-right\">{{ \"NoConnection.Text\" | translate }}</div></div><div class=\"col-sm-12 card small\"><i ng-show=vm.oemConfig.ys6Dashboard.statuses.showIcons() class=\"card-icon fa fa-calendar fa-2x\"></i><label class=card-label>{{ \"LastUpdatedOn.Text\" | translate }}</label><div class=\"badge green pull-right\" style=font-size:10px>{{ vm.status.sentinelBattery.createdDate | utcDate }}</div></div></div><div class=bound-box><label class=field>{{ \"Battery.Text\" | translate }}</label><span class=field-underline></span><div class=\"col-sm-12 card small\"><img ng-show=vm.oemConfig.ys6Dashboard.statuses.showIcons() src=assets/images/bolt.png class=card-icon><label ng-if=!vm.oemConfig.sp2Contacts.logo.show() class=card-label>{{ \"CentralBoat.Text\" | translate }}</label><label ng-if=vm.oemConfig.sp2Contacts.logo.show() class=card-label>{{ \"Asset.Text\" | translate }}</label><div class=\"badge green pull-right\">{{ vm.status.sentinelBattery.boatBattery | number: 1 }}v</div></div><div class=\"col-sm-12 card small\"><img ng-show=vm.oemConfig.ys6Dashboard.statuses.showIcons() src=assets/images/bolt.png class=card-icon><label ng-if=!vm.oemConfig.sp2Contacts.logo.show() class=card-label>{{ \"CentralUnit.Text\" | translate }}</label><label ng-if=vm.oemConfig.sp2Contacts.logo.show() class=card-label>{{ \"Sp2BaseUnit.Text\" | translate }}</label><div class=\"badge green pull-right\">{{ vm.status.sentinelBattery.sentinelBattery | number: 1 }}v</div></div><div class=\"col-sm-12 card small\" ng-repeat=\"t in vm.status.sentinelVoltages\"><img ng-show=vm.oemConfig.ys6Dashboard.statuses.showIcons() src=assets/images/bolt.png class=card-icon><label class=card-label>{{ t.sentinelSensor.sensorName }}</label><div class=\"badge green pull-right\">{{ t.voltage | number: 1 }}v</div></div><div class=\"col-sm-12 card small\" ng-repeat=\"t in vm.status.sentinelMainSupplyHistory\"><img ng-show=vm.oemConfig.ys6Dashboard.statuses.showIcons() src=assets/images/bolt.png class=card-icon><label class=card-label>{{ t.sentinelSensor.sensorName }}</label><div ng-if=\"t.mainSupply==vm.shorePowerStatusEnum.off\" class=\"badge green pull-right\">On</div><div ng-if=\"t.mainSupply==vm.shorePowerStatusEnum.on\" class=\"badge blue pull-right\">Off</div><div ng-if=\"t.mainSupply==vm.shorePowerStatusEnum.notPurchased\" class=\"badge red pull-right\">N/A</div></div></div><div class=bound-box><label class=field>{{ \"Temperature.Text\" | translate }}</label><span class=field-underline></span><div class=\"col-sm-12 card small\" ng-if=\"vm.status.sentinelTemperatures.length == 0\"><img ng-show=vm.oemConfig.ys6Dashboard.statuses.showIcons() src=assets/images/thermometer.png class=card-icon><label class=card-label>{{ \"NoDataFound.Text\" | translate }}</label></div><div class=\"col-sm-12 card small\" ng-repeat=\"t in vm.status.sentinelTemperatures\"><img ng-show=vm.oemConfig.ys6Dashboard.statuses.showIcons() src=assets/images/thermometer.png class=card-icon><label class=card-label>{{ t.sentinelSensor.sensorName }}</label><div class=\"badge blue pull-right\" ng-if=\"vm.status.sentinelConnectivity.satellite == false && t.sentinelSensor.missingBattery == false\">{{ t.temperature | number: 0 | temperature }}</div><div class=\"badge red pull-right\" uib-tooltip=\"{{ \'MissingBattery.Text\' | translate }}\" ng-if=\"vm.status.sentinelConnectivity.satellite == false && t.sentinelSensor.missingBattery\">{{ t.temperature | number: 0 | temperature }}</div><div class=\"badge blue pull-right\" ng-if=\"vm.status.sentinelConnectivity.satellite == true\" uib-tooltip=\"{{ \'YachtToolTip.Text\' | translate }}\" tooltip-placement=top tooltip-enable=true>N/A</div></div></div></div><!--  --><div class=col-sm-6><div class=bound-box><label class=field>{{ \"Movement.Text\" | translate }}</label><span class=field-underline></span><div class=\"col-sm-12 card small\"><img ng-show=vm.oemConfig.ys6Dashboard.statuses.showIcons() src=assets/images/speedometer.png class=card-icon><label class=card-label>{{ \"Speed.Text\" | translate }}</label><div class=\"badge blue pull-right\" ng-if=\"vm.status.sentinelSpeed != null\">{{ vm.status.sentinelSpeed.speed | speed }}</div><div class=\"badge blue pull-right\" ng-if=\"vm.status.sentinelSpeed == null\">N/A</div></div><div class=\"col-sm-12 card small\"><img ng-show=vm.oemConfig.ys6Dashboard.statuses.showIcons() src=assets/images/course.png class=card-icon><label class=card-label>{{ \"Course.Text\" | translate }}</label><div class=\"badge blue pull-right\" ng-if=\"vm.status.sentinelLocation != null\">{{ vm.status.sentinelLocation.course | courseDirection }}</div><div class=\"badge blue pull-right\" ng-if=\"vm.status.sentinelLocation == null\">N/A</div></div><div class=\"col-sm-12 card small\"><img ng-show=vm.oemConfig.ys6Dashboard.statuses.showIcons() src=assets/images/compas.png class=card-icon><label class=card-label>{{ \"Latitude.Text\" | translate }}</label><div class=\"badge blue pull-right\" ng-if=\"vm.status.sentinelLocation != null\">{{ vm.status.sentinelLocation.latitude | number: 4 }}</div><div class=\"badge blue pull-right\" ng-if=\"vm.status.sentinelLocation == null\">N/A</div></div><div class=\"col-sm-12 card small\"><img ng-show=vm.oemConfig.ys6Dashboard.statuses.showIcons() src=assets/images/compas.png class=card-icon><label class=card-label>{{ \"Longitude.Text\" | translate }}</label><div class=\"badge blue pull-right\" ng-if=\"vm.status.sentinelLocation != null\">{{ vm.status.sentinelLocation.longitude | number: 4 }}</div><div class=\"badge blue pull-right\" ng-if=\"vm.status.sentinelLocation == null\">N/A</div></div></div><div class=bound-box><label class=field>{{ \"Connection.Text\" | translate }}</label><span class=field-underline></span><div class=\"col-sm-12 card small\"><img ng-show=vm.oemConfig.ys6Dashboard.statuses.showIcons() src=assets/images/gsm.png class=card-icon><label class=card-label>{{ \"GSM.Text\" | translate }}</label><div ng-if=\"vm.status.sentinelConnectivity.gsmSignal == true && vm.status.sentinelConnectivity.satellite == false\" class=\"round-bagde green\"></div><div ng-if=\"vm.status.sentinelConnectivity.gsmSignal == true && vm.status.sentinelConnectivity.satellite == true\" class=\"round-bagde red\"></div><div ng-if=\"vm.status.sentinelConnectivity.gsmSignal == false\" class=\"round-bagde red\"></div></div><!-- <div class=\"col-sm-12 card small\">\r\n              <img src=\"assets/images/globe.png\" class=\"card-icon\">\r\n              <label class=\"card-label\">{{\'GPS.Text\'| translate}}</label>\r\n              <div ng-if=\"vm.status.sentinelConnectivity.gpsConnection == true && vm.status.sentinelConnectivity.satellite == false\" class=\"round-bagde green\"></div>\r\n              <div ng-if=\"vm.status.sentinelConnectivity.gpsConnection == true && vm.status.sentinelConnectivity.satellite == true\" class=\"round-bagde red\"></div>\r\n              <div ng-if=\"vm.status.sentinelConnectivity.gpsConnection == false\" class=\"round-bagde red\"></div>\r\n            </div> --><div ng-if=!vm.oemConfig.sp2Contacts.logo.show() class=\"col-sm-12 card small\"><img ng-show=vm.oemConfig.ys6Dashboard.statuses.showIcons() src=assets/images/satellite.png class=card-icon><label class=card-label>{{ \"Satellite.Text\" | translate }}</label><div ng-if=\"vm.status.sentinelConnectivity.satellite == true\" class=\"round-bagde green\"></div><div ng-if=\"vm.status.sentinelConnectivity.satellite == false\" class=\"round-bagde red\"></div></div></div></div></div>");
$templateCache.put("app/main/tutorial/tutorial.html","<div ng-if=\"vm.oemConfig.oem!=\'fp\'\" class=swiper-container swiper><div class=swiper-wrapper><div class=swiper-slide><div class=mid-screen><img ng-src={{vm.oemConfig.tutorial.logo}}><p class=center>{{\'Welcome.Text\' | translate}}<br>{{\'ToMonitor.Text\' | translate}}</p><button class=\"oval-btn center\" ng-click=next()>{{\'Continue.Text\' | translate}}</button></div></div><div class=swiper-slide><div class=\"col-sm-5 col-xs-12\"><img ng-src={{vm.oemConfig.tutorial.screen2}} class=w-img></div><div class=\"col-sm-7 col-xs-12\"><h1>{{\'Monitor.Text\' | translate}}<br>{{\'AndManage.Text\' | translate}}</h1><p>{{\'EasyWay.Text\' | translate}}<br>{{\'ManageBoats.Text\' | translate}}<br>{{\'PersonalDashboard.Text\' | translate}}</p><button class=oval-btn ng-click=next()>{{\'Continue.Text\' | translate}}</button></div></div><div class=swiper-slide><div class=\"col-sm-5 col-xs-12\"><img ng-src={{vm.oemConfig.tutorial.screen3}} class=w-img></div><div class=\"col-sm-7 col-xs-12\"><h1>{{\'CheckBoat.Text\' | translate}}<br>{{\'Status.Text\' | translate}}</h1><p>{{\'CheckAny.Text\' | translate}}<br>{{\'BoatsWherever.Text\' | translate}}<br>{{\'Whenever.Text\' | translate}}</p><button class=oval-btn ng-click=next()>{{\'Continue.Text\' | translate}}</button></div></div><div class=swiper-slide><div class=\"col-sm-5 col-xs-12\"><img ng-src={{vm.oemConfig.tutorial.screen4}} class=w-img></div><div class=\"col-sm-7 col-xs-12\"><h1>{{\'SetAlarms.Text\' | translate}}</h1><p>{{\'SetSettings.Text\' | translate}}<br>{{\'AlarmsEasily.Text\' | translate}}</p><button class=oval-btn ng-click=next()>{{\'Continue.Text\' | translate}}</button></div></div><div class=swiper-slide><div class=\"col-sm-5 col-xs-12\"><img ng-src={{vm.oemConfig.tutorial.screen5}} class=w-img></div><div class=\"col-sm-7 col-xs-12\"><h1>{{\'Receive.Text\' | translate}}<br>{{\'Notifications.Text\' | translate}}</h1><p>{{\'RealTime.Text\' | translate}}<br>{{\'Smartphone.Text\' | translate}}</p><button class=\"oval-btn red\" ui-sref=\"boat.home({sentinelId: vm.currentSentinel.id})\">{{\'GetStarted.Text\' | translate}}</button></div></div></div><!-- Add Pagination --><div class=swiper-pagination></div></div><div ng-if=\"vm.oemConfig.oem==\'fp\'\" class=swiper-container swiper><div class=swiper-wrapper><div class=swiper-slide><div class=mid-screen><img ng-src={{vm.oemConfig.tutorial.logo}}><p class=center>{{\'Welcome.Text\' | translate}}<br>{{\'ToMonitor.Text\' | translate}}</p><button class=\"oval-btn center\" ng-click=next()>{{\'Continue.Text\' | translate}}</button></div></div><div class=swiper-slide><div class=\"col-sm-5 col-xs-12\"><img ng-src={{vm.oemConfig.tutorial.screen2}} class=w-img></div><div class=\"col-sm-7 col-xs-12\"><h1>{{\'Monitor.Text\' | translate}}<br>{{\'AndManage.Text\' | translate}}</h1><p>{{\'EasyWay.Text\' | translate}}<br>{{\'ManageBoats.Text\' | translate}}<br>{{\'PersonalDashboard.Text\' | translate}}</p><button class=oval-btn ng-click=next()>{{\'Continue.Text\' | translate}}</button></div></div><div class=swiper-slide><div class=\"col-sm-5 col-xs-12\"><img ng-src={{vm.oemConfig.tutorial.screen3}} class=w-img></div><div class=\"col-sm-7 col-xs-12\"><h1>{{\'CheckBoat.Text\' | translate}}<br>{{\'Status.Text\' | translate}}</h1><p>{{\'CheckAny.Text\' | translate}}<br>{{\'BoatsWherever.Text\' | translate}}<br>{{\'Whenever.Text\' | translate}}</p><button class=oval-btn ng-click=next()>{{\'Continue.Text\' | translate}}</button></div></div><div class=swiper-slide><div class=\"col-sm-5 col-xs-12\"><img ng-src={{vm.oemConfig.tutorial.screen6}} class=w-img></div><div class=\"col-sm-7 col-xs-12\"><h1>{{\'CheckYs6Status.Text\' | translate}}</h1><p>{{\'SwitchBetween.Text\' | translate}}<br>{{\'Ys6Anytime.Text\' | translate}}</p><p style=font-size:15px>{{\'ExtraOptional.Text\' | translate}}</p><button class=oval-btn ng-click=next()>{{\'Continue.Text\' | translate}}</button></div></div><div class=swiper-slide><div class=\"col-sm-5 col-xs-12\"><img ng-src={{vm.oemConfig.tutorial.screen4}} class=w-img></div><div class=\"col-sm-7 col-xs-12\"><h1>{{\'SetAlarms.Text\' | translate}}</h1><p>{{\'SetSettings.Text\' | translate}}<br>{{\'AlarmsEasily.Text\' | translate}}</p><button class=oval-btn ng-click=next()>{{\'Continue.Text\' | translate}}</button></div></div><div class=swiper-slide><div class=\"col-sm-5 col-xs-12\"><img ng-src={{vm.oemConfig.tutorial.screen7}} class=w-img></div><div class=\"col-sm-7 col-xs-12\"><h1>{{\'SetSecurityAlarms.Text\' | translate}}</h1><p>{{\'SetUpSecurity.Text\' | translate}}<br>{{\'CustomizedAlarms.Text\' | translate}}</p><button class=oval-btn ng-click=next()>{{\'Continue.Text\' | translate}}</button></div></div><div class=swiper-slide><div class=\"col-sm-5 col-xs-12\"><img ng-src={{vm.oemConfig.tutorial.screen8}} class=w-img></div><div class=\"col-sm-7 col-xs-12\"><h1>{{\'ViewBoat.Text\' | translate}}</h1><p>{{\'CheckOut.Text\' | translate}}<br>{{\'WhereItsBeen.Text\' | translate}}</p><button class=oval-btn ng-click=next()>{{\'Continue.Text\' | translate}}</button></div></div><div class=swiper-slide><div class=\"col-sm-5 col-xs-12\"><img ng-src={{vm.oemConfig.tutorial.screen9}} class=w-img></div><div class=\"col-sm-7 col-xs-12\"><h1>{{\'SeeYourBoat.Text\' | translate}}</h1><p>{{\'BeAlerted.Text\' | translate}}<br>{{\'VideoAndSnaps.Text\' | translate}}</p><button class=oval-btn ng-click=next()>{{\'Continue.Text\' | translate}}</button></div></div><div class=swiper-slide><div class=\"col-sm-5 col-xs-12\"><img ng-src={{vm.oemConfig.tutorial.screen5}} class=w-img></div><div class=\"col-sm-7 col-xs-12\"><h1>{{\'Receive.Text\' | translate}}<br>{{\'Notifications.Text\' | translate}}</h1><p>{{\'RealTime.Text\' | translate}}<br>{{\'Smartphone.Text\' | translate}}</p><button class=\"oval-btn red\" ui-sref=\"boat.home({sentinelId: vm.currentSentinel.id})\">{{\'GetStarted.Text\' | translate}}</button></div></div></div><!-- Add Pagination --><div class=swiper-pagination></div></div>");
$templateCache.put("app/main/update-password/update-password.html","<form name=form novalidate><div class=login-form><div class=main><div class=\"col-sm-12 center-align\"><h1>Update Password</h1></div><div class=\"col-sm-6 col-xs-12 card-slim content-box\"><label class=field>Password</label><input autocomplete=Off placeholder=\"Enter password\" type=password required name=new_password ng-maxlength=16 ng-pattern=\"/^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/\" ng-model=vm.account.password ng-class=\"{\'error\': form.$submitted && form.new_password.$invalid}\" ng-keyup=vm.onPasswordChange($event)><div ng-messages=form.new_password.$error ng-if=\"form.$submitted && form.new_password.$touched\" class=error><div ng-message=required>Password is required</div><div ng-message=maxlength>Password length should be less than 16 characters</div></div><div><ul class=password__validation__status><li ng-class=\"{\'ok\': vm.passwordValidationStatus.minLength == true}\"><i class=\"fa fa-times-circle\" ng-if=!vm.passwordValidationStatus.minLength aria-hidden=true></i> <i class=\"fa fa-check-circle-o\" ng-if=vm.passwordValidationStatus.minLength aria-hidden=true></i> <span>{{\'PasswordValidation.MinLength\' | translate}}</span></li><li ng-class=\"{\'ok\': vm.passwordValidationStatus.lowerCase == true}\"><i class=\"fa fa-times-circle\" ng-if=!vm.passwordValidationStatus.lowerCase aria-hidden=true></i> <i class=\"fa fa-check-circle-o\" ng-if=vm.passwordValidationStatus.lowerCase aria-hidden=true></i> <span>{{\'PasswordValidation.LowerCase\' | translate}}</span></li><li ng-class=\"{\'ok\': vm.passwordValidationStatus.upperCase == true}\"><i class=\"fa fa-times-circle\" ng-if=!vm.passwordValidationStatus.upperCase aria-hidden=true></i> <i class=\"fa fa-check-circle-o\" ng-if=vm.passwordValidationStatus.upperCase aria-hidden=true></i> <span>{{\'PasswordValidation.UpperCase\' | translate}}</span></li><li ng-class=\"{\'ok\': vm.passwordValidationStatus.number == true}\"><i class=\"fa fa-times-circle\" ng-if=!vm.passwordValidationStatus.number aria-hidden=true></i> <i class=\"fa fa-check-circle-o\" ng-if=vm.passwordValidationStatus.number aria-hidden=true></i> <span>{{\'PasswordValidation.Number\' | translate}}</span></li></ul></div></div><div class=\"col-sm-6 col-xs-12 card-slim content-box\"><label class=field>Confirm Password</label><input autocomplete=off type=password name=confirm_password required type=password confirm-pwd=vm.account.password ng-maxlength=16 ng-model=vm.account.confirmPassword ng-class=\"{ \'error\': form.$submitted && form.confirm_password.$invalid} \"><div ng-messages=form.confirm_password.$error ng-if=\"form.$submitted && form.confirm_password.$touched\" class=error><div ng-message=required>Confirm password is required</div><div ng-message=password>Password doest not match</div></div></div><div class=\"col-sm-12 card-slim\"><button class=\"oval-btn full red\" ng-click=\"form.$valid && vm.updatePassword()\">Update</button> <button class=\"oval-btn full red\" ng-click=vm.skipPasswordUpdate()>Skip</button></div></div></div></form>");
$templateCache.put("app/main/weather/error-box-dialog.html","<div class=modal-content><div class=modal-body><img src=assets/images/sos2.png><h3>{{\'NoInformation.Text\'| translate}}</h3><a href=\"\" ng-click=$dismiss()>{{\'Cancel.Text\'| translate}}</a></div></div><!-- modal-content -->");
$templateCache.put("app/main/weather/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.weather.logo.show() ng-src={{vm.oemConfig.weather.logo.image}} class=symbol><h2>{{\'Weather.Text\'| translate}}</h2></div>");
$templateCache.put("app/main/weather/weather.html","<div ng-hide=vm.show7days ng-if=\"vm.sentinelWeather!=null\"><div class=\"col-sm-12 mid button-bar\"><button class=\"oval-btn small active\" ng-click=\"vm.show7days=false\">{{\'Today.Text\'| translate}}</button> <button class=\"oval-btn small\" ng-click=\"vm.show7days=true\" style=\"width: auto\">{{\'Next7Days.Text\'| translate}}</button></div><!--  --><div class=col-sm-12><div class=weather-box><div class=temperature><div class=temperature-info>{{vm.weatherDetails.feelsLike|number:0}}&deg;</div><div class=min-max>{{vm.sentinelWeather.minTemperature |number:0 | temperature}} / {{vm.sentinelWeather.maxTemperature |number:0 | temperature}}</div></div><div class=day-info><ul><li><div class=icon><img src=assets/images/sunrise.png></div><div class=detail><span>{{\'Rise.Text\'| translate}}</span>{{vm.sentinelWeather.sunrise|date:\'hh:mm a\'}}</div></li><li><div class=icon><img src=assets/images/sunset.png></div><div class=detail><span>{{\'Set.Text\'| translate}}</span>{{vm.sentinelWeather.sunset|date:\'hh:mm a\'}}</div></li><li><div class=icon><img src=assets/images/rise.png></div><div class=detail><span>{{\'Rise.Text\'| translate}}</span>{{vm.sentinelWeather.moonrise|date:\'hh:mm a\'}}</div></li><li><div class=icon><img src=assets/images/set.png></div><div class=detail><span>{{\'Set.Text\'| translate}}</span>{{vm.sentinelWeather.moonset|date:\'hh:mm a\'}}</div></li></ul></div></div></div><!--  --><div class=\"col-sm-12 mid\" ng-if=\"vm.showTides == false\"><button ng-click=\"vm.showTides = true\" class=\"oval-btn red\">{{\'TidesInfo.Text\'| translate}}</button></div><div class=\"col-sm-12 mid\" ng-if=\"vm.showTides==true\"><h2 class=sub-heading>{{\'TidesInformation.Text\'| translate}}</h2></div><!--  --><div class=col-sm-6 data-ng-repeat=\"s in vm.sentinelWeather.sentinelWeatherTide\" ng-if=\"vm.showTides==true\"><div class=bound-box><label class=field>{{s.tideDateTime|date:\'dd-MMMM-yyyy hh:mm a\'}}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'TideHeight.Text\'| translate}}</label><div class=value>{{s.tideHeight | number:1 | height}}</div></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'TideType.Text\'| translate}}</label><div class=value>{{s.tideType}}</div></div></div></div><div class=\"col-sm-12 mid\" ng-if=\"vm.showTides == true\"><button ng-click=\"vm.showTides = false\" class=\"oval-btn red\">{{\'HideTidesInfo.Text\'| translate}}</button></div><div ng-hide=vm.showMoreInfo class=\"col-sm-12 mid\"><button class=\"oval-btn red\" ng-click=\"vm.showMoreInfo=true\">{{\'MoreInfo.Text\'| translate}}</button></div><div ng-hide=!vm.showMoreInfo><div class=\"col-sm-12 mid\"><h2 class=sub-heading>{{\'MoreInformation.Text\'| translate}}</h2></div><!--  --><div class=col-sm-6><div class=bound-box><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'CloudCover.Text\'| translate}}</label><div class=value>{{vm.weatherDetails.cloudCover}}%</div></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'Humidity.Text\'| translate}}</label><div class=value>{{vm.weatherDetails.humidity}}%</div></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'Precip.Text\'| translate}} (mm)</label><div class=value>{{vm.weatherDetails.precip | number:1}}</div></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'Pressure.Text\'| translate}}</label><div class=value>{{vm.weatherDetails.pressure | number:0}} (mb)</div></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'SwellDirection.Text\'| translate}}</label><div class=value>{{vm.weatherDetails.swellDirection}}&deg;</div></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'SwellHeight.Text\'| translate}}</label><div class=value>{{vm.weatherDetails.swellHeight | number:1 | height}}</div></div></div></div><div class=col-sm-6><div class=bound-box><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'SwellPeriod.Text\'| translate}}</label><div class=value>{{vm.weatherDetails.swellPeriod | number:1}} (s)</div></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'Visibility.Text\'| translate}}</label><div class=value>{{vm.weatherDetails.visibility}} (m)</div></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'WaterTemperature.Text\'| translate}}</label><div class=value>{{vm.weatherDetails.waterTemperature | number:0 | temperature}}</div></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'WindDirection.Text\'| translate}}</label><div class=value>{{vm.weatherDetails.windDirection}}&deg;</div></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'WindSpeed.Text\'| translate}}</label><div class=value>{{vm.weatherDetails.windSpeed | number:0 | speed}}</div></div></div></div><div class=\"col-sm-12 mid\"><button class=\"oval-btn red\" ng-click=\"vm.showMoreInfo=false\">{{\'LessInfo.Text\'| translate}}</button></div></div></div><div ng-hide=!vm.show7days ng-if=\"vm.foreCast!=null\"><div class=\"col-sm-12 mid button-bar\"><button class=\"oval-btn small\" ng-click=\"vm.show7days=false\">{{\'Today.Text\'| translate}}</button> <button class=\"oval-btn small active\" ng-click=\"vm.show7days=true\">{{\'Next7Days.Text\'| translate}}</button></div><div data-ng-repeat=\"s in vm.foreCast\" ng-init=\"s.showTides = true\"><div class=col-sm-12><h1 class=weather-heading>{{s.date|date:\'dd-MMM-yyyy\'}}</h1><div class=weather-box><div class=temperature><div class=temperature-info>{{s.weatherDetails.feelsLike|number:0}}&deg;</div><div class=min-max>{{s.minTemperature |number:0 | temperature}} / {{s.maxTemperature |number:0 | temperature}}</div></div><div class=day-info><ul><li><div class=icon><img src=assets/images/sunrise.png></div><div class=detail><span>{{\'Rise.Text\'| translate}}</span>{{s.sunrise|date:\'hh:mm a\'}}</div></li><li><div class=icon><img src=assets/images/sunset.png></div><div class=detail><span>{{\'Set.Text\'| translate}}</span>{{s.sunset|date:\'hh:mm a\'}}</div></li><li><div class=icon><img src=assets/images/rise.png></div><div class=detail><span>{{\'Rise.Text\'| translate}}</span>{{s.moonrise|date:\'hh:mm a\'}}</div></li><li><div class=icon><img src=assets/images/set.png></div><div class=detail><span>{{\'Set.Text\'| translate}}</span>{{s.moonset|date:\'hh:mm a\'}}</div></li></ul></div></div></div><!--  --><div class=\"col-sm-12 mid\" ng-if=\"s.showTides == false\"><button ng-click=\"s.showTides = true\" class=\"oval-btn red\">{{\'TidesInfo.Text\'| translate}}</button></div><div class=\"col-sm-12 mid\" ng-if=\"s.showTides == true\"><h2 class=sub-heading>{{\'TidesInformation.Text\'| translate}}</h2></div><!--  --><div class=col-sm-6 data-ng-repeat=\"t in s.sentinelWeatherTide\" ng-if=\"s.showTides == true\"><div class=bound-box><label class=field>{{t.tideDateTime|date:\'dd-MMMM-yyyy hh:mm a\'}}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'TideHeight.Text\'| translate}}</label><div class=value>{{t.tideHeight | number:1 | height}}</div></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'TideType.Text\'| translate}}</label><div class=value>{{t.tideType}}</div></div></div></div><div class=\"col-sm-12 mid\" ng-if=\"s.showTides == true\"><button ng-click=\"s.showTides = false\" class=\"oval-btn red\">{{\'HideTidesInfo.Text\'| translate}}</button></div><div ng-hide=t.showMoreInfo7days class=\"col-sm-12 mid\"><button class=\"oval-btn red\" ng-click=\"t.showMoreInfo7days=true\">{{\'MoreInfo.Text\'| translate}}</button></div><div ng-hide=!t.showMoreInfo7days><div class=\"col-sm-12 mid\"><h2 class=sub-heading>{{\'MoreInformation.Text\'| translate}}</h2></div><!--  --><div class=col-sm-6><div class=bound-box><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'CloudCover.Text\'| translate}}</label><div class=value>{{s.weatherDetails.cloudCover}}%</div></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'Humidity.Text\'| translate}}</label><div class=value>{{s.weatherDetails.humidity}}%</div></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'Precip.Text\'| translate}} (mm)</label><div class=value>{{s.weatherDetails.precip | number:1}}</div></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'Pressure.Text\'| translate}}</label><div class=value>{{s.weatherDetails.pressure | number:0}} (mb)</div></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'SwellDirection.Text\'| translate}}</label><div class=value>{{s.weatherDetails.swellDirection}}&deg;</div></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'SwellHeight.Text\'| translate}}</label><div class=value>{{s.weatherDetails.swellHeight | number:1 | height}}</div></div></div></div><div class=col-sm-6><div class=bound-box><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'SwellPeriod.Text\'| translate}}</label><div class=value>{{s.weatherDetails.swellPeriod | number:1}} (s)</div></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'Visibility.Text\'| translate}}</label><div class=value>{{s.weatherDetails.visibility | height}}</div></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'WaterTemperature.Text\'| translate}}</label><div class=value>{{s.weatherDetails.waterTemperature | number:0 | temperature}}</div></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'WindDirection.Text\'| translate}}</label><div class=value>{{s.weatherDetails.windDirection}}&deg;</div></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'WindSpeed.Text\'| translate}}</label><div class=value>{{s.weatherDetails.windSpeed | number:0 | speed}}</div></div></div></div><div ng-hide=!t.showMoreInfo7days class=\"col-sm-12 mid\"><button class=\"oval-btn red\" ng-click=\"t.showMoreInfo7days=false\">{{\'LessInfo.Text\'| translate}}</button></div></div></div></div>");
$templateCache.put("app/main/alarm/battery/battery.html","<div class=col-sm-12 style=margin-left:-5px><a href ng-click=vm.goBack() style=\"float: left\"><img src=assets/images/back.png class=back-btn2></a></div><div class=row><div class=col-sm-6><div class=bound-box><label class=field>{{\'BoatText.Text\'| translate}}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'BatteryType.Text\'| translate}}</label><div class=btn-group ng-if=\"vm.oemConfig.ys6Alarms.battery.batteryOptions() == 3\"><label class=\"btn btn-primary\" ng-model=vm.radioModel ng-click=vm.handleBoatBatteryChange() uib-btn-radio=12>12V</label><label class=\"btn btn-primary\" ng-model=vm.radioModel ng-click=vm.handleBoatBatteryChange() uib-btn-radio=24>24V</label><label class=\"btn btn-primary\" ng-model=vm.radioModel ng-click=vm.handleBoatBatteryChange() uib-btn-radio=36>36V</label></div><switch ng-if=\"vm.oemConfig.ys6Alarms.battery.batteryOptions() == 2\" id=enabled1 name=enabled1 off=12v on=24v ng-change=vm.handleBoatBatteryChange() ng-model=vm.boatBatteryAlarm.battery class=\"green wide\"></switch></div><div class=\"col-sm-12 card small flex-card\"><rzslider rz-slider-model=vm.boatBatteryAlarm.alarm.alarmValue.triggerValue rz-slider-options=vm.boatBatteryAlarm.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'Enabled.Text\'| translate}}</label><switch id=enabled3 name=enabled3 ng-model=vm.boatBatteryAlarm.alarm.enabled class=green></switch></div></div></div><!--  --><div class=col-sm-6><div class=bound-box><label class=field>{{\'CentralBoatText.Text\'| translate}}</label><!--<div class=\"col-sm-12 card small flex-card\">\r\n      <label class=\"card-label\">Battery type</label>\r\n      <switch id=\"enabled2\" name=\"enabled2\" off=\"12v\" on=\"24v\" ng-change=\"vm.handleSentinelBatteryChange()\" ng-model=\"vm.sentinelBatteryAlarm.battery\"\r\n        class=\"green wide\"></switch>\r\n    </div>\r\n    <div class=\"col-sm-12 card small flex-card\">\r\n      <rzslider rz-slider-model=\"vm.sentinelBatteryAlarm.alarm.alarmValue.triggerValue\" rz-slider-options=\"vm.sentinelBatteryAlarm.options\">\r\n      </rzslider>\r\n    </div>--><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'Enabled.Text\'| translate}}</label><switch id=enabled4 name=enabled4 ng-model=vm.sentinelBatteryAlarm.alarm.enabled class=green></switch></div></div></div></div><!--  --><div class=row><div class=col-sm-6 ng-repeat=\"v in vm.voltageSensors\"><div class=bound-box><label class=field>{{v.sensorName}}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'BatteryType.Text\'| translate}}</label><switch id=enabled1 name=enabled1 off=12v on=24v ng-change=vm.handleVoltageBatteryChange(v.voltageAlarm) ng-model=v.voltageAlarm.battery class=\"green wide\"></switch></div><div class=\"col-sm-12 card small flex-card\"><rzslider rz-slider-model=v.voltageAlarm.alarm.alarmValue.triggerValue rz-slider-options=v.voltageAlarm.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'Enabled.Text\'| translate}}</label><switch id=enabled3 name=enabled3 ng-model=v.voltageAlarm.enabled class=green></switch></div></div></div></div><!--  --><div class=\"col-sm-12 mid\" ng-if=vm.hasAccess><button class=\"oval-btn blue\" ng-click=vm.updateAlarms()>{{\'SaveChanges.Text\'| translate}}</button></div>");
$templateCache.put("app/main/alarm/battery/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.ys6Alarms.logo.show() src={{vm.oemConfig.ys6Alarms.logo.image}} class=symbol><h2 class=red-border-bottom>{{\'Battery.Text\'| translate}}</h2><div class=status>{{\'LastUpdatedOn.Text\'| translate}} {{vm.lastUpdated | utcDate}}</div></div>");
$templateCache.put("app/main/alarm/door/door.html","<!--<div class=\"col-sm-6\">\r\n    <div class=\"bound-box\">\r\n        <label class=\"field\">Sensor name</label>\r\n\r\n        <div class=\"col-sm-12 card small flex-card\">\r\n            <label class=\"card-label\">Door alarm</label>\r\n            <switch ng-model=\"vm.enableDoorAlarm\" class=\"green\"></switch>\r\n        </div>\r\n    </div>\r\n\r\n</div>--><div class=col-sm-12 style=margin-left:-5px><a href ng-click=vm.goBack() style=\"float: left\"><img src=assets/images/back.png class=back-btn2></a></div><div class=col-sm-6 ng-repeat=\"s in vm.sensors\"><div class=bound-box><label class=field>{{\'DoorSensor.Text\' | translate}} {{$index + 1}}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'Enabled.Text\'| translate}}</label><switch ng-model=s.enabled class=green></switch></div></div></div><div class=\"col-sm-12 mid\" ng-if=vm.hasAccess><button ng-click=vm.updateAlarm() class=\"oval-btn blue\">{{\'SaveChanges.Text\'| translate}}</button></div>");
$templateCache.put("app/main/alarm/door/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.ys6Alarms.logo.show() ng-src={{vm.oemConfig.ys6Alarms.logo.image}} class=symbol><h2 class=red-border-bottom>{{\'Door.Text\'| translate}}</h2><div class=status>{{\'LastUpdatedOn.Text\'| translate}} {{vm.lastUpdated | utcDate}}</div></div>");
$templateCache.put("app/main/alarm/highwater/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.ys6Alarms.logo.show() ng-src={{vm.oemConfig.ys6Alarms.logo.image}} class=symbol><h2 class=red-border-bottom>{{\'HighWater.Text\'| translate}}</h2><div class=status>{{\'LastUpdatedOn.Text\'| translate}} {{vm.lastUpdated | utcDate}}</div></div>");
$templateCache.put("app/main/alarm/highwater/highwater.html","<div class=col-sm-12 style=margin-left:-5px><a href ng-click=vm.goBack() style=\"float: left\"><img src=assets/images/back.png class=back-btn2></a></div><div ng-if=\"vm.sensors.length>0\"><div class=col-sm-6><div class=bound-box><label class=field>{{\'HighWater.Text\'| translate}}</label><div class=\"col-sm-12 card small flex-card\" ng-repeat=\"s in vm.sensors\"><label class=card-label>{{s.sensorName}}</label><switch ng-model=s.enabled class=green></switch></div></div></div><div class=\"col-sm-12 mid\" ng-if=vm.hasAccess><button ng-click=vm.updateAlarm() class=\"oval-btn blue\">{{\'SaveChanges.Text\'| translate}}</button></div></div>");
$templateCache.put("app/main/alarm/item-security/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.ys6Alarms.logo.show() ng-src={{vm.oemConfig.ys6Alarms.logo.image}} class=symbol><h2 class=red-border-bottom>{{\'ItemSecurity.Text\' | translate}}</h2><div class=status>{{\'LastUpdatedOn.Text\' | translate}} {{vm.lastUpdated | utcDate}}</div></div>");
$templateCache.put("app/main/alarm/item-security/item-security.html","<!--  --><div class=col-sm-12 style=margin-left:-5px><a href ng-click=vm.goBack() style=\"float: left\"><img src=assets/images/back.png class=back-btn2></a></div><div ng-repeat=\"s in vm.sensors\" class=col-sm-12><div class=col-sm-6><div class=bound-box><label class=field>{{\'ItemSecurity.Text\'| translate}} {{$index + 1}}</label><div class=\"col-sm-12 card small flex-card\"><rzslider rz-slider-model=s.alarmValue rz-slider-options=vm.sliderOptions></rzslider></div></div></div><!--  --><!--  --><div class=col-sm-6><div class=bound-box><label class=field>{{\'TurnOnOrOff.Text\' | translate}}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'Enabled.Text\' | translate}}</label><switch id=enabled1 name=enabled1 ng-model=s.enabled class=green></switch></div></div></div></div><!--  --><div class=\"col-sm-12 mid\" ng-if=vm.hasAccess><button ng-click=vm.saveItemSecurityAlarm() class=\"oval-btn blue\">{{\'SaveChanges.Text\' | translate}}</button></div>");
$templateCache.put("app/main/alarm/motiondetector/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.ys6Alarms.logo.show() ng-src={{vm.oemConfig.ys6Alarms.logo.image}} class=symbol><h2 class=red-border-bottom>{{\'MotionDetector.Text\'| translate}}</h2><div class=status>{{\'LastUpdatedOn.Text\'| translate}} {{vm.lastUpdated | utcDate}}</div></div>");
$templateCache.put("app/main/alarm/motiondetector/motiondetector.html","<div class=col-sm-12 style=margin-left:-5px><a href ng-click=vm.goBack() style=\"float: left\"><img src=assets/images/back.png class=back-btn2></a></div><div ng-if=\"vm.sensors.length>0\"><div class=col-sm-6><div class=bound-box><label class=field>{{\'MotionDetection.Text\'| translate}}</label><div class=\"col-sm-12 card small flex-card\" ng-repeat=\"s in vm.sensors\"><label class=card-label>{{s.sensorName}}</label><switch ng-model=s.enabled class=green></switch></div></div></div><div class=\"col-sm-12 mid\" ng-if=vm.hasAccess><button ng-click=vm.updateAlarm() class=\"oval-btn blue\">{{\'SaveChanges.Text\'| translate}}</button></div></div>");
$templateCache.put("app/main/alarm/nmea/error-box-dialog.html","<div class=modal-content><div class=modal-body><img src=assets/images/sos2.png><h3>{{\'NotSupported.Text\'| translate}}</h3><span>{{\'NmeaNetworkNotSupported.Text\'| translate}}</span> <a href=\"\" ng-click=$dismiss()>{{\'Cancel.Text\'| translate}}</a></div></div><!-- modal-content -->");
$templateCache.put("app/main/alarm/nmea/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.nmeaAlarms.logo.show() ng-src={{vm.oemConfig.nmeaAlarms.logo.image}} class=symbol><h2 class=red-border-bottom>{{\'NmeaAlarms.Text\'| translate}}</h2><div class=status>{{\'LastAmendedOn.Text\'| translate}} {{vm.timeStamp}}</div></div>");
$templateCache.put("app/main/alarm/nmea/index.html","<div class=alarm-box><!--  --><div class=row><div class=col-sm-12><div class=\"col-sm-6 p-0\"><div class=bound-box><div class=\"col-md-6 col-sm-6 card small flex-card\"><label class=card-label>YS6</label><switch ng-click=vm.showYS6Alarms(); ng-model=vm.enabled class=green></switch><label class=\"card-label text-right\">NMEA</label></div></div></div></div></div><div class=row><div class=col-sm-6><div class=bound-box><div class=\"col-sm-12 card small flex-card blank\"><label class=field style=width:80%>{{ \"Alarm.Text\" | translate }}</label><label class=field>{{ \"Status2.Text\" | translate }}</label></div><div class=\"col-sm-12 card small flex-card\" ng-click=vm.goToTimeToEmptyAlarm()><label class=card-label style=width:80%>{{ \"TimeToEmpty.Text\" | translate }}</label><div><div class=\"round-bagde green\" uib-tooltip=\"{{ \'AlarmActivated.Text\' | translate }}\" ng-if=\"vm.nmeaAlarmsStatus.timeToEmptyAlarmStatus == true\"></div><div class=\"round-bagde red\" uib-tooltip=\"{{ \'AlarmInactive.Text\' | translate }}\" ng-if=\"vm.nmeaAlarmsStatus.timeToEmptyAlarmStatus == false\"></div></div><a><img src=assets/images/arrow.png class=\"card-icon pull-right\"></a></div><div class=\"col-sm-12 card small flex-card\" ng-click=vm.goToPositionAndSpeedAlarm()><label class=card-label style=width:80%>{{ \"PositionAndSpeed.Text\" | translate }}</label><div><div class=\"round-bagde green\" uib-tooltip=\"{{ \'AlarmActivated.Text\' | translate }}\" ng-if=\"vm.nmeaAlarmsStatus.positionAndSpeedAlarmStatus == true\"></div><div class=\"round-bagde red\" uib-tooltip=\"{{ \'AlarmInactive.Text\' | translate }}\" ng-if=\"vm.nmeaAlarmsStatus.positionAndSpeedAlarmStatus == false\"></div></div><a><img src=assets/images/arrow.png class=\"card-icon pull-right\"></a></div><div class=\"col-sm-12 card small flex-card\" ng-click=vm.goToWaterDepthAlarm()><label class=card-label style=width:80%>{{ \"WaterDepth.Text\" | translate }}</label><div><div class=\"round-bagde green\" uib-tooltip=\"{{ \'AlarmActivated.Text\' | translate }}\" ng-if=\"vm.nmeaAlarmsStatus.waterDepthAlarmStatus == true\"></div><div class=\"round-bagde red\" uib-tooltip=\"{{ \'AlarmInactive.Text\' | translate }}\" ng-if=\"vm.nmeaAlarmsStatus.waterDepthAlarmStatus == false\"></div></div><a><img src=assets/images/arrow.png class=\"card-icon pull-right\"></a></div><div class=\"col-sm-12 card small flex-card\" ng-click=vm.goToEnginesAlarm()><label class=card-label style=width:80%>{{ \"Engines.Text\" | translate }}</label><div><div class=\"round-bagde green\" uib-tooltip=\"{{ \'AlarmActivated.Text\' | translate }}\" ng-if=\"vm.nmeaAlarmsStatus.enginesAlarmStatus == true\"></div><div class=\"round-bagde red\" uib-tooltip=\"{{ \'AlarmInactive.Text\' | translate }}\" ng-if=\"vm.nmeaAlarmsStatus.enginesAlarmStatus == false\"></div></div><a><img src=assets/images/arrow.png class=\"card-icon pull-right\"></a></div><div class=\"col-sm-12 card small flex-card\" ng-click=vm.goToFluidLevelsAlarm()><label class=card-label style=width:80%>{{ \"FluidLevels.Text\" | translate }}</label><div><div class=\"round-bagde green\" uib-tooltip=\"{{ \'AlarmActivated.Text\' | translate }}\" ng-if=\"vm.nmeaAlarmsStatus.fluidLevelAlarmStatus == true\"></div><div class=\"round-bagde red\" uib-tooltip=\"{{ \'AlarmInactive.Text\' | translate }}\" ng-if=\"vm.nmeaAlarmsStatus.fluidLevelAlarmStatus == false\"></div></div><a><img src=assets/images/arrow.png class=\"card-icon pull-right\"></a></div></div></div><div class=col-sm-6><div class=bound-box><div class=\"col-sm-12 card small flex-card blank hidden-xs\"><label class=field style=width:80%>{{ \"Alarm.Text\" | translate }}</label><label class=field>{{ \"Status2.Text\" | translate }}</label></div><div class=\"col-sm-12 card small flex-card\" ng-click=vm.goToPowerAlarm()><label class=card-label style=width:80%>{{ \"PowerAlarm.Text\" | translate }}</label><div><div class=\"round-bagde green\" uib-tooltip=\"{{ \'AlarmActivated.Text\' | translate }}\" ng-if=\"vm.nmeaAlarmsStatus.powerAlarmStatus == true\"></div><div class=\"round-bagde red\" uib-tooltip=\"{{ \'AlarmInactive.Text\' | translate }}\" ng-if=\"vm.nmeaAlarmsStatus.powerAlarmStatus == false\"></div></div><a><img src=assets/images/arrow.png class=\"card-icon pull-right\"></a></div><!-- ui-sref=\"boat.nmea_bilge_alarm({sentinelId: vm.currentSentinelId})\" --><div class=\"col-sm-12 card small flex-card\" ng-click=vm.goToSpeedLimitAlarm()><label class=card-label style=width:80%>{{ \"SpeedLimit.Text\" | translate }}</label><div><div class=\"round-bagde green\" uib-tooltip=\"{{ \'AlarmActivated.Text\' | translate }}\" ng-if=\"vm.nmeaAlarmsStatus.speedLimitAlarmStatus == true\"></div><div class=\"round-bagde red\" uib-tooltip=\"{{ \'AlarmInactive.Text\' | translate }}\" ng-if=\"vm.nmeaAlarmsStatus.speedLimitAlarmStatus == false\"></div></div><!-- ui-sref=\"boat.nmea_bilge_alarm({sentinelId: vm.currentSentinelId})\" --> <a ng-click=vm.goToSpeedLimitAlarm()><img src=assets/images/arrow.png class=\"card-icon pull-right\"></a></div><div class=\"col-sm-12 card small flex-card\" ng-click=vm.goToTemperatureAndHumidityAlarm()><label class=card-label style=width:80%>{{ \"TemperatureAndHumidity.Text\" | translate }}</label><div><div class=\"round-bagde green\" uib-tooltip=\"{{ \'AlarmActivated.Text\' | translate }}\" ng-if=\"vm.nmeaAlarmsStatus.tempAndHumidityAlarmStatus == true\"></div><div class=\"round-bagde red\" uib-tooltip=\"{{ \'AlarmInactive.Text\' | translate }}\" ng-if=\"vm.nmeaAlarmsStatus.tempAndHumidityAlarmStatus == false\"></div></div><a><img src=assets/images/arrow.png class=\"card-icon pull-right\"></a></div><div class=\"col-sm-12 card small flex-card\" ui-sref=\"boat.nmea_manufacturer_set_alarm({sentinelId: vm.currentSentinelId})\"><label class=card-label style=width:80%>{{ \"ManufacturerSet.Text\" | translate }}</label><div><div class=\"round-bagde green\" uib-tooltip=\"{{ \'AlarmActivated.Text\' | translate }}\" ng-if=\"vm.nmeaAlarmsStatus.manufacturerSetAlarmStatus == true\"></div><div class=\"round-bagde red\" uib-tooltip=\"{{ \'AlarmInactive.Text\' | translate }}\" ng-if=\"vm.nmeaAlarmsStatus.manufacturerSetAlarmStatus == false\"></div></div><a ui-sref=\"boat.nmea_manufacturer_set_alarm({sentinelId: vm.currentSentinelId})\"><img src=assets/images/arrow.png class=\"card-icon pull-right\"></a></div><div class=\"col-sm-12 card small flex-card\" ng-click=vm.goToWindSpeedAlarm()><label class=card-label style=width:80%>{{ \"WindSpeed.Text\" | translate }}</label><div><div class=\"round-bagde green\" uib-tooltip=\"{{ \'AlarmActivated.Text\' | translate }}\" ng-if=\"vm.nmeaAlarmsStatus.windSpeedAlarmStatus == true\"></div><div class=\"round-bagde red\" uib-tooltip=\"{{ \'AlarmInactive.Text\' | translate }}\" ng-if=\"vm.nmeaAlarmsStatus.windSpeedAlarmStatus == false\"></div></div><a><img src=assets/images/arrow.png class=\"card-icon pull-right\"></a></div></div></div></div><!--  --><div class=row><div class=col-sm-6><div class=bound-box><div class=\"col-sm-12 card small flex-card\"><div class=my-legend><div class=legend-scale><ul class=legend-labels><li><span class=\"badge green\"></span> <b>{{ \"Active.Text\" | translate }}</b></li><li><span class=\"badge red\"></span> <b>{{ \"Inactive.Text\" | translate }}</b></li></ul></div></div></div></div></div></div></div>");
$templateCache.put("app/main/alarm/position/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.ys6Alarms.logo.show() ng-src={{vm.oemConfig.ys6Alarms.logo.image}} class=symbol><h2 class=red-border-bottom>{{\'Position.Text\'|translate}}</h2><div class=status>{{\'LastUpdateOn.Text\'|translate}} {{vm.lastUpdated | utcDate}}</div></div>");
$templateCache.put("app/main/alarm/position/map.html","<style>.map.alarm {\r\n    height: 600px;\r\n    width: 90%;\r\n    margin: auto;\r\n  }</style><div class=row style=\"margin: 0\"><div class=col-sm-12 style=margin-left:-5px;margin-bottom:15px><a href ng-click=vm.goBack() style=\"float: left\"><img src=assets/images/back.png class=back-btn2></a></div><div class=col-md-12 style=\"margin-bottom: 25px\"><div id=map class=\"map alarm\"></div></div></div>");
$templateCache.put("app/main/alarm/position/position.html","<!--  --><div class=col-sm-4><div class=bound-box><label class=\"field pull-left\" style=margin-left:0>{{\'Longitude.Text\'| translate}} {{vm.sentinelLocation.center.longitude | number:2}}/ {{\'Latitude.Text\'| translate}} {{vm.sentinelLocation.center.latitude | number:2}}</label></div></div><div class=col-sm-6><div class=bound-box><switch id=enabled1 name=enabled1 off=\"Short range\" on=\"Long range\" ng-change=vm.handleRangeChange() ng-model=vm.positionAlarmRange class=\"green wide x-wide\"></switch></div></div><!--  --><!--  --><!--<div class=\"col-sm-6\">\r\n  <div class=\"bound-box\">\r\n    <label class=\"field\">Distance from fence center: {{vm.distance | number:1}}m  </label>\r\n  </div>\r\n</div>--><!--  --><div class=col-sm-12><div class=bound-box><div class=\"col-sm-12 card small flex-card\"><!--  --><rzslider ng-if=\"vm.noPositionData == false\" rz-slider-model=vm.geoFenceAlarm.map.radius rz-slider-options=vm.sliderOptions></rzslider><div ng-if=\"vm.noPositionData == true\" class=danger uib-alert>{{\'NoLocationData.Text\'| translate}}</div><!--  --></div><div class=\"col-sm-6 card small flex-card\"><label class=card-label>{{ \"MoveOut.Text\" | translate }}</label><switch id=enabled4 name=enabled4 ng-model=vm.geoFenceAlarm.moveOutEnabled class=green></switch></div><div class=\"col-sm-6 card small flex-card\"><label class=card-label>{{ \"MoveIn.Text\" | translate }}</label><switch id=enabled4 name=enabled4 ng-model=vm.geoFenceAlarm.moveInEnabled class=green></switch></div></div></div><!--  --><div ng-if=vm.hasAccess><div class=\"col-sm-6 mid\"><button ng-if=\"vm.noPositionData == false\" class=\"oval-btn blue pull-right\" ng-click=vm.saveGeofenceAlarm()>{{\'SaveChanges.Text\'| translate}}</button></div><div class=\"col-sm-6 mid\"><button ng-if=\"vm.noPositionData == false\" class=\"oval-btn red pull-left\" ng-click=vm.resetGeoFenceToCurrentLocation()>{{\'Reset.Text\'| translate}}</button></div></div>");
$templateCache.put("app/main/alarm/safe-return/existing-contact-dialog.html","<form novalidate=\"\" ng-submit=\"form.$valid && vm.saveContact()\" name=form><div class=modal-content><div class=modal-header><button class=close type=button ng-click=$dismiss()>x</button><h3 class=modal-title>{{\'AddContact.Text\'| translate}}</h3></div><div class=modal-body><div class=full-width><div class=content-box><div class=table-responsive><table class=\"table table-condensed table-hover table-bordered table-striped m-table\"><thead><tr><td>{{\'Name.Text\'| translate}}</td><td>{{\'Email.Text\'| translate}}</td><td>{{\'Add.Text\'| translate}}</td></tr></thead><tbody><tr ng-repeat=\"contact in vm.newContacts\"><td>{{contact.name}}</td><td>{{contact.emailAddress}}</td><td><input type=checkbox id=contact.id class=checkbox-visible ng-model=contact.isSelected></td></tr></tbody></table></div><button type=submit class=\"oval-btn red text-center\">{{\'AddContact.Text\'| translate}}</button> <a class=link ng-click=$dismiss() type=button>{{\'Cancel.Text\'| translate}}</a></div></div></div></div></form>");
$templateCache.put("app/main/alarm/safe-return/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.ys6Alarms.logo.show() ng-src={{vm.oemConfig.ys6Alarms.logo.image}} class=symbol><h2 class=red-border-bottom>{{\'SafeReturn.Text\'|translate}}</h2><div class=status>{{\'LastUpdateOn.Text\'|translate}} {{vm.lastUpdated | utcDate}}</div></div>");
$templateCache.put("app/main/alarm/safe-return/map.html","<style>.map.alarm {\r\n    height: 600px;\r\n    width: 90%;\r\n    margin: auto;\r\n  }</style><div class=row style=\"margin: 0\"><div class=col-sm-12 style=margin-left:-5px;margin-bottom:15px><a href ng-click=vm.goBack() style=\"float: left\"><img src=assets/images/back.png class=back-btn2></a></div><div class=col-md-12 style=\"margin-bottom: 25px\"><div id=map class=\"map alarm\"></div></div></div>");
$templateCache.put("app/main/alarm/safe-return/safe-return.html","<div class=row><div class=col-sm-4><div class=bound-box><label class=\"field pull-left\" style=margin-left:0 ng-if=\"vm.sentinelLocation.markers[1].coords!=undefined\">{{\'Latitude.Text\'| translate}} {{vm.sentinelLocation.markers[1].coords.latitude | number:2}} / {{\'Longitude.Text\'| translate}} {{vm.sentinelLocation.markers[1].coords.longitude | number:2}}</label></div></div></div><div class=row><div class=col-sm-12><div class=bound-box><div class=\"col-sm-6 card small flex-card\" ng-click=vm.deleteSafeReturnLocation()><label class=card-label>{{\'Enabled.Text\' | translate}}</label><switch id=enabled4 name=enabled4 ng-model=vm.sentinelLocation.Enabled class=green></switch></div><div class=\"col-sm-12 card small flex-card\" ng-if=vm.sentinelLocation.Enabled><rzslider ng-if=\"vm.noPositionData == false\" rz-slider-model=vm.sentinelLocation.map.radius rz-slider-options=vm.sliderOptions></rzslider><div ng-if=\"vm.noPositionData == true\" class=danger uib-alert>{{\'NoLocationData.Text\'| translate}}</div></div><div class=\"col-sm-6 card small flex-card\" ng-if=vm.sentinelLocation.Enabled><label class=card-label>{{\'IsDailyAlarm.Text\' | translate}}</label><switch id=enabled5 name=enabled5 ng-model=vm.sentinelLocation.isDaily class=green></switch></div><div class=\"col-sm-6 card small\" style=display:flex;flex-direction:column ng-if=\"vm.sentinelLocation.Enabled && !vm.sentinelLocation.isDaily\"><label class=card-label>{{\'SelectDateTime\' | translate}}</label><input ng-model=vm.sentinelLocation.map.startTime type=text class=\"active form-control\" future-only datetime-picker date-format=\"dd MMMM, yyyy hh:mm:ss a\" future-only required></div><div class=\"col-sm-6 card small\" style=display:flex;flex-direction:column ng-if=\"vm.sentinelLocation.Enabled && vm.sentinelLocation.isDaily\"><label class=card-label>{{\'SelectTime\' | translate}}</label><div uib-timepicker ng-model=vm.sentinelLocation.map.startTime show-meridian=true required></div></div><div class=\"col-sm-12 card small\" style=display:flex;flex-direction:column ng-if=vm.sentinelLocation.Enabled><label class=card-label>{{\'EnterMessage.Text\'| translate}}</label><textarea uib-tooltip=\"{{\'EnterMessage.Text\'| translate}}\" rows=8 required type=text class=\"active fluid\" style=max-width:100% name=EnterMessage ng-model=vm.sentinelLocation.map.message placeholder=\"{{\'EnterMessage.Text\'| translate}}\">\r\n                </textarea><div><label class=card-label>Below is my boat\'s last known details.</label><p>Date of last message: {{vm.boatStatus.sentinelBattery.createdDate | date: \'dd MMMM, yyyy hh:mm:ss a\'}}</p><p>Boat battery: {{vm.boatStatus.sentinelBattery.boatBattery | number:1}}v</p><p>Central unit battery: {{vm.boatStatus.sentinelBattery.sentinelBattery | number:1}}v</p><p><ul><li ng-repeat=\"t in vm.boatStatus.sentinelTemperatures\"><p>{{t.sentinelSensor.sensorName}} {{t.temperature | number:0 | temperature}}</p></li></ul></p><p>Speed: {{vm.boatStatus.sentinelSpeed.speed}} {{vm.boatStatus.sentinelSpeed.units}}</p><p>Course: {{vm.boatStatus.sentinelLocation.course | courseDirection}}</p><p>{{vm.boatStatus.sentinelLocation.latitude | number:4}} / {{vm.boatStatus.sentinelLocation.longitude | number:4}}</p><p><span ng-if=vm.boatStatus.sentinelConnectivity.satellite>Satellite {{\'Connection.Text\' | translate}}</span> <span ng-if=vm.boatStatus.sentinelConnectivity.gsmSignal>3g/4G {{\'Connection.Text\' | translate}}</span></p></div></div></div></div></div><div class=row ng-if=vm.hasAccess style=\"margin-bottom: 25px\"><div class=\"col-md-4 mid\"><button ng-if=\"vm.noPositionData == false\" class=\"oval-btn blue pull-right\" ng-click=vm.saveSafeReturnAlarm()>{{\'SaveChanges.Text\'| translate}}</button></div><div class=\"col-md-4 mid\"><button ng-if=\"vm.noPositionData == false && vm.isUpdateCase\" class=\"oval-btn red\" ng-click=vm.resetSafeReturnToCurrentLocation()>{{\'Reset.Text\'| translate}}</button></div><div class=\"col-md-4 mid\" ng-if=vm.sentinelLocation.Enabled><div class=btn-group uib-dropdown ng-if=\"vm.noPositionData == false\"><button id=single-button type=button class=\"oval-btn red\" style=margin-bottom:0px uib-dropdown-toggle>{{\'Contacts.Text\'| translate}} <span class=caret></span></button><ul class=\"drop-down-fix dropdown-menu\" uib-dropdown-menu role=menu style=margin-left:18px aria-labelledby=single-button><li role=menuitem><a href ng-click=vm.newContactDialog()>{{\'AddNew.Text\'| translate}}</a></li><li role=menuitem><a href ng-click=vm.existingContactDialog()>{{\'AddExisting.Text\'| translate}}</a></li></ul></div></div><!-- <div class=\"col-sm-4 mid\">\r\n        <button ng-if=\"vm.noPositionData == false && vm.isUpdateCase\" class=\"oval-btn red pull-left\" ng-click=\"vm.deleteSafeReturnLocation()\">{{\'DeleteReturnPoint.Text\'| translate}}</button>\r\n    </div> --></div><div class=row ng-if=\"vm.sentinelLocation.Enabled && vm.noPositionData == false\"><div class=\"col-sm-6 col-xs-12\" ng-repeat=\"c in vm.contacts\"><div class=bound-box ng-if=c.isSelected><div class=\"col-sm-12 card contact-card safe-return\"><div class=card-header><i class=\"fa fa-times pull-right\" ng-click=vm.markSelectedContact(c) uib-tooltip=\"{{\'RemoveContact.Text\'| translate}}\" tooltip-placement=top-right></i></div><div class=card-body><label class=field>{{\'Name.Text\'| translate}}</label><label class=card-label>{{c.name}}</label><label class=field>{{\'Email.Text\'| translate}}</label><label class=card-label>{{c.emailAddress}}</label><label class=field>{{\'Phone.Text\'| translate}}</label><label class=card-label>({{c.countryCode}}) {{c.phoneNumber}}</label></div></div></div></div></div>");
$templateCache.put("app/main/alarm/shock/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.ys6Alarms.logo.show() ng-src={{vm.oemConfig.ys6Alarms.logo.image}} class=symbol><h2 class=red-border-bottom>{{\'Shock.Text\'| translate}}</h2><div class=status>{{\'LastUpdatedOn.Text\'| translate}} {{vm.lastUpdated | utcDate}}</div></div>");
$templateCache.put("app/main/alarm/shock/shock.html","<div class=col-sm-12 style=margin-left:-5px><a href ng-click=vm.goBack() style=\"float: left\"><img src=assets/images/back.png class=back-btn2></a></div><div class=col-sm-6><div class=bound-box><label class=field>{{\'AtAnchor.Text\'| translate}}</label><div class=\"col-sm-12 card small flex-card\"><rzslider rz-slider-model=vm.mildShockAlarm.severity rz-slider-options=vm.sliderOptions></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'Enabled.Text\'| translate}}</label><switch id=mildShock name=mildShock ng-model=vm.mildShockAlarm.enabled class=green></switch></div></div></div><div class=col-sm-6><div class=bound-box><label class=field>{{\'AtSea.Text\'| translate}}</label><div class=\"col-sm-12 card small flex-card\"><rzslider rz-slider-model=vm.severeShockAlarm.severity rz-slider-options=vm.sliderOptions></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'Enabled.Text\'| translate}}</label><switch id=severeShock name=severeShock ng-model=vm.severeShockAlarm.enabled class=green></switch></div></div></div><div class=\"col-sm-12 mid\" ng-if=vm.hasAccess><button class=\"oval-btn blue\" ng-click=vm.updateAlarm()>{{\'SaveChanges.Text\'| translate}}</button></div>");
$templateCache.put("app/main/alarm/shorepower/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.ys6Alarms.logo.show() ng-src={{vm.oemConfig.ys6Alarms.logo.image}} class=symbol><h2 class=red-border-bottom>{{\'ShorePower.Text\'| translate}}</h2><div class=status>{{\'LastUpdatedOn.Text\'| translate}} {{vm.lastUpdated | utcDate}}</div></div>");
$templateCache.put("app/main/alarm/shorepower/shorepower.html","<!--  --><div class=col-sm-12 style=margin-left:-5px><a href ng-click=vm.goBack() style=\"float: left\"><img src=assets/images/back.png class=back-btn2></a></div><div ng-if=\"vm.sensors.length>0\"><div class=col-sm-6><div class=bound-box><label class=field>{{\'ShorePower.Text\'| translate}}</label><div class=\"col-sm-12 card small flex-card\" ng-repeat=\"s in vm.sensors\"><label class=card-label>{{s.sensorName}}</label><switch ng-model=s.enabled class=green></switch></div></div></div><!--  --><div class=\"col-sm-12 mid\" ng-if=vm.hasAccess><button class=\"oval-btn blue\" ng-click=vm.updateAlarm()>{{\'SaveChanges.Text\'| translate}}</button></div></div>");
$templateCache.put("app/main/alarm/temperature/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.ys6Alarms.logo.show() ng-src={{vm.oemConfig.ys6Alarms.logo.image}} class=symbol><h2 class=red-border-bottom>{{\'Temperature.Text\'| translate}}</h2><div class=status>{{\'LastUpdatedOn.Text\'| translate}} {{vm.lastUpdated | utcDate}}</div></div>");
$templateCache.put("app/main/alarm/temperature/temperature.html","<!--  --><div class=col-sm-12 style=\"margin-left: -5px\"><a href ng-click=vm.goBack() style=\"float: left\"><img src=assets/images/back.png class=back-btn2></a></div><div ng-if=\"vm.sensors.length>0\"><div class=col-sm-6 ng-repeat=\"s in vm.sensors\"><div class=bound-box><label class=field>{{s.sensorName | translate}}</label><div class=\"col-sm-12 card small flex-card temp-slider\"><!--  --><rzslider rz-slider-model=s.alarm.alarmValue.min rz-slider-high=s.alarm.alarmValue.max rz-slider-options=vm.sentinelAlarmSlider.options></rzslider><!--  --></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'Enabled.Text\'| translate}}</label><switch ng-model=s.enabled class=green></switch></div></div></div><!--  --><div class=\"col-sm-12 mid\" ng-if=vm.hasAccess><button class=\"oval-btn blue\" ng-click=vm.updateAlarm()>{{\'SaveChanges.Text\'| translate}}</button></div></div>");
$templateCache.put("app/main/alarm/tilt/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.ys6Alarms.logo.show() ng-src={{vm.oemConfig.ys6Alarms.logo.image}} class=symbol><h2 class=red-border-bottom>{{\'Tilt.Text\'| translate}}</h2><div class=status>{{\'LastUpdatedOn.Text\'| translate}} {{vm.lastUpdated | utcDate}}</div></div>");
$templateCache.put("app/main/alarm/tilt/tilt.html","<div class=col-sm-12 style=margin-left:-5px><a href ng-click=vm.goBack() style=\"float: left\"><img src=assets/images/back.png class=back-btn2></a></div><div class=col-sm-12><div class=bound-box uib-tooltip=\"{{\'TiltAlarmToolTip.Text\'| translate}}\"><label class=field>{{\'TiltAlarm.Text\'| translate}}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{\'Enabled.Text\'| translate}}</label><div><switch id=roughSea name=roughSea ng-model=vm.tiltAlarm.enabled class=green></switch></div></div><div class=\"col-sm-12 card small flex-card\"><rzslider rz-slider-model=vm.tiltAlarm.value rz-slider-options=vm.tiltAlarm.options></rzslider></div></div></div><!--  --><div class=\"col-sm-12 mid\" ng-if=vm.hasAccess><button ng-click=vm.saveTiltAlarms() class=\"oval-btn blue\">{{\'SaveChanges.Text\'| translate}}</button></div>");
$templateCache.put("app/main/account-settings/termsAndconditions/accept-terms.html","<div class=modal-content><div class=modal-header><button type=button class=close ng-click=$dismiss()>x</button><h3 class=modal-title>{{\'AcceptTerms.Text\'| translate}}</h3></div><div class=modal-body><div class=full-width><form novalidate name=form ng-submit=\"form.$valid && vm.updateFpAccount()\"><div style=\"margin-left: 25px; margin-right: 25px; text-align: left\"><div class=row><div class=\"col-sm-12 no-gutter\"><div class=round><input style=\"visibility: hidden !important\" type=checkbox id=round ng-model=vm.user.acceptTerms><label for=round style=\"top: -10px\"></label></div><label for=round class=\"action-label terms\" translate=\"{{ \'TermsAndConditionsStatment.Text\' }}\"></label></div></div><div class=row><div class=col-lg-12><div style=\"display: flex;\r\n               align-items: center;\r\n                  justify-content: center\"><button ng-if=!vm.login type=submit ng-disabled=!vm.user.acceptTerms class=\"oval-btn blue\">{{\'SaveChanges.Text\'| translate}} <button ng-if=vm.login type=submit ng-disabled=!vm.user.acceptTerms class=\"oval-btn blue\">{{\'AgreeAndContinue.Text\'| translate}}</button></button></div></div></div><div class=row><div class=col-lg-12><a class=link style=\"cursor: pointer\" ng-click=$dismiss() type=button>{{\'Cancel.Text\'| translate}}</a></div></div></div></form></div></div></div>");
$templateCache.put("app/main/boats/edit/edit-dialog.html","<div class=modal-content flow-init=vm.flow flow-files-submitted=$flow.upload() flow-file-success=\"vm.fileSuccess($file, $message, $flow)\"><div class=modal-header><button type=button class=close ng-click=$dismiss()>x</button><h3 class=modal-title>{{ vm.oemConfig.manageBoats.label.edit() | translate}}</h3></div><div class=modal-body><div class=full-width><div class=content-box><form novalidate name=form ng-submit=\"form.$valid && vm.saveChanges()\"><label class=field>{{ vm.oemConfig.manageBoats.label.name() | translate}}</label><input style=text-align:center required type=text class=active ng-model=vm.sentinel.name name=boat_name placeholder=\"{{ vm.oemConfig.manageBoats.label.name() | translate}}\" ng-class=\"{error: form.$submitted && form.boat_name.$invalid}\"><div ng-messages=form.boat_name.$error class=error ng-if=form.$submitted><div ng-message=required>{{ vm.oemConfig.manageBoats.label.nameRequired() | translate}}</div></div><label class=field>{{\'EnterIMEI.Text\'| translate}} (IMEI)</label><input style=text-align:center uib-tooltip=\"{{\'ProductToolTip.Text\'| translate}}\" required type=text ng-class=\"{error: form.$submitted && form.imei.$invalid}\" class=active ui-validate-async=\"{validImei: \'vm.validateImei($value)\'}\" name=imei ng-model=vm.sentinel.imei placeholder=\"{{\'EnterIMEI.Text\'| translate}}\"><br><div ng-messages=form.imei.$error class=error ng-if=form.$submitted><div ng-message=required>{{\'IMEIRequired.Text\'| translate}}</div><div ng-message=minlength>{{\'IMEIDigits.Text\'| translate}}</div><div ng-message=validImei>{{\'IMEIInvalid.Text\'| translate}}</div></div><div style=\"display: flex;align-items: center;justify-content: center\" class=col-sm-12 ng-if=!vm.sentinel.isCameraOnly><button class=\"oval-btn blue\" type=button flow-btn>{{\'ScanQR.Text\'| translate}}</button></div><label class=field>{{\'EnterMMSI.Text\'| translate}}</label><input style=text-align:center type=text ng-class=\"{error: form.$submitted && form.mmsi.$invalid}\" name=mmsi ng-model=vm.sentinel.mmsi class=active placeholder=\"{{\'EnterMMSI.Text\'| translate}}\"><div ng-messages=form.mmsi.$error class=error ng-if=form.$submitted><div ng-message=required>{{\'MMSIRequired.Text\'| translate}}</div></div><label ng-if=vm.oemConfig.SentinelProductCodeInput.show() class=field>{{ \"SentinelDomotics.Text\" | translate }}</label><input ng-if=vm.oemConfig.SentinelProductCodeInput.show() type=text name=w2k1Key style=text-align:center ui-validate-async=\"{validW2k1Key: \'vm.validateW2k1Key($value)\'}\" autocomplete=off class=active ng-model=vm.w2K1SerialKey><div ng-if=!validW2k1Key ng-messages=form.w2k1Key.$error class=error><div ng-message=validW2k1Key>{{ \"SentinelDomotics.Invalid\" | translate }}</div></div><div style=\"display: flex;align-items: center;justify-content: center\"><button type=submit class=\"oval-btn blue\">{{\'SaveChanges.Text\'| translate}}</button></div><a class=link style=\"cursor: pointer\" ng-click=$dismiss() type=button>{{\'Cancel.Text\'| translate}}</a></form></div></div></div></div>");
$templateCache.put("app/main/boats/getEmailnPassword/input.dialog.html","<div class=modal-content><div class=modal-header><button type=button class=close ng-click=$dismiss()>x</button><h3 class=modal-title>{{ \"Email and password\" | translate}}</h3></div><div class=modal-body><div class=full-width><div class=content-box><form novalidate name=form ng-submit=\"form.$valid && vm.saveChanges()\"><label class=field>{{ \'Email\' | translate}}</label><input style=text-align:center required type=email class=active ng-model=vm.email name=email placeholder=\"{{ \'Email\' | translate}}\" ng-class=\"{error: form.$submitted && form.email.$invalid}\"><div ng-messages=form.email.$error class=error ng-if=form.$submitted><div ng-message=required>{{ \"Email is required\" | translate}}</div></div><label class=field>{{\'Password\'| translate}}</label><input style=text-align:center required type=password ng-class=\"{error: form.$submitted && form.password.$invalid}\" class=active name=password ng-model=vm.password placeholder=\"{{\'Password\'| translate}}\"><br><div ng-messages=form.password.$error class=error ng-if=form.$submitted><div ng-message=required>{{\'Password is required\'| translate}}</div><!-- <div ng-message=\"minlength\">{{\'IMEIDigits.Text\'| translate}}</div>\r\n            <div ng-message=\"validImei\">{{\'IMEIInvalid.Text\'| translate}}</div> --></div><div style=\"display: flex;align-items: center;justify-content: center\"><button type=submit class=\"oval-btn blue\">{{\'SaveChanges.Text\'| translate}}</button></div><a class=link style=\"cursor: pointer\" ng-click=$dismiss() type=button>{{\'Cancel.Text\'| translate}}</a></form></div></div></div></div>");
$templateCache.put("app/main/boats/selectSellBoatTo/selectSellBoatTo.html","<div class=modal-content><div class=modal-header><button type=button class=close ng-click=$dismiss()>x</button><h3 class=modal-title>{{ \"Transfer Boat to\" | translate}}</h3></div><div class=modal-body><div class=full-width><div class=content-box><form novalidate name=form ng-submit=\"form.$valid && vm.saveChanges()\"><div class=row style=\"margin-bottom: 8%\"><div class=\"col-sm-12 no-gutter\"><div class=round><input style=\"visibility: hidden !important\" type=radio value=default name=sellTo id=default ng-model=vm.sellTo ng-click=vm.showOrHideEmailField()><label for=default class=action-label style=\"top: -10px\"></label></div><label for=default class=action-label>Transfer to default</label></div></div><div class=row style=\"margin-bottom: 8%\"><div class=\"col-sm-12 no-gutter\"><div class=round><input style=\"visibility: hidden !important\" type=radio value=existing name=sellTo id=existing ng-model=vm.sellTo ng-click=vm.showOrHideEmailField()><label for=existing class=action-label style=\"top: -10px\"></label></div><label for=existing class=action-label>Transfer to Existing User</label></div></div><div class=row ng-show=vm.showEmail><div class=col-sm-12><label for=email class=action-label>Email Address</label><input type=email ng-model=vm.email placeholder=abc@yatchSentinel.com name=email></div></div><div style=\"display: flex;align-items: center;justify-content: center\"><button type=submit class=\"oval-btn blue\">{{\'Sell Boat\' | translate}}</button></div><a class=link style=\"cursor: pointer\" ng-click=$dismiss() type=button>{{\'Cancel.Text\'| translate}}</a></form></div></div></div></div>");
$templateCache.put("app/main/boats/index/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.manageBoats.logo.show() ng-src={{vm.oemConfig.manageBoats.logo.image}} class=symbol><h2 class=red-border-bottom>{{vm.oemConfig.header.manageBoats()| translate}}</h2></div>");
$templateCache.put("app/main/boats/index/manage-boats.html","<div class=col-sm-6><form novalidate=\"\" name=form ng-submit=\"form.$valid  && vm.addNewBoat(form)\"><div class=bound-box flow-init=vm.flow flow-files-submitted=$flow.upload() flow-file-success=\"vm.fileSuccess($file, $message, $flow)\"><label class=field>{{ vm.oemConfig.manageBoats.label.add() | translate }}</label><div class=\"col-sm-12 card small\"><label class=card-label>{{ vm.oemConfig.manageBoats.label.name() | translate }}</label><input required type=text class=active ng-model=vm.sentinel.name name=boat_name placeholder=\"{{ vm.oemConfig.manageBoats.label.name() | translate }}\" ng-class=\"{error: form.$submitted && form.boat_name.$invalid}\"><div ng-messages=form.boat_name.$error class=error ng-if=form.$submitted><div ng-message=required>{{ vm.oemConfig.manageBoats.label.nameRequired() | translate }}</div></div></div><div class=\"col-sm-12 card small\" ng-if=!vm.isNmeaOnly><label class=card-label>{{ \"EnterIMEI.Text\" | translate }}</label><input uib-tooltip=\"{{ \'ProductToolTip.Text\' | translate }}\" required type=text ng-class=\"{error: form.$submitted && form.imei.$invalid}\" class=\"active fluid\" ui-validate-async=\"{validImei: \'vm.validateImei($value)\'}\" name=imei ng-model=vm.sentinel.imei placeholder=\"{{ \'EnterIMEI.Text\' | translate }}\"> <button class=\"oval-btn blue fluid\" type=button flow-btn>{{ \"ScanQR.Text\" | translate }}</button><div ng-messages=form.imei.$error class=error ng-if=form.$submitted><div ng-message=required>{{ \"IMEIRequired.Text\" | translate }}</div><div ng-message=minlength>{{ \"IMEIDigits.Text\" | translate }}</div><div ng-message=validImei>{{ \"IMEIInvalid.Text\" | translate }}</div></div></div><div class=\"col-sm-12 card small\" uib-tooltip=\"{{ \'MaritimeToolTip.Text\' | translate }}\"><label class=card-label>{{ \"EnterMMSI.Text\" | translate }}</label><input type=text ng-class=\"{error: form.$submitted && form.mmsi.$invalid}\" name=mmsi ng-model=vm.sentinel.mmsi class=active placeholder=\"{{ \'EnterMMSI.Text\' | translate }}\"></div><div ng-if=vm.oemConfig.SentinelProductCodeInput.show() class=\"col-sm-12 card small\" uib-tooltip=\"{{ \'SentinelDomoticsTip.Text\' | translate }}\"><label class=card-label>{{ \"SentinelDomotics.Text\" | translate }}</label><input type=text name=w2k1Key style=\"text-align: center\" ng-required=vm.isNmeaOnly placeholder=\"{{ \'SentinelDomotics.Text\' | translate }}\" ui-validate-async=\"{validW2k1Key: \'vm.validateW2k1Key($value)\'}\" autocomplete=off class=active ng-model=vm.w2K1SerialKey><div ng-messages=form.w2k1Key.$error class=error><div ng-if=\"vm.isNmeaOnly && form.$submitted && form.w2k1Key.$error\" ng-message=required>{{ \"SentinelDomotics.Required\" | translate }}</div><div ng-if=!validW2k1Key ng-message=validW2k1Key>{{ \"SentinelDomotics.Invalid\" | translate }}</div></div></div><div ng-if=vm.oemConfig.SentinelProductCodeInput.show() class=\"col-sm-12 card small\"><div class=round style=\"margin-top: 7px\"><input style=\"visibility: hidden !important\" type=checkbox id=isNmeaOnly name=isNmeaOnly ng-model=vm.isNmeaOnly><label for=isNmeaOnly></label></div><label for=isNmeaOnly class=\"card-label m-t-5\" style=\"display: inline-block\">{{ \'SentinelDomoticsOnly.Text\' | translate }}</label></div></div><div class=\"col-sm-12 mid\"><button type=submit class=\"oval-btn blue\">{{ vm.oemConfig.manageBoats.label.addNew() | translate }}</button></div></form></div><!--  --><!--  --><div class=col-sm-6><div class=bound-box><label class=field>{{ vm.oemConfig.manageBoats.label.myList() | translate }}</label><div class=\"col-sm-12 card small\" ng-repeat=\"s in vm.sentinels\"><label class=card-label data-ng-bind=s.name>{{ s.name }}</label><label class=field>IMEI: {{ s.imei }} MMSI: {{ s.mmsi }}</label><label ng-if=\"s.validW2K1SerialKey!=null && !vm.oemConfig.sp2Contacts.logo.show()\" class=field>SD-Key: {{ s.validW2K1SerialKey.w2K1SerialKey }}</label><a title=\"Edit Boat\" ng-click=vm.editBoatDialog(s) style=\"cursor: pointer\" class=\"pull-right edit-icon\"><img src=assets/images/edit.png></a><button ng-click=vm.deleteBoat(s) class=\"pull-right link deleteBoat\" title=\"Delete Boat\"><i style=\"margin-top: 5px\" class=\"fa fa-times fa-2x\"></i></button> <button title=\"Sell Boat\" ng-click=vm.sellBoat(s) class=\"pull-right link sell-boat-btn\" ng-if=vm.oemConfig.manageBoats.sellButton.show()>Transfer the boat to a new owner</button></div><div class=\"col-sm-12 card small\" ng-repeat=\"s in vm.sharedSentinels\"><label class=card-label data-ng-bind=s.name>{{ s.name }}</label><label class=field>IMEI: {{ s.imei }} MMSI: {{ s.mmsi }}</label><button ng-click=vm.deleteSharedBoat(s) class=\"pull-right link\"><i style=\"margin-top: 5px\" class=\"fa fa-times fa-2x\"></i></button></div></div></div>");
$templateCache.put("app/main/cameras/details/cameras.details.controller.html","<div class=alarm-box><div class=\"row m-0\"><div class=\"col-md-4 col-sm-12 p-l-10\" ng-if=vm.canViewLive ng-click=vm.viewLiveFeed()><div class=\"card small flex-card\"><label class=\"card-label full\">{{ \"LiveFeed.Text\" | translate }}</label><button class=\"pull-right link\"><i style=margin-top:5px class=\"fa fa-eye fa-2x\"></i></button></div></div><div class=\"col-md-4 col-sm-12\" ng-if=vm.canViewLive ng-click=vm.takeSnapshot()><div class=\"card small flex-card\"><label class=\"card-label full\">{{ \"CaptureSnapshot.Text\" | translate }}</label><button class=\"pull-right link\"><i style=margin-top:5px class=\"fa fa-camera fa-2x\"></i></button></div></div><div class=\"col-md-4 col-sm-12\" ng-click=vm.viewSettings() ng-if=\"vm.sharedUserPermissions==null && vm.sharedUserPermissions==undefined\"><div class=\"card small flex-card\"><label class=\"card-label full\">{{ \"Settings.Text\" | translate }}</label><button class=\"pull-right link\"><i style=margin-top:5px class=\"fa fa-cog fa-2x\"></i></button></div></div></div><div class=\"row m-0\" style=margin-top:10px ng-hide=\"vm.videoLoaded==\'\'\"><div class=col-xs-12><img id=video style=\"width: 100%\"><p ng-if=\"vm.showTrialVideo==true\"><video id=trialVideo style=width:100% controls><source ng-src=\"{{ vm.trialVideo }}\" type=video/mp4></video></p><uib-progressbar ng-if=\"vm.showTrialVideo==false\" class=\"progress-striped active\" max=vm.streamMax value=vm.streamValue type=info><i>{{vm.streamValue}} sec / {{vm.streamMax}} sec</i></uib-progressbar></div></div><div class=\"row m-0\" style=margin-top:10px ng-hide=\"vm.imageLoaded==\'\'\"><div class=col-xs-12><img ng-src=\"{{ vm.snapshot }}\" id=snapshot></div></div><div class=\"row m-0\" style=margin-top:10px ng-if=\"vm.videoLoaded!=\'\'\"><div class=col-sm-12><button class=\"btn btn-primary\" ng-click=vm.closeLiveFeed()><i class=\"fa fa-times\"></i> {{ \"CloseLiveFeed.Text\" | translate }}</button></div></div><div class=\"row m-0\" style=margin-top:10px ng-if=\"vm.imageLoaded!=\'\'\"><div class=col-sm-12><button class=\"btn btn-primary\" ng-click=vm.closeSnapshot()><i class=\"fa fa-times\"></i> {{ \"CloseSnapshot.Text\" | translate }}</button></div></div><div class=\"row m-0\" style=margin-top:20px ng-if=\"vm.canViewAlert && vm.events.length > 0\"><div class=col-md-12><timeline><timeline-event ng-repeat=\"event in vm.events\" side=right><timeline-badge class=\"{{ event.badgeClass }} timeline-hidden\" when-visible=vm.animateElementIn when-not-visible=vm.animateElementOut><i class=\"glyphicon {{ event.badgeIconClass }}\"></i></timeline-badge><timeline-panel style=\"padding-bottom: 0px\" class=\"{{ event.badgeClass }} timeline-hidden\" when-visible=vm.animateElementIn when-not-visible=vm.animateElementOut><timeline-heading><h4 ng-if=\"event.cameraEventTypeId == 1\">{{ \"CameraMotionAlert.Text\" | translate }}</h4><h4 ng-if=\"event.cameraEventTypeId == 2\">{{ \"SnapshotTaken.Text\" | translate }}</h4></timeline-heading><p><a style=\"cursor: pointer\" class=link ng-click=vm.showSnapshot(event.object) ng-if=!event.object.showSnapshotBool>{{ \"ShowSnapshot.Text\" | translate }}</a></p><p><a style=\"cursor: pointer\" class=link ng-click=vm.hideSnapshot(event.object) ng-if=\"event.object.showSnapshotBool == true\">{{ \"HideSnapshot.Text\" | translate }}</a></p><p ng-if=\"event.object.cameraEventTypeId == 1 && event.object.videoAttachment!=null\"><a style=\"cursor: pointer\" class=link ng-click=vm.showVideo(event.object) ng-if=!event.object.showVideoBool>{{ \"ShowVideo.Text\" | translate }}</a></p><p ng-if=\"event.object.cameraEventTypeId == 1\"><a style=\"cursor: pointer\" class=link ng-click=vm.hideVideo(event.object) ng-if=\"event.object.showVideoBool==true\">{{ \"HideVideo.Text\" | translate }}</a></p><p ng-if=\"event.object.showSnapshotBool==true\"><img ng-src=\"{{ event.object.snapshotAttachment.blobUri }}\"></p><p><a style=\"cursor: pointer\" class=link ng-click=vm.downloadSnapShot(event.object) target=_blank ng-if=\"event.object.showSnapshotBool == true\">{{ \"Download.Text\" | translate }}</a></p><p ng-if=\"event.object.showVideoBool==true && event.object.cameraEventTypeId == 1\"><video style=width:100% controls><source ng-src=\"{{ event.object.videoAttachment.blobUri }}\" type=video/mp4></video></p><p><a style=\"cursor: pointer\" ng-click=vm.downloadVideo(event.object) target=_blank class=link ng-if=\"event.object.showVideoBool == true\">{{ \"Download.Text\" | translate }}</a></p><hr style=\"margin-bottom:5px;margin-top: 10px\"><p><small class=text-muted style=font-size:75%><i class=\"glyphicon glyphicon-time\"></i> {{ event.time |utcDate}}</small></p></timeline-panel></timeline-event></timeline><div class=\"col-sm-12 mid\" ng-if=\"vm.events.length > 0 && vm.showLoadMore == true\"><div class=bound-box><button class=\"oval-btn red\" ng-click=vm.getEvents()><img src=assets/images/load.png> {{\'LoadMore.Text\'| translate}}</button></div></div></div></div></div>");
$templateCache.put("app/main/cameras/details/header.html","<div class=slider-caption><img src=assets//images/symbol.png class=symbol><h2 class=red-border-bottom>{{vm.camera.name}}</h2></div>");
$templateCache.put("app/main/cameras/index/cameras.html","<div class=alarm-box><div class=\"row m-0\"><div class=col-md-6><div class=bound-box><div class=\"col-sm-12 col-md-6 card small flex-card blank\"><label class=field>{{ \"Camera.Text\" | translate }}</label><label class=field>{{ \"Status2.Text\" | translate }}</label></div></div></div><div class=col-md-6 ng-hide=\"vm.totalUserSentinelCameras <= 1\"><div class=bound-box><div class=\"col-sm-12 col-md-6 card small flex-card blank\"><label class=field>{{ \"Camera.Text\" | translate }}</label><label class=field>{{ \"Status2.Text\" | translate }}</label></div></div></div></div><div class=\"row m-0\"><div class=\"col-sm-12 col-md-6\" ng-repeat=\"camera in vm.userSentinelCameras\"><div class=bound-box ng-click=vm.viewDetails(camera.cameraId)><div class=\"col-sm-6 card small flex-card\"><label class=card-label>{{ camera.name }}</label><div><div class=\"round-bagde green\" uib-tooltip=\"{{ \'Armed.Text\' | translate }}\" ng-if=\"camera.cameraStatus.online == true && camera.cameraMode.mode==\'armed\'\"></div><div class=\"round-bagde red\" uib-tooltip=\"{{ \'Disarmed.Text\' | translate }}\" ng-if=\"camera.cameraStatus.online == true && camera.cameraMode.mode==\'disarmed\'\"></div><div class=\"round-bagde grey\" uib-tooltip=\"{{ \'CameraOffline.Text\' | translate }}\" ng-if=\"camera.cameraStatus.online == false\"></div></div><a><img src=assets/images/arrow.png class=\"card-icon pull-right\"></a></div></div></div></div><div class=\"row m-0\" ng-if=\"vm.userSentinelTuyaCameras.length>0\"><div class=\"col-sm-12 col-md-6\" ng-repeat=\"device in vm.userSentinelTuyaCameras\"><div class=bound-box ng-click=vm.viewTuyaDetails(device)><div class=\"col-sm-6 card small flex-card\"><label class=card-label>{{ device.name }}</label><div class=\"round-bagde green\" uib-tooltip=\"{{ \'Armed.Text\' | translate }}\" ng-if=\"device.status && device.isArmed\"></div><div class=\"round-bagde red\" uib-tooltip=\"{{ \'Disarmed.Text\' | translate }}\" ng-if=\"device.status && !device.isArmed\"></div><div class=\"round-bagde grey\" uib-tooltip=\"{{ \'cameraOffline.Text\' | translate }}\" ng-if=\"device.status == false\"></div><a><img src=assets/images/arrow.png class=\"card-icon pull-right\"></a></div></div></div></div><div class=\"row m-0\"><div class=col-sm-6><div class=bound-box><div ng-if=\"vm.totalUserSentinelCameras==0 && vm.userSentinelTuyaCameras.length==0\" class=danger uib-alert>{{ \"NoCameras.Text\" | translate }}</div></div></div></div><!--  --><div class=\"row m-0\"><div class=col-sm-6><div class=bound-box><div class=\"col-sm-12 card small flex-card\"><div class=my-legend><div class=legend-scale><ul class=legend-labels><li><span class=\"badge green\"></span> <b>{{ \"Armed.Text\" | translate }}</b></li><li><span class=\"badge red\"></span> <b>{{ \"Disarmed.Text\" | translate }}</b></li><li><span class=\"badge grey\"></span> <b>{{ \"Offline.Text\" | translate }}</b></li></ul></div></div></div></div></div></div></div>");
$templateCache.put("app/main/cameras/index/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.camera.logo.show() ng-src={{vm.oemConfig.camera.logo.image}} class=symbol><h2 class=red-border-bottom>{{ \"ManageCameras.Text\" | translate }}</h2></div>");
$templateCache.put("app/main/cameras/tuyaDetails/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.camera.logo.show() ng-src={{vm.oemConfig.camera.logo.image}} class=symbol><h2 class=red-border-bottom>{{ vm.cameraName }}</h2></div>");
$templateCache.put("app/main/cameras/tuyaDetails/tuyaCameras.details.controller.html","<div class=alarm-box><div class=\"row m-0\"><!--    ng-if=\"vm.canViewLive\" --><div class=\"col-md-6 col-sm-12 p-l-10\" ng-click=vm.viewLiveFeed()><div class=\"card small flex-card\"><label class=\"card-label full\">{{ \"LiveFeed.Text\" | translate }}</label><button class=\"pull-right link\"><i style=margin-top:5px class=\"fa fa-eye fa-2x\"></i></button></div></div><!-- <div class=\"col-md-6 col-sm-12\" ng-if=\"vm.canViewLive\" ng-click=\"vm.takeSnapshot()\">\r\n      <div class=\"card small flex-card\">\r\n        <label class=\"card-label full\">\r\n          {{ \"CaptureSnapshot.Text\" | translate }}\r\n        </label>\r\n        <button class=\"pull-right link\">\r\n          <i style=\"margin-top:5px\" class=\"fa fa-camera fa-2x\"></i>\r\n        </button>\r\n      </div>\r\n    </div>--><div class=\"col-md-6 col-sm-12\" ng-click=vm.viewSettings()><div class=\"card small flex-card\"><label class=\"card-label full\">{{ \"Settings.Text\" | translate }}</label><button class=\"pull-right link\"><i style=\"margin-top: 5px\" class=\"fa fa-cog fa-2x\"></i></button></div></div></div><!-- <div class=\"row m-0\" style=\"margin-top:10px\" ng-hide=\"vm.imageLoaded == \'\' \">\r\n    <div class=\"col-xs-12\">\r\n      <img ng-src=\"{{ vm.snapshot }}\" id=\"snapshot\" />\r\n    </div>\r\n  </div> --><div class=\"row m-0\" style=\"margin-top: 10px\" ng-if=vm.isWatchLive><div class=col-xs-12><video id=tuyaVideoPlayer class=\"video-js vjs-default-skin\" style=\"width: 100% ; height: 477px\"><source type=application/x-mpegURL src={{vm.video}}></video><!-- <p ng-if=\"vm.showTrialVideo==true\">\r\n        <video id=\"trialVideo\" style=\"width: 100%\" controls>\r\n          <source ng-src=\"{{ vm.trialVideo }}\" type=\"video/mp4\" />\r\n        </video>\r\n      </p> --><div class=\"row m-0\" style=margin-top:10px ng-if=vm.isWatchLive><div class=\"col-sm-12 card small\" ng-if=vm.isArmedModeSupported><img src=assets/images/bolt.png class=card-icon><label class=card-label>Arm camera</label><div uib-tooltip=\" Arm/disarmed\" class=pull-right style=\"margin-top: 7px\"><i class=\"fa fa-toggle-on\" ng-class=\"vm.armedMode?\'switchActive\':\'fa-rotate-180 switchInactive\'\" ng-click=\" vm.armedFunc()\"></i></div></div><div class=\"col-sm-12 card small\" ng-if=vm.isNightVisionSupported><img src=assets/images/bolt.png class=card-icon><label class=card-label>Night Vision</label><div uib-tooltip=\"Night Vision\" class=pull-right style=\"margin-top: 7px\"><i class=\"fa fa-toggle-on\" ng-class=\"vm.nightVision?\'switchActive\':\'fa-rotate-180 switchInactive\'\" ng-click=vm.nightVisionFunc()></i></div></div><div class=\"col-sm-12 card small\" ng-if=vm.isSirenSupported><img src=assets/images/bolt.png class=card-icon><label class=card-label>Siren</label><div uib-tooltip=Siren class=pull-right style=\"margin-top: 7px\"><img src=assets/images/siren.png alt=\"\" style=\"width: 25px\" ng-click=vm.playSirenFunc()></div></div><div class=col-sm-12><button class=\"btn btn-primary btn-block\" ng-click=vm.closeLiveWatch()><i class=\"fa fa-times\"></i> {{ \"CloseLiveFeed.Text\" | translate }}</button></div></div><!-- <uib-progressbar\r\n        class=\"progress-striped active\"\r\n        max=\"vm.streamMax\"\r\n        value=\"vm.streamValue\"\r\n        type=\"info\"\r\n        ><i>{{vm.streamValue}} sec / {{vm.streamMax}} sec</i></uib-progressbar\r\n      > --></div></div><!-- <div class=\"row m-0\" style=\"margin-top:10px\" ng-if=\"vm.imageLoaded!=\'\'\">\r\n    <div class=\"col-sm-12\">\r\n      <button class=\"btn btn-primary\" ng-click=\"vm.closeSnapshot()\">\r\n        <i class=\"fa fa-times\"></i>\r\n        {{ \"CloseSnapshot.Text\" | translate }}\r\n      </button>\r\n    </div>\r\n  </div> --><div class=\"row m-0\" style=\"margin-top: 10px\" ng-if=\"vm.videoLoaded!=\'\'\"><div class=col-sm-12><button class=\"btn btn-primary\" ng-click=vm.closeLiveFeed()><i class=\"fa fa-times\"></i> {{ \"CloseLiveFeed.Text\" | translate }}</button></div></div><div class=\"row m-0\" style=margin-top:20px ng-if=\"vm.events.length > 0\"><div class=col-md-12><timeline><timeline-event ng-repeat=\"event in vm.events\" side=right><timeline-badge class=\"{{ event.badgeClass }} timeline-hidden\" when-visible=vm.animateElementIn when-not-visible=vm.animateElementOut><i class=\"glyphicon {{ event.badgeIconClass }}\"></i></timeline-badge><timeline-panel style=\"padding-bottom: 0px\" class=\"{{ event.badgeClass }} timeline-hidden\" when-visible=vm.animateElementIn when-not-visible=vm.animateElementOut><timeline-heading><h4 ng-if=\"event.cameraEventTypeId == 1\">{{ \"CameraMotionAlert.Text\" | translate }}</h4><h4 ng-if=\"event.cameraEventTypeId == 2\">{{ \"SnapshotTaken.Text\" | translate }}</h4></timeline-heading><p><a style=\"cursor: pointer\" class=link ng-click=vm.showSnapshot(event.object) ng-if=!event.object.showSnapshotBool>{{ \"ShowSnapshot.Text\" | translate }}</a></p><p><a style=\"cursor: pointer\" class=link ng-click=vm.hideSnapshot(event.object) ng-if=\"event.object.showSnapshotBool == true\">{{ \"HideSnapshot.Text\" | translate }}</a></p><p ng-if=\"event.object.cameraEventTypeId == 1 && event.object.videoAttachment!=null\"><a style=\"cursor: pointer\" class=link ng-click=vm.showVideo(event.object) ng-if=!event.object.showVideoBool>{{ \"ShowVideo.Text\" | translate }}</a></p><p ng-if=\"event.object.cameraEventTypeId == 1\"><a style=\"cursor: pointer\" class=link ng-click=vm.hideVideo(event.object) ng-if=\"event.object.showVideoBool==true\">{{ \"HideVideo.Text\" | translate }}</a></p><p ng-if=\"event.object.showSnapshotBool==true\"><img ng-src=\"{{ event.object.snapshotAttachment.blobUri }}\"></p><p ng-if=\"event.object.showVideoBool==true\"><video style=width:100% controls><source ng-src=\"{{ event.object.videoAttachment.blobUri }}\" type=video/mp4></video></p><p ng-if=\"event.object.showSnapshotBool==true\"><a style=\"cursor: pointer\" class=link ng-click=vm.downloadSnapshot(event.object)>{{ \"Download.Text\" | translate }}</a></p><p ng-if=\"event.object.showVideoBool==true\"><a style=\"cursor: pointer\" class=link ng-click=vm.downloadVideo(event.object)>{{ \"Download.Text\" | translate }}</a></p><hr style=\"margin-bottom:5px;margin-top: 10px\"><p><small class=text-muted style=font-size:75%><i class=\"glyphicon glyphicon-time\"></i> {{ event.time |utcDate}}</small></p></timeline-panel></timeline-event></timeline><div class=\"col-sm-12 mid\" ng-if=\"vm.events.length > 0 && vm.showLoadMore == true\"><div class=bound-box><button class=\"oval-btn red\" ng-click=vm.getEvents()><img src=assets/images/load.png> {{\'LoadMore.Text\'| translate}}</button></div></div></div></div></div>");
$templateCache.put("app/main/cameras/setting/cameras.settings.controller.html","<div class=alarm-box><div class=\"row m-0\"><div class=col-md-6><div class=bound-box><div class=\"col-sm-12 col-md-6 card small flex-card blank\"><label class=field>{{ \"CameraDetails.Text\" | translate }}</label></div></div></div></div><div class=\"row m-0\"><div class=col-sm-6><div class=bound-box><div class=\"col-sm-12 card small\"><i class=\"card-icon fa fa-camera fa-2x\"></i><label class=card-label>{{ vm.camera.name }}</label><div ng-if=\"vm.cameraMode.mode==\'armed\'\" class=\"badge green pull-right\" style=margin-top:7px>{{ \"Armed.Text\" | translate }}</div><div ng-if=\"vm.cameraMode.mode==\'disarmed\'\" class=\"badge red pull-right\" style=margin-top:7px>{{ \"Disarmed.Text\" | translate }}</div><div ng-if=\"vm.cameraMode.mode!=\'disarmed\' && vm.cameraMode.mode!=\'armed\'\" class=\"badge blue pull-right\" style=margin-top:7px>{{ vm.cameraMode.mode }}</div></div><div class=\"col-sm-12 card small\"><img src=assets/images/bolt.png class=card-icon><label class=card-label>{{ \"FirmwareVersion.Text\" | translate }}</label><div ng-if=\"vm.cameraFirmwareStatus.status==\'up-to-date\'\" uib-tooltip=\"{{ \'UpToDate.Text\' | translate }}\" class=\"badge green pull-right\" style=margin-top:7px>{{ vm.cameraFirmwareStatus.currentVersion }}</div><div ng-if=\"vm.cameraFirmwareStatus.status==\'upgradable\'\" uib-tooltip=\"{{ \'Upgradable.Text\' | translate }}\" class=\"badge red pull-right\" style=margin-top:7px>{{ vm.cameraFirmwareStatus.currentVersion }}</div><div ng-if=\"vm.cameraFirmwareStatus.status==\'upgrading\'\" uib-tooltip=\"{{ \'Upgrading.Text\' | translate }}\" class=\"badge blue pull-right\" style=margin-top:7px>{{ vm.cameraFirmwareStatus.currentVersion }}</div></div><div class=\"col-sm-12 card small\"><img src=assets/images/bolt.png class=card-icon><label class=card-label>{{ \"ConnectionType\" | translate }}</label><div class=\"badge blue pull-right\" style=margin-top:7px>{{ vm.cameraStatus.connectionType }}</div><div ng-if=\"vm.cameraStatus.connectionType == \'Wifi\' &&  vm.cameraWifiStatus.ssid!=undefined\" class=\"badge blue pull-right\" style=margin-top:7px>{{ vm.cameraWifiStatus.ssid }}</div><!-- <div\r\n            ng-if=\"vm.cameraStatus.connectionType == \'Mobile\'\"\r\n            class=\"badge blue pull-right\"\r\n            style=\"margin-top:7px\"\r\n          >\r\n            {{ vm.cameraSimStatus.carrier }}\r\n            {{ vm.cameraSimStatus.apn.name }}\r\n          </div> --></div></div></div><div class=col-sm-6><div class=bound-box><div class=\"col-sm-12 mid\"><button type=button ng-click=vm.removeCamera() class=\"oval-btn red\">{{ \"RemoveCamera.Text\" | translate }}</button></div><div class=\"col-sm-12 mid\" ng-if=\"vm.cameraFirmwareStatus.status==\'upgradable\'\"><button type=button ng-click=vm.upgradeFirmware() class=\"oval-btn blue\">{{ \"UpgradeFirmware.Text\" | translate }}</button></div></div></div></div></div>");
$templateCache.put("app/main/cameras/setting/header.html","<div class=slider-caption><img src=assets//images/symbol.png class=symbol><h2 class=red-border-bottom>{{ \"CameraSettings.Text\" | translate }}</h2></div>");
$templateCache.put("app/main/cameras/tuyaSettings/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.camera.logo.show() ng-src={{vm.oemConfig.camera.logo.image}} class=symbol><h2 class=red-border-bottom>{{ \"Settings.Text\" | translate }}</h2></div>");
$templateCache.put("app/main/cameras/tuyaSettings/tuyaCameras.settings.controller.html","<div class=alarm-box><div class=\"row m-0\"><div class=col-md-6><div class=bound-box><div class=\"col-sm-12 col-md-6 card small flex-card blank\"><label class=field>{{ \"CameraDetails.Text\" | translate }}</label></div></div></div></div><div class=\"row m-0\"><div class=col-sm-6><div class=bound-box><div class=\"col-sm-12 card small\"><i class=\"card-icon fa fa-camera fa-2x\"></i><label class=card-label>{{ vm.cameraName }}</label><div ng-if=vm.armedMode class=\"badge green pull-right\" style=\"margin-top: 7px\">{{ \"Armed.Text\" | translate }}</div><div ng-if=!vm.armedMode class=\"badge red pull-right\" style=\"margin-top: 7px\">{{ \"Disarmed.Text\" | translate }}</div><!-- <div\r\n            class=\"badge blue pull-right\"\r\n            style=\"margin-top: 7px\"\r\n          >\r\n            {{ vm.cameraMode }}\r\n          </div> --></div><div class=\"col-sm-12 card small\" ng-if=vm.isArmedModeSupported><img src=assets/images/bolt.png class=card-icon><label class=card-label>Arm/disarmed</label><div uib-tooltip=\" Arm/disarmed\" class=pull-right style=\"margin-top: 7px\"><i class=\"fa fa-toggle-on\" ng-class=\"vm.armedMode?\'switchActive\':\'fa-rotate-180 switchInactive\'\" ng-click=\" vm.armedFunc()\"></div></div><div class=\"col-sm-12 card small\" ng-if=vm.isNightVisionSupported><img src=assets/images/bolt.png class=card-icon><label class=card-label>Night Vision</label><div uib-tooltip=\"Night Vision\" class=pull-right style=\"margin-top: 7px\"><i class=\"fa fa-toggle-on\" ng-class=\"vm.nightVision?\'switchActive\':\'fa-rotate-180 switchInactive\'\" ng-click=vm.nightVisionFunc()></div></div></div></div><div class=col-sm-6><div class=bound-box><div class=\"col-sm-12 mid\"><button type=button ng-click=vm.showConfirm() class=\"oval-btn red\">{{ \"RemoveCamera.Text\" | translate }}</button></div></div></div></div></div>");
$templateCache.put("app/main/forum/category/category.html","<div class=main-wrapper_fm><div class=gen-wrapper_fm><button class=button-gen_fm ng-click=\"vm.show=!vm.show\">New Post</button><p style=\"font-size: 20px\"><a ng-if=vm.stateCheck ui-sref=\"boat.home({sentinelId: vm.sentinelId})\">Home / </a><a ui-sref=\"forum({sentinelId: vm.sentinelId})\">Forum</a> / {{vm.forumCategory.name}}</p><div class=main__wrap_fm><div class=\"drops-wrap_fm edit_bl\"><div class=t_bl_fm><p class=t_title_fm>{{vm.forumCategory.name}}</p><p class=link-text_fm>Hosted by {{vm.forumCategory.hostedBy}}</p></div><div class=block_drop_fm><div class=\"head__gen_fm f_area\"><!--<p class=\"text-f_fm\">Filters</p>\r\n            <p class=\"f_sign_fm\">\r\n              <img src=\"assets/images/forum/noun_filter_737331.svg\" alt=\"filter\">\r\n            </p>--></div><div class=f-cont_fm ng-repeat=\"forumCategoryPost in vm.forumCategoryPosts\"><div class=pic_area_fm><p class=img_wrap_fm><img ng-src={{forumCategoryPost.profilePicture}} alt=pic></p><div class=f-cont_wrap_fm><p style=\"cursor: pointer\" class=c_title_fm ui-sref=\"forum_post({sentinelId: vm.sentinelId,categoryId:vm.forumCategory.id,postId: forumCategoryPost.id})\">{{forumCategoryPost.title}}</p><div class=d_nick_fm><p class=d_title_fm>Today at {{forumCategoryPost.createdDate| date:\'mediumTime\'}} •</p><p class=d_sub_fm>&nbsp;{{forumCategoryPost.user.fullName}}</p></div></div></div><div class=cont_data_wrap_fm><div class=d_wrap_fm><div class=rv_wrap_fm><p class=\"d_title_fm wdt\">Replies:</p><p class=d_sub_fm>{{forumCategoryPost.numberOfReplies}}</p></div><div class=rv_wrap_fm><p class=\"d_title_fm wdt\">Views:</p><p class=d_sub_fm>{{forumCategoryPost.numberOfViews}}</p></div></div><div class=pers_d_wrap_fm ng-if=\"forumCategoryPost.latestReply!=null\"><div class=date-n_wrap_fm><p class=d_title_fm>{{forumCategoryPost.latestReply.createdDate| date:\'mediumTime\'}}</p><p class=\"d_sub_fm lt\">{{forumCategoryPost.latestReply.user.fullName}}</p></div><p class=img-d_wrap_fm><img ng-src={{forumCategoryPost.latestReply.user.profilePicture}} alt=pic></p></div></div></div></div><div show-new-post-dialog show-hidden=vm.show hide-category=vm.hideCategory categories=vm.forumCategoriesHierarchy callback=vm.hideDialog></div></div><div class=lp-wrap_fm><div class=\"head__gen_fm lp\"><div class=arrow-down_fm><img src=assets/images/forum/Pen.svg alt=pen></div><p class=text-gen_fm>Latest Posts</p></div><div class=posts_wrapper_fm><div class=l-post-wrap_fm ng-repeat=\"latestPost in vm.latestPosts\"><p class=ph-wrap_fm><img ng-src={{latestPost.profilePicture}} alt=us></p><div class=post-cont-wrap_fm><a class=post-cont-text_fm ui-sref=\"forum_post({sentinelId: vm.sentinelId,categoryId:latestPost.forumCategoryId,postId: latestPost.id})\">{{latestPost.title}}</a><p class=post-cont-sub_fm>Latest: Today at {{latestPost.createdDate| date:\'mediumTime\'}}</p><a class=club-name_fm ui-sref=\"forum_category({sentinelId: vm.sentinelId,categoryId: latestPost.forumCategoryId})\">{{latestPost.forumCategoryName}}</a></div></div></div></div></div></div></div>");
$templateCache.put("app/main/forum/new/new-post.html","<form novalidate name=form ng-submit=\"form.$valid && vm.createPost(form)\"><div class=new-f-post_fm ng-show=showHidden flow-init=vm.uploadApi flow-files-submitted=$flow.upload() flow-complete=vm.onUploadComplete() flow-upload-started=vm.onUploadStarted($file,$flow) flow-file-success=\"vm.onUploadSuccess($file, $message, $flow)\" flow-progress=vm.flowProgress($flow)><p class=m-title-post_fm>New Forum Post</p><p class=in-title_fm>Title</p><input required name=forum_title ng-model=vm.forum.title type=text class=inp-gen_fm ng-class=\"{error: form.$submitted && form.forum_title.$invalid}\" placeholder=\"Write something here...\"><div style=\"margin-top: -18px;margin-bottom: 10px\" ng-messages=form.forum_title.$error class=error ng-if=form.$submitted><div ng-message=required>{{\'ForumNameRequired.Text\'| translate}}</div></div><p class=in-title_fm>Content</p><div ng-class=\"{textAreaError: form.$submitted && form.forum_content.$invalid}\"><textarea class=textarea-gen_fm required name=forum_content ui-tinymce=vm.tinymceOptions ng-model=vm.forum.description placeholder=\"Write something here...\"></textarea></div><div style=\"margin-top: 12px;margin-bottom: 10px\" ng-messages=form.forum_content.$error class=error ng-if=form.$submitted><div ng-message=required>{{\'ForumContentRequired.Text\'| translate}}</div></div><!-- Drop your files area --><div class=drop-gen_fm flow-drag-enter=\"style={border:\'4px dotted green\'}\" flow-drag-leave=\"style={border: \'1px dashed #707070\'}\" ng-style=style flow-drop><p class=dr_title_fm flow-btn>Drop files or add attachments here...</p></div><div class=m-t-15><label for=boat_image flow-btn>{{ \"UploadedFiles.Text\" | translate }}</label><table class=\"m-t-5 table table-condensed table-hover table-bordered table-striped m-table\"><thead><tr class=text-center><td>#</td><td>{{ \"Name.Text\" | translate }}</td><td>{{ \"Action.Text\" | translate }}</td></tr></thead><tbody><tr class=text-center ng-repeat=\"attachment in vm.uploadedFiles\"><td>{{ $index + 1 }}</td><td>{{attachment.file.name}}</td><td><a><i class=\"fa fa-times\" uib-tooltip=\"{{ \'DeleteFile.Text\' | translate }}\" ng-click=vm.deleteUploadedFile(attachment)></i></a></td></tr></tbody></table></div><div class=\"row m-t-10\" ng-if=vm.showProgressBar><div class=col-12><uib-progressbar class=\"progress-striped active\" value=vm.flowProgressValue type=success></uib-progressbar></div></div><hr><p ng-if=!hideCategory class=\"in-title_fm usual\">Category</p><select ng-if=!hideCategory placeholder=\"Write something here...\" class=sel_gen_fm ng-class=\"{error: form.$submitted && form.category_name.$invalid}\" required ng-model=vm.forum.category name=category_name id=category_value ng-options=\"category.id as category.name for category in categories\"></select><div style=\"margin-top: -18px;margin-bottom: 10px\" ng-messages=form.category_name.$error class=error ng-if=\"!hideCategory && form.$submitted\"><div ng-message=required>{{\'ForumCategoryRequired.Text\'| translate}}</div></div><!--<div class=\"check-area_fm\">\r\n            <div class=\"check-wrap_fm\">\r\n                <input type=\"checkbox\">\r\n                <p class=\"check-title_fm\">Make it as sticky post</p>\r\n            </div>\r\n            <div class=\"check-wrap_fm\">\r\n                <input type=\"checkbox\">\r\n                <p class=\"check-title_fm\">Make it as announcement</p>\r\n            </div>\r\n        </div>\r\n        <p class=\"in-title_fm usual\">Send notification about the topic</p>\r\n        <input type=\"text\" class=\"inp-gen_fm\" placeholder=\"\">--><div class=buttons-wrap_fm><button type=button ng-disabled=vm.disableButton class=\"button-gen_fm form\" ng-click=callback(false)>Cancel</button> <button type=submit ng-disabled=vm.disableButton class=\"button-gen_fm form blue\">Submit</button></div></div></form>");
$templateCache.put("app/main/forum/index/index.html","<div class=main-wrapper_fm><div class=gen-wrapper_fm><button class=button-gen_fm ng-click=\"vm.show=!vm.show\">New Post</button><p style=\"font-size: 20px\"><a style=\"font-size: 20px\" ng-if=vm.stateCheck ui-sref=\"boat.home({sentinelId: vm.sentinelId})\">Home /</a> Forum</p><div class=main__wrap_fm><div class=\"drops-wrap_fm edit_bl\"><div class=block_drop_fm ng-repeat=\"forumCategory in vm.forumCategories\" ng-class=\"{\'collapsed\': forumCategory.isCollapsed}\"><div class=head__gen_fm ng-click=vm.toggleAccordions(forumCategory)><p class=text-gen_fm>{{forumCategory.name}}</p><div class=arrow-down_fm ng-class=\"{\'rotate\': vm.isCollapsed}\"><img src=assets/images/forum/down-arrow.svg alt=arr></div></div><div class=main-cont-strip_fm ng-repeat=\"forumChildCategory in forumCategory.forumChildCategories\"><p class=picture-wrap_fm><img class=f-picture_fm src=\"assets/images/forum/comments folder icon.svg\" alt=folder></p><div class=w-wrap_fm><div class=st-wrap_fm><div class=sec-cont_wrap_fm><p style=\"cursor: pointer\" class=\"text-gen_fm dark\" ui-sref=\"forum_category({sentinelId: vm.sentinelId,categoryId: forumChildCategory.id})\">{{forumChildCategory.name}}</p><div class=links_wrap_fm><p class=\"link-text_fm link\">{{forumChildCategory.tagline}}</p><p class=link-text_fm>Hosted by {{forumCategory.hostedBy}}</p></div></div></div><div class=nd-wrap_fm><div class=data_wrapper_fm><div class=data_wrap_fm><p class=d_title_fm>Threads</p><p class=d_sub_fm>{{forumChildCategory.threads}}</p></div><div class=data_wrap_fm><p class=d_title_fm>Messages</p><p class=d_sub_fm>{{forumChildCategory.messages}}</p></div></div><div class=pers-card_fm ng-class=\"{latestpost: forumChildCategory.latestPost==null}\"><p class=\"ph-wrap_fm lg\" ng-if=\"forumChildCategory.latestPost!=null\"><img ng-src={{forumChildCategory.latestPost.profilePicture}} alt=us></p><div class=pers_data_fm ng-if=\"forumChildCategory.latestPost!=null\"><a ui-sref=\"forum_post({sentinelId: vm.sentinelId,categoryId:forumChildCategory.id,postId: forumChildCategory.latestPost.id})\" class=d_sub_fm>{{forumChildCategory.latestPost.title}}</a><div class=d_nick_fm><p class=d_title_fm>Today at {{forumChildCategory.latestPost.createdDate| date:\'mediumTime\'}} •</p><p class=d_sub_fm>&nbsp;{{forumChildCategory.latestPost.user.fullName}}</p></div></div></div></div></div></div></div><div show-new-post-dialog show-hidden=vm.show hide-category=vm.hideCategory categories=vm.forumCategoriesHierarchy callback=vm.hideDialog></div></div><div class=lp-wrap_fm><div class=\"head__gen_fm lp\"><div class=arrow-down_fm><img src=assets/images/forum/Pen.svg alt=pen></div><p class=text-gen_fm>Latest Posts</p></div><div class=posts_wrapper_fm><div class=l-post-wrap_fm ng-repeat=\"latestPost in vm.latestPosts\"><p class=ph-wrap_fm><img ng-src={{latestPost.profilePicture}} alt=us></p><div class=post-cont-wrap_fm><a class=post-cont-text_fm ui-sref=\"forum_post({sentinelId: vm.sentinelId,categoryId:latestPost.forumCategoryId,postId: latestPost.id})\">{{latestPost.title}}</a><p class=post-cont-sub_fm>Latest: Today at {{latestPost.createdDate| date:\'mediumTime\'}}</p><a class=club-name_fm ui-sref=\"forum_category({sentinelId: vm.sentinelId,categoryId: latestPost.forumCategoryId})\">{{latestPost.forumCategoryName}}</a></div></div></div></div></div></div></div>");
$templateCache.put("app/main/help-center/chatCredentials/chatCredentials.html","<div class=login-window__wrap><div class=login-window__main><div class=login_head><p class=main-title>{{ \"ChatLogin.Text\" | translate }}</p></div><div class=login-fields__wrap><div class=login-field_wrap><label for=name class=add_text>{{ \"FullName.Text\" | translate }}</label><div class=input-wrap><input type=text class=input-general name=name id=name ng-model=vm.model.name placeholder=\"{{ \'FullName.Text\' | translate }}\"></div></div><div class=login-field_wrap><label for=email class=add_text>{{ \"EmailAddress.Text\" | translate }}</label><div class=input-wrap><input type=text class=input-general name=email id=email ng-model=vm.model.email placeholder=\"{{ \'EmailAddress.Text\' | translate }}\"></div></div><div class=login-field_wrap><label for=phone class=add_text>{{ \"Phone.Text\" | translate }}</label><div class=input-wrap><input type=text class=input-general name=phone id=phone ng-model=vm.model.phoneNumber placeholder=\"{{ \'Phone.Text\' | translate }}\"></div></div><div class=login-field_wrap><label class=add_text>{{ \"Question.Text\" | translate }}</label><div class=input-wrap><textarea class=\"input-general textarea\" ng-model=vm.model.question placeholder=\"{{ \'Question.Text\' | translate }}\"></textarea></div></div><button type=submit class=gen-btn ng-click=vm.startChat()>{{ \"StartChat.Text\" | translate }}</button></div></div></div>");
$templateCache.put("app/main/help-center/chatCredentials/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.helpCenter.logo.show() ng-src={{vm.oemConfig.helpCenter.logo.image}} class=symbol><h2>{{\"HelpCenter.Text\" | translate}}</h2></div>");
$templateCache.put("app/main/help-center/groupChat/groupChat.html","<div class=conversations__wrapper flow-init=vm.uploadApi flow-files-submitted=$flow.upload() flow-complete=vm.onUploadComplete() flow-upload-started=vm.onUploadStarted($file,$flow) flow-file-success=\"vm.onUploadSuccess($file, $message, $flow)\" flow-progress=vm.flowProgress($flow)><div class=conversations__chat-window><div class=chat-top_wrap><div class=chat-in__wrap><p class=chat-top_ava><img ng-src={{vm.recipient.profilePicture}} alt=ava></p><div class=in-data__wrap><p class=pers-rank>{{ \"CustomerSupport.Text\" | translate }}</p><p class=top-person_initials>{{vm.recipient.fullName}}</p></div></div></div><div class=chat-window__wrap id=chat-messages><div class=reply__wrap ng-repeat=\"message in vm.groupMessages\" ng-class=\"{\'customer-reply\' : message.senderUserId==vm.user.id,\'admin-reply\': message.senderUserId!=vm.user.id}\"><div style=cursor:pointer ng-if=\"message.attachmentId!=null\" ng-click=vm.downloadFile(message.attachmentId)><p class=ct-text>{{message.message}}</p><p class=\"g-date ct-date\" ng-if=\"message.senderUserId!=vm.user.id\">{{message.createdDate | date: \'dd MMM, yyyy hh:mm a\'}}</p><p class=\"g-date ct-date\" ng-if=\"message.senderUserId==vm.user.id\">You: {{message.createdDate | date: \'dd MMM, yyyy hh:mm a\'}}</p></div><div ng-if=\"message.attachmentId==null\"><p class=ct-text>{{message.message}}</p><p class=\"g-date ct-date\" ng-if=\"message.senderUserId!=vm.user.id\">{{message.createdDate | date: \'dd MMM, yyyy hh:mm a\'}}</p><p class=\"g-date ct-date\" ng-if=\"message.senderUserId==vm.user.id\">You: {{message.createdDate | date: \'dd MMM, yyyy hh:mm a\'}}</p></div></div><!-- <div class=\"typing-process\">\r\n        <img src=\"/assets/images/type.svg\" alt=\"type\">\r\n      </div> --></div><div class=\"col-lg-12 chat-b-input_wrap\"><p class=chat-pin flow-btn><img src=/assets/images/paperclip.svg alt=pin></p><p class=add-text flow-btn>Add files</p><div class=b-input><input ng-keydown=\"$event.keyCode == 13 && vm.sendMessage()\" class=b-input__general ng-model=vm.message type=text placeholder=\"{{ \'EnterMessage.Text\' | translate }}\"><p class=send-img ng-click=vm.sendMessage()><img src=/assets/images/send.svg alt=send></p></div></div></div></div>");
$templateCache.put("app/main/help-center/groupChat/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.helpCenter.logo.show() ng-src={{vm.oemConfig.helpCenter.logo.image}} class=symbol><h2>{{\"HelpCenter.Text\" | translate}}</h2></div>");
$templateCache.put("app/main/nmea/engine-details/engine-details.controller.html","<div class=row><div class=\"col-md-12 text-center\"><label style=\"font-size:24px;font-family: \'proximanova\', Arial, sans-serif;color : #182E51\">{{ vm.currentSelected | translate }}</label><br><label style=\"font-size:20px;font-family: \'proximanova\', Arial, sans-serif;color : red\">{{ vm.currentEngineName }}</label></div></div><div class=row ng-hide=!vm.speedGraphData.length><div class=col-md-12><div id=chartdiv style=\"min-height: 350px\"></div><!-- <canvas\r\n      id=\"currentGraph\"\r\n      class=\"chart chart-line\"\r\n      chart-data=\"vm.currentGraphData\"\r\n      chart-labels=\"vm.currentGraphLabels\"\r\n      chart-options=\"vm.chartOptions\"\r\n      chart-dataset-override=\"vm.chartDataOptions\"\r\n    >\r\n    </canvas> --></div></div><div class=row ng-hide=vm.speedGraphData.length><div class=\"col-md-12 text-center\"><h2>{{ \"GraphDataUnavailable.Text\" | translate }}</h2></div></div><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=\"col-md-4 col-sm-4 col-xs-4 text-center\" style=\"padding: 0px 8% 0px 8%\"><button class=nmea-graph-btn ng-class=\"{active: vm.isActiveInterval==vm.nmeaGraphIntervalEnum.Daily}\" ng-click=vm.getDailyGraphData()><div class=\"badge nmea-graph-btn-icon shaded-blue\"></div>{{ \"Daily.Text\" | translate }}</button></div><div class=\"col-md-4 col-sm-4 col-xs-4 text-center\" style=\"padding: 0px 8% 0px 8%\"><button class=nmea-graph-btn ng-class=\"{active: vm.isActiveInterval==vm.nmeaGraphIntervalEnum.Weekly}\" ng-click=vm.getWeeklyGraphData()><div class=\"badge nmea-graph-btn-icon shaded-purple\"></div>{{ \"Weekly.Text\" | translate }}</button></div><div class=\"col-md-4 col-sm-4 col-xs-4 text-center\" style=\"padding: 0px 8% 0px 8%\"><button class=nmea-graph-btn ng-class=\"{active: vm.isActiveInterval==vm.nmeaGraphIntervalEnum.Monthly}\" ng-click=vm.getMonthlyGraphData()><div class=\"badge nmea-graph-btn-icon shaded-orange\"></div>{{ \"Monthly.Text\" | translate }}</button></div></div></div><div class=\"row m-t-30 pb-10\" style=\"padding-bottom: 10px\" ng-repeat=\"item in vm.engineInstancesData\" index=item.id><label class=field>{{ \"Engine.Text\" | translate }}: {{ item.engineName }}</label><div class=bound-box><div class=\"col-md-12 col-sm-12 col-xs-12\" class=nmea-engine-widget-background><label class=field>{{ \"DashboardData.Text\" | translate }}</label><div class=\"col-md-6 col-sm-6 col-xs-12 m-t-5\" ng-click=\"vm.getGraphData(\'\',\'Speed.Text\',null,vm.nmeaDataFieldEnum.Pgn129026Sog,\'knots\')\"><div class=nmea-engine-widget-left-side><img src=assets/images/rev_limit.png class=nmea-m-auto style=\"width: 35px\"></div><div class=nmea-engine-widget-right-side><p class=nmea-engine-widget-small-text>{{ \"Speed.Text\" | translate }}</p><div class=nmea-engine-widget-value-div><p class=nmea-engine-widget-small-text style=\"width: 100%;font-size: 12px;font-weight: 500\" ng-if=\"item.nmeaSpeedInKnots!=undefined\">{{ item.nmeaSpeedInKnots | speed }}</p><p class=nmea-engine-widget-small-text style=\"width: 100%;font-size: 12px;font-weight: 500\" ng-if=\"item.nmeaSpeedInKnots==undefined\">N/A</p></div></div></div><div class=\"col-md-6 col-sm-6 col-xs-12 m-t-5\" ng-click=\"vm.getGraphData(item.engineName,\'Boost.Text\',item.instanceNumber,vm.nmeaDataFieldEnum.Pgn127488BoostPressure, \'psi\')\"><div class=nmea-engine-widget-left-side><img src=assets/images/boost_icon.png class=nmea-m-auto style=\"width: 35px\"></div><div class=nmea-engine-widget-right-side><p class=nmea-engine-widget-small-text>{{ \"Boost.Text\" | translate }}</p><div class=nmea-engine-widget-value-div><p class=nmea-engine-widget-small-text style=\"width: 100%;font-size: 12px;font-weight: 500\" ng-if=\"item.nmeaBoostInPsi!=undefined\">{{ item.nmeaBoostInPsi }} psi</p><p class=nmea-engine-widget-small-text style=\"width: 100%;font-size: 12px;font-weight: 500\" ng-if=\"item.nmeaBoostInPsi==undefined\">N/A</p></div></div></div><div class=\"col-md-6 col-sm-6 col-xs-12 m-t-5\" ng-click=\"vm.getGraphData(item.engineName,\'Rpm.Text\',item.instanceNumber,vm.nmeaDataFieldEnum.Pgn127488Speed,\'rpm\')\"><div class=nmea-engine-widget-left-side><img src=assets/images/rpm_icon.png class=nmea-m-auto style=\"width: 35px\"></div><div class=nmea-engine-widget-right-side><p class=nmea-engine-widget-small-text>{{ \"Rpm.Text\" | translate }}</p><div class=nmea-engine-widget-value-div><p class=nmea-engine-widget-small-text style=\"width: 100%;font-size: 12px;font-weight: 500\" ng-if=\"item.nmeaRpm!=undefined\">{{ item.nmeaRpm }} rpm</p><p class=nmea-engine-widget-small-text style=\"width: 100%;font-size: 12px;font-weight: 500\" ng-if=\"item.nmeaRpm==undefined\">N/A</p></div></div></div><div class=\"col-md-6 col-sm-6 col-xs-12 m-t-5\" ng-click=\"vm.getGraphData(item.engineName,\'Trim.Text\',item.instanceNumber,vm.nmeaDataFieldEnum.Pgn127488TiltTrim,\'%\')\"><div class=nmea-engine-widget-left-side><img src=assets/images/trim_icon.png class=nmea-m-auto style=\"width: 35px\"></div><div class=nmea-engine-widget-right-side><p class=nmea-engine-widget-small-text>{{ \"Trim.Text\" | translate }}</p><div class=nmea-engine-widget-value-div><p class=nmea-engine-widget-small-text style=\"width: 100%;font-size: 12px;font-weight: 500\" ng-if=\"item.nmeaTrim!=undefined\">{{ item.nmeaTrim }}%</p><p class=nmea-engine-widget-small-text style=\"width: 100%;font-size: 12px;font-weight: 500\" ng-if=\"item.nmeaTrim==undefined\">N/A</p></div></div></div><div class=\"col-md-6 col-sm-6 col-xs-12 m-t-5\" ng-click=\"vm.getGraphData(item.engineName,\'OilPressure.Text\',item.instanceNumber,vm.nmeaDataFieldEnum.Pgn127489OilPressure,\'psi\')\"><div class=nmea-engine-widget-left-side><img src=assets/images/oil_pressure.png class=nmea-m-auto style=\"width: 45px\"></div><div class=nmea-engine-widget-right-side><p class=nmea-engine-widget-small-text>{{ \"OilPressure.Text\" | translate }}</p><div class=nmea-engine-widget-value-div><p class=nmea-engine-widget-small-text style=\"width: 100%;font-size: 12px;font-weight: 500\" ng-if=\"item.nmeaOilPressureInPsi!=undefined\">{{ item.nmeaOilPressureInPsi }} psi</p><p class=nmea-engine-widget-small-text style=\"width: 100%;font-size: 12px;font-weight: 500\" ng-if=\"item.nmeaOilPressureInPsi==undefined\">N/A</p></div></div></div><!-- <div class=\"col-md-6 col-sm-6 col-xs-12 m-t-5\"\r\n        ng-click=\"vm.getGraphData(item.engineName,\'FuelLevel.Text\',item.instanceNumber,vm.nmeaDataFieldEnum.Pgn127505Level,\'%\')\">\r\n        <div class=\"nmea-engine-widget-left-side\">\r\n          <img src=\"assets/images/Temperature-Sea.png\" class=\"nmea-m-auto\" style=\"width: 40px;\" />\r\n        </div>\r\n        <div class=\"nmea-engine-widget-right-side\">\r\n          <p class=\"nmea-engine-widget-small-text\">\r\n            {{ \"FuelLevel.Text\" | translate }}\r\n          </p>\r\n          <div class=\"nmea-engine-widget-value-div\">\r\n            <p class=\"nmea-engine-widget-small-text \" style=\"width: 100%;font-size: 12px;font-weight: 500;\"\r\n              ng-if=\"item.fuelLevel!=undefined\">\r\n              {{ item.fuelLevel }}%\r\n            </p>\r\n            <p class=\"nmea-engine-widget-small-text \" style=\"width: 100%;font-size: 12px;font-weight: 500;\"\r\n              ng-if=\"item.fuelLevel==undefined\">\r\n              N/A\r\n            </p>\r\n          </div>\r\n        </div>\r\n      </div> --><div class=\"col-md-6 col-sm-6 col-xs-12 m-t-5\" ng-click=\"vm.getGraphData(item.engineName,\'OilTemperature.Text\',item.instanceNumber,vm.nmeaDataFieldEnum.Pgn127489OilTemperature,\'°c\')\"><div class=nmea-engine-widget-left-side><img src=assets/images/Temperature-Sea.png class=nmea-m-auto style=\"width: 40px\"></div><div class=nmea-engine-widget-right-side><p class=nmea-engine-widget-small-text>{{ \"OilTemperature.Text\" | translate }}</p><div class=nmea-engine-widget-value-div><p class=nmea-engine-widget-small-text style=\"width: 100%;font-size: 12px;font-weight: 500\" ng-if=\"item.nmeaOilTemperatureInC!=undefined\">{{ item.nmeaOilTemperatureInC | temperature }}</p><p class=nmea-engine-widget-small-text style=\"width: 100%;font-size: 12px;font-weight: 500\" ng-if=\"item.nmeaOilTemperatureInC==undefined\">N/A</p></div></div></div><div class=\"col-md-6 col-sm-6 col-xs-12 m-t-5\" ng-click=\"vm.getGraphData(item.engineName,\'EngineTemperature.Text\',item.instanceNumber,vm.nmeaDataFieldEnum.Pgn127489Temperature,\'°c\')\"><div class=nmea-engine-widget-left-side><img src=assets/images/engine_temp_logo.png class=nmea-m-auto></div><div class=nmea-engine-widget-right-side><p class=nmea-engine-widget-small-text>{{ \"EngineTemperature.Text\" | translate }}</p><div class=nmea-engine-widget-value-div><p class=nmea-engine-widget-small-text style=\"width: 100%;font-size: 12px;font-weight: 500\" ng-if=\"item.nmeaEngineTemperatureInC!=undefined\">{{ item.nmeaEngineTemperatureInC | temperature }}</p><p class=nmea-engine-widget-small-text style=\"width: 100%;font-size: 12px;font-weight: 500\" ng-if=\"item.nmeaEngineTemperatureInC==undefined\">N/A</p></div></div></div></div></div><div class=\"bound-box m-t-15\"><div class=\"col-md-12 col-sm-12 col-xs-12\" class=nmea-engine-widget-background><label class=field>{{ \"OtherData.Text\" | translate }}</label><div class=\"col-md-6 col-sm-6 col-xs-12 m-t-5\" ng-click=\"vm.getGraphData(item.engineName,\'AlternatorPotential.Text\',item.instanceNumber,vm.nmeaDataFieldEnum.Pgn127489AlternatorPotential,\'V\')\"><div class=nmea-engine-widget-left-side><img src=assets/images/convertor.png class=nmea-m-auto style=\"width: 35px\"></div><div class=nmea-engine-widget-right-side><p class=nmea-engine-widget-small-text>{{ \"AlternatorPotential.Text\" | translate }}</p><div class=nmea-engine-widget-value-div><p class=nmea-engine-widget-small-text style=\"width:100%;font-size: 12px;font-weight: 500\" ng-if=\"item.nmeaAlternatorPotential!=undefined\">{{ item.nmeaAlternatorPotential }}V</p><p class=nmea-engine-widget-small-text style=\"width:100%;font-size: 12px;font-weight: 500\" ng-if=\"item.nmeaAlternatorPotential==undefined\">N/A</p></div></div></div><div class=\"col-md-6 col-sm-6 col-xs-12 m-t-5\" ng-click=\"vm.getGraphData(item.engineName,\'FuelRate.Text\',item.instanceNumber,vm.nmeaDataFieldEnum.Pgn127489FuelRate,\'cu-m/hr\')\"><div class=nmea-engine-widget-left-side><img src=assets/images/fuel_rate_icon.png class=nmea-m-auto style=width:40px></div><div class=nmea-engine-widget-right-side><p class=nmea-engine-widget-small-text>{{ \"FuelRate.Text\" | translate }}</p><div class=nmea-engine-widget-value-div><p class=nmea-engine-widget-small-text style=\"width: 100%;font-size: 12px;font-weight: 500\" ng-if=\"item.nmeaFuelRate!=undefined\">{{ item.nmeaFuelRate | volume }}/hr</p><p class=nmea-engine-widget-small-text style=\"width: 100%;font-size: 12px;font-weight: 500\" ng-if=\"item.nmeaFuelRate==undefined\">N/A</p></div></div></div><div class=\"col-md-6 col-sm-6 col-xs-12 m-t-5\" ng-click=\"vm.getGraphData(item.engineName,\'FuelPressure.Text\',item.instanceNumber,vm.nmeaDataFieldEnum.Pgn127489FuelPressure,\'psi\')\"><div class=nmea-engine-widget-left-side><img src=assets/images/oil_pressure.png class=nmea-m-auto style=\"width: 45px\"></div><div class=nmea-engine-widget-right-side><p class=nmea-engine-widget-small-text>{{ \"FuelPressure.Text\" | translate }}</p><div class=nmea-engine-widget-value-div><p class=nmea-engine-widget-small-text style=\"width:100%;font-size: 12px;font-weight: 500\" ng-if=\"item.nmeaFuelPressure!=undefined\">{{ item.nmeaFuelPressure }} psi</p><p class=nmea-engine-widget-small-text style=\"width:100%;font-size: 12px;font-weight: 500\" ng-if=\"item.nmeaFuelPressure==undefined\">N/A</p></div></div></div><div class=\"col-md-6 col-sm-6 col-xs-12 m-t-5\" ng-click=\"vm.getGraphData(item.engineName,\'EngineLoad.Text\',item.instanceNumber,vm.nmeaDataFieldEnum.Pgn127489PercentEngineLoad,\'%\')\"><div class=nmea-engine-widget-left-side><img src=assets/images/engine_load_icon.png class=nmea-m-auto style=\"width: 45px\"></div><div class=nmea-engine-widget-right-side><p class=nmea-engine-widget-small-text>{{ \"EngineLoad.Text\" | translate }}</p><div class=nmea-engine-widget-value-div><p class=nmea-engine-widget-small-text style=\"width:100%;font-size: 12px;font-weight: 500\" ng-if=\"item.nmeaEngineLoad!=undefined\">{{ item.nmeaEngineLoad }}%</p><p class=nmea-engine-widget-small-text style=\"width:100%;font-size: 12px;font-weight: 500\" ng-if=\"item.nmeaEngineLoad==undefined\">N/A</p></div></div></div><div class=\"col-md-6 col-sm-6 col-xs-12 m-t-5\" ng-click=\"vm.getGraphData(item.engineName,\'EngineHours.Text\',item.instanceNumber,vm.nmeaDataFieldEnum.Pgn127489TotalEngineHours,\'hrs\')\"><div class=nmea-engine-widget-left-side><img src=assets/images/clock_logo.png class=nmea-m-auto></div><div class=nmea-engine-widget-right-side><p class=nmea-engine-widget-small-text>{{ \"EngineHours.Text\" | translate }}</p><div class=nmea-engine-widget-value-div><p class=nmea-engine-widget-small-text style=\"width: 100%;font-size: 12px;font-weight: 500\" ng-if=\"item.nmeaTotalEngineHours!=undefined\">{{ item.nmeaTotalEngineHours }} hrs</p><p class=nmea-engine-widget-small-text style=\"width: 100%;font-size: 12px;font-weight: 500\" ng-if=\"item.nmeaTotalEngineHours==undefined\">N/A</p></div></div></div><div class=\"col-md-6 col-sm-6 col-xs-12 m-t-5\" ng-click=\"vm.getGraphData(item.engineName,\'EngineTorque.Text\',item.instanceNumber,vm.nmeaDataFieldEnum.Pgn127489PercentEngineTorque,\'%\')\"><div class=nmea-engine-widget-left-side><img src=assets/images/engine_torque_icon.png class=nmea-m-auto style=\"width: 45px\"></div><div class=nmea-engine-widget-right-side><p class=nmea-engine-widget-small-text>{{ \"EngineTorque.Text\" | translate }}</p><div class=nmea-engine-widget-value-div><p class=nmea-engine-widget-small-text style=\"width:100%;font-size: 12px;font-weight: 500\" ng-if=\"item.nmeaEngineTorque!=undefined\">{{ item.nmeaEngineTorque }}%</p><p class=nmea-engine-widget-small-text style=\"width:100%;font-size: 12px;font-weight: 500\" ng-if=\"item.nmeaEngineTorque==undefined\">N/A</p></div></div></div><div class=\"col-md-6 col-sm-6 col-xs-12 m-t-5\" ng-click=\"vm.getGraphData(item.engineName,\'EngineCoolantPressure.Text\',item.instanceNumber,vm.nmeaDataFieldEnum.Pgn127489CoolantPressure,\'psi\')\"><div class=nmea-engine-widget-left-side><img src=assets/images/engine_coolant_pressure.png class=nmea-m-auto style=\"width: 45px\"></div><div class=nmea-engine-widget-right-side><p class=nmea-engine-widget-small-text>{{ \"EngineCoolantPressure.Text\" | translate }}</p><div class=nmea-engine-widget-value-div><p class=nmea-engine-widget-small-text style=\"width:100%;font-size: 12px;font-weight: 500\" ng-if=\"item.nmeaCoolantPressure!=undefined\">{{ item.nmeaCoolantPressure }} psi</p><p class=nmea-engine-widget-small-text style=\"width:100%;font-size: 12px;font-weight: 500\" ng-if=\"item.nmeaCoolantPressure==undefined\">N/A</p></div></div></div></div></div></div><div class=\"row m-10\" ng-if=vm.showSampleData><div style=\"bottom: 65px;\r\n      z-index: 99999;\r\n      width: 100%;\r\n      background: #003055;\r\n      text-align: center;\r\n      position: fixed;\r\n      left: 0;\r\n      padding:10px 0\"><span style=\"color:red;font-size: 20px;font-weight: 500\">Sample Data</span></div></div>");
$templateCache.put("app/main/nmea/engine-details/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.nmeaDashboardDeatails.logo.show() ng-src={{vm.oemConfig.nmeaDashboardDeatails.logo.image}} class=symbol><h2 class=red-border-bottom>{{ \"EngineDetails.Text\" | translate }}</h2></div>");
$templateCache.put("app/main/nmea/graph-modal/header.html","<div class=slider-caption><img src=assets//images/symbol.png class=symbol><h2 class=red-border-bottom>{{ \"Graph.Text\" | translate }}</h2></div>");
$templateCache.put("app/main/nmea/graph-modal/modal.controller.html","<div class=modal-content><div class=modal-header><button class=close type=button ng-click=$dismiss()>x</button><h4 class=modal-title>{{vm.intanceType}}</h4></div><div class=modal-body.graph><div class=row><div class=\"col-md-12 text-center\"><label style=\"font-size:24px;font-family: \'proximanova\', Arial, sans-serif;color : #182E51\">{{ vm.intanceName | translate }}</label></div></div><div class=row ng-hide=!vm.graphData.length><div class=col-md-12 style=\"padding: 0px 3% 0px 3%\"><div id=chartdiv style=\"min-height: 350px\"></div></div></div><div class=row ng-hide=vm.graphData.length><div class=\"col-md-12 text-center\" style=\"padding: 0px 3% 0px 3%\"><h4>{{ \"GraphDataUnavailable.Text\" | translate }}</h4></div></div><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\" style=\"padding: 0px 0px 2% 0px\"><div class=\"col-md-4 col-sm-4 col-xs-4 text-center\"><button class=nmea-graph-btn ng-class=\"{active: vm.isActiveInterval==vm.nmeaGraphIntervalEnum.Daily}\" ng-click=vm.getDailyGraphData()><div class=\"btn badge nmea-graph-btn-icon shaded-blue\"></div>{{ \"Daily.Text\" | translate }}</button></div><div class=\"col-md-4 col-sm-4 col-xs-4 text-center\"><button class=nmea-graph-btn ng-class=\"{active: vm.isActiveInterval==vm.nmeaGraphIntervalEnum.Weekly}\" ng-click=vm.getWeeklyGraphData()><div class=\"btn badge nmea-graph-btn-icon shaded-purple\"></div>{{ \"Weekly.Text\" | translate }}</button></div><div class=\"col-md-4 col-sm-4 col-xs-4 text-center\"><button class=nmea-graph-btn ng-class=\"{active: vm.isActiveInterval==vm.nmeaGraphIntervalEnum.Monthly}\" ng-click=vm.getMonthlyGraphData()><div class=\"btn badge nmea-graph-btn-icon shaded-orange\"></div>{{ \"Monthly.Text\" | translate }}</button></div></div></div></div></div>");
$templateCache.put("app/main/nmea/index/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.nmeaDashboard.logo.show() ng-src={{vm.oemConfig.nmeaDashboard.logo.image}} class=symbol><h2 class=red-border-bottom>{{ \"NmeaDashboard.Text\" | translate }}</h2></div>");
$templateCache.put("app/main/nmea/index/name-power-source.html","<div ng-init=\"nmeaPowerInstance.newName = nmeaPowerInstance.name; nmeaPowerInstance.newValue = nmeaPowerInstance.value\"><h4>We could not determine where this power source is from.</h4><div class=form-group><p>What type of power source is this?</p><select ng-model=nmeaPowerInstance.newValue class=form-control><option value=-1 disabled=disabled>Choose</option><option value=0>Battery</option><option value=3>Solar cell</option><option value=4>Wind power</option></select></div><div class=form-group><p>What would you like to name it?</p><input ng-model=nmeaPowerInstance.newName style=width:100% type=text class=form-control></div><div class=form-group><button ng-click=vm.addPowerSourceNameAndType(nmeaPowerInstance) ng-disabled=\"nmeaPowerInstance.newValue == \'-1\' || nmeaPowerInstance.newName == \'\'\" class=\"btn btn-primary\">Submit</button></div></div>");
$templateCache.put("app/main/nmea/index/nmea.index.controller.html","<div class=\"row m-10\"><div class=bound-box><div class=\"col-sm-6 p-0\"><div class=bound-box><div class=\"col-sm-6 nmea-card card small flex-card\"><label class=\"card-label auto white\">YS6</label><switch ng-click=vm.showYS6Dashboard(); ng-model=vm.enabled class=\"green pull-right\"></switch><label class=\"card-label auto white text-right\">NMEA</label></div></div></div></div></div><div class=\"row m-10\" ng-if=\"vm.alerts.length > 0\"><div class=bound-box><label class=\"field white\">{{ \"DashboardAlerts.Text\" | translate }}</label><div class=\"col-sm-12 col-xs-12\"><div uib-alert class=\"p-5 m-t-5\" style=\"background: antiquewhite\"><div class=row><div class=\"col-md-3 col-sm-4 col-xs-4 text-center m-t-5\" ng-repeat=\"alert in vm.alerts\" style=\"min-height: 100px\"><img ng-src=\"assets/images/{{ alert.image }}\" class=nmea-alert-icon><p>{{ alert.text | translate }}</p></div></div></div></div></div></div><div class=\"row m-10\"><div class=bound-box><div><label class=\"field white refresh-status\">{{ \"LastUpdatedOn.Text\" | translate }}</label></div><div class=col-sm-4><div class=\"nmea-card card small\"><div class=\"row text-center\"><div ng-class=\"{\'badge unset green\':vm.currentSentinel.nmeaHeartBeatStatus,\'badge unset red\':!vm.currentSentinel.nmeaHeartBeatStatus}\" ng-if=\"vm.lastUpdatedOn!=undefined\">{{ vm.lastUpdatedOn | utcDate }}</div><div ng-class=\"{\'badge unset green\':vm.currentSentinel.nmeaHeartBeatStatus,\'badge unset red\':!vm.currentSentinel.nmeaHeartBeatStatus}\" ng-if=\"vm.lastUpdatedOn==undefined\">N/A</div></div></div></div><div class=col-sm-4 ng-if=\"vm.currentSentinel.sonoffSensorId!=null\"><div class=\"nmea-card card small\"><div class=\"row text-center\"><div ng-click=vm.updateSonoffStatus() style=\"cursor: pointer\" class=\"badge unset green\">{{\'UpdateStatus.Text\' | translate}} <img style=\"width: 12px\" src=\"assets/images/fp/refresh status.png\" class=\"refresh-status crossRotate\"></div></div></div></div></div></div><div class=\"row m-10\" ng-if=\"vm.totalofTotalEngineHours!=undefined || vm.totalComulativeDistance!=undefined\"><div class=bound-box><label class=\"field white\">{{ \"BoatHistory.Text\" | translate }}</label><div class=col-sm-12><div class=\"col-md-6 col-sm-6 col-xs-6\" ng-if=\"vm.totalofTotalEngineHours!=undefined\"><div class=\"nmea-card card small\"><div class=\"row text-center\"><i class=\"card-icon fa fa-clock-o fa-2x white\"></i><label class=\"card-label auto white nmea-current-trip-label\">{{ \"TotalEngineHours.Text\" | translate }}</label></div><div class=\"row text-center\" ng-if=\"vm.totalofTotalEngineHours!=undefined\"><div class=\"badge unset green\">{{ vm.totalofTotalEngineHours |number:1}} h</div></div><div class=\"row text-center\" ng-if=\"vm.totalofTotalEngineHours==undefined\"><div class=\"badge unset green\">N/A</div></div></div></div><div class=\"col-md-6col-sm-6 col-xs-6\" ng-if=\"vm.totalComulativeDistance!=undefined\"><div class=\"nmea-card card small\"><div class=\"row text-center\"><i class=\"card-icon fa fa-globe fa-2x white\"></i><label class=\"card-label auto white nmea-current-trip-label\">{{ \"TotalComulativeDistance.Text\" | translate }}</label></div><div class=\"row text-center\"><div class=\"badge unset green\">{{ vm.totalComulativeDistance | distance }}</div></div></div></div></div></div></div><div class=\"row m-10\" ng-if=\"vm.nmeaTimeToEmptyInHr!=undefined || vm.nmeaDistanceToEmptyInNm!=undefined || vm.nmeaTripTimeInHr!=undefined\"><div class=bound-box><label class=\"field white\">{{ \"CurrentTrip.Text\" | translate }}</label><div class=col-sm-12><div class=\"col-md-4 col-sm-6 col-xs-6 nmea-current-trip-padding\" ng-if=\"vm.nmeaTimeToEmptyInHr!=undefined\"><div class=\"nmea-card card small\"><div class=\"row text-center\"><i class=\"card-icon fa fa-clock-o fa-2x white\"></i><label class=\"card-label auto white nmea-current-trip-label\">{{ \"TimeToEmpty.Text\" | translate }}</label></div><div class=\"row text-center\"><div class=\"badge unset green\">{{ vm.nmeaTimeToEmptyInHr }} h</div></div></div></div><div class=\"col-md-4 col-sm-6 col-xs-6 nmea-current-trip-padding\" ng-if=\"vm.nmeaTripTimeInHr!=undefined\"><div class=\"nmea-card card small\"><div class=\"row text-center\"><i class=\"card-icon fa fa-clock-o fa-2x white\"></i><label class=\"card-label auto white nmea-current-trip-label\">{{ \"TripTime.Text\" | translate }}</label></div><div class=\"row text-center\"><div class=\"badge unset green\">{{ vm.nmeaTripTimeInHr }} h</div></div></div></div><div class=\"col-md-4 col-sm-6 col-xs-6 nmea-current-trip-padding\" ng-if=\"vm.nmeaDistanceToEmptyInNm!=undefined\"><div class=\"nmea-card card small\"><div class=\"row text-center\"><i class=\"card-icon fa fa-globe fa-2x white\"></i><label class=\"card-label auto white nmea-current-trip-label\">{{ \"DistanceToEmpty.Text\" | translate }}</label></div><div class=\"row text-center\"><div class=\"badge unset green\">{{ vm.nmeaDistanceToEmptyInNm | distance }}</div></div></div></div></div></div></div><div class=\"row m-10 m-b-40\" ng-if=\"vm.engineSlides.length>0\" style=\"min-height: 305px\"><div class=nmea-engine-slider uib-carousel active=vm.activeEngineSlide no-transition=true><div uib-slide ng-repeat=\"item in vm.engineSlides track by item.index\" index=item.index><div class=bound-box><label class=\"field white pull-left\" style=\"float: left !important\">{{ \"Engine.Text\" | translate }}: <a ui-sref=\"boat.engine-details({sentinelId: vm.sentinelId})\" class=nmea-link>{{ item.engineName }}</a></label><label ng-if=item.isValidData ui-sref=\"boat.engine-details({sentinelId: vm.sentinelId})\" class=\"nmea-info-link pull-right\" style=\"float: right !important\">{{ \"MoreInfo.Text\" | translate }}</label><div class=\"col-sm-12 text-center\" style=\"margin-top: 25px\"><div class=col-sm-4><canvas id=\"boostGauge_{{ item.engineName }}\" ng-click=\"vm.openGraphDialoge(vm.sentinelId,vm.nmeaDataFieldEnum.Pgn127488BoostPressure,item.id,null,item.engineName,\'Boost\')\"></canvas></div><div class=\"col-sm-4 m-r-20 nmea-speed-guage\" ng-click=\"vm.openGraphDialoge(vm.sentinelId,vm.nmeaDataFieldEnum.Pgn129026Sog,null,null,item.engineName,\'Speed\')\"><canvas id=\"speedGauge_{{ item.engineName }}\"></canvas></div><div class=\"col-sm-4 m-t-30\"><canvas id=\"rpmGauge_{{ item.engineName }}\" style=\"margin: auto;display: block\" ng-click=\"vm.openGraphDialoge(vm.sentinelId,vm.nmeaDataFieldEnum.Pgn127488Speed,item.id,null,item.engineName,\'Rpm\')\"></canvas><canvas id=\"trimGauge_{{ item.engineName }}\" class=nmea-trim-gauge ng-click=\"vm.openGraphDialoge(vm.sentinelId,vm.nmeaDataFieldEnum.Pgn127488TiltTrim,item.id,null,item.engineName,\'Trim\')\"></canvas></div></div><div class=col-sm-12><div class=\"col-sm-4 text-center nmea-engine-temp-gauge\" ng-click=\"vm.openGraphDialoge(vm.sentinelId,vm.nmeaDataFieldEnum.Pgn127489Temperature,item.id,null,item.engineName,\'Engine Temperature\')\"><!-- <canvas id=\"oilTemperatureGauge_{{ item.engineName }}\" style=\"display: block;margin: auto\"></canvas> --><canvas id=\"engineTemperatureGauge_{{ item.engineName }}\" style=\"display: block;margin: auto\"></canvas><label class=\"card-label auto white m-0 p-0-imp\">{{ \"EngineTemperature.Text\" | translate }}</label></div><div class=\"col-sm-4 text-center nmea-oil-pressure-guage\" ng-click=\"vm.openGraphDialoge(vm.sentinelId,vm.nmeaDataFieldEnum.Pgn127489OilPressure,item.id,null,item.engineName,\'Oil pressure\')\"><canvas id=\"oilPressureGauge_{{ item.engineName }}\"></canvas></div></div></div></div></div></div><div class=\"row m-10\" ng-if=\"vm.nmeaWaterDepth!=undefined || vm.nmeaCogInDeg!=undefined || vm.nmeaSogInKnots!=undefined || vm.nmeaSowInKnots!=undefined || vm.nmeaWindSpeedInKnots!=undefined || nmeaWindAngleInDegree!=undefined\"><div class=bound-box><div class=col-md-12><label class=\"field white\" style=\"font-size: 12px;margin-left: 20px\">{{ \"Course.Text\" | translate }}</label></div><div class=\"col-md-4 col-sm-6 col-xs-6 text-center course-container\" ng-if=\"vm.nmeaWaterDepth!=undefined\" ng-click=\"vm.openGraphDialoge(vm.sentinelId,vm.nmeaDataFieldEnum.Pgn128267Depth,null,null,\'Course\',\'Water depth\')\"><img src=assets/images/water-depth.png class=nmea-alert-icon-medium><label class=\"card-label unset p-0-imp m-0-imp white nmea-fluid-level-label ng-binding\">{{ \"WaterDepth.Text\" | translate }}</label><label class=\"badge unset green nmea-medium-label\">{{ vm.nmeaWaterDepth | height }}</label></div><div class=\"col-md-4 col-sm-6 col-xs-6 text-center course-container\" ng-if=\" vm.nmeaCogInDeg!=undefined\" ng-click=\"vm.openGraphDialoge(vm.sentinelId,vm.nmeaDataFieldEnum.Pgn129026Cog,null,null,\'Course\',\'COG\')\"><img src=assets/images/cog.png class=nmea-alert-icon-medium><label class=\"card-label unset p-0-imp m-0-imp white nmea-fluid-level-label ng-binding\">{{ \"COG.Text\" | translate }}</label><label class=\"badge unset green nmea-medium-label\">{{ vm.nmeaCogInDeg }}°</label></div><div class=\"col-md-4 col-sm-6 col-xs-6 text-center course-container\" ng-if=\"vm.nmeaSogInKnots!=undefined\" ng-click=\"vm.openGraphDialoge(vm.sentinelId,vm.nmeaDataFieldEnum.Pgn129026Sog,null,null,\'Course\',\'SOG\')\"><img src=assets/images/sog.png class=nmea-alert-icon-medium><label class=\"card-label unset p-0-imp m-0-imp white nmea-fluid-level-label ng-binding\">{{ \"SOG.Text\" | translate }}</label><label class=\"badge unset green nmea-medium-label\">{{ vm.nmeaSogInKnots | speed }}</label></div><div class=\"col-md-4 col-sm-6 col-xs-6 text-center course-container\" ng-if=\" vm.nmeaSowInKnots!=undefined\" ng-click=\"vm.openGraphDialoge(vm.sentinelId,vm.nmeaDataFieldEnum.Pgn128259SpeedWaterReferenced,null,null,\'Course\',\'SOW\')\"><img src=assets/images/sow.png class=nmea-alert-icon-medium><label class=\"card-label unset p-0-imp m-0-imp white nmea-fluid-level-label ng-binding\">{{ \"SOW.Text\" | translate }}</label><label class=\"badge unset green nmea-medium-label\">{{ vm.nmeaSowInKnots | speed }}</label></div><div class=\"col-md-4 col-sm-6 col-xs-6 text-center course-container\" ng-if=\"vm.nmeaWindSpeedInKnots!=undefined\" ng-click=\"vm.openGraphDialoge(vm.sentinelId,vm.nmeaDataFieldEnum.Pgn130306WindSpeed,null,null,\'Course\',\'Wind Speed\')\"><img src=assets/images/wind-speed.png class=nmea-alert-icon-medium><label class=\"card-label unset p-0-imp m-0-imp white nmea-fluid-level-label ng-binding\">{{ \"WindSpeed.Text\" | translate }}</label><label class=\"badge unset green nmea-medium-label\">{{ vm.nmeaWindSpeedInKnots | speed }}</label></div><div class=\"col-md-4 col-sm-6 col-xs-6 text-center course-container\" ng-if=\"vm.nmeaWindAngleInDegree!=undefined\" ng-click=\"vm.openGraphDialoge(vm.sentinelId,vm.nmeaDataFieldEnum.Pgn130306WindAngle,null,null,\'Course\',\'Wind Angle\')\"><img src=assets/images/wind-direction.png class=nmea-alert-icon-medium><label class=\"card-label unset p-0-imp m-0-imp white nmea-fluid-level-label ng-binding\">{{ \"WindDirection.Text\" | translate }}</label><label class=\"badge unset green nmea-medium-label\">{{ vm.nmeaWindAngleInDegree | courseDirection }}</label></div></div></div><div class=\"row m-10\" ng-if=\"vm.nmeaPowerInstances.length>0\"><div class=bound-box><label class=\"field white\" style=\"float: left !important\">{{ \"Power2.Text\" | translate }}</label><label ui-sref=\"boat.power-details({sentinelId: vm.sentinelId})\" class=nmea-info-link style=\"float: right !important;display: block\">{{ \"MoreInfo.Text\" | translate }}</label><div class=row><div class=\"bound-box m-t-10\"><div class=\"col-xs-6 col-sm-4 col-md-3 power-container\" ng-repeat=\"nmeaPowerInstance in vm.nmeaPowerInstances\" popover-trigger=\"\'outsideClick click\'\" popover-class=name-power-source uib-popover-template=\"\'app/main/nmea/index/name-power-source.html\'\" popover-enable=\"!nmeaPowerInstance.value && nmeaPowerInstance.dcType == \'-1\'\"><div class=\"row text-center\" style=display:block ng-data-sourceid={{nmeaPowerInstance.nmeaSourceId}} ng-data-instance={{nmeaPowerInstance.instanceNumber}} ng-click=\"(nmeaPowerInstance.value || nmeaPowerInstance.dcType != \'-1\') && vm.openGraphDialoge(vm.sentinelId,nmeaPowerInstance.nmeaDataFieldEnumId,nmeaPowerInstance.instanceNumber,nmeaPowerInstance.sourceId,\'Power\',nmeaPowerInstance.name,nmeaPowerInstance.nmeaSourceId)\"><div><img ng-src=\"{{ nmeaPowerInstance.icon }}\" class=nmea-alert-icon-medium></div><label class=\"card-label unset p-0-imp m-0-imp white nmea-fluid-level-label ng-binding\">{{ nmeaPowerInstance.name }}</label><label class=\"badge unset green nmea-medium-label\" ng-if=nmeaPowerInstance.value>{{ nmeaPowerInstance.value }}%</label><label class=\"badge unset green nmea-medium-label\" ng-if=\"(nmeaPowerInstance.voltage && nmeaPowerInstance.dcType==-1) || (nmeaPowerInstance.voltage && !nmeaPowerInstance.value)\">{{nmeaPowerInstance.voltage }}v</label><label class=\"badge unset green nmea-medium-label\" ng-if=\"(nmeaPowerInstance.current && nmeaPowerInstance.dcType==-1) || (nmeaPowerInstance.current && !nmeaPowerInstance.value)\">{{nmeaPowerInstance.current }}A</label></div></div></div></div></div></div><div class=\"row m-10\" ng-if=\"vm.nmeaFluidInstances.length>0\"><div class=bound-box><label class=\"field white\" style=\"float: left !important\">{{ \"FluidLevel.Text\" | translate }}</label><div class=row><div class=bound-box><div class=\"col-sm-3 col-xs-4 col-md-3 fluid-container\" ng-repeat=\"nmeaFluidInstance in vm.nmeaFluidInstances\"><div class=\"row text-center\" ng-click=\"vm.openGraphDialoge(vm.sentinelId,vm.nmeaDataFieldEnum.Pgn127505Level,null,nmeaFluidInstance.sourceId,\'Fluid\',nmeaFluidInstance.name)\"><div class=\"m-b-5 m-t-10\"><canvas id={{nmeaFluidInstance.canvasId}}></canvas></div><label class=\"card-label unset p-0-imp m-0-imp white nmea-fluid-level-label\">{{ nmeaFluidInstance.name }}</label><label class=\"badge unset green nmea-medium-label\">{{ nmeaFluidInstance.value }}%</label></div></div></div></div></div></div><div class=\"row m-10\" ng-if=\"vm.insideTemperature!=undefined || vm.seaTemperature!=undefined || vm.outsideTemperature!=undefined || vm.engineRoomTemperature!=undefined || vm.mainCabinTemperature!=undefined || vm.refrigerationTemperature!=undefined\"><div class=bound-box><label class=\"field white\">{{ \"Temperature.Text\" | translate }}</label><div class=\"col-sm-12 col-xs-12\"><div ng-class=\"{\'col-sm-6 col-xs-6\':vm.temperatureCount==2,\'col-md-4 col-sm-6 col-xs-6\':vm.temperatureCount!=2}\" class=temperature-container ng-if=\"vm.insideTemperature!=undefined\" ng-click=\"vm.openGraphDialoge(vm.sentinelId,vm.nmeaDataFieldEnum.Pgn130316Temperature,null,vm.nmeaTemperatureSourceEnum.InsideTemperature,\'Temperature\',\'Inside\')\"><div class=\"row text-center\"><div class=\"m-b-5 m-t-10\"><img src=assets/images/Temperature-Inside.png class=nmea-alert-icon-medium></div><label class=\"card-label unset p-0-imp m-0-imp white nmea-fluid-level-label ng-binding\">{{ \"Inside.Text\" | translate }}</label><label class=\"badge unset green nmea-medium-label\">{{ vm.insideTemperature | temperature }}</label></div></div><div ng-class=\"{\'col-sm-6 col-xs-6\':vm.temperatureCount==2,\'col-md-4 col-sm-6 col-xs-6\':vm.temperatureCount!=2}\" class=temperature-container ng-if=\"vm.outsideTemperature!=undefined\" ng-click=\"vm.openGraphDialoge(vm.sentinelId,vm.nmeaDataFieldEnum.Pgn130316Temperature,null,vm.nmeaTemperatureSourceEnum.OutsideTemperature,\'Temperature\',\'Outside\')\"><div class=\"row text-center\"><div class=\"m-b-5 m-t-10\"><img src=assets/images/Temperature-Outside.png class=nmea-alert-icon-medium></div><label class=\"card-label unset p-0-imp m-0-imp white nmea-fluid-level-label ng-binding\">{{ \"Outside.Text\" | translate }}</label><label class=\"badge unset green nmea-medium-label\">{{ vm.outsideTemperature | temperature }}</label></div></div><div ng-class=\"{\'col-sm-6 col-xs-6\':vm.temperatureCount==2,\'col-md-4 col-sm-6 col-xs-6\':vm.temperatureCount!=2}\" class=temperature-container ng-if=\"vm.seaTemperature!=undefined\" ng-click=\"vm.openGraphDialoge(vm.sentinelId,vm.nmeaDataFieldEnum.Pgn130316Temperature,null,vm.nmeaTemperatureSourceEnum.SeaTemperature,\'Temperature\',\'Water\')\"><div class=\"row text-center\"><div class=\"m-b-5 m-t-10\"><img src=assets/images/Temperature-Sea.png class=nmea-alert-icon-medium></div><label class=\"card-label unset p-0-imp m-0-imp white nmea-fluid-level-label ng-binding\">{{ \"Water.Text\" | translate }}</label><label class=\"badge unset green nmea-medium-label\">{{ vm.seaTemperature | temperature }}</label></div></div><div ng-class=\"{\'col-sm-6 col-xs-6\':vm.temperatureCount==2,\'col-md-4 col-sm-6 col-xs-6\':vm.temperatureCount!=2}\" class=temperature-container ng-if=\"vm.engineRoomTemperature!=undefined\" ng-click=\"vm.openGraphDialoge(vm.sentinelId,vm.nmeaDataFieldEnum.Pgn130316Temperature,null,vm.nmeaTemperatureSourceEnum.EngineRoomTemperature,\'Temperature\',\'Engine room\')\"><div class=\"row text-center\"><div class=\"m-b-5 m-t-10\"><img src=assets/images/engine_room.png class=nmea-alert-icon-medium></div><label class=\"card-label unset p-0-imp m-0-imp white nmea-fluid-level-label ng-binding\">{{ \"EngineRoom.Text\" | translate }}</label><label class=\"badge unset green nmea-medium-label\">{{ vm.engineRoomTemperature | temperature }}</label></div></div><div ng-class=\"{\'col-sm-6 col-xs-6\':vm.temperatureCount==2,\'col-md-4 col-sm-6 col-xs-6\':vm.temperatureCount!=2}\" class=temperature-container ng-if=\"vm.mainCabinTemperature!=undefined\" ng-click=\"vm.openGraphDialoge(vm.sentinelId,vm.nmeaDataFieldEnum.Pgn130316Temperature,null,vm.nmeaTemperatureSourceEnum.MainCabinTemperature,\'Temperature\',\'Main Cabin\')\"><div class=\"row text-center\"><div class=\"m-b-5 m-t-10\"><img src=assets/images/main_cabin.png class=nmea-alert-icon-medium></div><label class=\"card-label unset p-0-imp m-0-imp white nmea-fluid-level-label ng-binding\">{{ \"MainCabin.Text\" | translate }}</label><label class=\"badge unset green nmea-medium-label\">{{ vm.mainCabinTemperature | temperature }}</label></div></div><div ng-class=\"{\'col-sm-6 col-xs-6\':vm.temperatureCount==2,\'col-md-4 col-sm-6 col-xs-6\':vm.temperatureCount!=2}\" class=temperature-container ng-if=\"vm.refrigerationTemperature!=undefined\" ng-click=\"vm.openGraphDialoge(vm.sentinelId,vm.nmeaDataFieldEnum.Pgn130316Temperature,null,vm.nmeaTemperatureSourceEnum.RefrigerationTemperature,\'Temperature\',\'Refrigeration temperature\')\"><div class=\"row text-center\"><div class=\"m-b-5 m-t-10\"><img src=assets/images/freezer.png class=nmea-alert-icon-medium></div><label class=\"card-label unset p-0-imp m-0-imp white nmea-fluid-level-label ng-binding\">{{ \"RefrigerationTemp.Text\" | translate }}</label><label class=\"badge unset green nmea-medium-label\">{{ vm.refrigerationTemperature | temperature }}</label></div></div><div ng-class=\"{\'col-sm-6 col-xs-6\':vm.temperatureCount==2,\'col-md-4 col-sm-6 col-xs-6\':vm.temperatureCount!=2}\" class=temperature-container ng-if=\"vm.liveWellTemperature!=undefined\" ng-click=\"vm.openGraphDialoge(vm.sentinelId,vm.nmeaDataFieldEnum.Pgn130316Temperature,null,vm.nmeaTemperatureSourceEnum.LiveWellTemperature,\'Temperature\',\'Live Well\')\"><div class=\"row text-center\"><div class=\"m-b-5 m-t-10\"><img src=assets/images/liveWell.png class=nmea-alert-icon-medium></div><label class=\"card-label unset p-0-imp m-0-imp white nmea-fluid-level-label ng-binding\">{{ \"Livewell.Text\" | translate }}</label><label class=\"badge unset green nmea-medium-label\">{{ vm.liveWellTemperature | temperature }}</label></div></div><div ng-class=\"{\'col-sm-6 col-xs-6\':vm.temperatureCount==2,\'col-md-4 col-sm-6 col-xs-6\':vm.temperatureCount!=2}\" class=temperature-container ng-if=\"vm.bailWellTemperature!=undefined\" ng-click=\"vm.openGraphDialoge(vm.sentinelId,vm.nmeaDataFieldEnum.Pgn130316Temperature,null,vm.nmeaTemperatureSourceEnum.BailWellTemperature,\'Temperature\',\'Bail Well\')\"><div class=\"row text-center\"><div class=\"m-b-5 m-t-10\"><img src=assets/images/bailWell.png class=nmea-alert-icon-medium></div><label class=\"card-label unset p-0-imp m-0-imp white nmea-fluid-level-label ng-binding\">{{ \"BailWell.Text\" | translate }}</label><label class=\"badge unset green nmea-medium-label\">{{ vm.bailWellTemperature | temperature }}</label></div></div><div ng-class=\"{\'col-sm-6 col-xs-6\':vm.temperatureCount==2,\'col-md-4 col-sm-6 col-xs-6\':vm.temperatureCount!=2}\" class=temperature-container ng-if=\"vm.heatingSystemTemperature!=undefined\" ng-click=\"vm.openGraphDialoge(vm.sentinelId,vm.nmeaDataFieldEnum.Pgn130316Temperature,null,vm.nmeaTemperatureSourceEnum.HeatingSystemTemperature,\'Temperature\',\'Heating System\')\"><div class=\"row text-center\"><div class=\"m-b-5 m-t-10\"><img src=assets/images/heatingSystem.png class=nmea-alert-icon-medium></div><label class=\"card-label unset p-0-imp m-0-imp white nmea-fluid-level-label ng-binding\">{{ \"HeatingSystem.Text\" | translate }}</label><label class=\"badge unset green nmea-medium-label\">{{ vm.heatingSystemTemperature | temperature }}</label></div></div><div ng-class=\"{\'col-sm-6 col-xs-6\':vm.temperatureCount==2,\'col-md-4 col-sm-6 col-xs-6\':vm.temperatureCount!=2}\" class=temperature-container ng-if=\"vm.dewPointTemperature!=undefined\" ng-click=\"vm.openGraphDialoge(vm.sentinelId,vm.nmeaDataFieldEnum.Pgn130316Temperature,null,vm.nmeaTemperatureSourceEnum.DewPointTemperature,\'Temperature\',\'Dew Point\')\"><div class=\"row text-center\"><div class=\"m-b-5 m-t-10\"><img src=assets/images/dewPoint.png class=nmea-alert-icon-medium></div><label class=\"card-label unset p-0-imp m-0-imp white nmea-fluid-level-label ng-binding\">{{ \"DewPoint.Text\" | translate }}</label><label class=\"badge unset green nmea-medium-label\">{{ vm.dewPointTemperature | temperature }}</label></div></div><div ng-class=\"{\'col-sm-6 col-xs-6\':vm.temperatureCount==2,\'col-md-4 col-sm-6 col-xs-6\':vm.temperatureCount!=2}\" class=temperature-container ng-if=\"vm.windChillTemperature!=undefined\" ng-click=\"vm.openGraphDialoge(vm.sentinelId,vm.nmeaDataFieldEnum.Pgn130316Temperature,null,vm.nmeaTemperatureSourceEnum.WindChillTemperatureAndApparent,\'Temperature\',\'Wind Chill\')\"><div class=\"row text-center\"><div class=\"m-b-5 m-t-10\"><img src=assets/images/windChill.png class=nmea-alert-icon-medium></div><label class=\"card-label unset p-0-imp m-0-imp white nmea-fluid-level-label ng-binding\">{{ \"WindChill.Text\" | translate }}</label><label class=\"badge unset green nmea-medium-label\">{{ vm.windChillTemperature | temperature }}</label></div></div><div ng-class=\"{\'col-sm-6 col-xs-6\':vm.temperatureCount==2,\'col-md-4 col-sm-6 col-xs-6\':vm.temperatureCount!=2}\" class=temperature-container ng-if=\"vm.freezerTemperature!=undefined\" ng-click=\"vm.openGraphDialoge(vm.sentinelId,vm.nmeaDataFieldEnum.Pgn130316Temperature,null,vm.nmeaTemperatureSourceEnum.FreezerTemperature,\'Temperature\',\'Freezer\')\"><div class=\"row text-center\"><div class=\"m-b-5 m-t-10\"><img src=assets/images/freezer.png class=nmea-alert-icon-medium></div><label class=\"card-label unset p-0-imp m-0-imp white nmea-fluid-level-label ng-binding\">{{ \"Freezer.Text\" | translate }}</label><label class=\"badge unset green nmea-medium-label\">{{ vm.freezerTemperature | temperature }}</label></div></div><div ng-class=\"{\'col-sm-6 col-xs-6\':vm.temperatureCount==2,\'col-md-4 col-sm-6 col-xs-6\':vm.temperatureCount!=2}\" class=temperature-container ng-if=\"vm.exhaustGasTemperature!=undefined\" ng-click=\"vm.openGraphDialoge(vm.sentinelId,vm.nmeaDataFieldEnum.Pgn130316Temperature,null,vm.nmeaTemperatureSourceEnum.ExhaustGasTemperature,\'Temperature\',\'Exhaust Gas\')\"><div class=\"row text-center\"><div class=\"m-b-5 m-t-10\"><img src=assets/images/exhaustGas.png class=nmea-alert-icon-medium></div><label class=\"card-label unset p-0-imp m-0-imp white nmea-fluid-level-label ng-binding\">{{ \"ExhaustGas.Text\" | translate }}</label><label class=\"badge unset green nmea-medium-label\">{{ vm.exhaustGasTemperature | temperature }}</label></div></div></div></div></div><div class=\"row m-10\" ng-if=\"vm.insideHumidity!=undefined || vm.outsideHumidity!=undefined\"><div class=bound-box><label class=\"field white\">{{ \"Humidity.Text\" | translate }}</label><div class=\"col-sm-12 col-xs-12\"><div class=\"col-md-4 col-sm-6 col-xs-6\" ng-if=\"vm.insideHumidity!=undefined\" class=temperature-container ng-click=\"vm.openGraphDialoge(vm.sentinelId,vm.nmeaDataFieldEnum.Pgn130313ActualHumidity,null,0,\'Humidity\',\'Inside\')\"><div class=\"row text-center\"><div class=\"m-b-5 m-t-10\"><img src=assets/images/Humidity-indoor.png class=nmea-alert-icon-medium></div><label class=\"card-label unset p-0-imp m-0-imp white nmea-fluid-level-label ng-binding\">{{ \"Inside.Text\" | translate }}</label><label class=\"badge unset green nmea-medium-label\">{{ vm.insideHumidity }}%</label></div></div><div class=\"col-md-4 col-sm-6 col-xs-6\" ng-if=\"vm.outsideHumidity!=undefined\" class=temperature-container ng-click=\"vm.openGraphDialoge(vm.sentinelId,vm.nmeaDataFieldEnum.Pgn130313ActualHumidity,null,1,\'Humidity\',\'Outside\')\"><div class=\"row text-center\"><div class=\"m-b-5 m-t-10\"><img src=assets/images/Humidity-Outdoor.png class=nmea-alert-icon-medium></div><label class=\"card-label unset p-0-imp m-0-imp white nmea-fluid-level-label ng-binding\">{{ \"Outside.Text\" | translate }}</label><label class=\"badge unset green nmea-medium-label\">{{ vm.outsideHumidity }}%</label></div></div></div></div></div><div class=\"row m-10\" ng-if=vm.showSampleData><div style=\"bottom: 65px;\r\n    z-index: 99999;\r\n    width: 100%;\r\n    background: #003055;\r\n    text-align: center;\r\n    position: fixed;\r\n    left: 0;\r\n    padding:10px 0\"><span style=\"color:red;font-size: 20px;font-weight: 500\">Sample Data</span></div></div>");
$templateCache.put("app/main/nmea/power-details/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.nmeaDashboardDeatails.logo.show() ng-src={{vm.oemConfig.nmeaDashboardDeatails.logo.image}} class=symbol><h2 class=red-border-bottom>{{ \"PowerDetails.Text\" | translate }}</h2></div>");
$templateCache.put("app/main/nmea/power-details/power-details.controller.html","<div class=row><div class=\"col-md-12 text-center\"><label style=\"font-size:24px;font-family: \'proximanova\', Arial, sans-serif;color : #182E51\">{{ vm.currentSelected | translate }}</label><br><label style=\"font-size:20px;font-family: \'proximanova\', Arial, sans-serif;color : red\">{{ vm.currentPowerInstanceName }}</label></div></div><div class=row ng-hide=!vm.powerGraphData.length><div class=\"col-md-12 text-center\"><div id=chartdiv style=\"min-height: 350px\"></div></div></div><div class=row ng-hide=vm.powerGraphData.length><div class=\"col-md-12 text-center\"><h2>{{ \"GraphDataUnavailable.Text\" | translate }}</h2></div></div><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=\"col-md-4 col-sm-4 col-xs-4 text-center\" style=\"padding: 0px 8% 0px 8%\"><button class=nmea-graph-btn ng-class=\"{active: vm.isActiveInterval==vm.nmeaGraphIntervalEnum.Daily}\" ng-click=vm.getDailyGraphData()><div class=\"badge nmea-graph-btn-icon shaded-blue\"></div>{{ \"Daily.Text\" | translate }}</button></div><div class=\"col-md-4 col-sm-4 col-xs-4 text-center\" style=\"padding: 0px 8% 0px 8%\"><button class=nmea-graph-btn ng-class=\"{active: vm.isActiveInterval==vm.nmeaGraphIntervalEnum.Weekly}\" ng-click=vm.getWeeklyGraphData()><div class=\"badge nmea-graph-btn-icon shaded-purple\"></div>{{ \"Weekly.Text\" | translate }}</button></div><div class=\"col-md-4 col-sm-4 col-xs-4 text-center\" style=\"padding: 0px 8% 0px 8%\"><button class=nmea-graph-btn ng-class=\"{active: vm.isActiveInterval==vm.nmeaGraphIntervalEnum.Monthly}\" ng-click=vm.getMonthlyGraphData()><div class=\"badge nmea-graph-btn-icon shaded-orange\"></div>{{ \"Monthly.Text\" | translate }}</button></div></div></div><div class=\"row m-t-30\" style=\"padding-bottom: 10px\" ng-repeat=\"nmeaPowerInstance in vm.nmeaPowerInstances\"><div class=\"bound-box m-t-15\"><div class=\"col-md-12 col-sm-12 col-xs-12\" class=nmea-engine-widget-background><label class=field>{{ nmeaPowerInstance.name }}</label><div class=\"col-md-6 col-sm-6 col-xs-12 m-t-5\" ng-click=\"vm.getGraphData(nmeaPowerInstance.name,\'Voltage.Text\',nmeaPowerInstance.instanceNumber,vm.nmeaDataFieldEnum.Pgn127508Voltage,nmeaPowerInstance.nmeaSourceId,\'V\')\"><div class=nmea-engine-widget-left-side><img src=assets/images/voltage_logo.png class=nmea-m-auto></div><div class=nmea-engine-widget-right-side><p class=nmea-engine-widget-small-text>{{ \"Voltage.Text\" | translate }}</p><div class=nmea-engine-widget-value-div><p class=nmea-engine-widget-small-text style=\"width:100%;font-size: 12px;font-weight: 500\" ng-if=\"nmeaPowerInstance.voltage!=undefined\">{{ nmeaPowerInstance.voltage }} V</p><p class=nmea-engine-widget-small-text style=\"width:100%;font-size: 12px;font-weight: 500\" ng-if=\"nmeaPowerInstance.voltage==undefined\">N/A</p></div></div></div><div class=\"col-md-6 col-sm-6 col-xs-12 m-t-5\" ng-click=\"vm.getGraphData(nmeaPowerInstance.name,\'Current.Text\',nmeaPowerInstance.instanceNumber,vm.nmeaDataFieldEnum.Pgn127508Current,nmeaPowerInstance.nmeaSourceId,\'A\')\"><div class=nmea-engine-widget-left-side><img src=assets/images/voltage_logo.png class=nmea-m-auto></div><div class=nmea-engine-widget-right-side><p class=nmea-engine-widget-small-text>{{ \"Current.Text\" | translate }}</p><div class=nmea-engine-widget-value-div><p class=nmea-engine-widget-small-text style=\"width:100%;font-size: 12px;font-weight: 500\" ng-if=\"nmeaPowerInstance.current!=undefined\">{{ nmeaPowerInstance.current }} A</p><p class=nmea-engine-widget-small-text style=\"width:100%;font-size: 12px;font-weight: 500\" ng-if=\"nmeaPowerInstance.current==undefined\">N/A</p></div></div></div><div class=\"col-md-6 col-sm-6 col-xs-12 m-t-5\" ng-click=\"vm.getGraphData(nmeaPowerInstance.name,\'StateOfCharge.Text\',nmeaPowerInstance.instanceNumber,vm.nmeaDataFieldEnum.Pgn127506StateOfCharge,nmeaPowerInstance.nmeaSourceId,\'%\')\"><div class=nmea-engine-widget-left-side><img src=assets/images/Battery-logo.png class=nmea-m-auto></div><div class=nmea-engine-widget-right-side><p class=nmea-engine-widget-small-text>{{ \"StateOfCharge.Text\" | translate }}</p><div class=nmea-engine-widget-value-div><p class=nmea-engine-widget-small-text style=\"width:100%;font-size: 12px;font-weight: 500\" ng-if=\"nmeaPowerInstance.stateOfCharge!=undefined\">{{ nmeaPowerInstance.stateOfCharge }}%</p><p class=nmea-engine-widget-small-text style=\"width:100%;font-size: 12px;font-weight: 500\" ng-if=\"nmeaPowerInstance.stateOfCharge==undefined\">N/A</p></div></div></div><div class=\"col-md-6 col-sm-6 col-xs-12 m-t-5\" ng-click=\"vm.getGraphData(nmeaPowerInstance.name,\'BatteryCaseTemperature.Text\',nmeaPowerInstance.instanceNumber,vm.nmeaDataFieldEnum.Pgn127508Temperature,nmeaPowerInstance.nmeaSourceId,\'°c\')\"><div class=nmea-engine-widget-left-side><img src=assets/images/Temperature_logo.png class=nmea-m-auto></div><div class=nmea-engine-widget-right-side><p class=nmea-engine-widget-small-text>{{ \"BatteryCaseTemperature.Text\" | translate }}</p><div class=nmea-engine-widget-value-div><p class=nmea-engine-widget-small-text style=\"width:100%;font-size: 12px;font-weight: 500\" ng-if=\"nmeaPowerInstance.batteryCaseTemperature!=undefined\">{{ nmeaPowerInstance.batteryCaseTemperature | temperature }}</p><p class=nmea-engine-widget-small-text style=\"width:100%;font-size: 12px;font-weight: 500\" ng-if=\"nmeaPowerInstance.batteryCaseTemperature==undefined\">N/A</p></div></div></div><div class=\"col-md-6 col-sm-6 col-xs-12 m-t-5\" ng-click=\"vm.getGraphData(nmeaPowerInstance.name,\'StateOfHealth.Text\',nmeaPowerInstance.instanceNumber,vm.nmeaDataFieldEnum.Pgn127506StateOfHealth,nmeaPowerInstance.nmeaSourceId,\'%\')\"><div class=nmea-engine-widget-left-side><img src=assets/images/health_logo.png class=nmea-m-auto></div><div class=nmea-engine-widget-right-side><p class=nmea-engine-widget-small-text>{{ \"StateOfHealth.Text\" | translate }}</p><div class=nmea-engine-widget-value-div><p class=nmea-engine-widget-small-text style=\"width:100%;font-size: 12px;font-weight: 500\" ng-if=\"nmeaPowerInstance.stateOfHealth!=undefined\">{{ nmeaPowerInstance.stateOfHealth }}%</p><p class=nmea-engine-widget-small-text style=\"width:100%;font-size: 12px;font-weight: 500\" ng-if=\"nmeaPowerInstance.stateOfHealth==undefined\">N/A</p></div></div></div><div class=\"col-md-6 col-sm-6 col-xs-12 m-t-5\" ng-click=\"vm.getGraphData(nmeaPowerInstance.name,\'TimeRemaining.Text\',nmeaPowerInstance.instanceNumber,vm.nmeaDataFieldEnum.Pgn127506TimeRemaining,nmeaPowerInstance.nmeaSourceId,\'Hrs\')\"><div class=nmea-engine-widget-left-side><img src=assets/images/clock_logo.png class=nmea-m-auto></div><div class=nmea-engine-widget-right-side><p class=nmea-engine-widget-small-text>{{ \"TimeRemaining.Text\" | translate }}</p><div class=nmea-engine-widget-value-div><p class=nmea-engine-widget-small-text style=\"width: 100%;font-size: 12px;font-weight: 500\" ng-if=\"nmeaPowerInstance.timeRemaining!=undefined\">{{ nmeaPowerInstance.timeRemaining }} Hrs</p><p class=nmea-engine-widget-small-text style=\"width:100%;font-size: 12px;font-weight: 500\" ng-if=\"nmeaPowerInstance.timeRemaining==undefined\">N/A</p></div></div></div><div class=\"col-md-6 col-sm-6 col-xs-12 m-t-5\" ng-click=\"vm.getGraphData(nmeaPowerInstance.name,\'AmpHours.Text\',nmeaPowerInstance.instanceNumber,vm.nmeaDataFieldEnum.Pgn127506AmpHours,nmeaPowerInstance.nmeaSourceId,\'AH\')\"><div class=nmea-engine-widget-left-side><img src=assets/images/power_logo.png class=nmea-m-auto></div><div class=nmea-engine-widget-right-side><p class=nmea-engine-widget-small-text>{{ \"AmpHours.Text\" | translate }}</p><div class=nmea-engine-widget-value-div><p class=nmea-engine-widget-small-text style=\"width:100%;font-size: 12px;font-weight: 500\" ng-if=\"nmeaPowerInstance.ampHours!=undefined\">{{ nmeaPowerInstance.ampHours }}AH</p><p class=nmea-engine-widget-small-text style=\"width:100%;font-size: 12px;font-weight: 500\" ng-if=\"nmeaPowerInstance.ampHours==undefined\">N/A</p></div></div></div></div></div></div><div class=\"row m-10\" ng-if=vm.showSampleData><div style=\"bottom: 65px;\r\n      z-index: 99999;\r\n      width: 100%;\r\n      background: #003055;\r\n      text-align: center;\r\n      position: fixed;\r\n      left: 0;\r\n      padding:10px 0\"><span style=\"color:red;font-size: 20px;font-weight: 500\">Sample Data</span></div></div>");
$templateCache.put("app/main/sensors/rename/rename.html","<form novalidate name=form ng-submit=\"form.$valid && vm.saveChanges()\"><!--  --><div class=col-sm-12><div class=bound-box><label class=field>{{vm.sensor.sensorType.sensorTypeName}}</label><div class=\"col-sm-6 card small flex-card\"><div class=col-sm-6><label class=card-label>{{\'SensorName\' | translate}}</label><input type=text class=active ng-model=vm.sensor.sensorName></div></div></div></div><!--  --><div class=\"col-sm-12 mid\" ng-if=vm.hasAccess><button class=\"oval-btn blue\">{{\'RenameIt\' | translate}}</button></div></form>");
$templateCache.put("app/main/sensors/index/error-box-dialog.html","<div class=modal-content><div class=modal-body><img src=assets/images/sos2.png><h3>No sensors found</h3><a href=\"\" ng-click=$dismiss()>Cancel</a></div></div><!-- modal-content -->");
$templateCache.put("app/main/sensors/index/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.sensors.logo.show() ng-src={{vm.oemConfig.sensors.logo.image}} class=symbol><h2 class=red-border-bottom>{{\'RenameSensor\' | translate}}</h2></div>");
$templateCache.put("app/main/sensors/index/index.html","<!--  --><div class=col-sm-6 ng-repeat=\"items in vm.sensorTypes\"><div class=bound-box ng-repeat=\"type in items\" ng-if=\"type.sensors.length > 0\"><label class=field>{{ type.sensorTypeName }}</label><div class=\"col-sm-12 card small flex-card\" ng-repeat=\"s in type.sensors\"><label class=\"card-label full\" ui-sref=\"boat.rename_sensor({sentinelId:s.userSentinelId , sensorId: s.id})\">{{ s.sensorName }}</label><!--Hide edit link for Center unit temperature sensor--> <a ui-sref=\"boat.rename_sensor({sentinelId:s.userSentinelId , sensorId: s.id})\" ng-hide=\"s.sensorNumber == 1 && s.sensorTypeId == 1\" ng-if=\"vm.sharedUserPermissions==null && vm.sharedUserPermissions==undefined\" class=pull-right><img src=assets/images/edit.png></a><button ng-click=vm.deleteSensor(s) ng-hide=\"s.sensorNumber == 1 && s.sensorTypeId == 1\" ng-if=\"vm.sharedUserPermissions==null && vm.sharedUserPermissions==undefined\" class=\"pull-right link\"><i style=margin-top:5px class=\"fa fa-times fa-2x\"></i></button></div></div></div><!--  --><div class=col-sm-12 ng-if=\"vm.cameras.length>0\"><div class=bound-box><label class=field>{{ \"Cameras.Text\" | translate }}</label></div></div><div class=col-sm-6 ng-if=\"vm.cameras.length>0\" ng-repeat=\"camera in vm.cameras\"><div class=bound-box><div class=\"col-sm-12 card small flex-card\"><label class=\"card-label full\">{{ camera.name }}</label><a class=pull-right ng-click=vm.renameCamera(camera) ng-if=\"vm.sharedUserPermissions==null && vm.sharedUserPermissions==undefined\"><img src=assets/images/edit.png></a><button ng-click=vm.deleteCamera(camera) ng-hide=\"s.sensorNumber == 1 && s.sensorTypeId == 1\" class=\"pull-right link\" ng-if=\"vm.sharedUserPermissions==null && vm.sharedUserPermissions==undefined\"><i style=margin-top:5px class=\"fa fa-times fa-2x\"></i></button></div></div></div><!--  --><div class=col-sm-12 ng-if=\"vm.cameras.length>0\"><div class=bound-box><label class=field>{{ \"Cameras.Text\" | translate }}</label></div></div><div class=col-sm-6 ng-if=\"vm.cameras.length>0\" ng-repeat=\"camera in vm.cameras\"><div class=bound-box><div class=\"col-sm-12 card small flex-card\"><label class=\"card-label full\">{{ camera.name }}</label><a class=pull-right ng-click=vm.renameCamera(camera) ng-if=\"vm.sharedUserPermissions==null && vm.sharedUserPermissions==undefined\"><img src=assets/images/edit.png></a><button ng-click=vm.deleteCamera(camera) ng-hide=\"s.sensorNumber == 1 && s.sensorTypeId == 1\" class=\"pull-right link\" ng-if=\"vm.sharedUserPermissions==null && vm.sharedUserPermissions==undefined\"><i style=margin-top:5px class=\"fa fa-times fa-2x\"></i></button></div></div></div><!--  --><div class=row><div class=col-sm-6 ng-if=\"vm.engines.length>0\"><div class=col-sm-12><div class=bound-box style=\"margin-bottom: 0px\"><label class=field>{{ \"NmeaEngines.Text\" | translate }}</label></div></div><div class=col-sm-12 ng-repeat=\"engine in vm.engines\"><div class=\"col-sm-6 card small flex-card\"><label class=\"card-label full\" ui-sref=\"boat.rename_nmea_instance({sentinelId:engine.userSentinelId, instanceNumber: engine.nmeaInstanceNumber, instanceType:\'Engine\', instanceName:engine.instanceName})\">{{ engine.instanceName }}</label><a class=pull-right ui-sref=\"boat.rename_nmea_instance({sentinelId:engine.userSentinelId, instanceNumber: engine.nmeaInstanceNumber, instanceType:\'Engine\', instanceName:engine.instanceName})\" ng-if=\"vm.sharedUserPermissions==null && vm.sharedUserPermissions==undefined\"><img src=assets/images/edit.png></a></div></div></div><div class=col-sm-6><div class=col-sm-12 ng-repeat=\"powerInstance in vm.powerInstances\"><div class=bound-box><label class=field ng-if=\"powerInstance.dcType==vm.nmeaDcTypesEnum.Battery\">{{ \"BatteryInstance.Text\" | translate }}</label><label class=field ng-if=\"powerInstance.dcType==vm.nmeaDcTypesEnum.SolarCell\">{{ \"SolarCellInstance.Text\" | translate }}</label><label class=field ng-if=\"powerInstance.dcType==vm.nmeaDcTypesEnum.WindPower\">{{ \"WindPowerInstance.Text\" | translate }}</label><label class=field ng-if=\"powerInstance.dcType== -1\">{{ \"UNKNOWN.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\" style=margin-right:5px ng-repeat=\"nmeaInstance in powerInstance.nmeaInstances\"><label class=\"card-label full\" ui-sref=\"boat.rename_nmea_instance({sentinelId:nmeaInstance.userSentinelId, instanceNumber: nmeaInstance.nmeaInstanceNumber, sourceId: nmeaInstance.sourceId, instanceType:\'Power\', instanceName:nmeaInstance.instanceName})\">{{ nmeaInstance.instanceName }}</label><a class=pull-right ui-sref=\"boat.rename_nmea_instance({sentinelId:nmeaInstance.userSentinelId, instanceNumber: nmeaInstance.nmeaInstanceNumber,sourceId: nmeaInstance.sourceId, instanceType:\'Power\', instanceName:nmeaInstance.instanceName})\" ng-if=\"vm.sharedUserPermissions==null && vm.sharedUserPermissions==undefined\"><img src=assets/images/edit.png></a></div></div></div></div></div><!--  -->");
$templateCache.put("app/main/sensors/rename_camera/rename_camera.html","<form novalidate name=form ng-submit=\"form.$valid && vm.saveChanges()\"><!--  --><div class=col-sm-12><div class=bound-box><label class=field>{{ \"Camera_Name\" | translate }}</label><div class=\"col-sm-6 card small flex-card\"><div class=col-sm-6><label class=card-label>{{ \"Camera_Name\" | translate }}</label><input type=text class=active ng-model=vm.newName></div></div></div></div><!--  --><div class=\"col-sm-12 mid\" ng-if=vm.hasAccess><button class=\"oval-btn blue\">{{ \"RenameIt\" | translate }}</button></div></form>");
$templateCache.put("app/main/sensors/rename_nmea_instance/rename.html","<form novalidate name=form ng-submit=\"form.$valid && vm.saveChanges()\"><!--  --><div class=col-sm-12><div class=bound-box><label class=field>{{ \"NmeaInstance.Text\" | translate }}</label><div class=\"col-sm-6 card small flex-card\"><div class=col-sm-6><label class=card-label>{{ \"EnterNewName.Text\" | translate }}</label><input type=text class=active ng-model=vm.newName></div></div></div></div><!--  --><div class=\"col-sm-12 mid\" ng-if=vm.hasAccess><button class=\"oval-btn blue\">{{ \"RenameIt\" | translate }}</button></div></form>");
$templateCache.put("app/main/alarm/nmea/current-trip-alarm/alarm1.html","<div class=col-sm-12 style=margin-left:-5px><a href ng-click=vm.goBack() style=\"float: left\"><img src=assets/images/back.png class=back-btn2></a></div><!-- <div class=\"row\"> --><div class=col-sm-6 ng-if=vm.hasTimeToEmptyData><div class=bound-box><label class=field>{{ \"TimeToEmpty.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=green rz-slider-model=vm.nmeaAlarm1TimeToEmpty.alarm.triggerValue rz-slider-options=vm.nmeaAlarm1TimeToEmpty.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm1TimeToEmpty.enabled class=green disabled=!vm.hasTimeToEmptyData ng-change=vm.hasSupportForFeature(vm.hasTimeToEmptyData)></switch></div></div></div><div class=col-sm-6 ng-if=vm.hasDistanceToEmptyData><div class=bound-box><label class=field>{{ \"DistanceToEmpty.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=green rz-slider-model=vm.nmeaAlarm1DistanceToEmpty.alarm.triggerValue rz-slider-options=vm.nmeaAlarm1DistanceToEmpty.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm1DistanceToEmpty.enabled class=green disabled=!vm.hasDistanceToEmptyData ng-change=vm.hasSupportForFeature(vm.hasDistanceToEmptyData)></switch></div></div></div><!--  --><!-- </div>\r\n<div class=\"row\"> --><div class=col-sm-6 ng-if=vm.hasTripDistanceData><div class=bound-box><label class=field>{{ \"TripDistance.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaAlarm1TripDistance.alarm.triggerValue rz-slider-options=vm.nmeaAlarm1TripDistance.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm1TripDistance.enabled class=green disabled=!vm.hasTripDistanceData ng-change=vm.hasSupportForFeature(vm.hasTripDistanceData)></switch></div></div></div><div class=col-sm-6 ng-if=vm.hasTripRunTimeData><div class=bound-box><label class=field>{{ \"TripRunTime.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaAlarm1TripRunTime.alarm.triggerValue rz-slider-options=vm.nmeaAlarm1TripRunTime.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm1TripRunTime.enabled class=green disabled=!vm.hasTripRunTimeData ng-change=vm.hasSupportForFeature(vm.hasTripRunTimeData)></switch></div></div></div><!--  --><!-- </div> --><!--  --><div class=\"col-sm-12 mid\" ng-if=vm.hasAccess><button class=\"oval-btn blue\" ng-click=vm.updateAlarms()>{{ \"SaveChanges.Text\" | translate }}</button></div>");
$templateCache.put("app/main/alarm/nmea/current-trip-alarm/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.nmeaAlarms.logo.show() ng-src={{vm.oemConfig.nmeaAlarms.logo.image}} class=symbol><h2 class=red-border-bottom>{{ \"TimeToEmpty.Text\" | translate }}</h2><div class=status>{{ \"LastUpdatedOn.Text\" | translate }} {{ vm.lastUpdated | utcDate }}</div></div>");
$templateCache.put("app/main/alarm/nmea/fluid/alarm5.html","<div class=col-sm-12 style=margin-left:-5px><a href ng-click=vm.goBack() style=\"float: left\"><img src=assets/images/back.png class=back-btn2></a></div><div class=row><div class=col-sm-6 ng-repeat=\"fluidAlarm in vm.fluidLevelAlarms\"><div class=bound-box><label class=field>{{ fluidAlarm.nmeaInstance.instanceName }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class={{fluidAlarm.class}} rz-slider-model=fluidAlarm.nmeaAlarm.alarm.triggerValue rz-slider-options=fluidAlarm.nmeaAlarm.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=fluidAlarm.nmeaAlarm.enabled class=green></switch></div></div></div></div><div class=\"col-sm-12 mid\" ng-if=vm.hasAccess><button class=\"oval-btn blue\" ng-click=vm.updateAlarms()>{{ \"SaveChanges.Text\" | translate }}</button></div>");
$templateCache.put("app/main/alarm/nmea/fluid/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.nmeaAlarms.logo.show() ng-src={{vm.oemConfig.nmeaAlarms.logo.image}} class=symbol><h2 class=red-border-bottom>{{ \"FluidLevels.Text\" | translate }}</h2><div class=status>{{ \"LastUpdatedOn.Text\" | translate }} {{ vm.lastUpdated | utcDate }}</div></div>");
$templateCache.put("app/main/alarm/nmea/engine/alarm4.html","<div class=col-sm-12 style=margin-left:-5px><a href ng-click=vm.goBack() style=\"float: left\"><img src=assets/images/back.png class=back-btn2></a></div><div class=row><div class=col-sm-12><div class=bound-box><label class=field>{{ \"Engines.Text\" | translate }}</label></div></div></div><div class=row ng-if=\"vm.engines.length>0\"><div class=col-sm-6 ng-repeat=\"engine in vm.engines\"><div class=bound-box><div class=\"col-sm-12 card small flex-card\" ng-click=vm.goToEngineAlarm(engine)><label class=card-label>{{ engine.engineName }}</label><a ng-click=vm.goToEngineAlarm(engine)><img src=assets/images/arrow.png class=\"card-icon pull-right\"></a></div></div></div></div><div class=row ng-if=\"vm.engines.length==0\"><div class=col-sm-6><div class=bound-box><label class=card-label>{{ \"NoEnginesFound.Text\" | translate }}</label></div></div></div>");
$templateCache.put("app/main/alarm/nmea/engine/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.nmeaAlarms.logo.show() ng-src={{vm.oemConfig.nmeaAlarms.logo.image}} class=symbol><h2 class=red-border-bottom>{{ \"Engines.Text\" | translate }}</h2><div class=status>{{ \"LastUpdatedOn.Text\" | translate }} {{ vm.lastUpdated | utcDate }}</div></div>");
$templateCache.put("app/main/alarm/nmea/manufacturer-set/alarm9.html","<div class=col-sm-12 style=margin-left:-5px><a href ng-click=vm.goBack() style=\"float: left\"><img src=assets/images/back.png class=back-btn2></a></div><div class=row><div class=col-sm-12><div class=bound-box><label class=field>{{ \"ExtraDetails.Text\" | translate }}</label></div></div></div><div class=row><div class=col-sm-6><div class=bound-box><label class=field>{{ \"CheckEngine.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled1 name=enabled1 ng-model=vm.nmeaAlarm9CheckEngine class=green disabled=true></switch></div></div></div><div class=col-sm-6><div class=bound-box><label class=field>{{ \"OverTemperature.Text\" | translate }} ({{ \"Engine.Text\" | translate }})</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled2 name=enabled2 ng-model=vm.nmeaAlarm9OverTemperature class=green disabled=true></switch></div></div></div><!--  --></div><div class=row><div class=col-sm-6><div class=bound-box><label class=field>{{ \"LowOilPressure.Text\" | translate }} ({{ \"Engine.Text\" | translate }})</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm9LowOilPressure class=green disabled=true></switch></div></div></div><div class=col-sm-6><div class=bound-box><label class=field>{{ \"LowOilLevel.Text\" | translate }} ({{ \"Engine.Text\" | translate }})</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled4 name=enabled4 ng-model=vm.nmeaAlarm9LowOilLevel class=green disabled=true></switch></div></div></div><!--  --></div><div class=row><div class=col-sm-6><div class=bound-box><label class=field>{{ \"LowFuelPressure.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled5 name=enabled5 ng-model=vm.nmeaAlarm9LowFuelPressure class=green disabled=true></switch></div></div></div><div class=col-sm-6><div class=bound-box><label class=field>{{ \"LowSystemVoltage.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled6 name=enabled6 ng-model=vm.nmeaAlarm9LowSystemVoltage class=green disabled=true></switch></div></div></div><!--  --></div><div class=row><div class=col-sm-6><div class=bound-box><label class=field>{{ \"LowCoolantLevel.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled7 name=enabled7 ng-model=vm.nmeaAlarm9LowCoolantLevel class=green disabled=true></switch></div></div></div><div class=col-sm-6><div class=bound-box><label class=field>{{ \"WaterFlow.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled8 name=enabled8 ng-model=vm.nmeaAlarm9WaterFlow class=green disabled=true></switch></div></div></div><!--  --></div><div class=row><div class=col-sm-6><div class=bound-box><label class=field>{{ \"WaterInFuel.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled9 name=enabled9 ng-model=vm.nmeaAlarm9WaterInFuel class=green disabled=true></switch></div></div></div><!--  --><div class=col-sm-6><div class=bound-box><label class=field>{{ \"ChargeIndicator.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled9 name=enabled9 ng-model=vm.nmeaAlarm9ChargeIndicator class=green disabled=true></switch></div></div></div></div><!--  --><div class=row><div class=col-sm-6><div class=bound-box><label class=field>{{ \"PreheatIndicator.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled9 name=enabled9 ng-model=vm.nmeaAlarm9PreheatIndicator class=green disabled=true></switch></div></div></div><!--  --><div class=col-sm-6><div class=bound-box><label class=field>{{ \"HighBoostPressure.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled9 name=enabled9 ng-model=vm.nmeaAlarm9HighBoostPressure class=green disabled=true></switch></div></div></div></div><div class=row><div class=col-sm-6><div class=bound-box><label class=field>{{ \"RevLimitExceeded.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled9 name=enabled9 ng-model=vm.nmeaAlarm9RevLimitExceeded class=green disabled=true></switch></div></div></div><!--  --><div class=col-sm-6><div class=bound-box><label class=field>{{ \"EGRSystem.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled9 name=enabled9 ng-model=vm.nmeaAlarm9EGRSystem class=green disabled=true></switch></div></div></div></div><div class=row><div class=col-sm-6><div class=bound-box><label class=field>{{ \"EngineEmergencyStopMode.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled9 name=enabled9 ng-model=vm.nmeaAlarm9EngineEmergencyStopMode class=green disabled=true></switch></div></div></div><!--  --><div class=col-sm-6><div class=bound-box><label class=field>{{ \"PowerReduction.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled9 name=enabled9 ng-model=vm.nmeaAlarm9PowerReduction class=green disabled=true></switch></div></div></div></div><div class=row><div class=col-sm-6><div class=bound-box><label class=field>{{ \"EngineCommError.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled9 name=enabled9 ng-model=vm.nmeaAlarm9EngineCommError class=green disabled=true></switch></div></div></div><!--  --><div class=col-sm-6><div class=bound-box><label class=field>{{ \"SubOrSecondaryThrottle.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled9 name=enabled9 ng-model=vm.nmeaAlarm9SubOrSecondaryThrottle class=green disabled=true></switch></div></div></div></div><div class=row><div class=col-sm-6><div class=bound-box><label class=field>{{ \"NeutralStartProtect.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled9 name=enabled9 ng-model=vm.nmeaAlarm9NeutralStartProtect class=green disabled=true></switch></div></div></div><!--  --><div class=col-sm-6><div class=bound-box><label class=field>{{ \"EngineShuttingDown.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled9 name=enabled9 ng-model=vm.nmeaAlarm9EngineShuttingDown class=green disabled=true></switch></div></div></div></div><div class=row><div class=col-sm-6><div class=bound-box><label class=field>{{ \"CheckTransmission.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled9 name=enabled9 ng-model=vm.nmeaAlarm9CheckTransmission class=green disabled=true></switch></div></div></div><!--  --><div class=col-sm-6><div class=bound-box><label class=field>{{ \"OverTemperature.Text\" | translate }} {{ \"Transmission.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled9 name=enabled9 ng-model=vm.nmeaAlarm9OverTemperatureTransmission class=green disabled=true></switch></div></div></div></div><div class=row><div class=col-sm-6><div class=bound-box><label class=field>{{ \"LowOilPressure.Text\" | translate }} {{ \"Transmission.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled9 name=enabled9 ng-model=vm.nmeaAlarm9LowOilPressureTransmission class=green disabled=true></switch></div></div></div><!--  --><div class=col-sm-6><div class=bound-box><label class=field>{{ \"LowOilLevel.Text\" | translate }} {{ \"Transmission.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled9 name=enabled9 ng-model=vm.nmeaAlarm9LowOilLevelTransmission class=green disabled=true></switch></div></div></div></div><div class=row><div class=col-sm-6><div class=bound-box><label class=field>{{ \"SailDrive.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled9 name=enabled9 ng-model=vm.nmeaAlarm9SailDrive class=green disabled=true></switch></div></div></div><!--  --></div><div class=\"col-sm-12 mid\" ng-if=vm.hasAccess><button class=\"oval-btn blue\" ng-click=vm.updateAlarms()>{{ \"SaveChanges.Text\" | translate }}</button></div>");
$templateCache.put("app/main/alarm/nmea/manufacturer-set/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.nmeaAlarms.logo.show() ng-src={{vm.oemConfig.nmeaAlarms.logo.image}} class=symbol><h2 class=red-border-bottom>{{ \"ManufacturerSet.Text\" | translate }}</h2><div class=status>{{ \"LastUpdatedOn.Text\" | translate }} {{ vm.lastUpdated | utcDate }}</div></div>");
$templateCache.put("app/main/alarm/nmea/power/alarm.html","<div class=col-sm-12 style=margin-left:-5px><a href ng-click=vm.goBack() style=\"float: left\"><img src=assets/images/back.png class=back-btn2></a></div><div class=row><div class=col-sm-12><div class=bound-box><label class=field>{{ \"PowerInstances.Text\" | translate }}</label></div></div></div><div class=row ng-if=\"vm.powerInstances.length>0\"><div class=col-sm-12 ng-repeat=\"powerInstance in vm.powerInstances\"><div class=bound-box style=\"margin-bottom: 0\"><div class=\"col-sm-12 card small flex-card\" style=margin-right:5px ng-repeat=\"nmeaInstance in powerInstance.nmeaInstances\" ng-click=\"vm.goToPowerAlarm(nmeaInstance.nmeaInstanceNumber, nmeaInstance.sourceId)\"><label class=\"card-label full\">{{ nmeaInstance.instanceName }}</label><a><img src=assets/images/arrow.png class=\"card-icon pull-right\"></a></div></div></div></div><div class=row ng-if=\"vm.powerInstances.length==0\"><div class=col-sm-6><div class=bound-box><label class=card-label>{{ \"NoPowerInstancesFound.Text\" | translate }}</label></div></div></div>");
$templateCache.put("app/main/alarm/nmea/power/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.nmeaAlarms.logo.show() ng-src={{vm.oemConfig.nmeaAlarms.logo.image}} class=symbol><h2 class=red-border-bottom>{{ \"PowerAlarmHeader.Text\" | translate }}</h2><div class=status>{{ \"LastUpdatedOn.Text\" | translate }} {{ vm.lastUpdated | utcDate }}</div></div>");
$templateCache.put("app/main/alarm/nmea/pos-and-speed/alarm3.html","<!--  --><div class=col-sm-4><div class=bound-box><label class=\"field pull-left\" style=margin-left:0>{{ \"Longitude.Text\" | translate }} {{ vm.sentinelLocation.center.longitude | number: 2 }} {{ \"Latitude.Text\" | translate }} {{ vm.sentinelLocation.center.latitude | number: 2 }}</label></div></div><div class=col-sm-6><div class=bound-box><switch id=enabled1 name=enabled1 off=\"{{vm.translations[\'ShortRange.Text\']}}\" on=\"{{vm.translations[\'LongRange.Text\']}}\" ng-change=vm.handleRangeChange() ng-model=vm.positionAlarmRange class=\"green wide x-wide\"></switch></div></div><!--  --><!--  --><!--<div class=\"col-sm-6\">\r\n  <div class=\"bound-box\">\r\n    <label class=\"field\">Distance from fence center: {{vm.distance | number:1}}m  </label>\r\n  </div>\r\n</div>--><!--  --><div class=col-sm-12><div class=bound-box><div class=\"col-sm-12 card small flex-card\"><!--  --><rzslider ng-if=\"vm.noPositionData == false\" rz-slider-model=vm.geoFenceAlarm.map.radius rz-slider-options=vm.sliderOptions></rzslider><div ng-if=\"vm.noPositionData == true\" class=danger uib-alert>{{ \"NoLocationData.Text\" | translate }}</div><!--  --></div><div class=\"col-sm-6 card small flex-card\"><label class=card-label>{{ \"MoveOut.Text\" | translate }}</label><switch id=enabled4 name=enabled4 ng-model=vm.geoFenceAlarm.moveOutEnabled class=green disabled=!vm.hasLocation ng-change=vm.hasSupportForFeature(vm.hasLocation)></switch></div><div class=\"col-sm-6 card small flex-card\"><label class=card-label>{{ \"MoveIn.Text\" | translate }}</label><switch id=enabled4 name=enabled4 ng-model=vm.geoFenceAlarm.moveInEnabled class=green disabled=!vm.hasLocation ng-change=vm.hasSupportForFeature(vm.hasLocation)></switch></div></div></div><div class=col-sm-12><div class=bound-box><div class=\"col-sm-6 p-0\"><label class=field>{{ \"GeofencingSpeedLimit.Text\" | translate }}</label><!-- <div class=\"col-sm-12 card small flex-card\">\r\n            <label class=\"card-label\">{{ \"BoostRange.Text\" | translate }}</label>\r\n            <switch\r\n              id=\"enabled1\"\r\n              name=\"enabled1\"\r\n              off=\"12Psi\"\r\n              on=\"24Psi\"\r\n              ng-change=\"vm.handleSentinelBoostChange()\"\r\n              ng-model=\"vm.nmeaAlarm2TimeToEmpty.boost\"\r\n              class=\"green wide\"\r\n            ></switch>\r\n          </div> --><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaAlarm2Sog.alarm.triggerValue rz-slider-options=vm.nmeaAlarm2Sog.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm2Sog.enabled class=green></switch></div></div></div></div><!--  --><div ng-if=vm.hasLocation><div class=\"col-sm-6 mid\"><button class=\"oval-btn blue pull-right\" ng-click=vm.saveGeofenceAlarm()>{{ \"SaveChanges.Text\" | translate }}</button></div><div class=\"col-sm-6 mid\"><button ng-if=\"vm.noPositionData == false\" class=\"oval-btn red pull-left\" ng-click=vm.resetGeoFenceToCurrentLocation()>{{ \"Reset.Text\" | translate }}</button></div></div>");
$templateCache.put("app/main/alarm/nmea/pos-and-speed/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.nmeaAlarms.logo.show() ng-src={{vm.oemConfig.nmeaAlarms.logo.image}} class=symbol><h2 class=red-border-bottom>{{ \"PositionAndSpeed.Text\" | translate }}</h2><div class=status>{{ \"LastUpdatedOn.Text\" | translate }} {{ vm.lastUpdated | utcDate }}</div></div>");
$templateCache.put("app/main/alarm/nmea/pos-and-speed/map.html","<style>.map.alarm {\r\n    height: 600px;\r\n    width: 90%;\r\n    margin: auto;\r\n  }</style><div class=row style=\"margin: 0\"><div class=col-sm-12 style=\"margin-left: -5px; margin-bottom: 15px\"><a href ng-click=vm.goBack() style=\"float: left\"><img src=assets/images/back.png class=back-btn2></a></div><div class=col-md-12 style=\"margin-bottom: 25px\"><div id=map class=\"map alarm\"></div></div></div>");
$templateCache.put("app/main/alarm/nmea/speed-limit/alarm7.html","<div class=col-sm-12 style=margin-left:-5px><a href ng-click=vm.goBack() style=\"float: left\"><img src=assets/images/back.png class=back-btn2></a></div><div class=row><div class=col-sm-6><div class=bound-box><label class=field>{{ \"SpeedOverGround.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaAlarm7SpeedOverGround.alarm.triggerValue rz-slider-options=vm.nmeaAlarm7SpeedOverGround.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm7SpeedOverGround.enabled class=green></switch></div></div></div><div class=col-sm-6><div class=bound-box><label class=field>{{ \"SpeedOverWater.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaAlarm7SpeedOverWater.alarm.triggerValue rz-slider-options=vm.nmeaAlarm7SpeedOverWater.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm7SpeedOverWater.enabled class=green></switch></div></div></div></div><div class=\"col-sm-12 mid\" ng-if=vm.hasAccess><button class=\"oval-btn blue\" ng-click=vm.updateAlarms()>{{ \"SaveChanges.Text\" | translate }}</button></div>");
$templateCache.put("app/main/alarm/nmea/speed-limit/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.nmeaAlarms.logo.show() ng-src={{vm.oemConfig.nmeaAlarms.logo.image}} class=symbol><h2 class=red-border-bottom>{{ \"SpeedLimit.Text\" | translate }}</h2><div class=status>{{ \"LastUpdatedOn.Text\" | translate }} {{ vm.lastUpdated | utcDate }}</div></div>");
$templateCache.put("app/main/alarm/nmea/water-depth/alarm2.html","<div class=col-sm-12 style=margin-left:-5px><a href ng-click=vm.goBack() style=\"float: left\"><img src=assets/images/back.png class=back-btn2></a></div><div class=row><div class=col-sm-6><div class=bound-box><label class=field>{{ \"WaterDepth.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=green rz-slider-model=vm.nmeaAlarm2WaterDepth.alarm.triggerValue rz-slider-options=vm.nmeaAlarm2WaterDepth.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm2WaterDepth.enabled class=green></switch></div></div></div><!--  --></div><!--  --><div class=\"col-sm-12 mid\" ng-if=vm.hasAccess><button class=\"oval-btn blue\" ng-click=vm.updateAlarms()>{{ \"SaveChanges.Text\" | translate }}</button></div>");
$templateCache.put("app/main/alarm/nmea/water-depth/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.nmeaAlarms.logo.show() ng-src={{vm.oemConfig.nmeaAlarms.logo.image}} class=symbol><h2 class=red-border-bottom>{{ \"WaterDepth.Text\" | translate }}</h2><div class=status>{{ \"LastUpdatedOn.Text\" | translate }} {{ vm.lastUpdated | utcDate }}</div></div>");
$templateCache.put("app/main/alarm/nmea/temp-and-hum/alarm8.html","<div class=col-sm-12 style=margin-left:-5px><a href ng-click=vm.goBack() style=\"float: left\"><img src=assets/images/back.png class=back-btn2></a></div><!-- <div class=\"row\"> --><div class=col-sm-6 ng-if=vm.hasSeaTempData><div class=bound-box><label class=field>{{ \"SeaTemperature.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaAlarm8SeaTemperature.alarm.min rz-slider-high=vm.nmeaAlarm8SeaTemperature.alarm.max rz-slider-options=vm.nmeaAlarm8SeaTemperature.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm8SeaTemperature.enabled class=green disabled=!vm.hasSeaTempData ng-change=vm.hasSupportForFeature(vm.hasSeaTempData)></switch></div></div></div><div class=col-sm-6 ng-if=vm.hasOutsideTempData><div class=bound-box><label class=field>{{ \"OutsideTemperature.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaAlarm8OutsideTemperature.alarm.min rz-slider-high=vm.nmeaAlarm8OutsideTemperature.alarm.max rz-slider-options=vm.nmeaAlarm8OutsideTemperature.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm8OutsideTemperature.enabled class=green disabled=!vm.hasOutsideTempData ng-change=vm.hasSupportForFeature(vm.hasOutsideTempData)></switch></div></div></div><!--  --><!-- </div>\r\n<div class=\"row\"> --><div class=col-sm-6 ng-if=vm.hasInsideTempData><div class=bound-box><label class=field>{{ \"InsideTemperature.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaAlarm8InsideTemperature.alarm.min rz-slider-high=vm.nmeaAlarm8InsideTemperature.alarm.max rz-slider-options=vm.nmeaAlarm8InsideTemperature.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm8InsideTemperature.enabled class=green disabled=!vm.hasInsideTempData ng-change=vm.hasSupportForFeature(vm.hasInsideTempData)></switch></div></div></div><div class=col-sm-6 ng-if=vm.hasEngineRoomTempData><div class=bound-box><label class=field>{{ \"EngineRoomTemperature.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaAlarm8EngineRoomTemperature.alarm.min rz-slider-high=vm.nmeaAlarm8EngineRoomTemperature.alarm.max rz-slider-options=vm.nmeaAlarm8EngineRoomTemperature.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm8EngineRoomTemperature.enabled class=green disabled=!vm.hasEngineRoomTempData ng-change=vm.hasSupportForFeature(vm.hasEngineRoomTempData)></switch></div></div></div><!--  --><!-- </div>\r\n<div class=\"row\"> --><div class=col-sm-6 ng-if=vm.hasMainCabinTempData><div class=bound-box><label class=field>{{ \"MainCabinTemperature.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaAlarm8MainCabinTemperature.alarm.min rz-slider-high=vm.nmeaAlarm8MainCabinTemperature.alarm.max rz-slider-options=vm.nmeaAlarm8MainCabinTemperature.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm8MainCabinTemperature.enabled class=green disabled=!vm.hasMainCabinTempData ng-change=vm.hasSupportForFeature(vm.hasMainCabinTempData)></switch></div></div></div><div class=col-sm-6 ng-if=vm.hasLiveWellTempData><div class=bound-box><label class=field>{{ \"LiveWellTemperature.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaAlarm8LiveWellTemperature.alarm.min rz-slider-high=vm.nmeaAlarm8LiveWellTemperature.alarm.max rz-slider-options=vm.nmeaAlarm8LiveWellTemperature.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm8LiveWellTemperature.enabled class=green disabled=!vm.hasLiveWellTempData ng-change=vm.hasSupportForFeature(vm.hasLiveWellTempData)></switch></div></div></div><!--  --><!-- </div>\r\n<div class=\"row\"> --><div class=col-sm-6 ng-if=vm.hasBailWellTempData><div class=bound-box><label class=field>{{ \"BailWellTemperature.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaAlarm8BailWellTemperature.alarm.min rz-slider-high=vm.nmeaAlarm8BailWellTemperature.alarm.max rz-slider-options=vm.nmeaAlarm8BailWellTemperature.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm8BailWellTemperature.enabled class=green disabled=!vm.hasBailWellTempData ng-change=vm.hasSupportForFeature(vm.hasBailWellTempData)></switch></div></div></div><div class=col-sm-6 ng-if=vm.hasReferigerationTempData><div class=bound-box><label class=field>{{ \"RefrigerationTemperature.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaAlarm8RefrigerationTemperature.alarm.min rz-slider-high=vm.nmeaAlarm8RefrigerationTemperature.alarm.max rz-slider-options=vm.nmeaAlarm8RefrigerationTemperature.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm8RefrigerationTemperature.enabled class=green disabled=!vm.hasReferigerationTempData ng-change=vm.hasSupportForFeature(vm.hasReferigerationTempData)></switch></div></div></div><!--  --><!-- </div>\r\n<div class=\"row\"> --><div class=col-sm-6 ng-if=vm.hasHeatingSystemTempData><div class=bound-box><label class=field>{{ \"HeatingSystemTemperature.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaAlarm8HeatingSystemTemperature.alarm.min rz-slider-high=vm.nmeaAlarm8HeatingSystemTemperature.alarm.max rz-slider-options=vm.nmeaAlarm8HeatingSystemTemperature.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm8HeatingSystemTemperature.enabled class=green disabled=!vm.hasHeatingSystemTempData ng-change=vm.hasSupportForFeature(vm.hasHeatingSystemTempData)></switch></div></div></div><div class=col-sm-6 ng-if=vm.hasDewPointTempData><div class=bound-box><label class=field>{{ \"DewPointTemperature.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaAlarm8DewPointTemperature.alarm.min rz-slider-high=vm.nmeaAlarm8DewPointTemperature.alarm.max rz-slider-options=vm.nmeaAlarm8DewPointTemperature.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm8DewPointTemperature.enabled class=green disabled=!vm.hasDewPointTempData ng-change=vm.hasSupportForFeature(vm.hasDewPointTempData)></switch></div></div></div><!--  --><!-- </div>\r\n<div class=\"row\"> --><div class=col-sm-6 ng-if=vm.hasWindChillTempData><div class=bound-box><label class=field>{{ \"WindChillTemperature.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaAlarm8WindChillTemperature.alarm.min rz-slider-high=vm.nmeaAlarm8WindChillTemperature.alarm.max rz-slider-options=vm.nmeaAlarm8WindChillTemperature.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm8WindChillTemperature.enabled class=green disabled=!vm.hasWindChillTempData ng-change=vm.hasSupportForFeature(vm.hasWindChillTempData)></switch></div></div></div><div class=col-sm-6 ng-if=vm.hasFreezerTempData><div class=bound-box><label class=field>{{ \"FreezerTemperature.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaAlarm8FreezerTemperature.alarm.min rz-slider-high=vm.nmeaAlarm8FreezerTemperature.alarm.max rz-slider-options=vm.nmeaAlarm8FreezerTemperature.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm8FreezerTemperature.enabled class=green disabled=!vm.hasFreezerTempData ng-change=vm.hasSupportForFeature(vm.hasFreezerTempData)></switch></div></div></div><!--  --><!-- </div> --><!-- <div class=\"row\"> --><div class=col-sm-6 ng-if=vm.hasExhaustGasTempData><div class=bound-box><label class=field>{{ \"ExhaustGasTemperature.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaAlarm8ExhaustGasTemperature.alarm.min rz-slider-high=vm.nmeaAlarm8ExhaustGasTemperature.alarm.max rz-slider-options=vm.nmeaAlarm8ExhaustGasTemperature.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm8ExhaustGasTemperature.enabled class=green disabled=!vm.hasExhaustGasTempData ng-change=vm.hasSupportForFeature(vm.hasExhaustGasTempData)></switch></div></div></div><!-- </div> --><div class=row><div class=bound-box><hr style=\"border-top: 4px solid #eeeeee\"></div></div><!-- <div class=\"row\"> --><div class=col-sm-6 ng-if=vm.hasInsideHumidityData><div class=bound-box><label class=field>{{ \"InsideHumidity.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaAlarm8InsideHumidity.alarm.min rz-slider-high=vm.nmeaAlarm8InsideHumidity.alarm.max rz-slider-options=vm.nmeaAlarm8InsideHumidity.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm8InsideHumidity.enabled class=green disabled=!vm.hasInsideHumidityData ng-change=vm.hasSupportForFeature(vm.hasInsideHumidityData)></switch></div></div></div><div class=col-sm-6 ng-if=vm.hasOutsideHumidityData><div class=bound-box><label class=field>{{ \"OutsideHumidity.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaAlarm8OutsideHumidity.alarm.min rz-slider-high=vm.nmeaAlarm8OutsideHumidity.alarm.max rz-slider-options=vm.nmeaAlarm8OutsideHumidity.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm8OutsideHumidity.enabled class=green disabled=!vm.hasOutsideHumidityData ng-change=vm.hasSupportForFeature(vm.hasOutsideHumidityData)></switch></div></div></div><!--  --><!-- </div> --><!--  --><div class=\"col-sm-12 mid\" ng-if=vm.hasAccess><button class=\"oval-btn blue\" ng-click=vm.updateAlarms()>{{ \"SaveChanges.Text\" | translate }}</button></div>");
$templateCache.put("app/main/alarm/nmea/temp-and-hum/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.nmeaAlarms.logo.show() ng-src={{vm.oemConfig.nmeaAlarms.logo.image}} class=symbol><h2 class=red-border-bottom>{{ \"TemperatureAndHumidity.Text\" | translate }}</h2><div class=status>{{ \"LastUpdatedOn.Text\" | translate }} {{ vm.lastUpdated | utcDate }}</div></div>");
$templateCache.put("app/main/alarm/nmea/wind-speed/alarm10.html","<div class=col-sm-12 style=margin-left:-5px><a href ng-click=vm.goBack() style=\"float: left\"><img src=assets/images/back.png class=back-btn2></a></div><div class=row><div class=col-sm-6><div class=bound-box><label class=field>{{ \"WindSpeed.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card wind-speed\"><rzslider class=red rz-slider-model=vm.nmeaAlarm10WindSpeed.alarm.triggerValue rz-slider-options=vm.nmeaAlarm10WindSpeed.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm10WindSpeed.enabled class=green disabled=!vm.hasWindSpeedDbData ng-change=vm.hasSupportForFeature(vm.hasWindSpeedDbData)></switch></div></div></div><!--  --></div><!--  --><div class=\"col-sm-12 mid\" ng-if=vm.hasAccess><button class=\"oval-btn blue\" ng-click=vm.updateAlarms()>{{ \"SaveChanges.Text\" | translate }}</button></div>");
$templateCache.put("app/main/alarm/nmea/wind-speed/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.nmeaAlarms.logo.show() ng-src={{vm.oemConfig.nmeaAlarms.logo.image}} class=symbol><h2 class=red-border-bottom>{{ \"WindSpeed.Text\" | translate }}</h2><div class=status>{{ \"LastUpdatedOn.Text\" | translate }} {{ vm.lastUpdated | utcDate }}</div></div>");
$templateCache.put("app/main/forum/category/post/post.html","<div class=main-wrapper_fm><div class=gen-wrapper_fm><button class=button-gen_fm style=\"visibility: hidden\">New Post</button><p style=\"font-size: 20px\"><a ng-if=vm.stateCheck ui-sref=\"boat.home({sentinelId: vm.sentinelId})\">Home / </a><a ui-sref=\"forum({sentinelId: vm.sentinelId})\">Forum</a> / <a ui-sref=\"forum_category({sentinelId: vm.sentinelId,categoryId: vm.categoryId})\">{{vm.categoryName}}</a> / {{vm.mainPost.title}}</p><div class=main__wrap_fm><div class=\"drops-wrap_fm edit_bl\"><div class=t_bl_fm><p class=t_title_fm>{{vm.mainPost.title}}</p><p class=link-text_fm>Hosted by {{vm.forumCategory.hostedBy}}</p></div><div class=\"block_drop_fm map\" ng-repeat=\"post in vm.forumPosts\"><div class=\"head__gen_fm f_area\"><p class=\"text-gen_fm map\">{{post.createdDate|date:\'mediumDate\'}}</p><!-- <p class=\"f_sign_fm\">\r\n              <img src=\"assets/images/forum/Reply icon.svg\" alt=\"filter\">\r\n            </p>--></div><div class=\"f-cont_fm map\"><div class=m_area_wrap_fm><div class=\"pic_area_fm map\"><p class=\"img_wrap_fm map\"><img ng-src={{post.profilePicture}} alt=pic></p><div class=b_wrap_fm><div class=\"f-cont_wrap_fm map\"><p class=\"c_title_fm map\">{{post.user.fullName}}</p><p class=\"d_title_fm map\"><!--Group Editor--></p></div><div class=\"d_wrap_fm map\"><div class=\"rv_wrap_fm map\"><p class=\"d_title_fm wdt map\">Joined:</p><p class=\"d_sub_fm map\">{{post.user.createdDate|date:\'mediumDate\'}}</p></div><div class=\"rv_wrap_fm map\"><p class=\"d_title_fm wdt map\">Messages:</p><p class=\"d_sub_fm map\">{{post.numberOfMessages}}</p></div></div></div></div></div><div class=map_wrapper_fm><div class=m_m_area_wrap_fm style=\"width: 95%\"><p class=m_tit_fm ng-bind-html=post.description></p><ul><li ng-repeat=\"forumPostAttachment in post.forumPostAttachments\"><a><i ng-click=vm.downloadFile(forumPostAttachment.attachment)>{{forumPostAttachment.attachment.name}}</i></a></li></ul><!-- <div class=\"pic_map_fm\">\r\n                  <img src=\"assets/images/forum/log (2).png\" alt=\"map\">\r\n                </div> --></div><!--<div class=\"journey_d_fm\">\r\n                <p class=\"j_title_fm\">My Journey</p>\r\n                <div class=\"d_d_wrap_fm\">\r\n                  <p class=\"dr_w_fm\">Distance: </p>\r\n                  <p class=\"dr_w_fm red\">&nbsp;25nm</p>\r\n                </div>\r\n                <div class=\"d_d_wrap_fm\">\r\n                  <p class=\"dr_w_fm\">Time: </p>\r\n                  <p class=\"dr_w_fm red\">&nbsp;1:25h</p>\r\n                </div>\r\n                <div class=\"d_d_wrap_fm\">\r\n                  <p class=\"dr_w_fm\">Max Speed:</p>\r\n                  <p class=\"dr_w_fm red\">&nbsp;17kn</p>\r\n                </div>\r\n              </div>--></div></div></div><div show-new-post-dialog show-hidden=vm.show hide-category=vm.hideCategory categories=vm.forumCategories callback=vm.hideDialog></div><div flow-init=vm.uploadApi flow-files-submitted=$flow.upload() flow-complete=vm.onUploadComplete() flow-upload-started=vm.onUploadStarted($file,$flow) flow-file-success=\"vm.onUploadSuccess($file, $message, $flow)\" flow-progress=vm.flowProgress($flow)><form novalidate name=form ng-submit=\"form.$valid && vm.createForumPostMessage(form)\"><div class=\"block_drop_fm map send\"><div class=bottom_pic_wrap_fm><p class=\"img_wrap_fm bottom\"><img ng-src={{vm.loggedInProfilePicture}} alt=pic></p></div><div class=textarea_b_wrap_fm><div style=\"width: 100%\"><textarea class=textarea_bottom required name=forum_description ng-model=vm.forum.description placeholder=\"Write a reply...\" ng-class=\"{textAreaError: form.$submitted && form.forum_description.$invalid}\"></textarea><div ng-messages=form.forum_description.$error class=error ng-if=form.$submitted style=\"position: absolute\"><div ng-message=required>{{\'ForumContentRequired.Text\'| translate}}</div></div></div><div class=bott_group_fm><p class=img_pin_fm><img src=\"assets/images/forum/Group 144.svg\" class=dr_title_fm flow-btn alt=pin></p><button class=\"button-gen_fm bottom\" type=submit>Send</button></div></div></div><div class=m-t-15 ng-if=\"vm.uploadedFiles.length>0\"><label for=boat_image flow-btn>{{ \"UploadedFiles.Text\" | translate }}</label><table class=\"m-t-5 table table-condensed table-hover table-bordered table-striped m-table\"><thead><tr class=text-center><td>#</td><td>{{ \"Name.Text\" | translate }}</td><td>{{ \"Action.Text\" | translate }}</td></tr></thead><tbody><tr class=text-center ng-repeat=\"attachment in vm.uploadedFiles\"><td>{{ $index + 1 }}</td><td>{{attachment.file.name}}</td><td><a><i class=\"fa fa-times\" uib-tooltip=\"{{ \'DeleteFile.Text\' | translate }}\" ng-click=vm.deleteUploadedFile(attachment)></i></a></td></tr></tbody></table></div><div class=\"row m-t-10\" ng-if=vm.showProgressBar><div class=col-12><uib-progressbar class=\"progress-striped active\" value=vm.flowProgressValue type=success></uib-progressbar></div></div><hr></form></div></div><div class=lp-wrap_fm><div class=\"head__gen_fm lp\"><div class=arrow-down_fm><img src=assets/images/forum/Pen.svg alt=pen></div><p class=text-gen_fm>Latest Posts</p></div><div class=posts_wrapper_fm><div class=l-post-wrap_fm ng-repeat=\"latestPost in vm.latestPosts\"><p class=ph-wrap_fm><img ng-src={{latestPost.profilePicture}} alt=us></p><div class=post-cont-wrap_fm><a class=post-cont-text_fm ui-sref=\"forum_post({categoryId:latestPost.forumCategoryId,postId: latestPost.id})\">{{latestPost.title}}</a><p class=post-cont-sub_fm>Latest: Today at {{latestPost.createdDate| date:\'mediumTime\'}}</p><a class=club-name_fm ui-sref=\"forum_category({sentinelId: vm.sentinelId,categoryId: latestPost.forumCategoryId})\">{{latestPost.forumCategoryName}}</a></div></div></div></div></div></div></div>");
$templateCache.put("app/main/alarm/nmea/engine/engine-details/alarm.html","<div class=col-sm-12 style=margin-left:-5px><a href ng-click=vm.goBack() style=\"float: left\"><img src=assets/images/back.png class=back-btn2></a></div><!-- <div class=\"row\"> --><div class=col-sm-6 ng-if=vm.hasRpmData><div class=bound-box><label class=field>{{ \"Rpmx100.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaEngineAlarmRpm.alarm.triggerValue rz-slider-options=vm.nmeaEngineAlarmRpm.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaEngineAlarmRpm.enabled class=green disabled=!vm.hasRpmData ng-change=vm.hasSupportForFeature(vm.hasRpmData)></switch></div></div></div><div class=col-sm-6 ng-if=vm.hasFuelPressureData><div class=bound-box><label class=field>{{ \"FuelPressure.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaEngineAlarmFuelPressure.alarm.triggerValue rz-slider-options=vm.nmeaEngineAlarmFuelPressure.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaEngineAlarmFuelPressure.enabled class=green disabled=!vm.hasFuelPressureData ng-change=vm.hasSupportForFeature(vm.hasFuelPressureData)></switch></div></div></div><!--  --><!-- </div>\r\n<div class=\"row\"> --><div class=col-sm-6 ng-if=vm.hasFuelRateData><div class=bound-box><label class=field>{{ \"FuelRate.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaEngineAlarmFuelRate.alarm.triggerValue rz-slider-options=vm.nmeaEngineAlarmFuelRate.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaEngineAlarmFuelRate.enabled class=green disabled=!vm.hasFuelRateData ng-change=vm.hasSupportForFeature(vm.hasFuelRateData)></switch></div></div></div><div class=col-sm-6 ng-if=vm.hasTransmissionOilPressureData><div class=bound-box><label class=field>{{ \"TransmissionOilPressure.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaEngineAlarmTransmissionOilPressure.alarm.triggerValue rz-slider-options=vm.nmeaEngineAlarmTransmissionOilPressure.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaEngineAlarmTransmissionOilPressure.enabled class=green disabled=!vm.hasTransmissionOilPressureData ng-change=vm.hasSupportForFeature(vm.hasTransmissionOilPressureData)></switch></div></div></div><!--  --><!-- </div>\r\n<div class=\"row\"> --><div class=col-sm-6 ng-if=vm.hasEngineTemperatureData><div class=bound-box><label class=field>{{ \"EngineTemperature.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaEngineAlarmEngineTemperature.alarm.min rz-slider-high=vm.nmeaEngineAlarmEngineTemperature.alarm.max rz-slider-options=vm.nmeaEngineAlarmEngineTemperature.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaEngineAlarmEngineTemperature.enabled class=green disabled=!vm.hasEngineTemperatureData ng-change=vm.hasSupportForFeature(vm.hasEngineTemperatureData)></switch></div></div></div><div class=col-sm-6 ng-if=vm.hasOilTemperatureData><div class=bound-box><label class=field>{{ \"OilTemperature.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaEngineAlarmOilTemperature.alarm.min rz-slider-high=vm.nmeaEngineAlarmOilTemperature.alarm.max rz-slider-options=vm.nmeaEngineAlarmOilTemperature.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaEngineAlarmOilTemperature.enabled class=green disabled=!vm.hasOilTemperatureData ng-change=vm.hasSupportForFeature(vm.hasOilTemperatureData)></switch></div></div></div><!--  --><!-- </div>\r\n<div class=\"row\"> --><div class=col-sm-6 ng-if=vm.hasEngineLoadData><div class=bound-box><label class=field>{{ \"EngineLoad.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaEngineAlarmEngineLoad.alarm.triggerValue rz-slider-options=vm.nmeaEngineAlarmEngineLoad.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaEngineAlarmEngineLoad.enabled class=green disabled=!vm.hasEngineLoadData ng-change=vm.hasSupportForFeature(vm.hasEngineLoadData)></switch></div></div></div><div class=col-sm-6 ng-if=vm.hasEngineTorqueData><div class=bound-box><label class=field>{{ \"EngineTorque.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaEngineAlarmEngineTorque.alarm.triggerValue rz-slider-options=vm.nmeaEngineAlarmEngineTorque.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaEngineAlarmEngineTorque.enabled class=green disabled=!vm.hasEngineTorqueData ng-change=vm.hasSupportForFeature(vm.hasEngineTorqueData)></switch></div></div></div><!--  --><!-- </div>\r\n<div class=\"row\"> --><div class=col-sm-6 ng-if=vm.hasAlternatorPotentialData><div class=bound-box><label class=field>{{ \"AlternatorPotential.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=green rz-slider-model=vm.nmeaEngineAlarmAlternatorPotential.alarm.triggerValue rz-slider-options=vm.nmeaEngineAlarmAlternatorPotential.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaEngineAlarmAlternatorPotential.enabled class=green disabled=!vm.hasAlternatorPotentialData ng-change=vm.hasSupportForFeature(vm.hasAlternatorPotentialData)></switch></div></div></div><div class=col-sm-6 ng-if=vm.hasBoostData><div class=bound-box><label class=field>{{ \"Boost.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaEngineAlarmBoost.alarm.triggerValue rz-slider-options=vm.nmeaEngineAlarmBoost.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaEngineAlarmBoost.enabled class=green disabled=!vm.hasBoostData ng-change=vm.hasSupportForFeature(vm.hasBoostData)></switch></div></div></div><!--  --><!-- </div>\r\n<div class=\"row\"> --><div class=col-sm-6 ng-if=vm.hasTransmissionOilTemperatureData><div class=bound-box><label class=field>{{ \"TransmissionOilTemperature.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaEngineAlarmTransmissionOilTemperature.alarm.min rz-slider-high=vm.nmeaEngineAlarmTransmissionOilTemperature.alarm.max rz-slider-options=vm.nmeaEngineAlarmTransmissionOilTemperature.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaEngineAlarmTransmissionOilTemperature.enabled class=green disabled=!vm.hasTransmissionOilTemperatureData ng-change=vm.hasSupportForFeature(vm.hasTransmissionOilTemperatureData)></switch></div></div></div><div class=col-sm-6 ng-if=vm.hasEngineOilPressureData><div class=bound-box><label class=field>{{ \"EngineOilPressure.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaEngineAlarmEngineOilPressure.alarm.min rz-slider-high=vm.nmeaEngineAlarmEngineOilPressure.alarm.max rz-slider-options=vm.nmeaEngineAlarmEngineOilPressure.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaEngineAlarmEngineOilPressure.enabled class=green disabled=!vm.hasEngineOilPressureData ng-change=vm.hasSupportForFeature(vm.hasEngineOilPressureData)></switch></div></div></div><div class=row><div class=col-sm-6><div class=bound-box><label class=field>{{ \"TotalEngineHours.Text\" | translate }}</label><label class=field>{{ \"CurrentEngineHours.Text\" | translate }}: <span style=\"display: inline-block\">{{ vm.currentTotalEngineHours |number:1}} hrs</span></label><button ng-click=vm.addEngineHourAlert() class=\"oval-btn blue\">+ {{ \"AddNewAlert.Text\" | translate }}</button></div></div></div><div class=row><div class=col-sm-6 ng-repeat=\"alert in vm.engineHoursAlerts\"><div class=bound-box><div class=\"col-sm-12 card small flex-card\"><div class=row><div class=col-sm-6><label class=field style=display:inline-block>{{ \"Description.Text\" | translate }}</label><input style=display:inline-block placeholder=\"{{ \'Description.Text\' | translate }}\" type=text required name=description maxlength=50 ng-model=alert.description></div><div class=col-sm-6><label class=field style=display:inline-block>{{ \"Hours.Text\" | translate }}</label><input style=display:inline-block placeholder=\"{{ \'Hours.Text\' | translate }}\" type=text required name=hours ng-model=alert.hours></div></div><div><button class=\"pull-right link\" ng-click=vm.deleteEngineHourAlert(alert) style=width:40px><i ng-click=vm.deleteEngineHourAlert(alert) class=\"fa fa-times fa-2x\"></i></button></div></div></div></div></div><!--  --><div class=\"col-sm-12 mid\" ng-if=vm.hasAccess><button class=\"oval-btn blue\" ng-click=vm.updateAlarms()>{{ \"SaveChanges.Text\" | translate }}</button></div>");
$templateCache.put("app/main/alarm/nmea/engine/engine-details/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.nmeaAlarms.logo.show() ng-src={{vm.oemConfig.nmeaAlarms.logo.image}} class=symbol><h2 class=red-border-bottom>{{ \"EngineAlarm.Text\" | translate }}</h2><div class=status>{{ \"LastUpdatedOn.Text\" | translate }} {{ vm.lastUpdated | utcDate }}</div></div>");
$templateCache.put("app/main/alarm/nmea/power/power-details/alarm6.html","<div class=col-sm-12 style=margin-left:-5px><a href ng-click=vm.goBack() style=\"float: left\"><img src=assets/images/back.png class=back-btn2></a></div><!-- <div class=\"row\"> --><div class=col-sm-6 ng-if=vm.hasVoltageData><div class=bound-box><label class=field>{{ \"Voltage.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=green rz-slider-model=vm.nmeaAlarm6Voltage.alarm.triggerValue rz-slider-options=vm.nmeaAlarm6Voltage.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm6Voltage.enabled class=green disabled=!vm.hasVoltageData ng-change=vm.hasSupportForFeature(vm.hasVoltageData)></switch></div></div></div><div class=col-sm-6 ng-if=vm.hasCurrentData><div class=bound-box><label class=field>{{ \"Current.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaAlarm6Current.alarm.min rz-slider-high=vm.nmeaAlarm6Current.alarm.max rz-slider-options=vm.nmeaAlarm6Current.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm6Current.enabled class=green disabled=!vm.hasCurrentData ng-change=vm.hasSupportForFeature(vm.hasCurrentData)></switch></div></div></div><!-- </div>\r\n<div class=\"row\"> --><div class=col-sm-6 ng-if=vm.hasStateOfChargeData><div class=bound-box><label class=field>{{ \"StateOfCharge.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=green rz-slider-model=vm.nmeaAlarm6StateOfCharge.alarm.triggerValue rz-slider-options=vm.nmeaAlarm6StateOfCharge.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm6StateOfCharge.enabled class=green disabled=!vm.hasStateOfChargeData ng-change=vm.hasSupportForFeature(vm.hasStateOfChargeData)></switch></div></div></div><div class=col-sm-6 ng-if=vm.hasTimeRemainingData><div class=bound-box><label class=field>{{ \"TimeRemaining.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=green rz-slider-model=vm.nmeaAlarm6TimeRemaining.alarm.triggerValue rz-slider-options=vm.nmeaAlarm6TimeRemaining.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm6TimeRemaining.enabled class=green disabled=!vm.hasTimeRemainingData ng-change=vm.hasSupportForFeature(vm.hasTimeRemainingData)></switch></div></div></div><!--  --><!-- </div>\r\n<div class=\"row\"> --><div class=col-sm-6 ng-if=vm.hasStateOfHealthData><div class=bound-box><label class=field>{{ \"StateOfHealth.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=green rz-slider-model=vm.nmeaAlarm6StateOfHealth.alarm.triggerValue rz-slider-options=vm.nmeaAlarm6StateOfHealth.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm6StateOfHealth.enabled class=green disabled=!vm.hasStateOfHealthData ng-change=vm.hasSupportForFeature(vm.hasStateOfHealthData)></switch></div></div></div><div class=col-sm-6 ng-if=vm.hasBatteryCaseTempData><div class=bound-box><label class=field>{{ \"BatteryCaseTemperature.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=red rz-slider-model=vm.nmeaAlarm6BatteryCaseTemperature.alarm.min rz-slider-high=vm.nmeaAlarm6BatteryCaseTemperature.alarm.max rz-slider-options=vm.nmeaAlarm6BatteryCaseTemperature.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm6BatteryCaseTemperature.enabled class=green disabled=!vm.hasBatteryCaseTempData ng-change=vm.hasSupportForFeature(vm.hasBatteryCaseTempData)></switch></div></div></div><!--  --><!-- </div>\r\n<div class=\"row\"> --><div class=col-sm-6 ng-if=vm.hasAmpHoursData><div class=bound-box><label class=field>{{ \"AmpHours.Text\" | translate }}</label><div class=\"col-sm-12 card small flex-card\"><rzslider class=green rz-slider-model=vm.nmeaAlarm6AmpHours.alarm.triggerValue rz-slider-options=vm.nmeaAlarm6AmpHours.options></rzslider></div><div class=\"col-sm-12 card small flex-card\"><label class=card-label>{{ \"Enabled.Text\" | translate }}</label><switch id=enabled3 name=enabled3 ng-model=vm.nmeaAlarm6AmpHours.enabled class=green disabled=!vm.hasAmpHoursData ng-change=vm.hasSupportForFeature(vm.hasAmpHoursData)></switch></div></div></div><!--  --><!-- </div> --><!--  --><div class=\"col-sm-12 mid\" ng-if=vm.hasAccess><button class=\"oval-btn blue\" ng-click=vm.updateAlarms()>{{ \"SaveChanges.Text\" | translate }}</button></div>");
$templateCache.put("app/main/alarm/nmea/power/power-details/header.html","<div class=slider-caption><img ng-if=vm.oemConfig.nmeaAlarms.logo.show() ng-src={{vm.oemConfig.nmeaAlarms.logo.image}} class=symbol><h2 class=red-border-bottom>{{ \"PowerAlarmHeader.Text\" | translate }}</h2><div class=status>{{ \"LastUpdatedOn.Text\" | translate }} {{ vm.lastUpdated | utcDate }}</div></div>");}]);